// Written by Robert Kieffer – https://github.com/broofa/node-uuid
// MIT License - http://opensource.org/licenses/mit-license.php
// The wrapped node-uuid library is at version 1.4.7

function UUID () {
  'use strict';

  // Unique ID creation requires a high quality random # generator.  We feature
  // detect to determine the best RNG source, normalizing to a function that
  // returns 128-bits of randomness, since that's what's usually required
  var _rng, _mathRNG, _whatwgRNG;

  // Allow for MSIE11 msCrypto
  var _crypto = window.crypto || window.msCrypto;

  if (!_rng && _crypto && _crypto.getRandomValues) {
    // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
    //
    // Moderately fast, high quality
    try {
      var _rnds8 = new Uint8Array(16);
      _whatwgRNG = _rng = function whatwgRNG() {
        _crypto.getRandomValues(_rnds8);
        return _rnds8;
      };
      _rng();
    } catch(e) {}
  }

  if (!_rng) {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var  _rnds = new Array(16);
    _mathRNG = _rng = function() {
      for (var i = 0, r; i < 16; i++) {
        if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
        _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
      }

      return _rnds;
    };
    if ('undefined' !== typeof console && console.warn) {
      console.warn('[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()');
    }
  }

  // Buffer class to use
  var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;

  // Maps for number <-> hex string conversion
  var _byteToHex = [];
  var _hexToByte = {};
  for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
  }

  // **`parse()` - Parse a UUID into it's component bytes**
  function parse(s, buf, offset) {
    var i = (buf && offset) || 0, ii = 0;

    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
      if (ii < 16) { // Don't overflow!
        buf[i + ii++] = _hexToByte[oct];
      }
    });

    // Zero out remaining bytes if string was short
    while (ii < 16) {
      buf[i + ii++] = 0;
    }

    return buf;
  }

  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
  function unparse(buf, offset) {
    var i = offset || 0, bth = _byteToHex;
    return  bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]];
  }

  // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html

  // random #'s we need to init node and clockseq
  var _seedBytes = _rng();

  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
  var _nodeId = [
    _seedBytes[0] | 0x01,
    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
  ];

  // Per 4.2.2, randomize (14 bit) clockseq
  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

  // Previous uuid creation time
  var _lastMSecs = 0, _lastNSecs = 0;

  // See https://github.com/broofa/node-uuid for API details
  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];

    options = options || {};

    var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;

    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();

    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;

    // Time since last uuid creation (in msecs)
    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq == null) {
      clockseq = clockseq + 1 & 0x3fff;
    }

    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
      nsecs = 0;
    }

    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }

    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;

    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;

    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;

    // `time_mid`
    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;

    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;

    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;

    // `clock_seq_low`
    b[i++] = clockseq & 0xff;

    // `node`
    var node = options.node || _nodeId;
    for (var n = 0; n < 6; n++) {
      b[i + n] = node[n];
    }

    return buf ? buf : unparse(b);
  }

  // **`v4()` - Generate random UUID**

  // See https://github.com/broofa/node-uuid for API details
  function v4(options, buf, offset) {
    // Deprecated - 'format' argument, as supported in v1.2
    var i = buf && offset || 0;

    if (typeof(options) === 'string') {
      buf = (options === 'binary') ? new BufferClass(16) : null;
      options = null;
    }
    options = options || {};

    var rnds = options.random || (options.rng || _rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ii++) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || unparse(rnds);
  }

  // Export public API
  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  uuid.parse = parse;
  uuid.unparse = unparse;
  uuid.BufferClass = BufferClass;
  uuid._rng = _rng;
  uuid._mathRNG = _mathRNG;
  uuid._whatwgRNG = _whatwgRNG;

  return uuid;
}

// check for Module/AMD support, otherwise call the uuid function to setup the angular module.
if (typeof module !== 'undefined' && module.exports) {
  module.exports = new UUID();

} else if (typeof define !== 'undefined' && define.amd) {
  // AMD. Register as an anonymous module.
  define (function() {
    return new UUID();
  });
  
} else {
  window.uuid = UUID();
}
/*! Raven.js 3.23.3 (f261ec2) | github.com/getsentry/raven-js */
!function(a){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=a();else if("function"==typeof define&&define.amd)define([],a);else{var b;b="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,b.Raven=a()}}(function(){return function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a){this.name="RavenConfigError",this.message=a}d.prototype=new Error,d.prototype.constructor=d,b.exports=d},{}],2:[function(a,b,c){var d=a(5),e=function(a,b,c){var e=a[b],f=a;if(b in a){var g="warn"===b?"warning":b;a[b]=function(){var a=[].slice.call(arguments),h=d.safeJoin(a," "),i={level:g,logger:"console",extra:{arguments:a}};"assert"===b?a[0]===!1&&(h="Assertion failed: "+(d.safeJoin(a.slice(1)," ")||"console.assert"),i.extra.arguments=a.slice(1),c&&c(h,i)):c&&c(h,i),e&&Function.prototype.apply.call(e,f,a)}}};b.exports={wrapMethod:e}},{5:5}],3:[function(a,b,c){(function(c){function d(){return+new Date}function e(a,b){return q(b)?function(c){return b(c,a)}:b}function f(){this.a=!("object"!=typeof JSON||!JSON.stringify),this.b=!p(P),this.c=!p(Q),this.d=null,this.e=null,this.f=null,this.g=null,this.h=null,this.i=null,this.j={},this.k={release:O.SENTRY_RELEASE&&O.SENTRY_RELEASE.id,logger:"javascript",ignoreErrors:[],ignoreUrls:[],whitelistUrls:[],includePaths:[],headers:null,collectWindowErrors:!0,captureUnhandledRejections:!0,maxMessageLength:0,maxUrlLength:250,stackTraceLimit:50,autoBreadcrumbs:!0,instrument:!0,sampleRate:1},this.l={method:"POST",keepalive:!0,referrerPolicy:I()?"origin":""},this.m=0,this.n=!1,this.o=Error.stackTraceLimit,this.p=O.console||{},this.q={},this.r=[],this.s=d(),this.t=[],this.u=[],this.v=null,this.w=O.location,this.x=this.w&&this.w.href,this.y();for(var a in this.p)this.q[a]=this.p[a]}var g=a(6),h=a(7),i=a(8),j=a(1),k=a(5),l=k.isError,m=k.isObject,n=k.isPlainObject,o=k.isErrorEvent,p=k.isUndefined,q=k.isFunction,r=k.isString,s=k.isArray,t=k.isEmptyObject,u=k.each,v=k.objectMerge,w=k.truncate,x=k.objectFrozen,y=k.hasKey,z=k.joinRegExp,A=k.urlencode,B=k.uuid4,C=k.htmlTreeAsString,D=k.isSameException,E=k.isSameStacktrace,F=k.parseUrl,G=k.fill,H=k.supportsFetch,I=k.supportsReferrerPolicy,J=k.serializeKeysForMessage,K=k.serializeException,L=a(2).wrapMethod,M="source protocol user pass host port path".split(" "),N=/^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/,O="undefined"!=typeof window?window:"undefined"!=typeof c?c:"undefined"!=typeof self?self:{},P=O.document,Q=O.navigator;f.prototype={VERSION:"3.23.3",debug:!1,TraceKit:g,config:function(a,b){var c=this;if(c.g)return this.z("error","Error: Raven has already been configured"),c;if(!a)return c;var d=c.k;b&&u(b,function(a,b){"tags"===a||"extra"===a||"user"===a?c.j[a]=b:d[a]=b}),c.setDSN(a),d.ignoreErrors.push(/^Script error\.?$/),d.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/),d.ignoreErrors=z(d.ignoreErrors),d.ignoreUrls=!!d.ignoreUrls.length&&z(d.ignoreUrls),d.whitelistUrls=!!d.whitelistUrls.length&&z(d.whitelistUrls),d.includePaths=z(d.includePaths),d.maxBreadcrumbs=Math.max(0,Math.min(d.maxBreadcrumbs||100,100));var e={xhr:!0,console:!0,dom:!0,location:!0,sentry:!0},f=d.autoBreadcrumbs;"[object Object]"==={}.toString.call(f)?f=v(e,f):f!==!1&&(f=e),d.autoBreadcrumbs=f;var h={tryCatch:!0},i=d.instrument;return"[object Object]"==={}.toString.call(i)?i=v(h,i):i!==!1&&(i=h),d.instrument=i,g.collectWindowErrors=!!d.collectWindowErrors,c},install:function(){var a=this;return a.isSetup()&&!a.n&&(g.report.subscribe(function(){a.A.apply(a,arguments)}),a.k.captureUnhandledRejections&&a.B(),a.C(),a.k.instrument&&a.k.instrument.tryCatch&&a.D(),a.k.autoBreadcrumbs&&a.E(),a.F(),a.n=!0),Error.stackTraceLimit=a.k.stackTraceLimit,this},setDSN:function(a){var b=this,c=b.G(a),d=c.path.lastIndexOf("/"),e=c.path.substr(1,d);b.H=a,b.h=c.user,b.I=c.pass&&c.pass.substr(1),b.i=c.path.substr(d+1),b.g=b.J(c),b.K=b.g+"/"+e+"api/"+b.i+"/store/",this.y()},context:function(a,b,c){return q(a)&&(c=b||[],b=a,a=void 0),this.wrap(a,b).apply(this,c)},wrap:function(a,b,c){function d(){var d=[],f=arguments.length,g=!a||a&&a.deep!==!1;for(c&&q(c)&&c.apply(this,arguments);f--;)d[f]=g?e.wrap(a,arguments[f]):arguments[f];try{return b.apply(this,d)}catch(h){throw e.L(),e.captureException(h,a),h}}var e=this;if(p(b)&&!q(a))return a;if(q(a)&&(b=a,a=void 0),!q(b))return b;try{if(b.M)return b;if(b.N)return b.N}catch(f){return b}for(var g in b)y(b,g)&&(d[g]=b[g]);return d.prototype=b.prototype,b.N=d,d.M=!0,d.O=b,d},uninstall:function(){return g.report.uninstall(),this.P(),this.Q(),this.R(),this.S(),Error.stackTraceLimit=this.o,this.n=!1,this},T:function(a){this.z("debug","Raven caught unhandled promise rejection:",a),this.captureException(a.reason)},B:function(){return this.T=this.T.bind(this),O.addEventListener&&O.addEventListener("unhandledrejection",this.T),this},P:function(){return O.removeEventListener&&O.removeEventListener("unhandledrejection",this.T),this},captureException:function(a,b){if(b=v({trimHeadFrames:0},b?b:{}),o(a)&&a.error)a=a.error;else if(l(a))a=a;else{if(!n(a))return this.captureMessage(a,v(b,{stacktrace:!0,trimHeadFrames:b.trimHeadFrames+1}));b=this.U(b,a),a=new Error(b.message)}this.d=a;try{var c=g.computeStackTrace(a);this.V(c,b)}catch(d){if(a!==d)throw d}return this},U:function(a,b){var c=Object.keys(b).sort(),d=v(a,{message:"Non-Error exception captured with keys: "+J(c),fingerprint:[i(c)],extra:a.extra||{}});return d.extra.W=K(b),d},captureMessage:function(a,b){if(!this.k.ignoreErrors.test||!this.k.ignoreErrors.test(a)){b=b||{},a+="";var c,d=v({message:a},b);try{throw new Error(a)}catch(e){c=e}c.name=null;var f=g.computeStackTrace(c),h=s(f.stack)&&f.stack[1],i=h&&h.url||"";if((!this.k.ignoreUrls.test||!this.k.ignoreUrls.test(i))&&(!this.k.whitelistUrls.test||this.k.whitelistUrls.test(i))){if(this.k.stacktrace||b&&b.stacktrace){d.fingerprint=null==d.fingerprint?a:d.fingerprint,b=v({trimHeadFrames:0},b),b.trimHeadFrames+=1;var j=this.X(f,b);d.stacktrace={frames:j.reverse()}}return d.fingerprint&&(d.fingerprint=s(d.fingerprint)?d.fingerprint:[d.fingerprint]),this.Y(d),this}}},captureBreadcrumb:function(a){var b=v({timestamp:d()/1e3},a);if(q(this.k.breadcrumbCallback)){var c=this.k.breadcrumbCallback(b);if(m(c)&&!t(c))b=c;else if(c===!1)return this}return this.u.push(b),this.u.length>this.k.maxBreadcrumbs&&this.u.shift(),this},addPlugin:function(a){var b=[].slice.call(arguments,1);return this.r.push([a,b]),this.n&&this.F(),this},setUserContext:function(a){return this.j.user=a,this},setExtraContext:function(a){return this.Z("extra",a),this},setTagsContext:function(a){return this.Z("tags",a),this},clearContext:function(){return this.j={},this},getContext:function(){return JSON.parse(h(this.j))},setEnvironment:function(a){return this.k.environment=a,this},setRelease:function(a){return this.k.release=a,this},setDataCallback:function(a){var b=this.k.dataCallback;return this.k.dataCallback=e(b,a),this},setBreadcrumbCallback:function(a){var b=this.k.breadcrumbCallback;return this.k.breadcrumbCallback=e(b,a),this},setShouldSendCallback:function(a){var b=this.k.shouldSendCallback;return this.k.shouldSendCallback=e(b,a),this},setTransport:function(a){return this.k.transport=a,this},lastException:function(){return this.d},lastEventId:function(){return this.f},isSetup:function(){return!!this.a&&(!!this.g||(this.ravenNotConfiguredError||(this.ravenNotConfiguredError=!0,this.z("error","Error: Raven has not been configured.")),!1))},afterLoad:function(){var a=O.RavenConfig;a&&this.config(a.dsn,a.config).install()},showReportDialog:function(a){if(P){a=a||{};var b=a.eventId||this.lastEventId();if(!b)throw new j("Missing eventId");var c=a.dsn||this.H;if(!c)throw new j("Missing DSN");var d=encodeURIComponent,e="";e+="?eventId="+d(b),e+="&dsn="+d(c);var f=a.user||this.j.user;f&&(f.name&&(e+="&name="+d(f.name)),f.email&&(e+="&email="+d(f.email)));var g=this.J(this.G(c)),h=P.createElement("script");h.async=!0,h.src=g+"/api/embed/error-page/"+e,(P.head||P.body).appendChild(h)}},L:function(){var a=this;this.m+=1,setTimeout(function(){a.m-=1})},$:function(a,b){var c,d;if(this.b){b=b||{},a="raven"+a.substr(0,1).toUpperCase()+a.substr(1),P.createEvent?(c=P.createEvent("HTMLEvents"),c.initEvent(a,!0,!0)):(c=P.createEventObject(),c.eventType=a);for(d in b)y(b,d)&&(c[d]=b[d]);if(P.createEvent)P.dispatchEvent(c);else try{P.fireEvent("on"+c.eventType.toLowerCase(),c)}catch(e){}}},_:function(a){var b=this;return function(c){if(b.aa=null,b.v!==c){b.v=c;var d;try{d=C(c.target)}catch(e){d="<unknown>"}b.captureBreadcrumb({category:"ui."+a,message:d})}}},ba:function(){var a=this,b=1e3;return function(c){var d;try{d=c.target}catch(e){return}var f=d&&d.tagName;if(f&&("INPUT"===f||"TEXTAREA"===f||d.isContentEditable)){var g=a.aa;g||a._("input")(c),clearTimeout(g),a.aa=setTimeout(function(){a.aa=null},b)}}},ca:function(a,b){var c=F(this.w.href),d=F(b),e=F(a);this.x=b,c.protocol===d.protocol&&c.host===d.host&&(b=d.relative),c.protocol===e.protocol&&c.host===e.host&&(a=e.relative),this.captureBreadcrumb({category:"navigation",data:{to:b,from:a}})},C:function(){var a=this;a.da=Function.prototype.toString,Function.prototype.toString=function(){return"function"==typeof this&&this.M?a.da.apply(this.O,arguments):a.da.apply(this,arguments)}},Q:function(){this.da&&(Function.prototype.toString=this.da)},D:function(){function a(a){return function(b,d){for(var e=new Array(arguments.length),f=0;f<e.length;++f)e[f]=arguments[f];var g=e[0];return q(g)&&(e[0]=c.wrap(g)),a.apply?a.apply(this,e):a(e[0],e[1])}}function b(a){var b=O[a]&&O[a].prototype;b&&b.hasOwnProperty&&b.hasOwnProperty("addEventListener")&&(G(b,"addEventListener",function(b){return function(d,f,g,h){try{f&&f.handleEvent&&(f.handleEvent=c.wrap(f.handleEvent))}catch(i){}var j,k,l;return e&&e.dom&&("EventTarget"===a||"Node"===a)&&(k=c._("click"),l=c.ba(),j=function(a){if(a){var b;try{b=a.type}catch(c){return}return"click"===b?k(a):"keypress"===b?l(a):void 0}}),b.call(this,d,c.wrap(f,void 0,j),g,h)}},d),G(b,"removeEventListener",function(a){return function(b,c,d,e){try{c=c&&(c.N?c.N:c)}catch(f){}return a.call(this,b,c,d,e)}},d))}var c=this,d=c.t,e=this.k.autoBreadcrumbs;G(O,"setTimeout",a,d),G(O,"setInterval",a,d),O.requestAnimationFrame&&G(O,"requestAnimationFrame",function(a){return function(b){return a(c.wrap(b))}},d);for(var f=["EventTarget","Window","Node","ApplicationCache","AudioTrackList","ChannelMergerNode","CryptoOperation","EventSource","FileReader","HTMLUnknownElement","IDBDatabase","IDBRequest","IDBTransaction","KeyOperation","MediaController","MessagePort","ModalWindow","Notification","SVGElementInstance","Screen","TextTrack","TextTrackCue","TextTrackList","WebSocket","WebSocketWorker","Worker","XMLHttpRequest","XMLHttpRequestEventTarget","XMLHttpRequestUpload"],g=0;g<f.length;g++)b(f[g])},E:function(){function a(a,c){a in c&&q(c[a])&&G(c,a,function(a){return b.wrap(a)})}var b=this,c=this.k.autoBreadcrumbs,d=b.t;if(c.xhr&&"XMLHttpRequest"in O){var e=XMLHttpRequest.prototype;G(e,"open",function(a){return function(c,d){return r(d)&&d.indexOf(b.h)===-1&&(this.ea={method:c,url:d,status_code:null}),a.apply(this,arguments)}},d),G(e,"send",function(c){return function(){function d(){if(e.ea&&4===e.readyState){try{e.ea.status_code=e.status}catch(a){}b.captureBreadcrumb({type:"http",category:"xhr",data:e.ea})}}for(var e=this,f=["onload","onerror","onprogress"],g=0;g<f.length;g++)a(f[g],e);return"onreadystatechange"in e&&q(e.onreadystatechange)?G(e,"onreadystatechange",function(a){return b.wrap(a,void 0,d)}):e.onreadystatechange=d,c.apply(this,arguments)}},d)}c.xhr&&H()&&G(O,"fetch",function(a){return function(){for(var c=new Array(arguments.length),d=0;d<c.length;++d)c[d]=arguments[d];var e,f=c[0],g="GET";if("string"==typeof f?e=f:"Request"in O&&f instanceof O.Request?(e=f.url,f.method&&(g=f.method)):e=""+f,e.indexOf(b.h)!==-1)return a.apply(this,c);c[1]&&c[1].method&&(g=c[1].method);var h={method:g,url:e,status_code:null};return a.apply(this,c).then(function(a){return h.status_code=a.status,b.captureBreadcrumb({type:"http",category:"fetch",data:h}),a})}},d),c.dom&&this.b&&(P.addEventListener?(P.addEventListener("click",b._("click"),!1),P.addEventListener("keypress",b.ba(),!1)):(P.attachEvent("onclick",b._("click")),P.attachEvent("onkeypress",b.ba())));var f=O.chrome,g=f&&f.app&&f.app.runtime,h=!g&&O.history&&history.pushState&&history.replaceState;if(c.location&&h){var i=O.onpopstate;O.onpopstate=function(){var a=b.w.href;if(b.ca(b.x,a),i)return i.apply(this,arguments)};var j=function(a){return function(){var c=arguments.length>2?arguments[2]:void 0;return c&&b.ca(b.x,c+""),a.apply(this,arguments)}};G(history,"pushState",j,d),G(history,"replaceState",j,d)}if(c.console&&"console"in O&&console.log){var k=function(a,c){b.captureBreadcrumb({message:a,level:c.level,category:"console"})};u(["debug","info","warn","error","log"],function(a,b){L(console,b,k)})}},R:function(){for(var a;this.t.length;){a=this.t.shift();var b=a[0],c=a[1],d=a[2];b[c]=d}},S:function(){for(var a in this.q)this.p[a]=this.q[a]},F:function(){var a=this;u(this.r,function(b,c){var d=c[0],e=c[1];d.apply(a,[a].concat(e))})},G:function(a){var b=N.exec(a),c={},d=7;try{for(;d--;)c[M[d]]=b[d]||""}catch(e){throw new j("Invalid DSN: "+a)}if(c.pass&&!this.k.allowSecretKey)throw new j("Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key");return c},J:function(a){var b="//"+a.host+(a.port?":"+a.port:"");return a.protocol&&(b=a.protocol+":"+b),b},A:function(){this.m||this.V.apply(this,arguments)},V:function(a,b){var c=this.X(a,b);this.$("handle",{stackInfo:a,options:b}),this.fa(a.name,a.message,a.url,a.lineno,c,b)},X:function(a,b){var c=this,d=[];if(a.stack&&a.stack.length&&(u(a.stack,function(b,e){var f=c.ga(e,a.url);f&&d.push(f)}),b&&b.trimHeadFrames))for(var e=0;e<b.trimHeadFrames&&e<d.length;e++)d[e].in_app=!1;return d=d.slice(0,this.k.stackTraceLimit)},ga:function(a,b){var c={filename:a.url,lineno:a.line,colno:a.column,"function":a.func||"?"};return a.url||(c.filename=b),c.in_app=!(this.k.includePaths.test&&!this.k.includePaths.test(c.filename)||/(Raven|TraceKit)\./.test(c["function"])||/raven\.(min\.)?js$/.test(c.filename)),c},fa:function(a,b,c,d,e,f){var g=(a?a+": ":"")+(b||"");if(!this.k.ignoreErrors.test||!this.k.ignoreErrors.test(b)&&!this.k.ignoreErrors.test(g)){var h;if(e&&e.length?(c=e[0].filename||c,e.reverse(),h={frames:e}):c&&(h={frames:[{filename:c,lineno:d,in_app:!0}]}),(!this.k.ignoreUrls.test||!this.k.ignoreUrls.test(c))&&(!this.k.whitelistUrls.test||this.k.whitelistUrls.test(c))){var i=v({exception:{values:[{type:a,value:b,stacktrace:h}]},culprit:c},f);this.Y(i)}}},ha:function(a){var b=this.k.maxMessageLength;if(a.message&&(a.message=w(a.message,b)),a.exception){var c=a.exception.values[0];c.value=w(c.value,b)}var d=a.request;return d&&(d.url&&(d.url=w(d.url,this.k.maxUrlLength)),d.Referer&&(d.Referer=w(d.Referer,this.k.maxUrlLength))),a.breadcrumbs&&a.breadcrumbs.values&&this.ia(a.breadcrumbs),a},ia:function(a){for(var b,c,d,e=["to","from","url"],f=0;f<a.values.length;++f)if(c=a.values[f],c.hasOwnProperty("data")&&m(c.data)&&!x(c.data)){d=v({},c.data);for(var g=0;g<e.length;++g)b=e[g],d.hasOwnProperty(b)&&d[b]&&(d[b]=w(d[b],this.k.maxUrlLength));a.values[f].data=d}},ja:function(){if(this.c||this.b){var a={};return this.c&&Q.userAgent&&(a.headers={"User-Agent":navigator.userAgent}),O.location&&O.location.href&&(a.url=O.location.href),this.b&&P.referrer&&(a.headers||(a.headers={}),a.headers.Referer=P.referrer),a}},y:function(){this.ka=0,this.la=null},ma:function(){return this.ka&&d()-this.la<this.ka},na:function(a){var b=this.e;return!(!b||a.message!==b.message||a.culprit!==b.culprit)&&(a.stacktrace||b.stacktrace?E(a.stacktrace,b.stacktrace):!a.exception&&!b.exception||D(a.exception,b.exception))},oa:function(a){if(!this.ma()){var b=a.status;if(400===b||401===b||429===b){var c;try{c=H()?a.headers.get("Retry-After"):a.getResponseHeader("Retry-After"),c=1e3*parseInt(c,10)}catch(e){}this.ka=c?c:2*this.ka||1e3,this.la=d()}}},Y:function(a){var b=this.k,c={project:this.i,logger:b.logger,platform:"javascript"},e=this.ja();if(e&&(c.request=e),a.trimHeadFrames&&delete a.trimHeadFrames,a=v(c,a),a.tags=v(v({},this.j.tags),a.tags),a.extra=v(v({},this.j.extra),a.extra),a.extra["session:duration"]=d()-this.s,this.u&&this.u.length>0&&(a.breadcrumbs={values:[].slice.call(this.u,0)}),this.j.user&&(a.user=this.j.user),b.environment&&(a.environment=b.environment),b.release&&(a.release=b.release),b.serverName&&(a.server_name=b.serverName),Object.keys(a).forEach(function(b){(null==a[b]||""===a[b]||t(a[b]))&&delete a[b]}),q(b.dataCallback)&&(a=b.dataCallback(a)||a),a&&!t(a)&&(!q(b.shouldSendCallback)||b.shouldSendCallback(a)))return this.ma()?void this.z("warn","Raven dropped error due to backoff: ",a):void("number"==typeof b.sampleRate?Math.random()<b.sampleRate&&this.pa(a):this.pa(a))},qa:function(){return B()},pa:function(a,b){var c=this,d=this.k;if(this.isSetup()){if(a=this.ha(a),!this.k.allowDuplicates&&this.na(a))return void this.z("warn","Raven dropped repeat event: ",a);this.f=a.event_id||(a.event_id=this.qa()),this.e=a,this.z("debug","Raven about to send:",a);var e={sentry_version:"7",sentry_client:"raven-js/"+this.VERSION,sentry_key:this.h};this.I&&(e.sentry_secret=this.I);var f=a.exception&&a.exception.values[0];this.k.autoBreadcrumbs&&this.k.autoBreadcrumbs.sentry&&this.captureBreadcrumb({category:"sentry",message:f?(f.type?f.type+": ":"")+f.value:a.message,event_id:a.event_id,level:a.level||"error"});var g=this.K;(d.transport||this.ra).call(this,{url:g,auth:e,data:a,options:d,onSuccess:function(){c.y(),c.$("success",{data:a,src:g}),b&&b()},onError:function(d){c.z("error","Raven transport failed to send: ",d),d.request&&c.oa(d.request),c.$("failure",{data:a,src:g}),d=d||new Error("Raven send failed (no additional details provided)"),b&&b(d)}})}},ra:function(a){var b=a.url+"?"+A(a.auth),c=null,d={};if(a.options.headers&&(c=this.sa(a.options.headers)),a.options.fetchParameters&&(d=this.sa(a.options.fetchParameters)),H()){d.body=h(a.data);var e=v({},this.l),f=v(e,d);return c&&(f.headers=c),O.fetch(b,f).then(function(b){if(b.ok)a.onSuccess&&a.onSuccess();else{var c=new Error("Sentry error code: "+b.status);c.request=b,a.onError&&a.onError(c)}})["catch"](function(){a.onError&&a.onError(new Error("Sentry error code: network unavailable"))})}var g=O.XMLHttpRequest&&new O.XMLHttpRequest;if(g){var i="withCredentials"in g||"undefined"!=typeof XDomainRequest;i&&("withCredentials"in g?g.onreadystatechange=function(){if(4===g.readyState)if(200===g.status)a.onSuccess&&a.onSuccess();else if(a.onError){var b=new Error("Sentry error code: "+g.status);b.request=g,a.onError(b)}}:(g=new XDomainRequest,b=b.replace(/^https?:/,""),a.onSuccess&&(g.onload=a.onSuccess),a.onError&&(g.onerror=function(){var b=new Error("Sentry error code: XDomainRequest");b.request=g,a.onError(b)})),g.open("POST",b),c&&u(c,function(a,b){g.setRequestHeader(a,b)}),g.send(h(a.data)))}},sa:function(a){var b={};for(var c in a)if(a.hasOwnProperty(c)){var d=a[c];b[c]="function"==typeof d?d():d}return b},z:function(a){this.q[a]&&this.debug&&Function.prototype.apply.call(this.q[a],this.p,[].slice.call(arguments,1))},Z:function(a,b){p(b)?delete this.j[a]:this.j[a]=v(this.j[a]||{},b)}},f.prototype.setUser=f.prototype.setUserContext,f.prototype.setReleaseContext=f.prototype.setRelease,b.exports=f}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{1:1,2:2,5:5,6:6,7:7,8:8}],4:[function(a,b,c){(function(c){var d=a(3),e="undefined"!=typeof window?window:"undefined"!=typeof c?c:"undefined"!=typeof self?self:{},f=e.Raven,g=new d;g.noConflict=function(){return e.Raven=f,g},g.afterLoad(),b.exports=g}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{3:3}],5:[function(a,b,c){(function(c){function d(a){return"object"==typeof a&&null!==a}function e(a){switch({}.toString.call(a)){case"[object Error]":return!0;case"[object Exception]":return!0;case"[object DOMException]":return!0;default:return a instanceof Error}}function f(a){return m()&&"[object ErrorEvent]"==={}.toString.call(a)}function g(a){return void 0===a}function h(a){return"function"==typeof a}function i(a){return"[object Object]"===Object.prototype.toString.call(a)}function j(a){return"[object String]"===Object.prototype.toString.call(a)}function k(a){return"[object Array]"===Object.prototype.toString.call(a)}function l(a){if(!i(a))return!1;for(var b in a)if(a.hasOwnProperty(b))return!1;return!0}function m(){try{return new ErrorEvent(""),!0}catch(a){return!1}}function n(){if(!("fetch"in P))return!1;try{return new Headers,new Request(""),new Response,!0}catch(a){return!1}}function o(){if(!n())return!1;try{return new Request("pickleRick",{referrerPolicy:"origin"}),!0}catch(a){return!1}}function p(){return"function"==typeof PromiseRejectionEvent}function q(a){function b(b,c){var d=a(b)||b;return c?c(d)||d:d}return b}function r(a,b){var c,d;if(g(a.length))for(c in a)v(a,c)&&b.call(null,c,a[c]);else if(d=a.length)for(c=0;c<d;c++)b.call(null,c,a[c])}function s(a,b){return b?(r(b,function(b,c){a[b]=c}),a):a}function t(a){return!!Object.isFrozen&&Object.isFrozen(a)}function u(a,b){return!b||a.length<=b?a:a.substr(0,b)+"…"}function v(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function w(a){for(var b,c=[],d=0,e=a.length;d<e;d++)b=a[d],j(b)?c.push(b.replace(/([.*+?^=!:${}()|\[\]\/\\])/g,"\\$1")):b&&b.source&&c.push(b.source);return new RegExp(c.join("|"),"i")}function x(a){var b=[];return r(a,function(a,c){b.push(encodeURIComponent(a)+"="+encodeURIComponent(c))}),b.join("&")}function y(a){if("string"!=typeof a)return{};var b=a.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/),c=b[6]||"",d=b[8]||"";return{protocol:b[2],host:b[4],path:b[5],relative:b[5]+c+d}}function z(){var a=P.crypto||P.msCrypto;if(!g(a)&&a.getRandomValues){var b=new Uint16Array(8);a.getRandomValues(b),b[3]=4095&b[3]|16384,b[4]=16383&b[4]|32768;var c=function(a){for(var b=a.toString(16);b.length<4;)b="0"+b;return b};return c(b[0])+c(b[1])+c(b[2])+c(b[3])+c(b[4])+c(b[5])+c(b[6])+c(b[7])}return"xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g,function(a){var b=16*Math.random()|0,c="x"===a?b:3&b|8;return c.toString(16)})}function A(a){for(var b,c=5,d=80,e=[],f=0,g=0,h=" > ",i=h.length;a&&f++<c&&(b=B(a),!("html"===b||f>1&&g+e.length*i+b.length>=d));)e.push(b),g+=b.length,a=a.parentNode;return e.reverse().join(h)}function B(a){var b,c,d,e,f,g=[];if(!a||!a.tagName)return"";if(g.push(a.tagName.toLowerCase()),a.id&&g.push("#"+a.id),b=a.className,b&&j(b))for(c=b.split(/\s+/),f=0;f<c.length;f++)g.push("."+c[f]);var h=["type","name","title","alt"];for(f=0;f<h.length;f++)d=h[f],e=a.getAttribute(d),e&&g.push("["+d+'="'+e+'"]');return g.join("")}function C(a,b){return!!(!!a^!!b)}function D(a,b){return g(a)&&g(b)}function E(a,b){return!C(a,b)&&(a=a.values[0],b=b.values[0],a.type===b.type&&a.value===b.value&&(!D(a.stacktrace,b.stacktrace)&&F(a.stacktrace,b.stacktrace)))}function F(a,b){if(C(a,b))return!1;var c=a.frames,d=b.frames;if(c.length!==d.length)return!1;for(var e,f,g=0;g<c.length;g++)if(e=c[g],f=d[g],e.filename!==f.filename||e.lineno!==f.lineno||e.colno!==f.colno||e["function"]!==f["function"])return!1;return!0}function G(a,b,c,d){var e=a[b];a[b]=c(e),a[b].M=!0,a[b].O=e,d&&d.push([a,b,e])}function H(a,b){if(!k(a))return"";for(var c=[],d=0;d<a.length;d++)try{c.push(String(a[d]))}catch(e){c.push("[value cannot be serialized]")}return c.join(b)}function I(a){return~-encodeURI(a).split(/%..|./).length}function J(a){return I(JSON.stringify(a))}function K(a){var b=40;if("string"==typeof a)return a.length<=b?a:a.substr(0,b-1)+"…";if("number"==typeof a||"boolean"==typeof a||"undefined"==typeof a)return a;var c=Object.prototype.toString.call(a);return"[object Object]"===c?"[Object]":"[object Array]"===c?"[Array]":"[object Function]"===c?a.name?"[Function: "+a.name+"]":"[Function]":a}function L(a,b){return 0===b?K(a):i(a)?Object.keys(a).reduce(function(c,d){return c[d]=L(a[d],b-1),c},{}):Array.isArray(a)?a.map(function(a){return L(a,b-1)}):K(a)}function M(a,b,c){if(!i(a))return a;b="number"!=typeof b?Q:b,c="number"!=typeof b?R:c;var d=L(a,b);return J(O(d))>c?M(a,b-1):d}function N(a,b){if("number"==typeof a||"string"==typeof a)return a.toString();if(!Array.isArray(a))return"";if(a=a.filter(function(a){return"string"==typeof a}),0===a.length)return"[object has no keys]";if(b="number"!=typeof b?S:b,a[0].length>=b)return a[0];for(var c=a.length;c>0;c--){var d=a.slice(0,c).join(", ");if(!(d.length>b))return c===a.length?d:d+"…"}return""}var O=a(7),P="undefined"!=typeof window?window:"undefined"!=typeof c?c:"undefined"!=typeof self?self:{},Q=3,R=51200,S=40;b.exports={isObject:d,isError:e,isErrorEvent:f,isUndefined:g,isFunction:h,isPlainObject:i,isString:j,isArray:k,isEmptyObject:l,supportsErrorEvent:m,supportsFetch:n,supportsReferrerPolicy:o,supportsPromiseRejectionEvent:p,wrappedCallback:q,each:r,objectMerge:s,truncate:u,objectFrozen:t,hasKey:v,joinRegExp:w,urlencode:x,uuid4:z,htmlTreeAsString:A,htmlElementAsString:B,isSameException:E,isSameStacktrace:F,parseUrl:y,fill:G,safeJoin:H,serializeException:M,serializeKeysForMessage:N}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{7:7}],6:[function(a,b,c){(function(c){function d(){return"undefined"==typeof document||null==document.location?"":document.location.href}var e=a(5),f={collectWindowErrors:!0,debug:!1},g="undefined"!=typeof window?window:"undefined"!=typeof c?c:"undefined"!=typeof self?self:{},h=[].slice,i="?",j=/^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;f.report=function(){function a(a){m(),s.push(a)}function b(a){for(var b=s.length-1;b>=0;--b)s[b]===a&&s.splice(b,1)}function c(){n(),s=[]}function k(a,b){var c=null;if(!b||f.collectWindowErrors){for(var d in s)if(s.hasOwnProperty(d))try{s[d].apply(null,[a].concat(h.call(arguments,2)))}catch(e){c=e}if(c)throw c}}function l(a,b,c,g,h){var l=null,m=e.isErrorEvent(h)?h.error:h,n=e.isErrorEvent(a)?a.message:a;if(v)f.computeStackTrace.augmentStackTraceWithInitialElement(v,b,c,n),o();else if(m&&e.isError(m))l=f.computeStackTrace(m),k(l,!0);else{var p,r={url:b,line:c,column:g},s=void 0;if("[object String]"==={}.toString.call(n)){var p=n.match(j);p&&(s=p[1],n=p[2])}r.func=i,l={name:s,message:n,url:d(),stack:[r]},k(l,!0)}return!!q&&q.apply(this,arguments)}function m(){r||(q=g.onerror,g.onerror=l,r=!0)}function n(){r&&(g.onerror=q,r=!1,q=void 0)}function o(){var a=v,b=t;t=null,v=null,u=null,k.apply(null,[a,!1].concat(b))}function p(a,b){var c=h.call(arguments,1);if(v){if(u===a)return;o()}var d=f.computeStackTrace(a);if(v=d,u=a,t=c,setTimeout(function(){u===a&&o()},d.incomplete?2e3:0),b!==!1)throw a}var q,r,s=[],t=null,u=null,v=null;return p.subscribe=a,p.unsubscribe=b,p.uninstall=c,p}(),f.computeStackTrace=function(){function a(a){if("undefined"!=typeof a.stack&&a.stack){for(var b,c,e,f=/^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,g=/^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,h=/^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i,j=/(\S+) line (\d+)(?: > eval line \d+)* > eval/i,k=/\((\S*)(?::(\d+))(?::(\d+))\)/,l=a.stack.split("\n"),m=[],n=(/^(.*) is undefined$/.exec(a.message),0),o=l.length;n<o;++n){if(c=f.exec(l[n])){var p=c[2]&&0===c[2].indexOf("native"),q=c[2]&&0===c[2].indexOf("eval");q&&(b=k.exec(c[2]))&&(c[2]=b[1],c[3]=b[2],c[4]=b[3]),e={url:p?null:c[2],func:c[1]||i,args:p?[c[2]]:[],line:c[3]?+c[3]:null,column:c[4]?+c[4]:null}}else if(c=g.exec(l[n]))e={url:c[2],func:c[1]||i,args:[],line:+c[3],column:c[4]?+c[4]:null};else{if(!(c=h.exec(l[n])))continue;var q=c[3]&&c[3].indexOf(" > eval")>-1;q&&(b=j.exec(c[3]))?(c[3]=b[1],c[4]=b[2],c[5]=null):0!==n||c[5]||"undefined"==typeof a.columnNumber||(m[0].column=a.columnNumber+1),e={url:c[3],func:c[1]||i,args:c[2]?c[2].split(","):[],line:c[4]?+c[4]:null,column:c[5]?+c[5]:null}}!e.func&&e.line&&(e.func=i),m.push(e)}return m.length?{name:a.name,message:a.message,url:d(),stack:m}:null}}function b(a,b,c,d){var e={url:b,line:c};if(e.url&&e.line){if(a.incomplete=!1,e.func||(e.func=i),a.stack.length>0&&a.stack[0].url===e.url){if(a.stack[0].line===e.line)return!1;if(!a.stack[0].line&&a.stack[0].func===e.func)return a.stack[0].line=e.line,!1}return a.stack.unshift(e),a.partial=!0,!0}return a.incomplete=!0,!1}function c(a,g){for(var h,j,k=/function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,l=[],m={},n=!1,o=c.caller;o&&!n;o=o.caller)if(o!==e&&o!==f.report){if(j={url:null,func:i,line:null,column:null},o.name?j.func=o.name:(h=k.exec(o.toString()))&&(j.func=h[1]),"undefined"==typeof j.func)try{j.func=h.input.substring(0,h.input.indexOf("{"))}catch(p){}m[""+o]?n=!0:m[""+o]=!0,l.push(j)}g&&l.splice(0,g);var q={name:a.name,message:a.message,url:d(),stack:l};return b(q,a.sourceURL||a.fileName,a.line||a.lineNumber,a.message||a.description),q}function e(b,e){var g=null;e=null==e?0:+e;try{if(g=a(b))return g}catch(h){if(f.debug)throw h}try{if(g=c(b,e+1))return g}catch(h){if(f.debug)throw h}return{name:b.name,message:b.message,url:d()}}return e.augmentStackTraceWithInitialElement=b,e.computeStackTraceFromStackProp=a,e}(),b.exports=f}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{5:5}],7:[function(a,b,c){function d(a,b){for(var c=0;c<a.length;++c)if(a[c]===b)return c;return-1}function e(a,b,c,d){return JSON.stringify(a,g(b,d),c)}function f(a){var b={stack:a.stack,message:a.message,name:a.name};for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&(b[c]=a[c]);return b}function g(a,b){var c=[],e=[];return null==b&&(b=function(a,b){return c[0]===b?"[Circular ~]":"[Circular ~."+e.slice(0,d(c,b)).join(".")+"]"}),function(g,h){if(c.length>0){var i=d(c,this);~i?c.splice(i+1):c.push(this),~i?e.splice(i,1/0,g):e.push(g),~d(c,h)&&(h=b.call(this,g,h))}else c.push(h);return null==a?h instanceof Error?f(h):h:a.call(this,g,h)}}c=b.exports=e,c.getSerialize=g},{}],8:[function(a,b,c){function d(a,b){var c=(65535&a)+(65535&b),d=(a>>16)+(b>>16)+(c>>16);return d<<16|65535&c}function e(a,b){return a<<b|a>>>32-b}function f(a,b,c,f,g,h){return d(e(d(d(b,a),d(f,h)),g),c)}function g(a,b,c,d,e,g,h){return f(b&c|~b&d,a,b,e,g,h)}function h(a,b,c,d,e,g,h){return f(b&d|c&~d,a,b,e,g,h)}function i(a,b,c,d,e,g,h){return f(b^c^d,a,b,e,g,h)}function j(a,b,c,d,e,g,h){return f(c^(b|~d),a,b,e,g,h)}function k(a,b){a[b>>5]|=128<<b%32,a[(b+64>>>9<<4)+14]=b;var c,e,f,k,l,m=1732584193,n=-271733879,o=-1732584194,p=271733878;for(c=0;c<a.length;c+=16)e=m,f=n,k=o,l=p,m=g(m,n,o,p,a[c],7,-680876936),p=g(p,m,n,o,a[c+1],12,-389564586),o=g(o,p,m,n,a[c+2],17,606105819),n=g(n,o,p,m,a[c+3],22,-1044525330),m=g(m,n,o,p,a[c+4],7,-176418897),p=g(p,m,n,o,a[c+5],12,1200080426),o=g(o,p,m,n,a[c+6],17,-1473231341),n=g(n,o,p,m,a[c+7],22,-45705983),m=g(m,n,o,p,a[c+8],7,1770035416),p=g(p,m,n,o,a[c+9],12,-1958414417),o=g(o,p,m,n,a[c+10],17,-42063),n=g(n,o,p,m,a[c+11],22,-1990404162),m=g(m,n,o,p,a[c+12],7,1804603682),p=g(p,m,n,o,a[c+13],12,-40341101),o=g(o,p,m,n,a[c+14],17,-1502002290),n=g(n,o,p,m,a[c+15],22,1236535329),m=h(m,n,o,p,a[c+1],5,-165796510),
p=h(p,m,n,o,a[c+6],9,-1069501632),o=h(o,p,m,n,a[c+11],14,643717713),n=h(n,o,p,m,a[c],20,-373897302),m=h(m,n,o,p,a[c+5],5,-701558691),p=h(p,m,n,o,a[c+10],9,38016083),o=h(o,p,m,n,a[c+15],14,-660478335),n=h(n,o,p,m,a[c+4],20,-405537848),m=h(m,n,o,p,a[c+9],5,568446438),p=h(p,m,n,o,a[c+14],9,-1019803690),o=h(o,p,m,n,a[c+3],14,-187363961),n=h(n,o,p,m,a[c+8],20,1163531501),m=h(m,n,o,p,a[c+13],5,-1444681467),p=h(p,m,n,o,a[c+2],9,-51403784),o=h(o,p,m,n,a[c+7],14,1735328473),n=h(n,o,p,m,a[c+12],20,-1926607734),m=i(m,n,o,p,a[c+5],4,-378558),p=i(p,m,n,o,a[c+8],11,-2022574463),o=i(o,p,m,n,a[c+11],16,1839030562),n=i(n,o,p,m,a[c+14],23,-35309556),m=i(m,n,o,p,a[c+1],4,-1530992060),p=i(p,m,n,o,a[c+4],11,1272893353),o=i(o,p,m,n,a[c+7],16,-155497632),n=i(n,o,p,m,a[c+10],23,-1094730640),m=i(m,n,o,p,a[c+13],4,681279174),p=i(p,m,n,o,a[c],11,-358537222),o=i(o,p,m,n,a[c+3],16,-722521979),n=i(n,o,p,m,a[c+6],23,76029189),m=i(m,n,o,p,a[c+9],4,-640364487),p=i(p,m,n,o,a[c+12],11,-421815835),o=i(o,p,m,n,a[c+15],16,530742520),n=i(n,o,p,m,a[c+2],23,-995338651),m=j(m,n,o,p,a[c],6,-198630844),p=j(p,m,n,o,a[c+7],10,1126891415),o=j(o,p,m,n,a[c+14],15,-1416354905),n=j(n,o,p,m,a[c+5],21,-57434055),m=j(m,n,o,p,a[c+12],6,1700485571),p=j(p,m,n,o,a[c+3],10,-1894986606),o=j(o,p,m,n,a[c+10],15,-1051523),n=j(n,o,p,m,a[c+1],21,-2054922799),m=j(m,n,o,p,a[c+8],6,1873313359),p=j(p,m,n,o,a[c+15],10,-30611744),o=j(o,p,m,n,a[c+6],15,-1560198380),n=j(n,o,p,m,a[c+13],21,1309151649),m=j(m,n,o,p,a[c+4],6,-145523070),p=j(p,m,n,o,a[c+11],10,-1120210379),o=j(o,p,m,n,a[c+2],15,718787259),n=j(n,o,p,m,a[c+9],21,-343485551),m=d(m,e),n=d(n,f),o=d(o,k),p=d(p,l);return[m,n,o,p]}function l(a){var b,c="",d=32*a.length;for(b=0;b<d;b+=8)c+=String.fromCharCode(a[b>>5]>>>b%32&255);return c}function m(a){var b,c=[];for(c[(a.length>>2)-1]=void 0,b=0;b<c.length;b+=1)c[b]=0;var d=8*a.length;for(b=0;b<d;b+=8)c[b>>5]|=(255&a.charCodeAt(b/8))<<b%32;return c}function n(a){return l(k(m(a),8*a.length))}function o(a,b){var c,d,e=m(a),f=[],g=[];for(f[15]=g[15]=void 0,e.length>16&&(e=k(e,8*a.length)),c=0;c<16;c+=1)f[c]=909522486^e[c],g[c]=1549556828^e[c];return d=k(f.concat(m(b)),512+8*b.length),l(k(g.concat(d),640))}function p(a){var b,c,d="0123456789abcdef",e="";for(c=0;c<a.length;c+=1)b=a.charCodeAt(c),e+=d.charAt(b>>>4&15)+d.charAt(15&b);return e}function q(a){return unescape(encodeURIComponent(a))}function r(a){return n(q(a))}function s(a){return p(r(a))}function t(a,b){return o(q(a),q(b))}function u(a,b){return p(t(a,b))}function v(a,b,c){return b?c?t(b,a):u(b,a):c?r(a):s(a)}b.exports=v},{}]},{},[4])(4)});
//# sourceMappingURL=raven.min.js.map
/*! Raven.js 3.23.3 (f261ec2) | github.com/getsentry/raven-js */
!function(a){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=a();else if("function"==typeof define&&define.amd)define([],a);else{var b;b="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,b=b.Raven||(b.Raven={}),b=b.Plugins||(b.Plugins={}),b.Angular=a()}}(function(){return function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a,b){function c(){this.$get=["$window",function(b){return a}]}function f(a){a.decorator("$exceptionHandler",["Raven","$delegate",h])}function h(a,b){return function(c,d){a.captureException(c,{extra:{cause:d}}),b(c,d)}}b=b||window.angular,b&&(b.module(g,[]).provider("Raven",c).config(["$provide",f]),a.setDataCallback(e(function(a){return d.a(a)})))}var e=a(2).wrappedCallback,f=/^\[((?:[$a-zA-Z0-9]+:)?(?:[$a-zA-Z0-9]+))\] (.*?)\n?(\S+)$/,g="ngRaven";d.a=function(a){var b=a.exception;if(b){b=b.values[0];var c=f.exec(b.value);c&&(b.type=c[1],b.value=c[2],a.message=b.type+": "+b.value,a.extra.angularDocs=c[3].substr(0,250))}return a},d.moduleName=g,b.exports=d},{2:2}],2:[function(a,b,c){(function(c){function d(a){return"object"==typeof a&&null!==a}function e(a){switch({}.toString.call(a)){case"[object Error]":return!0;case"[object Exception]":return!0;case"[object DOMException]":return!0;default:return a instanceof Error}}function f(a){return m()&&"[object ErrorEvent]"==={}.toString.call(a)}function g(a){return void 0===a}function h(a){return"function"==typeof a}function i(a){return"[object Object]"===Object.prototype.toString.call(a)}function j(a){return"[object String]"===Object.prototype.toString.call(a)}function k(a){return"[object Array]"===Object.prototype.toString.call(a)}function l(a){if(!i(a))return!1;for(var b in a)if(a.hasOwnProperty(b))return!1;return!0}function m(){try{return new ErrorEvent(""),!0}catch(a){return!1}}function n(){if(!("fetch"in P))return!1;try{return new Headers,new Request(""),new Response,!0}catch(a){return!1}}function o(){if(!n())return!1;try{return new Request("pickleRick",{referrerPolicy:"origin"}),!0}catch(a){return!1}}function p(){return"function"==typeof PromiseRejectionEvent}function q(a){function b(b,c){var d=a(b)||b;return c?c(d)||d:d}return b}function r(a,b){var c,d;if(g(a.length))for(c in a)v(a,c)&&b.call(null,c,a[c]);else if(d=a.length)for(c=0;c<d;c++)b.call(null,c,a[c])}function s(a,b){return b?(r(b,function(b,c){a[b]=c}),a):a}function t(a){return!!Object.isFrozen&&Object.isFrozen(a)}function u(a,b){return!b||a.length<=b?a:a.substr(0,b)+"…"}function v(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function w(a){for(var b,c=[],d=0,e=a.length;d<e;d++)b=a[d],j(b)?c.push(b.replace(/([.*+?^=!:${}()|\[\]\/\\])/g,"\\$1")):b&&b.source&&c.push(b.source);return new RegExp(c.join("|"),"i")}function x(a){var b=[];return r(a,function(a,c){b.push(encodeURIComponent(a)+"="+encodeURIComponent(c))}),b.join("&")}function y(a){if("string"!=typeof a)return{};var b=a.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/),c=b[6]||"",d=b[8]||"";return{protocol:b[2],host:b[4],path:b[5],relative:b[5]+c+d}}function z(){var a=P.crypto||P.msCrypto;if(!g(a)&&a.getRandomValues){var b=new Uint16Array(8);a.getRandomValues(b),b[3]=4095&b[3]|16384,b[4]=16383&b[4]|32768;var c=function(a){for(var b=a.toString(16);b.length<4;)b="0"+b;return b};return c(b[0])+c(b[1])+c(b[2])+c(b[3])+c(b[4])+c(b[5])+c(b[6])+c(b[7])}return"xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g,function(a){var b=16*Math.random()|0,c="x"===a?b:3&b|8;return c.toString(16)})}function A(a){for(var b,c=5,d=80,e=[],f=0,g=0,h=" > ",i=h.length;a&&f++<c&&(b=B(a),!("html"===b||f>1&&g+e.length*i+b.length>=d));)e.push(b),g+=b.length,a=a.parentNode;return e.reverse().join(h)}function B(a){var b,c,d,e,f,g=[];if(!a||!a.tagName)return"";if(g.push(a.tagName.toLowerCase()),a.id&&g.push("#"+a.id),b=a.className,b&&j(b))for(c=b.split(/\s+/),f=0;f<c.length;f++)g.push("."+c[f]);var h=["type","name","title","alt"];for(f=0;f<h.length;f++)d=h[f],e=a.getAttribute(d),e&&g.push("["+d+'="'+e+'"]');return g.join("")}function C(a,b){return!!(!!a^!!b)}function D(a,b){return g(a)&&g(b)}function E(a,b){return!C(a,b)&&(a=a.values[0],b=b.values[0],a.type===b.type&&a.value===b.value&&(!D(a.stacktrace,b.stacktrace)&&F(a.stacktrace,b.stacktrace)))}function F(a,b){if(C(a,b))return!1;var c=a.frames,d=b.frames;if(c.length!==d.length)return!1;for(var e,f,g=0;g<c.length;g++)if(e=c[g],f=d[g],e.filename!==f.filename||e.lineno!==f.lineno||e.colno!==f.colno||e["function"]!==f["function"])return!1;return!0}function G(a,b,c,d){var e=a[b];a[b]=c(e),a[b].b=!0,a[b].c=e,d&&d.push([a,b,e])}function H(a,b){if(!k(a))return"";for(var c=[],d=0;d<a.length;d++)try{c.push(String(a[d]))}catch(e){c.push("[value cannot be serialized]")}return c.join(b)}function I(a){return~-encodeURI(a).split(/%..|./).length}function J(a){return I(JSON.stringify(a))}function K(a){var b=40;if("string"==typeof a)return a.length<=b?a:a.substr(0,b-1)+"…";if("number"==typeof a||"boolean"==typeof a||"undefined"==typeof a)return a;var c=Object.prototype.toString.call(a);return"[object Object]"===c?"[Object]":"[object Array]"===c?"[Array]":"[object Function]"===c?a.name?"[Function: "+a.name+"]":"[Function]":a}function L(a,b){return 0===b?K(a):i(a)?Object.keys(a).reduce(function(c,d){return c[d]=L(a[d],b-1),c},{}):Array.isArray(a)?a.map(function(a){return L(a,b-1)}):K(a)}function M(a,b,c){if(!i(a))return a;b="number"!=typeof b?Q:b,c="number"!=typeof b?R:c;var d=L(a,b);return J(O(d))>c?M(a,b-1):d}function N(a,b){if("number"==typeof a||"string"==typeof a)return a.toString();if(!Array.isArray(a))return"";if(a=a.filter(function(a){return"string"==typeof a}),0===a.length)return"[object has no keys]";if(b="number"!=typeof b?S:b,a[0].length>=b)return a[0];for(var c=a.length;c>0;c--){var d=a.slice(0,c).join(", ");if(!(d.length>b))return c===a.length?d:d+"…"}return""}var O=a(3),P="undefined"!=typeof window?window:"undefined"!=typeof c?c:"undefined"!=typeof self?self:{},Q=3,R=51200,S=40;b.exports={isObject:d,isError:e,isErrorEvent:f,isUndefined:g,isFunction:h,isPlainObject:i,isString:j,isArray:k,isEmptyObject:l,supportsErrorEvent:m,supportsFetch:n,supportsReferrerPolicy:o,supportsPromiseRejectionEvent:p,wrappedCallback:q,each:r,objectMerge:s,truncate:u,objectFrozen:t,hasKey:v,joinRegExp:w,urlencode:x,uuid4:z,htmlTreeAsString:A,htmlElementAsString:B,isSameException:E,isSameStacktrace:F,parseUrl:y,fill:G,safeJoin:H,serializeException:M,serializeKeysForMessage:N}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{3:3}],3:[function(a,b,c){function d(a,b){for(var c=0;c<a.length;++c)if(a[c]===b)return c;return-1}function e(a,b,c,d){return JSON.stringify(a,g(b,d),c)}function f(a){var b={stack:a.stack,message:a.message,name:a.name};for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&(b[c]=a[c]);return b}function g(a,b){var c=[],e=[];return null==b&&(b=function(a,b){return c[0]===b?"[Circular ~]":"[Circular ~."+e.slice(0,d(c,b)).join(".")+"]"}),function(g,h){if(c.length>0){var i=d(c,this);~i?c.splice(i+1):c.push(this),~i?e.splice(i,1/0,g):e.push(g),~d(c,h)&&(h=b.call(this,g,h))}else c.push(h);return null==a?h instanceof Error?f(h):h:a.call(this,g,h)}}c=b.exports=e,c.getSerialize=g},{}]},{},[1])(1)});
//# sourceMappingURL=angular.min.js.map
/**
 * marked - a markdown parser
 * Copyright (c) 2011-2018, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

;(function(root) {
'use strict';

/**
 * Block-Level Grammar
 */

var block = {
  newline: /^\n+/,
  code: /^( {4}[^\n]+\n*)+/,
  fences: /^ {0,3}(`{3,}|~{3,})([^`~\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?:\n+|$)|$)/,
  hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6}) +([^\n]*?)(?: +#+)? *(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3})(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
  html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?\\?>\\n*' // (3)
    + '|<![A-Z][\\s\\S]*?>\\n*' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>\\n*' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:\\n{2,}|$)' // (6)
    + '|<(?!script|pre|style)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$)' // (7) open tag
    + '|</(?!script|pre|style)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$)' // (7) closing tag
    + ')',
  def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
  nptable: noop,
  table: noop,
  lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html)[^\n]+)*)/,
  text: /^[^\n]+/
};

block._label = /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/;
block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
block.def = edit(block.def)
  .replace('label', block._label)
  .replace('title', block._title)
  .getRegex();

block.bullet = /(?:[*+-]|\d{1,9}\.)/;
block.item = /^( *)(bull) ?[^\n]*(?:\n(?!\1bull ?)[^\n]*)*/;
block.item = edit(block.item, 'gm')
  .replace(/bull/g, block.bullet)
  .getRegex();

block.list = edit(block.list)
  .replace(/bull/g, block.bullet)
  .replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))')
  .replace('def', '\\n+(?=' + block.def.source + ')')
  .getRegex();

block._tag = 'address|article|aside|base|basefont|blockquote|body|caption'
  + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption'
  + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe'
  + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option'
  + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr'
  + '|track|ul';
block._comment = /<!--(?!-?>)[\s\S]*?-->/;
block.html = edit(block.html, 'i')
  .replace('comment', block._comment)
  .replace('tag', block._tag)
  .replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/)
  .getRegex();

block.paragraph = edit(block._paragraph)
  .replace('hr', block.hr)
  .replace('heading', ' {0,3}#{1,6} +')
  .replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('blockquote', ' {0,3}>')
  .replace('fences', ' {0,3}(?:`{3,}|~{3,})[^`\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)')
  .replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();

block.blockquote = edit(block.blockquote)
  .replace('paragraph', block.paragraph)
  .getRegex();

/**
 * Normal Block Grammar
 */

block.normal = merge({}, block);

/**
 * GFM Block Grammar
 */

block.gfm = merge({}, block.normal, {
  nptable: /^ *([^|\n ].*\|.*)\n *([-:]+ *\|[-| :]*)(?:\n((?:.*[^>\n ].*(?:\n|$))*)\n*|$)/,
  table: /^ *\|(.+)\n *\|?( *[-:]+[-| :]*)(?:\n((?: *[^>\n ].*(?:\n|$))*)\n*|$)/
});

/**
 * Pedantic grammar (original John Gruber's loose markdown specification)
 */

block.pedantic = merge({}, block.normal, {
  html: edit(
    '^ *(?:comment *(?:\\n|\\s*$)'
    + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))')
    .replace('comment', block._comment)
    .replace(/tag/g, '(?!(?:'
      + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub'
      + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)'
      + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b')
    .getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^ *(#{1,6}) *([^\n]+?) *(?:#+ *)?(?:\n+|$)/,
  fences: noop, // fences not supported
  paragraph: edit(block.normal._paragraph)
    .replace('hr', block.hr)
    .replace('heading', ' *#{1,6} *[^\n]')
    .replace('lheading', block.lheading)
    .replace('blockquote', ' {0,3}>')
    .replace('|fences', '')
    .replace('|list', '')
    .replace('|html', '')
    .getRegex()
});

/**
 * Block Lexer
 */

function Lexer(options) {
  this.tokens = [];
  this.tokens.links = Object.create(null);
  this.options = options || marked.defaults;
  this.rules = block.normal;

  if (this.options.pedantic) {
    this.rules = block.pedantic;
  } else if (this.options.gfm) {
    this.rules = block.gfm;
  }
}

/**
 * Expose Block Rules
 */

Lexer.rules = block;

/**
 * Static Lex Method
 */

Lexer.lex = function(src, options) {
  var lexer = new Lexer(options);
  return lexer.lex(src);
};

/**
 * Preprocessing
 */

Lexer.prototype.lex = function(src) {
  src = src
    .replace(/\r\n|\r/g, '\n')
    .replace(/\t/g, '    ')
    .replace(/\u00a0/g, ' ')
    .replace(/\u2424/g, '\n');

  return this.token(src, true);
};

/**
 * Lexing
 */

Lexer.prototype.token = function(src, top) {
  src = src.replace(/^ +$/gm, '');
  var next,
      loose,
      cap,
      bull,
      b,
      item,
      listStart,
      listItems,
      t,
      space,
      i,
      tag,
      l,
      isordered,
      istask,
      ischecked;

  while (src) {
    // newline
    if (cap = this.rules.newline.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[0].length > 1) {
        this.tokens.push({
          type: 'space'
        });
      }
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      var lastToken = this.tokens[this.tokens.length - 1];
      src = src.substring(cap[0].length);
      // An indented code block cannot interrupt a paragraph.
      if (lastToken && lastToken.type === 'paragraph') {
        lastToken.text += '\n' + cap[0].trimRight();
      } else {
        cap = cap[0].replace(/^ {4}/gm, '');
        this.tokens.push({
          type: 'code',
          codeBlockStyle: 'indented',
          text: !this.options.pedantic
            ? rtrim(cap, '\n')
            : cap
        });
      }
      continue;
    }

    // fences
    if (cap = this.rules.fences.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'code',
        lang: cap[2] ? cap[2].trim() : cap[2],
        text: cap[3] || ''
      });
      continue;
    }

    // heading
    if (cap = this.rules.heading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[1].length,
        text: cap[2]
      });
      continue;
    }

    // table no leading pipe (gfm)
    if (cap = this.rules.nptable.exec(src)) {
      item = {
        type: 'table',
        header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : []
      };

      if (item.header.length === item.align.length) {
        src = src.substring(cap[0].length);

        for (i = 0; i < item.align.length; i++) {
          if (/^ *-+: *$/.test(item.align[i])) {
            item.align[i] = 'right';
          } else if (/^ *:-+: *$/.test(item.align[i])) {
            item.align[i] = 'center';
          } else if (/^ *:-+ *$/.test(item.align[i])) {
            item.align[i] = 'left';
          } else {
            item.align[i] = null;
          }
        }

        for (i = 0; i < item.cells.length; i++) {
          item.cells[i] = splitCells(item.cells[i], item.header.length);
        }

        this.tokens.push(item);

        continue;
      }
    }

    // hr
    if (cap = this.rules.hr.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'hr'
      });
      continue;
    }

    // blockquote
    if (cap = this.rules.blockquote.exec(src)) {
      src = src.substring(cap[0].length);

      this.tokens.push({
        type: 'blockquote_start'
      });

      cap = cap[0].replace(/^ *> ?/gm, '');

      // Pass `top` to keep the current
      // "toplevel" state. This is exactly
      // how markdown.pl works.
      this.token(cap, top);

      this.tokens.push({
        type: 'blockquote_end'
      });

      continue;
    }

    // list
    if (cap = this.rules.list.exec(src)) {
      src = src.substring(cap[0].length);
      bull = cap[2];
      isordered = bull.length > 1;

      listStart = {
        type: 'list_start',
        ordered: isordered,
        start: isordered ? +bull : '',
        loose: false
      };

      this.tokens.push(listStart);

      // Get each top-level item.
      cap = cap[0].match(this.rules.item);

      listItems = [];
      next = false;
      l = cap.length;
      i = 0;

      for (; i < l; i++) {
        item = cap[i];

        // Remove the list item's bullet
        // so it is seen as the next token.
        space = item.length;
        item = item.replace(/^ *([*+-]|\d+\.) */, '');

        // Outdent whatever the
        // list item contains. Hacky.
        if (~item.indexOf('\n ')) {
          space -= item.length;
          item = !this.options.pedantic
            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
            : item.replace(/^ {1,4}/gm, '');
        }

        // Determine whether the next list item belongs here.
        // Backpedal if it does not belong in this list.
        if (i !== l - 1) {
          b = block.bullet.exec(cap[i + 1])[0];
          if (bull.length > 1 ? b.length === 1
            : (b.length > 1 || (this.options.smartLists && b !== bull))) {
            src = cap.slice(i + 1).join('\n') + src;
            i = l - 1;
          }
        }

        // Determine whether item is loose or not.
        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
        // for discount behavior.
        loose = next || /\n\n(?!\s*$)/.test(item);
        if (i !== l - 1) {
          next = item.charAt(item.length - 1) === '\n';
          if (!loose) loose = next;
        }

        if (loose) {
          listStart.loose = true;
        }

        // Check for task list items
        istask = /^\[[ xX]\] /.test(item);
        ischecked = undefined;
        if (istask) {
          ischecked = item[1] !== ' ';
          item = item.replace(/^\[[ xX]\] +/, '');
        }

        t = {
          type: 'list_item_start',
          task: istask,
          checked: ischecked,
          loose: loose
        };

        listItems.push(t);
        this.tokens.push(t);

        // Recurse.
        this.token(item, false);

        this.tokens.push({
          type: 'list_item_end'
        });
      }

      if (listStart.loose) {
        l = listItems.length;
        i = 0;
        for (; i < l; i++) {
          listItems[i].loose = true;
        }
      }

      this.tokens.push({
        type: 'list_end'
      });

      continue;
    }

    // html
    if (cap = this.rules.html.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: this.options.sanitize
          ? 'paragraph'
          : 'html',
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: this.options.sanitize ? (this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0])) : cap[0]
      });
      continue;
    }

    // def
    if (top && (cap = this.rules.def.exec(src))) {
      src = src.substring(cap[0].length);
      if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
      tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
      if (!this.tokens.links[tag]) {
        this.tokens.links[tag] = {
          href: cap[2],
          title: cap[3]
        };
      }
      continue;
    }

    // table (gfm)
    if (cap = this.rules.table.exec(src)) {
      item = {
        type: 'table',
        header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : []
      };

      if (item.header.length === item.align.length) {
        src = src.substring(cap[0].length);

        for (i = 0; i < item.align.length; i++) {
          if (/^ *-+: *$/.test(item.align[i])) {
            item.align[i] = 'right';
          } else if (/^ *:-+: *$/.test(item.align[i])) {
            item.align[i] = 'center';
          } else if (/^ *:-+ *$/.test(item.align[i])) {
            item.align[i] = 'left';
          } else {
            item.align[i] = null;
          }
        }

        for (i = 0; i < item.cells.length; i++) {
          item.cells[i] = splitCells(
            item.cells[i].replace(/^ *\| *| *\| *$/g, ''),
            item.header.length);
        }

        this.tokens.push(item);

        continue;
      }
    }

    // lheading
    if (cap = this.rules.lheading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[2].charAt(0) === '=' ? 1 : 2,
        text: cap[1]
      });
      continue;
    }

    // top-level paragraph
    if (top && (cap = this.rules.paragraph.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'paragraph',
        text: cap[1].charAt(cap[1].length - 1) === '\n'
          ? cap[1].slice(0, -1)
          : cap[1]
      });
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      // Top-level should never reach here.
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'text',
        text: cap[0]
      });
      continue;
    }

    if (src) {
      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return this.tokens;
};

/**
 * Inline-Level Grammar
 */

var inline = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: noop,
  tag: '^comment'
    + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>', // CDATA section
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
  nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
  strong: /^__([^\s_])__(?!_)|^\*\*([^\s*])\*\*(?!\*)|^__([^\s][\s\S]*?[^\s])__(?!_)|^\*\*([^\s][\s\S]*?[^\s])\*\*(?!\*)/,
  em: /^_([^\s_])_(?!_)|^\*([^\s*<\[])\*(?!\*)|^_([^\s<][\s\S]*?[^\s_])_(?!_|[^\spunctuation])|^_([^\s_<][\s\S]*?[^\s])_(?!_|[^\spunctuation])|^\*([^\s<"][\s\S]*?[^\s\*])\*(?!\*|[^\spunctuation])|^\*([^\s*"<\[][\s\S]*?[^\s])\*(?!\*)/,
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: noop,
  text: /^(`+|[^`])(?:[\s\S]*?(?:(?=[\\<!\[`*]|\b_|$)|[^ ](?= {2,}\n))|(?= {2,}\n))/
};

// list of punctuation marks from common mark spec
// without ` and ] to workaround Rule 17 (inline code blocks/links)
inline._punctuation = '!"#$%&\'()*+,\\-./:;<=>?@\\[^_{|}~';
inline.em = edit(inline.em).replace(/punctuation/g, inline._punctuation).getRegex();

inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;

inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
inline.autolink = edit(inline.autolink)
  .replace('scheme', inline._scheme)
  .replace('email', inline._email)
  .getRegex();

inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;

inline.tag = edit(inline.tag)
  .replace('comment', block._comment)
  .replace('attribute', inline._attribute)
  .getRegex();

inline._label = /(?:\[[^\[\]]*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
inline._href = /<(?:\\[<>]?|[^\s<>\\])*>|[^\s\x00-\x1f]*/;
inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;

inline.link = edit(inline.link)
  .replace('label', inline._label)
  .replace('href', inline._href)
  .replace('title', inline._title)
  .getRegex();

inline.reflink = edit(inline.reflink)
  .replace('label', inline._label)
  .getRegex();

/**
 * Normal Inline Grammar
 */

inline.normal = merge({}, inline);

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = merge({}, inline.normal, {
  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/,
  link: edit(/^!?\[(label)\]\((.*?)\)/)
    .replace('label', inline._label)
    .getRegex(),
  reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/)
    .replace('label', inline._label)
    .getRegex()
});

/**
 * GFM Inline Grammar
 */

inline.gfm = merge({}, inline.normal, {
  escape: edit(inline.escape).replace('])', '~|])').getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
  del: /^~+(?=\S)([\s\S]*?\S)~+/,
  text: /^(`+|[^`])(?:[\s\S]*?(?:(?=[\\<!\[`*~]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))|(?= {2,}\n|[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))/
});

inline.gfm.url = edit(inline.gfm.url, 'i')
  .replace('email', inline.gfm._extended_email)
  .getRegex();
/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = merge({}, inline.gfm, {
  br: edit(inline.br).replace('{2,}', '*').getRegex(),
  text: edit(inline.gfm.text)
    .replace('\\b_', '\\b_| {2,}\\n')
    .replace(/\{2,\}/g, '*')
    .getRegex()
});

/**
 * Inline Lexer & Compiler
 */

function InlineLexer(links, options) {
  this.options = options || marked.defaults;
  this.links = links;
  this.rules = inline.normal;
  this.renderer = this.options.renderer || new Renderer();
  this.renderer.options = this.options;

  if (!this.links) {
    throw new Error('Tokens array requires a `links` property.');
  }

  if (this.options.pedantic) {
    this.rules = inline.pedantic;
  } else if (this.options.gfm) {
    if (this.options.breaks) {
      this.rules = inline.breaks;
    } else {
      this.rules = inline.gfm;
    }
  }
}

/**
 * Expose Inline Rules
 */

InlineLexer.rules = inline;

/**
 * Static Lexing/Compiling Method
 */

InlineLexer.output = function(src, links, options) {
  var inline = new InlineLexer(links, options);
  return inline.output(src);
};

/**
 * Lexing/Compiling
 */

InlineLexer.prototype.output = function(src) {
  var out = '',
      link,
      text,
      href,
      title,
      cap,
      prevCapZero;

  while (src) {
    // escape
    if (cap = this.rules.escape.exec(src)) {
      src = src.substring(cap[0].length);
      out += escape(cap[1]);
      continue;
    }

    // tag
    if (cap = this.rules.tag.exec(src)) {
      if (!this.inLink && /^<a /i.test(cap[0])) {
        this.inLink = true;
      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
        this.inLink = false;
      }
      if (!this.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.inRawBlock = true;
      } else if (this.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.inRawBlock = false;
      }

      src = src.substring(cap[0].length);
      out += this.options.sanitize
        ? this.options.sanitizer
          ? this.options.sanitizer(cap[0])
          : escape(cap[0])
        : cap[0];
      continue;
    }

    // link
    if (cap = this.rules.link.exec(src)) {
      var lastParenIndex = findClosingBracket(cap[2], '()');
      if (lastParenIndex > -1) {
        var linkLen = 4 + cap[1].length + lastParenIndex;
        cap[2] = cap[2].substring(0, lastParenIndex);
        cap[0] = cap[0].substring(0, linkLen).trim();
        cap[3] = '';
      }
      src = src.substring(cap[0].length);
      this.inLink = true;
      href = cap[2];
      if (this.options.pedantic) {
        link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);

        if (link) {
          href = link[1];
          title = link[3];
        } else {
          title = '';
        }
      } else {
        title = cap[3] ? cap[3].slice(1, -1) : '';
      }
      href = href.trim().replace(/^<([\s\S]*)>$/, '$1');
      out += this.outputLink(cap, {
        href: InlineLexer.escapes(href),
        title: InlineLexer.escapes(title)
      });
      this.inLink = false;
      continue;
    }

    // reflink, nolink
    if ((cap = this.rules.reflink.exec(src))
        || (cap = this.rules.nolink.exec(src))) {
      src = src.substring(cap[0].length);
      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = this.links[link.toLowerCase()];
      if (!link || !link.href) {
        out += cap[0].charAt(0);
        src = cap[0].substring(1) + src;
        continue;
      }
      this.inLink = true;
      out += this.outputLink(cap, link);
      this.inLink = false;
      continue;
    }

    // strong
    if (cap = this.rules.strong.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.strong(this.output(cap[4] || cap[3] || cap[2] || cap[1]));
      continue;
    }

    // em
    if (cap = this.rules.em.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.em(this.output(cap[6] || cap[5] || cap[4] || cap[3] || cap[2] || cap[1]));
      continue;
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.codespan(escape(cap[2].trim(), true));
      continue;
    }

    // br
    if (cap = this.rules.br.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.br();
      continue;
    }

    // del (gfm)
    if (cap = this.rules.del.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.del(this.output(cap[1]));
      continue;
    }

    // autolink
    if (cap = this.rules.autolink.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[2] === '@') {
        text = escape(this.mangle(cap[1]));
        href = 'mailto:' + text;
      } else {
        text = escape(cap[1]);
        href = text;
      }
      out += this.renderer.link(href, null, text);
      continue;
    }

    // url (gfm)
    if (!this.inLink && (cap = this.rules.url.exec(src))) {
      if (cap[2] === '@') {
        text = escape(cap[0]);
        href = 'mailto:' + text;
      } else {
        // do extended autolink path validation
        do {
          prevCapZero = cap[0];
          cap[0] = this.rules._backpedal.exec(cap[0])[0];
        } while (prevCapZero !== cap[0]);
        text = escape(cap[0]);
        if (cap[1] === 'www.') {
          href = 'http://' + text;
        } else {
          href = text;
        }
      }
      src = src.substring(cap[0].length);
      out += this.renderer.link(href, null, text);
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      src = src.substring(cap[0].length);
      if (this.inRawBlock) {
        out += this.renderer.text(this.options.sanitize ? (this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0])) : cap[0]);
      } else {
        out += this.renderer.text(escape(this.smartypants(cap[0])));
      }
      continue;
    }

    if (src) {
      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return out;
};

InlineLexer.escapes = function(text) {
  return text ? text.replace(InlineLexer.rules._escapes, '$1') : text;
};

/**
 * Compile Link
 */

InlineLexer.prototype.outputLink = function(cap, link) {
  var href = link.href,
      title = link.title ? escape(link.title) : null;

  return cap[0].charAt(0) !== '!'
    ? this.renderer.link(href, title, this.output(cap[1]))
    : this.renderer.image(href, title, escape(cap[1]));
};

/**
 * Smartypants Transformations
 */

InlineLexer.prototype.smartypants = function(text) {
  if (!this.options.smartypants) return text;
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
};

/**
 * Mangle Links
 */

InlineLexer.prototype.mangle = function(text) {
  if (!this.options.mangle) return text;
  var out = '',
      l = text.length,
      i = 0,
      ch;

  for (; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
};

/**
 * Renderer
 */

function Renderer(options) {
  this.options = options || marked.defaults;
}

Renderer.prototype.code = function(code, infostring, escaped) {
  var lang = (infostring || '').match(/\S*/)[0];
  if (this.options.highlight) {
    var out = this.options.highlight(code, lang);
    if (out != null && out !== code) {
      escaped = true;
      code = out;
    }
  }

  if (!lang) {
    return '<pre><code>'
      + (escaped ? code : escape(code, true))
      + '</code></pre>';
  }

  return '<pre><code class="'
    + this.options.langPrefix
    + escape(lang, true)
    + '">'
    + (escaped ? code : escape(code, true))
    + '</code></pre>\n';
};

Renderer.prototype.blockquote = function(quote) {
  return '<blockquote>\n' + quote + '</blockquote>\n';
};

Renderer.prototype.html = function(html) {
  return html;
};

Renderer.prototype.heading = function(text, level, raw, slugger) {
  if (this.options.headerIds) {
    return '<h'
      + level
      + ' id="'
      + this.options.headerPrefix
      + slugger.slug(raw)
      + '">'
      + text
      + '</h'
      + level
      + '>\n';
  }
  // ignore IDs
  return '<h' + level + '>' + text + '</h' + level + '>\n';
};

Renderer.prototype.hr = function() {
  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
};

Renderer.prototype.list = function(body, ordered, start) {
  var type = ordered ? 'ol' : 'ul',
      startatt = (ordered && start !== 1) ? (' start="' + start + '"') : '';
  return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
};

Renderer.prototype.listitem = function(text) {
  return '<li>' + text + '</li>\n';
};

Renderer.prototype.checkbox = function(checked) {
  return '<input '
    + (checked ? 'checked="" ' : '')
    + 'disabled="" type="checkbox"'
    + (this.options.xhtml ? ' /' : '')
    + '> ';
};

Renderer.prototype.paragraph = function(text) {
  return '<p>' + text + '</p>\n';
};

Renderer.prototype.table = function(header, body) {
  if (body) body = '<tbody>' + body + '</tbody>';

  return '<table>\n'
    + '<thead>\n'
    + header
    + '</thead>\n'
    + body
    + '</table>\n';
};

Renderer.prototype.tablerow = function(content) {
  return '<tr>\n' + content + '</tr>\n';
};

Renderer.prototype.tablecell = function(content, flags) {
  var type = flags.header ? 'th' : 'td';
  var tag = flags.align
    ? '<' + type + ' align="' + flags.align + '">'
    : '<' + type + '>';
  return tag + content + '</' + type + '>\n';
};

// span level renderer
Renderer.prototype.strong = function(text) {
  return '<strong>' + text + '</strong>';
};

Renderer.prototype.em = function(text) {
  return '<em>' + text + '</em>';
};

Renderer.prototype.codespan = function(text) {
  return '<code>' + text + '</code>';
};

Renderer.prototype.br = function() {
  return this.options.xhtml ? '<br/>' : '<br>';
};

Renderer.prototype.del = function(text) {
  return '<del>' + text + '</del>';
};

Renderer.prototype.link = function(href, title, text) {
  href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
  if (href === null) {
    return text;
  }
  var out = '<a href="' + escape(href) + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += '>' + text + '</a>';
  return out;
};

Renderer.prototype.image = function(href, title, text) {
  href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
  if (href === null) {
    return text;
  }

  var out = '<img src="' + href + '" alt="' + text + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += this.options.xhtml ? '/>' : '>';
  return out;
};

Renderer.prototype.text = function(text) {
  return text;
};

/**
 * TextRenderer
 * returns only the textual part of the token
 */

function TextRenderer() {}

// no need for block level renderers

TextRenderer.prototype.strong =
TextRenderer.prototype.em =
TextRenderer.prototype.codespan =
TextRenderer.prototype.del =
TextRenderer.prototype.text = function(text) {
  return text;
};

TextRenderer.prototype.link =
TextRenderer.prototype.image = function(href, title, text) {
  return '' + text;
};

TextRenderer.prototype.br = function() {
  return '';
};

/**
 * Parsing & Compiling
 */

function Parser(options) {
  this.tokens = [];
  this.token = null;
  this.options = options || marked.defaults;
  this.options.renderer = this.options.renderer || new Renderer();
  this.renderer = this.options.renderer;
  this.renderer.options = this.options;
  this.slugger = new Slugger();
}

/**
 * Static Parse Method
 */

Parser.parse = function(src, options) {
  var parser = new Parser(options);
  return parser.parse(src);
};

/**
 * Parse Loop
 */

Parser.prototype.parse = function(src) {
  this.inline = new InlineLexer(src.links, this.options);
  // use an InlineLexer with a TextRenderer to extract pure text
  this.inlineText = new InlineLexer(
    src.links,
    merge({}, this.options, { renderer: new TextRenderer() })
  );
  this.tokens = src.reverse();

  var out = '';
  while (this.next()) {
    out += this.tok();
  }

  return out;
};

/**
 * Next Token
 */

Parser.prototype.next = function() {
  this.token = this.tokens.pop();
  return this.token;
};

/**
 * Preview Next Token
 */

Parser.prototype.peek = function() {
  return this.tokens[this.tokens.length - 1] || 0;
};

/**
 * Parse Text Tokens
 */

Parser.prototype.parseText = function() {
  var body = this.token.text;

  while (this.peek().type === 'text') {
    body += '\n' + this.next().text;
  }

  return this.inline.output(body);
};

/**
 * Parse Current Token
 */

Parser.prototype.tok = function() {
  switch (this.token.type) {
    case 'space': {
      return '';
    }
    case 'hr': {
      return this.renderer.hr();
    }
    case 'heading': {
      return this.renderer.heading(
        this.inline.output(this.token.text),
        this.token.depth,
        unescape(this.inlineText.output(this.token.text)),
        this.slugger);
    }
    case 'code': {
      return this.renderer.code(this.token.text,
        this.token.lang,
        this.token.escaped);
    }
    case 'table': {
      var header = '',
          body = '',
          i,
          row,
          cell,
          j;

      // header
      cell = '';
      for (i = 0; i < this.token.header.length; i++) {
        cell += this.renderer.tablecell(
          this.inline.output(this.token.header[i]),
          { header: true, align: this.token.align[i] }
        );
      }
      header += this.renderer.tablerow(cell);

      for (i = 0; i < this.token.cells.length; i++) {
        row = this.token.cells[i];

        cell = '';
        for (j = 0; j < row.length; j++) {
          cell += this.renderer.tablecell(
            this.inline.output(row[j]),
            { header: false, align: this.token.align[j] }
          );
        }

        body += this.renderer.tablerow(cell);
      }
      return this.renderer.table(header, body);
    }
    case 'blockquote_start': {
      body = '';

      while (this.next().type !== 'blockquote_end') {
        body += this.tok();
      }

      return this.renderer.blockquote(body);
    }
    case 'list_start': {
      body = '';
      var ordered = this.token.ordered,
          start = this.token.start;

      while (this.next().type !== 'list_end') {
        body += this.tok();
      }

      return this.renderer.list(body, ordered, start);
    }
    case 'list_item_start': {
      body = '';
      var loose = this.token.loose;
      var checked = this.token.checked;
      var task = this.token.task;

      if (this.token.task) {
        body += this.renderer.checkbox(checked);
      }

      while (this.next().type !== 'list_item_end') {
        body += !loose && this.token.type === 'text'
          ? this.parseText()
          : this.tok();
      }
      return this.renderer.listitem(body, task, checked);
    }
    case 'html': {
      // TODO parse inline content if parameter markdown=1
      return this.renderer.html(this.token.text);
    }
    case 'paragraph': {
      return this.renderer.paragraph(this.inline.output(this.token.text));
    }
    case 'text': {
      return this.renderer.paragraph(this.parseText());
    }
    default: {
      var errMsg = 'Token with "' + this.token.type + '" type was not found.';
      if (this.options.silent) {
        console.log(errMsg);
      } else {
        throw new Error(errMsg);
      }
    }
  }
};

/**
 * Slugger generates header id
 */

function Slugger() {
  this.seen = {};
}

/**
 * Convert string to unique id
 */

Slugger.prototype.slug = function(value) {
  var slug = value
    .toLowerCase()
    .trim()
    .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '')
    .replace(/\s/g, '-');

  if (this.seen.hasOwnProperty(slug)) {
    var originalSlug = slug;
    do {
      this.seen[originalSlug]++;
      slug = originalSlug + '-' + this.seen[originalSlug];
    } while (this.seen.hasOwnProperty(slug));
  }
  this.seen[slug] = 0;

  return slug;
};

/**
 * Helpers
 */

function escape(html, encode) {
  if (encode) {
    if (escape.escapeTest.test(html)) {
      return html.replace(escape.escapeReplace, function(ch) { return escape.replacements[ch]; });
    }
  } else {
    if (escape.escapeTestNoEncode.test(html)) {
      return html.replace(escape.escapeReplaceNoEncode, function(ch) { return escape.replacements[ch]; });
    }
  }

  return html;
}

escape.escapeTest = /[&<>"']/;
escape.escapeReplace = /[&<>"']/g;
escape.replacements = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

escape.escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
escape.escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;

function unescape(html) {
  // explicitly match decimal, hex, and named HTML entities
  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function(_, n) {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

function edit(regex, opt) {
  regex = regex.source || regex;
  opt = opt || '';
  return {
    replace: function(name, val) {
      val = val.source || val;
      val = val.replace(/(^|[^\[])\^/g, '$1');
      regex = regex.replace(name, val);
      return this;
    },
    getRegex: function() {
      return new RegExp(regex, opt);
    }
  };
}

function cleanUrl(sanitize, base, href) {
  if (sanitize) {
    try {
      var prot = decodeURIComponent(unescape(href))
        .replace(/[^\w:]/g, '')
        .toLowerCase();
    } catch (e) {
      return null;
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
      return null;
    }
  }
  if (base && !originIndependentUrl.test(href)) {
    href = resolveUrl(base, href);
  }
  try {
    href = encodeURI(href).replace(/%25/g, '%');
  } catch (e) {
    return null;
  }
  return href;
}

function resolveUrl(base, href) {
  if (!baseUrls[' ' + base]) {
    // we can ignore everything in base after the last slash of its path component,
    // but we might need to add _that_
    // https://tools.ietf.org/html/rfc3986#section-3
    if (/^[^:]+:\/*[^/]*$/.test(base)) {
      baseUrls[' ' + base] = base + '/';
    } else {
      baseUrls[' ' + base] = rtrim(base, '/', true);
    }
  }
  base = baseUrls[' ' + base];

  if (href.slice(0, 2) === '//') {
    return base.replace(/:[\s\S]*/, ':') + href;
  } else if (href.charAt(0) === '/') {
    return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
  } else {
    return base + href;
  }
}
var baseUrls = {};
var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

function noop() {}
noop.exec = noop;

function merge(obj) {
  var i = 1,
      target,
      key;

  for (; i < arguments.length; i++) {
    target = arguments[i];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }

  return obj;
}

function splitCells(tableRow, count) {
  // ensure that every cell-delimiting pipe has a space
  // before it to distinguish it from an escaped pipe
  var row = tableRow.replace(/\|/g, function(match, offset, str) {
        var escaped = false,
            curr = offset;
        while (--curr >= 0 && str[curr] === '\\') escaped = !escaped;
        if (escaped) {
          // odd number of slashes means | is escaped
          // so we leave it alone
          return '|';
        } else {
          // add space before unescaped |
          return ' |';
        }
      }),
      cells = row.split(/ \|/),
      i = 0;

  if (cells.length > count) {
    cells.splice(count);
  } else {
    while (cells.length < count) cells.push('');
  }

  for (; i < cells.length; i++) {
    // leading or trailing whitespace is ignored per the gfm spec
    cells[i] = cells[i].trim().replace(/\\\|/g, '|');
  }
  return cells;
}

// Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
// /c*$/ is vulnerable to REDOS.
// invert: Remove suffix of non-c chars instead. Default falsey.
function rtrim(str, c, invert) {
  if (str.length === 0) {
    return '';
  }

  // Length of suffix matching the invert condition.
  var suffLen = 0;

  // Step left until we fail to match the invert condition.
  while (suffLen < str.length) {
    var currChar = str.charAt(str.length - suffLen - 1);
    if (currChar === c && !invert) {
      suffLen++;
    } else if (currChar !== c && invert) {
      suffLen++;
    } else {
      break;
    }
  }

  return str.substr(0, str.length - suffLen);
}

function findClosingBracket(str, b) {
  if (str.indexOf(b[1]) === -1) {
    return -1;
  }
  var level = 0;
  for (var i = 0; i < str.length; i++) {
    if (str[i] === '\\') {
      i++;
    } else if (str[i] === b[0]) {
      level++;
    } else if (str[i] === b[1]) {
      level--;
      if (level < 0) {
        return i;
      }
    }
  }
  return -1;
}

function checkSanitizeDeprecation(opt) {
  if (opt && opt.sanitize && !opt.silent) {
    console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
  }
}

/**
 * Marked
 */

function marked(src, opt, callback) {
  // throw error in case of non string input
  if (typeof src === 'undefined' || src === null) {
    throw new Error('marked(): input parameter is undefined or null');
  }
  if (typeof src !== 'string') {
    throw new Error('marked(): input parameter is of type '
      + Object.prototype.toString.call(src) + ', string expected');
  }

  if (callback || typeof opt === 'function') {
    if (!callback) {
      callback = opt;
      opt = null;
    }

    opt = merge({}, marked.defaults, opt || {});
    checkSanitizeDeprecation(opt);

    var highlight = opt.highlight,
        tokens,
        pending,
        i = 0;

    try {
      tokens = Lexer.lex(src, opt);
    } catch (e) {
      return callback(e);
    }

    pending = tokens.length;

    var done = function(err) {
      if (err) {
        opt.highlight = highlight;
        return callback(err);
      }

      var out;

      try {
        out = Parser.parse(tokens, opt);
      } catch (e) {
        err = e;
      }

      opt.highlight = highlight;

      return err
        ? callback(err)
        : callback(null, out);
    };

    if (!highlight || highlight.length < 3) {
      return done();
    }

    delete opt.highlight;

    if (!pending) return done();

    for (; i < tokens.length; i++) {
      (function(token) {
        if (token.type !== 'code') {
          return --pending || done();
        }
        return highlight(token.text, token.lang, function(err, code) {
          if (err) return done(err);
          if (code == null || code === token.text) {
            return --pending || done();
          }
          token.text = code;
          token.escaped = true;
          --pending || done();
        });
      })(tokens[i]);
    }

    return;
  }
  try {
    if (opt) opt = merge({}, marked.defaults, opt);
    checkSanitizeDeprecation(opt);
    return Parser.parse(Lexer.lex(src, opt), opt);
  } catch (e) {
    e.message += '\nPlease report this to https://github.com/markedjs/marked.';
    if ((opt || marked.defaults).silent) {
      return '<p>An error occurred:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
    }
    throw e;
  }
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  merge(marked.defaults, opt);
  return marked;
};

marked.getDefaults = function() {
  return {
    baseUrl: null,
    breaks: false,
    gfm: true,
    headerIds: true,
    headerPrefix: '',
    highlight: null,
    langPrefix: 'language-',
    mangle: true,
    pedantic: false,
    renderer: new Renderer(),
    sanitize: false,
    sanitizer: null,
    silent: false,
    smartLists: false,
    smartypants: false,
    xhtml: false
  };
};

marked.defaults = marked.getDefaults();

/**
 * Expose
 */

marked.Parser = Parser;
marked.parser = Parser.parse;

marked.Renderer = Renderer;
marked.TextRenderer = TextRenderer;

marked.Lexer = Lexer;
marked.lexer = Lexer.lex;

marked.InlineLexer = InlineLexer;
marked.inlineLexer = InlineLexer.output;

marked.Slugger = Slugger;

marked.parse = marked;

if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = marked;
} else if (typeof define === 'function' && define.amd) {
  define(function() { return marked; });
} else {
  root.marked = marked;
}
})(this || (typeof window !== 'undefined' ? window : global));

;(function() {
  'use strict'

  angular
    .module('glow.resources', [])

    /*
     * Don't Remove - forces resources to be instantiated
     */
    // eslint-disable-next-line no-unused-vars
    .run(["resources", function(resources) {}])
})()

;(function() {
  'use strict'

  /**
   * @name glow.components
   * @description wrapper module for glow component directives
   */
  angular.module('glow.components', [
    'glow.components.autofocus',
    'glow.components.dialog',
    'glow.components.email',
    'glow.components.emptyToNull',
    'glow.components.glClouds',
    'glow.components.hint',
    'glow.components.icon',
    'glow.components.iconButton',
    'glow.components.imageInput',
    'glow.components.mediaView',
    'glow.components.imageviewer',
    'glow.components.listInput',
    'glow.components.multiselectDropdown',
    'glow.components.overlock',
    'glow.components.questionEditor',
    'glow.components.templates',
    'glow.components.toast',
  ])
})()

;(function() {
  'use strict'

  angular.module('glow.services', ['glow.resources'])
})()

;(function() {
  'use strict'

  angular.module('glow.components.autofocus', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.dialog', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.email', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.emptyToNull', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.glClouds', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.hint', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.icon', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.iconButton', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.imageInput', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.imageviewer', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.listInput', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.mediaView', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.multiselectDropdown', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.overlock', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.questionEditor', [])
})()

;(function() {
  'use strict'

  angular.module('glow.components.toast', [])
})()

;(function() {
  'use strict'

  /**
   * @name glow.lib
   * @description wrapper module for shared glow lib modules - analytics, resources & services
   */
  angular.module('glow.lib', [
    'ngRaven',
    'ui.router',
    'glow.resources',
    'glow.services',

    // glow components is a separate module at this time - not all properties require the components
    // 'glow.components'
  ])
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "$http", "configService"];
  angular.module('glow.services').service('aiService', Service)

  /* @ngInject */
  function Service($q, $http, configService) {
    var OPEN_AI_NODE_URL = configService.getNodeUrl('/open-ai')

    var ValidationTypes = {
      TEXT: 'textQualityCheck',
    }

    return {
      validateTextAnswer: validateTextAnswer,
    }

    function validateTextAnswer(
      surveyId,
      respondentId,
      questionTitle,
      textAnswer
    ) {
      var data = {
        type: ValidationTypes.TEXT,
        question: questionTitle,
        answer: textAnswer,
        surveyUrl: configService.getSubscriberPortalUrl(
          '/surveys/' + surveyId + '?tab=editor'
        ),
        isProd: configService.isProduction(),
        respondentId: respondentId,
      }
      return $http({
        method: 'POST',
        url: OPEN_AI_NODE_URL,
        data: data,
        responseType: 'application/json',
      })
        .then(function(response) {
          return response.data.accept
        })
        .catch(function(err) {
          console.error(err)
          return $q.resolve(true) // if the API fails, resolve as accepted
        })
    }
  }
})()

/* globals analytics, ga, ionic, gtag */
;(function() {
  'use strict'

  Service.$inject = ["$transitions", "$location", "$window", "$document", "$log", "$timeout", "$http", "configService", "analyticsResource"];
  run.$inject = ["glAnalytics"];
  angular
    .module('glow.services')
    .factory('glAnalytics', Service)
    .run(run)

  /* @ngInject */
  function Service(
    $transitions,
    $location,
    $window,
    $document,
    $log,
    $timeout,
    $http,
    configService,
    analyticsResource
  ) {
    // TODO: requires glow.services to be injected to use $log.create - this cannot be done until the services
    // dependency is removed from resources module. In additon, this file can then be added back to glow.services.
    // var log = $log.create('glAnalytics');
    var log = $log.create ? $log.create('glAnalytics') : $log

    // ---DEPRECATED---
    // These are tracking ids for the old Universal Analytics properties
    // Universal Analytics properties will stop processing data starting 1 July 2023
    // more info : https://support.google.com/analytics/answer/10089681
    var TRACKING_IDS = {
      'glow.app': 'UA-50246606-7',
      UserPortal: 'UA-50246606-1',
      SubPortal: 'UA-50246606-6',
      AdminPortal: 'UA-50246606-9',
    }
    // ------------

    var ACTIVE_CAMPAIGN_ID = '999927148'

    var userId
    var userEmail
    var Dimensions = {
      APP: 'dimension1',
      JOB_ROLE: 'dimension2',
      INDUSTRY: 'dimension3',
      CITY: 'dimension4',
      STATE: 'dimension5',
      POSTCODE: 'dimension6',
      PLAN: 'dimension7',
      COUNTRY: 'dimension8',
    }

    $transitions.onSuccess(null, onStateChange)

    return {
      init: init,
      track: track,
      trackView: trackViewManually,
      setUser: setUser,
      set: set,
      Dimensions: Dimensions,
    }

    function init() {
      if (configService.isTest()) {
        return
      }

      // ---DEPRECATED---
      // this is an old implementation to setup the Universal Analytics properties
      // using the legacy library (analytics.js). The new implementation for
      // the new Google Analytics 4(GA4) properties are being setup using the
      // gtag.js library on index.jade script tag
      var trackingId = TRACKING_IDS[configService.getBuildProperty()]
      if (!trackingId) {
        return log.error(
          'no tracking id found for property [' +
            configService.getBuildProperty() +
            '], aborted'
        )
      }
      // try initialise ga
      if (window.ga) {
        ga(function() {
          // ready function: https://developers.google.com/analytics/devguides/collection/analyticsjs/ga-object-methods-reference#method-summary
          ga('create', trackingId)
        })
        log.debug('started analytics (ga)')
      }
      // ------------

      // try initialise cordova plugin
      if (window.ionic) {
        ionic.Platform.ready(function() {
          if (window.analytics) {
            analytics.setDebugMode()
            analytics.startTrackerWithId(trackingId)
            log.debug('started analytics (cordova-ga)')
          } else if (ionic.Platform.isIOS() || ionic.Platform.isAndroid()) {
            log.error('native app is missing analytics plugin')
          }
        })
      }
    }

    function setUser(user) {
      userId = user.id
      userEmail = user.email
      set('userId', userId)
      var campaign = _.pick(user.registrationContext, [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content',
      ])
      set('campaignSource', campaign.utm_source)
      set('campaignMedium', campaign.utm_medium)
      set('campaignName', campaign.utm_campaign)
      set('campaignKeyword', campaign.utm_term)
      set('campaignContent', campaign.utm_content)
    }

    function set(key, value) {
      // ---DEPRECATED--- replaced by window.gtag
      if (window.ga) {
        ga('set', key, value)
        log.debug('set', key, value)
      }
      // ------------

      if (window.gtag) {
        gtag('set', key, value)
        log.debug('gtag.set', key, value)
      }
    }

    function getUserId() {
      return userId || 'unknown'
    }

    function track(category, action, label, value) {
      if (_.isNumber(value)) {
        value = Math.round(value) // ensure its an integer not a float
      }
      if (configService.isTest()) {
        return
      }
      // convert label object into string of [...key:value]'s
      if (_.isPlainObject(label)) {
        _.each(label, function(value, key) {
          if (_.isNil(value)) delete label[key]
        })
        label = _.map(label, function(value, key) {
          return key + ':' + value
        }).join(' ')
      }
      if (!configService.isProduction()) {
        // expose what we were trying to send
        return log.debug('skipped event tracking (not production)', {
          category: category,
          action: action,
          label: label,
          value: value,
        })
      }

      // ---DEPRECATED--- replaced by window.gtag
      // try send to GA
      if (window.ga) {
        ga('send', 'event', category, action, label, value)
      }
      // ------------

      if (window.gtag) {
        gtag('event', action, {
          event_category: category,
          event_label: label,
          value: value,
        })
      }

      // try send to cordova plugin
      if (window.analytics) {
        analytics.trackEvent(category, action, label, value)
      }

      // send to BE
      sendActivity({
        userId: getUserId(),
        createdAt: new Date().toISOString(),
        category: category,
        action: action,
        label: label,
        value: value,
      })
    }

    function trackView(url) {
      if (!configService.isProduction()) {
        // expose what we were trying to send
        return log.debug('skipped view tracking (not production)', url)
      }

      // ---DEPRECATED--- replaced by window.gtag
      // try send to GA
      if (window.ga) {
        ga('send', 'pageview', url)
      }
      // ------------

      if (window.gtag) {
        gtag('event', 'page_view', { page_location: url })
      }

      // try send to cordova plugin
      if (window.analytics) {
        analytics.trackView(url)
      }
      // send to active-campaign in SP
      if (configService.isSubPortal()) {
        trackActiveCampaignView()
      }
      // send to BE
      sendActivity({
        userId: getUserId(),
        createdAt: new Date().toISOString(),
        page: url,
      })
    }

    function trackViewManually(url) {
      log.warn(
        'WARNING: views are tracked automatically, use this method wisely!'
      )
      trackView(url)
    }

    function onStateChange() {
      var url = $location.url()
      $timeout(function() {
        // delay as location isn't updated immediately
        trackView(url)
      }, 100)
    }

    function sendActivity(activity) {
      // HACK: wrapping the activity in an array as the BE is not ready to accept single objects yet
      analyticsResource
        .save({ activity: [activity] })
        .success(function() {
          log.debug('activity sent!')
        })
        .error(function(error) {
          log.debug('error sending activity: ' + JSON.stringify(error))
        })
    }

    function trackActiveCampaignView() {
      var config = {
        method: 'GET',
        url: 'https://trackcmp.net/visit',
        params: {
          actid: ACTIVE_CAMPAIGN_ID,
          e: userEmail,
          r: $document.referrer,
          u: $window.location.href,
        },
      }
      $http(config)
    }
  }

  /* @ngInject */
  function run(glAnalytics) {
    glAnalytics.init()
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "resources"];
  config.$inject = ["api"];
  angular
    .module('glow.services')
    .service('api', Service)
    .run(config)

  /* @ngInject */
  function Service($q, resources) {
    var self = this

    this._build = _build

    function createPromise(action) {
      return function() {
        var args = arguments
        return $q(function(resolve, reject) {
          action
            .apply(this, args)
            .success(function(_, resp) {
              resolve(resp)
            })
            .error(function(err) {
              reject(err)
            })
        })
      }
    }

    function _build() {
      // Get all the resource services eg publicationsResource, assetsResource etc
      _.each(resources.getAll(), function(resource, resourceName) {
        var actions = {}
        // Loop through and create a function that uses a real promise,
        // that wraps the underlying resource actions
        _.each(resource, function(action, name) {
          actions[name] = createPromise(action)
        })
        // Add this resource by name to the service
        // so we can use it, eg `api.subscribers.get()`
        self[resourceName] = actions
      })
    }
  }

  function config(api) {
    api._build()
  }
})()

;(function() {
  'use strict'

  angular.module('glow.services').provider('app', Provider)

  function Provider() {
    Service.$inject = ["$transitions", "$location"];
    var AppName = 'Glow'
    var DefaultTags = {
      title: undefined,
      type: 'website',
      siteName: undefined,
      url: undefined,
      description: undefined,
      image: undefined,
    }
    var PropertyNames = {
      title: 'og:title',
      type: 'og:type',
      siteName: 'og:site_name',
      url: 'og:url',
      description: 'og:description',
      image: 'og:image',
    }

    return {
      setAppName: setAppName,
      setDefaultTags: setDefaultTags,
      $get: Service,
    }

    function setAppName(name) {
      AppName = name
    }

    function setDefaultTags(tags) {
      DefaultTags = tags
    }

    /* @ngInject */
    function Service($transitions, $location) {
      var service = {
        setTitle: setTitle,
        setTags: setTags,
      }

      setTitle()
      setTags()
      $transitions.onSuccess(null, onStateChange)

      return service

      function onStateChange(trans) {
        var toState = trans.to()
        DefaultTags.url = $location.absUrl()
        setTitle(toState.title)
        setTags(toState.tags)
      }

      function setTitle(title) {
        if (!title && service.title) {
          return
        }
        service.title = title ? title + ' | ' + AppName : AppName
      }

      function setTags(tags) {
        tags = _.defaults(tags, DefaultTags)
        tags = _.map(tags, function(content, key) {
          return {
            property: PropertyNames[key],
            content: content,
          }
        })
        tags = _.filter(tags, function(tag) {
          return tag.property && tag.content
        })
        service.tags = tags
      }
    }
  }
})()

;(function() {
  'use strict'

  glAuthService.$inject = ["$q", "$rootScope", "$injector", "glErrorService", "glPrefs", "resources", "authResource"];
  var ngModule
  try {
    ngModule = angular.module('glow.services')
  } catch (ModuleNotFoundError) {
    ngModule = angular.module('glow.services', [])
  }

  ngModule.factory('glAuthService', glAuthService).constant('AUTH_EVENTS', {
    loginSuccess: 'auth-login-success',
    loginFailed: 'auth-login-failed',
    logoutSuccess: 'auth-logout-success',
    sessionTimeout: 'auth-session-timeout',
    notAuthenticated: 'auth-not-authenticated',
    notAuthorised: 'auth-not-authorised',
  })

  /* @ngInject */
  function glAuthService(
    $q,
    $rootScope,
    $injector,
    glErrorService,
    glPrefs,
    resources,
    authResource
  ) {
    var glAnalytics = $injector.get('glAnalytics')
    var prefs = glPrefs.create('as')

    var Roles = {
      SUBSCRIBER_SUPPORT: 'ROLE_SUBSCRIBER_SUPPORT',
      ADMIN: 'ROLE_ADMIN',
      EMAIL: 'ROLE_EMAIL',
      PHONE: 'ROLE_PHONE',
      USER: 'ROLE_USER', // Doug said this sometimes comes back instead of ROLE_PHONE and will be migrated later
      SUBSCRIBER: 'ROLE_SUBSCRIBER',
    }

    var Events = {
      USER_CHANGE: 'AUTH_SERVICE_USER_CHANGE',
    }

    var storageKey = 'gu'

    return {
      Roles: Roles,
      Events: Events,
      login: login,
      logout: logout,
      hasCredentials: hasCredentials,
      getToken: getToken,
    }

    function getAuth() {
      return prefs.get(storageKey) || {}
    }

    function setAuth(data) {
      // log.info('setAuth(data)', data);
      resources.setAuth(data)
      prefs.set(storageKey, data)
    }

    function hasCredentials() {
      var auth = getAuth()
      return (
        auth &&
        !_.isEmpty(auth) &&
        (auth.token || (auth.email && auth.password))
      )
    }

    function getToken() {
      return getAuth().token
    }

    /**
     * @name login
     * @description Log user in
     * @param {Object} auth an object with email/password or a token
     * @param {?string} allowedRoles
     * @return {Promise} promise resolves with user profile
     */
    function login(auth, allowedRoles) {
      if (!!allowedRoles && !_.isArray(allowedRoles)) {
        allowedRoles = [allowedRoles]
      }

      // use provided auth or fallback to stored auth
      auth = auth || getAuth()

      // log.info('login(auth)', auth);

      if (auth.email && auth.password) {
        return loginWithEmail(auth.email, auth.password, allowedRoles)
      } else if (auth.token) {
        return loginWithToken(auth.token, allowedRoles)
      } else {
        return $q.reject()
      }
    }

    function loginWithEmail(email, password, allowedRoles) {
      var token

      return getTokenWithCredentials(email, password)
        .then(function(data) {
          token = data.token
          return getUserWithToken(data.token)
        })
        .then(function(user) {
          return checkRoles(user, allowedRoles)
        })
        .then(function(user) {
          setAuth({
            token: token,
          })
          onUserChange(user)
          return user
        })
    }

    function loginWithToken(token, allowedRoles) {
      return getUserWithToken(token)
        .then(function(user) {
          return checkRoles(user, allowedRoles)
        })
        .then(function(user) {
          setAuth({
            token: token,
          })
          onUserChange(user)
          return user
        })
    }

    function getTokenWithCredentials(email, password) {
      return $q(function(resolve, reject) {
        if (!email || !password) {
          return reject()
        }

        authResource
          .login({ email: email, password: password })
          .success(function(x, data) {
            resolve(data)
          })
          .error(reject)
      })
    }

    function getUserWithToken(token) {
      return $q(function(resolve, reject) {
        if (!token) {
          return reject()
        }

        var options = {
          auth: { token: token },
        }

        authResource
          .me(null, null, options)
          .success(function(x, data) {
            resolve(data)
          })
          .error(reject)
      })
    }

    function hasRoles(user, allowedRoles) {
      if (!allowedRoles) {
        return true
      } else {
        return _.reduce(
          allowedRoles,
          function(isAllowed, allowedRole) {
            return isAllowed || _.includes(user.roles, allowedRole)
          },
          false
        )
      }
    }

    /**
     * @param {Object} user The user model with `roles` of array type.
     * @param {?string} allowedRoles The roles to check or undefined to skip checking.
     * @return {Object} The user object
     * @throws {Error}
     */
    function checkRoles(user, allowedRoles) {
      if (hasRoles(user, allowedRoles)) {
        return user
      } else {
        var errorMessage = [
          'This user',
          user.fullname,
          'does not have access to this Portal. Please try alternative credentials.',
        ].join(' ')

        throw new Error(errorMessage)
      }
    }

    function onUserChange(user) {
      user = user || {}

      glAnalytics.setUser(user)
      glPrefs.setUser(user.id)

      glErrorService.setUserContext(
        _.isEmpty(user)
          ? undefined
          : {
              id: user.id,
              email: user.email,
              group: user.group,
            }
      )

      $rootScope.$broadcast(Events.USER_CHANGE)
    }

    function logout() {
      setAuth(null)
      onUserChange(null)
      return $q.resolve()
    }
  }
})()

/* globals tinygradient */
;(function() {
  'use strict'

  angular.module('glow.services').factory('colors', Service)

  /* @ngInject */
  function Service() {
    var RGBA_REGEX = /^rgba\(([^,\).]+),([^\),]+)\)$/i

    var cachedGradients = {}
    var groups = {}

    var Colors = {
      BLACK: '#000',
      WHITE: '#FFF',
      BLUE_CLEAR: '#3aa3e3',
      BLUE_SLATE: '#3c4b5b',
      BLUE_ATHENS_GRAY: '#e6e8eb',
      GREEN_SEAFOAM: '#2ab27b',
      GREY_INDIFFERENT: '#555459',
      GREY_SILVER: '#9e9ea6',
      GREY_SOFT: '#e8e8e8',
      GREY_GALLERY: '#efefef',
      GREY_SEVERE: '#3d3c40',
      GREEN_EMERALD: '#3c6',
      ORANGE_NEON_CARROT: '#f93',
      ORANGE_FLAMINGO: '#f26122',
      ORANGE_TANGO: '#f47421',
      ORANGE_BLAZE: '#ff6600',
      ORANGE_SEA_BUCKTHORN: '#f78c28',
      ORANGE_GLOW: '#faa41a',
      PURPLE_FUCHIA: '#7d60c5',
      RED_CANDY: '#eb4d5c',
      WHITE_ALABASTER: '#f7f7f7',
      YELLOW_STAR: '#f6d513',
      DODGER_BLUE: '#2196f3',
      INHERIT: 'inherit',
    }

    var Types = {
      HEX: 'hex',
      RGBA: 'rgba',
      NAMED: 'NAMED',
    }

    var CORE_COLORS = [
      '#ffbc00',
      '#ffd600',
      '#00b0ff',
      '#2979ff',
      '#6200ea',
      '#ff9100',
      '#ff6d00',
      '#8bc34a',
      '#43a047',
      '#00796b',
      '#ff9e80',
      '#ff5252',
      '#bcaaa4',
      '#795548',
      '#bf63d6',
      '#9c27b0',
      '#00c4d3',
    ]
    var CORE_GRADIENT = ['#f50057', '#ffd600', '#4caf50']

    return {
      parse: parse,
      rgba: rgba,
      Colors: Colors,
      getGradient: getGradient,
      getByKey: getByKey,
      expandHex: expandHex,
      CORE_COLORS: CORE_COLORS,
      CORE_GRADIENT: CORE_GRADIENT,
    }

    function parse(val) {
      var type = getType(val)
      // console.log('parse', val, type)

      if (type === Types.HEX) {
        return val
      } else if (type === Types.RGBA) {
        var data = RGBA_REGEX.exec(val)
        var color = parse(data[1])
        var opacity = data[2]
        return rgba(color, opacity)
      } else if (type === Types.NAMED) {
        return Colors[val]
      }
    }

    function rgba(hex, opacity) {
      hex = hex.replace('#', '')
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
      }
      var r = parseInt(hex.substring(0, 2), 16)
      var g = parseInt(hex.substring(2, 4), 16)
      var b = parseInt(hex.substring(4, 6), 16)
      return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')'
    }

    function getType(val) {
      if (!val) {
        return
      }
      if (_.startsWith(val, '#') || val.length === 3 || val.length === 6) {
        return Types.HEX
      }
      if (RGBA_REGEX.test(val)) {
        return Types.RGBA
      }
      if (Colors[val]) {
        return Types.NAMED
      }
    }

    function reduceColors(colors, n) {
      var steps = (colors.length - 1) / (n - 1)
      var result = []
      for (let i = 0; i < n; i++) {
        var pos = i * steps
        if (pos % 1 === 0) {
          // pos is a whole number we can use it
          // directly, as an index
          result.push(colors[pos])
        } else {
          // pos is in between two colors, we need to
          // calculate the color in between
          var colorA = colors[Math.floor(pos)]
          var colorB = colors[Math.ceil(pos)]
          var color = tinygradient([colorA, colorB])
            .hsvAt(0.5)
            .toHex()
          result.push('#' + color)
        }
      }
      return result
    }

    function logColors(colors) {
      var args = ['']
      _.each(colors, function(hex) {
        args[0] += '%c--'
        args.push('background: ' + hex + '; color: ' + hex + ';')
      })
      console.log.apply(this, args)
    }

    function getGradient(baseColors, steps) {
      var cacheKey = baseColors.join('') + steps
      var cached = cachedGradients[cacheKey]
      if (cached) {
        return cached
      }

      // if we have no colors use black!
      if (!baseColors.length) {
        var hexColors = ['#000000']
        cachedGradients[cacheKey] = hexColors
        logColors(hexColors)
        return hexColors
      }

      // if there is only one step needed, just use the first color
      if (steps === 1) {
        var hexColors = [baseColors[0]]
        cachedGradients[cacheKey] = hexColors
        logColors(hexColors)
        return hexColors
      }

      // if there are more baseColors than steps needed
      // we need to shrink the baseColors down to the number of steps
      if (baseColors.length > steps) {
        var hexColors = reduceColors(baseColors, steps)
        cachedGradients[cacheKey] = hexColors
        logColors(hexColors)
        return hexColors
      }

      // if there are the same number of baseColors and steps
      // we just use them!.
      // if there is only one color we just use that as that too.
      if (baseColors.length === steps || baseColors.length === 1) {
        var hexColors = baseColors.slice()
        cachedGradients[cacheKey] = hexColors
        logColors(hexColors)
        return hexColors
      }

      // if there are less baseColors than steps
      // we need to generate a gradient to fill in
      // the steps
      var baseGradient = tinygradient(baseColors)
      var colors = baseGradient.hsv(steps, 'short')
      var hexColors = _.map(colors, function(color) {
        return '#' + color.toHex()
      })
      logColors(hexColors)
      cachedGradients[cacheKey] = hexColors
      return hexColors
    }

    function getByKey(groupName, key) {
      var group = groups[groupName]
      if (!group) {
        group = groups[groupName] = { cursor: 0, colorByKey: {} }
      }
      var color = group.colorByKey[key]
      if (!color) {
        color = group.colorByKey[key] =
          CORE_COLORS[group.cursor % CORE_COLORS.length]
        group.cursor++
      }
      return color
    }

    function expandHex(hex) {
      if (hex.length === 4) {
        return '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3]
      }
      return hex
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$location", "$log", "ravenService"];
  angular.module('glow.services').service('configService', Service)

  /* @ngInject */
  function Service($location, $log, ravenService) {
    var self = this
    var config = window.glow.config
    var build = window.glow.build
    var requiredConfig = [
      'apiUrl',
      'subPortalUrl',
      'userPortalUrl',
      'adminPortalUrl',
      'nodeUrl',
      'zoneUrl',
      'glowLinkHost',
      'downgradeUrl',
    ]
    var requiredBuildInfo = ['env', 'property', 'version', 'commit']
    _.each(requiredConfig, function(key) {
      if (!config[key])
        throw new Error('configService: missing config "' + key + '"')
    })
    _.each(requiredBuildInfo, function(key) {
      if (!build[key])
        throw new Error('configService: missing config "' + key + '"')
    })

    // We log the build & config to make debugging properties easier
    // but the logs are noisy when running int-tests so we suppress it.
    if (build.env !== 'Test') {
      console.log(glow.build)
      console.log(glow.config)
    }

    // allow devs to change the api url
    try {
      // we are seeing some browsers without localStorage
      // so we can just catch the error and ignore all this
      var apiUrlOverride = localStorage.getItem('API_URL')
      if (apiUrlOverride) {
        config.apiUrl = apiUrlOverride
        console.log('API_URL modified to ' + config.apiUrl)
      }
    } catch (error) {
      // ...
    }

    self.getBuildEnv = getBuildEnv
    self.getBuildProperty = getBuildProperty
    self.getBuildVersion = getBuildVersion
    self.getBuildCommit = getBuildCommit
    self.isDevelopment = isDevelopment
    self.isStaging = isStaging
    self.isProduction = isProduction
    self.isTest = isTest
    self.isSubPortal = isSubPortal
    self.isUserPortal = isUserPortal
    self.isAdminPortal = isAdminPortal
    self.getApiUrl = getApiUrl
    self.getDatapackUrl = getDatapackUrl
    self.getSubscriberPortalUrl = getSubscriberPortalUrl
    self.getUserPortalUrl = getUserPortalUrl
    self.getAdminPortalUrl = getAdminPortalUrl
    self.getSurveyAiEditorOrigin = getSurveyAiEditorOrigin
    self.getGlowLinkHost = getGlowLinkHost
    self.getNodeUrl = getNodeUrl
    self.getZoneUrl = getZoneUrl
    self.getDowngradeUrl = getDowngradeUrl
    self.getVersion = getVersion
    self.getCommit = getCommit

    initialise()

    function getBuildEnv() {
      return build.env
    }

    function getBuildProperty() {
      return build.property
    }

    function getBuildVersion() {
      return build.version
    }

    function getBuildCommit() {
      return build.commit
    }

    function isDevelopment() {
      return build.env === 'Development'
    }

    function isStaging() {
      return build.env === 'Staging'
    }

    function isProduction() {
      return build.env === 'Production'
    }

    function isTest() {
      return build.env === 'Test'
    }

    function isSubPortal() {
      return build.platform === 'SubPortal'
    }

    function isUserPortal() {
      return build.platform === 'UserPortal'
    }

    function isAdminPortal() {
      return build.platform === 'AdminPortal'
    }

    function isPreview() {
      // check if our platform accessed with netlify preview URL
      return isStaging() && _.includes(getHost(), getPreviewDomain())
    }

    function makePreviewUrl(netlifyPortalUrlSuffix) {
      // generate netlify preview url
      var urlPrefix = getHost().split('--')[0]
      return (
        '://' +
        urlPrefix +
        '--' +
        netlifyPortalUrlSuffix +
        '.' +
        getPreviewDomain()
      )
    }

    function makeNodePreviewUrl() {
      // generate vercel node preview url
      var url = getHost().split('--')[0]
      return (
        '://' + config.vercelNodeUrlPrefix + url + config.vercelNodeUrlSuffix
      )
    }

    function getProtocol() {
      return $location.protocol()
    }

    function getHost() {
      return $location.host()
    }

    function getPreviewDomain() {
      return 'netlify.app'
    }

    function getApiUrl() {
      // development uses same-protocol - otherwise use https
      return makeUrlWithArgs(
        isDevelopment() ? getProtocol() : 'https',
        config.apiUrl,
        arguments
      )
    }

    function getDatapackUrl() {
      // development uses same-protocol - otherwise use https
      return makeUrlWithArgs(
        isDevelopment() ? getProtocol() : 'https',
        config.datapackUrl,
        arguments
      )
    }

    function getGlowLinkHost() {
      return config.glowLinkHost
    }

    function getUserPortalUrl() {
      // development uses same-protocol - otherwise use https
      var url = isPreview()
        ? makePreviewUrl(config.netlifyUserPortalUrlSuffix)
        : config.userPortalUrl
      return makeUrlWithArgs(
        isDevelopment() ? getProtocol() : 'https',
        url,
        arguments
      )
    }

    function getNodeUrl() {
      // development uses same-protocol - otherwise use https
      var url = isPreview() ? makeNodePreviewUrl() : config.nodeUrl
      return makeUrlWithArgs(
        isDevelopment() ? getProtocol() : 'https',
        url,
        arguments
      )
    }

    function getZoneUrl() {
      // development uses same-protocol - otherwise use https
      return makeUrlWithArgs(
        isDevelopment() ? getProtocol() : 'https',
        config.zoneUrl,
        arguments
      )
    }

    function getDowngradeUrl() {
      // development uses same-protocol - otherwise use https
      return makeUrlWithArgs(
        isDevelopment() ? getProtocol() : 'https',
        config.downgradeUrl,
        arguments
      )
    }

    function getSubscriberPortalUrl() {
      // development uses same-protocol - otherwise use https
      var url = isPreview()
        ? makePreviewUrl(config.netlifySubPortalUrlSuffix)
        : config.subPortalUrl
      return makeUrlWithArgs(
        isDevelopment() ? getProtocol() : 'https',
        url,
        arguments
      )
    }

    function getAdminPortalUrl() {
      // always use http (AP does not have ssl)
      var url = isPreview()
        ? makePreviewUrl(config.netlifyAdminPortalUrlSuffix)
        : config.adminPortalUrl
      return makeUrlWithArgs('http', url, arguments)
    }

    function getSurveyAiEditorOrigin() {
      var url = config.surveyAiEditorOrigin
      return makeUrlWithArgs(
        isDevelopment() ? getProtocol() : 'https',
        url,
        arguments
      )
    }

    function makeUrlWithArgs(protocol, base, args) {
      // If the baseUrl already has a protocol ignore the specified one
      if (_.startsWith(base, 'http')) {
        protocol = ''
      }
      args = Array.prototype.slice.call(args)
      var path = args.join('')
      return protocol + base + path
    }

    function getVersion() {
      return build.version
    }

    function getCommit() {
      return build.commit
    }

    function initialise() {
      ravenService.setRelease(getBuildVersion())
      $log.debug(build.env)
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.services').factory('countryService', Service)

  /* @ngInject */
  function Service() {
    var Countries = [
      {
        cc: 'AF',
        name: 'Afghanistan',
        id: '7f5e0117-aa34-41ce-a6be-cb9296499419',
      },
      { cc: 'AL', name: 'Albania', id: '985a4d6c-6388-463b-8aa9-a89bafecd7d3' },
      { cc: 'DZ', name: 'Algeria', id: 'cbf119b7-22d8-4f0f-8670-ebf2abb7a253' },
      {
        cc: 'DS',
        name: 'American Samoa',
        id: '30c71b37-9b3e-4c3b-afb1-0d5c33d49b44',
      },
      { cc: 'AD', name: 'Andorra', id: '1561c4fa-db87-4736-b6b9-248bc2978098' },
      { cc: 'AO', name: 'Angola', id: '0bc2e62f-f4d2-40cc-9968-ec928e315ad2' },
      {
        cc: 'AI',
        name: 'Anguilla',
        id: '1d38b660-8895-4340-926e-f225eaefa011',
      },
      {
        cc: 'AQ',
        name: 'Antarctica',
        id: 'd427f02b-760a-47e3-9343-7b5ca58b5f3d',
      },
      {
        cc: 'AG',
        name: 'Antigua and Barbuda',
        id: 'dec073be-ee0c-4f58-84f7-ee1e29017b50',
      },
      {
        cc: 'AR',
        name: 'Argentina',
        id: '8d9efd51-9d39-448e-a946-ee0fd0bcbc77',
      },
      { cc: 'AM', name: 'Armenia', id: 'e6f16333-0c3f-4b7e-b39a-e834e7a7a558' },
      { cc: 'AW', name: 'Aruba', id: '78d56ae9-3fcd-4bf4-8550-4dfb74217fe6' },
      {
        cc: 'AU',
        name: 'Australia',
        id: 'e388d689-d159-4cf9-979a-c058419af047',
      },
      { cc: 'AT', name: 'Austria', id: 'a1fba6e3-33bd-4bbe-a311-0d8d745b2338' },
      {
        cc: 'AZ',
        name: 'Azerbaijan',
        id: '439a7fc4-fa2b-4942-8acc-5dcd3d21f64f',
      },
      { cc: 'BS', name: 'Bahamas', id: 'd6f4a7ad-8fb2-43db-9a77-42994978dc70' },
      { cc: 'BH', name: 'Bahrain', id: 'b60416ba-f01b-41f2-ab30-bda4c16d542d' },
      {
        cc: 'BD',
        name: 'Bangladesh',
        id: 'bfe55445-9b51-4eed-8d4b-11899e26c619',
      },
      {
        cc: 'BB',
        name: 'Barbados',
        id: '1e94e9c6-a9f2-46a0-98a8-fa6d316f6606',
      },
      { cc: 'BY', name: 'Belarus', id: 'd1c963ee-24a1-4f6d-9fdb-0b3617975ce3' },
      { cc: 'BE', name: 'Belgium', id: '59e151d8-d730-4651-ad27-d446a94ffdfc' },
      { cc: 'BZ', name: 'Belize', id: 'f9c5bd6b-2676-4261-bb21-77a8424c45f2' },
      { cc: 'BJ', name: 'Benin', id: 'dcf2579c-ff02-4ea6-8664-b0266466b95b' },
      { cc: 'BM', name: 'Bermuda', id: '9eaddd90-8554-4682-ba3c-2baf0af36be0' },
      { cc: 'BT', name: 'Bhutan', id: '26295ed4-d6f8-4c1f-a311-4963879039e6' },
      { cc: 'BO', name: 'Bolivia', id: 'd8d015d7-2f48-434a-b29f-a3d94073c431' },
      {
        cc: 'BA',
        name: 'Bosnia and Herzegovina',
        id: 'cbc841ef-d42f-49b7-8f24-d09bf849f509',
      },
      {
        cc: 'BW',
        name: 'Botswana',
        id: 'cfeb4726-eef6-4c45-9ce1-609df93f47c7',
      },
      {
        cc: 'BV',
        name: 'Bouvet Island',
        id: '04689174-529d-4d97-b691-37039115443d',
      },
      { cc: 'BR', name: 'Brazil', id: 'd549783e-0205-4d35-94e9-59b9fd49684c' },
      {
        cc: 'IO',
        name: 'British Indian Ocean Territory',
        id: '9e0c645b-ef99-4af7-b6ef-b7040ab78709',
      },
      {
        cc: 'BN',
        name: 'Brunei Darussalam',
        id: 'a325d003-1a3a-467c-bae0-2e46a45c55f1',
      },
      {
        cc: 'BG',
        name: 'Bulgaria',
        id: 'a21d54d1-1b13-4c5a-a4de-7e318240568b',
      },
      {
        cc: 'BF',
        name: 'Burkina Faso',
        id: '952303d3-4e67-459d-aa1c-70dadd3890f2',
      },
      { cc: 'BI', name: 'Burundi', id: 'e26d388a-6497-4183-9b9e-d1af8c469fc2' },
      {
        cc: 'KH',
        name: 'Cambodia',
        id: '664d91d4-fedf-4ec7-ac08-7a3052763835',
      },
      {
        cc: 'CM',
        name: 'Cameroon',
        id: '1cf06539-08be-4f1f-8688-f16d19f01486',
      },
      { cc: 'CA', name: 'Canada', id: '1e4aa35e-bc41-4224-9ac1-65f3cee9a745' },
      {
        cc: 'CV',
        name: 'Cape Verde',
        id: 'b478987d-7602-4f68-bd00-21e8361d9b94',
      },
      {
        cc: 'KY',
        name: 'Cayman Islands',
        id: '29ab0f12-4767-4b31-8d14-e7d487fd5afc',
      },
      {
        cc: 'CF',
        name: 'Central African Republic',
        id: 'df006439-ae78-4eda-b1dc-582c7521ec79',
      },
      { cc: 'TD', name: 'Chad', id: '72977a2c-8d65-4f60-90e7-648f55b43958' },
      { cc: 'CL', name: 'Chile', id: 'a3bd1093-c67c-49ff-b466-1b4ae60c98ea' },
      { cc: 'CN', name: 'China', id: '1b2f43ac-676c-412a-914c-fd978bd6f488' },
      {
        cc: 'CX',
        name: 'Christmas Island',
        id: '75764a8e-fe90-47fa-837f-980544876305',
      },
      {
        cc: 'CC',
        name: 'Cocos (Keeling) Islands',
        id: '4f037a5b-08a2-4542-8a8f-15f4a96589a4',
      },
      {
        cc: 'CO',
        name: 'Colombia',
        id: '345b0a37-6257-4c77-9af2-4bf337457b47',
      },
      { cc: 'KM', name: 'Comoros', id: '857821ff-d0ef-44e7-aa48-9115610ad16d' },
      { cc: 'CG', name: 'Congo', id: '4f3c3b15-8ab2-4e40-97f3-aaff075655f5' },
      {
        cc: 'CK',
        name: 'Cook Islands',
        id: '2a388468-4c6d-4a36-9147-07a228c2ef9d',
      },
      {
        cc: 'CR',
        name: 'Costa Rica',
        id: '7bb6c633-5154-48d2-9d6e-2363e066f703',
      },
      {
        cc: 'HR',
        name: 'Croatia (Hrvatska)',
        id: 'c9f179b9-390b-4acf-8dc2-233fb2f8b1ac',
      },
      { cc: 'CU', name: 'Cuba', id: 'edf83b97-8e24-46ca-a371-f6516448b8e4' },
      { cc: 'CY', name: 'Cyprus', id: '8e3a5df4-47e4-4260-95b0-94d4f6c7ab21' },
      {
        cc: 'CZ',
        name: 'Czech Republic',
        id: '7de23cd6-852c-459f-94e8-940b09b2d07d',
      },
      { cc: 'DK', name: 'Denmark', id: '300f8528-888f-4de4-901c-6b2692c9d757' },
      {
        cc: 'DJ',
        name: 'Djibouti',
        id: 'f22489e1-4838-4dd0-a561-f045e68c89ee',
      },
      {
        cc: 'DM',
        name: 'Dominica',
        id: 'ff6d84b6-61aa-4fa2-8795-747613eb3b33',
      },
      {
        cc: 'DO',
        name: 'Dominican Republic',
        id: 'd0e16f8f-f766-494e-b034-2c021c361921',
      },
      {
        cc: 'TP',
        name: 'East Timor',
        id: '410400b4-d921-496c-b3e3-2d31d99bbd76',
      },
      { cc: 'EC', name: 'Ecuador', id: 'bfb7cef6-5b24-4ee4-9ef0-13c8f2bc10f5' },
      { cc: 'EG', name: 'Egypt', id: 'd70ffd4a-4252-4742-a108-f4a648c19cdb' },
      {
        cc: 'SV',
        name: 'El Salvador',
        id: 'bc89fbd8-e50c-4d75-b2fa-5ddfdc7e8aee',
      },
      {
        cc: 'GQ',
        name: 'Equatorial Guinea',
        id: '54671460-e4f2-4697-9958-1b5e09599f81',
      },
      { cc: 'ER', name: 'Eritrea', id: 'c2501573-1b40-4e57-ab1e-0963b6c79563' },
      { cc: 'EE', name: 'Estonia', id: '21b97ed0-d253-4711-97fd-badc585e54ef' },
      {
        cc: 'ET',
        name: 'Ethiopia',
        id: '629815bc-043d-4c18-b41f-edb6dba154a1',
      },
      {
        cc: 'FK',
        name: 'Falkland Islands (Malvinas)',
        id: '7ab892ce-68bb-4bf3-b4ba-5b3cd6c40ffa',
      },
      {
        cc: 'FO',
        name: 'Faroe Islands',
        id: 'ab713a3f-861d-4080-8bd3-294eefdf83ee',
      },
      { cc: 'FJ', name: 'Fiji', id: '814fa7b4-3f0e-4d69-8b74-3bf54c607a61' },
      { cc: 'FI', name: 'Finland', id: '473f1daf-503c-45c7-be55-504868e596a3' },
      { cc: 'FR', name: 'France', id: '9968457e-3945-4185-8f73-658cda4863b0' },
      {
        cc: 'FX',
        name: 'France, Metropolitan',
        id: 'cc7b70d8-47b6-44f7-b09f-d9151d0046e2',
      },
      {
        cc: 'GF',
        name: 'French Guiana',
        id: 'cdfedb56-4abc-4416-9e32-9e7b59ac2dfd',
      },
      {
        cc: 'PF',
        name: 'French Polynesia',
        id: 'a998a662-d5ca-4d8a-81f0-139d54b9c07c',
      },
      {
        cc: 'TF',
        name: 'French Southern Territories',
        id: '2164136e-3c46-419e-a918-42216b7f3de4',
      },
      { cc: 'GA', name: 'Gabon', id: '8aadb240-e2d9-46e8-a7cb-e25029b61b63' },
      { cc: 'GM', name: 'Gambia', id: '0e9b269b-b4ee-4433-9226-e7ebe6d74fb6' },
      { cc: 'GE', name: 'Georgia', id: 'b1481cc2-129c-4a05-8196-4266dc4b5129' },
      { cc: 'DE', name: 'Germany', id: 'adff06b9-ad71-46c4-abd1-74f454edbbe1' },
      { cc: 'GH', name: 'Ghana', id: 'ef78ce76-403e-4ef0-ae84-f2da0b87b920' },
      {
        cc: 'GI',
        name: 'Gibraltar',
        id: '277d03f7-b46f-4ac8-b47f-adaf563354d5',
      },
      {
        cc: 'GK',
        name: 'Guernsey',
        id: '69002e22-3507-42e0-b6c4-b85d98ad7a62',
      },
      { cc: 'GR', name: 'Greece', id: '774ff291-6e90-4a43-9f6c-e4f15c739e2f' },
      {
        cc: 'GL',
        name: 'Greenland',
        id: 'ec7d82e4-b6af-499e-9d86-3b565e8f66a6',
      },
      { cc: 'GD', name: 'Grenada', id: 'd78821f9-3a94-4c3d-bfb5-da9f92d0b882' },
      {
        cc: 'GP',
        name: 'Guadeloupe',
        id: 'e8169ecb-dffe-48f9-be9d-241119e25b5d',
      },
      { cc: 'GU', name: 'Guam', id: 'a343a974-16ec-4ad7-873c-1d3ef342b51e' },
      {
        cc: 'GT',
        name: 'Guatemala',
        id: 'b9853d98-5bdc-476b-88df-77cc183afc9e',
      },
      { cc: 'GN', name: 'Guinea', id: 'f644cbdf-b45a-4f0d-82ef-9419ba3b0842' },
      {
        cc: 'GW',
        name: 'Guinea-Bissau',
        id: 'c462d97b-a50d-4a79-a645-9acaebce1ef5',
      },
      { cc: 'GY', name: 'Guyana', id: 'e52c1262-529f-49ce-b616-f5dfde79dd49' },
      { cc: 'HT', name: 'Haiti', id: '86a52c36-5e73-49a8-bd2e-891e0e0b4d18' },
      {
        cc: 'HM',
        name: 'Heard and Mc Donald Islands',
        id: 'ab1458e8-937a-4d62-8946-e69e32be93e2',
      },
      {
        cc: 'HN',
        name: 'Honduras',
        id: 'e144d9b1-140f-43dd-8e7b-c35127d0ffb6',
      },
      {
        cc: 'HK',
        name: 'Hong Kong',
        id: '60cdfc36-da1f-4033-92f0-ad9f3ab8967e',
      },
      { cc: 'HU', name: 'Hungary', id: 'c5d99ba1-4544-4189-879e-33354d1717bc' },
      { cc: 'IS', name: 'Iceland', id: 'b639eb9d-18fe-45fd-9bc8-d38717b81c6b' },
      { cc: 'IN', name: 'India', id: '9bac6524-694e-420a-bf43-d9926419bff2' },
      {
        cc: 'IM',
        name: 'Isle of Man',
        id: '377d52e5-fff4-43e4-a390-1bda2d526ae9',
      },
      {
        cc: 'ID',
        name: 'Indonesia',
        id: '8144174f-3b28-4169-9f70-d64841dbb750',
      },
      {
        cc: 'IR',
        name: 'Iran (Islamic Republic of)',
        id: 'd2e6a323-c23e-43aa-a8cd-c0fec1369f25',
      },
      { cc: 'IQ', name: 'Iraq', id: 'b3b72a53-5da3-4d94-8f06-6175ce5ae4c4' },
      { cc: 'IE', name: 'Ireland', id: 'a49fd418-df0e-410d-b301-19b8ebc92be2' },
      { cc: 'IL', name: 'Israel', id: 'ce11c5d0-817d-4d0d-97ca-63d2377f9c36' },
      { cc: 'IT', name: 'Italy', id: '8839e7cf-1219-46c4-a017-8c79b2498252' },
      {
        cc: 'CI',
        name: 'Ivory Coast',
        id: '80c0c608-eddf-4bf2-958e-dfe05b3ccaa0',
      },
      { cc: 'JE', name: 'Jersey', id: 'ace871f2-9c43-4bf5-9f64-13324cabd12f' },
      { cc: 'JM', name: 'Jamaica', id: '77f03777-f425-48ae-9d94-32514e6dc782' },
      { cc: 'JP', name: 'Japan', id: '977c3261-6fe6-484a-99ee-2b8a9bc0ef01' },
      { cc: 'JO', name: 'Jordan', id: '73c13002-6fc2-41fe-9484-3c62e9f44e91' },
      {
        cc: 'KZ',
        name: 'Kazakhstan',
        id: '7f89a2cc-d22e-4648-9617-0cb21a5f3dda',
      },
      { cc: 'KE', name: 'Kenya', id: 'a8cce6d6-4e64-4746-9f16-87c775499303' },
      {
        cc: 'KI',
        name: 'Kiribati',
        id: '8f2091de-d3f0-4b17-9896-21c8c48de0ca',
      },
      {
        cc: 'KP',
        name: "Korea, Democratic People's Republic of",
        id: '1939d05b-bb09-497e-aec9-9d040cf70cdb',
      },
      {
        cc: 'KR',
        name: 'Korea, Republic of',
        id: '8d02fcb1-2634-4f39-a075-d772d8b70ddd',
      },
      { cc: 'XK', name: 'Kosovo', id: '4fecdd65-12a3-495a-94d8-82dece857965' },
      { cc: 'KW', name: 'Kuwait', id: 'a3ebf308-b522-4a65-a811-6fd05eea5184' },
      {
        cc: 'KG',
        name: 'Kyrgyzstan',
        id: '23d50a95-cbf9-4629-833e-f65e7ea32717',
      },
      {
        cc: 'LA',
        name: "Lao People's Democratic Republic",
        id: 'bb89e8ff-c45b-46ae-8c5e-c0c854cbfcf7',
      },
      { cc: 'LV', name: 'Latvia', id: 'a3071930-59aa-417b-a8a0-fe626ac40cbc' },
      { cc: 'LB', name: 'Lebanon', id: 'ebccda2e-38d4-4d5d-8fdb-6e6f1a6c2edd' },
      { cc: 'LS', name: 'Lesotho', id: 'f1ffff31-ee73-4a48-8aaf-249c003a7afc' },
      { cc: 'LR', name: 'Liberia', id: 'c29a0612-f1f4-4327-ac14-5f9228d52e12' },
      {
        cc: 'LY',
        name: 'Libyan Arab Jamahiriya',
        id: 'bc76a9cf-b919-4a75-a524-5b634e59fddb',
      },
      {
        cc: 'LI',
        name: 'Liechtenstein',
        id: 'f2ad3d40-d983-45e2-a772-6ff610326e44',
      },
      {
        cc: 'LT',
        name: 'Lithuania',
        id: 'ee4c3936-421c-4590-ba31-a21abbc5c636',
      },
      {
        cc: 'LU',
        name: 'Luxembourg',
        id: 'df99254f-8b05-4063-b9d9-3fab7f51918f',
      },
      { cc: 'MO', name: 'Macau', id: '48e2ee7c-ab96-48d9-af20-a8e59385e5f8' },
      {
        cc: 'MK',
        name: 'Macedonia',
        id: '9ea5ae51-e971-4835-b6bb-e580b3aa436b',
      },
      {
        cc: 'MG',
        name: 'Madagascar',
        id: '54e4edca-5f11-43c1-a512-f57f1b995343',
      },
      { cc: 'MW', name: 'Malawi', id: 'bd83d800-66c9-482b-8fec-9e5f971f54e1' },
      {
        cc: 'MY',
        name: 'Malaysia',
        id: '8abbd70e-486f-44b4-9cf4-f50095df55b3',
      },
      {
        cc: 'MV',
        name: 'Maldives',
        id: '9f79919e-f23a-4995-a39b-ef3269504176',
      },
      { cc: 'ML', name: 'Mali', id: '8e7faafa-a014-48cf-a17d-5189bd54525c' },
      { cc: 'MT', name: 'Malta', id: 'dcbb503b-b513-4955-9761-3188ad94b1b6' },
      {
        cc: 'MH',
        name: 'Marshall Islands',
        id: '76fcc5cd-e5d5-4009-9481-905caa21c1b0',
      },
      {
        cc: 'MQ',
        name: 'Martinique',
        id: 'b97f34b4-5767-4d0b-a67e-3b823b29025f',
      },
      {
        cc: 'MR',
        name: 'Mauritania',
        id: '8e4f6ab3-19c2-4204-8311-309e437e9deb',
      },
      {
        cc: 'MU',
        name: 'Mauritius',
        id: 'e694102c-8c08-451b-aeff-d470a01e691e',
      },
      { cc: 'TY', name: 'Mayotte', id: '256d4e16-194b-4758-a7fd-afac8e21e5de' },
      { cc: 'MX', name: 'Mexico', id: '595de102-6351-48e5-8e5c-c86a21c107e9' },
      {
        cc: 'FM',
        name: 'Micronesia, Federated States of',
        id: '3ef2b7ac-e025-4508-89f3-d650529497e1',
      },
      {
        cc: 'MD',
        name: 'Moldova, Republic of',
        id: '040baadc-997f-4228-97d7-c62875250ca2',
      },
      { cc: 'MC', name: 'Monaco', id: 'c7961cc9-f892-4b75-bb14-b373460d3023' },
      {
        cc: 'MN',
        name: 'Mongolia',
        id: '3519b3c9-c46b-4757-a629-2a5832bed95b',
      },
      {
        cc: 'ME',
        name: 'Montenegro',
        id: '939b0a8e-d8f0-4edf-b393-b323e05f8871',
      },
      {
        cc: 'MS',
        name: 'Montserrat',
        id: 'f1ffb116-e5a4-4476-90ed-574ee4d3deca',
      },
      { cc: 'MA', name: 'Morocco', id: '477dd8c7-55da-4ab0-b205-754d8cf0e576' },
      {
        cc: 'MZ',
        name: 'Mozambique',
        id: '7fdfb1ac-fb79-4438-8eee-395c2e9046c2',
      },
      { cc: 'MM', name: 'Myanmar', id: '6e6ce2ab-d273-4e63-a8a9-4161489e19c4' },
      { cc: 'NA', name: 'Namibia', id: '61771ff5-a989-4567-8f54-e47f3cfe8dc0' },
      { cc: 'NR', name: 'Nauru', id: 'fdce6d50-6c24-47ac-93ec-834cb4e3c71e' },
      { cc: 'NP', name: 'Nepal', id: '45639e45-5e14-4813-8a95-131333ec3f36' },
      {
        cc: 'NL',
        name: 'Netherlands',
        id: '3d9765f8-0d7b-477f-9855-f316789d094b',
      },
      {
        cc: 'AN',
        name: 'Netherlands Antilles',
        id: '9230677c-f7d9-448b-8d3d-8aeb140c30a3',
      },
      {
        cc: 'NC',
        name: 'New Caledonia',
        id: '85598e1c-10d4-4bc1-904c-e985c43c6bf6',
      },
      {
        cc: 'NZ',
        name: 'New Zealand',
        id: '4cab1992-51a4-4225-82d8-140586da3d2b',
      },
      {
        cc: 'NI',
        name: 'Nicaragua',
        id: '09d714df-2531-4112-bd26-173352da0242',
      },
      { cc: 'NE', name: 'Niger', id: 'a0575815-045d-462d-b579-7bfc643f5aef' },
      { cc: 'NG', name: 'Nigeria', id: '3946df0b-89fa-4b24-af75-bbc3e5ce9801' },
      { cc: 'NU', name: 'Niue', id: '4fc9acff-9e61-4497-a2d1-af26af94a8b5' },
      {
        cc: 'NF',
        name: 'Norfolk Island',
        id: '2119d7d0-1a6d-4066-b5b3-bd3096fe6531',
      },
      {
        cc: 'MP',
        name: 'Northern Mariana Islands',
        id: '909a9ea4-850a-44c8-aa4f-d6b1fe366c5b',
      },
      { cc: 'NO', name: 'Norway', id: 'cd478fba-30d7-4d21-9793-9edbcdae903b' },
      { cc: 'OM', name: 'Oman', id: '90f428bc-b768-420e-9e63-b5335e99f8fb' },
      {
        cc: 'PK',
        name: 'Pakistan',
        id: 'daf1555c-16ac-4781-9afc-e16a5ededba6',
      },
      { cc: 'PW', name: 'Palau', id: '95fcaa90-68e1-4a8d-b95a-6ee09c015007' },
      {
        cc: 'PS',
        name: 'Palestine',
        id: 'c5964f5d-6aba-4e8c-a0f5-2d33679e26aa',
      },
      { cc: 'PA', name: 'Panama', id: 'd012e9ba-2ad5-46a0-a810-1aa2976acd88' },
      {
        cc: 'PG',
        name: 'Papua New Guinea',
        id: 'f6ef6f4f-63fa-4b1e-884e-01268b73af49',
      },
      {
        cc: 'PY',
        name: 'Paraguay',
        id: 'a0b94e26-e6ac-4522-8c15-47d0baa40b66',
      },
      { cc: 'PE', name: 'Peru', id: 'fa7021e4-4fbd-4b2c-befd-1c07019340b4' },
      {
        cc: 'PH',
        name: 'Philippines',
        id: 'f80eef61-bcf8-4ea3-b6f3-7ebfddcec03c',
      },
      {
        cc: 'PN',
        name: 'Pitcairn',
        id: '387801fb-c229-4126-9ce3-fb5f67fa7996',
      },
      { cc: 'PL', name: 'Poland', id: '8a5a1233-d6eb-4f45-adb9-bca041d216d5' },
      {
        cc: 'PT',
        name: 'Portugal',
        id: '501c52a8-84e3-4913-b7fb-3404eed5f77a',
      },
      {
        cc: 'PR',
        name: 'Puerto Rico',
        id: '899d28b3-f7a6-475a-8601-60f77aedb035',
      },
      { cc: 'QA', name: 'Qatar', id: '629ad3d3-2783-44b6-a5d9-06d10c5ba5e6' },
      { cc: 'RE', name: 'Reunion', id: 'bb34662c-1004-448f-b63a-2df3af82eb74' },
      { cc: 'RO', name: 'Romania', id: 'cd901c9e-8341-4dc0-9bc5-1865c5a04a87' },
      {
        cc: 'RU',
        name: 'Russian Federation',
        id: '1fb43903-e712-424e-9a37-917d11c5ee85',
      },
      { cc: 'RW', name: 'Rwanda', id: 'bc2f9d9c-97ed-47e4-988f-a20611ef3e65' },
      {
        cc: 'KN',
        name: 'Saint Kitts and Nevis',
        id: '429d8082-e7fb-4f0b-829d-4e17601bc317',
      },
      {
        cc: 'LC',
        name: 'Saint Lucia',
        id: '40ce459f-5e17-4fca-aeb9-92db617e4c75',
      },
      {
        cc: 'VC',
        name: 'Saint Vincent and the Grenadines',
        id: '64e3d3a5-0763-499f-8d32-7f2b11ccbe38',
      },
      { cc: 'WS', name: 'Samoa', id: 'a4218070-43e6-40a5-a504-61e959148454' },
      {
        cc: 'SM',
        name: 'San Marino',
        id: 'de890939-b0e7-43e8-887a-976bbd667ca8',
      },
      {
        cc: 'ST',
        name: 'Sao Tome and Principe',
        id: '077effb3-d5e8-44f7-b8cb-14c6cbd85124',
      },
      {
        cc: 'SA',
        name: 'Saudi Arabia',
        id: '5043d5f7-3644-4550-b978-9bca83a25033',
      },
      { cc: 'SN', name: 'Senegal', id: '00971456-a9af-4f8a-82d6-143583c21013' },
      { cc: 'RS', name: 'Serbia', id: '14b00341-5041-4456-8823-61983a376fec' },
      {
        cc: 'SC',
        name: 'Seychelles',
        id: '8701ae47-44f4-42a2-9eee-db9d7d2e958e',
      },
      {
        cc: 'SL',
        name: 'Sierra Leone',
        id: 'f4879d1e-f56e-4030-acde-cf045c28b96f',
      },
      {
        cc: 'SG',
        name: 'Singapore',
        id: '551fff85-ba7a-469a-a89a-b10c102f43a8',
      },
      {
        cc: 'SK',
        name: 'Slovakia',
        id: '333d24f1-9e95-4211-b166-c89a057cc2e8',
      },
      {
        cc: 'SI',
        name: 'Slovenia',
        id: 'd6cdd3f3-8db7-412c-820a-0b58039d48b0',
      },
      {
        cc: 'SB',
        name: 'Solomon Islands',
        id: 'dd95566e-6a57-4ba8-831a-af0d68e5012b',
      },
      { cc: 'SO', name: 'Somalia', id: 'b171dccb-eae8-4df4-b405-e83ac4b8a344' },
      {
        cc: 'ZA',
        name: 'South Africa',
        id: '690c61c3-909d-45e7-9973-b15c3e134dfc',
      },
      {
        cc: 'GS',
        name: 'South Georgia South Sandwich Islands',
        id: '293e370d-d6c7-4ac6-a226-e8c4efa6f7ce',
      },
      { cc: 'ES', name: 'Spain', id: 'c0d91a68-22f0-4063-bbc4-799e6cd4298b' },
      {
        cc: 'LK',
        name: 'Sri Lanka',
        id: '64ba0ef8-a349-471f-9d54-6ceeb7c0ea2c',
      },
      {
        cc: 'SH',
        name: 'St. Helena',
        id: 'cd273595-1da0-476b-aa06-6270440a0337',
      },
      {
        cc: 'PM',
        name: 'St. Pierre and Miquelon',
        id: '32b76309-003f-4b7b-8198-be1e487a75b3',
      },
      { cc: 'SD', name: 'Sudan', id: 'b730204b-d810-430e-a098-e456abac6e4b' },
      {
        cc: 'SR',
        name: 'Suriname',
        id: 'ad067adc-3737-4e47-bb13-09818632ac4b',
      },
      {
        cc: 'SJ',
        name: 'Svalbard and Jan Mayen Islands',
        id: 'fa46aa13-9b79-4c35-b460-7b604d0dc18a',
      },
      {
        cc: 'SZ',
        name: 'Swaziland',
        id: '63264ead-3ede-4ea4-aa16-032c102bd0ce',
      },
      { cc: 'SE', name: 'Sweden', id: 'f1910d51-8808-441c-94db-6bab30976b2a' },
      {
        cc: 'CH',
        name: 'Switzerland',
        id: '8d9a5cda-d15e-4796-b76f-5d8d5d536612',
      },
      {
        cc: 'SY',
        name: 'Syrian Arab Republic',
        id: 'efa79dd1-2533-4780-b74a-2a0925586dfe',
      },
      { cc: 'TW', name: 'Taiwan', id: '854f5d41-5e47-46f8-8072-55e754e44b37' },
      {
        cc: 'TJ',
        name: 'Tajikistan',
        id: 'f17ee205-deff-4216-b207-d52c5e684609',
      },
      {
        cc: 'TZ',
        name: 'Tanzania, United Republic of',
        id: 'f55e4e91-4b30-4489-b484-51d04c06417f',
      },
      {
        cc: 'TH',
        name: 'Thailand',
        id: '74c30f30-7b42-4377-ad4f-3375684e8b0e',
      },
      { cc: 'TG', name: 'Togo', id: 'abebcca9-c4a7-4cc5-8c5c-30bd6b29e411' },
      { cc: 'TK', name: 'Tokelau', id: '5be6717b-8a8a-492d-acea-4f18860751b9' },
      { cc: 'TO', name: 'Tonga', id: '54b86012-3f40-4e0b-83a5-0665d163b336' },
      {
        cc: 'TT',
        name: 'Trinidad and Tobago',
        id: '57b91e3f-7c5f-46e1-9ad0-552963dacb96',
      },
      { cc: 'TN', name: 'Tunisia', id: 'f26605c7-61d2-44ff-984b-cd6d06b259a9' },
      { cc: 'TR', name: 'Turkey', id: '40ae9b2d-a843-4ac2-b3af-ced75e5afe74' },
      {
        cc: 'TM',
        name: 'Turkmenistan',
        id: '59b9571c-99dc-4f4f-95b7-6ddd044203af',
      },
      {
        cc: 'TC',
        name: 'Turks and Caicos Islands',
        id: '4f976370-5ddf-4428-9c6c-312288e3e834',
      },
      { cc: 'TV', name: 'Tuvalu', id: '29f42335-a27b-4a43-97f9-942d83bf5f5c' },
      { cc: 'UG', name: 'Uganda', id: '9a3f9b24-9efb-4ad8-973d-9e8d664fe833' },
      { cc: 'UA', name: 'Ukraine', id: '031708f2-2539-494d-b718-0c687052a758' },
      {
        cc: 'AE',
        name: 'United Arab Emirates',
        id: 'e8ac5cc6-891f-45a6-a0df-00780e37b1e0',
      },
      {
        cc: 'GB',
        name: 'United Kingdom',
        id: '468ca123-7d0c-4ce8-a3ea-3130834ff880',
      },
      {
        cc: 'US',
        name: 'United States',
        id: '0d22dc0a-f388-405a-b8ce-a14a3f208d77',
      },
      {
        cc: 'UM',
        name: 'United States minor outlying islands',
        id: '4a56c960-1ab2-43d0-916b-8acdfd86e0f0',
      },
      { cc: 'UY', name: 'Uruguay', id: '8c38e4d3-23b9-49ad-8a95-3e927b8a3105' },
      {
        cc: 'UZ',
        name: 'Uzbekistan',
        id: 'fc74b851-7380-43dc-b8d7-ba10981c4a7d',
      },
      { cc: 'VU', name: 'Vanuatu', id: '42e5c055-facc-4b95-8414-f4d643bacc53' },
      {
        cc: 'VA',
        name: 'Vatican City State',
        id: '23e48e23-aad6-4075-961b-f2d4c9d07873',
      },
      {
        cc: 'VE',
        name: 'Venezuela',
        id: 'e976f18c-55d9-47e6-95b3-54fcd07c8052',
      },
      { cc: 'VN', name: 'Vietnam', id: '2e4e2be9-7bbc-497e-9739-848932ee981a' },
      {
        cc: 'VG',
        name: 'Virgin Islands (British)',
        id: '31d02a5f-8361-4c94-a797-08e11e378783',
      },
      {
        cc: 'VI',
        name: 'Virgin Islands (U.S.)',
        id: '880a9254-a32a-4589-81ad-c532d3c84291',
      },
      {
        cc: 'WF',
        name: 'Wallis and Futuna Islands',
        id: '983da32e-5d7f-45a4-a376-d1a8de3b2943',
      },
      {
        cc: 'EH',
        name: 'Western Sahara',
        id: '4e6dbd3a-3da9-4e35-ae2c-df8174e0a348',
      },
      { cc: 'YE', name: 'Yemen', id: 'cd1fd751-bb88-414e-b9a7-ba6c0d81c33f' },
      { cc: 'ZR', name: 'Zaire', id: '4e8b64a6-6723-4c65-88c8-5ecff0e7410c' },
      { cc: 'ZM', name: 'Zambia', id: 'c041aabd-dfe0-4169-9555-4f48fb526591' },
      {
        cc: 'ZW',
        name: 'Zimbabwe',
        id: '00b42d28-d8f8-4cfd-a18c-c7b49843ece8',
      },
    ]

    return {
      getAll: getAll,
      getById: getById,
      getByCC: getByCC,
      getSelectOptions: getSelectOptions,
    }

    function getAll() {
      return _.cloneDeep(Countries)
    }

    function getById(id) {
      return _.cloneDeep(_.find(Countries, { id: id }))
    }

    function getByCC(cc) {
      return _.cloneDeep(_.find(Countries, { cc: cc }))
    }

    function getSelectOptions() {
      return _.map(getAll(), function(country) {
        return {
          label: country.name,
          value: country.id,
          promoted: _.includes(['AU', 'GB', 'US'], country.cc),
        }
      })
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$log", "$location", "emailAddressesResource"];
  run.$inject = ["glEmailVerify"];
  angular
    .module('glow.services')
    .factory('glEmailVerify', Service)
    .run(run)

  /* @ngInject */
  function Service($log, $location, emailAddressesResource) {
    var log = $log.create ? $log.create('glEmailVerify') : $log

    return {
      init: init,
    }

    function init() {
      var token = $location.search().emailVerifyToken
      if (token) {
        verifyEmail(token)
      }
    }

    function verifyEmail(token) {
      var data = {
        token: token,
      }
      emailAddressesResource
        .verify(data)
        .success(function() {
          log.debug('verified email with token ' + token)
        })
        .error(function() {
          log.debug("couldn't verify email with token " + token)
        })
    }
  }

  /* @ngInject */
  function run(glEmailVerify) {
    glEmailVerify.init()
  }
})()

;(function() {
  'use strict'

  config.$inject = ["$provide", "$httpProvider"];
  exeptionHandlerDecorator.$inject = ["$delegate", "$injector", "glErrorService"];
  httpInterceptor.$inject = ["$q", "glErrorService"];
  glErrorService.$inject = ["$log", "ravenService"];
  angular
    .module('glow.services')
    .config(config)
    .service('glErrorService', glErrorService)

  /**
   * Whitelist API responses - these errors will not be logged
   */
  var whitelistApiResponses = [
    // usernames returns a 404 when a username does not exist - we do not want to log this
    {
      status: 404,
      pattern: /\/usernames/g,
    },
    {
      status: 404,
      pattern: /\/useremails/g,
    },
    {
      status: 404,
      pattern: /\/email-addresses/g,
    },
    // AI brief polling returns 404 while the brief is still being generated - we do not want to log this
    {
      status: 404,
      pattern: /\/conversation\/.*\/brief/g,
    },
  ]

  /* @ngInject */
  function config($provide, $httpProvider) {
    $provide.decorator('$exceptionHandler', exeptionHandlerDecorator)
    $httpProvider.interceptors.push(httpInterceptor)
  }

  /* @ngInject */
  function exeptionHandlerDecorator($delegate, $injector, glErrorService) {
    // need to inject $location manually to prevent circular reference
    // $location <- $exceptionHandler <- $rootScope
    var $location

    function exceptionHandler(exception, cause) {
      $location = $location || $injector.get('$location')

      var exceptionData = {
        culprit: $location.absUrl(),
        extra: {
          exception: exception,
          cause: cause,
        },
        tags: {
          property: glow.build.property,
          environment: glow.build.env,
          version: glow.build.version,
          commit: glow.build.commit,
        },
      }
      glErrorService.captureException(exception, exceptionData)

      $delegate(exception, cause)
    }

    return exceptionHandler
  }

  /* @ngInject */
  function httpInterceptor($q, glErrorService) {
    return {
      responseError: function(rejection) {
        // There is a huge shitshow of different error formats
        // coming through here. Let's try to normalize them all :'(

        // data *might* be a JSON string
        try {
          rejection.data = JSON.parse(rejection.data)
        } catch (err) {
          // ...
        }

        // data.message *might* be a JSON string
        if (rejection.data && rejection.data.message) {
          try {
            rejection.data.message = JSON.parse(rejection.data.message)
          } catch (err) {
            // ...
          }
        }

        // We will also modify response data to add the status for better error handling
        // within $transitions.onError from failed route resolve functions.
        // This is named __status so that it doesn't collide with canonical responses
        // such as the Dynata API - which uses this field for it's errors
        if (_.isPlainObject(rejection.data)) {
          rejection.data.__status = rejection.status
        }

        // log 4xx and 5xx errors
        if (
          rejection.status &&
          rejection.status >= 400 &&
          !inApiWhitelist(rejection)
        ) {
          var message =
            rejection.config.method +
            ' ' +
            rejection.config.url +
            ' - ' +
            rejection.status +
            ' ' +
            '(' +
            rejection.statusText +
            ')'

          // attempt to parse the json data otherwise
          // just send it as a string
          var data = rejection.config.data
          try {
            data = JSON.parse(data)
          } catch (e) {
            // ...
          }

          var rejectionData = {
            culprit: rejection.config.url,
            extra: {
              status: rejection.status,
              statusText: rejection.statusText,
              url: rejection.config.url,
              method: rejection.config.method,
              headers: rejection.config.headers,
              data: data,
              response: rejection.data,
            },
            tags: {
              property: glow.build.property,
              environment: glow.build.env,
              version: glow.build.version,
              commit: glow.build.commit,
            },
          }

          glErrorService.captureMessage(message, rejectionData)
        }

        return $q.reject(rejection)
      },
    }

    // return true if error status / URL pattern pair match an entry in the whitelistApiResponses array
    function inApiWhitelist(rejection) {
      var response

      for (var i = 0, len = whitelistApiResponses.length; i < len; i++) {
        response = whitelistApiResponses[i]

        if (
          !_.isEmpty(rejection.config.url.match(response.pattern)) &&
          rejection.status === response.status
        ) {
          return true
        }
      }
      return false
    }
  }

  /* @ngInject */
  function glErrorService($log, ravenService) {
    var development = glow.build.env === 'Development'

    var service = {
      captureException: captureException,
      captureMessage: captureMessage,
      setUser: setUser,
      setUserContext: setUserContext,
      lastEventId: lastEventId,
      lastException: lastException,
      setTagsContext: setTagsContext,
    }

    return service

    function captureException(exception, cause) {
      if (development) {
        $log.error('Raven: Exception ', exception, cause)
      } else {
        ravenService.captureException(exception, cause)
      }
    }

    function captureMessage(message, data) {
      if (development) {
        $log.error('Raven: Message ', message, data)
      } else {
        ravenService.captureMessage(message, data)
      }
    }

    function setUser(user) {
      if (development) {
        $log.info('Raven: User ', user)
      } else {
        ravenService.setUser(user)
      }
    }

    function setUserContext(user) {
      if (development) {
        $log.info('Raven: User Context ', user)
      } else {
        ravenService.setUserContext(user)
      }
    }

    function lastEventId() {
      if (development) {
        return 'Raven: Last Event ID'
      } else {
        return ravenService.lastEventId()
      }
    }

    function lastException() {
      if (development) {
        $log.error('Raven: Last Exception')
      } else {
        return ravenService.lastException()
      }
    }

    function setTagsContext(data) {
      if (development) {
        $log.info('Raven: Tags Context ', data)
      } else {
        ravenService.setTagsContext(data)
      }
    }
  }
})()

/* globals google */
;(function() {
  'use strict'

  Service.$inject = ["$q", "mapService", "glAnalytics"];
  angular.module('glow.services').factory('geocodeService', Service)

  /* @ngInject */
  function Service($q, mapService, glAnalytics) {
    var geocoder
    var GoogleAutocompleteService
    var GooglePlacesService

    return {
      searchPlace: searchPlace,
      getPlaceDetails: getPlaceDetails,
      getCountryBounds: getCountryBounds,
      getLocalityFromLocation: getLocalityFromLocation,
      findLocalities: findLocalities,
      localitiesFromLocation: localitiesFromLocation,
      searchNearbyPlaces: searchNearbyPlaces,
      createLocalityObj: createLocalityObj,
    }

    function load() {
      return mapService.load().then(function() {
        geocoder = new google.maps.Geocoder()
        GoogleAutocompleteService = new google.maps.places.AutocompleteService()
        GooglePlacesService = new google.maps.places.PlacesService(
          document.createElement('div')
        ) // HACK: stop doing this.
      })
    }

    function track(action, label) {
      glAnalytics.track('geocode-service', action, label)
    }

    function searchPlace(query, config) {
      return $q(function(resolve) {
        return load().then(function() {
          if (!query) {
            return resolve([])
          }
          var options = {
            input: query,
          }
          if (config) {
            options.types = [config.type] // From API docs "In general only a single type is allowed."
            options.bounds = config.searchBounds // Bounds is ignored if location & radius is specified
            if (config.location) {
              options.location = new google.maps.LatLng({
                lat: config.location.latitude,
                lng: config.location.longitude,
              })
              options.radius = 1000 // 1km
            }
          }
          GoogleAutocompleteService.getPlacePredictions(options, function(
            results
          ) {
            // null is returned if no results. Return an empty array instead for consistency
            resolve(results || [])

            track('autocomplete-service-api', {
              fn: 'searchPlace',
              apiMethod: 'getPlacePredictions',
              query: query,
            })
          })
        })
      })
    }

    function getPlaceDetails(placeId, fields) {
      return $q(function(resolve) {
        return load().then(function() {
          var options = {
            placeId: placeId,
            fields: fields, // if fields not specified, all fields are returned
          }
          GooglePlacesService.getDetails(options, function(result) {
            resolve(result)

            track('places-service-api', {
              fn: 'getPlaceDetails',
              apiMethod: 'getDetails',
              placeId: placeId,
            })
          })
        })
      })
    }

    function getCountryBounds(query) {
      return $q(function(resolve) {
        return load().then(function() {
          if (!query) {
            return resolve()
          }
          var options = {
            address: query,
          }
          geocoder.geocode(options, function(results) {
            var country = _.find(results, function(result) {
              return _.includes(result.types, 'country')
            })
            var bounds = country ? country.geometry.viewport : null
            resolve(bounds)

            track('geocoder-api', {
              fn: 'getCountryBounds',
              apiMethod: 'geocode',
              query: query,
            })
          })
        })
      })
    }

    function getLocalityFromLocation(lat, lng) {
      return $q(function(resolve, reject) {
        return load().then(function() {
          if (!lat || !lng) {
            return reject()
          }
          var options = {
            location: {
              lat: lat,
              lng: lng,
            },
            rankBy: google.maps.places.RankBy.DISTANCE,
            type: 'locality',
          }

          GooglePlacesService.nearbySearch(options, function(results) {
            if (results.length) {
              getPlaceDetails(results[0].place_id).then(function(result) {
                var locality = {}
                _.forEach(result.address_components, function(component) {
                  if (
                    _.includes(component.types, 'administrative_area_level_1')
                  ) {
                    locality.state = component.short_name
                  } else if (_.includes(component.types, 'locality')) {
                    locality.suburb = component.long_name
                  }
                })
                resolve(locality)
              })
            } else {
              resolve()
            }

            track('places-service-api', {
              fn: 'getLocalityFromLocation',
              apiMethod: 'nearbySearch',
            })
          })
        })
      })
    }

    function findLocalities(query, countryCode, restrictionCountryCode) {
      return $q(function(resolve) {
        return load().then(function() {
          if (!query) {
            return resolve([])
          }
          var options = {
            address: query,
            // region biasing - prefers aussie results
            // searching "Melbourne" shows australian city, but you can still search "Melbourne Florida"
            region: countryCode || 'AU',
          }
          if (restrictionCountryCode) {
            options.componentRestrictions = { country: restrictionCountryCode }
          }
          geocoder
            .geocode(options)
            .then(function(results) {
              var localities = filterLocalities(results.results)
              // console.log(JSON.stringify(localities, 0, 2));
              resolve(localities)

              track('geocoder-api', {
                fn: 'findLocalities',
                apiMethod: 'geocode',
                query: query,
              })
            })
            .catch(function(err) {
              // catch error and return empty results
              console.error(err)
              resolve([])
            })
        })
      })
    }

    function localitiesFromLocation(lat, lng) {
      return $q(function(resolve, reject) {
        return load().then(function() {
          if (!lat || !lng) {
            return reject()
          }
          var options = {
            location: {
              lat: lat,
              lng: lng,
            },
          }
          geocoder.geocode(options, function(results) {
            var localities = filterLocalities(results)
            // console.log(JSON.stringify(localities, 0, 2));
            resolve(localities)

            track('geocoder-api', {
              fn: 'localitiesFromLocation',
              apiMethod: 'geocode',
            })
          })
        })
      })
    }

    function searchNearbyPlaces(lat, lng, query, type, radius) {
      return $q(function(resolve, reject) {
        return load().then(function() {
          if (!lat || !lng) {
            return reject()
          }
          var options = {
            location: {
              lat: lat,
              lng: lng,
            },
            keyword: query,
            radius: radius || 50000, // in meters, max 50000
            rankBy: google.maps.places.RankBy.PROMINENCE, // default, radius must be sepciifed
            type: type,
          }

          GooglePlacesService.nearbySearch(options, function(results, status) {
            if (results.length) {
              _.each(results, function(place) {
                // Note: This locality object is incomplete because it is missing the address attribute, which is not included in these results.
                // To retrieve the address, an additional request to get the place details is required. This will be completed upon submission.
                place.locality = createLocalityObj(place)
                place.distance = google.maps.geometry.spherical.computeDistanceBetween(
                  { lat: lat, lng: lng },
                  place.geometry.location
                )
              })
              resolve(results)
            } else {
              resolve()
            }

            track('places-service-api', {
              fn: 'searchNearbyPlaces',
              apiMethod: 'nearbySearch',
              query: query,
              type: type,
            })
          })
        })
      })
    }

    function filterLocalities(results) {
      var localities = []
      _.each(results, function(result) {
        var validTypes = [
          'locality',
          'neighborhood',
          'administrative_area_level_1',
          'administrative_area_level_2',
        ]
        var valid = _.some(validTypes, function(type) {
          return _.includes(result.types, type)
        })
        if (valid) {
          var locality = createLocalityObj(result)
          localities.push(locality)
        }
      })
      return localities
    }

    function createLocalityObj(result) {
      var location = result.geometry.location
      var locality = {
        placeId: result.place_id,
        name: result.name,
        address: result.formatted_address,
        lat: location.lat(),
        lng: location.lng(),
        type: result.types[0],
      }
      if (!locality.name && locality.address) {
        locality.name = locality.address
        delete locality.address
      }
      if (result.address_components) {
        _.each(result.address_components, function(component) {
          if (_.includes(component.types, 'country')) {
            locality.country = component.long_name
          } else if (
            _.includes(component.types, 'administrative_area_level_1')
          ) {
            locality.state = component.long_name
          } else if (
            _.includes(component.types, 'administrative_area_level_2')
          ) {
            locality.city = component.long_name
          } else if (
            _.includes(component.types, 'locality') ||
            _.includes(component.types, 'neighborhood')
          ) {
            locality.suburb = component.long_name
          } else if (_.includes(component.types, 'postal_code')) {
            locality.postcode = component.long_name
          }
        })
        // tiny hack for cities, otherwise suburb=city-name
        // not perfect but works for majority of queries
        if (!locality.city) {
          locality.city = locality.suburb
          delete locality.suburb
        }
      }
      return locality
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.services').factory('hubService', Service)

  /* @ngInject */
  function Service() {
    var Hubs = [
      { id: 'ee757f95-11cb-43d0-bd07-e018ea3b9ce4', label: 'Asia' },
      { id: '01fefcad-72f0-4f2c-b6f4-3568751795a4', label: 'EMEA' },
      { id: '8888ac90-c442-4dc8-974d-eacf5400acc7', label: 'Pacific' },
      { id: '96db6e40-8b7c-4ba8-968a-9552cdf2f57c', label: 'USA' },
    ]

    return {
      getAll: getAll,
      getSelectOptions: getSelectOptions,
    }

    function getAll() {
      return _.cloneDeep(Hubs)
    }

    function getSelectOptions() {
      var options = [{ label: 'None', value: '' }]
      getAll().forEach(function(hub) {
        options.push({ label: hub.label, value: hub.id })
      })
      return options
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "imagesResource"];
  angular.module('glow.services').factory('imageService', Service)

  /* @ngInject */
  function Service($q, imagesResource) {
    return {
      create: create,
    }

    function create(imageData) {
      return $q(function(resolve, reject) {
        imagesResource
          .create({ imageData: imageData })
          .success(function(resp) {
            resolve(resp.imageUrl)
          })
          .error(reject)
      })
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.services').factory('industryService', Service)

  /* @ngInject */
  function Service() {
    var Industries = [
      {
        id: '7c34a5ce-d67a-4cff-9eea-6cbb5cbe7aa1',
        name: 'FMCG',
        groups: [],
        code: 'FMCG',
      },
      {
        id: 'e7090a54-bcad-4b7f-8a9f-c7c6a737b77f',
        name: 'Agriculture, Forestry & Fishing',
        groups: [],
        code: 'AGRICULTURE_FORESTRY_FISHING',
      },
      {
        id: '2f7a15a4-49e2-4133-98c0-34c904a40a0e',
        name: 'Mining',
        groups: [],
        code: 'MINING',
      },
      {
        id: 'ed090ee1-7a4e-468e-b617-7a71c0ae0ec9',
        name: 'Manufacturing',
        groups: [],
        code: 'MANUFACTURING',
      },
      {
        id: '61b420d0-aeee-4ede-a7a5-00296c116b28',
        name: 'Electricity, Gas, Water and Waste Services',
        groups: [],
        code: 'ELECTRICITY_GAS_WATER_WASTE',
      },
      {
        id: 'cd6a4e94-5ab6-41dd-bd6f-352b597046e7',
        name: 'Construction',
        groups: [],
        code: 'CONSTRUCTION',
      },
      {
        id: '4d6af81c-ffea-4bd9-84e2-2059a9ac46da',
        name: 'Wholesale Trade',
        groups: [],
        code: 'WHOLESALE',
      },
      {
        id: 'e5406191-d4a5-41d1-b62e-da0727f481e6',
        name: 'Retail Trade',
        groups: [],
        code: 'RETAIL',
      },
      {
        id: '36df42e0-2020-4934-a3d8-137840c856f2',
        name: 'Accommodation and Food Services',
        groups: [],
        code: 'ACCOM_AND_FOOD',
      },
      {
        id: '8e286302-c989-4ef9-b36a-028ac1c4abf6',
        name: 'Transport, Postal and Warehousing',
        groups: [],
        code: 'TRNASPORT_POSTAL_WAREHOUSING',
      },
      {
        id: '95e91282-566f-4f9d-aa34-cc009b24fdb2',
        name: 'Information Media and Telecommunications',
        groups: [],
        code: 'INFO_MEDIA_TELECOM',
      },
      {
        id: '86fc0da5-b3c4-42b4-b791-1b39b2863dfb',
        name: 'Financial and Insurance Services',
        groups: [],
        code: 'FINANCIAL_INSURANCE',
      },
      {
        id: '2a6b157f-2495-4a52-aec5-d3c4d13e261a',
        name: 'Rental, Hiring and Real Estate Services',
        groups: [],
        code: 'RENTAL_HIRING_REAL_ESTATE',
      },
      {
        id: '88ab9b49-7360-4d2d-9878-467690b5c3e2',
        name: 'Professional, Scientific and Technical Services',
        groups: [],
        code: 'PROF_SCIENTIFIC_TECHNICAL',
      },
      {
        id: '9e77844a-645d-4a36-bc23-dc2fbf051879',
        name: 'Administrative and Support Services',
        groups: [],
        code: 'ADMIN_SUPPORT',
      },
      {
        id: '5b09771f-7cd4-4788-b14f-ccf9fc5902d5',
        name: 'Public Administration and Safety',
        groups: [],
        code: 'PUBLIC_ADMIN_SAFETY',
      },
      {
        id: '0a0a4890-39da-4776-aced-d433f119cd83',
        name: 'Education and Training',
        groups: [],
        code: 'EDUCATION',
      },
      {
        id: 'd6e30c5a-c4da-41c6-a4ad-c502273be384',
        name: 'Health Care and Social Assistance',
        groups: [],
        code: 'HEALTH_SOCIAL_ASSIST',
      },
      {
        id: '1fff9536-4cae-42f1-b121-bc5d0ca83ce5',
        name: 'Arts and Recreation Services',
        groups: [],
        code: 'ARTS_RECREATION',
      },
      {
        id: '233ef9ce-ae4e-48b4-a22e-243f4059fc16',
        name: 'Other Services',
        groups: [],
        code: 'OTHER',
      },
    ]

    return {
      getAll: getAll,
      getById: getById,
      getByCode: getByCode,
    }

    function getAll() {
      return _.cloneDeep(Industries)
    }

    function getById(id) {
      return _.cloneDeep(_.find(Industries, { id: id }))
    }

    function getByCode(code) {
      return _.cloneDeep(_.find(Industries, { code: code }))
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.services').factory('jobRoleService', Service)

  /* @ngInject */
  function Service() {
    var JobRoles = [
      {
        id: '7e5543a6-d886-478b-bc3f-e25969c25bcc',
        name: 'Account Manager / Sales',
        code: 'ACCOUNT_MGR_SALES',
      },
      {
        id: 'e0b0bbbe-44de-40d9-b32c-451ccd9aa411',
        name: 'Advertising and Promotions',
        code: 'ADVERTISING',
      },
      {
        id: '0f99a7a6-7705-40b8-aeb2-82db83c66db6',
        name: 'Brand Manager',
        code: 'BRAND_MANAGER',
      },
      {
        id: '81e2b033-4cd1-41a1-952e-50178873f6a6',
        name: 'Business Owner',
        code: 'BUSINESS_OWNER',
      },
      {
        id: '0b38f90c-c3d3-4c91-bc32-618fd20f5acd',
        name: 'Business Consultant',
        code: 'BUSINESS_CONSULTANT',
      },
      {
        id: '845847b2-10d4-42d8-9284-97123d5dba0f',
        name: 'Customer Service',
        code: 'CUSTOMER_SERVICE',
      },
      {
        id: '36b4f4f3-1e71-4a80-9f3c-b811a6392f9d',
        name: 'Finance',
        code: 'FINANCE',
      },
      {
        id: 'a400aa7d-523d-4c45-983d-eec7c827e736',
        name: 'General Manager',
        code: 'GENERAL_MANAGER',
      },
      {
        id: '0b8c25f4-d4e1-40ac-ab28-22cb8b4518e9',
        name: 'Intern',
        code: 'INTERN',
      },
      {
        id: '0814e742-eb2e-4fa3-a913-843e434beed9',
        name: 'Media / Journalist',
        code: 'MEDIA_JOURNALIST',
      },
      {
        id: 'a6ae007c-15f3-46a3-8ea6-c85b30067b58',
        name: 'Manager',
        code: 'MANAGER',
      },
      {
        id: '204c9896-9c2f-404c-b753-04ea9a26e0ca',
        name: 'People and Culture / HR',
        code: 'PEOPLE_CULTURE_HUMAN_RESOURCES',
      },
      {
        id: '4f6f7e84-8a94-42bf-aac6-62ae50a076be',
        name: 'Product Manager',
        code: 'PRODUCT_MANAGER',
      },
      {
        id: '5b4988f1-fe3b-497b-86ee-0cd38f9abd7d',
        name: 'Procurement / Purchasing',
        code: 'PROCUREMENT_PURCHASING',
      },
      {
        id: 'a70a5641-f3ab-40f9-ab03-f68b88db0948',
        name: 'Research Analyst',
        code: 'RESEARCH_ANALYST',
      },
      {
        id: '3101d4dd-1128-4561-856e-d55e5483e673',
        name: 'Research Manager',
        code: 'RESEARCH_MANAGER',
      },
      {
        id: '850544bf-50be-456a-ba76-41d8f20741c5',
        name: 'Student',
        code: 'STUDENT',
      },
      {
        id: '55129558-2c81-4534-a5cd-330ed4e4a693',
        name: 'Technology',
        code: 'TECHNOLOGY',
      },
      {
        id: '106ccf80-275f-41d9-be3b-733e5ff2af52',
        name: 'Other',
        code: 'OTHER',
      },
    ]

    return {
      getAll: getAll,
      getById: getById,
      getByCode: getByCode,
    }

    function getAll() {
      return _.cloneDeep(JobRoles)
    }

    function getById(id) {
      return _.cloneDeep(_.find(JobRoles, { id: id }))
    }

    function getByCode(code) {
      return _.cloneDeep(_.find(JobRoles, { code: code }))
    }
  }
})()

;(function() {
  'use strict'

  keyEventService.$inject = ["$document"];
  angular.module('glow.services').service('keyEventService', keyEventService)

  /* @ngInject */
  function keyEventService($document) {
    var keys = {
      enter: 13,
      escape: 27,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
    }

    var registeredEvents = [
      /* {
                hash: 'time:key hash',
                keyToPress: 13,
                priority: 100,
                callback: function() {...}
            } */
    ]

    $document.bind('keydown', function(event) {
      // FIX: IE11 doesnt have `event.path`
      // TODO: this fixes the error but prevents keyEventService running on IE11
      if (!event || !event.path || !event.path.length) {
        return // return if no event.path
      }

      if (
        event.path[0].nodeName === 'INPUT' ||
        event.path[0].nodeName === 'TEXTAREA'
      ) {
        return false
      }

      reactToKeyEvent(event.keyCode)
    })

    function registerKeyEvent(keyToPress, callback, priority) {
      if (
        typeof keyToPress === 'undefined' ||
        typeof callback === 'undefined'
      ) {
        return
      }

      if (typeof priority !== 'number') {
        priority = 10
      }

      var handle = {
        hash: new Date().getTime() + ':' + keyToPress,
        keyToPress: keyToPress,
        priority: priority,
        callback: callback,
      }
      registeredEvents.push(handle)

      return handle.hash
    }

    function unregisterKeyEvent(hash) {
      var handlers = _.filter(registeredEvents, { hash: hash })
      if (handlers.length === 0) {
        return
      }

      _.forEach(handlers, function(h) {
        registeredEvents.splice(_.findIndex(registeredEvents, h), 1)
      })
    }

    function reactToKeyEvent(keyCode) {
      var keyHandlers = _.filter(registeredEvents, { keyToPress: keyCode })
      if (keyHandlers.length === 0) {
        return
      }

      var highestPriorityHandler = _.maxBy(keyHandlers, function(h) {
        return h.priority
      })

      var highestPriorityHandlerIndex = _.findIndex(
        keyHandlers,
        highestPriorityHandler
      )
      highestPriorityHandler.callback()

      registeredEvents.splice(highestPriorityHandlerIndex, 1)
    }

    return {
      KEY: keys,
      registerKeyEvent: registerKeyEvent,
      unregisterKeyEvent: unregisterKeyEvent,
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "kitsResource", "kitFactory"];
  angular.module('glow.services').factory('kitsService', Service)

  /* @ngInject */
  function Service($q, kitsResource, kitFactory) {
    return {
      getByOwner: getByOwner,
      getAll: getAll,
      getById: getById,
      getAssignedKits: getAssignedKits,
      getByContentGroup: getByContentGroup,
      giveToContentGroup: giveToContentGroup,
      takeFromContentGroup: takeFromContentGroup,
      deleteKit: deleteKit,
      assignKitsToSurvey: assignKitsToSurvey,
      assignKitsToQuestionTemplate: assignKitsToQuestionTemplate,
    }

    function getByOwner(ownerId) {
      return $q(function(resolve, reject) {
        kitsResource
          .getKitsByOwner({ ownerId: ownerId })
          .success(function(x, data) {
            var kits = _.map(data, function(kit) {
              return kitFactory.create().fromServer(kit)
            })
            resolve(kits)
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function getAll() {
      return $q(function(resolve, reject) {
        kitsResource
          .get()
          .success(function(x, data) {
            var kits = _.map(data, function(kit) {
              return kitFactory.create().fromServer(kit)
            })
            resolve(kits)
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function getById(kitId) {
      return $q(function(resolve, reject) {
        if (!kitId) {
          var kit = kitFactory.create()
          return resolve(kit)
        }

        kitsResource
          .get({ id: kitId })
          .success(function(x, data) {
            var kit = kitFactory.create().fromServer(data)
            resolve(kit)
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function getAssignedKits(groupId) {
      return $q(function(resolve, reject) {
        kitsResource
          .getKitsByGroup({ groupId: groupId })
          .success(function(x, data) {
            var kits = _.map(data, function(kit) {
              return kitFactory.create().fromServer(kit)
            })
            resolve(kits)
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function getByContentGroup(contentGroupId) {
      return $q(function(resolve, reject) {
        kitsResource
          .getKitsByContentGroup({ contentGroupId: contentGroupId })
          .success(function(x, data) {
            var kits = _.map(data, function(kit) {
              return kitFactory.create().fromServer(kit)
            })
            resolve(kits)
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function giveToContentGroup(contentGroupId, kitId) {
      return $q(function(resolve, reject) {
        kitsResource
          .assignContentGroup({ contentGroupId: contentGroupId, id: kitId })
          .success(resolve)
          .error(function(error) {
            reject(error)
          })
      })
    }

    function takeFromContentGroup(contentGroupId, kitId) {
      return $q(function(resolve, reject) {
        kitsResource
          .removeContentGroup({ contentGroupId: contentGroupId, id: kitId })
          .success(resolve)
          .error(function(error) {
            reject(error)
          })
      })
    }

    function deleteKit(kitId) {
      return $q(function(resolve, reject) {
        if (!kitId) {
          reject()
        }

        kitsResource
          .delete({ id: kitId })
          .success(function() {
            resolve()
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function assignKitsToSurvey(surveyTemplateId, currentKits, selectedKits) {
      var promises = []

      var addedKits = getAddedKits(currentKits, selectedKits)
      var removedKits = getRemovedKits(currentKits, selectedKits)

      _.each(addedKits, function(kit) {
        promises.push(
          promisify(
            kitsResource.assignSurveyTemplate({
              id: kit.id,
              surveyTemplateId: surveyTemplateId,
            })
          )
        )
      })

      _.each(removedKits, function(kit) {
        promises.push(
          promisify(
            kitsResource.unAssignSurveyTemplate({
              id: kit.id,
              surveyTemplateId: surveyTemplateId,
            })
          )
        )
      })

      return $q.all(promises)
    }

    function assignKitsToQuestionTemplate(
      questionTemplateId,
      currentKits,
      selectedKits
    ) {
      var promises = []

      var addedKits = getAddedKits(currentKits, selectedKits)
      var removedKits = getRemovedKits(currentKits, selectedKits)

      _.each(addedKits, function(kit) {
        promises.push(
          promisify(
            kitsResource.assignQuestionTemplate({
              id: kit.id,
              questionTemplateId: questionTemplateId,
            })
          )
        )
      })

      _.each(removedKits, function(kit) {
        promises.push(
          promisify(
            kitsResource.unAssignQuestionTemplate({
              id: kit.id,
              questionTemplateId: questionTemplateId,
            })
          )
        )
      })

      return $q.all(promises)
    }

    function getAddedKits(currentKits, selectedKits) {
      return _.filter(selectedKits, function(kit) {
        return !_.find(currentKits, { id: kit.id })
      })
    }

    function getRemovedKits(currentKits, selectedKits) {
      return _.filter(currentKits, function(kit) {
        return !_.find(selectedKits, { id: kit.id })
      })
    }

    function promisify(resource) {
      return $q(function(resolve, reject) {
        return resource.success(resolve).error(reject)
      })
    }
  }
})()

/* globals self */
;(function() {
  'use strict'

  var ngModule
  try {
    ngModule = angular.module('glow.services')
  } catch (ModuleNotFoundError) {
    ngModule = angular.module('glow.services', [])
  }

  ngModule.provider('$log', $log)

  /*
   * @name $logProvider
   * @description
   * Override's Angular $log provider to configure how the application logs messages
   *
   * @ngInject */
  function $log() {
    var debug = true
    var enabled = 2
    var production = false

    // valid log levels
    var logLevels = [0, 1, 2]

    // namespaces to filter by
    var filtered = []

    // namespaces to ignore
    var ignored = []

    // levels at which logs are enabled
    var logLevelHash = {
      error: 0,
      warn: 0,
      info: 1,
      log: 1,
      debug: 2,
    }

    /**
     * if glow build exists and environment is production, force log level to 0
     */
    if (window.glow.build.env === 'Production') {
      production = true
      enabled = 0
    }

    /**
     * @name $logProvider#isEnabled
     * @descirption determine if log function is enabled based on current logLevel
     * @param {Number=} key name of log function
     * @return {Boolean} true if key exists and should be enabled at this log level
     */
    function isEnabled(key) {
      return logLevelHash[key] !== undefined && logLevelHash[key] <= enabled
    }

    /**
     * @name $logProvider#debugEnabled
     * @description enable debug logs: for backwards compatibility with angular's $log provider
     * @param {Boolean=} flag enable or disable debug level messages
     * @return {*} current value if used as a getter or itself (chaining) if used as a setter
     */
    this.debugEnabled = function(flag) {
      if (angular.isDefined(flag)) {
        debug = flag
        return this
      } else {
        return debug
      }
    }

    /**
     * @name $logProvider#logLevel
     * @description set log level
     * @param {Number=} level [ 0, 1, 2 ]
     * @return {*} current value if used as a getter or itself (chaining) if used as a setter
     */
    this.logLevel = function(level) {
      if (angular.isDefined(level)) {
        if (_.indexOf(logLevels, level) === -1 || production) {
          // not a valid level or production mode so cannot set log level
          return
        }
        enabled = level
        return this
      } else {
        return enabled
      }
    }

    /**
     * @name $logProvider#ignore
     * @description ignore the given namespace(s)
     * @param {[]} namespaces a namespace or array of namespaces to ignore
     */
    this.ignore = function(namespaces) {
      if (typeof namespaces === 'string') {
        namespaces = [namespaces]
      }
      ignored = ignored.concat(namespaces)
    }

    /**
     * @name $logProvider#filter
     * @description filter logs by given namespace(s) - once set any logs not matched by the filters are suppressed.
     * @param {[]} namespaces a namespace or array of namespaces to filter by
     */
    this.filter = function(namespaces) {
      if (typeof namespaces === 'string') {
        namespaces = [namespaces]
      }
      filtered = filtered.concat(namespaces)
    }

    this.$get = ["$window", "ravenService", function($window, ravenService) {
      return {
        /**
         * @name $log#log
         * @description write a log message
         */
        log: (function() {
          return function() {
            if (isEnabled('log')) {
              consoleLog('log').apply(self, arguments)
            }
          }
        })(),

        /**
         * @name $log#info
         * @description write an information message
         */
        info: (function() {
          return function() {
            if (isEnabled('info')) {
              consoleLog('info').apply(self, arguments)
            }
          }
        })(),

        /**
         * @name $log#warn
         * @description write a warning message
         */
        warn: (function() {
          return function() {
            if (isEnabled('warn')) {
              consoleLog('warn').apply(self, arguments)
            }
          }
        })(),

        /**
         * @name $log#error
         * @description write an error message
         */
        error: (function() {
          return function() {
            // log error message to sentry
            if (arguments[0] && _.isString(arguments[0])) {
              var logMessage = '$log.error: ' + arguments[0] + arguments[1]
              ravenService.captureMessage(logMessage)
            }

            if (isEnabled('error')) {
              consoleLog('error').apply(self, arguments)
            }
          }
        })(),

        /**
         * @name $log#debug
         * @description write a debug message
         */
        debug: (function() {
          return function() {
            if (debug && isEnabled('debug')) {
              consoleLog('debug').apply(self, arguments)
            }
          }
        })(),

        /**
         * @name $log#create
         * @description create a namespaced instance of the $log service
         * @param {String} namespace to prepend to log messages
         * @return {Object} new $log service with namespaced messages
         */
        create: function(namespace) {
          return {
            log: namespaceFn(this.log, namespace),
            info: namespaceFn(this.info, namespace),
            warn: namespaceFn(this.warn, namespace),
            error: namespaceFn(this.error, namespace),
            debug: namespaceFn(this.debug, namespace),
          }
        },
      }

      function namespaceFn(logFn, namespace) {
        return function() {
          var args = Array.prototype.slice.call(arguments)

          args.unshift(namespace + ':: ')

          logFn.apply(null, args)
        }
      }

      function formatError(arg) {
        if (arg instanceof Error) {
          if (arg.stack) {
            arg =
              arg.message && arg.stack.indexOf(arg.message) === -1
                ? 'Error: ' + arg.message + '\n' + arg.stack
                : arg.stack
          } else if (arg.sourceURL) {
            arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line
          }
        }
        return arg
      }

      function logValid(args) {
        var namespace

        // check for namespace
        if (args.length > 0 && !_.isObject(args[0])) {
          namespace = args[0].substr(0, args[0].indexOf('::'))

          // invalid if ignored
          if (_.indexOf(ignored, namespace) !== -1) {
            return false
          }

          // if filtered logs, check if namespace is part of filter
          if (filtered.length > 0) {
            return _.indexOf(filtered, namespace) !== -1 ? true : false
          }
        }

        // un-namespaced logs always valid unless filter exists
        if (filtered.length === 0) {
          return true
        }
      }

      function consoleLog(type) {
        var console = $window.console || {}
        var logFn = console[type] || console.log || angular.noop
        var hasApply = false

        // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
        // The reason behind this is that console.log has type "object" in IE8...
        try {
          hasApply = !!logFn.apply
        } catch (e) {
          // do nothing
        }

        if (hasApply) {
          return function() {
            var args = []

            angular.forEach(arguments, function(arg) {
              args.push(formatError(arg))
            })

            if (logValid(args)) {
              return logFn.apply(console, args)
            }
          }
        }

        // we are IE which either doesn't have window.console => this is noop and we do nothing,
        // or we are IE where console.log doesn't have apply so we log at least first 2 args
        return function(arg1, arg2) {
          logFn(arg1, arg2 === null ? '' : arg2)
        }
      }
    }]
  }
})()

;(function() {
  'use strict'

  angular.module('glow.services').factory('numericService', Service)

  /* @ngInject */
  function Service() {
    var num = new Intl.NumberFormat()
    var percent = new Intl.NumberFormat({ style: 'percent' })
    var dollar = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    })
    var pound = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
    })

    var Units = {
      NUMBER: 'number',
      NUMBER_PURE: 'number-pure',
      PERCENT: 'percent',
      CUSTOM: 'custom',
      CURRENCY_DOLLAR: 'currency-dollar',
      CURRENCY_POUND: 'currency-pound',
      TIME_MINUTE: 'time-minute',
      TIME_HOUR: 'time-hour',
      TIME_DAY: 'time-day',
      TIME_WEEK: 'time-week',
      TIME_MONTH: 'time-month',
      TIME_YEAR: 'time-year',
      MASS_GRAM: 'mass-gram',
      MASS_KILOGRAM: 'mass-kilogram',
    }

    return {
      calculateValues: calculateValues,
      getUnit: getUnit,
      getUnits: getUnits,
      round: round,
      Units: Units,
    }

    function calculateValues(min, max, steps, unitType, labels) {
      var inc = (max - min) / steps
      var unit = getUnit(unitType)
      var values = []
      _.times(steps, function(i) {
        var value = round(min + i * inc)
        values.push({
          label: unit.parse(value, i, labels),
          number: value,
        })
      })

      values.push({
        label: unit.parse(max, steps, labels),
        number: max,
      })

      return values
    }

    function getUnit(type) {
      return _.find(getUnits(), { type: type })
    }

    function getUnits() {
      return [
        {
          type: Units.NUMBER,
          label: 'Number',
          group: 'General',
          parse: function(val) {
            return num.format(val)
          },
        },
        {
          type: Units.NUMBER_PURE,
          label: 'Number (no formatting)',
          group: 'General',
          parse: function(val) {
            return val.toString()
          },
        },
        {
          type: Units.PERCENT,
          label: 'Percent',
          group: 'General',
          parse: function(val) {
            return percent.format(val) + '%'
          },
        },
        {
          type: Units.CUSTOM,
          label: 'Custom',
          group: 'General',
          parse: function(val, step, labels) {
            // step/labels isn't provided for numeric stats
            // because custom labels don't apply here
            // just return the number
            if (!step && !labels) {
              return val.toString()
            }
            return labels[step] || val.toString()
          },
        },
        {
          type: Units.CURRENCY_DOLLAR,
          label: 'Dollar ($)',
          group: 'Currency',
          parse: function(val) {
            return dollar.format(val)
          },
        },
        {
          type: Units.CURRENCY_POUND,
          label: 'Pound (£)',
          group: 'Currency',
          parse: function(val) {
            return pound.format(val)
          },
        },
        {
          type: Units.TIME_MINUTE,
          label: 'Minute',
          group: 'Time',
          parse: function(val) {
            return val + (val !== 1 ? ' minutes' : ' minute')
          },
        },
        {
          type: Units.TIME_HOUR,
          label: 'Hour',
          group: 'Time',
          parse: function(val) {
            return val + (val !== 1 ? ' hours' : ' hour')
          },
        },
        {
          type: Units.TIME_DAY,
          label: 'Day',
          group: 'Time',
          parse: function(val) {
            return val + (val !== 1 ? ' days' : ' day')
          },
        },
        {
          type: Units.TIME_WEEK,
          label: 'Week',
          group: 'Time',
          parse: function(val) {
            return val + (val !== 1 ? ' weeks' : ' week')
          },
        },
        {
          type: Units.TIME_MONTH,
          label: 'Month',
          group: 'Time',
          parse: function(val) {
            return val + (val !== 1 ? ' months' : ' month')
          },
        },
        {
          type: Units.TIME_YEAR,
          label: 'Year',
          group: 'Time',
          parse: function(val) {
            return val + (val !== 1 ? ' years' : ' year')
          },
        },
        {
          type: Units.MASS_GRAM,
          label: 'Gram',
          group: 'Mass',
          parse: function(val) {
            return val + 'g'
          },
        },
        {
          type: Units.MASS_KILOGRAM,
          label: 'Kilogram',
          group: 'Mass',
          parse: function(val) {
            return val + 'kg'
          },
        },
      ]
    }

    function round(num) {
      return Math.round(num * 100) / 100
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "opportunitiesResource"];
  angular.module('glow.services').factory('opportunityService', Service)

  /* @ngInject */
  function Service($q, opportunitiesResource) {
    var Defaults = {
      businessName: ' ',
      businessAddress: ' ',
      businessCity: ' ',
      businessState: ' ',
      firstName: ' ',
      lastName: ' ',
      role: ' ',
      phoneNumber: ' ',
      email: ' ',
    }

    return {
      send: send,
    }

    function send(data) {
      return $q(function(resolve, reject) {
        _.defaults(data, Defaults)
        opportunitiesResource
          .create(data)
          .success(resolve)
          .error(reject)
      })
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$location", "glUtils"];
  angular.module('glow.services').factory('paramService', Service)

  /* @ngInject */
  function Service($location, glUtils) {
    var IS_NESTED_PARAM = /^[\S]+?(?=\[)\[[\S]+?(?=\])\]$/
    var NESTED_PARAM_ROOT = /^[\S]+?(?=\[)/
    var NESTED_PARAM_SUB = /\[([\S]+?(?=\]))/

    return {
      get: get,
      objToFloppy: objToFloppy,
    }

    function get(options, url) {
      var originalParams = url
        ? glUtils.getQueryParams(url)
        : $location.search()
      var params = {}

      options = _.defaults(options, {
        floppyKeys: [],
      })

      _.each(originalParams, function(value, key) {
        // parse nested params
        // eg: `foo[bar]=baz` into params.foo.bar = baz
        if (IS_NESTED_PARAM.test(key)) {
          var root = key.match(NESTED_PARAM_ROOT)[0]
          var sub = key.match(NESTED_PARAM_SUB)[1]
          params[root] = params[root] || {}
          params[root][sub] = value

          // normal params
        } else {
          params[key] = value
        }
      })

      _.each(options.floppyKeys, function(key) {
        params[key] = objToFloppy(params[key])
      })

      return params
    }

    function objToFloppy(object) {
      var floppy = []

      _.each(object, function(value, key) {
        var p = {}
        p[key] = value
        floppy.push(p)
      })

      return _.isEmpty(floppy) ? undefined : floppy
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.services').factory('placeTypeService', Service)

  /* @ngInject */
  function Service() {
    // https://developers.google.com/maps/documentation/places/web-service/supported_types
    var PlaceTypes = [
      'accounting',
      'airport',
      'amusement_park',
      'aquarium',
      'art_gallery',
      'atm',
      'bakery',
      'bank',
      'bar',
      'beauty_salon',
      'bicycle_store',
      'book_store',
      'bowling_alley',
      'bus_station',
      'cafe',
      'campground',
      'car_dealer',
      'car_rental',
      'car_repair',
      'car_wash',
      'casino',
      'cemetery',
      'church',
      'city_hall',
      'clothing_store',
      'convenience_store',
      'courthouse',
      'dentist',
      'department_store',
      'doctor',
      'drugstore',
      'electrician',
      'electronics_store',
      'embassy',
      'fire_station',
      'florist',
      'funeral_home',
      'furniture_store',
      'gas_station',
      'gym',
      'hair_care',
      'hardware_store',
      'hindu_temple',
      'home_goods_store',
      'hospital',
      'insurance_agency',
      'jewelry_store',
      'laundry',
      'lawyer',
      'library',
      'light_rail_station',
      'liquor_store',
      'local_government_office',
      'locksmith',
      'lodging',
      'meal_delivery',
      'meal_takeaway',
      'mosque',
      'movie_rental',
      'movie_theater',
      'moving_company',
      'museum',
      'night_club',
      'painter',
      'park',
      'parking',
      'pet_store',
      'pharmacy',
      'physiotherapist',
      'plumber',
      'police',
      'post_office',
      'primary_school',
      'real_estate_agency',
      'restaurant',
      'roofing_contractor',
      'rv_park',
      'school',
      'secondary_school',
      'shoe_store',
      'shopping_mall',
      'spa',
      'stadium',
      'storage',
      'store',
      'subway_station',
      'supermarket',
      'synagogue',
      'taxi_stand',
      'tourist_attraction',
      'train_station',
      'transit_station',
      'travel_agency',
      'university',
      'veterinary_care',
      'zoo',
    ]

    return {
      getAll: getAll,
      getSelectOptions: getSelectOptions,
    }

    function getAll() {
      return _.cloneDeep(PlaceTypes)
    }

    function getSelectOptions() {
      return _.map(getAll(), function(type) {
        return {
          label: type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
          value: type,
          promoted: _.includes(['store', 'supermarket', 'restaurant'], type),
        }
      })
    }
  }
})()

;(function() {
  'use strict'

  /*
   * @name glPrefs
   *
   * Utility module to get, set and remove preferences in localStorage. Preferences automatically handle
   * environment specific keys, with the ability to set namespaces, per-user values and
   * expiry dates. It also falls back to in-memory storage in cases where localStorage is not available (eg Safari
   * in private mode).
   *
   */

  Service.$inject = ["$window", "$log", "configService"];
  angular.module('glow.services').factory('glPrefs', Service)

  /* @ngInject */
  function Service($window, $log, configService) {
    var log = $log.create ? $log.create('glPrefs') : $log
    var base64Regex = new RegExp(
      '^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$'
    )

    var environment = configService.getBuildEnv()
    var localStorageEnabled = isLocalStorageEnabled()
    var preferencesCache = {}
    var memoryStorage = {}
    var userId

    return {
      create: create,
      setUser: setUser,
      localStorageEnabled: localStorageEnabled,
    }

    /*
     * @name create
     * @desc create a preference interface
     *
     * @param  {String}          namespace   a namespace value to prevent cross-module collisions
     * @return {Preferences}     prefs       the interface to get, set and remove preferences
     */
    function create(namespace) {
      if (!namespace) {
        throw new Error('tried to instantiate glPrefs without a namespace')
      }
      if (!preferencesCache[namespace]) {
        preferencesCache[namespace] = new Preferences(namespace)
      }
      return preferencesCache[namespace]
    }

    /*
     * @name setUser
     * @desc set the user id for user specific preferences
     * @param {String} id  the id of the user
     */
    function setUser(id) {
      userId = id
      log.debug('setUser', id)
    }

    function Preferences(namespace) {
      this.set = function(key, data, options) {
        options = options || {}
        key = makeTransactionalKey(key, options)

        if (data === undefined || data === null) {
          return removeStorageItem(key)
        }

        var pref = {}
        pref.expiry = makeExpiry(options.expiry)
        pref.data = data

        try {
          pref = btoa(JSON.stringify(pref))
        } catch (e) {
          // do nothing
        }

        setStorageItem(key, pref)
      }

      this.get = function(key, options) {
        options = options || {}
        key = makeTransactionalKey(key, options)

        var pref = getStorageItem(key)

        if (!pref) {
          return
        }

        // gracefully accept old glPrefs which were not base64 encoded
        if (!isBase64(pref)) {
          pref = btoa(pref)
        }

        try {
          pref = JSON.parse(atob(pref))
        } catch (e) {
          // do nothing
        }

        if (pref.expiry && isExpired(pref.expiry)) {
          return removeStorageItem(key)
        }

        return pref.data
      }

      this.getExpiryHours = function(key, options) {
        options = options || {}
        key = makeTransactionalKey(key, options)

        var pref = getStorageItem(key)

        if (pref) {
          try {
            pref = JSON.parse(pref)
          } catch (e) {
            // do nothing
          }

          if (pref.expiry && !isExpired(pref.expiry)) {
            var expireDate = moment(pref.expiry)
            var nowDate = moment()
            return Math.round(
              moment.duration(expireDate.diff(nowDate)).asHours()
            )
          }
        }
      }

      function makeExpiry(expiry) {
        var expiryString
        if (expiry && _.includes(expiry, ' ')) {
          var amount = expiry.split(' ')[0]
          var type = expiry.split(' ')[1]
          expiryString = moment()
            .add(amount, type)
            .toISOString()
        }
        return expiryString
      }

      function isExpired(expiry) {
        if (!expiry) {
          return false
        }
        return moment(expiry).isBefore(moment())
      }

      function getStorageItem(key) {
        if (localStorageEnabled) {
          return localStorage.getItem(key)
        } else {
          return memoryStorage[key]
        }
      }

      function setStorageItem(key, value) {
        if (localStorageEnabled) {
          localStorage.setItem(key, value)
        } else {
          memoryStorage[key] = value
        }
      }

      function removeStorageItem(key) {
        if (localStorageEnabled) {
          localStorage.removeItem(key)
        } else {
          memoryStorage[key] = undefined
        }
      }

      /*
       * @name makeTransactionalKey
       * @desc generates the transactional key, taking into account the environment, namespace and options.
       * @param {String} key The raw key name
       * @param {Object} options
       * @return {String} transKey The usable key for localStorage transactions
       */
      function makeTransactionalKey(key, options) {
        options = options || {}

        var transKey =
          environment + '-' + namespace + '-' + getUserId() + '-' + key

        return transKey

        function getUserId() {
          if (options.user === true && userId) {
            return userId
          }
          return '0' // no user
        }
      }
    }

    /*
     * Code borrowed from [angular-local-storage]
     * (https://github.com/grevory/angular-local-storage/blob/master/src/angular-local-storage.js#L87)
     */
    function isLocalStorageEnabled() {
      var supported
      try {
        var testKey = '__' + Math.round(Math.random() * 1e7)
        supported =
          'localStorage' in $window && $window['localStorage'] !== null
        // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage
        // is available, but trying to call .setItem throws an exception.
        //
        // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage
        // that exceeded the quota."
        if (supported) {
          localStorage.setItem(testKey, '')
          localStorage.removeItem(testKey)
        }
      } catch (e) {
        supported = false
      }
      log.debug('localStorage=' + supported)
      return supported
    }

    function isBase64(string) {
      return base64Regex.test(string)
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "surveysResource", "glUtils"];
  angular.module('glow.services').factory('promotionsService', Service)

  /* @ngInject */
  function Service($q, surveysResource, glUtils) {
    var DefaultResponseCost = 100
    var DefaultExitCost = 100

    return {
      getInfo: getInfo,
      updateSurveyTransaction: updateSurveyTransaction,
      verifyUserTransaction: verifyUserTransaction,
    }

    function getInfo(costPerResponse, costPerExit) {
      var responseEntries = makeEntries(costPerResponse || DefaultResponseCost)
      var exitEntries = makeEntries(costPerExit || DefaultExitCost)

      return {
        progressText: 'Feed & Win!',
        introCtaText: 'Complete this survey to Feed & Win!',
        introFeedText: makeFeedText(responseEntries),
        introWinText: makeWinText(responseEntries),
        outroTitle: 'Reward yourself!',
        outroFeedTextResponse:
          'Thank you for taking our survey. ' + makeFedText(responseEntries),
        outroFeedTextExit:
          "Thank you but unfortunately you don't qualify to complete this survey. " +
          'Not to worry - you still fed someone in need!',
        outroWinTextResponse: makeWinText(responseEntries),
        outroWinTextExit: makeWinText(exitEntries),
        outroSubmitButton: 'Count Me In!',
        outroOptoutText: "No Thanks, I'm Good",
        confirmTitle: 'Your entry has been confirmed. Good Luck!',
      }
    }

    // 1 entry per $1USD of response or exit
    // Assume cost will always be multiples of 100
    function makeEntries(cost) {
      return Math.round(cost / 100)
    }

    function makeWinText(entries) {
      return (
        'Get ' +
        entries +
        glUtils.numberSwitch(entries, ' entry', ' entries') +
        ' into our monthly draw to win one of several amazing prizes!'
      )
    }

    function makeFeedText(entries) {
      return (
        'Feed ' +
        entries +
        glUtils.numberSwitch(entries, ' person', ' people') +
        ' in need'
      )
    }

    function makeFedText(entries) {
      return (
        'You just fed ' +
        entries +
        glUtils.numberSwitch(entries, ' person', ' people') +
        ' in need!'
      )
    }

    function updateSurveyTransaction(responseData, userData, auth) {
      return $q(function(resolve, reject) {
        var options = {
          name: userData.name,
          email: userData.email,
        }
        // Prioritise responseId if exitId also exists
        if (responseData.responseId) {
          options.responseId = responseData.responseId
        } else if (responseData.exitId) {
          options.exitId = responseData.exitId
        }
        surveysResource
          .updateSurveyTransactionNameAndEmail(options, null, auth)
          .success(resolve)
          .error(reject)
      })
    }

    function verifyUserTransaction(transactionId) {
      return $q(function(resolve, reject) {
        var options = { id: transactionId }
        surveysResource
          .verifyUserTransaction(options)
          .success(resolve)
          .error(reject)
      })
    }
  }
})()

;(function() {
  'use strict'

  questionLicenseService.$inject = ["Question"];
  angular
    .module('glow.services')
    .factory('questionLicenseService', questionLicenseService)

  /* @ngInject */
  function questionLicenseService(Question) {
    var ACTIVE_LICENSE_VALUE = 'GMSACTIVE'
    var licenseStateCache = {}

    var definitions = [
      {
        key: 'srs',
        questionType: Question.Types.SCORE,
        discriminatorField: 'scoreType',
        prepareField: 'scorePrepare',
        discriminatorValue: Question.ScoreTypes.SRS,
        subscriberField: 'srsSubscriberId',
        shortLabel: 'SRS',
        label: 'Social Responsibility Score (SRS)',
      },
      {
        key: 'nts',
        questionType: Question.Types.SCORE,
        discriminatorField: 'scoreType',
        prepareField: 'scorePrepare',
        discriminatorValue: Question.ScoreTypes.NTS,
        subscriberField: 'ntsSubscriberId',
        shortLabel: 'NTS',
        label: 'Net Trust Score (NTS)',
      },
    ]

    return {
      contactHref: 'mailto:hello@glowfeed.com?Subject=GMS%20License%20Enquiry',
      getAdminOptions: getAdminOptions,
      getForQuestion: getForQuestion,
      getForPickerItem: getForPickerItem,
      getSurveyState: getSurveyState,
    }

    function getAdminOptions() {
      return [
        { label: 'None', value: null },
        { label: ACTIVE_LICENSE_VALUE, value: ACTIVE_LICENSE_VALUE },
      ]
    }

    function getForQuestion(question, subscriber) {
      if (!question) return

      var definition = getDefinition(question.type, question)
      return getForDefinition(definition, subscriber)
    }

    function getForPickerItem(item, subscriber) {
      if (!item) return

      var definition = getDefinition(item.type, item.defaults || {})
      return getForDefinition(definition, subscriber)
    }

    function getDefinition(questionType, data) {
      return _.find(definitions, function(definition) {
        return (
          definition.questionType === questionType &&
          (data[definition.discriminatorField] ||
            data[definition.prepareField]) === definition.discriminatorValue
        )
      })
    }

    function getForDefinition(definition, subscriber) {
      if (!definition) return

      var isLicensed =
        !!subscriber &&
        subscriber[definition.subscriberField] === ACTIVE_LICENSE_VALUE
      var cacheKey = definition.key + ':' + isLicensed

      if (!licenseStateCache[cacheKey]) {
        licenseStateCache[cacheKey] = _.assign({}, definition, {
          isLicensed: isLicensed,
          badgeLabel: isLicensed ? 'GMS licensed' : 'GMS license required',
        })
      }

      return licenseStateCache[cacheKey]
    }

    function getSurveyState(survey, subscriber) {
      if (!survey || survey.isTemplate) return

      var licensesByType = {}
      var unlicensedViews = []

      _.each(survey.views, function(view) {
        if (!view.isQuestion()) return

        var license = getForQuestion(view.value, subscriber)
        if (!license || license.isLicensed) return

        licensesByType[license.key] = license
        unlicensedViews.push(view)
      })

      if (!unlicensedViews.length) return

      var licenses = _.values(licensesByType)
      return {
        licenses: licenses,
        shortLabels: joinLabels(_.map(licenses, 'shortLabel')),
        labels: joinLabels(_.map(licenses, 'label')),
        unlicensedViews: unlicensedViews,
      }
    }

    function joinLabels(labels) {
      if (labels.length < 2) return labels[0]
      return labels.slice(0, -1).join(', ') + ' and ' + _.last(labels)
    }
  }
})()

/* globals Raven */
;(function() {
  'use strict'

  var Dsn = 'https://fa16bdd7e28745938ffc442fd6573fa9@sentry.io/53569'

  var LiveEnvironments = [
    /^https?:\/\/(app|www|staging)\.glowfeed\.com/,
    /^https?:\/\/(admin|admin-staging)\.glowfeed\.com/,
    /^https?:\/\/(portal|portal-staging)\.glowfeed\.com/,
  ]

  // Look at the browser URL to determine if we are running in staging/production
  var isLive = _.some(LiveEnvironments, function(reg) {
    return reg.test(window.location.href)
  })

  var Config = {
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
      'originalCreateNotification',
      'canvas.contentDocument',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      /**
       * AngularJS 1.6 started throwing errors when promise rejections
       * are not handled. These were getting picked up here and sent to
       * sentry flooding our logs.
       *
       * Most unhandled promise rejections are explicit, and mean
       * that we don't want anything more to happen in the chain.
       *
       * AngularJS did offer a way to revert the behaviour using
       *
       * ```
       * $qProvider.errorOnUnhandledRejections(false)
       * ```
       *
       * But this also swallows actual errors in a promise, and
       * so never get caught here and reported to sentry.
       *
       * Instead, we will add a check here to discern whether this
       * is a real error and send it to sentry.
       *
       * Issue: https://github.com/angular/angular.js/issues/16828
       *
       **/
      /^(\$log\.error\: )*Possibly unhandled rejection:/,
    ],
    autoBreadcrumbs: {
      console: isLive,
    },
    shouldSendCallback: function() {
      // Only send errors to sentry if the site is live in staging/production
      return isLive
    },
  }

  // Initialise raven
  Raven.config(Dsn, Config)
    .addPlugin(Raven.Plugins.Angular)
    .install()

  angular.module('glow.services').service('ravenService', Service)

  /* @ngInject */
  function Service() {
    return Raven
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$log", "configService", "glUtils"];
  angular.module('glow.services').service('glSurveyUtils', Service)

  /* @ngInject */
  function Service($log, configService, glUtils) {
    var log = $log.create('glSurveyUtils')

    var QuestionBehaviours = [
      { type: 'text', behaviour: 'single', frontendType: 'singletext' },
      { type: 'text', behaviour: 'multiline', frontendType: 'text' },
      { type: 'text', behaviour: 'scan', frontendType: 'scan' },
      { type: 'text', behaviour: 'image', frontendType: 'image' },
      {
        type: 'choice',
        behaviour: 'hiddenvariables',
        frontendType: 'hiddenvariables',
      },
    ]

    return {
      parseSandboxData: parseSandboxData,
      generateTokenUrl: generateTokenUrl,
      undoQuestionBehaviours: undoQuestionBehaviours,
      redoQuestionBehaviours: redoQuestionBehaviours,
    }

    function parseSandboxData(survey) {
      survey.data = _.isPlainObject(survey.data) ? survey.data : {}

      // The new default is backAllowed:false but before this field existed back was allowed.
      // If no value exists then continue to allow back for backward compatibility.
      survey.data.backAllowed = _.isBoolean(survey.data.backAllowed)
        ? survey.data.backAllowed
        : true

      migrateSectionsString(survey)
      migrateLogic(survey)
      migrateShuffle(survey)
      migrateDisplayType(survey)
      migrateLenderReducer(survey)
      migrateSectionsMediaType(survey)
      migrateLogicTarget(survey)
      migrateSingleTextQuestion(survey)
      migrateSectionDelay(survey)
      migrateSectionHide(survey)
      migrateIntroTimeVisible(survey)
      migrateIntroCustomDataVisible(survey)
      migrateOrigins(survey)
      migrateShuffleGroup(survey)
      migrateLogicCondition(survey)
      migrateConstantSumTotalQuantifier(survey)
      migrateLogicConditionStatements(survey)
      migrateChoiceHeadings(survey)
      migrateTextNumericValidation(survey)
      migrateTextQuantifier(survey)
      migrateLeastFillLogicActionType(survey)
      migrateRankLogic(survey)
      migrateViews(survey)
      migrateLocation(survey)
    }

    function migrateSectionsString(survey) {
      if (!_.isString(survey.data.sections)) {
        return // already up to date
      }

      var VALIDATOR = /^(\[\d+\|[\s\S][^\|]+(\|(https:)?\/\/[\S]+)?\])+$/
      var SECTION = /\[[\s\S][^\]]+\]/g
      var QUESTION = /^\[(\d+)/
      var TITLE = /\[\d+\|([\s\S][^\]\|]+)/
      var IMAGE_URL = /\[\d+\|[\s\S][^\]\|]+\|([\s\S][^\]]+)/

      var string = survey.data.sections
      survey.data.sections = []

      if (string === '') return

      if (!VALIDATOR.test(string)) {
        log.debug('invalid $$sections format: ' + string)
        return
      }

      _.each(string.match(SECTION), function(section) {
        var questionMatches = section.match(QUESTION)
        var titleMatches = section.match(TITLE)
        var imageUrlMatches = section.match(IMAGE_URL)

        survey.data.sections.push({
          id: glUtils.uuid(),
          beforeQuestionIndex: parseInt(questionMatches[1]) - 1,
          title: unescape(titleMatches[1] || ''),
          imageUrl: imageUrlMatches && imageUrlMatches[1],
        })
      })
    }

    function migrateLogic(survey) {
      // check if we need to migrate
      var requiresMigration = _.some(survey.questions, function(question) {
        return question.data && question.data.forks
      })
      if (!requiresMigration) return
      console.log('migrating forks to logic...')
      survey.didMigrateLogic = true
      var hideForks = []
      _.each(survey.questions, function(question) {
        question.data = _.isPlainObject(question.data) ? question.data : {}
        if (!question.data.logic) question.data.logic = []
        if (!question.data.forks) return

        _.each(question.data.forks, function(fork) {
          // hide forks need to be moved out of this question
          // and into the question they hide as a DISPLAY logic
          if (_.includes(['HIDE', 'HIDE_SECTION'], fork.action)) {
            hideForks.push({ fromQuestionId: question.id, fork: fork })
            return
          }

          // other forks become ACTION logic on this question
          var logic = {
            id: glUtils.uuid(),
            type: 'ACTION',
            questionId: question.id,
            conditions: [],
            actions: [],
          }

          var condition = {
            id: glUtils.uuid(),
            questionId: fork.questionId,
          }
          switch (fork.matcher) {
            case 'NONE':
              condition.type = 'ANSWERED'
              break
            case 'ANY':
              condition.type = 'DIDNT_ANSWER'
              break
            case 'CHOICES':
              condition.type = 'SELECTED'
              condition.quantifier = 'ANY'
              condition.choiceIds = fork.choiceIds
              break
            case 'NOT_CHOICES':
              condition.type = 'SELECTED'
              condition.quantifier = 'NONE'
              condition.choiceIds = fork.choiceIds
              break
          }

          var action = {
            id: glUtils.uuid(),
          }
          switch (fork.action) {
            case 'JUMP_TO':
              action.type = 'JUMP_TO_QUESTION'
              action.questionId = fork.targetQuestionId
              break
            case 'SUBMIT':
              action.type = 'SUBMIT'
              break
            case 'EXIT':
              action.type = 'EXIT'
              break
            case 'QUALITYEXIT':
              action.type = 'QUALITYEXIT'
              break
            case 'FOLLOWUP':
              action.type = 'JUMP_TO_FOLLOWUP'
              break
            case 'JUMP_TO_SECTION':
              action.type = 'JUMP_TO_SECTION'
              action.sectionId = fork.targetSectionId
              break
            case 'TAG':
              action.type = 'TAG'
              action.tag = fork.tagName
              break
          }
          logic.conditions.push(condition)
          logic.actions.push(action)
          question.data.logic.push(logic)
        })
        delete question.data.forks
      })

      // pre-bootstrap sections with a logic array
      _.each(survey.data.sections, function(section) {
        section.logic = _.isArray(section.logic) ? section.logic : []
      })

      // move hide forks into inverse location as DISPLAY logic
      _.each(hideForks, function(hideFork) {
        var fork = hideFork.fork

        var logic = {
          id: glUtils.uuid(),
          type: 'DISPLAY',
          questionId: fork.action === 'HIDE' ? fork.targetQuestionId : null,
          sectionId:
            fork.action === 'HIDE_SECTION' ? fork.targetSectionId : null,
          conditions: [],
          actions: [],
        }
        var condition = {
          id: glUtils.uuid(),
          questionId: hideFork.fromQuestionId,
        }
        switch (fork.matcher) {
          case 'NONE':
            condition.type = 'ANSWERED'
            break
          case 'ANY':
            condition.type = 'DIDNT_ANSWER'
            break
          case 'CHOICES':
            condition.type = 'SELECTED'
            condition.quantifier = 'NONE'
            condition.choiceIds = fork.choiceIds
            break
          case 'NOT_CHOICES':
            condition.type = 'SELECTED'
            condition.quantifier = 'ANY'
            condition.choiceIds = fork.choiceIds
            break
        }
        logic.conditions.push(condition)

        var targetLogic

        // question
        if (logic.questionId) {
          var question = _.find(survey.questions, function(question) {
            return question.id === logic.questionId
          })
          targetLogic = question.data.logic
        }
        // section
        if (logic.sectionId) {
          var section = _.find(survey.data.sections, function(section) {
            return section.id === logic.sectionId
          })
          targetLogic = section.logic
        }

        // if this target (question or section) already has display logic
        // we need to add this as an additional AND condition to keep
        // the same functionality as the old logic using hide.
        // Eg "Q1 might hide Q3" and "Q2 might hide Q3" so the inverse of this
        // would be "display Q3 if Q1 -AND- Q2 conditions are met"
        var displayLogic = _.find(targetLogic, function(l) {
          return l.type === 'DISPLAY'
        })
        if (displayLogic) {
          displayLogic.conditions.push(logic.conditions[0])
        } else {
          targetLogic.push(logic)
        }
      })
    }

    function migrateShuffle(survey) {
      // Shuffle used to be only for choices, the field was:
      //   question.data.shuffle: Boolean
      // but now statements can be shuffled, so we migrate to:
      //   question.data.shuffleChoices: Boolean
      //   question.data.shuffleStatements: Boolean
      _.each(survey.questions, function(question) {
        question.data = _.isPlainObject(question.data) ? question.data : {}
        if (_.isBoolean(question.data.shuffle)) {
          question.data.shuffleChoices = question.data.shuffle
          delete question.data.shuffle
        }
      })
    }

    function migrateDisplayType(survey) {
      // lazy migrate survey questions displayType field
      _.each(survey.questions, function(question) {
        question.data = _.isPlainObject(question.data) ? question.data : {}
        if (
          question.type.toLowerCase() === 'matrix' &&
          !question.data.displayType
        ) {
          question.data.displayType = 'DEFAULT'
        }
      })
    }

    function migrateLenderReducer(survey) {
      /**
       * Previously, you could only borrow from "choices" in a previous question
       * and the reducers were of a single enum type:
       *
       * Question {
       *  choiceLender: ID
       *  statementLender: ID
       *  choiceLenderReducer: SELECTED|NOT_SELECTED|NULL
       *  statementLenderReducer: SELECTED|NOT_SELECTED|NULL
       * }
       *
       * Now we can borrow from choices AND statements, and when borrowing from a
       * matrix question we can reduce them based on the opposite choices or statements selected:
       *
       * Question {
       *  choiceLender: {
       *    id: QuestionID
       *    target: STATEMENTS|CHOICES
       *    reducer: SELECTED|NOT_SELECTED|NULL
       *    statementIds: [...StatementID] // when borrowing choices from matrix, which statement should we use to reduce choice selections from?
       *    choiceIds: [...ChoiceID] // when borrowing statements from matrix, which choice selections should we reduce the statements from?
       *  }
       *  statementLender: same as above^
       * }
       *
       * see GLOW-225 (Borrow From Matrix)
       */
      _.each(survey.questions, function(question) {
        question.data = _.isPlainObject(question.data) ? question.data : {}

        if (_.isString(question.data.choiceLender)) {
          // migrate from old format to new format
          question.data.choiceLender = {
            id: question.data.choiceLender,
            target: null,
            reducer: question.data.choiceLenderReducer,
            statementIds: [],
            choiceIds: [],
          }
          delete question.data.choiceLenderReducer
        } else if (
          _.isPlainObject(question.data.choiceLender) &&
          question.data.choiceLender.statementIds === undefined
        ) {
          // TEMP: this migrates something that came up during QA
          question.data.choiceLender.statementIds = question.data.choiceLender
            .statementId
            ? [question.data.choiceLender.statementId]
            : []
          delete question.data.choiceLender.statementId
        } else if (!question.data.choiceLender) {
          // otherwise migrate to new defaults
          question.data.choiceLender = {
            id: null,
            target: null,
            reducer: null,
            statementIds: [],
            choiceIds: [],
          }
        }

        if (_.isString(question.data.statementLender)) {
          // migrate from old format to new format
          question.data.statementLender = {
            id: question.data.statementLender,
            target: null,
            reducer: question.data.statementLenderReducer,
            statementIds: [],
            choiceIds: [],
          }
          delete question.data.statementLenderReducer
        } else if (
          _.isPlainObject(question.data.statementLender) &&
          question.data.statementLender.statementIds === undefined
        ) {
          // TEMP: this migrates something that came up during QA
          question.data.statementLender.statementIds = question.data
            .statementLender.statementId
            ? [question.data.statementLender.statementId]
            : []
          delete question.data.statementLender.statementId
        } else if (!question.data.statementLender) {
          // otherwise migrate to new defaults
          question.data.statementLender = {
            id: null,
            target: null,
            reducer: null,
            statementIds: [],
            choiceIds: [],
          }
        }
      })
    }

    function migrateSectionsMediaType(survey) {
      // lazy migrate survey sections mediaType
      _.each(survey.data.sections, function(section) {
        if (!section.mediaType) {
          var count = 0
          if (section.imageUrl) {
            section.mediaType = 'IMAGE'
            count++
          }
          if (section.audioUrl) {
            section.mediaType = 'AUDIO'
            count++
          }
          if (section.youTubeVideoUrl) {
            section.mediaType = 'VIDEO'
            count++
          }
          if (count > 1) {
            console.error(
              'Multiple survey section media detected on section ' +
                section.title
            )
          }
        }
      })
    }

    function migrateLogicTarget(survey) {
      // migrate question logic to have a target = QUESTION
      _.each(survey.questions, function(question) {
        _.each(question.data.logic, function(logic) {
          if (!logic.target) {
            logic.target = 'QUESTION'
          }
        })
      })

      // migrate section logic to have a target = SECTION
      _.each(survey.data.sections, function(section) {
        _.each(section.logic, function(logic) {
          if (!logic.target) {
            logic.target = 'SECTION'
          }
        })
      })
    }

    function generateTokenUrl(surveyId) {
      var token = glUtils.randomString(8)
      var url = configService.getUserPortalUrl() + '/survey/' + surveyId
      return glUtils.addParams(url, { token: token })
    }

    function undoQuestionBehaviours(question, typeKey, behaviourKey) {
      typeKey = typeKey || 'type'
      behaviourKey = behaviourKey || 'behaviour'

      var info = _.find(QuestionBehaviours, {
        type: question[typeKey],
        behaviour: question[behaviourKey],
      })

      if (info) {
        question[typeKey] = info.frontendType
        delete question[behaviourKey]
      }
    }

    function redoQuestionBehaviours(question, typeKey, behaviourKey) {
      typeKey = typeKey || 'type'
      behaviourKey = behaviourKey || 'behaviour'

      var info = _.find(QuestionBehaviours, {
        frontendType: question[typeKey],
      })

      if (info) {
        question[typeKey] = info.type
        question[behaviourKey] = info.behaviour
      }
    }

    function migrateSingleTextQuestion(survey) {
      // Previously text questions only had one field.
      // We now support multiple fields for text entry so we need to migrate
      // the old ones to have a numeric value of 1.
      // Addition to that we now have mininum answers validation
      // for compulsory and is default to 1
      _.each(survey.questions, function(question) {
        question.data = _.isPlainObject(question.data) ? question.data : {}

        if (question.type === 'text' && question.behaviour === 'single') {
          if (!_.isNumber(question.textFieldNumber)) {
            question.textFieldNumber = 1
          }
          if (!_.isNumber(question.data.minAnswers)) {
            question.data.minAnswers = 1
          }
        }
      })
    }

    function migrateSectionDelay(survey) {
      _.each(survey.data.sections, function(section) {
        if (!_.isNumber(section.delay)) {
          section.delay = 0
        }
      })
    }

    function migrateSectionHide(survey) {
      _.each(survey.data.sections, function(section) {
        if (!_.isNumber(section.hide)) {
          section.hide = 0
        }
      })
    }

    function migrateIntroTimeVisible(survey) {
      if (!_.isBoolean(survey.data.introTimeVisible)) {
        survey.data.introTimeVisible = true
      }
    }

    function migrateIntroCustomDataVisible(survey) {
      if (!_.isBoolean(survey.data.introCustomDataVisible)) {
        survey.data.introCustomDataVisible = false
      }
    }

    function migrateOrigins(survey) {
      if (!survey.data.origins) {
        survey.data.origins = []
        survey.data.originsPre = true
      }
    }

    function migrateShuffleGroup(survey) {
      // ShuffleGroup used to represent a start and end range of views
      // that should be shuffled.
      // ShuffleGroup now represents a list of ViewGroups that should
      // be shuffled.
      // The original ShuffleGroup functionality (individual views shuffled)
      // is now handled by ViewGroup's (and migrated here).

      // This migration should only run once, before ViewGroups are created
      if (survey.data.viewGroups) return

      survey.data.viewGroups = []
      survey.data.shuffleGroups = _.isArray(survey.data.shuffleGroups)
        ? survey.data.shuffleGroups
        : []

      // construct array of view ids from questions and sections
      var viewIds = []
      var questions = _.orderBy(survey.questions, 'order')
      _.each(questions, function(question) {
        viewIds.push(question.id)
      })
      _.each(survey.data.sections, function(section) {
        var startIndex = viewIds.length // end of array
        var question = questions[section.beforeQuestionIndex]
        if (question) {
          startIndex = _.indexOf(viewIds, question.id)
        }
        Array.prototype.splice.apply(
          viewIds,
          [startIndex, 0].concat([section.id])
        )
      })

      // migrate the views to a new ViewGroup and remove the old ShuffleGroup
      _.each(survey.data.shuffleGroups, function(shuffleGroup) {
        if (!shuffleGroup.startId || !shuffleGroup.endId) return

        var startIndex = _.indexOf(viewIds, shuffleGroup.startId)
        var endIndex = _.indexOf(viewIds, shuffleGroup.endId)
        var sliced = _.slice(viewIds, startIndex, endIndex + 1)
        var groupViewIds = _.filter(sliced, function(viewId) {
          // ensure the view is not already belong to a group
          return !_.some(survey.data.viewGroups, function(viewGroup) {
            return _.includes(viewGroup.viewIds, viewId)
          })
        })
        var viewGroup = {
          id: glUtils.uuid(),
          name: 'Group ' + (survey.data.viewGroups.length + 1),
          viewIds: groupViewIds.slice(),
          shuffleIds: groupViewIds.slice(),
        }
        survey.data.viewGroups.push(viewGroup)
      })
      survey.data.shuffleGroups = []
    }

    function migrateLogicConditionType(condition) {
      // migrate logic condtition type enum from SELECTED_AMOUNT to ANSWERED_AMOUNT
      if (condition.type === 'SELECTED_AMOUNT') {
        condition.type = 'ANSWERED_AMOUNT'
      }
    }

    function migrateLogicConditionQuantifier(survey, condition) {
      // Previously we had the LogicCondition.quantifier field.
      // This migration breaks them out into distinct quantifier fields: .listQuantifier, .numericQuantifier etc

      if (!condition.quantifier) return

      switch (condition.type) {
        case 'SELECTED':
          var question = _.find(survey.questions, {
            id: condition.questionId,
          })
          if (!question) break // broken logic

          // if question has choices OR question is text type
          // then use selection quantifier
          if (
            question.choices.length > 0 ||
            question.type === 'location' ||
            question.type === 'text' ||
            (question.type === 'text' &&
              question.behaviour === 'single' &&
              _.includes([null, 'EMAIL'], question.data.textValidator))
          ) {
            condition.selectionQuantifier = condition.quantifier
          }
          // if question question is numeric type then use numeric quantifier
          if (
            question.type === 'numeric' ||
            (question.type === 'text' &&
              question.behaviour === 'single' &&
              _.includes(
                ['NUMERIC', 'NUMERIC_RANGE'],
                question.data.textValidator
              ))
          ) {
            condition.numericQuantifier = condition.quantifier
          }
          break
        case 'ANSWERED_AMOUNT':
          condition.numericQuantifier = condition.quantifier
          break
        case 'IS_TAGGED':
          condition.selectionQuantifier = condition.quantifier
          break
        case 'LIST':
          condition.listQuantifier = condition.quantifier
          break
      }
      delete condition.quantifier
    }

    function migrateLogicCondition(survey) {
      _.each(survey.questions, function(question) {
        _.each(question.data.logic, function(logic) {
          _.each(logic.conditions, function(condition) {
            migrateLogicConditionType(condition)
            migrateLogicConditionQuantifier(survey, condition)
          })
        })
      })
      _.each(survey.data.sections, function(section) {
        _.each(section.logic, function(logic) {
          _.each(logic.conditions, function(condition) {
            migrateLogicConditionType(condition)
            migrateLogicConditionQuantifier(survey, condition)
          })
        })
      })
    }

    function migrateConstantSumTotalQuantifier(survey) {
      // Previously we don't have quantifier for constant sum total required
      // this migration is to default the quantifier to EQUAL when total is required
      _.each(survey.questions, function(question) {
        if (question.type !== 'constantsum') return // continue
        question.data = _.isPlainObject(question.data) ? question.data : {}
        if (
          question.data.constantSumTotal &&
          question.data.constantSumTotalQuantifier === undefined
        ) {
          question.data.constantSumTotalQuantifier = 'EQUAL'
        }
      })
    }

    function migrateLogicConditionStatements(survey) {
      _.each(survey.questions, function(question) {
        // var migrated = []
        // var original = []
        _.each(question.data.logic, function(logic) {
          // var didMigrate = false
          _.each(logic.conditions, function(condition) {
            if (!_.isArray(condition.statementIds)) {
              condition.statementIds = []
              if (condition.statementId) {
                condition.statementIds.push(condition.statementId)
                // didMigrate = true
              }
              delete condition.statementId
            }
          })
          // if (didMigrate) {
          //   migrated.push(logic)
          // } else {
          //   original.push(logic)
          // }
        })

        // Here we try to optimize by combining logic with other logic if
        // the ONLY thing different is just statementId's
        // See: https://trello.com/c/DfkrpQdN/277-large-survey-performance
        /*
        if (migrated.length) {
          var combined = []
          var pool = migrated.slice()
          while (pool.length) {
            var logicA = pool.shift()
            var match = combined.find(function(logicB) {
              if (logicB.conditions.length !== 1) return
              if (logicA.actions.length !== logicB.actions.length) return
              if (logicA.conditions.length !== logicB.conditions.length) return
              var a = _.cloneDeep(logicA)
              var b = _.cloneDeep(logicB)
              a.id = b.id = null
              a.actions.forEach(function(a) {
                a.id = null
              })
              b.actions.forEach(function(a) {
                a.id = null
              })
              a.conditions[0].id = null
              b.conditions[0].id = null
              b.conditions[0].statementIds = a.conditions[0].statementIds.slice()
              return _.isEqual(a, b)
            })
            if (match) {
              match.conditions[0].statementIds = _(
                match.conditions[0].statementIds
              )
                .concat(logicA.conditions[0].statementIds)
                .uniq()
                .value()
            } else {
              combined.push(logicA)
            }
          }
          question.data.logic = _.concat(combined, original)
        }
        */
      })
    }

    function migrateChoiceHeadings(survey) {
      _.each(survey.questions, function(question) {
        question.data = _.isPlainObject(question.data) ? question.data : {}

        // we'll use the existence of question.data.randomizeChoices
        // to indicate whether this lazy migration has run or not
        if (question.data.randomizeChoices !== undefined) {
          return
        }

        question.data.randomizeChoices = null
        question.data.randomizeChoiceHeadings = null
        question.data.randomizeStatements = null
        question.data.randomizeStatementHeadings = null

        if (question.data.shuffleChoices) {
          question.data.randomizeChoices = 'SHUFFLE'
        }
        if (question.data.rotateChoices) {
          question.data.randomizeChoices = 'ROTATE'
        }

        if (question.data.shuffleStatements) {
          question.data.randomizeStatements = 'SHUFFLE'
        }
        if (question.data.rotateStatements) {
          question.data.randomizeStatements = 'ROTATE'
        }

        delete question.data.shuffleChoices
        delete question.data.rotateChoices
        delete question.data.shuffleStatements
        delete question.data.rotateStatements
      })
    }

    function migrateTextNumericValidation(survey) {
      _.each(survey.questions, function(question) {
        var data = question.data
        if (!data) return
        /**
         * This field used to be type string but is now numeric.
         * This parses strings into numbers (eg "100,000" => 100000)
         */
        if (_.isString(data.textNumericMin)) {
          data.textNumericMin = parseInt(data.textNumericMin.replace(/,/g, ''))
        }
        if (_.isString(data.textNumericMax)) {
          data.textNumericMax = parseInt(data.textNumericMax.replace(/,/g, ''))
        }
      })
    }

    function migrateLogicConditionTextQuantifier(survey, condition) {
      // Previously, both choice-based and text-based question conditions used the
      // `selectionQuantifier` field as they both had the same kind of quantifiers.
      // Text-based questions now have new quantifiers that don't make sense for
      // choice-based questions so we need to split it out into `selectionQuantifier`
      // and `textQuantifier`
      // ---
      // See: https://trello.com/c/j91MouG0/326-least-fill

      if (!condition.selectionQuantifier || condition.type !== 'SELECTED')
        return

      var question = _.find(survey.questions, {
        id: condition.questionId,
      })
      if (!question) return // broken logic

      var usesText =
        question.type === 'location' ||
        question.type === 'text' ||
        (question.type === 'text' &&
          question.behaviour === 'single' &&
          _.includes([null, 'EMAIL'], question.data.textValidator))
      if (usesText && !condition.textQuantifier) {
        condition.textQuantifier = condition.selectionQuantifier
        condition.selectionQuantifier = null
      }
    }

    function migrateTextQuantifier(survey) {
      _.each(survey.questions, function(question) {
        _.each(question.data.logic, function(logic) {
          _.each(logic.conditions, function(condition) {
            migrateLogicConditionTextQuantifier(survey, condition)
          })
        })
      })
      _.each(survey.data.sections, function(section) {
        _.each(section.logic, function(logic) {
          _.each(logic.conditions, function(condition) {
            migrateLogicConditionTextQuantifier(survey, condition)
          })
        })
      })
    }

    function migrateLeastFillLogicActionType(survey) {
      _.each(survey.questions, function(question) {
        _.each(question.data.logic, function(logic) {
          _.each(logic.actions, function(action) {
            if (action.type === 'LEAST_FILL') {
              action.type = 'ADD_LEAST_FILLED_TAGS'
            }
          })
        })
      })
      _.each(survey.data.sections, function(section) {
        _.each(section.logic, function(logic) {
          _.each(logic.actions, function(action) {
            if (action.type === 'LEAST_FILL') {
              action.type = 'ADD_LEAST_FILLED_TAGS'
            }
          })
        })
      })
    }

    function migrateRankLogic(survey) {
      // Rank question conditions were only selection based,
      // eg "respondent selected any of A,B,C"
      //
      // Now you can choose the ranks that the choices must be, eg
      // "respondent selected any of A,B,C ranked any of 1,2,3"
      //
      // All previous rank based conditions are migrated here to "select"
      // all of the ranks, resulting in the same behaviour.
      _.each(survey.questions, function(question) {
        _.each(question.data.logic, function(logic) {
          _.each(logic.conditions, function(condition) {
            if (!condition.questionId) return
            var question = survey.questions.find(function(question) {
              return question.id === condition.questionId
            })
            if (!question) return // ???
            if (question.type === 'rank') {
              if (condition.type === 'SELECTED' && !condition.ranks) {
                condition.ranks = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
              }
            }
          })
        })
      })
    }

    function migrateViews(survey) {
      /**
       * We are about to introduce more view types (eg loop) so can't rely on
       * section.beforeQuestionIndex to insert the sections into
       * the correct place. Instead, we will now store a views array
       * that has the absolute order.
       */
      survey.data = _.isPlainObject(survey.data) ? survey.data : {}
      var data = survey.data
      if (data.views) return

      data.views = []

      // order questions and add as a view
      survey.questions = _.orderBy(survey.questions, function(q) {
        return _.isString(q.order) ? parseInt(q.order, 10) : q.order
      })
      survey.questions.forEach(function(q) {
        data.views.push({
          type: 'QUESTION',
          value: q.id, // stored by reference
        })
      })

      // add section views in correct place
      _.each(data.sections, function(s) {
        var view = {
          type: 'SECTION',
          value: s, // stored by data
        }
        var idx = null
        var question = survey.questions[s.beforeQuestionIndex]
        if (question) {
          idx = _.findIndex(data.views, function(view) {
            return view.value === question.id
          })
        }
        // beforeQuestionIndex can be -1 which means it will be
        // placed at the end
        var pos = _.isNumber(idx) ? idx : data.views.length
        data.views.splice(pos, 0, view)
      })
      delete data.sections
    }

    function migrateLocation(survey) {
      // We're introducing location type for location question
      // either DEFAULT or PLACES
      // Here we migrate existing location questions to have default type
      _.each(survey.questions, function(question) {
        question.data = _.isPlainObject(question.data) ? question.data : {}

        if (
          question.type === 'text' &&
          question.data.isLocationType &&
          !question.data.locationType
        ) {
          question.data.locationType = 'DEFAULT'
        }
      })
    }
  }
})()

/* globals uuid */
;(function() {
  'use strict'

  service.$inject = ["$window", "$anchorScroll", "$timeout", "$state", "$rootScope", "$document", "$animate", "$q"];
  angular.module('glow.services').factory('glUtils', service)

  /* @ngInject */
  function service(
    $window,
    $anchorScroll,
    $timeout,
    $state,
    $rootScope,
    $document,
    $animate,
    $q
  ) {
    var shouldAnchorScroll = true
    var ORDER_BUFFER = 1024
    var SubscriptionCodeValidation = '[A-Za-z0-9_-]{2,}' // Upper or lower case letters, numbers, a hyphen or an underscore, at least 2 characters

    return {
      SubscriptionCodeValidation: SubscriptionCodeValidation,
      imageStyle: imageStyle,
      popup: popup,
      addParams: addParams,
      addParamsV2: addParamsV2,
      pullParams: pullParams,
      getQueryParams: getQueryParams,
      formatUnicorn: formatUnicorn,
      getDateRange: getDateRange,
      offsetRect: offsetRect,
      checkDates: checkDates,
      randomString: randomString,
      scrollToElementAnimated: scrollToElementAnimated,
      broadcaster: broadcaster,
      pad: pad,
      changeParams: changeParams,
      constructFilterParam: constructFilterParam,
      getClipboardData: getClipboardData,
      uuid: uuid.v4,
      uuidVersion: uuidVersion,
      numberSwitch: numberSwitch,
      countLabel: countLabel,
      fixRouterScroll: fixRouterScroll,
      generateHash: generateHash,
      downloadFile: downloadFile,
      downloadUrl: downloadUrl,
      getPrecision: getPrecision,
      getItemOrder: getItemOrder,
      resetItemsOrder: resetItemsOrder,
      animateMove: animateMove,
      bulkAnimateMove: bulkAnimateMove,
      stringReverse: stringReverse,
      stringReplaceAt: stringReplaceAt,
      clampImageSize: clampImageSize,
      validateUrl: validateUrl,
      fetchBlobDataFromUrl: fetchBlobDataFromUrl,
      bulkMove: bulkMove,
      shiftSelect: shiftSelect,
    }

    function imageStyle(url) {
      if (!url) {
        return
      }
      return { backgroundImage: 'url(' + url + ')' }
    }

    /**
     * @name popup
     * @description Pop up new window in center of screen
     * @param {String} url url to load in pop up window
     * @param {String} title title of pop up window
     * @param {String} w width of pop up window
     * @param {String} h height of pop up window
     */
    function popup(url, title, w, h) {
      // Fixes dual-screen position                         Most browsers      Firefox
      var dualScreenLeft =
        window.screenLeft !== undefined ? window.screenLeft : screen.left
      var dualScreenTop =
        window.screenTop !== undefined ? window.screenTop : screen.top

      var width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width
      var height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height

      var left = width / 2 - w / 2 + dualScreenLeft
      var top = height / 2 - h / 2 + dualScreenTop
      var newWindow = window.open(
        url,
        title,
        'scrollbars=yes, width=' +
          w +
          ', height=' +
          h +
          ', top=' +
          top +
          ', left=' +
          left
      )

      // Puts focus on the newWindow
      if (window.focus) {
        newWindow.focus()
      }
      return newWindow
    }

    /**
     * @name addParams
     * @description add array of params to a URL
     * @param  {String} url    base URL
     * @param  {Array} params  array of params to add to base URL
     * @return {String}        url with query params added
     */
    function addParams(url, params) {
      var pieces = []
      _.each(params, function(value, key) {
        if (key && value) {
          pieces.push(key + '=' + encodeURIComponent(value))
        }
      })
      if (pieces.length > 0) {
        pieces = pieces.join('&')
        url += '?' + pieces
      }
      return url
    }

    function addParamsV2(url, params) {
      try {
        var newUrl = new URL(url)
        _.each(params, function(value, key) {
          newUrl.searchParams.set(key, value)
        })
        return newUrl.toString()
      } catch (err) {
        // invalid url, use original without CD's
        console.error(err)
        return url
      }
    }

    // Pulls params out of a url and returns the result
    // If a value is provided for a param being pulled then it will be matched
    function pullParams(url, paramsToPull) {
      var params = getQueryParams(url)

      if (!paramsToPull || !params) {
        return url
      }

      var baseUrl = url.split('?')[0]

      _.forEach(paramsToPull, function(value, key) {
        params = _.omitBy(params, function(paramValue, paramKey) {
          var keyCheck = paramKey === key
          // Convert to a string in order to compare to numbers or booleans in the params to pull
          var valueCheck =
            value === undefined || value === null
              ? true
              : paramValue === _.toString(value)
          return keyCheck && valueCheck
        })
      })

      return addParams(baseUrl, params)
    }

    /**
     * @name getQueryParams
     * @description get the collection of query params for a url
     *              http://stackoverflow.com/questions/2090551/parse-query-string-in-javascript
     * @param  {String} url
     * @return {Object} the key: value pairs of query params
     */
    function getQueryParams(url) {
      if (!url) {
        return
      }

      var queryString = url.split('?')

      // There should be one and only one query string, i.e. the second array element
      if (queryString.length !== 2) {
        return
      }

      var keyValueStrings = queryString[1].split('&')
      var query = {}

      for (var i = 0; i < keyValueStrings.length; i++) {
        var keyValuePair = keyValueStrings[i].split('=')
        query[decodeURIComponent(keyValuePair[0])] = decodeURIComponent(
          keyValuePair[1] || ''
        )
      }

      return query
    }

    /**
     * @name formatUnicorn
     * @description String formatter based on StackOverflow's String.prototype.formatUnicorn
     *              [link](http://stackoverflow.com/a/18234317/1531255)
     * @param {String} string  string with format placeholders
     * @param {Object} data    object with references to the placeholders
     * @example
     * // returns 'foo loves bar'
     * formatUnicorn('foo loves {lover}', { lover: 'bar' });
     * @returns  {String} Returns the formatted string
     */
    function formatUnicorn(string, data) {
      if (!data || !_.isObject(data)) {
        return string
      }
      _.each(data, function(value, key) {
        string = string.replace(RegExp('\\{' + key + '\\}', 'gi'), data[key])
      })
      return string
    }

    /**
     * @name getDateRange
     * @description get array of dates between two times
     * @param  {Moment} startDate start date
     * @param  {Moment} endDate   end date
     * @param  {String} intervalType  intervalType to use - default 'days'
     * @param  {String} interval inverval value - default 1
     * @param  {String} format    date format - default 'YYYY-MM-DD'
     * @return {Array}            array of dates
     */
    function getDateRange(startDate, endDate, intervalType, interval, format) {
      intervalType = intervalType || 'days'
      interval = interval || 1
      format = format || 'YYYY-MM-DD'
      var dateArray = []
      var currentDate = startDate.clone()

      while (currentDate <= endDate) {
        dateArray.push(currentDate.format(format))
        currentDate = currentDate.clone().add(interval, intervalType)
      }

      return dateArray
    }

    function offsetRect(element, offsetParent) {
      var node = getNode(element)
      offsetParent = getNode(offsetParent || node.offsetParent || document.body)
      var nodeR = node.getBoundingClientRect()
      var offsetR = offsetParent.getBoundingClientRect()

      return {
        left: nodeR.left - offsetR.left,
        top: nodeR.top - offsetR.top,
        width: nodeR.width,
        height: nodeR.height,
      }

      function getNode(el) {
        return el[0] || el
      }
    }

    /**
     * @name  checkDates
     * @description check dates are in chronological order - end date is after start date
     * @param  {String} start start date in ISO format
     * @param  {String} end   end date in ISO format
     * @return {Boolean}      true if dates are in chronological order
     */
    function checkDates(start, end) {
      var chrono = false
      var same = true
      var past

      start = start && moment(start)
      end = end && moment(end)

      past = past ? end.isBefore(moment()) : null

      if (start && end) {
        chrono = end.isAfter(start)
        same = end.isSame(start, 'day')
      }

      return chrono && !same && !past
    }

    /**
     * @name uuidVersion
     * @description read the version field of a uuid, as defined by RFC 4122 and kept by RFC 9562
     *              (4 = random, 1/6/7 = time-based, 3/5 = name-based). the field is part of the
     *              uuid format itself, so it is set by every generator on every platform, not just
     *              by this library, and it survives swapping the library out - only this function
     *              would change. anything that is not a well-formed uuid answers null, never a version.
     * @param  {String} id - uuid string, any case, with or without hyphens
     * @return {Number|null} version 1-8, or null when it cannot be read
     */
    function uuidVersion(id) {
      if (!_.isString(id)) return null
      // the version is the high nibble of byte 6, the same byte v4() stamps - `>> 4` drops the low nibble
      var version = uuid.parse(id)[6] >> 4
      return version || null
    }

    /**
     * @name randomString
     * @description generate a random string
     * @param  {Number}  length    - length of string to generate, defaults to 12 (optional)
     * @param  {Boolean} numerical - true if string should be only numerical, defaults to false (optional)
     * @return {String}           random string of set length
     */
    function randomString(length, numerical) {
      var chars = numerical
        ? '0123456789'
        : '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      var result = ''
      length = length || 12
      for (var i = length; i > 0; --i) {
        result += chars[Math.round(Math.random() * (chars.length - 1))]
      }
      return result
    }

    function scrollToElementAnimated(element) {
      if ($document.scrollToElementAnimated) {
        $document.scrollToElementAnimated(element, 200, 500, function(t) {
          // easeInOutQuad - https://gist.github.com/gre/1650294
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
        })
      } else {
        // fallback for properties that dont have duScroll
        $window.scrollTop(element.getBoundingClientRect().top)
      }
    }

    function broadcaster(namespace) {
      return function(value) {
        $rootScope.$broadcast(namespace + ':' + value)
      }
    }

    /**
     * @name pad
     * @description pads a number with leading zeros
     * @param {Number} number - the number to pad
     * @param {Number} toMatch - the width of the final output
     * @return {String} a string with leading zeros (if required)
     */
    function pad(number, toMatch) {
      var padded = number.toString()
      var digits = toMatch.toString().length
      while (padded.length < digits) {
        padded = '0' + padded
      }
      return padded
    }

    function changeParams(newParams, digest, scrollTop) {
      function apply() {
        // we "fixed" router scroll so that the page scrolls to the top
        // on params change. this is what we want 90% of the time, but
        // in some cases (eg changing report filters) we don't want this behaviour.
        // so we disable it temporarily.
        if (scrollTop === false) shouldAnchorScroll = false
        $state.go('.', newParams, { location: 'replace' })
      }
      if (digest) {
        $timeout(function() {
          apply()
        })
      } else {
        apply()
      }
    }

    /**
     * Construct Filter Param
     * @desc a helper for creating the value of a `?filter=X` param
     * @param {Array} optional  an array of optional filter strings (eg `name eq John`)
     * @param {Array} required an array of required filter strings (eg `state eq PUBLISHED`)
     */
    function constructFilterParam(optional, required) {
      if (!optional || !optional.length) {
        return required.join(' and ')
      }

      var filters = []

      _.each(optional, function(oFilter) {
        var subFilters = []

        _.each(required, function(rFilter) {
          subFilters.push(rFilter)
        })
        subFilters.push(oFilter)

        var subFilter = subFilters.join(' and ')
        filters.push(subFilter)
      })

      return filters.join(' or ')
    }

    function getClipboardData(e, format) {
      var text
      format = format || 'text/plain'
      if (e.clipboardData && e.clipboardData.getData) {
        text = e.clipboardData.getData(format)
      } else if (window.clipboardData && window.clipboardData.getData) {
        // IE 11
        // This is deprecated in edge
        text = window.clipboardData.getData('Text')
      }
      /**
       * If we extract some text from the clipboard, prevent the default paste event from firing.
       * This also acts as a fallback so it will paste normally for other browsers
       */
      if (text) {
        e.preventDefault()
      }
      return text || ''
    }

    function numberSwitch(number, single, plural) {
      return number === 1 ? single : plural
    }

    function countLabel(count, noun) {
      return (
        count.toLocaleString() + ' ' + numberSwitch(count, noun, noun + 's')
      )
    }

    function fixRouterScroll() {
      // Origin: https://github.com/angular-ui/ui-router/issues/816#issuecomment-282118102
      // UI-router has horrible route scroll management.
      // This hack makes route scrolling act more "correct" by scrolling to the top
      // when new routes are pushed, but existing routes will remember their scroll
      // positions when navigating back/forward.
      // When using this, make sure you
      // - remove any autoscroll=true from ui-view's
      // - don't use $uiViewScrollProvider.useAnchorScroll()
      var wrap = function(method) {
        var orig = $window.window.history[method]
        $window.window.history[method] = function() {
          var retval = orig.apply(this, Array.prototype.slice.call(arguments))
          if (shouldAnchorScroll) {
            $anchorScroll()
          } else {
            // due to async nature of $state.go() we have to make this a
            // one-off trigger that self-enables after being disabled
            // temporarily
            shouldAnchorScroll = true
          }
          return retval
        }
      }
      wrap('pushState')
      wrap('replaceState')
    }

    function generateHash(string) {
      // Origin: https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
      // Utility function to generate hash from a given string

      if (!string) {
        return null
      }

      if (_.isObject(string)) {
        string = JSON.stringify(string)
      }

      var hash = 0,
        i,
        chr
      for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i)
        hash = (hash << 5) - hash + chr
        hash |= 0 // Convert to 32bit integer
      }

      return hash
    }

    function downloadFile(data, mimeType, fileName) {
      // Utility function to let user download a file

      var options = {}
      if (mimeType) {
        options.type = mimeType
      }
      var blob = new Blob([data], options)

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName) // IE 10+
      } else {
        var link = document.createElement('a')
        // Browsers that support HTML5 download attribute
        if (link.download !== undefined) {
          var url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', fileName)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    }

    function downloadUrl(url, fileName) {
      var link = document.createElement('a')
      if (link.download !== undefined) {
        // the browser doesnt seem to honor fileName if there
        // is a content disposition header on the file itself
        // see: https://stackoverflow.com/a/71155039/1531255
        link.setAttribute('href', url)
        link.setAttribute('download', fileName)
        link.style.visibility = 'hidden'
        document.body.appendChild(link) // Firefox requires the link to be in the body
        link.click()
        document.body.removeChild(link) // remove the link when done
      } else {
        window.location.replace(url)
      }
    }

    function getPrecision(a) {
      // Origin: https://stackoverflow.com/a/27865285/5731688
      // Utility function to get amount of decimals a number have

      if (!Number.isFinite(a)) return 0
      var e = 1,
        p = 0
      while (Math.round(a * e) / e !== a) {
        e *= 10
        p++
      }
      return p
    }

    function getItemOrder(item, items) {
      // Utility function to get order number of an item based on it's current position on items array
      // IMPORTANT: this function should be called after item has been added to the items array and each items must have `uuid` field

      var hasEmptyOrder = _.some(items, function(obj) {
        return item.uuid !== obj.uuid && obj.order === null
      })
      if (hasEmptyOrder) {
        // if items has empty order (excluding current item)
        // then return null because we can't get proper order number
        return null
      }
      var index = _.indexOf(items, item)
      var isFirst = index === 0
      var isLast = index === items.length - 1
      var prevItem = items[index - 1]
      var nextItem = items[index + 1]
      var order
      if (isFirst && isLast) {
        // only item in array
        order = ORDER_BUFFER
      } else if (isFirst) {
        order = nextItem.order / 2
      } else if (isLast) {
        order = prevItem.order + ORDER_BUFFER
      } else {
        order = (prevItem.order + nextItem.order) / 2
      }
      // check if order number is too close together or is too large
      // then return as null to trigger mass update on move
      var precision = 0.0001
      if (prevItem && Math.abs(order - prevItem.order) <= precision) {
        order = null
      }
      if (nextItem && Math.abs(order - nextItem.order) <= precision) {
        order = null
      }
      if (order > Number.MAX_SAFE_INTEGER) {
        order = null
      }
      return order
    }

    function resetItemsOrder(items) {
      // Utility function to reset items order number

      var newOrder = 0
      _.each(items, function(item) {
        item.order = newOrder += ORDER_BUFFER
      })
    }

    function animateMove(itemClassPrefix, index, amount) {
      // Utility function to animate moving item up/down

      var actionedIsAbove = amount > 0
      var transitionStyles = {
        position: 'relative',
        transition: 'all .4s ease-in-out',
        '-webkit-transition': 'all .4s ease-in-out',
      }
      var noTransitionStyles = {
        transform: 'none',
        transition: 'none',
        '-webkit-transition': 'none',
      }
      var actioned = {}
      actioned.elem = angular.element(
        document.querySelectorAll('.' + itemClassPrefix + index)[0]
      )
      actioned.bounds = actioned.elem[0].getBoundingClientRect()
      actioned.elem.css(transitionStyles)
      var other = {}
      other.elem = angular.element(
        document.querySelectorAll('.' + itemClassPrefix + (index + amount))[0]
      )
      other.bounds = other.elem[0].getBoundingClientRect()
      other.elem.css(transitionStyles)
      if (actionedIsAbove) {
        actioned.newTop = other.bounds.bottom - actioned.bounds.bottom
        other.newTop = actioned.bounds.top - other.bounds.top
      } else {
        other.newTop = actioned.bounds.bottom - other.bounds.bottom
        actioned.newTop = other.bounds.top - actioned.bounds.top
      }
      var animOne = $animate.animate(actioned.elem, null, {
        transform: 'translateY(' + actioned.newTop + 'px)',
      })
      var animTwo = $animate.animate(other.elem, null, {
        transform: 'translateY(' + other.newTop + 'px)',
      })
      return $q.all([animOne, animTwo]).then(function() {
        other.elem.css(noTransitionStyles)
        actioned.elem.css(noTransitionStyles)
      })
    }

    function bulkAnimateMove(options) {
      options = _.defaults(options, {
        itemClassPrefix: '',
        itemIndexes: [],
        amount: 0,
        itemsGapSize: 0,
      })

      var transitionStyles = {
        position: 'relative',
        transition: 'all .4s ease-in-out',
        '-webkit-transition': 'all .4s ease-in-out',
      }
      var noTransitionStyles = {
        transform: 'none',
        transition: 'none',
        '-webkit-transition': 'none',
      }

      // ensure item indexes are sorted ascending
      var indexes = options.itemIndexes.slice()
      indexes.sort(function(a, b) {
        return a - b
      })

      // find out which direction the items will be moved
      var isMoveUp = options.amount < 0

      // find index position where the items will be moved to
      var targetIndex =
        options.amount + (isMoveUp ? _.head(indexes) : _.last(indexes))

      // find item indexes to be moved upwards and downwards
      var upwardIndexes = []
      var downwardIndexes = []
      if (isMoveUp) {
        upwardIndexes = indexes.slice()
        downwardIndexes = [targetIndex]
        for (var i = _.last(indexes); i > targetIndex; i--) {
          if (indexes.includes(i)) continue
          downwardIndexes.push(i)
        }
        downwardIndexes.sort(function(a, b) {
          return a - b
        })
      } else {
        downwardIndexes = indexes.slice()
        upwardIndexes = [targetIndex]
        for (var i = _.head(indexes); i < targetIndex; i++) {
          if (indexes.includes(i)) continue
          upwardIndexes.push(i)
        }
        upwardIndexes.sort(function(a, b) {
          return a - b
        })
      }

      function makeItemObj(index) {
        var obj = {}
        obj.elem = angular.element(
          document.querySelectorAll('.' + options.itemClassPrefix + index)[0]
        )
        obj.bounds = obj.elem[0].getBoundingClientRect()
        obj.elem.css(transitionStyles)
        return obj
      }
      var upwardItems = upwardIndexes.map(makeItemObj)
      var downwardItems = downwardIndexes.map(makeItemObj)

      // calculate the first upward item new top
      var firstUpwardItem = _.head(upwardItems)
      var upwardTargetItem = _.head(downwardItems)
      firstUpwardItem.newTop =
        upwardTargetItem.bounds.top - firstUpwardItem.bounds.top

      // calculate the last downward item new top
      var lastDownwardItem = _.last(downwardItems)
      var downwardTargetItem = _.last(upwardItems)
      lastDownwardItem.newTop =
        downwardTargetItem.bounds.bottom - lastDownwardItem.bounds.bottom

      // calculate new top for remaining upward items based on item before it
      // separate first upward item and store it as temp item and use it as the initial previous upward item
      var tempUpwardItem = upwardItems.shift()
      var prevUpwardItem = tempUpwardItem
      upwardItems.forEach(function(upwardItem) {
        upwardItem.newTop =
          prevUpwardItem.newTop +
          prevUpwardItem.bounds.bottom -
          upwardItem.bounds.top +
          options.itemsGapSize
        prevUpwardItem = upwardItem
      })
      upwardItems.unshift(tempUpwardItem) // put back the first upward item

      // calculate new top for remaining downward items based on item before it
      // separate last downward item and store it as temp item and use it as the initial previous downward item
      var tempDownwardItem = downwardItems.pop()
      var prevDownwardItem = tempDownwardItem
      _.forEachRight(downwardItems, function(downwardItem) {
        downwardItem.newTop =
          prevDownwardItem.newTop +
          prevDownwardItem.bounds.top -
          downwardItem.bounds.bottom -
          options.itemsGapSize
        prevDownwardItem = downwardItem
      })
      downwardItems.push(tempDownwardItem) // put back the last downward item

      // create animate promise objects and invoke animations
      var allItems = upwardItems.concat(downwardItems)
      var promises = allItems.map(function(item) {
        return $animate.animate(item.elem, null, {
          transform: 'translateY(' + item.newTop + 'px)',
        })
      })
      return $q.all(promises).then(function() {
        allItems.forEach(function(item) {
          item.elem.css(noTransitionStyles)
        })
      })
    }

    function stringReverse(str) {
      // Utility function to reverse string

      return str
        .split('')
        .reverse()
        .join('')
    }

    function stringReplaceAt(str, start, end, replacement) {
      // Utility function to replace string based on position

      return str.slice(0, start) + replacement + str.slice(end)
    }

    function clampImageSize(
      originalWidth,
      originalHeight,
      maxWidth,
      maxHeight
    ) {
      // Utility function to clamp image width and height
      // copied from g-image.component.js

      // clamp width first
      var width = _.clamp(originalWidth, maxWidth)
      var ratio = width / originalWidth
      var height = ratio * originalHeight
      // then adjust height
      if (maxHeight) {
        height = _.clamp(height, maxHeight)
        ratio = height / originalHeight
        width = ratio * originalWidth
      }
      return {
        width: width,
        height: height,
      }
    }

    function validateUrl(url) {
      var VALID_URL = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i
      return VALID_URL.test(url)
    }

    /**
     * @name fetchBlobDataFromUrl
     * @description fetch blob data from given url
     * @param  {String} url an url
     * @return {Promise} a promise which resolves to blob data
     */
    function fetchBlobDataFromUrl(url) {
      return fetch(url)
        .then(function(response) {
          return response.blob()
        })
        .catch(function(err) {
          console.error(err)
          return $q.reject(err)
        })
    }

    function bulkMove(collection, items, amount, path) {
      var target
      var isAfterTarget
      if (amount < 0) {
        var firstViewIndex = collection.indexOf(_.head(items))
        target = collection[firstViewIndex + amount]
        isAfterTarget = false
      }
      if (amount > 0) {
        var lastViewIndex = collection.indexOf(_.last(items))
        target = collection[lastViewIndex + amount]
        isAfterTarget = true
      }
      // remove items to be moved and store it in variable
      var itemsToBeMoved = _.remove(collection, function(item) {
        return !!_.find(items, [path, _.get(item, path)])
      })
      // get the target index
      var toIndex = collection.indexOf(target)
      if (isAfterTarget) {
        toIndex++
      }
      // insert the removed views to target index
      Array.prototype.splice.apply(
        collection,
        [toIndex, 0].concat(itemsToBeMoved)
      )
    }

    function shiftSelect(
      event,
      index,
      anchorIndex,
      collection,
      isSelectedNow,
      setSelected
    ) {
      if (event.shiftKey && anchorIndex !== null) {
        var start = Math.min(anchorIndex, index)
        var end = Math.max(anchorIndex, index)
        for (var i = start; i <= end; i++) {
          setSelected(collection[i], !isSelectedNow)
        }
      } else {
        setSelected(collection[index], !isSelectedNow)
      }
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.services').factory('websiteService', Service)

  /* @ngInject */
  function Service() {
    var websiteUrl = 'https://www.glowfeed.com'

    var service = {
      getWebsiteUrl: getWebsiteUrl,
      getTermsUrl: getTermsUrl,
      getPrivacyUrl: getPrivacyUrl,
      getPackThankyouUrl: getPackThankyouUrl,
      getPackThankyouUrlAu: getPackThankyouUrlAu,
      getPackThankyouUrlUk: getPackThankyouUrlUk,
      getPackThankyouSignupUrl: getPackThankyouSignupUrl,
      getPackThankyouSignupUrlAu: getPackThankyouSignupUrlAu,
      getPackThankyouSignupUrlUk: getPackThankyouSignupUrlUk,
    }

    return service

    function getWebsiteUrl() {
      return websiteUrl
    }

    function getTermsUrl() {
      return getWebsiteUrl() + '/about-us/terms-of-use'
    }

    function getPrivacyUrl() {
      return getWebsiteUrl() + '/about-us/privacy-policy'
    }

    // These are for the original sign up and purchase Pack journey
    function getPackThankyouUrl() {
      return getWebsiteUrl() + '/thank-you-download-generic'
    }

    function getPackThankyouUrlAu() {
      return getWebsiteUrl() + '/thank-you-download-au'
    }

    function getPackThankyouUrlUk() {
      return getWebsiteUrl() + '/uk/thank-you-download-uk'
    }

    // These are for the sign up to preview a Pack journey
    function getPackThankyouSignupUrl() {
      return getWebsiteUrl() + '/thank-you-sign-up-generic'
    }

    function getPackThankyouSignupUrlAu() {
      return getWebsiteUrl() + '/thank-you-sign-up-au'
    }

    function getPackThankyouSignupUrlUk() {
      return getWebsiteUrl() + '/uk/thank-you-sign-up-uk'
    }
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  // eslint-disable-next-line no-unused-vars
  function config(resourcesProvider) {
    // resourcesProvider.create('survey', {
    //     url: '/surveys/:id',
    //     params: {
    //         id: '@id'
    //     },
    //     actions: {
    //         get: {
    //             method: 'GET'
    //         },
    //         save: {
    //             method: 'PUT',
    //             transformRequest: transformRequest
    //         },
    //         list: {
    //             method: 'GET',
    //             url: '/element/:elementId/surveys',
    //             isArray: true
    //         }
    //     }
    // });
    // function transformRequest (data, headersGetter) {
    //     return {
    //         id: data.id,
    //         elementId: data.elementId,
    //         title: data.title,
    //         startAt: data.startAt,
    //         endAt: data.endAt,
    //         couponId: data.rewards && data.rewards.coupon,
    //         promote: data.promote,
    //         notify: data.notify,
    //         questions: data.questions
    //     };
    // }
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('accessTokens', {
      url: '/tokens',
      actions: {
        generate: {
          method: 'POST',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('activityStreams', {
      url: '/activity-streams',
      actions: {
        get: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('adminStats', {
      url: '/admin-stats',
      actions: {
        get: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('analytics', {
      url: '/analytics',
      actions: {
        save: {
          method: 'POST',
          insecure: true,
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('assetTokens', {
      url: '/asset-tokens',
      params: {},
      actions: {
        create: {
          method: 'POST',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('assets', {
      url: '/assets/:id',
      params: {
        id: '@id',
      },
      actions: {
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('audienceChannels', {
      url: '/audience-channels/:id',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
          url: '/audience-channels',
        },
        update: {
          method: 'PUT',
        },
        getBySurvey: {
          method: 'GET',
          query: 'GetChannelsBySurvey',
        },
        disableBySurvey: {
          method: 'PUT',
          command: 'DisableChannelsBySurvey',
        },
        getBySubscriber: {
          method: 'GET',
          query: 'GetChannelsBySubscriber',
        },
        getByProduct: {
          method: 'GET',
          query: 'GetChannelByProduct',
        },
        getByPlace: {
          method: 'GET',
          query: 'GetChannelByPlace',
        },
        list: {
          method: 'GET',
        },
        preCheck: {
          url: '/audience-channels/:id/precheck',
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('audio', {
      url: '/assets/audio',
      actions: {
        create: {
          // expects {filename: String, fileData: dataURL}
          // returns {id: UUID, assetUrl: String}
          method: 'POST',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('auth', {
      url: '/user',
      params: {
        id: '@id',
      },
      actions: {
        /* login
                 * @desc exchange email/password for an auth token
                 * @returns { id, token }
                 */
        login: {
          method: 'POST',
          url: '/tokens',
        },

        /* signup
                 * @desc create a new user
                 * @returns { id, token }
                 */
        signup: {
          method: 'POST',
          url: '/customers',
        },

        /* me
                 * @desc get my user profile using the current auth header
                 * @returns { id, group: { id }, username, email, fullname, roles: [] }
                 */
        me: {
          method: 'POST',
          url: '/user',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('beacons', {
      url: '/beacons/:id',
      params: {
        id: '@id',
        slug: '@slug',
      },
      actions: {
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        getBySlug: {
          url: '/beacons/:slug',
          method: 'GET',
          query: 'GetBySlug',
        },
        getBySubscriber: {
          method: 'GET',
          url: '/subscribers/:id/beacons',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('bundles', {
      url: '/bundles/:id',
      params: {
        id: '@id',
      },
      actions: {
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        get: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('charges', {
      url: '/charges',
      actions: {
        get: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('contentGroups', {
      url: '/content-groups/:id',
      params: {
        id: '@id',
      },
      actions: {
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('coupons', {
      url: '/coupons/:id',
      params: {
        id: '@id',
        subscriberId: '@subscriberId',
      },
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
        },
        createSecure: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        saveImage: {
          url: '/coupons/:id/image',
          method: 'POST',
        },
        saveRedemptionImage: {
          url: '/coupons/:id/redemption-image',
          method: 'POST',
        },
        getBySubscriber: {
          url: '/subscribers/:subscriberId/coupons',
          method: 'GET',
        },
        deleteBySubscriber: {
          url: '/subscribers/:subscriberId/coupons/:id',
          method: 'DELETE',
        },

        // dispatch a coupon to a user
        dispatchToUser: {
          url: '/coupon-dispatches',
          method: 'POST',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('creditPromotions', {
      url: '/credit-promotions/:id',
      params: {
        id: '@id',
        token: '@token',
      },
      actions: {
        get: {
          method: 'GET',
        },
        list: {
          method: 'GET',
        },
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        attemptActivation: {
          url: '/credit-promotions/:token/activate',
          method: 'PUT',
        },
        getByToken: {
          method: 'GET',
          view: 'GetByToken',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('crossTabs', {
      url: '/crosstabs/:id',
      params: {
        id: '@id',
        surveyId: '@surveyId',
      },
      actions: {
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
        get: {
          method: 'GET',
        },
        getBySurvey: {
          method: 'GET',
          url: '/surveys/:surveyId/crosstabs',
        },
      },
    })
  }
})()

;(function () {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config (resourcesProvider) {
    resourcesProvider.create('crowds', {
      url: '/crowds',
      params: {},
      actions: {
        join: {
          method: 'POST'
        },
        leave: {
          method: 'DELETE'
        },
        get: {
          method: 'GET'
        }
      }
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('dashboardAggregates', {
      url: '/dashboard-aggregates',
      actions: {
        get: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('devices', {
      url: '/devices',
      actions: {
        get: {
          method: 'GET',
        },
        save: {
          method: 'POST',
          insecure: true,
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('edges', {
      url: '/edges/:id',
      params: {
        id: '@id',
      },
      actions: {
        create: {
          method: 'POST',
        },
        remove: {
          method: 'DELETE',
        },
      },
    })
  }
})()

angular.module('glow.components.templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('alert-dialog.template.html','<gl-dialog class="alert-dialog"><div class="alert-dialog__content"><div class="alert-dialog__title" ng-if="title">{{ title }}</div><div class="alert-dialog__message" compile-html="message | glNToBr"></div><label class="gl-form-checkbox-group" ng-if="disengageId" for="disengage" style="margin: 16px 0 0;"><input class="gl-checkbox" type="checkbox" id="disengage" ng-model="didDisengage" ng-change="setDisengage(didDisengage)"/><div class="gl-form-label">Don\'t show this again</div></label></div><div class="alert-dialog__actions"><g-btn class="alert-dialog__action" label="{{ closeText || &quot;Okay&quot; }}" on-click="dialog.close()"></g-btn><g-btn class="alert-dialog__action" ng-if="confirm" label="{{ cancelText || &quot;Cancel&quot; }}" on-click="dialog.cancel()" secondary="true"></g-btn></div></gl-dialog>');
$templateCache.put('asset-download.html','<gl-dialog class="asset-download"><div class="asset-download__content"><div class="asset-download__title">{{ title }}</div><div class="asset-download__desc">{{ desc }}</div><a class="asset-download__btn" ng-href="{{ url }}" download="" ng-click="dialog.close()" target="_blank">Download</a></div></gl-dialog>');
$templateCache.put('bundle-card.html','<div class="bundle-card"><div class="bundle-card__title"><g-icon icon="bundle" size="large"></g-icon><div class="bundle-card__name">{{ $ctrl.bundle.name }}</div></div><div class="bundle-card__desc" compile-html="$ctrl.bundle.desc"></div><div class="bundle-card__feature -first"><div class="bundle-card__feature-info"><div class="bundle-card__feature-name">{{ $ctrl.bundle.credit.byCurrency($ctrl.currency).format() }} Credit</div><div class="bundle-card__feature-desc">To use on consumer panel survey responses.</div></div><div class="bundle-card__feature-cost">{{ $ctrl.bundle.credit.byCurrency($ctrl.currency).format() }}</div></div><div class="bundle-card__feature"><div class="bundle-card__feature-info"><div class="bundle-card__feature-name">1 QA Review</div><div class="bundle-card__feature-desc">Quality assurance backed by a team of research analysts</div></div><div class="bundle-card__feature-cost">{{ $ctrl.bundle.reviewPrice.byCurency($ctrl.currency).format() }}</div></div><div class="bundle-card__feature"><div class="bundle-card__feature-info"><div class="bundle-card__feature-name">Subtotal</div></div><div class="bundle-card__feature-cost -strike -detract">{{ $ctrl.bundle.getSubtotal($ctrl.currency).format() }}</div></div><div class="bundle-card__feature"><div class="bundle-card__feature-info"><div class="bundle-card__feature-name">Total</div><div class="bundle-card__feature-desc">Save {{ $ctrl.bundle.getSavingsCost($ctrl.currency).format() }} ({{ $ctrl.bundle.getSavingsPercent($ctrl.currency) }} discount)</div></div><div class="bundle-card__feature-cost -emphasis">{{ $ctrl.bundle.price.byCurrency($ctrl.currency).format({ currency: true }) }}</div></div><div class="bundle-card__footer"> <g-btn class="bundle-card__cta" label="Purchase" on-click="$ctrl.onSelect({ $bundle: $ctrl.bundle })"></g-btn><div class="bundle-card__terms">*Limited time offer. Restrictions apply - See <a href="https://www.glowfeed.com/about-us/terms-of-use" target="blank">T&C\'s</a> for bundle terms.</div></div></div>');
$templateCache.put('bundle-selector.html','<div class="bundle-selector"><div class="bundle-selector__loading" ng-if="$ctrl.state.isLoading()"><g-spinner block="true"></g-spinner></div><div class="bundle-selector__zero" ng-if="$ctrl.state.isZero()"><g-zero title="No Bundles" message="It looks like there are no bundles available right now, please check back soon!" image="svg/undraw_launching_125y.svg"></g-zero></div><div class="bundle-selector__list" ng-if="$ctrl.state.isReady()"><div class="bundle-selector__list-item" ng-repeat="bundle in $ctrl.bundles | filter:$ctrl.isVisible | orderBy:$ctrl.orderBy track by bundle.id"><bundle-card bundle="bundle" currency="$ctrl.currency" on-select="$ctrl.onSelect({ $bundle: bundle })"></bundle-card></div></div><div class="bundle-selector__footer"><span>Have some questions?</span><a class="bundle-selector__link" ng-click="$ctrl.openChat()">Chat to us</a></div></div>');
$templateCache.put('choice-fields.html','<list-input label="{{ $ctrl.listInputLabel }}" survey="$ctrl.question.survey" lender="$ctrl.question.choiceLender" get-prev-questions="$ctrl.question.getPrevQuestions()" model="$ctrl.question.choices" presets="null" max-items="null" randomize-headings="$ctrl.question.randomizeChoiceHeadings" randomize-items="$ctrl.question.randomizeChoices" images-enabled="$ctrl.question.choiceImagesEnabled" labels-hidden="$ctrl.question.choiceLabelsHidden" grid-column-max="$ctrl.question.choiceGridColumnMax" parent-id="$ctrl.question.id" add-only="$ctrl.isRestricted" disabled="false" is-template="$ctrl.question.isTemplate" is-text-capture-option="$ctrl.isTextCaptureOption()" is-unique-text-capture="false" is-exclusive-option="$ctrl.isExclusiveOption()" is-anchor-option="$ctrl.isAnchorOption()" is-independent-option="false" is-heading-option="$ctrl.question.supportsChoiceHeadings()" is-randomize-option="true" is-score-option="false" is-borrow-from-option="true" is-borrow-from-persist-option="true" is-borrow-from-displayed-options="true" is-copy-from-option="true" is-hide-labels-option="$ctrl.isHideLabelsOption()" is-images-option="$ctrl.question.canHaveChoiceImages()" is-grid-column-max-option="$ctrl.isGridColumnMaxOption()" is-logic-editor-option="true" on-randomize-headings="$ctrl.question.randomizeChoiceHeadings = $value" on-randomize-items="$ctrl.question.randomizeChoices = $value" on-hidden-labels-toggle="$ctrl.question.choiceLabelsHidden = !$ctrl.question.choiceLabelsHidden" on-copy-from="$ctrl.question.copyChoicesFrom($questionId, $target, false)" on-borrow-from="$ctrl.question.borrowChoicesFrom($questionId, false)" on-image-change="$ctrl.onImageChange($item, $imageData)" on-images-toggle="$ctrl.question.choiceImagesEnabled = !$ctrl.question.choiceImagesEnabled" on-item-add="$ctrl.question.addChoice($item, $index, $shouldReplace)" on-tags-add="$ctrl.question.addChoiceDisplayLogicWithTags($item, $tags)" on-grid-column-max="$ctrl.question.choiceGridColumnMax = $value"></list-input><div class="gl-form-group" ng-if="$ctrl.isMinField()"><label class="gl-form-label" for="question{{ $ctrl.question.id }}minSelections">Minimum choices respondent should select (leave blank to be optional)</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}minSelections" type="number" min="-1" name="question{{ $ctrl.question.id }}minSelections" ng-model="$ctrl.question.minSelections"/></div><div class="gl-form-group" ng-if="$ctrl.isMaxField()"><label class="gl-form-label" for="question{{ $ctrl.question.id }}maxSelections">Maximum choices respondent can select (leave blank for unlimited)</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}maxSelections" type="number" min="1" name="question{{ $ctrl.question.id }}maxSelections" ng-model="$ctrl.question.maxSelections"/></div><div class="gl-form-checkbox-group" ng-if="$ctrl.isSamplingField()"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}choiceSamplingEnabled" ng-model="$ctrl.question.choiceSamplingEnabled"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}choiceSamplingEnabled" hint="Randomly select a number of choices to be shown to each respondent. Uses Fisher Yates algorithm." inline="true">Sample choices</field-label></div><div class="gl-form-group choice-fields__child-group" ng-if="$ctrl.question.choiceSamplingEnabled"><label class="gl-form-label" for="question{{ $ctrl.question.id }}choiceSamplingAmount">Number of choices to sample</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}choiceSamplingAmount" type="number" min="1" name="question{{ $ctrl.question.id }}choiceSamplingAmount" ng-model="$ctrl.question.choiceSamplingAmount"/></div>');
$templateCache.put('constant-sum-fields.html','<div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}matrixEnabled" ng-model="$ctrl.question.matrixEnabled" ng-disabled="$ctrl.isRestricted"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}matrixEnabled" inline="true">Use as Matrix</field-label></div><list-input ng-if="$ctrl.question.matrixEnabled" label="Statements" survey="$ctrl.question.survey" lender="$ctrl.question.statementLender" get-prev-questions="$ctrl.question.getPrevQuestions()" model="$ctrl.question.statements" presets="null" max-items="null" randomize-headings="$ctrl.question.randomizeStatementHeadings" randomize-items="$ctrl.question.randomizeStatements" images-enabled="$ctrl.question.statementImagesEnabled" labels-hidden="$ctrl.question.statementLabelsHidden" parent-id="$ctrl.question.id" add-only="$ctrl.isRestricted" disabled="false" is-template="$ctrl.question.isTemplate" is-text-capture-option="false" is-unique-text-capture="false" is-exclusive-option="false" is-anchor-option="true" is-independent-option="false" is-heading-option="false" is-randomize-option="true" is-score-option="false" is-borrow-from-option="true" is-borrow-from-persist-option="true" is-borrow-from-displayed-options="true" is-copy-from-option="true" is-hide-labels-option="true" is-images-option="$ctrl.question.canHaveStatementImages()" is-logic-editor-option="true" on-randomize-headings="$ctrl.question.randomizeStatementHeadings = $value" on-randomize-items="$ctrl.question.randomizeStatements = $value" on-hidden-labels-toggle="$ctrl.question.statementLabelsHidden = !$ctrl.question.statementLabelsHidden" on-copy-from="$ctrl.question.copyChoicesFrom($questionId, $target, true)" on-borrow-from="$ctrl.question.borrowChoicesFrom($questionId, true)" on-image-change="$ctrl.onImageChange($item, $imageData)" on-images-toggle="$ctrl.question.statementImagesEnabled = !$ctrl.question.statementImagesEnabled" on-item-add="$ctrl.question.addStatement($item, $index, $shouldReplace)" on-tags-add="$ctrl.question.addChoiceDisplayLogicWithTags($item, $tags)"></list-input><list-input label="Choices" survey="$ctrl.question.survey" lender="$ctrl.question.choiceLender" get-prev-questions="$ctrl.question.getPrevQuestions()" model="$ctrl.question.choices" presets="null" max-items="11" randomize-headings="$ctrl.question.randomizeChoiceHeadings" randomize-items="$ctrl.question.randomizeChoices" images-enabled="$ctrl.question.choiceImagesEnabled" labels-hidden="$ctrl.question.choiceLabelsHidden" parent-id="$ctrl.question.id" add-only="$ctrl.isRestricted" disabled="$ctrl.isRestricted &amp;&amp; $ctrl.question.matrixEnabled" is-template="$ctrl.question.isTemplate" is-text-capture-option="false" is-unique-text-capture="false" is-exclusive-option="false" is-anchor-option="true" is-independent-option="false" is-heading-option="false" is-randomize-option="true" is-score-option="false" is-borrow-from-option="true" is-borrow-from-persist-option="true" is-borrow-from-displayed-options="true" is-copy-from-option="true" is-hide-labels-option="true" is-images-option="$ctrl.question.canHaveChoiceImages()" is-logic-editor-option="true" on-randomize-headings="$ctrl.question.randomizeChoiceHeadings = $value" on-randomize-items="$ctrl.question.randomizeChoices = $value" on-hidden-labels-toggle="$ctrl.question.choiceLabelsHidden = !$ctrl.question.choiceLabelsHidden" on-copy-from="$ctrl.question.copyChoicesFrom($questionId, $target, false)" on-borrow-from="$ctrl.question.borrowChoicesFrom($questionId, false)" on-image-change="$ctrl.onImageChange($item, $imageData)" on-images-toggle="$ctrl.question.choiceImagesEnabled = !$ctrl.question.choiceImagesEnabled" on-item-add="$ctrl.question.addChoice($item, $index, $shouldReplace)" on-tags-add="$ctrl.question.addChoiceDisplayLogicWithTags($item, $tags)"></list-input><div class="constant-sum-fields__split"><div><div class="gl-form-group"><field-label class="gl-form-label" hint="Require respondents to enter values that add up to a total amount validated by the selected quantifier." inline="true">Total Required</field-label><gl-multiselect-dropdown single-select="single-select" options="$ctrl.question.ConstantSumTotalQuantifierOptions" selected-model="$ctrl.quantifier" on-select="$ctrl.onQuantifierChange" extra-settings="{ displayProp: &quot;label&quot;, idProp: &quot;value&quot;, externalIdProp: &quot;value&quot;, showCheckAll: false, showUncheckAll: false }"></gl-multiselect-dropdown></div></div><div ng-if="$ctrl.quantifier.value &amp;&amp; $ctrl.quantifier.value !== $ctrl.question.ConstantSumTotalQuantifiers.BETWEEN"><constant-sum-total-field question="$ctrl.question" key="constantSumTotal" model="$ctrl.question.constantSumTotal" pipes="$ctrl.question.constantSumTotalPipes" pipes-allowed="$ctrl.pipesAllowed" get-pipe-questions="$ctrl.getPipeQuestions()"></constant-sum-total-field></div><div class="constant-sum-fields__split" ng-if="$ctrl.quantifier.value &amp;&amp; $ctrl.quantifier.value === $ctrl.question.ConstantSumTotalQuantifiers.BETWEEN"><div><constant-sum-total-field question="$ctrl.question" key="constantSumTotalMin" model="$ctrl.question.constantSumTotalMin" pipes="$ctrl.question.constantSumTotalMinPipes" pipes-allowed="$ctrl.pipesAllowed" get-pipe-questions="$ctrl.getPipeQuestions()"></constant-sum-total-field></div><div><constant-sum-total-field question="$ctrl.question" key="constantSumTotalMax" model="$ctrl.question.constantSumTotalMax" pipes="$ctrl.question.constantSumTotalMaxPipes" pipes-allowed="$ctrl.pipesAllowed" get-pipe-questions="$ctrl.getPipeQuestions()"></constant-sum-total-field></div></div></div><div class="gl-form-group" ng-if="$ctrl.question.matrixEnabled &amp;&amp; $ctrl.quantifier.value"><field-label class="gl-form-label" inline="true">Statements Override</field-label><field-select inline="false" placeholder="Statements" multi="true" all-toggle="true" search="$ctrl.statementOptions.length &gt; 10" large-list="$ctrl.statementOptions.length &gt; 10" options="$ctrl.statementOptions" selected="$ctrl.selectedStatements" on-before-open="$ctrl.makeStatementOptions()" on-change="$ctrl.onStatementsChange($value)"></field-select></div><div class="constant-sum-fields__split" ng-repeat="rule in $ctrl.question.constantSumStatementRules track by rule.statementId"><div class="center"><field-label class="gl-form-label" inline="true">{{ $ctrl.getStatementLabel(rule.statementId) }}</field-label></div><div ng-if="$ctrl.quantifier.value &amp;&amp; $ctrl.quantifier.value !== $ctrl.question.ConstantSumTotalQuantifiers.BETWEEN"><constant-sum-total-field question="$ctrl.question" key="{{&quot;statementRuleTotal-&quot; + rule.statementId}}" model="rule.total" pipes="rule.totalPipes" pipes-allowed="$ctrl.pipesAllowed" get-pipe-questions="$ctrl.getPipeQuestions()"></constant-sum-total-field></div><div class="constant-sum-fields__split" ng-if="$ctrl.quantifier.value &amp;&amp; $ctrl.quantifier.value === $ctrl.question.ConstantSumTotalQuantifiers.BETWEEN"><div><constant-sum-total-field question="$ctrl.question" key="{{&quot;statementRuleMin-&quot; + rule.statementId}}" model="rule.min" pipes="rule.minPipes" pipes-allowed="$ctrl.pipesAllowed" get-pipe-questions="$ctrl.getPipeQuestions()"></constant-sum-total-field></div><div><constant-sum-total-field question="$ctrl.question" key="{{&quot;statementRuleMax-&quot; + rule.statementId}}" model="rule.max" pipes="rule.maxPipes" pipes-allowed="$ctrl.pipesAllowed" get-pipe-questions="$ctrl.getPipeQuestions()"></constant-sum-total-field></div></div></div><div class="constant-sum-fields__split"><div><div class="gl-form-group"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}numberMinValue" hint="Minimum number allowed to be entered" inline="true">Minimum</field-label><input class="gl-form-control" id="question{{ $ctrl.question.id }}numberMinValue" type="number" min="0" name="question{{ $ctrl.question.id }}numberMinValue" ng-model="$ctrl.question.numberMinValue"/></div></div><div><div class="gl-form-group"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}numberMaxValue" hint="Maximum number allowed to be entered" inline="true">Maximum</field-label><input class="gl-form-control" id="question{{ $ctrl.question.id }}numberMaxValue" type="number" min="1" name="question{{ $ctrl.question.id }}numberMaxValue" ng-model="$ctrl.question.numberMaxValue"/></div></div></div><div class="gl-form-group"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}numberInterval" hint="Interval number allowed to be entered (leave blank to allow decimals)" inline="true">Interval</field-label><input class="gl-form-control" id="question{{ $ctrl.question.id }}numberInterval" type="number" min="1" name="question{{ $ctrl.question.id }}numberInterval" ng-model="$ctrl.question.numberInterval"/></div><div class="constant-sum-fields__split"><div><div class="gl-form-group"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}textPrefix" inline="true">Prefix</field-label><input class="gl-form-control" id="question{{ $ctrl.question.id }}textPrefix" type="text" name="question{{ $ctrl.question.id }}textPrefix" ng-model="$ctrl.question.textPrefix"/></div></div><div><div class="gl-form-group"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}textSuffix" inline="true">Suffix</field-label><input class="gl-form-control" id="question{{ $ctrl.question.id }}textSuffix" type="text" name="question{{ $ctrl.question.id }}textSuffix" ng-model="$ctrl.question.textSuffix"/></div></div></div><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}constantSumShowTotal" ng-model="$ctrl.question.constantSumShowTotal"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}constantSumShowTotal" hint="Show respondents the total amount they have entered" inline="true">Show total</field-label></div><div class="gl-form-checkbox-group" ng-if="$ctrl.question.matrixEnabled"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}flipTableAxis" ng-model="$ctrl.question.flipTableAxis"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}flipTableAxis" hint="On large screens respondents see a table view that you may want to flip. On small screens respondents see vertical blocks for each statement." inline="true">Flip table axis</field-label></div>');
$templateCache.put('constant-sum-total-field.html','<div class="constant-sum-total-field gl-form-group"><div class="constant-sum-total-field__top"><g-menu ng-if="$ctrl.shouldShowInserter()" on-before-open="$ctrl.prepareMenu()" align="bottom-right"><g-menu-box class="-scroll" g-menu-content="g-menu-content" max-width="320px"><g-menu-item ng-repeat="question in $ctrl.pipeQuestions" text="{{ question.getTitleLabel({ number: true }) }}" highlight="$ctrl.pipes.has(question.getNumber())" on-click="$ctrl.insertPipe(question.getNumber())"></g-menu-item></g-menu-box><micro-action icon="expand-more">Insert answer</micro-action></g-menu></div><input class="gl-form-control constant-sum-total-field__input-number" ng-if="!$ctrl.shouldShowTextInput()" ng-init="$ctrl.initInput(&quot;number&quot;)" id="question{{ $ctrl.question.id }}{{ $ctrl.key }}" type="number" name="question{{ $ctrl.question.id }}{{ $ctrl.key }}" ng-focus="$ctrl.setEditing(true)" ng-blur="$ctrl.setEditing(false)" ng-model="$ctrl.model"/><div ng-if="$ctrl.shouldShowTextInput()" ng-init="$ctrl.initInput(&quot;text&quot;)"><input class="gl-form-control constant-sum-total-field__input-text" id="question{{ $ctrl.question.id }}{{ $ctrl.key }}" type="text" name="question{{ $ctrl.question.id }}{{ $ctrl.key }}" ng-focus="$ctrl.setEditing(true)" ng-blur="$ctrl.setEditing(false); $ctrl.cleanPipeString()" autocomplete="off"/><g-icon-button class="constant-sum-total-field__btn-clear" ng-if="$ctrl.isEditing" icon="close" size="SMALL" on-click="$ctrl.clearPipes()"></g-icon-button></div></div>');
$templateCache.put('credit-promotion-thanks-dialog.html','<div class="credit-promotion-thanks-dialog__content"><p class="credit-promotion-thanks-dialog__icon"><g-icon icon="glow-man" size="40" color="ORANGE_BLAZE"></g-icon></p><p class="credit-promotion-thanks-dialog__title">Welcome to the Glow Growth Program!</p><p class="credit-promotion-thanks-dialog__subtitle">Your grant has been activated with the credits added to your balance. </p><div class="credit-promotion-thanks-dialog__text"><ul><li>View credit balance and grant details on the home screen or in the \'billing\' section of your account</li><li>FAQs and support <a href="https://docs.glowfeed.com/" target="_blank">documentation</a></li><li><a href="https://campaign.glowfeed.com/book-an-intro" target="_blank">Contact us</a> to get help with your next project or discuss your specific needs</li></ul></div><div class="credit-promotion-thanks-dialog__button"><g-btn label="Let\'s go" on-click="$ctrl.onDone()"></g-btn></div></div>');
$templateCache.put('definition-popup.html','<span class="definition-popup__label"><span class="definition-popup__label-text">{{ $ctrl.label }}</span><g-icon class="definition-popup__label-icon" icon="help" size="16" color="INHERIT"></g-icon><gl-hint>{{ $ctrl.definition }}</gl-hint></span>');
$templateCache.put('errors.html','<ul class="errors__container"><li class="errors__error" ng-repeat="error in $ctrl.errors track by $index"> <span ng-if="$ctrl.errors.length &gt; 1">- </span><span>{{ error }}</span></li></ul>');
$templateCache.put('external-panel-selector.html','<div class="external-panel-selector__content"><div class="external-panel-selector__items"><div ng-repeat="provider in $ctrl.providers"><div class="external-panel-selector__item" ng-click="$ctrl.onSelect({ $provider: provider })"> <div class="external-panel-selector__item-image" ng-style="{ backgroundImage: &quot;url(&quot; + provider.logoUrl + &quot;)&quot; }"></div><div class="external-panel-selector__item-name">{{ provider.name }}</div></div></div></div></div>');
$templateCache.put('field-checkbox.html','<div class="field-checkbox" ng-class="{ &quot;-inline&quot;: $ctrl.inline }"><div class="field-checkbox__box" ng-class="{ &quot;-checked&quot;: $ctrl.checked, &quot;-highlight&quot;: $ctrl.highlight }" ng-click="$ctrl.onClick()"><g-icon class="field-checkbox__icon" icon="done" color="INHERIT" size="small"></g-icon></div><field-label key="{{ $ctrl.key }}" inline="true" disabled="$ctrl.disabled" hint="{{ $ctrl.hint }}"><span ng-transclude=""></span></field-label></div><input class="field-checkbox__control" type="checkbox" id="{{ $ctrl.key }}" name="{{ $ctrl.key }}" ng-disabled="$ctrl.disabled" ng-model="$ctrl.control" ng-change="$ctrl.onClick()"/>');
$templateCache.put('field-error-message.html','<ng-message class="field-error-message" when="{{ $ctrl.when }}" ng-transclude=""></ng-message>');
$templateCache.put('field-error.html','<ng-messages class="field-error" for="$ctrl.form[$ctrl.field].$error" ng-show="$ctrl.form[$ctrl.field].$touched" ng-transclude=""></ng-messages>');
$templateCache.put('field-file.html','<label class="field-file" for="{{ $ctrl.key }}"><g-spinner class="field-file__loading" ng-if="$ctrl.loading" size="15"></g-spinner><div class="field-file__placeholder" ng-if="!$ctrl.model &amp;&amp; !$ctrl.error &amp;&amp; !$ctrl.loading">Choose</div><div class="field-file__filename" ng-if="$ctrl.model &amp;&amp; !$ctrl.error">{{ $ctrl.model.filename }}</div><div class="field-file__error" ng-if="$ctrl.error">{{ $ctrl.error }}</div><g-icon-button class="field-file__action" ng-if="$ctrl.model &amp;&amp; !$ctrl.error" icon="install" size="small" on-click="$ctrl.download()"></g-icon-button><g-icon-button class="field-file__action" ng-if="$ctrl.model &amp;&amp; !$ctrl.error" icon="close" size="small" on-click="$ctrl.remove()"></g-icon-button><input class="field-file__input" ng-if="!$ctrl.isRebuilding" type="file" id="{{ $ctrl.key }}" name="{{ $ctrl.key }}"/></label>');
$templateCache.put('field-image.html','<div class="field-image" ng-style="{ maxWidth: $ctrl.maxWidth &amp;&amp; ($ctrl.maxWidth + &quot;px&quot;) }"><span ng-style="$ctrl.ratioStyle()"></span><figure class="field-image__image" ng-style="$ctrl.imageStyle()"></figure><div class="field-image__placeholder" ng-show="!$ctrl.error &amp;&amp; !$ctrl.imageUrl()"><g-icon icon="image" color="rgba(BLACK, .54)"></g-icon><div class="field-image__placeholder-text" ng-if="$ctrl.placeholder" ng-bind="$ctrl.placeholder"></div></div><div class="field-image__error" ng-if="$ctrl.error"><div class="field-image__error-msg">{{ $ctrl.error }}</div></div><input class="field-image__input" ng-if="!$ctrl.rebuilding" id="{{ $ctrl.key }}" name="{{ $ctrl.key }}" type="file" ng-model="$ctrl.model" ng-attr-required="$ctrl.required"/><span class="field-image__close" ng-show="$ctrl.canRemove &amp;&amp; !$ctrl.loading &amp;&amp; $ctrl.imageUrl()" ng-click="$ctrl.clear(); $ctrl.rebuild()"><g-icon icon="close" color="INHERIT" size="small"></g-icon></span><div class="field-image__loading" ng-if="$ctrl.loading"><g-spinner></g-spinner></div></div>');
$templateCache.put('field-label.html','<div class="field-label" ng-class="{ \n        &quot;-inline&quot;: $ctrl.inline,\n        &quot;-disabled&quot;: $ctrl.disabled\n    }"><label for="{{ $ctrl.key }}" ng-transclude=""></label><span ng-if="$ctrl.hint"><g-icon class="field-label__icon" icon="help" size="small" color="rgba(BLACK, .2)"></g-icon><gl-hint>{{ $ctrl.hint }}</gl-hint></span></div>');
$templateCache.put('field-palette.html','<div class="field-palette" ng-class="{ &quot;-disabled&quot;: $ctrl.disabled }"><div class="field-palette__item" ng-repeat="color in $ctrl.value track by $index"><g-menu align="top-left" disabled="$ctrl.disabled" on-close="$ctrl.clean($index)"><div class="field-palette__color" ng-style="$ctrl.getStyle(color)"></div><div g-menu-content="g-menu-content"><div class="field-palette__edit"><div g-menu-open="true"><color-picker ng-model="$ctrl.value[$index]" color-picker-format="&quot;hex&quot;" color-picker-alpha="false" color-picker-case="upper" color-picker-swatch="false" color-picker-swatch-only="true" color-picker-inline="true"></color-picker><div class="field-palette__fields"><div class="field-palette__input"><field-text model="$ctrl.value[$index]" inline="true"></field-text></div><div class="field-palette__btn"><g-btn icon="delete" secondary="true" on-click="$ctrl.remove($index)" block="true"></g-btn></div></div></div></div></div></g-menu></div><div class="field-palette__add" ng-if="!$ctrl.disabled" ng-click="$ctrl.add()"><g-icon icon="add" color="INHERIT" size="small"></g-icon></div></div>');
$templateCache.put('field-radio-set.html','<div class="field-radio-set" ng-class="{ &quot;-vertical&quot;: $ctrl.vertical }" ng-transclude="ng-transclude"></div>');
$templateCache.put('field-radio.html','<div class="field-radio" ng-class="{ &quot;-inline&quot;: $ctrl.inline }" ng-click="$ctrl.onClick()"><div class="field-radio__box" ng-class="{ &quot;-selected&quot;: $ctrl.selected }"><div class="field-radio__selected"></div></div><field-label key="{{ $ctrl.key }}" inline="true" disabled="$ctrl.disabled" hint="{{ $ctrl.hint }}"><span ng-transclude=""></span></field-label></div>');
$templateCache.put('field-section-switch.html','<div class="field-section-switch"><label class="field-section-switch__label" ng-click="$ctrl.onClick()" ng-transclude=""></label><field-switch on="$ctrl.on" on-click="$ctrl.onClick()"></field-switch></div>');
$templateCache.put('field-section-toggle.html','<div class="field-section-toggle" ng-class="{ &quot;-open&quot;: $ctrl.open }" ng-click="$ctrl.onClick()"><g-icon class="field-section-toggle__icon" icon="expand-more" size="20" color="INHERIT"></g-icon><label class="field-section-toggle__label" ng-transclude=""></label></div>');
$templateCache.put('field-section.html','<div class="field-section" ng-transclude=""></div>');
$templateCache.put('field-select.html','<div class="field-select"><g-menu align="{{ $ctrl.align }}" disabled="$ctrl.isDisabled" close-on-input-focus="$ctrl.closeOnInputFocus" on-remote="$ctrl.menu = $remote" on-open="$ctrl.onOpen()" on-before-open="$ctrl.onBeforeOpen()" on-close="$ctrl.onClose()"><div ng-transclude="control"><label class="field-select__control" tabindex="0" ng-class="{ \n                    &quot;-open&quot;: $ctrl.isOpen, \n                    &quot;-disabled&quot;: $ctrl.isDisabled, \n                    &quot;-inline&quot;: $ctrl.inline \n                }"><div class="field-select__placeholder" ng-if="!$ctrl.value" ng-class="{ &quot;-blank&quot;: !$ctrl.placeholder }" title="{{ $ctrl.placeholder }}">{{ $ctrl.placeholder || "-" }}</div><div class="field-select__value" ng-if="$ctrl.value" title="{{ $ctrl.value }}">{{ $ctrl.value }}<div class="field-select__option-tag" ng-if="$ctrl.tag" ng-style="{ &quot;background-color&quot;: $ctrl.tagColor }">{{ $ctrl.tag }}</div></div><g-icon class="field-select__caret" icon="dropdown" color="INHERIT" size="small" ng-class="{ &quot;-open&quot;: $ctrl.isOpen }"></g-icon></label></div><div class="field-select__box" g-menu-content="g-menu-content" ng-class="{ &quot;-limit-width&quot;: $ctrl.hasControl }"><div class="field-select__actions" ng-if="$ctrl.multi &amp;&amp; $ctrl.allToggle"><div class="field-select__action" ng-click="$ctrl.selectAll()">Select All</div><div class="field-select__action" ng-click="$ctrl.selectNone()">Select None</div></div><div class="field-select__search" ng-if="$ctrl.search" g-menu-open="true"><field-text key="{{ $ctrl.searchKey }}" type="text" model="$ctrl.query" placeholder="Search" autocomplete="off" inline="true"></field-text></div><div class="field-select__list" ng-class="{ &quot;-large&quot;: $ctrl.largeList }"><div class="field-select__option" g-menu-open="$ctrl.multi || option.persistent" ng-repeat="option in $ctrl.options | filter:$ctrl.isPromotedAndVisible track by option.value" title="{{ option.label }}" ng-if="$ctrl.isVisible(option)" ng-class="{ \n                        &quot;-selected&quot;: $ctrl.isSelected(option.value),\n                        &quot;-disabled&quot;: $ctrl.isOptionDisabled(option.value)\n                    }" ng-click="$ctrl.select(option.value)"><g-checkbox class="field-select__option-checkbox" ng-if="$ctrl.multi" selected="$ctrl.isSelected(option.value)" disabled="$ctrl.isOptionDisabled(option.value)" static="true"></g-checkbox><div class="field-select__option-label" ng-class="{ &quot;-selected&quot;: $ctrl.isSelected(option.value) }">{{ option.label }}<div class="field-select__option-tag" ng-if="option.tag" ng-style="{ &quot;background-color&quot;: option.tagColor }">{{ option.tag }}</div></div><div class="field-select__option-remove" ng-if="option.isCustom"><g-icon-button class="field-select__option-remove-icon" icon="close" size="tiny" on-click="$ctrl.removeCustom(option)"></g-icon-button></div></div><div class="field-select__divider" ng-if="$ctrl.hasVisiblePromotedOptions()"></div><div class="field-select__option" g-menu-open="$ctrl.multi || option.persistent" ng-repeat="option in $ctrl.options | filter:$ctrl.isNotPromotedAndVisible track by option.value" title="{{ option.label }}" ng-if="$ctrl.isVisible(option)" ng-class="{ \n                        &quot;-selected&quot;: $ctrl.isSelected(option.value),\n                        &quot;-disabled&quot;: $ctrl.isOptionDisabled(option.value)\n                    }" ng-click="$ctrl.select(option.value)"><g-checkbox class="field-select__option-checkbox" ng-if="$ctrl.multi" selected="$ctrl.isSelected(option.value)" disabled="$ctrl.isOptionDisabled(option.value)" static="true"></g-checkbox><div class="field-select__option-label" ng-class="{ &quot;-selected&quot;: $ctrl.isSelected(option.value) }">{{ option.label }}<div class="field-select__option-tag" ng-if="option.tag" ng-style="{ &quot;background-color&quot;: option.tagColor }">{{ option.tag }}</div></div><div class="field-select__option-remove" ng-if="option.isCustom"><g-icon-button class="field-select__option-remove-icon" icon="close" size="tiny" on-click="$ctrl.removeCustom(option)"></g-icon-button></div></div><div ng-if="$ctrl.isCustomField" g-menu-open="true"><form ng-submit="$ctrl.addCustom()"><input class="field-select__custom" type="text" placeholder="Custom" ng-model="$ctrl.custom"/></form></div></div></div></g-menu></div>');
$templateCache.put('field-switch.html','<div class="field-switch" ng-class="{ &quot;-on&quot;: $ctrl.on }" ng-click="$ctrl.onClick()"> <div class="field-switch__knob"></div></div>');
$templateCache.put('field-text.html','<div class="field-text" ng-class="{ &quot;-inline&quot;: $ctrl.inline, &quot;-small&quot;: $ctrl.small }"><div class="field-text__icon" ng-if="$ctrl.icon"><g-icon icon="{{ $ctrl.icon }}" color="INHERIT"></g-icon></div><div class="field-text__prefix" ng-if="$ctrl.prefix"><span ng-bind="$ctrl.prefix"></span></div><input ng-if="$ctrl.type !== &quot;textarea&quot;" name="{{ $ctrl.key }}" id="{{ $ctrl.key }}" type="{{ $ctrl.type || &quot;text&quot; }}" placeholder="{{ $ctrl.placeholder }}" lang="{{ $ctrl.lang }}" ng-model="$ctrl.model" ng-blur="$ctrl.onBlur()" ng-change="$ctrl.onChange({ $value: $ctrl.model })" ng-disabled="$ctrl.disabled" ng-attr-min="{{ $ctrl.min }}" ng-attr-max="{{ $ctrl.max }}" ng-attr-autocomplete="{{ $ctrl.autocomplete }}" ng-attr-money="{{ $ctrl.money }}" ng-keydown="$ctrl.handleKeyDown($event)" ng-paste="$ctrl.onPaste($event)" ng-trim="{{ !$ctrl.noTrim }}" gl-autofocus="$ctrl.autofocus"/><textarea ng-if="$ctrl.type === &quot;textarea&quot; &amp;&amp; $ctrl.expand === false" ng-class="{ &quot;-min-height&quot;: !$ctrl.noMinHeight }" name="{{ $ctrl.key }}" id="{{ $ctrl.key }}" placeholder="{{ $ctrl.placeholder }}" lang="{{ $ctrl.lang }}" ng-model="$ctrl.model" ng-change="$ctrl.onChange({ $value: $ctrl.model })" ng-trim="{{ !$ctrl.noTrim }}" gl-autofocus="$ctrl.autofocus"></textarea><textarea ng-if="$ctrl.type === &quot;textarea&quot; &amp;&amp; $ctrl.expand !== false" ng-class="{ &quot;-min-height&quot;: !$ctrl.noMinHeight }" name="{{ $ctrl.key }}" id="{{ $ctrl.key }}" placeholder="{{ $ctrl.placeholder }}" lang="{{ $ctrl.lang }}" ng-model="$ctrl.model" ng-change="$ctrl.onChange({ $value: $ctrl.model })" ng-trim="{{ !$ctrl.noTrim }}" msd-elastic="" gl-autofocus="$ctrl.autofocus"></textarea><div class="field-text__suffix" ng-if="$ctrl.suffix"><span ng-bind="$ctrl.suffix"></span></div></div>');
$templateCache.put('field-video.html','<label class="field-video" for="{{ $ctrl.key }}" ng-class="{ &quot;-inline&quot;: $ctrl.inline }"><div class="field-video__player" ng-if="$ctrl.video.state === $ctrl.video.State.READY" ng-click="$event.preventDefault()"><video-player video="$ctrl.video"></video-player></div><div class="field-video__aspect" ng-if="$ctrl.video.isLoading()"><div class="field-video__aspect-content"><div class="field-video__loading"><div class="field-video__loading-phase">{{ $ctrl.loadingStateLabels[$ctrl.video.state] }}</div><div class="field-video__loading-progress" ng-if="$ctrl.video.hasProgress()">{{ $ctrl.video.progress }}%</div></div></div></div><div class="field-video__aspect" ng-if="$ctrl.video.state === $ctrl.video.State.ERROR"><div class="field-video__aspect-content"><div class="field-video__error"><g-icon class="field-video__error-icon" icon="important" color="INHERIT"></g-icon><div class="field-video__error-msg">{{ $ctrl.video.error }}</div></div></div></div><div class="field-video__info"><g-icon class="field-video__info-icon" icon="video" color="INHERIT"></g-icon><div class="field-video__info-placeholder" ng-if="$ctrl.video.state === $ctrl.video.State.NEW">Choose file</div><div class="field-video__info-label" ng-if="$ctrl.video.state !== $ctrl.video.State.NEW">{{ $ctrl.video.name }}</div><div class="field-video__info-btn" ng-if="$ctrl.video.isLoading()"><g-spinner size="15"></g-spinner></div><div class="field-video__info-btn" ng-if="$ctrl.video.state === $ctrl.video.State.READY"><g-icon-button icon="close" size="small" on-click="$ctrl.video.clear()"></g-icon-button></div></div><input class="field-video__control" ng-if="!$ctrl.video.isLoading()" ng-init="$ctrl.bind()" name="{{ $ctrl.key }}" id="{{ $ctrl.key }}" type="file" accept="video/*"/><div class="field-video__drop" ng-if="$ctrl.dropping" ng-class="{ &quot;-extra-inset&quot;: $ctrl.video.state !== $ctrl.video.State.NEW }"><div class="field-video__drop-inner"></div></div></label>');
$templateCache.put('find-and-replace.template.html','<g-dialog-header title="Find &amp; Replace" on-close="$ctrl.onClose()"></g-dialog-header><div class="find-and-replace__content"><div class="find-and-replace__fields" ng-if="!$ctrl.isReplacePreview"><div class="find-and-replace__field"><field-text class="find-and-replace__field-text -with-action" placeholder="Search" inline="true" model="$ctrl.searchInput" on-enter="$ctrl.find($ctrl.searchInput)" autofocus="true" no-trim="true"></field-text><div class="find-and-replace__field-action-wrapper"><button class="find-and-replace__field-action gi gi-format-letter-case" ng-click="$ctrl.matchCase = !$ctrl.matchCase; $ctrl.find($ctrl.searchInput)" ng-class="{ &quot;-selected&quot;: $ctrl.matchCase }"><gl-hint>Match Case</gl-hint></button></div><div class="find-and-replace__field-btn-wrapper"><g-btn label="Find" on-click="$ctrl.find($ctrl.searchInput)" secondary="true" block="true"></g-btn></div></div><div class="find-and-replace__field" ng-if="$ctrl.results.length"><field-text class="find-and-replace__field-text" placeholder="Replace" inline="true" model="$ctrl.replaceInput" on-enter="$ctrl.replace($ctrl.replaceInput)" no-trim="true"></field-text><div class="find-and-replace__field-btn-wrapper"><g-btn label="Replace" on-click="$ctrl.replace($ctrl.replaceInput)" secondary="true" block="true"></g-btn></div></div><div class="find-and-replace__field-error-text" ng-if="$ctrl.replaceErrorText">{{ $ctrl.replaceErrorText }}</div></div><div class="find-and-replace__fields" ng-if="$ctrl.isReplacePreview"><div class="find-and-replace__confirm-replace-text">Are you sure you want to replace all selected results with \u201C<b>{{ $ctrl.replaceStr }}</b>\u201D ?</div><div class="find-and-replace__confirm-replace-actions"><g-btn label="Cancel" on-click="$ctrl.cancelReplace()" secondary="true"></g-btn><g-btn label="Replace" on-click="$ctrl.confirmReplace()"></g-btn></div></div><div class="find-and-replace__zero" ng-if="!$ctrl.results.length"><div class="find-and-replace__zero-text" ng-if="!$ctrl.searchQuery">Nothing to find</div><div class="find-and-replace__zero-text" ng-if="$ctrl.searchQuery">No results found for "{{ $ctrl.searchQuery }}"</div></div><div class="find-and-replace__results" ng-if="$ctrl.results.length"><div class="find-and-replace__toolbar" ng-class="{ &quot;-preview&quot;: $ctrl.isReplacePreview }"><div class="find-and-replace__toggle" ng-if="!$ctrl.isReplacePreview" ng-click="$ctrl.toggleSelectAll()"><g-checkbox selected="$ctrl.isAllSelected()" static="true"></g-checkbox></div><div class="find-and-replace__toolbar-content"><div class="find-and-replace__toolbar-info" ng-if="!$ctrl.isReplacePreview">{{ $ctrl.getSelected().length }} selected</div><div class="find-and-replace__toolbar-gap"></div><div class="find-and-replace__toolbar-info"> <span>{{ $ctrl.results.length }} results</span><span ng-if="$ctrl.isReplacePreview">&nbsp;to replace</span></div></div></div><div class="find-and-replace__result" ng-repeat="result in $ctrl.results track by $index" ng-class="{ &quot;-preview&quot;: $ctrl.isReplacePreview }"><div class="find-and-replace__toggle" ng-if="!$ctrl.isReplacePreview" ng-click="result.skipReplace = !result.skipReplace"><g-checkbox selected="!result.skipReplace" static="true"></g-checkbox></div><div class="find-and-replace__result-text"><div class="find-and-replace__result-title">{{ result.title }}</div><div class="find-and-replace__result-content" ng-bind-html="result.content"></div></div></div></div></div>');
$templateCache.put('g-btn.html','<a class="g-btn" ng-href="{{ $ctrl.link }}" ng-attr-target="{{ $ctrl.target }}" ng-click="$ctrl.click($event)" ng-class="{ \n        &quot;-secondary&quot;: $ctrl.secondary,\n        &quot;-tertiary&quot;: $ctrl.tertiary,        \n        &quot;-danger&quot;: $ctrl.danger,\n        &quot;-disabled&quot;: $ctrl.disabled,\n        &quot;-small&quot;: $ctrl.small,\n        &quot;-block&quot;: $ctrl.block\n    }"><div class="g-btn__content" ng-if="!$ctrl.loader"><g-icon class="g-btn__icon" ng-if="$ctrl.icon" icon="{{ $ctrl.icon }}" color="INHERIT" size="small"></g-icon><span class="g-btn__label" ng-if="$ctrl.label">{{ $ctrl.label }}</span></div><div class="g-btn__loading" ng-if="$ctrl.loader" ng-style="{ width: $ctrl.loader.width + &quot;px&quot; }"><g-spinner color="{{ $ctrl.secondary ? &quot;rgba(BLACK, .54)&quot; : &quot;rgba(WHITE, .4)&quot; }}" size="{{ $ctrl.small ? 15 : 20 }}"></g-spinner></div></a><gl-hint ng-if="$ctrl.hint">{{ $ctrl.hint }}</gl-hint>');
$templateCache.put('g-calendar.html','<div class="g-calendar__head"><g-icon-button icon="chevron-left" on-click="$ctrl.prev()"></g-icon-button><div class="g-calendar__title">{{ $ctrl.month.format(\'MMMM YYYY\') }}</div><g-icon-button icon="chevron-right" on-click="$ctrl.next()"></g-icon-button></div><div class="g-calendar__days"><div class="g-calendar__day">Mo</div><div class="g-calendar__day">Tu</div><div class="g-calendar__day">We</div><div class="g-calendar__day">Th</div><div class="g-calendar__day">Fr</div><div class="g-calendar__day">Sa</div><div class="g-calendar__day">Su</div></div><div class="g-calendar__dates"><div class="g-calendar__date" ng-repeat="point in $ctrl.points track by $index"><div class="g-calendar__circle" ng-click="$ctrl.select(point)" ng-class="{ \n                disabled: point.disabled,\n                selected: point.selected,\n                active: point.active,\n                left: point.left,\n                right: point.right\n            }"> <div class="g-calendar__circle-inner">{{ point.number }}</div></div></div></div>');
$templateCache.put('g-checkbox.html','<div class="g-checkbox-box" ng-click="$ctrl.toggle($event)" ng-class="{ \n        &quot;-selected&quot;: $ctrl.isSelected,\n        &quot;-disabled&quot;: $ctrl.isDisabled,\n        &quot;-focus&quot;: $ctrl.isFocused\n    }"><g-icon class="g-checkbox-box__icon" icon="done" size="12" color="INHERIT"></g-icon></div><input class="g-checkbox__element" ng-if="!$ctrl.isStatic" type="checkbox" ng-model="$ctrl.isSelected" ng-change="$ctrl.onChange({ $value: $ctrl.isSelected })" ng-focus="$ctrl.isFocused = true" ng-blur="$ctrl.isFocused = false" ng-disabled="$ctrl.isDisabled"/>');
$templateCache.put('g-colored-dot.html','<div class="g-color-dot" ng-style="{ backgroundColor: $ctrl.color }"></div>');
$templateCache.put('g-dialog-header.html','<div class="g-dialog-header__container" ng-class="{ &quot;-border&quot;: !$ctrl.tabs }"><div class="g-dialog-header__top"><div class="g-dialog-header__back" ng-if="$ctrl.onBack &amp;&amp; !$ctrl.hideBack"><g-icon-button icon="back" on-click="$ctrl.onBack({ $event: $event })"></g-icon-button></div><div class="g-dialog-header__content"><div class="g-dialog-header__title">{{ $ctrl.title || "Untitled" }}</div><div class="g-dialog-header__sub-title" ng-if="$ctrl.subTitle">{{ $ctrl.subTitle }}</div></div><div class="g-dialog-header__btn" ng-if="$ctrl.btn"><g-btn label="{{ $ctrl.btn }}" on-click="$ctrl.onBtnClick()"></g-btn></div><div class="g-dialog-header__close" ng-if="$ctrl.onClose &amp;&amp; !$ctrl.hideClose"><g-icon-button icon="close" on-click="$ctrl.onClose({ $event: $event })"></g-icon-button></div></div><div class="g-dialog-header__message" ng-if="$ctrl.message" ng-bind-html="$ctrl.message"></div><div class="g-dialog-header__tabs" ng-if="$ctrl.tabs"><g-tabs tabs="$ctrl.tabs" selected="$ctrl.selectedTab" on-change="$ctrl.onTabChange({ $value: $value })"></g-tabs></div></div>');
$templateCache.put('g-file-input.html','<div class="g-file-input"><div ng-transclude="control" ng-click="$ctrl.triggerInputClick()"><g-btn label="{{ &quot;Select &quot; + $ctrl.multiple ? &quot;files&quot; : &quot;file&quot; }}" secondary="true" disabled="$ctrl.disabled || $ctrl.loading"></g-btn></div><input class="g-file-input__input" ng-if="!$ctrl.isRebuilding" type="file" accept="{{ $ctrl.accept }}"/></div>');
$templateCache.put('g-image.html','<img class="g-image__img" ng-if="$ctrl.url" ng-style="$ctrl.styles" ng-src="{{ $ctrl.url }}" ng-click="$ctrl.onClick()"/>');
$templateCache.put('g-menu-item.html','<a class="g-menu-item" ng-class="{ &quot;-disabled&quot;: $ctrl.isDisabled, &quot;-highlight&quot;: $ctrl.isHighlighted, &quot;-danger&quot;: $ctrl.isDanger }" ng-click="$ctrl.click($event)" ng-href="{{ $ctrl.href }}" target="blank"><div class="g-menu-item__image" ng-if="$ctrl.isImage" ng-style="$ctrl.imageStyle"></div><g-icon class="g-menu-item__icon" ng-if="$ctrl.icon" icon="{{ $ctrl.icon }}" size="{{ $ctrl.iconSize }}" strike="$ctrl.iconStrike" color="INHERIT"></g-icon><div class="g-menu-item__text-wrapper"><div class="g-menu-item__text">{{ $ctrl.text }}</div><div class="g-menu-item__sub-text" ng-if="$ctrl.subText">{{ $ctrl.subText }}</div></div></a>');
$templateCache.put('g-menu.html','<div ng-transclude="ng-transclude"></div>');
$templateCache.put('g-spinner.html','<div><svg class="g-spinner" ng-cloak="" ng-attr-width="{{ $ctrl.size }}px" ng-attr-height="{{ $ctrl.size }}px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="g-spinner__path" ng-class="{ &quot;-rainbow&quot;: $ctrl.rainbow }" ng-style="{ stroke: $ctrl.color }" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg></div>');
$templateCache.put('gl-clouds.template.html','<div class="gl-clouds-group"></div><div class="gl-clouds-group -repeat"></div><div class="gl-clouds-front" ng-if="$ctrl.bottom !== false"></div><div class="gl-clouds-content" ng-transclude="ng-transclude"></div>');
$templateCache.put('hint-box.template.html','<div class="hint__text" ng-transclude="ng-transclude"></div><div class="hint__pointer"><div class="hint__pointer-visual"></div></div>');
$templateCache.put('icon-button.template.html','<g-icon class="g-icon-button" ng-click="$ctrl.click($event)" icon="{{ $ctrl.icon }}" shadow="{{ $ctrl.isHover ? $ctrl.hoverShadow : $ctrl.shadow }}" color="{{ $ctrl.disabled ? $ctrl.disabledColor : ($ctrl.isHover ? $ctrl.hoverColor : $ctrl.color) }}" size="{{ $ctrl.size }}" ng-mouseenter="$ctrl.isHover = true" ng-mouseleave="$ctrl.isHover = false"></g-icon><gl-hint ng-if="$ctrl.hint">{{ $ctrl.hint }}</gl-hint>');
$templateCache.put('icon.template.html','<div class="g-icon gi" ng-class="$ctrl.class" ng-style="$ctrl.style"></div>');
$templateCache.put('image-input.template.html','<div class="gl-image-input"><span ng-style="ratioStyle()"></span><figure class="gl-image-input-image" ng-style="imageStyle()"></figure><span class="gl-image-input-hint" ng-show="hint &amp;&amp; !error &amp;&amp; !imageUrl()">{{ hint }}</span><div class="gl-image-input-error" ng-if="error"><div class="gl-image-input-error-msg">{{ error }}</div></div><input class="gl-image-input-input" ng-if="!rebuilding" type="file"/><span class="gl-image-input-close" ng-show="canRemove &amp;&amp; imageUrl()" ng-click="clear(); rebuild()"><span class="gi gi-close"></span></span></div>');
$templateCache.put('intro-editor.html','<form><label class="gl-form-group" for="title"><div class="gl-form-label">Title</div><input class="gl-form-control" id="title" name="title" ng-model="$ctrl.survey.title" autocomplete="off"/></label><label class="gl-form-group" for="imageUrl"><div class="gl-form-label">Image</div><gl-image-input class="intro-editor__image-input" id="imageUrl" src="$ctrl.survey.imageUrl" on-change="$ctrl.setImage($imageData)" hint="600 x 450" ratio="0.75"></gl-image-input></label><label class="gl-form-checkbox-group" for="introTimeVisible"><input class="gl-checkbox" type="checkbox" id="introTimeVisible" ng-model="$ctrl.survey.introTimeVisible"/><div class="gl-form-label">Show Time Estimate</div></label><label class="gl-form-checkbox-group" for="introCustomDataVisible"><input class="gl-checkbox" type="checkbox" id="introCustomDataVisible" ng-model="$ctrl.survey.introCustomDataVisible"/><field-label class="gl-form-label" key="introCustomDataVisible" hint="Display personalized information (like respondent ID, test ID, or other custom fields)" inline="true">Show Custom Data</field-label></label><div class="intro-editor__ssr" ng-if="$ctrl.isSsr"><h3>SSR Settings</h3><label class="gl-form-checkbox-group" for="showIntro"><input class="gl-checkbox" type="checkbox" id="showIntro" ng-model="$ctrl.survey.showIntro"/><div class="gl-form-label">Show Intro</div></label><label class="gl-form-group" ng-if="$ctrl.survey.showIntro" for="introText"><div class="gl-form-label">Intro Text</div><input class="gl-form-control" id="introText" name="introText" ng-model="$ctrl.survey.introText" autocomplete="off"/></label><label class="gl-form-group" ng-if="$ctrl.survey.showIntro" for="introTextUrl"><div class="gl-form-label">Intro Text URL</div><input class="gl-form-control" id="introTextUrl" name="introTextUrl" ng-model="$ctrl.survey.introTextUrl" autocomplete="off"/></label></div></form>');
$templateCache.put('list-input.html','<div class="list-input__head"><label class="gl-form-label list-input__head-label">{{ $ctrl.label }}</label><div class="list-input__head-spacer"></div><div class="list-input__randomize" ng-if="$ctrl.isRandomizeOption"><g-menu align="bottom-right" close-on-input-focus="true"><div class="list-input__randomize-control" ng-class="{ &quot;-active&quot;: $ctrl.getRandomizeItems() || $ctrl.getRandomizeHeadings() }"><span>Randomize</span><g-icon icon="expand-more" size="small" color="rgba(BLUE_SLATE, .4)"></g-icon></div><g-menu-box g-menu-content="g-menu-content" max-width="1000px"><div class="list-input__randomize-popover" g-menu-open="g-menu-open"><div class="list-input__randomize-block"><div class="list-input__randomize-title" ng-if="$ctrl.hasHeadings()">{{ $ctrl.label }}</div><field-radio-set vertical="true"><field-radio selected="$ctrl.getRandomizeItems(null)" on-select="$ctrl.setRandomizeItems(null)">None</field-radio><field-radio selected="$ctrl.getRandomizeItems(&quot;SHUFFLE&quot;)" on-select="$ctrl.setRandomizeItems(&quot;SHUFFLE&quot;)" hint="{{ $ctrl.label }} will be randomly shuffled. Uses Fisher Yates algorithm.">Shuffle</field-radio><field-radio selected="$ctrl.getRandomizeItems(&quot;ROTATE&quot;)" on-select="$ctrl.setRandomizeItems(&quot;ROTATE&quot;)" hint="{{ $ctrl.label }} will maintain the same order but rotate linearly. Uses Fisher yates algorithm.">Rotate</field-radio><field-radio selected="$ctrl.getRandomizeItems(&quot;FLIP&quot;)" on-select="$ctrl.setRandomizeItems(&quot;FLIP&quot;)" hint="{{ $ctrl.label }} will be randomly flipped between ascending and descending order. Uses Fisher yates algorithm.">Flip</field-radio></field-radio-set></div><div class="list-input__randomize-block" ng-if="$ctrl.hasHeadings()"><div class="list-input__randomize-title">Headings</div><field-radio-set vertical="true"><field-radio selected="$ctrl.getRandomizeHeadings(null)" on-select="$ctrl.setRandomizeHeadings(null)">None</field-radio><field-radio selected="$ctrl.getRandomizeHeadings(&quot;SHUFFLE&quot;)" on-select="$ctrl.setRandomizeHeadings(&quot;SHUFFLE&quot;)" hint="Headings will be randomly shuffled. Uses Fisher yates algorithm.">Shuffle</field-radio><field-radio selected="$ctrl.getRandomizeHeadings(&quot;ROTATE&quot;)" on-select="$ctrl.setRandomizeHeadings(&quot;ROTATE&quot;)" hint="Headings will maintain the same order but rotate linearly. Uses Fisher yates algorithm.">Rotate</field-radio><field-radio selected="$ctrl.getRandomizeHeadings(&quot;FLIP&quot;)" on-select="$ctrl.setRandomizeHeadings(&quot;FLIP&quot;)" hint="Headings will be randomly flipped between ascending and descending order. Uses Fisher yates algorithm.">Flip</field-radio></field-radio-set></div></div></g-menu-box></g-menu></div><div class="list-input__head-toggle" ng-if="$ctrl.isHideLabelsOption &amp;&amp; $ctrl.imagesEnabled" ng-click="$ctrl.onHiddenLabelsToggle()"><g-checkbox selected="$ctrl.labelsHidden" static="true"></g-checkbox><span>Hide Labels</span></div><div class="list-input__head-toggle" ng-if="$ctrl.isImagesOption" ng-click="$ctrl.onImagesToggle()"><g-checkbox selected="$ctrl.imagesEnabled" static="true"></g-checkbox><span>Images</span></div><field-select ng-if="$ctrl.isGridColumnMaxOption" options="$ctrl.gridColumnMaxOptions" selected="$ctrl.gridColumnMax" on-change="$ctrl.onGridColumnMax({$value : $value})"><field-select-control><micro-action icon="expand-more"><div class="list-input__head-micro-text" ng-class="{ &quot;-active&quot;: $ctrl.gridColumnMax }">Max Columns</div></micro-action></field-select-control></field-select><field-select ng-if="$ctrl.presets" options="$ctrl.presets" on-change="$ctrl.usePreset($value)"><field-select-control><micro-action icon="expand-more">Templates/Presets</micro-action></field-select-control></field-select><field-select ng-if="$ctrl.isBorrowFromOption &amp;&amp; $ctrl.lenders.length" options="$ctrl.lenders" selected="$ctrl.lenderQuestion.id" on-change="$ctrl.borrowFrom($value)"><field-select-control><micro-action icon="expand-more">Borrow from</micro-action></field-select-control></field-select><field-select ng-if="$ctrl.isCopyFromOption &amp;&amp; $ctrl.copiers.length" options="$ctrl.copiers" selected="null" align="bottom-attach" on-change="$ctrl.copyFrom($value)" on-close="$ctrl.copyTargetQuestionId=null"><field-select-control><micro-action icon="expand-more">Copy from</micro-action></field-select-control></field-select><div class="list-input__head-icon-btn"><g-icon-button icon="copy" size="SMALL" on-click="$ctrl.copyToClipboard()"></g-icon-button><gl-hint>Copy items to clipboard</gl-hint></div><div class="list-input__head-icon-btn" ng-if="!$ctrl.isAddOnly &amp;&amp; !$ctrl.tempClearedItems.length"><g-icon-button icon="delete" size="SMALL" on-click="$ctrl.clearItems()"></g-icon-button><gl-hint>Clear items</gl-hint></div><div class="list-input__head-icon-btn" ng-if="$ctrl.tempClearedItems.length"><g-icon-button icon="restart" size="SMALL" on-click="$ctrl.undoClearItems()"></g-icon-button><gl-hint>Undo clear items</gl-hint></div></div><div class="list-input__box"><div class="list-input__lender" ng-if="$ctrl.lenderQuestion"><div class="list-input__lender-head"><div class="list-input__lender-head-title">Borrow from: </div><div class="list-input__lender-head-question">{{ $ctrl.lenderQuestion.getTitleLabel({ number: true }) }}</div><div class="list-input__head-toggle list-input__lender-head-btn" ng-if="$ctrl.isBorrowFromPersistOption" ng-click="$ctrl.togglePersistOrder()"><g-checkbox selected="$ctrl.lender.persistOrder" disabled="!$ctrl.getRandomizeItems(null) || !$ctrl.getRandomizeHeadings(null)" static="true"></g-checkbox><span>Persist Order</span><gl-hint>If the question you are borrowing from uses randomization, this option will keep them in the same randomized order.</gl-hint></div><div class="list-input__lender-head-btn"><g-icon-button icon="close" size="SMALL" on-click="$ctrl.borrowFrom(null)"></g-icon-button></div></div><div class="list-input__lender-select-container"><div class="list-input__lender-select-item" ng-if="$ctrl.lenderQuestion.isUsedAsMatrix()"><field-select inline="true" placeholder="Select target" options="$ctrl.targetOptions" selected="$ctrl.lender.target" on-change="$ctrl.lender.target = $value"></field-select></div><div class="list-input__lender-select-item"><field-select ng-if="!$ctrl.lender.target || $ctrl.lender.targetsChoices()" inline="true" placeholder="{{ !$ctrl.lender.target ? &quot;Exclusion&quot; : &quot;Exclude these choices&quot; }}" multi="true" multi-format="$ctrl.formatMultiOptions($options, &quot;Exclude: &quot;)" options="$ctrl.choiceOptions" selected="$ctrl.lender.exclusionIds" disabled="!$ctrl.lender.target" on-change="$ctrl.lender.exclusionIds = $value"></field-select><field-select ng-if="$ctrl.lender.targetsStatements()" inline="true" placeholder="Exclude these statements" multi="true" multi-format="$ctrl.formatMultiOptions($options, &quot;Exclude: &quot;)" options="$ctrl.statementOptions" selected="$ctrl.lender.exclusionIds" on-change="$ctrl.lender.exclusionIds = $value"></field-select></div><div class="list-input__lender-select-item" ng-if="!$ctrl.lenderQuestion.isUsedAsMatrix() || $ctrl.lender.target" ng-class="{&quot;-first&quot;: !$ctrl.lenderQuestion.isUsedAsMatrix()}"><field-select inline="true" options="$ctrl.getReducerOptions()" selected="$ctrl.lender.reducer" on-change="$ctrl.lender.reducer = $value"></field-select></div><div class="list-input__lender-select-item" ng-if="$ctrl.lender.usesLoopKey($ctrl.survey, $ctrl.parentId)"><field-select inline="true" placeholder="Select loop variable" options="$ctrl.loopVariableOptions" prefix="Loop Variable: " selected="$ctrl.lender.loopKey" on-change="$ctrl.lender.loopKey = $value"></field-select></div><div class="list-input__lender-select-item" ng-if="$ctrl.lenderQuestion.isUsedAsMatrix() &amp;&amp; $ctrl.lender.target &amp;&amp; $ctrl.lender.isSelectionReducer()"><field-select ng-if="$ctrl.lender.targetsStatements()" inline="true" placeholder="Select Choices" multi="true" options="$ctrl.choiceOptionsSansHeadings" selected="$ctrl.lender.choiceIds" on-change="$ctrl.lender.choiceIds = $value"></field-select><field-select ng-if="$ctrl.lender.targetsChoices()" inline="true" placeholder="Select Statements" multi="true" options="$ctrl.statementOptionsSansHeadings" selected="$ctrl.lender.statementIds" on-change="$ctrl.lender.statementIds = $value"></field-select></div></div></div><div class="list-input__row" ng-repeat="item in $ctrl.items" ng-if="item.isHeading ? $ctrl.isHeadingOption : true"><gl-image-input class="list-input__image" ng-if="$ctrl.imagesEnabled" src="item.imageUrl" on-change="$ctrl.onImageChange({ $item: item, $imageData: $imageData })" hint="400 x 300" ratio="0.75"></gl-image-input><input class="list-input__input" item-index="{{ $index }}" type="text" placeholder="{{ $ctrl.getPlaceholder($index) }}" ng-model="$ctrl.items[$index].value" ng-class="{ &quot;-heading&quot;: item.isHeading }" ng-paste="$ctrl.onPasteItem($event, $index)" ng-focus="$ctrl.onFocus($index)" ng-blur="$ctrl.onBlur($index)"/><div class="list-input__hidden-choice" ng-if="$ctrl.items[$index].isHidden">HIDDEN</div><div class="list-input__score-input" ng-if="$ctrl.isScoreOption &amp;&amp; !item.isHeading &amp;&amp; !item.isIndependent"><input type="number" ng-model="$ctrl.items[$index].score" placeholder="Score"/></div><div class="list-input__feature" ng-if="$ctrl.isLogicEditorOption &amp;&amp; !item.isHeading &amp;&amp; item.value.length"><logic-editor-opener mode="icon" survey="$ctrl.survey" view="$ctrl.view" filter-id="item.id" is-forbidden="true"></logic-editor-opener></div><div class="list-input__feature" ng-if="$ctrl.isTextCaptureOption &amp;&amp; !item.isHeading" ng-class="{ &quot;-enabled&quot;: item.isCapture }" ng-click="$ctrl.toggleTextCapture($index)"><g-icon icon="text-input" color="INHERIT"></g-icon><gl-hint>Text Capture: If a respondent selects this choice they will be able to enter some text to elaborate on their answer.</gl-hint></div><div class="list-input__feature" ng-if="$ctrl.isExclusiveOption &amp;&amp; !item.isHeading" ng-class="{ &quot;-enabled&quot;: item.isExclusive }" ng-click="$ctrl.toggleExclusive($index)"><g-icon icon="exclusive" color="INHERIT"></g-icon><gl-hint>Exclusive: If a respondent selects this they will not be able to select any other choices.</gl-hint></div><div class="list-input__feature" ng-if="$ctrl.isAnchorOption" ng-class="{ &quot;-enabled&quot;: item.isAnchored }" ng-click="$ctrl.toggleAnchor($index)"><g-icon icon="anchor" color="INHERIT"></g-icon><gl-hint>Anchor: If you have shuffle OR rotate enabled, a choice that is anchored will remain in the same position.</gl-hint></div><div class="list-input__feature" ng-if="$ctrl.isIndependentOption &amp;&amp; !item.isHeading" ng-class="{ &quot;-enabled&quot;: item.isIndependent }" ng-click="$ctrl.toggleIndependent($index)"><g-icon icon="independent" color="INHERIT"></g-icon><gl-hint>Independent: This will display the choice outside of the sliding scale. It is useful for "N/A" or "Don\'t Know" choices.</gl-hint></div><div><g-menu align="bottom-right"><g-icon-button icon="more"></g-icon-button><g-menu-box g-menu-content="g-menu-content"><g-menu-item ng-if="$ctrl.canMoveUp($index)" text="Move Up" sub-text="Shift + \u2191" on-click="$ctrl.moveItem($index, -1)"></g-menu-item><g-menu-item ng-if="$ctrl.canMoveDown($index)" text="Move Down" sub-text="Shift + \u2193" on-click="$ctrl.moveItem($index, 1)"></g-menu-item><g-menu-item ng-if="!item.isHeading &amp;&amp; $ctrl.isHeadingOption" text="Convert To Heading" on-click="item.convertToHeading()"></g-menu-item><g-menu-item ng-if="$ctrl.canRemoveItem($index)" text="Remove" on-click="$ctrl.removeItem($index)"></g-menu-item><g-menu-item ng-if="$ctrl.canToggleHideItem($index)" text="{{ $ctrl.items[$index].isHidden ? &quot;Unhide&quot; : &quot;Hide&quot; }}" on-click="$ctrl.toggleHideItem($index)"></g-menu-item></g-menu-box></g-menu></div></div><div class="list-input__row" ng-if="$ctrl.canAddItem()"><input class="list-input__input" type="text" placeholder="Add" ng-focus="$ctrl.addItem($event)"/></div></div><div class="list-input__limit-reached" ng-if="!$ctrl.canAddItem() &amp;&amp; $ctrl.maxItems &gt; 0 &amp;&amp; !$ctrl.isDisabled">The limit ({{ $ctrl.maxItems }}) has been reached</div>');
$templateCache.put('location-fields.html','<div class="list-input"><field-label>Location</field-label><div class="location-fields__split"><div><field-select options="$ctrl.ruleOptions" selected="$ctrl.selectedRule" on-change="$ctrl.onChange($value, $ctrl.selectedCountry)" inline="true"></field-select></div><div><field-select options="$ctrl.countries" selected="$ctrl.selectedCountry" on-change="$ctrl.onChange($ctrl.selectedRule, $value)" search="true" inline="true"></field-select></div></div><field-label>Type</field-label><div class="location-fields__split -margin-bottom"><div><field-select options="$ctrl.typeOptions" selected="$ctrl.question.locationType" on-change="$ctrl.question.locationType = $value" inline="true"></field-select></div><div><field-select ng-if="$ctrl.isPlacesType()" placeholder="Filter places by types (max 3)" options="$ctrl.placeTypeOptions" selected="$ctrl.question.locationTypesFilter" on-change="$ctrl.question.locationTypesFilter = $value" disable-options="$ctrl.question.locationTypesFilter.length &gt; 2" multi="true" search="true" inline="true"></field-select></div></div><div class="gl-form-checkbox-group" ng-if="$ctrl.isPlacesType()"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}locationShowSearchField" ng-model="$ctrl.question.locationShowSearchField"/><label class="gl-form-label" for="question{{ $ctrl.question.id }}locationShowSearchField">Show search field</label></div><div class="gl-form-group" ng-if="$ctrl.isPlacesType()"><label class="gl-form-label" for="question{{ $ctrl.question.id }}locationSearchTerms">Search term</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}locationSearchTerms" name="question{{ $ctrl.question.id }}locationSearchTerms" ng-model="$ctrl.question.locationSearchTerms"/></div><div class="gl-form-checkbox-group" ng-if="$ctrl.isPlacesType()"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}locationExcludePrevious" ng-model="$ctrl.question.locationExcludePrevious"/><label class="gl-form-label" for="question{{ $ctrl.question.id }}locationExcludePrevious">Exclude previous selected places</label></div></div>');
$templateCache.put('logic-editor-opener.html','<div class="logic-editor-opener" ng-click="$ctrl.openLogicEditor()"><div class="logic-editor-opener__summary" ng-if="$ctrl.mode === &quot;summary&quot;"><div class="logic-editor-opener__summary-zero" ng-if="!$ctrl.view.value.logic.length"><g-icon icon="logic" size="SMALL"></g-icon><div class="logic-editor-opener__summary-zero-text">No logic</div></div><div class="logic-editor-opener__summary-item" ng-repeat="logic in $ctrl.view.value.logic track by logic.id"><div class="logic-editor-opener__summary-title">{{ logic.makeSummaryTitle($ctrl.view.value) }}</div><ul class="logic-editor-opener__summary-list"><li class="logic-editor-opener__summary-list-item" ng-repeat="condition in logic.conditions track by condition.id"> <span class="logic-editor-opener__summary-list-text" compile-html="condition.toString()"></span><span class="logic-editor-opener__summary-list-and" ng-if="!$last">and,</span></li></ul><span ng-if="logic.type === &quot;ACTION&quot;"><div class="logic-editor-opener__summary-title">Then...</div><ul class="logic-editor-opener__summary-list"><li class="logic-editor-opener__summary-list-item" ng-repeat="action in logic.actions track by action.id"> <span class="logic-editor-opener__summary-list-text" compile-html="action.toString()"></span><span class="logic-editor-opener__summary-list-and" ng-if="!$last">and,</span></li></ul></span></div></div><g-icon-button ng-if="$ctrl.mode === &quot;icon&quot;" icon="logic" color="{{ $ctrl.isIconHighlighted ? &quot;&quot; : &quot;rgba(BLACK, 0.2)&quot; }}" hover-color="{{ $ctrl.filterId &amp;&amp; !$ctrl.isIconHighlighted ? &quot;rgba(BLACK, 0.3)&quot; : &quot;&quot; }}" size="22" disabled="$ctrl.survey.queue.isProcessing()" hint="Logic editor"></g-icon-button></div>');
$templateCache.put('logic-editor.html','<div class="logic-editor__container"><div class="logic-editor__header"><div class="logic-editor__header-title">{{ $ctrl.title }}</div><div class="logic-editor__header-buttons"><g-btn ng-if="!$ctrl.survey.isOutdated() &amp;&amp; !$ctrl.isForbidden" label="Save &amp; Close" on-click="$ctrl.onDone({ $clickedSave: true })"></g-btn><g-btn label="Close" secondary="true" on-click="$ctrl.onDone()"></g-btn></div></div><div class="logic-editor__content"><div class="logic-editor__nav" ng-if="$ctrl.supportsFilter || $ctrl.isCursorNav()"><div class="logic-editor__filter" ng-if="$ctrl.supportsFilter"> <span class="logic-editor__filter-label">Filter by </span><div class="logic-editor__filter-select"><field-select placeholder="options" options="$ctrl.filterOptions" selected="$ctrl.filterValue" on-change="$ctrl.applyFilter($value)" multi="true" inline="true" search="$ctrl.filterOptions.length &gt; 10"></field-select></div><a class="logic-editor__filter-clear" ng-if="$ctrl.filterValue.length" ng-click="$ctrl.applyFilter([])"> <span>Clear</span></a></div><div class="logic-editor__nav-bottom" ng-if="$ctrl.isCursorNav()" ng-class="{ &quot;-no-filter&quot;: !$ctrl.supportsFilter }"><div class="logic-editor__nav-btn" ng-class="{ &quot;-disabled&quot;: !$ctrl.isCursorPrev() }" ng-click="$ctrl.cursorFirst()"> <span>First</span></div><div class="logic-editor__nav-btn" ng-class="{ &quot;-disabled&quot;: !$ctrl.isCursorPrev() }" ng-click="$ctrl.cursorPrev()"> <span>Previous</span></div><div class="logic-editor__nav-info"><span>{{ $ctrl.getCursorInfo() }}</span></div><div class="logic-editor__nav-btn" ng-class="{ &quot;-disabled&quot;: !$ctrl.isCursorNext() }" ng-click="$ctrl.cursorNext()"> <span>Next</span></div><div class="logic-editor__nav-btn" ng-class="{ &quot;-disabled&quot;: !$ctrl.isCursorNext() }" ng-click="$ctrl.cursorLast()"> <span>Last</span></div></div></div><div class="logic-editor__zero" ng-if="!$ctrl.logic.length">This {{ $ctrl.viewType }} has no logic.</div><div class="logic-editor__zero" ng-if="$ctrl.logic.length &amp;&amp; !$ctrl.filteredLogic.length"></div><div class="logic-editor__logic" ng-repeat="logic in $ctrl.getLogic() as displayedLogic track by logic.id"><div class="logic-editor__logic-head"> <div class="logic-editor__logic-head-title">{{ $ctrl.getTitle(logic) }}</div><g-icon-button class="logic-editor__logic-head-btn" ng-if="!$first" icon="expand-less" size="small" ng-click="$ctrl.moveLogic(logic.id, displayedLogic[$index - 1].id)"></g-icon-button><g-icon-button class="logic-editor__logic-head-btn" ng-if="!$last" icon="expand-more" size="small" ng-click="$ctrl.moveLogic(logic.id, displayedLogic[$index + 1].id)"></g-icon-button><g-icon-button class="logic-editor__logic-head-btn" icon="copy" size="small" ng-click="$ctrl.duplicateLogic(logic.id)"></g-icon-button><g-icon-button class="logic-editor__logic-head-btn" icon="close" size="small" ng-click="$ctrl.removeLogic(logic.id)"></g-icon-button></div><div class="logic-editor__logic-row" ng-if="logic.isDisplay() &amp;&amp; $ctrl.supportsDisplayTarget"><div class="logic-editor__logic-row-fields -two"><div class="logic-editor__logic-row-field"><field-select placeholder="target" options="$ctrl.targetOptions" selected="logic.target" on-change="logic.target = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="logic.targetsChoices()"><field-select placeholder="{{ $ctrl.targetChoicesPlaceholder }}" options="$ctrl.targetChoicesOptions" selected="logic.choiceIds" on-change="logic.choiceIds = $value; $ctrl.update()" multi="true" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="logic.targetsStatements()"><field-select placeholder="statements" options="$ctrl.targetStatementsOptions" selected="logic.statementIds" on-change="logic.statementIds = $value; $ctrl.update()" multi="true" inline="true"></field-select></div></div><div class="logic-editor__logic-row-side"></div></div><div class="logic-editor__logic-head" ng-if="logic.isDisplay() &amp;&amp; $ctrl.supportsDisplayTarget"><div class="logic-editor__logic-head-title">When...</div></div><div class="logic-editor__logic-row" ng-repeat="condition in logic.conditions track by condition.id"><div class="logic-editor__logic-row-fields" ng-class="$ctrl.getConditionRowClass(condition)"><div class="logic-editor__logic-row-field"><field-select placeholder="type" options="$ctrl.conditionTypeOptions" selected="condition.type" on-change="condition.type = $value; $ctrl.clearQuestion(condition); $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesQuestion()"><field-select placeholder="question" options="$ctrl.getQuestionOptions(condition)" selected="condition.questionId" on-change="condition.questionId = $value; condition.choiceIds = []; condition.statementIds = []; condition.loopKey = null; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesLoopKey()"><field-select placeholder="loop variable" options="$ctrl.getLoopVariableOptions(condition.questionId)" selected="condition.loopKey" on-change="condition.loopKey = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesDisplayedTarget()"><field-select placeholder="target" options="$ctrl.getDisplayedTargetOptions(condition.questionId)" selected="condition.displayedTarget" on-change="condition.displayedTarget = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesDisplayedQuantifier()"><field-select placeholder="quantifier" options="$ctrl.displayedQuantifierOptions" selected="condition.displayedQuantifier" on-change="condition.displayedQuantifier = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesStatements()"><field-select placeholder="statements" options="$ctrl.getStatementOptions(condition.questionId)" selected="condition.statementIds" on-change="condition.statementIds = $value; $ctrl.update()" multi="true" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesList()"><field-select placeholder="name" options="$ctrl.listOptions" selected="condition.list" on-change="condition.list = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesPeriod()"><field-text type="number" placeholder="within period" model="condition.period" suffix="days" inline="true"></field-text></div><div class="logic-editor__logic-row-field" ng-if="condition.usesSelectionQuantifier()"><field-select placeholder="quantifier" options="$ctrl.selectionQuantifierOptions" selected="condition.selectionQuantifier" on-change="condition.selectionQuantifier = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesChoiceQuantifier()"><field-select placeholder="quantifier" options="$ctrl.choiceQuantifierOptions" selected="condition.choiceQuantifier" on-change="condition.choiceQuantifier = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesListQuantifier()"><field-select placeholder="quantifier" options="$ctrl.listQuantifierOptions" selected="condition.listQuantifier" on-change="condition.listQuantifier = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesChoices()"><field-select placeholder="{{ $ctrl.getConditionChoicesPlaceholder(condition.questionId) }}" options="$ctrl.getChoiceOptions(condition.questionId)" selected="condition.choiceIds" on-change="condition.choiceIds = $value; $ctrl.update()" multi="true" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesTags()"><field-select placeholder="tags" options="$ctrl.allTagOptions" selected="condition.tags" on-change="condition.tags = $value; $ctrl.update()" multi="true" inline="true" search="$ctrl.allTagOptions.length &gt; 10" custom="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesTextQuantifier()"><field-select placeholder="quantifier" options="$ctrl.textQuantifierOptions" selected="condition.textQuantifier" on-change="condition.textQuantifier = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesNumericQuantifier()"><field-select placeholder="quantifier" options="$ctrl.numericQuantifierOptions" selected="condition.numericQuantifier" on-change="condition.numericQuantifier = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesNumber()"><field-text type="number" placeholder="number" model="condition.number" inline="true"></field-text></div><div class="logic-editor__logic-row-field" ng-if="condition.usesNumbers()"><field-text type="text" placeholder="numbers" model="condition.numbersStr" inline="true"></field-text></div><div class="logic-editor__logic-row-field" ng-if="condition.usesListItems()"><field-select placeholder="items" options="$ctrl.listItemOptionsByList[condition.list]" selected="condition.listItems" on-change="condition.listItems = $value; $ctrl.update()" multi="true" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesRanks()"><field-select placeholder="ranks" options="$ctrl.rankOptions" selected="condition.ranks" on-change="condition.ranks = $value; $ctrl.update()" multi="true" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesText()"><field-text type="text" placeholder="text" model="condition.text" inline="true"></field-text></div><div class="logic-editor__logic-row-field" ng-if="condition.usesInsideLoopQuantifier()"><field-select placeholder="quantifier" options="$ctrl.insideLoopQuantifierOptions" selected="condition.insideLoopQuantifier" on-change="condition.insideLoopQuantifier = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="condition.usesLoopKeys()"><field-select placeholder="loop variables" options="$ctrl.getLoopVariableOptions($ctrl.view.value.id)" selected="condition.loopKeys" on-change="condition.loopKeys = $value; $ctrl.update()" multi="true" inline="true"></field-select></div></div><div class="logic-editor__logic-row-side"><div class="logic-editor__logic-row-and" ng-if="$index !== logic.conditions.length - 1">AND</div><g-icon-button class="logic-editor__logic-row-add" ng-if="$index === logic.conditions.length - 1" icon="add" size="small" ng-click="logic.addCondition()"> </g-icon-button><div class="logic-editor__logic-row-gap"></div><g-icon-button class="logic-editor__logic-row-remove" icon="close" size="small" disabled="logic.conditions.length === 1" on-click="logic.removeCondition(condition.id)"> </g-icon-button></div></div><span ng-if="logic.type === &quot;ACTION&quot;"><div class="logic-editor__logic-head"><div class="logic-editor__logic-head-title">Then...</div></div><div class="logic-editor__logic-row-wrapper" ng-repeat="action in logic.actions track by action.id"><div class="logic-editor__logic-row"><div class="logic-editor__logic-row-fields" ng-class="$ctrl.getActionRowClass(action)"><div class="logic-editor__logic-row-field"><field-select placeholder="type" options="$ctrl.actionTypeOptions" selected="action.type" on-change="action.type = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="action.usesQuestion()"><field-select placeholder="question" options="$ctrl.allQuestionOptionsSansHiddenVariables" selected="action.questionId" on-change="action.questionId = $value; action.loopKey = null; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="action.usesSection()"><field-select placeholder="section" options="$ctrl.allSectionOptions" selected="action.sectionId" on-change="action.sectionId = $value; action.loopKey = null; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="action.usesLoopKey()"><field-select placeholder="loop variable" options="$ctrl.getLoopVariableOptions(action.getViewId())" selected="action.loopKey" on-change="action.loopKey = $value; $ctrl.update()" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="action.usesTag()"><field-text placeholder="tag" model="action.tag" inline="true"></field-text></div><div class="logic-editor__logic-row-field" ng-if="action.usesList()"><field-select placeholder="list" options="$ctrl.listOptions" selected="action.list" on-change="action.list = $value; $ctrl.update()" inline="true" custom="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="action.usesList() &amp;&amp; action.list"><field-select placeholder="item" options="$ctrl.listItemOptionsByList[action.list]" selected="action.listItem" on-change="action.listItem = $value; $ctrl.update()" inline="true" custom="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="action.usesViewGroups()"><field-select placeholder="groups" options="$ctrl.viewGroupOptions" selected="action.viewGroupIds" on-change="action.viewGroupIds = $value; $ctrl.update()" multi="true" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="action.usesLeastFill()"><field-select placeholder="tags" options="$ctrl.allTagOptions" selected="action.leastFill.tags" on-change="action.leastFill.tags = $value; $ctrl.update(); $ctrl.updateLeastFill(action.leastFill)" multi="true" inline="true" custom="true" search="$ctrl.allTagOptions.length &gt; 10"></field-select></div><div class="logic-editor__logic-row-field" ng-if="action.usesTags()"><field-select placeholder="tags" options="$ctrl.allTagOptions" selected="action.tags" on-change="action.tags = $value; $ctrl.update();" multi="true" inline="true" search="$ctrl.allTagOptions.length &gt; 10"></field-select></div><div class="logic-editor__logic-row-field" ng-if="action.usesLeastFill()" ng-init="action.leastFill.populateAmountOptions()"><field-select placeholder="Set amount to least fill" options="action.leastFill.amountOptions" selected="action.leastFill.amount" on-change="action.leastFill.amount = $value" inline="true"></field-select></div><div class="logic-editor__logic-row-field" ng-if="action.usesVariables()"><field-text placeholder="key" model="action.variableKey" on-key-down="$ctrl.onVariableKeyDown" on-paste="$ctrl.onVariablePaste" inline="true"></field-text></div><div class="logic-editor__logic-row-field" ng-if="action.usesVariables()"><field-text placeholder="value" model="action.variableValue" inline="true"></field-text></div></div><div class="logic-editor__logic-row-side"><div class="logic-editor__logic-row-and" ng-if="$index !== logic.actions.length - 1">AND</div><g-icon-button class="logic-editor__logic-row-add" ng-if="$index === logic.actions.length - 1" icon="add" size="small" ng-click="logic.addAction()"> </g-icon-button><div class="logic-editor__logic-row-gap"></div><g-icon-button class="logic-editor__logic-row-remove" icon="close" size="small" disabled="logic.actions.length === 1" on-click="logic.removeAction(action.id)"> </g-icon-button></div></div><errors ng-if="$ctrl.jumpsAndTargetUsesDisplayLogic(action)" small="true" errors="[&quot;Warning: The question this jumps to uses Display logic or in a loop with borrowed variables. If that question is hidden from the respondent they will continue to the next visible question.&quot;]" style="margin-right:80px;"></errors></div></span></div><div class="logic-editor__btns-wrapper"><div class="logic-editor__btns"><div class="logic-editor__btn -margin-right"><g-btn secondary="true" label="Add Display Logic" on-click="$ctrl.handleAddLogic(&quot;DISPLAY&quot;)"></g-btn></div><div class="logic-editor__btn -margin-right"><g-btn secondary="true" label="Add Action Logic" on-click="$ctrl.handleAddLogic(&quot;ACTION&quot;)"></g-btn></div></div><div class="logic-editor__btns"><div class="logic-editor__btn -margin-left"><g-btn disabled="!$ctrl.supportsQuickTags" secondary="true" label="Add Quick Tags" on-click="$ctrl.addQuickTags()"></g-btn></div></div></div><div class="logic-editor__tip"><g-icon class="logic-editor__tip-icon" icon="idea"></g-icon><div class="logic-editor__tip-text"><b>Pro Tip:</b> Need to use the same set of conditions in multiple places? Use a tag! That way you only need to configure your conditions once, no matter how complex they are.</div></div></div></div>');
$templateCache.put('matrix-fields.html','<list-input label="Statements" survey="$ctrl.question.survey" lender="$ctrl.question.statementLender" get-prev-questions="$ctrl.question.getPrevQuestions()" model="$ctrl.question.statements" presets="null" max-items="null" randomize-headings="$ctrl.question.randomizeStatementHeadings" randomize-items="$ctrl.question.randomizeStatements" images-enabled="$ctrl.question.statementImagesEnabled" labels-hidden="$ctrl.question.statementLabelsHidden" parent-id="$ctrl.question.id" add-only="$ctrl.isRestricted" disabled="false" is-template="$ctrl.question.isTemplate" is-text-capture-option="false" is-unique-text-capture="false" is-exclusive-option="false" is-anchor-option="true" is-independent-option="false" is-heading-option="$ctrl.question.supportsStatementHeadings()" is-randomize-option="true" is-score-option="false" is-borrow-from-option="true" is-borrow-from-persist-option="true" is-borrow-from-displayed-options="true" is-copy-from-option="true" is-hide-labels-option="true" is-images-option="$ctrl.question.canHaveStatementImages()" is-logic-editor-option="true" on-randomize-headings="$ctrl.question.randomizeStatementHeadings = $value" on-randomize-items="$ctrl.question.randomizeStatements = $value" on-hidden-labels-toggle="$ctrl.question.statementLabelsHidden = !$ctrl.question.statementLabelsHidden" on-copy-from="$ctrl.question.copyChoicesFrom($questionId, $target, true)" on-borrow-from="$ctrl.question.borrowChoicesFrom($questionId, true)" on-image-change="$ctrl.onImageChange($item, $imageData)" on-images-toggle="$ctrl.question.statementImagesEnabled = !$ctrl.question.statementImagesEnabled" on-item-add="$ctrl.question.addStatement($item, $index, $shouldReplace)" on-tags-add="$ctrl.question.addChoiceDisplayLogicWithTags($item, $tags)"></list-input><list-input label="Choices" survey="$ctrl.question.survey" lender="$ctrl.question.choiceLender" get-prev-questions="$ctrl.question.getPrevQuestions()" model="$ctrl.question.choices" presets="$ctrl.presets" max-items="$ctrl.isDndDisplayType() ? $ctrl.maxDndChoices : 11" randomize-headings="$ctrl.question.randomizeChoiceHeadings" randomize-items="$ctrl.question.randomizeChoices" images-enabled="$ctrl.question.choiceImagesEnabled" labels-hidden="$ctrl.question.choiceLabelsHidden" parent-id="$ctrl.question.id" add-only="$ctrl.isRestricted" disabled="$ctrl.isRestricted" is-template="$ctrl.question.isTemplate" is-text-capture-option="!$ctrl.isScaleDisplayType() &amp;&amp; !$ctrl.isDndDisplayType() &amp;&amp; !$ctrl.question.flipTableAxis" is-unique-text-capture="true" is-exclusive-option="!$ctrl.isScaleDisplayType() &amp;&amp; !$ctrl.isDndDisplayType()" is-anchor-option="true" is-independent-option="$ctrl.isScaleDisplayType()" is-heading-option="$ctrl.question.supportsChoiceHeadings()" is-randomize-option="true" is-score-option="false" is-borrow-from-option="true" is-borrow-from-persist-option="true" is-borrow-from-displayed-options="true" is-copy-from-option="true" is-hide-labels-option="true" is-images-option="$ctrl.question.canHaveChoiceImages()" is-logic-editor-option="true" on-randomize-headings="$ctrl.question.randomizeChoiceHeadings = $value" on-randomize-items="$ctrl.question.randomizeChoices = $value" on-hidden-labels-toggle="$ctrl.question.choiceLabelsHidden = !$ctrl.question.choiceLabelsHidden" on-copy-from="$ctrl.question.copyChoicesFrom($questionId, $target, false)" on-borrow-from="$ctrl.question.borrowChoicesFrom($questionId, false)" on-image-change="$ctrl.onImageChange($item, $imageData)" on-images-toggle="$ctrl.question.choiceImagesEnabled = !$ctrl.question.choiceImagesEnabled" on-item-add="$ctrl.question.addChoice($item, $index, $shouldReplace)" on-tags-add="$ctrl.question.addChoiceDisplayLogicWithTags($item, $tags)"></list-input><div class="gl-form-group" ng-if="!$ctrl.isScaleDisplayType() &amp;&amp; !$ctrl.isDndDisplayType()"><label class="gl-form-label" for="question{{ $ctrl.question.id }}maxSelections">Maximum choices respondent can select (leave blank for unlimited)</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}maxSelections" type="number" min="1" name="question{{ $ctrl.question.id }}maxSelections" ng-model="$ctrl.question.maxSelections"/></div><div class="list-input"><label class="gl-form-label list-input__head-label">Display Type</label><div class="matrix-fields__select-wrapper"><field-select placeholder="Select Type" options="$ctrl.question.MatrixDisplayTypeOptions" selected="$ctrl.question.displayType" on-change="$ctrl.setDisplayType($value)" inline="false"></field-select></div></div><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}statementSamplingEnabled" ng-model="$ctrl.question.statementSamplingEnabled"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}statementSamplingEnabled" hint="Randomly select a number of statements to be shown to each respondent. Uses Fisher Yates algorithm." inline="true">Sample statements</field-label></div><div class="gl-form-group matrix-fields__child-group" ng-if="$ctrl.question.statementSamplingEnabled"><label class="gl-form-label" for="question{{ $ctrl.question.id }}statementSamplingAmount">Number of statements to sample</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}statementSamplingAmount" type="number" min="1" name="question{{ $ctrl.question.id }}statementSamplingAmount" ng-model="$ctrl.question.statementSamplingAmount"/></div><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}choiceSamplingEnabled" ng-model="$ctrl.question.choiceSamplingEnabled"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}choiceSamplingEnabled" hint="Randomly select a number of choices to be shown to each respondent. Uses Fisher Yates algorithm." inline="true">Sample choices</field-label></div><div class="gl-form-group matrix-fields__child-group" ng-if="$ctrl.question.choiceSamplingEnabled"><label class="gl-form-label" for="question{{ $ctrl.question.id }}choiceSamplingAmount">Number of choices to sample</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}choiceSamplingAmount" type="number" min="1" name="question{{ $ctrl.question.id }}choiceSamplingAmount" ng-model="$ctrl.question.choiceSamplingAmount"/></div><div class="gl-form-checkbox-group" ng-if="$ctrl.isDefaultDisplayType()"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}flipTableAxis" ng-model="$ctrl.question.flipTableAxis" ng-change="$ctrl.onFlipTableAxisChange()"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}flipTableAxis" hint="On large screens respondents see a table view that you may want to flip. On small screens respondents see vertical blocks for each statement." inline="true">Flip table axis</field-label></div><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}matrixUniqueSelection" ng-model="$ctrl.question.matrixUniqueSelection"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}matrixUniqueSelection" hint="Prevent respondents from selecting the same choice for more than one statement." inline="true">Unique Selection</field-label></div>');
$templateCache.put('media-view.html','<div class="media-view" ng-click="$ctrl.close($event)"><img class="media-view__image" ng-if="$ctrl.type === $ctrl.Types.IMAGE" ng-src="{{ $ctrl.url }}" ng-style="$ctrl.getImageStyle()"/><div class="media-view__download" ng-if="$ctrl.type === $ctrl.Types.IMAGE &amp;&amp; $ctrl.showDownload"><g-btn label="Download Image" on-click="$ctrl.downloadImage()"></g-btn></div><div class="media-view__content" ng-if="$ctrl.type === $ctrl.Types.VIDEO"><div class="media-view__media-wrapper"><video-player video="$ctrl.video"></video-player></div></div><div class="media-view__content" ng-if="$ctrl.type === $ctrl.Types.YOUTUBE"><div class="media-view__media-wrapper media-view__aspect-ratio-box"><iframe class="media-view__iframe-youtube" ng-src="{{ $ctrl.youTubeVideoUrl }}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe></div></div><div class="media-view__content" ng-if="$ctrl.type === $ctrl.Types.AUDIO"><div class="media-view__media-wrapper"><audio class="media-view__audio" controls="controls"><source ng-src="{{ $ctrl.url }}"/>Your browser does not support the audio element.</audio></div></div><div class="media-view__content" ng-if="$ctrl.type === $ctrl.Types.IFRAME"><div class="media-view__media-wrapper -iframe"><iframe class="media-view__iframe" ng-src="{{ $ctrl.iframeUrl }}" allowfullscreen="allowfullscreen"></iframe></div></div></div>');
$templateCache.put('micro-action.html','<div class="micro-action"><div class="micro-action__text" ng-transclude=""></div><g-icon class="micro-action__icon" icon="{{ $ctrl.icon }}" size="small" color="rgba(BLUE_SLATE, .4)"></g-icon></div>');
$templateCache.put('min-characters-field.html','<div class="gl-form-group"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}minCharacters" hint="Require respondents to enter a minimum number of characters. Leave blank to make this optional" inline="true">Minimum characters</field-label><input class="gl-form-control" id="question{{ $ctrl.question.id }}minCharacters" type="number" min="1" name="question{{ $ctrl.question.id }}minCharacters" ng-model="$ctrl.question.minCharacters"/></div>');
$templateCache.put('multiselect-dropdown.template.html','<div class="gl-multiselect-dropdown" ng-class="{ open: open }"><div class="dropdown-toggle" ng-class="settings.buttonClasses" ng-click="toggleDropdown()">{{ getButtonText() }}<span class="gi" ng-class="{ &quot;gi-expand-more&quot;: !open, &quot;gi-expand-less&quot;: open }"></span></div><ul class="dropdown-menu" ng-style="{ display: open ? &quot;block&quot; : &quot;none&quot;, height: settings.scrollable ? settings.scrollableHeight : &quot;auto&quot; }"><li class="dropdown-item" ng-hide="!settings.showCheckAll || settings.selectionLimit &gt; 0"><a ng-click="checkAll()"><span class="gi gi-done"></span>{{ texts.checkAll }}</a></li><li class="dropdown-item" ng-show="::(settings.showUncheckAll &amp;&amp; !singleSelection)"><a ng-click="uncheckAll()"><span class="gi gi-close"></span>{{ texts.uncheckAll }}</a></li><hr class="divider" ng-hide="::(singleSelection || (!settings.showCheckAll || settings.selectionLimit &gt; 0) &amp;&amp; !settings.showUncheckAll)"/><li ng-show="::settings.enableSearch"><input class="dropdown-search" type="text" ng-model="searchFilter" placeholder="{{ texts.searchPlaceholder }}"/></li><hr class="divider" ng-show="settings.enableSearch"/><li class="dropdown-item" ng-repeat="option in recommendedOptions | filter: searchFilter"><a tabindex="-1" ng-click="setSelectedItem(getPropertyForObject(option, settings.idProp))"><span class="gi" ng-if="::!singleSelection" ng-class="{ &quot;gi-done&quot;: isChecked(getPropertyForObject(option, settings.idProp)) }"></span>{{ getPropertyForObject(option, settings.displayProp) }}</a></li><hr class="divider" ng-show="recommendedOptions.length"/><li class="dropdown-item" ng-repeat="option in options | filter: searchFilter"><a tabindex="-1" ng-click="setSelectedItem(getPropertyForObject(option, settings.idProp))"><span class="gi" ng-if="::!singleSelection" ng-class="{ &quot;gi-done&quot;: isChecked(getPropertyForObject(option, settings.idProp)) }"></span>{{ getPropertyForObject(option, settings.displayProp) }}</a></li></ul></div>');
$templateCache.put('numeric-fields.html','<div class="numeric-fields__options"><div class="numeric-fields__option"><label class="numeric-fields__field" for="question{{ $ctrl.question.id }}numericMin"><div class="numeric-fields__label">Start</div><input class="numeric-fields__input" id="question{{ $ctrl.question.id }}numericMin" type="number" name="question{{ $ctrl.question.id }}numericMin" ng-model="$ctrl.question.numericMin" ng-change="$ctrl.calc()" ng-disabled="$ctrl.isRestricted"/></label></div><div class="numeric-fields__option"><label class="numeric-fields__field" for="question{{ $ctrl.question.id }}numericMax"><div class="numeric-fields__label">End</div><input class="numeric-fields__input" id="question{{ $ctrl.question.id }}numericMax" type="number" name="question{{ $ctrl.question.id }}numericMax" ng-model="$ctrl.question.numericMax" ng-change="$ctrl.calc()" ng-disabled="$ctrl.isRestricted"/></label></div><div class="numeric-fields__option"><label class="numeric-fields__field" for="question{{ $ctrl.question.id }}numericUnit"><div class="numeric-fields__label">Unit</div><select class="numeric-fields__select" id="question{{ $ctrl.question.id }}numericUnit" ng-model="$ctrl.question.numericUnit" ng-options="unit.type as unit.label group by unit.group for unit in $ctrl.units" ng-change="$ctrl.calc()" ng-disabled="$ctrl.isRestricted"></select><g-icon class="numeric-fields__field-icon" icon="expand-more" size="small"></g-icon></label></div><div class="numeric-fields__option"><label class="numeric-fields__field" for="question{{ $ctrl.question.id }}numericSteps"><div class="numeric-fields__label">Steps</div><input class="numeric-fields__input" id="question{{ $ctrl.question.id }}numericSteps" type="number" name="question{{ $ctrl.question.id }}numericSteps" ng-model="$ctrl.question.numericSteps" ng-change="$ctrl.calc()" ng-disabled="$ctrl.isRestricted"/></label></div></div><div class="numeric-fields__choices" ng-if="!$ctrl.errors.length &amp;&amp; $ctrl.question.numericUnit !== $ctrl.Units.CUSTOM"><div class="numeric-fields__label">Choices</div><div class="numeric-fields__choice" ng-repeat="value in $ctrl.values|limitTo:$ctrl.ValuesLimit">{{ value.label }}</div><span ng-if="$ctrl.values.length &gt; $ctrl.ValuesLimit + 1">... </span><div class="numeric-fields__choice" ng-if="$ctrl.values.length &gt; $ctrl.ValuesLimit">{{ $ctrl.values[$ctrl.values.length - 1].label }}</div></div><div class="numeric-fields__choices" ng-if="$ctrl.question.numericUnit === $ctrl.Units.CUSTOM"><div class="numeric-fields__label">Choices</div><input class="numeric-fields__input -custom" ng-repeat="value in $ctrl.values" ng-model="value.label" ng-change="$ctrl.updateLabel($index, value.label)" ng-disabled="$ctrl.isRestricted"/></div><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}diff" ng-model="$ctrl.question.numericDiff" ng-disabled="$ctrl.isRestricted"/><label class="gl-form-label" for="question{{ $ctrl.question.id }}diff">Semantic Differential</label></div><div class="numeric-fields__diff" ng-if="$ctrl.question.numericDiff"><div><div class="numeric-fields__label">Left Text</div><input class="numeric-fields__input -diff" ng-model="$ctrl.question.numericDiffLeft" ng-disabled="$ctrl.isRestricted"/></div><div><div class="numeric-fields__label">Right Text</div><input class="numeric-fields__input -diff" ng-model="$ctrl.question.numericDiffRight" ng-disabled="$ctrl.isRestricted"/></div></div>');
$templateCache.put('overlock.html','<div class="g-overlock" ng-transclude="ng-transclude" ng-style="{ \n        backgroundColor: &quot;rgba(255, 255, 255, &quot; + ($ctrl.opacity || $ctrl.DefaultOpacity) + &quot;)&quot; \n    }"></div>');
$templateCache.put('pipe-chip-text.html','<span class="pipe-chip-text" compile-html="$ctrl.text | pipeChipText:$ctrl.pipes"></span>');
$templateCache.put('place-fields.html','<div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}multiselect" ng-model="$ctrl.question.maxSelections" ng-true-value="null" ng-false-value="1"/><label class="gl-form-label" for="question{{ $ctrl.question.id }}multiselect">Allow Multiple Selections</label></div><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}searchenabled" ng-model="$ctrl.question.isSearchEnabled"/><label class="gl-form-label" for="question{{ $ctrl.question.id }}searchenabled">Show search field</label></div><div class="gl-form-group"><label class="gl-form-label" for="question{{ $ctrl.question.id }}searchquery">Search term</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}searchquery" name="question{{ $ctrl.question.id }}searchquery" ng-model="$ctrl.question.defaultSearchQuery"/></div><div ng-if="$ctrl.subscriberId"><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}subscriberIdFilter" ng-model="$ctrl.question.subscriberIdFilter" ng-true-value="&quot;{{ $ctrl.subscriberId }}&quot;" ng-false-value="null"/><label class="gl-form-label" for="question{{ $ctrl.question.id }}subscriberIdFilter">Only Show My Elements</label></div></div>');
$templateCache.put('question-editor.html','<form class="question-editor" name="$ctrl.questionEditorForm"><!-- Title Selector--><title-selector ng-if="$ctrl.isTitleSelector()" question="$ctrl.question"></title-selector><!-- Title--><title-field ng-if="$ctrl.isTitleField()" key="question{{ $ctrl.question.id }}title" label="{{ $ctrl.titleFieldLabel }}" pipes-allowed="$ctrl.index &gt; 0" value="$ctrl.question.title" pipes="$ctrl.question.titlePipes" on-change="$ctrl.question.title = $value" get-pipe-questions="$ctrl.getPipeQuestions()"></title-field><!-- Description--><div class="gl-form-group" ng-if="$ctrl.isDescriptionField()"><label class="gl-form-label" for="question{{ $ctrl.question.id }}description">Description</label><textarea class="question-editor__textarea" id="question{{ $ctrl.question.id }}description" placeholder="{{ $ctrl.descriptionPlaceholder }}" ng-model="$ctrl.question.description" ng-change="$ctrl.onDescriptionChange()" msd-elastic="\n"></textarea></div><!-- Image--><div class="gl-form-group" ng-if="$ctrl.isImageField()"><div class="question-editor__split" ng-init="isImageLabel=!!$ctrl.question.imageUrl"><div><label class="gl-form-label" for="question{{ $ctrl.question.id }}image">Image</label><gl-image-input class="question-editor__image" id="question{{ $ctrl.question.id }}image" src="$ctrl.question.imageUrl" on-change="$ctrl.setImage($imageData); isImageLabel=!!$imageData" hint="800 x 400" ratio="0.5"></gl-image-input><div class="gl-form-checkbox-group" ng-if="$ctrl.isInLoop" style="margin-top:8px"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}ImageFromLoop" ng-model="$ctrl.question.imageFromLoop"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}ImageFromLoop" hint="Use the image from a loop variable when available" inline="true">From loop variable</field-label></div></div><div ng-if="isImageLabel"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}imageLabel" hint="The name of your image. This is shown on charts." inline="true">Image Label</field-label><input class="gl-form-control" type="text" id="question{{ $ctrl.question.id }}imageLabel" name="question{{ $ctrl.question.id }}imageLabel" placeholder="{{ $ctrl.defaultImageLabel }}" ng-model="$ctrl.question.imageLabel"/></div></div></div><!-- Text--><text-fields ng-if="$ctrl.isTextFields()" question="$ctrl.question" is-restricted="$ctrl.isRestricted"></text-fields><!-- Numeric--><numeric-fields ng-if="$ctrl.isNumericFields()" question="$ctrl.question" is-restricted="$ctrl.isRestricted"></numeric-fields><!-- Scale--><scale-fields ng-if="$ctrl.isScaleFields()" question="$ctrl.question" is-restricted="$ctrl.isRestricted"></scale-fields><!-- Rating--><rating-fields ng-if="$ctrl.isRatingFields()" question="$ctrl.question" is-restricted="$ctrl.isRestricted"></rating-fields><!-- Matrix--><matrix-fields ng-if="$ctrl.isMatrixFields()" question="$ctrl.question" is-restricted="$ctrl.isRestricted"></matrix-fields><!-- Choice--><choice-fields ng-if="$ctrl.isChoiceFields()" question="$ctrl.question" is-restricted="$ctrl.isRestricted" is-ssr="$ctrl.isSsr"></choice-fields><!-- Location--><location-fields ng-if="$ctrl.isLocationFields()" question="$ctrl.question" is-restricted="$ctrl.isRestricted"></location-fields><!-- Place--><place-fields ng-if="$ctrl.isPlaceFields()" question="$ctrl.question" is-restricted="$ctrl.isRestricted" subscriber-id="$ctrl.subscriberId"></place-fields><!-- Multiline Text--><min-characters-field ng-if="$ctrl.isMultilineTextFields()" question="$ctrl.question"></min-characters-field><!-- Constant Sum--><constant-sum-fields ng-if="$ctrl.isConstantSumFields()" question="$ctrl.question" is-restricted="$ctrl.isRestricted" pipes-allowed="$ctrl.index &gt; 0" get-pipe-questions="$ctrl.getPipeQuestions()"></constant-sum-fields><!-- Score--><score-fields ng-if="$ctrl.isScoreFields()" question="$ctrl.question" is-restricted="$ctrl.isRestricted"></score-fields><!-- Text Exclusive Choice--><div ng-if="$ctrl.isTextExclusiveChoiceFields()"><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}textExclusiveChoiceEnabled" ng-model="$ctrl.question.textExclusiveChoiceEnabled" ng-disabled="!!$ctrl.question.textValidator"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}textExclusiveChoiceEnabled" hint="{{ $ctrl.getTextExclusiveChoiceHint() }}" disabled="!!$ctrl.question.textValidator" inline="true">Add Exclusive Choice</field-label></div><div class="gl-form-group question-editor__child-group" ng-if="$ctrl.question.textExclusiveChoiceEnabled"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}textExclusiveChoiceLabel" disabled="!!$ctrl.question.textValidator" inline="true">Label</field-label><input class="gl-form-control" id="question{{ $ctrl.question.id }}textExclusiveChoiceLabel" type="text" name="question{{ $ctrl.question.id }}textExclusiveChoiceLabel" placeholder="" ng-model="$ctrl.question.textExclusiveChoiceLabel" ng-disabled="!!$ctrl.question.textValidator"/></div></div><!-- Compulsory--><div class="gl-form-checkbox-group" ng-if="$ctrl.isCompulsoryField()"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}compulsory" ng-model="$ctrl.question.isCompulsory" ng-disabled="$ctrl.isRestricted"/><label class="gl-form-label" for="question{{ $ctrl.question.id }}compulsory">Make Compulsory</label></div><!-- Reference--><div class="gl-form-group"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}reference" hint="An internal reference that is not exposed to respondents" inline="true">Reference</field-label><input class="gl-form-control" id="question{{ $ctrl.question.id }}reference" name="question{{ $ctrl.question.id }}reference" ng-model="$ctrl.question.reference"/></div><!-- Comparison Key--><div class="gl-form-group" ng-if="$ctrl.isComparisonKeyField()"><label class="gl-form-label" for="question{{ $ctrl.question.id }}comparisonKey">Comparison Key</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}comparisonKey" name="question{{ $ctrl.question.id }}comparisonKey" ng-model="$ctrl.question.comparisonKey" ng-disabled="$ctrl.isRestricted"/></div><!-- Profiling Key--><div ng-if="$ctrl.isProfilingFields()"><h5>Profiling</h5><div class="gl-form-group"><label class="gl-form-label" for="question{{ $ctrl.question.id }}profileKey">Key</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}profileKey" name="question{{ $ctrl.question.id }}profileKey" ng-model="$ctrl.question.profileKey" ng-disabled="$ctrl.isRestricted"/></div><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}profileAsDimension" ng-model="$ctrl.question.profileAsDimension" ng-disabled="$ctrl.isRestricted || !$ctrl.question.profileKey"/><label class="gl-form-label" for="question{{ $ctrl.question.id }}profileAsDimension">Submit as Dimension</label></div></div><!-- Lock--><label class="gl-form-checkbox-group" ng-if="$ctrl.isSsr" for="question{{ $ctrl.question.id }}isLocked"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}isLocked" ng-model="$ctrl.question.isLocked" ng-change="$ctrl.lock()"/><div class="gl-form-label">Locked (disables editing by Subscriber)</div></label><!-- Locked Overlay--><g-overlock ng-if="$ctrl.isLockedOverlay() &amp;&amp; (\n        $ctrl.question.state !== $ctrl.question.States.PUBLISHED || \n        $ctrl.question.state !== $ctrl.question.States.ARCHIVED\n        )"><div class="question-editor__lock"><g-icon icon="private" color="rgba(BLACK, 0.5)" size="extraLarge" tip="locked-question"></g-icon><h4>Question Locked</h4><div ng-switch="$ctrl.canUnlock()"><p ng-switch-when="false">This question can not be changed or removed.</p><p ng-switch-when="true">This question is locked to subscribers.</p></div><g-btn ng-if="$ctrl.canUnlock()" label="Unlock" secondary="true" on-click="$ctrl.unlock()"></g-btn></div></g-overlock><!-- Published Overlay--><g-overlock ng-if="$ctrl.question.state === $ctrl.question.States.PUBLISHED" opacity=".3"><div class="question-editor__lock"><g-icon icon="private" color="rgba(BLACK, 0.5)" size="extraLarge" tip="published-question"></g-icon><h4>Variant Published</h4><p>Make this question draft to edit</p></div></g-overlock><!-- Archived Overlay--><g-overlock ng-if="$ctrl.question.state === $ctrl.question.States.ARCHIVED" opacity=".3"><div class="question-editor__lock"><g-icon icon="private" color="rgba(BLACK, 0.5)" size="extraLarge" tip="archived-question"></g-icon><h4>Variant Archived</h4><p>Un archive question to edit</p></div></g-overlock><!-- Hidden Overlay--><g-overlock ng-if="$ctrl.question.isHidden"><div class="question-editor__lock"><g-icon icon="preview" strike="true" color="rgba(BLACK, 0.5)" size="extraLarge"></g-icon><h4>Hidden</h4><p>This question is hidden</p><g-btn label="Unhide" secondary="true" on-click="$ctrl.question.isHidden = false"></g-btn></div></g-overlock></form>');
$templateCache.put('radial.html','<svg class="radial" ng-attr-height="{{ $ctrl.radius * 2 }}" ng-attr-width="{{ $ctrl.radius * 2 }}"><circle class="radial__circle" fill="transparent" ng-attr-stroke="{{ $ctrl.color || &quot;black&quot; }}" ng-attr-stroke-width="{{ $ctrl.stroke }}" ng-attr-stroke-dasharray="{{ $ctrl.circumference + &quot; &quot; + $ctrl.circumference }}" ng-style="{ strokeDashoffset: $ctrl.strokeDashoffset }" ng-attr-r="{{ $ctrl.normalizedRadius }}" ng-attr-cx="{{ $ctrl.radius }}" ng-attr-cy="{{ $ctrl.radius }}"></circle></svg>');
$templateCache.put('rating-fields.html','<div class="gl-form-group"><label class="gl-form-label">Rating type</label><field-select options="$ctrl.templateOptions" selected="$ctrl.question.data.ratingTemplate" on-change="$ctrl.select($value)"></field-select></div>');
$templateCache.put('scale-fields.html','<list-input label="Choices" survey="$ctrl.question.survey" lender="$ctrl.question.choiceLender" get-prev-questions="$ctrl.question.getPrevQuestions()" model="$ctrl.question.choices" presets="$ctrl.presets" max-items="8" randomize-headings="$ctrl.question.randomizeChoiceHeadings" randomize-items="$ctrl.question.randomizeChoices" images-enabled="$ctrl.question.choiceImagesEnabled" labels-hidden="$ctrl.question.choiceLabelsHidden" parent-id="$ctrl.question.id" add-only="$ctrl.isRestricted" disabled="false" is-template="$ctrl.question.isTemplate" is-text-capture-option="false" is-unique-text-capture="false" is-exclusive-option="false" is-anchor-option="false" is-independent-option="true" is-heading-option="false" is-randomize-option="false" is-score-option="false" is-borrow-from-option="true" is-borrow-from-persist-option="true" is-borrow-from-displayed-options="true" is-copy-from-option="true" is-hide-labels-option="false" is-images-option="$ctrl.question.canHaveChoiceImages()" is-logic-editor-option="true" on-randomize-headings="$ctrl.question.randomizeChoiceHeadings = $value" on-randomize-items="$ctrl.question.randomizeChoices = $value" on-hidden-labels-toggle="$ctrl.question.choiceLabelsHidden = !$ctrl.question.choiceLabelsHidden" on-copy-from="$ctrl.question.copyChoicesFrom($questionId, $target, false)" on-borrow-from="$ctrl.question.borrowChoicesFrom($questionId, false)" on-image-change="$ctrl.onImageChange($item, $imageData)" on-images-toggle="$ctrl.question.choiceImagesEnabled = !$ctrl.question.choiceImagesEnabled" on-item-add="$ctrl.question.addChoice($item, $index, $shouldReplace)" on-tags-add="$ctrl.question.addChoiceDisplayLogicWithTags($item, $tags)"></list-input><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}choiceSamplingEnabled" ng-model="$ctrl.question.choiceSamplingEnabled"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}choiceSamplingEnabled" hint="Randomly select a number of choices to be shown to each respondent. Uses Fisher Yates algorithm." inline="true">Sample choices</field-label></div><div class="gl-form-group scale-fields__child-group" ng-if="$ctrl.question.choiceSamplingEnabled"><label class="gl-form-label" for="question{{ $ctrl.question.id }}choiceSamplingAmount">Number of choices to sample</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}choiceSamplingAmount" type="number" min="1" name="question{{ $ctrl.question.id }}choiceSamplingAmount" ng-model="$ctrl.question.choiceSamplingAmount"/></div>');
$templateCache.put('score-fields.html','<div class="gl-form-group"><field-label class="gl-form-label" inline="true">Type</field-label><field-radio-set vertical="false"><field-radio selected="$ctrl.isNTS()" on-select="$ctrl.setScoreType($ctrl.ScoreTypes.NTS)" disabled="$ctrl.isRestricted">Net Trust Score</field-radio><field-radio selected="$ctrl.isSRS()" on-select="$ctrl.setScoreType($ctrl.ScoreTypes.SRS)" disabled="$ctrl.isRestricted">Social Responsibility Score</field-radio><field-radio selected="$ctrl.isCustom()" on-select="$ctrl.setScoreType($ctrl.ScoreTypes.CUSTOM)" disabled="$ctrl.isRestricted" hint="Customise your own score question">Custom</field-radio></field-radio-set></div><div class="gl-form-checkbox-group" ng-if="!$ctrl.isCustom()"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}toggleIndependentChoice" ng-model="$ctrl.showIndependentChoice" ng-change="$ctrl.toggleIndependentChoice()"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}toggleIndependentChoice" inline="true">Show "Don\'t know" choice</field-label></div><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}matrixEnabled" ng-model="$ctrl.question.matrixEnabled" ng-disabled="$ctrl.isRestricted"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}matrixEnabled" inline="true">Use as Matrix</field-label></div><list-input ng-if="$ctrl.question.matrixEnabled" label="Statements" survey="$ctrl.question.survey" lender="$ctrl.question.statementLender" get-prev-questions="$ctrl.question.getPrevQuestions()" model="$ctrl.question.statements" presets="null" max-items="null" randomize-headings="$ctrl.question.randomizeStatementHeadings" randomize-items="$ctrl.question.randomizeStatements" images-enabled="$ctrl.question.statementImagesEnabled" labels-hidden="$ctrl.question.statementLabelsHidden" parent-id="$ctrl.question.id" add-only="$ctrl.isRestricted" disabled="false" is-template="$ctrl.question.isTemplate" is-text-capture-option="false" is-unique-text-capture="false" is-exclusive-option="false" is-anchor-option="true" is-independent-option="false" is-heading-option="false" is-randomize-option="true" is-score-option="false" is-borrow-from-option="true" is-borrow-from-persist-option="true" is-borrow-from-displayed-options="true" is-copy-from-option="true" is-hide-labels-option="false" is-images-option="$ctrl.question.canHaveStatementImages()" is-logic-editor-option="true" on-randomize-headings="$ctrl.question.randomizeStatementHeadings = $value" on-randomize-items="$ctrl.question.randomizeStatements = $value" on-hidden-labels-toggle="$ctrl.question.statementLabelsHidden = !$ctrl.question.statementLabelsHidden" on-copy-from="$ctrl.question.copyChoicesFrom($questionId, $target, true)" on-borrow-from="$ctrl.question.borrowChoicesFrom($questionId, true)" on-image-change="$ctrl.onImageChange($item, $imageData)" on-images-toggle="$ctrl.question.statementImagesEnabled = !$ctrl.question.statementImagesEnabled" on-item-add="$ctrl.question.addStatement($item, $index, $shouldReplace)" on-tags-add="$ctrl.question.addChoiceDisplayLogicWithTags($item, $tags)"></list-input><div ng-if="$ctrl.isCustom()"><list-input label="Choices" survey="$ctrl.question.survey" lender="$ctrl.question.choiceLender" get-prev-questions="$ctrl.question.getPrevQuestions()" model="$ctrl.question.choices" presets="null" max-items="11" randomize-headings="$ctrl.question.randomizeChoiceHeadings" randomize-items="$ctrl.question.randomizeChoices" images-enabled="$ctrl.question.choiceImagesEnabled" labels-hidden="$ctrl.question.choiceLabelsHidden" parent-id="$ctrl.question.id" add-only="$ctrl.isRestricted" disabled="$ctrl.isRestricted &amp;&amp; $ctrl.question.matrixEnabled" is-template="$ctrl.question.isTemplate" is-text-capture-option="false" is-unique-text-capture="false" is-exclusive-option="false" is-anchor-option="false" is-independent-option="true" is-heading-option="false" is-randomize-option="false" is-score-option="true" is-borrow-from-option="false" is-borrow-from-persist-option="true" is-borrow-from-displayed-options="true" is-copy-from-option="true" is-hide-labels-option="false" is-images-option="$ctrl.question.canHaveChoiceImages()" is-logic-editor-option="true" on-randomize-headings="$ctrl.question.randomizeChoiceHeadings = $value" on-randomize-items="$ctrl.question.randomizeChoices = $value" on-hidden-labels-toggle="$ctrl.question.choiceLabelsHidden = !$ctrl.question.choiceLabelsHidden" on-copy-from="$ctrl.question.copyChoicesFrom($questionId, $target, false)" on-borrow-from="$ctrl.question.borrowChoicesFrom($questionId, false)" on-image-change="$ctrl.onImageChange($item, $imageData)" on-images-toggle="$ctrl.question.choiceImagesEnabled = !$ctrl.question.choiceImagesEnabled" on-item-add="$ctrl.question.addChoice($item, $index, $shouldReplace)" on-tags-add="$ctrl.question.addChoiceDisplayLogicWithTags($item, $tags)"></list-input><div class="gl-form-group"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}scoreLeftExtremityLabel" hint="Configure the labels shown on the far left and right edges of the scale" inline="true">Range Labels</field-label><div class="score-fields__split"><div><input class="gl-form-control" id="question{{ $ctrl.question.id }}scoreLeftExtremityLabel" type="text" name="question{{ $ctrl.question.id }}scoreLeftExtremityLabel" placeholder="Left Text" ng-model="$ctrl.question.scoreLeftExtremityLabel"/></div><div><input class="gl-form-control" id="question{{ $ctrl.question.id }}scoreRightExtremityLabel" type="text" name="question{{ $ctrl.question.id }}scoreRightExtremityLabel" placeholder="Right Text" ng-model="$ctrl.question.scoreRightExtremityLabel"/></div></div></div><div class="gl-form-group"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}scoreLabel" hint="The name of your score type. This is shown on charts." inline="true">Score Label</field-label><input class="gl-form-control" id="question{{ $ctrl.question.id }}scoreLabel" type="text" name="question{{ $ctrl.question.id }}scoreLabel" placeholder="Score" ng-model="$ctrl.question.scoreLabel"/></div><div class="gl-form-group"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}scoreDefinition" hint="A description of what your score is measuring, or what it means. This is shown on charts." inline="true">Score Definition</field-label><input class="gl-form-control" id="question{{ $ctrl.question.id }}scoreDefinition" type="text" name="question{{ $ctrl.question.id }}scoreDefinition" ng-model="$ctrl.question.scoreDefinition"/></div></div><dive ng-if="$ctrl.question.matrixEnabled"><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}statementSamplingEnabled" ng-model="$ctrl.question.statementSamplingEnabled"/><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}statementSamplingEnabled" hint="Randomly select a number of statements to be shown to each respondent. Uses Fisher Yates algorithm." inline="true">Sample statements</field-label></div><div class="gl-form-group matrix-fields__child-group" ng-if="$ctrl.question.statementSamplingEnabled"><label class="gl-form-label" for="question{{ $ctrl.question.id }}statementSamplingAmount">Number of statements to sample</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}statementSamplingAmount" type="number" min="1" name="question{{ $ctrl.question.id }}statementSamplingAmount" ng-model="$ctrl.question.statementSamplingAmount"/></div></dive>');
$templateCache.put('section-editor.html','<form class="section-editor"><title-field key="section{{ $ctrl.section.id }}title" type="textarea" label="Text" pipes-allowed="$ctrl.index &gt; 0" value="$ctrl.section.title" pipes="$ctrl.section.titlePipes" on-change="$ctrl.section.title = $value" get-pipe-questions="$ctrl.getPipeQuestions()"></title-field><div class="gl-form-group"><div class="section-editor__split"><div class="section-editor__width-restrict"><label class="gl-form-label">Media</label><field-select options="$ctrl.mediaTypeOptions" selected="$ctrl.section.mediaType" on-change="$ctrl.section.mediaType = $value;" inline="true"></field-select></div><div class="section-editor__width-restrict" ng-if="$ctrl.section.mediaType"><field-label class="gl-form-label" key="section{{ $ctrl.section.id }}mediaLabel" hint="The name of your media. This is shown on charts." inline="true">Media Label</field-label><input class="gl-form-control" type="text" id="section{{ $ctrl.section.id }}mediaLabel" name="section{{ $ctrl.section.id }}mediaLabel" placeholder="{{ $ctrl.getDefaultMediaLabel($ctrl.section.mediaType) }}" ng-model="$ctrl.section.mediaLabel"/></div></div></div><div class="gl-form-group" ng-if="$ctrl.section.mediaType === $ctrl.section.MediaTypes.VIDEO"><label class="gl-form-group" for="section{{ $ctrl.section.id }}youTubeVideoUrl"><field-label class="gl-form-label" key="section{{ $ctrl.section.id }}youTubeVideoUrl" hint="Copy the URL from YouTube and paste it below" inline="true">YouTube Video URL</field-label><input class="gl-form-control" id="section{{ $ctrl.section.id }}youTubeVideoUrl" name="youTubeVideoUrl" ng-model="$ctrl.section.youTubeVideoUrl" autocomplete="off" ng-paste="$ctrl.onPaste($event)"/></label></div><div class="gl-form-group" ng-if="$ctrl.section.mediaType === $ctrl.section.MediaTypes.VIDEO_UPLOAD"><field-label class="gl-form-label" key="section{{ $ctrl.section.id }}video" inline="true">Video</field-label><div class="section-editor__width-restrict"><field-video key="section{{ $ctrl.section.id }}video" video="$ctrl.section.video" on-upload="$ctrl.section.survey.queue.add($promise, &quot;Uploading Video&quot;)"></field-video></div></div><div class="gl-form-group" ng-if="$ctrl.section.mediaType === $ctrl.section.MediaTypes.VIDEO_UPLOAD"><field-checkbox checked="$ctrl.section.video.restrictions.scrub" on-change="$ctrl.section.video.restrictions.scrub = $checked" hint="Prevents the respondent from skipping forward in the video. They are still able to rewind if they miss something.">Restricted Controls\n</field-checkbox></div><div class="gl-form-group" ng-if="$ctrl.section.mediaType === $ctrl.section.MediaTypes.VIDEO_UPLOAD"><field-checkbox checked="$ctrl.section.video.restrictions.complete" on-change="$ctrl.section.video.restrictions.complete = $checked" hint="The respondent must reach the end of the video before they can continue to the next screen.">Completion Required\n</field-checkbox></div><div class="gl-form-group" ng-if="$ctrl.section.mediaType === $ctrl.section.MediaTypes.AUDIO"><label class="gl-form-group" for="section{{ $ctrl.section.id }}audioUrl"><field-label class="gl-form-label" key="section{{ $ctrl.section.id }}audioUrl" hint="Copy and paste the MP3 URL or upload the MP3 file on your computer. Please note, the URL and the audio file must end with .mp3" inline="true">Audio URL (mp3)</field-label><div class="section-editor__audio-container"><input class="gl-form-control" id="section{{ $ctrl.section.id }}audioUrl" name="audioUrl" ng-model="$ctrl.section.audioUrl" ng-disabled="$ctrl.isUploadingAudioFile" autocomplete="off"/><g-file-input class="section-editor__audio-upload" accept="{{ $ctrl.audioFileExtension }}" multiple="false" disabled="$ctrl.isUploadingAudioFile" on-change="$ctrl.uploadAudioFile($files)"><g-file-input-control><g-btn label="Upload" secondary="true" loading="$ctrl.isUploadingAudioFile"></g-btn></g-file-input-control></g-file-input></div></label></div><div class="gl-form-group" ng-if="$ctrl.section.mediaType === $ctrl.section.MediaTypes.IMAGE"><label class="gl-form-label" for="section{{ $ctrl.section.id }}image">Image</label><gl-image-input class="section-editor__image" id="section{{ $ctrl.section.id }}image" src="$ctrl.section.imageUrl" on-change="$ctrl.setImage($imageData)" hint="800 x 400" ratio="0.5"></gl-image-input><div class="gl-form-checkbox-group" ng-if="$ctrl.isInLoop" style="margin-top:8px"><input class="gl-checkbox" type="checkbox" id="section{{ $ctrl.section.id }}ImageFromLoop" ng-model="$ctrl.section.imageFromLoop"/><field-label class="gl-form-label" key="section{{ $ctrl.section.id }}ImageFromLoop" hint="Use the image from a loop variable when available" inline="true">From loop variable</field-label></div></div><div class="gl-form-group" ng-if="$ctrl.section.mediaType === $ctrl.section.MediaTypes.IFRAME"><label class="gl-form-group" for="section{{ $ctrl.section.id }}iframeUrl"><field-label class="gl-form-label" key="section{{ $ctrl.section.id }}iframeUrl" hint="Copy the URL from external source and paste it below" inline="true">URL</field-label><input class="gl-form-control" id="section{{ $ctrl.section.id }}iframeUrl" name="iframeUrl" ng-model="$ctrl.section.iframeUrl" autocomplete="off"/></label></div><div class="gl-form-group" ng-if="$ctrl.section.usesDelay()"><label class="gl-form-group" for="section{{ $ctrl.section.id }}delay"><field-label class="gl-form-label" key="section{{ $ctrl.section.id }}delay" hint="Prevents the respondent from going to the next question for N seconds. Zero means no delay." inline="true">Delay Timer</field-label><input class="gl-form-control" id="section{{ $ctrl.section.id }}delay" type="number" name="delay" ng-model="$ctrl.section.delay" autocomplete="off"/></label></div><div class="gl-form-group" ng-if="$ctrl.section.mediaType === $ctrl.section.MediaTypes.IMAGE"><label class="gl-form-group" for="section{{ $ctrl.section.id }}hide"><field-label class="gl-form-label" key="section{{ $ctrl.section.id }}hide" hint="After N seconds the image will be hidden from the respondent. Zero means it will never be hidden." inline="true">Hide Timer</field-label><input class="gl-form-control" id="section{{ $ctrl.section.id }}hide" type="number" name="fade" ng-model="$ctrl.section.hide" autocomplete="off"/></label></div><!-- Reference--><div class="gl-form-group"><field-label class="gl-form-label" key="section{{ $ctrl.section.id }}reference" hint="An internal reference that is not exposed to respondents" inline="true">Reference</field-label><input class="gl-form-control" id="section{{ $ctrl.section.id }}reference" name="section{{ $ctrl.section.id }}reference" ng-model="$ctrl.section.reference"/></div><!-- Hidden Overlay--><g-overlock ng-if="$ctrl.section.isHidden"><div class="question-editor__lock"><g-icon icon="preview" strike="true" color="rgba(BLACK, 0.5)" size="extraLarge"></g-icon><h4>Hidden</h4><p>This section is hidden</p><g-btn label="Unhide" secondary="true" on-click="$ctrl.section.isHidden = false"></g-btn></div></g-overlock></form>');
$templateCache.put('tags-picker.html','<div class="tags-picker"><div class="tags-picker__zero" ng-if="!$ctrl.tags.length"><span>This survey has no tags. You can add tags for this survey in the editor.</span></div><div class="tags-picker__list" ng-if="$ctrl.tags.length"><div class="tags-picker__description" ng-if="$ctrl.description">{{ $ctrl.description }}</div><div class="tags-picker__search" ng-if="$ctrl.tags.length &gt; 10"><field-text key="search" type="text" model="$ctrl.query" placeholder="Search" autocomplete="off" autofocus="true" inline="true"></field-text></div><div class="tags-picker__item" ng-repeat="tag in $ctrl.tags | filter:$ctrl.query track by tag" ng-click="$ctrl.select(tag)"><g-checkbox selected="$ctrl.isSelected(tag)" static="true"></g-checkbox><div class="tags-picker__item-label" ng-class="{ &quot;-selected&quot;: $ctrl.isSelected(tag) }">{{ tag }}</div></div></div><div class="tags-picker__actions"><g-btn class="tags-picker__action" label="Apply" disabled="!$ctrl.tags.length" on-click="$ctrl.apply()"></g-btn><g-btn class="tags-picker__action" secondary="true" label="Cancel" on-click="$ctrl.onCancel()"></g-btn></div></div>');
$templateCache.put('text-fields.html','<div class="text-fields__split"><div><div class="gl-form-group"><label class="gl-form-label" for="question{{ $ctrl.question.id }}textFieldNumber">Number of fields</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}textFieldNumber" type="number" name="question{{ $ctrl.question.id }}textFieldNumber" ng-model="$ctrl.question.textFieldNumber" ng-change="$ctrl.onFieldNumberChange()" ng-disabled="$ctrl.isRestricted"/></div></div><div><div class="gl-form-group"><label class="gl-form-label" for="question{{ $ctrl.question.id }}minAnswers">Minimum required fields</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}minAnswers" type="number" min="1" name="question{{ $ctrl.question.id }}minAnswers" ng-model="$ctrl.question.minAnswers"/></div></div></div><div class="gl-form-checkbox-group"><input class="gl-checkbox" type="checkbox" id="question{{ $ctrl.question.id }}textFieldLabels" ng-model="$ctrl.labelsEnabled" ng-change="$ctrl.toggleLabels()"/><label class="gl-form-label" for="question{{ $ctrl.question.id }}textFieldLabels">Add labels for each field</label></div><div class="gl-form-group question-editor__child-group" ng-if="$ctrl.labelsEnabled"><div class="gl-form-group" ng-repeat="label in $ctrl.question.textFieldLabels track by $index"><field-label class="gl-form-label" key="question{{ $ctrl.question.id }}textFieldLabels-idx{{ $index }}" inline="true">Label {{ $index+1 }}</field-label><input class="gl-form-control" type="text" id="question{{ $ctrl.question.id }}textFieldLabels-idx{{ $index }}" ng-model="$ctrl.question.textFieldLabels[$index]"/></div></div><div class="gl-form-group"><div class="gl-form-label">Validator</div><gl-multiselect-dropdown single-select="single-select" options="$ctrl.validators" selected-model="$ctrl.validator" on-select="$ctrl.onValidatorChange" extra-settings="{ displayProp: &quot;label&quot;, idProp: &quot;value&quot;, externalIdProp: &quot;value&quot;, showCheckAll: false, showUncheckAll: false }"></gl-multiselect-dropdown></div><min-characters-field ng-if="!$ctrl.question.textValidator" question="$ctrl.question"></min-characters-field><div class="text-fields__split"><div><div class="gl-form-group" ng-if="$ctrl.question.textValidator === &quot;NUMERIC_RANGE&quot;"><label class="gl-form-label" for="question{{ $ctrl.question.id }}textNumericMin">Range Minimum</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}textNumericMin" type="number" name="question{{ $ctrl.question.id }}textNumericMin" ng-model="$ctrl.question.textNumericMin"/></div></div><div><div class="gl-form-group" ng-if="$ctrl.question.textValidator === &quot;NUMERIC_RANGE&quot;"><label class="gl-form-label" for="question{{ $ctrl.question.id }}textNumericMax">Range Maximum</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}textNumericMax" type="number" name="question{{ $ctrl.question.id }}textNumericMax" ng-model="$ctrl.question.textNumericMax"/></div></div></div><div class="text-fields__split"><div><div class="gl-form-group" ng-if="$ctrl.question.textValidator === &quot;NUMERIC_RANGE&quot; || $ctrl.question.textValidator === &quot;NUMERIC&quot;"><label class="gl-form-label" for="question{{ $ctrl.question.id }}textPrefix">Prefix</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}textPrefix" name="question{{ $ctrl.question.id }}textPrefix" ng-model="$ctrl.question.textPrefix"/></div></div><div><div class="gl-form-group" ng-if="$ctrl.question.textValidator === &quot;NUMERIC_RANGE&quot; || $ctrl.question.textValidator === &quot;NUMERIC&quot;"><label class="gl-form-label" for="question{{ $ctrl.question.id }}textSuffix">Suffix</label><input class="gl-form-control" id="question{{ $ctrl.question.id }}textSuffix" name="question{{ $ctrl.question.id }}textSuffix" ng-model="$ctrl.question.textSuffix"/></div></div></div>');
$templateCache.put('theme-question-dialog.html','<g-dialog-header title="Question Theme" on-close="$ctrl.onClose()"></g-dialog-header><div class="theme-question-dialog" ng-if="$ctrl.question"><theme-settings context="$ctrl.question.themeContext" survey-context="$ctrl.survey.themeContext" subscriber-context="$ctrl.subscriber.themeContext"></theme-settings><g-btn label="Save" on-click="$ctrl.save()" loading="$ctrl.saving"></g-btn></div><div class="theme-question-dialog" ng-if="!$ctrl.question"><g-spinner block="true"></g-spinner></div>');
$templateCache.put('theme-settings.html','<div class="theme-settings__bar"><div class="theme-settings__dropdown"><field-select placeholder="New Theme" options="$ctrl.options" selected="$ctrl.context.target" on-change="$ctrl.select($value)" inline="true"></field-select></div><div class="theme-settings__action" ng-class="{ &quot;-disabled&quot;: !$ctrl.canEdit() }" ng-click="$ctrl.edit()"><g-icon icon="edit" color="INHERIT" size="small"></g-icon><gl-hint ng-if="$ctrl.canEdit()">Edit this theme.</gl-hint><gl-hint ng-if="!$ctrl.canEdit() &amp;&amp; $ctrl.context.target === &quot;GLOW&quot;">The Glow theme cannot be edited.</gl-hint><gl-hint ng-if="!$ctrl.canEdit() &amp;&amp; $ctrl.context.target === &quot;SUBSCRIBER&quot;">You can edit your account theme in your account settings.</gl-hint><gl-hint ng-if="!$ctrl.canEdit() &amp;&amp; $ctrl.context.target === &quot;SURVEY&quot;">You can edit your survey theme in your analysis settings.</gl-hint></div><div class="theme-settings__action" ng-class="{ &quot;-disabled&quot;: !$ctrl.canDuplicate() }" ng-click="$ctrl.duplicate()"><g-icon icon="copy" color="INHERIT" size="small"></g-icon><gl-hint ng-if="$ctrl.canDuplicate()">Create a new theme using this one as a base.</gl-hint></div><div class="theme-settings__action" ng-class="{ &quot;-disabled&quot;: !$ctrl.canCreate() }" ng-click="$ctrl.create()"><g-icon icon="add" color="INHERIT" size="small"></g-icon><gl-hint ng-if="$ctrl.canCreate()">Create a new theme from scratch.</gl-hint></div></div><div class="theme-settings__editor"><div ng-if="$ctrl.mode === &quot;EDIT_PRESET&quot; || $ctrl.mode === &quot;NEW_PRESET&quot;"><field-label>Theme Name</field-label><field-text model="$ctrl.theme.name"></field-text></div><div class="theme-settings__label"><div class="theme-settings__label-text"><field-label hint="Colors used for regular (non-linear) charts." inline="true">Standard Palette</field-label></div><div class="theme-settings__label-action" ng-click="$ctrl.copyColors($ctrl.theme.standard)">Copy</div><div class="theme-settings__label-action" ng-click="$ctrl.pasteColors($ctrl.theme.standard)">Paste</div></div><field-palette value="$ctrl.theme.standard" on-change="$ctrl.theme.standard = $value" disabled="$ctrl.mode === &quot;PREVIEW&quot;"></field-palette><div class="theme-settings__label"><div class="theme-settings__label-text"><field-label hint="Colors used for scale based charts. Intermediate colors will be interpolated. Colors are ordered negative to positive." inline="true">Linear Palette</field-label></div><div class="theme-settings__label-action" ng-click="$ctrl.copyColors($ctrl.theme.linear)">Copy</div><div class="theme-settings__label-action" ng-click="$ctrl.pasteColors($ctrl.theme.linear)">Paste</div></div><field-palette value="$ctrl.theme.linear" on-change="$ctrl.theme.linear = $value" disabled="$ctrl.mode === &quot;PREVIEW&quot;"></field-palette></div>');
$templateCache.put('title-field.html','<label class="title-field gl-form-group"><div class="title-field__top"><div class="title-field__label gl-form-label" for="{{ $ctrl.key }}">{{ $ctrl.label }}</div><g-menu ng-if="$ctrl.shouldShowInserter()" on-before-open="$ctrl.prepareMenu()" align="bottom-right" close-on-input-focus="true"><g-menu-box class="-scroll" g-menu-content="g-menu-content" max-width="320px"><g-menu-item ng-repeat="question in $ctrl.pipeQuestions" text="{{ question.getTitleLabel({ number: true }) }}" highlight="$ctrl.pipes.has(question.getNumber())" on-click="$ctrl.insertPipe(question.getNumber())"></g-menu-item></g-menu-box><micro-action icon="expand-more">Insert answer from previous question</micro-action></g-menu></div><input class="gl-form-control" ng-if="$ctrl.type !== &quot;textarea&quot;" ng-init="$ctrl.initInput(&quot;input&quot;)" id="{{ $ctrl.key }}" name="{{ $ctrl.key }}" ng-focus="$ctrl.setEditing(true)" ng-blur="$ctrl.setEditing(false)" autocomplete="off"/><textarea class="gl-form-control elastic-input" ng-if="$ctrl.type === &quot;textarea&quot;" ng-init="$ctrl.initInput(&quot;textarea&quot;)" id="{{ $ctrl.key }}" name="{{ $ctrl.key }}" ng-focus="$ctrl.setEditing(true)" ng-blur="$ctrl.setEditing(false)" ng-model="$ctrl.value" msd-elastic=""></textarea></label>');
$templateCache.put('title-selector.html','<div class="title-selector"><div class="title-selector__label gl-form-label">Question</div><div class="title-selector__segments"><div class="title-selector__segment" ng-repeat="segment in ::$ctrl.selector.segments track by $index" ng-switch="segment.type"><div class="title-selector__text" ng-switch-when="TEXT">{{ segment.string }}</div><g-select class="title-selector__dropdown" ng-switch-when="DROPDOWN" placeholder="{{ segment.placeholder }}" options="segment.options" selected="segment.value" custom="segment.allowCustom" on-option-added="$ctrl.addOption(segment, $option)" on-change="$ctrl.updateSegment(segment, $value)" small="true"></g-select><input class="title-selector__input" ng-switch-when="INPUT" type="text" placeholder="{{ segment.placeholder }}" ng-model="segment.value" ng-change="$ctrl.updateSegment(segment, segment.value)"/></div></div></div>');
$templateCache.put('toast.template.html','<div class="gl-toast" ng-click="tapToast()" ng-class="{ \'from-top\': options.newestOnTop }"><div class="gl-toast-message">{{ message }} </div><a class="gl-toast-action" ng-if="action" ng-click="close(true)">{{ actionText || \'OK\' }}</a></div>');
$templateCache.put('translation-editor.html','<div class="translation-editor__header"><div class="translation-editor__header-title">{{ $ctrl.translation.id ? "Edit Translation" : "Add Translation" }}</div><div class="translation-editor__header-btn"><g-btn label="Done" on-click="$ctrl.done()" primary="true" loading="$ctrl.translation.isSaving" disabled="!$ctrl.translation.validate()"></g-btn></div><div class="translation-editor__header-btn"><g-btn label="Cancel" on-click="$ctrl.cancel()" secondary="true" disabled="$ctrl.translation.isSaving"></g-btn></div></div><div class="translation-editor__content"><field-label key="label" hint="A descriptive name for this translation">Label</field-label><field-text key="label" model="$ctrl.translation.label"></field-text><field-label key="language" hint="{{ $ctrl.getLangHint() }}">Language</field-label><field-select options="$ctrl.languageOptions" selected="$ctrl.translation.language" on-change="$ctrl.translation.language = $value" search="true"></field-select><field-label key="type">Type</field-label><field-select options="$ctrl.typeOptions" selected="$ctrl.translation.type" on-change="$ctrl.translation.type = $value"></field-select><div class="translation-editor__link" ng-if="$ctrl.translation.type === $ctrl.Types.CUSTOM"><div class="translation-editor__link-control" ng-click="$ctrl.translation.isPublicUpdateAllowed = !$ctrl.translation.isPublicUpdateAllowed"><field-checkbox checked="$ctrl.translation.isPublicUpdateAllowed" inline="true"></field-checkbox></div><div class="translation-editor__link-info"><field-label inline="true" ng-click="$ctrl.translation.isPublicUpdateAllowed = !$ctrl.translation.isPublicUpdateAllowed">Shareable Link</field-label><div class="translation-editor__link-text">If you require an external service to edit translations you can share a link with them. \nThe link will only grant access to view and edit the text values below.</div><div class="translation-editor__link-warning" ng-if="$ctrl.translation.isPublicUpdateAllowed &amp;&amp; $ctrl.translation.isNew">The link will become available once you have created this translation</div><div class="translation-editor__link-btn" ng-if="$ctrl.translation.isPublicUpdateAllowed"><g-btn icon="link" label="Copy Link" secondary="true" disabled="$ctrl.translation.isNew" on-click="$ctrl.copyLink($event)"></g-btn></div></div></div><div class="translation-editor__divide"></div><div class="translation-editor__search" ng-if="$ctrl.translation.type === $ctrl.Types.CUSTOM"><div class="translation-editor__search-filter"><field-text icon="search" placeholder="Search" model="$ctrl.filters.query" on-change="$ctrl.updateVisibleCorpus()" inline="true"></field-text></div><div class="translation-editor__search-actions" ng-click="$ctrl.filters.incomplete = !$ctrl.filters.incomplete; $ctrl.updateVisibleCorpus()"><field-label class="translation-editor__search-action-label" inline="true">Incomplete</field-label><field-checkbox class="translation-editor__search-action-checkbox" checked="$ctrl.filters.incomplete" inline="true"></field-checkbox></div></div><div class="translation-editor__mapping" ng-if="$ctrl.translation.type === $ctrl.Types.CUSTOM" ng-repeat="item in $ctrl.visibleCorpus track by $index"><field-label key="{{ item }}">{{ item }}</field-label><field-text key="{{ item }}" type="textarea" expand="true" no-min-height="true" model="$ctrl.translation.mappings[item]" on-blur="$ctrl.updateVisibleCorpus()" lang="$ctrl.translation.language"></field-text></div><div class="translation-editor__customize" ng-if="$ctrl.translation.type === $ctrl.Types.AUTO"><div class="translation-editor__customize-btn"><g-btn label="Customize" secondary="true" loading="$ctrl.isCustomizing" on-click="$ctrl.customize()"></g-btn></div><div class="translation-editor__customize-info"><div class="translation-editor__customize-text">Customise will pull in the auto-translated values for this survey and allow you to customise them to your needs.</div><div class="translation-editor__customize-text"><b>Note:</b> Any changes made to your survey will require you to come back here and update the translations again.</div></div></div></div>');
$templateCache.put('translation-manager.html','<g-dialog-header title="Translations" on-close="$ctrl.onClose()"></g-dialog-header><div class="translation-manager__warning" ng-if="!$ctrl.warningHidden"><g-icon class="translation-manager__warning-icon" icon="important" color="RED_CANDY"></g-icon><div class="translation-manager__warning-text">We recommend that you build and finalize your survey completely before creating translations.\nAny changes made to your survey after creating translations are likely to desynchronize your translations - which will need to be updated again.</div><g-icon-button class="translation-manager__warning-btn" icon="close" size="small" color="rgba(BLACK, 0.2)" on-click="$ctrl.hideWarning()"></g-icon-button></div><div class="translation-manager__content"><div class="translation-manager__actions"><g-btn label="Add" secondary="true" on-click="$ctrl.add()"></g-btn></div><div class="translation-manager__loading" ng-if="$ctrl.translations.state.isLoading()"><g-spinner block="true"></g-spinner></div><div class="translation-manager__error" ng-if="$ctrl.translations.state.isError()"><span>There was an error loading translations</span></div><div class="translation-manager__zero" ng-if="$ctrl.translations.state.isReady() &amp;&amp; !$ctrl.translations.value.length"><span>No translations</span></div><div class="translation-manager__list" ng-if="$ctrl.translations.state.isReady() &amp;&amp; $ctrl.translations.value.length"><div class="translation-manager__item" ng-repeat="translation in $ctrl.translations.value track by translation.id"><div class="translation-manager__item-info"><div class="translation-manager__item-info-label">{{ translation.label }}</div><div class="translation-manager__item-info-type">{{ translation.getTypeLabel() }} {{ $ctrl.getAutoSuffix(translation) }}</div></div><div class="translation-manager__item-error" ng-if="translation.isIncomplete($ctrl.corpus)"><g-icon class="translation-manager__item-error-icon" icon="important" color="RED_CANDY"></g-icon><div class="translation-manager__item-error-text">Incomplete</div></div><div class="translation-manager__item-action"><g-icon-button icon="edit" on-click="$ctrl.edit(translation)" hint="View or edit"></g-icon-button></div><div class="translation-manager__item-action"><g-icon-button icon="copy" on-click="$ctrl.duplicate(translation)" hint="Duplicate"></g-icon-button></div><div class="translation-manager__item-action"><g-icon-button icon="delete" on-click="$ctrl.remove(translation)" hint="Remove"></g-icon-button></div><div class="translation-manager__item-action"><g-icon-button icon="share" on-click="$ctrl.share(translation)" disabled="!translation.isPublicUpdateAllowed" hint="{{ translation.isPublicUpdateAllowed ? &quot;Share&quot; : &quot;Sharing disabled. If you want to share this translation with someone and allow them to update it, click the \'Edit\' button and turn \'Shareable Link\' on.&quot; }}"></g-icon-button></div></div></div></div>');
$templateCache.put('translation-picker.html','<div class="translation-picker"><div class="translation-picker__loading" ng-if="$ctrl.translations.state.isLoading()"><g-spinner block="true"></g-spinner></div><div class="translation-picker__error" ng-if="$ctrl.translations.state.isError()"><span>There was an error loading translations</span></div><div class="translation-picker__zero" ng-if="$ctrl.translations.state.isReady() &amp;&amp; !$ctrl.translations.value.length"><span>This survey has no translations. You can add translations for this survey in the editor.</span></div><div class="translation-picker__list" ng-if="$ctrl.translations.state.isReady() &amp;&amp; $ctrl.translations.value.length"><div class="translation-picker__item" ng-click="$ctrl.onSelect({ $translationId: null })"><div class="translation-picker__item-info"><div class="translation-picker__item-label">No Translation</div></div><g-icon class="translation-picker__item-selected-icon" ng-if="!$ctrl.translationId" icon="check-circle" color="INHERIT"></g-icon></div><div class="translation-picker__item" ng-repeat="translation in $ctrl.translations.value track by translation.id" ng-class="{ &quot;-disabled&quot;: $ctrl.isIncomplete(translation) }" ng-click="$ctrl.select(translation)"><div class="translation-picker__item-info"><div class="translation-picker__item-label">{{ translation.label }}</div><div class="translation-picker__item-type">{{ translation.getTypeLabel() }} {{ $ctrl.getAutoSuffix(translation) }}</div></div><g-icon class="translation-picker__item-selected-icon" ng-if="$ctrl.translationId === translation.id" icon="check-circle" color="INHERIT"></g-icon><g-icon-button class="translation-picker__item-incomplete-icon" ng-if="$ctrl.isIncomplete(translation)" icon="important" color="INHERIT" hover-color="INHERIT" hint="This translation is incomplete"></g-icon-button></div></div></div>');
$templateCache.put('video-player.html','<div class="video-player" ng-style="{ \n        paddingBottom: ($ctrl.video.height / $ctrl.video.width) * 100 + \'%\' \n    }" ng-class="{\n        &quot;-no-scrub&quot;: $ctrl.video.restrictions.scrub\n    }"><div class="video-player__wrapper"><video class="video-player__player video-js" playsinline="playsinline" aspect-ratio="{{ $ctrl.video.width }}:{{ $ctrl.video.height }}"></video></div></div>');}]);
;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('elementSources', {
      url: '/element-items',
      actions: {
        get: {
          method: 'GET',
          insecure: true,
        },
        getSecure: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('elementStats', {
      url: '/elements/:id/stats',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('elements', {
      url: '/elements/:id',
      params: {
        id: '@id',
        subscriberId: '@subscriberId',
      },
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          url: '/elements',
          method: 'POST',
          insecure: true,
        },
        createSecure: {
          method: 'POST',
        },
        getBySubscriber: {
          method: 'GET',
          url: '/subscribers/:subscriberId/elements',
        },
        // This request just updates the feedback categories
        updateFeedbackCategories: {
          method: 'PUT',
          transformRequest: updateCategoriesTransformRequest,
          command: 'UpdateElementFeedbackCategoriesCommand',
        },
        // This request rejects an element claim
        rejectClaim: {
          method: 'PUT',
          transformRequest: emptyRequestBody,
          command: 'RejectAnElementClaimCommand',
        },
        updateCustomerCareEmail: {
          method: 'PUT',
          transformRequest: updateEmailTransformRequest,
          command: 'UpdateElementCustomerCareEmailCommand',
        },
        // This request just updates the post reward coupon ID
        updatePostCouponId: {
          method: 'PUT',
          transformRequest: updatePostCouponIdTransformRequest,
          command: 'UpdateElementPostCouponIdCommand',
        },
        postAccess: {
          method: 'POST',
          url: '/elements/:id/post-access',
          command: 'SendPostAccessLinkCommand',
        },
        save: {
          method: 'PUT',
          transformRequest: saveTransformRequest,
        },
      },
    })

    function emptyRequestBody() {
      return {}
    }

    function updateCategoriesTransformRequest(data) {
      /**
       * Only feedbackCategories
       */
      return {
        feedbackCategories: data.feedbackCategories,
      }
    }

    function updateEmailTransformRequest(data) {
      return {
        customerCareEmail: data.customerCareEmail,
      }
    }

    function updatePostCouponIdTransformRequest(data) {
      /**
       * Only postCouponId
       */
      return {
        postCouponId: data.postCouponId,
      }
    }

    function saveTransformRequest(data) {
      /**
       * Data received for an element is tailored to the phone
       * app with a bunch of presentation data but the save request
       * is flatter and some things are not editable.
       */

      // Use 'name' if set
      data['title'] = data['name'] || data['title']
      if (!data['title']) {
        throw new Error('Expect title or name')
      }

      ;[
        'watermarkImageUrl', // Not editable
        'isSubscriberOwned', // Not editable
        'surveys', // Not editable
        'viewCount', // Not editable
        'owner', // Not editable
        'followerCount', // Not editable
        'placeData', // Flattened
        'productData', // Flattened
        'presentation', // Not editable
        'subscriberId', // Not editable
        'isVerified', // Not editable
        'createdAt', // Not editable
        'updatedAt', // Not editable
        'settings', // Not editable
        'route', // Not editable
        'purchaseLocations', // Not editable
        'promotions', // Not editable
        'pages', // Not editable
        'postCouponId', // Updated in a separate command
        'name', // Is 'title' (interchangeable)
        'brand', // Is 'subtitle' got product
        'announcements', // Not editable
      ].forEach(function(prop) {
        if (typeof data[prop] !== 'undefined') {
          delete data[prop]
        }
      })

      if (data['type'] && data['type'] === 'place') {
        // Don't want to update the foursquareId
        if (data['sourceId']) {
          delete data['sourceId']
        }
      }

      return data
    }
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('emailAddresses', {
      url: '/email-addresses',
      actions: {
        get: {
          method: 'GET',
        },
        verify: {
          method: 'POST',
          command: 'VerifyEmailAddress',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('estimates', {
      url: '/estimates/:id',
      params: {
        id: '@id',
      },
      actions: {
        create: {
          method: 'POST',
        },
        createEstimate: {
          // alias for create()
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
        emailEstimate: {
          method: 'PUT',
          command: 'EmailEstimate',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('exports', {
      url: '/exports/:id',
      params: {
        id: '@id',
        surveyId: '@surveyId',
      },
      actions: {
        create: {
          url: '/surveys/:surveyId/export',
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        // download: {
        //     url: '/exports/:id/download',
        //     method: 'GET',
        // },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('externalPanels', {
      url: '/external-panels/:id',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('images', {
      url: '/images',
      actions: {
        create: {
          method: 'POST',
        },
      },
    })
  }
})()

/**
 * Interactions model
 */
;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('interactions', {
      url: '/interactions/:id',
      params: {
        id: '@id',
      },
      actions: {
        getById: {
          method: 'GET',
        },
        getByElement: {
          method: 'GET',
          url: '/elements/:id/interactions',
        },
        getBySubscriber: {
          method: 'GET',
          url: '/subscribers/:id/interactions',
        },
        getByRelatedObject: {
          method: 'GET',
          url: '/interactions',
        },
        reply: {
          method: 'POST',
          url: '/interactions/:id/reply',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('invites', {
      url: '/invites',
      params: {
        token: '@token',
      },
      actions: {
        get: {
          method: 'GET',
          url: '/invites/:token',
        },
        consume: {
          method: 'PUT',
          url: '/invites/:token',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('invoiceItems', {
      url: '/invoice-items',
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST'
        }
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('invoices', {
      url: '/invoices',
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST'
        },
        finalize: {
          method: 'PUT',
          command: 'FinaliseInvoice'
        },
        pay: {
          method: 'PUT',
          command: 'PayInvoice'
        },
        upcoming: {
          method: 'GET',
          query: 'GetUpcomingInvoices'
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('kits', {
      url: '/kits/:id',
      params: {
        id: '@id',
        surveyTemplateId: '@surveyTemplateId',
        questionTemplateId: '@questionTemplateId',
        groupId: '@groupId',
      },
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
        assignContentGroup: {
          method: 'POST',
          url: '/kits/:id/content-groups/:contentGroupId',
        },
        removeContentGroup: {
          method: 'DELETE',
          url: '/kits/:id/content-groups/:contentGroupId',
        },

        // This is for the ADMIN user to be able to see which
        // kits are associated with which Content Group
        getKitsByContentGroup: {
          method: 'GET',
          query: 'GetKitsByContentGroup',
        },

        // This is for the subscriber user to get the Kits that they can
        // access (via their Content Group)
        getKitsByGroup: {
          method: 'GET',
          query: 'GetKitsByGroupId',
        },

        // This is for the SSR user to get the Kits that the subscriber
        // they're looking at OWNS
        getKitsByOwner: {
          method: 'GET',
          query: 'GetKitsByOwnerId',
        },
        assignSurveyTemplate: {
          method: 'POST',
          url: '/kits/:id/survey-templates/:surveyTemplateId',
        },
        unAssignSurveyTemplate: {
          method: 'DELETE',
          url: '/kits/:id/survey-templates/:surveyTemplateId',
        },
        assignQuestionTemplate: {
          method: 'POST',
          url: '/kits/:id/question-templates/:questionTemplateId',
        },
        unAssignQuestionTemplate: {
          method: 'DELETE',
          url: '/kits/:id/question-templates/:questionTemplateId',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('lightboxes', {
      url: '/lightboxes/:id',
      params: {
        id: '@id',
      },
      actions: {
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    var modify = {
      method: 'PUT',
      url: '/links/:fragment',
      command: 'RedirectShortUrlCommand',
    }

    resourcesProvider.create('links', {
      url: '/links',
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
        },
        delete: {
          method: 'DELETE',
          url: '/links/:fragment',
        },
        expand: {
          url: '/links/expand',
          method: 'GET',
        },
        modify: modify,
        modifyByFragment: modify,
        // Just a different placeholder
        modifyByShortUrl: _.defaults({ url: '/links/:shortUrl' }, modify),
      },
      // Additional properties available on
      // this resource
      addToResource: {
        getFragmentFromUrl: getFragment,
      },
    })

    /**
     * Return 54tkp12yv from https://glo.link/54tkp12yv
     */
    function getFragment(url) {
      // https://local.glo.link/54tkp12yv
      // https://staging.glo.link/54tkp12yv
      // https://glo.link/54tkp12yv
      // https://glo.link/my-own-link
      var gloLinkMatch = /https?:\/\/.*glo\.link\/(.*)$/i
      var execResult = gloLinkMatch.exec(url)

      if (execResult && execResult.length) {
        // execResult = ["https://local.glo.link/54tkp12yv", "54tkp12yv",..]
        return execResult[1]
      }

      return url
    }
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('metrics', {
      url: '/metrics',
      params: {},
      actions: {
        getSubscriber: {
          method: 'GET',
          query: 'GetSubscriberMetrics',
        },
        getSurvey: {
          method: 'GET',
          query: 'GetSurveyMetrics',
        },
        getPublishedSurvey: {
          method: 'GET',
          query: 'GetPublishedSurveyMetrics',
        },
        getRespondent: {
          method: 'GET',
          query: 'GetRespondentMetrics',
        },
        getResponse: {
          method: 'GET',
          query: 'GetResponseMetrics',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('mobileNotifications', {
      url: '/mobile-notifications',
      actions: {
        get: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('modules', {
      url: '/modules/:id',
      params: {
        id: '@id',
      },
      actions: {
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('notifications', {
      url: '/notification-lists/:id',
      params: {
        id: '@id',
      },
      actions: {
        list: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
      },
    })
  }
})()

/**
 * Opportunities model
 */

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('opportunities', {
      url: '/opportunities',
      actions: {
        create: {
          method: 'POST',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('pageElements', {
      url: '/page-elements',
      actions: {
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        delete: {
          method: 'DELETE',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('pageLinks', {
      url: '/page-links',
      actions: {
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        delete: {
          method: 'DELETE',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('pages', {
      url: '/pages/:id',
      params: {
        id: '@id',
      },
      actions: {
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('paymentMethods', {
      url: '/payment-methods',
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
          command: 'CreatePaymentMethod',
        },
        replace: {
          method: 'POST',
          command: 'ReplacePaymentMethod',
        },
        remove: {
          method: 'POST',
          command: 'RemovePaymentMethod',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('payments', {
      url: '/payments',
      actions: {
        preAuth: {
          url: '/payment-pre-auth',
          method: 'POST',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('places', {
      url: '/places/:id',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
        },
        getByOwner: {
          method: 'GET',
          query: 'GetPlacesByOwner',
        },
        getBySource: {
          method: 'GET',
          query: 'GetPlaceBySource',
        },
        getNearLocation: {
          method: 'GET',
          query: 'GetPlacesNearLocation',
        },
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('plans', {
      url: '/plans/:id',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        getMRP: {
          method: 'GET',
          url: '/mrp'
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('posts', {
      url: '/posts/:id',
      actions: {
        params: {
          id: '@id',
        },
        create: {
          method: 'POST',
        },
        createInsecure: {
          method: 'POST',
          insecure: true,
        },
        get: {
          method: 'GET',
        },
        getByToken: {
          method: 'GET',
        },
        reply: {
          url: '/posts/:id/comment',
          method: 'POST',
        },
        replyByToken: {
          insecure: true,
          url: '/posts/:id/comment',
          method: 'POST',
        },
        addImage: {
          url: '/posts/:id/image',
          method: 'POST',
        },
        updateState: {
          method: 'PUT',
        },
        close: {
          command: 'ClosePostCommand',
          method: 'PUT',
        },
        hide: {
          method: 'PUT',
          command: 'HidePostCommand',
          transformRequest: hide,
        },
        unhide: {
          method: 'PUT',
          command: 'UnhidePostCommand',
          transformRequest: unhide,
        },
        hidePostComment: {
          url: '/posts/:id/comment/:commentId',
          method: 'PUT',
          command: 'HidePostCommentCommand',
          transformRequest: hide,
        },
        unhidePostComment: {
          url: '/posts/:id/comment/:commentId',
          method: 'PUT',
          command: 'UnHidePostCommentCommand',
          transformRequest: unhide,
        },
      },
    })

    function hide(data) {
      data.hidden = true
      return data
    }

    function unhide(data) {
      data.hidden = false
      return data
    }
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('productSurveys', {
      url: '/products/:id',
      params: {
        id: '@id',
      },
      actions: {
        associate: {
          method: 'PUT',
          command: 'AssociateProductToSurveyCommand',
        },
        disassociate: {
          method: 'PUT',
          command: 'DisassociateProductFromSurveyCommand',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('products', {
      url: '/products/:id',
      params: {
        id: '@id',
      },
      actions: {
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
        get: {
          method: 'GET',
        },
        search: {
          method: 'GET',
          query: 'SearchForProduct',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('projectReports', {
      url: '/projects/:id/reports',
      params: {
        id: '@id',
      },
      actions: {
        list: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('projectResources', {
      url: '/projects/:projectId/resources/:id',
      params: {
        id: '@id',
        projectId: '@projectId',
      },
      actions: {
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('projectTrackers', {
      url: '/projects/:projectId/trackers/:id',
      params: {
        id: '@id',
        projectId: '@projectId',
      },
      actions: {
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        get: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('projectSurveys', {
      url: '/projects/:projectId/surveys',
      params: {
        projectId: '@projectId',
      },
      actions: {
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('projects', {
      url: '/projects/:id',
      params: {
        id: '@id',
      },
      actions: {
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
        archive: {
          method: 'PUT',
          url: '/projects/:id/archive',
        },
        unarchive: {
          method: 'PUT',
          url: '/projects/:id/unarchive',
        },
        search: {
          method: 'GET',
          url: '/projects/search',
          isArray: true,
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('promotions', {
      url: '/promotions',
      params: {
        id: '@id',
        promotion: '@promotion',
      },
      actions: {
        enrolElement: {
          method: 'POST',
          command: 'EnrolElementInPromotionCommand',
        },
        unEnrolElement: {
          method: 'DELETE',
          command: 'UnEnrolElementFromPromotionCommand',
        },
        enrolSurvey: {
          method: 'POST',
          command: 'EnrolSurveyInPromotionCommand',
        },
        unEnrolSurvey: {
          method: 'DELETE',
          command: 'UnEnrolSurveyFromPromotionCommand',
        },
        getUserTransactionReportItems: {
          url: '/promotions/:promotion/user-transactions',
          method: 'GET',
          view: 'UserTransactionReportItem',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('publicationMetrics', {
      url: '/publication-metrics/:id',
      params: {
        id: '@id',
      },
      actions: {
        create: {
          method: 'POST',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('publications', {
      url: '/publications/:id',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        acquire: {
          method: 'POST',
          url: '/publications/:id/acquire',
        },
        acquireWithToken: {
          method: 'POST',
          url: '/publications/:id/acquire',
          command: 'AcquireWithTokenCommand',
        },
        assignContentGroup: {
          method: 'POST',
          url: '/publications/:id/content-groups/:contentGroupId',
        },
        removeContentGroup: {
          method: 'DELETE',
          url: '/publications/:id/content-groups/:contentGroupId',
        },
        getPacksByContentGroup: {
          method: 'GET',
          query: 'GetPacksByContentGroup',
        },
        comingSoon: {
          method: 'PUT',
          command: 'PackComingSoonCommand',
        },
        available: {
          method: 'PUT',
          command: 'MakePackAvailableCommand',
        },
        notAvailable: {
          method: 'PUT',
          command: 'MakePackUnavailableCommand',
        },
        remove: {
          method: 'DELETE',
        },
        requestToPublish: {
          method: 'PUT',
          command: 'RequestToPublish',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('publishers', {
      url: '/publishers/:id',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        getByOwner: {
          method: 'GET',
          url: '/subscriber/:ownerId/publishers',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('purchases', {
      url: '/purchases',
      params: {},
      actions: {
        makePurchase: {
          method: 'POST',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('questionTemplates', {
      url: '/question-templates/:id',
      actions: {
        get: {
          method: 'GET',
          view: 'MyQuestionTemplates',
        },
        getAvailable: {
          method: 'GET',
          view: 'AssignedQuestionTemplates',
        },
        getCoreProfileTemplates: {
          method: 'GET',
          view: 'CoreProfileTemplates',
        },
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
        search: {
          method: 'GET',
          query: 'SearchMyQuestionTemplatesByQuestionTitle',
        },
        searchAvailable: {
          method: 'GET',
          query: 'SearchAssignedQuestionTemplatesByQuestionTitle',
        },
        publishQuestion: {
          url: '/question-templates/:templateId/questions/:questionId',
          command: 'PublishQuestionTemplateQuestionCommand',
          method: 'PUT',
        },
        archiveQuestion: {
          url: '/question-templates/:templateId/questions/:questionId',
          command: 'ArchiveQuestionTemplateQuestionCommand',
          method: 'PUT',
        },
        redraftQuestion: {
          url: '/question-templates/:templateId/questions/:questionId',
          command: 'RedraftQuestionTemplateQuestionCommand',
          method: 'PUT',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('questionsPlaces', {
      url: '/questions-places',
      actions: {
        questionPlacesReport: {
          url: '/questions-places/:id',
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('questions', {
      url: '/questions/:id',
      params: {
        id: '@id',
      },
      actions: {
        lock: {
          url: '/questions/:id',
          method: 'PUT',
          command: 'LockAQuestionCommand',
        },
        unlock: {
          method: 'PUT',
          command: 'UnLockAQuestionCommand',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('responses', {
      url: '/responses/:id',
      params: {
        id: '@id',
      },
      actions: {
        // returns `glow_report.query_optimised_responses` documents
        get: {
          method: 'GET',
        },
        // returns `glow_survey.survey_responses` responses
        list: {
          method: 'GET',
          url: '/surveys/:surveyId/responses',
        },
        listExpanded: {
          // lives in reporting domain
          // returns a list of query_optimised_responses
          url: '/surveys/:id/responses',
          method: 'GET',
          view: 'SurveyResponsesExpanded',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('reviews', {
      url: '/reviews/:id',
      actions: {
        params: {
          id: '@id',
        },
        create: {
          method: 'POST',
        },
        get: {
          method: 'GET',
        },
        reply: {
          url: '/review/:id/reply',
          method: 'POST',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('searchTerms', {
      url: '/search-terms',
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('search', {
      url: '/search',
      actions: {
        query: {
          method: 'GET',
          insecure: true,
        },
        querySecure: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('segments', {
      url: '/surveys/:surveyId/segments',
      actions: {
        add: {
          method: 'PUT',
          command: 'AddSegmentToResponsesCommand',
        },
        remove: {
          method: 'PUT',
          command: 'RemoveSegmentFromResponsesCommand',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('sentiment', {
      url: '/sentiment',
      actions: {
        get: {
          method: 'GET',
          view: 'SentimentReport',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('ssi', {
      url: '/ssi',
      params: {
        extProjectId: '@extProjectId',
        extLineItemId: '@extLineItemId',
        action: '@action',
        countryCode: '@countryCode',
        languageCode: '@languageCode',
      },
      actions: {
        createProject: {
          method: 'POST',
          url: '/ssi/projects',
        },
        updateProject: {
          method: 'POST',
          url: '/ssi/projects/:extProjectId',
        },
        buyProject: {
          method: 'POST',
          url: '/ssi/projects/:extProjectId/buy',
        },
        closeProject: {
          method: 'POST',
          url: '/ssi/projects/:extProjectId/close',
        },
        getProject: {
          method: 'GET',
          url: '/ssi/projects/:extProjectId',
        },
        getProjectReport: {
          method: 'GET',
          url: '/ssi/projects/:extProjectId/report',
        },
        addLineItem: {
          method: 'POST',
          url: '/ssi/projects/:extProjectId/lineItems',
        },
        updateLineItem: {
          method: 'POST',
          url: '/ssi/projects/:extProjectId/lineItems/:extLineItemId',
        },
        performLineItemAction: {
          method: 'POST',
          url: '/ssi/projects/:extProjectId/lineItems/:extLineItemId/:action',
        },
        getAllLineItems: {
          method: 'GET',
          url: '/ssi/projects/:extProjectId/lineItems',
        },
        getLineItem: {
          method: 'GET',
          url: '/ssi/projects/:extProjectId/lineItems/:extLineItemId',
        },
        getFeasibility: {
          method: 'GET',
          url: '/ssi/projects/:extProjectId/feasibility',
        },
        getCountries: {
          method: 'GET',
          url: '/ssi/countries',
        },
        getAttributes: {
          method: 'GET',
          url: '/ssi/attributes/:countryCode/:languageCode',
        },
        getCategories: {
          method: 'GET',
          url: '/ssi/categories/surveyTopics',
        },
        getEvents: {
          method: 'GET',
          url: '/ssi/events',
        },
        performEventAction: {
          method: 'POST',
          url: '/ssi/events/:action',
        },
        getTemplates: {
          method: 'GET',
          url: '/ssi/templates/quotaPlan/:countryCode/:languageCode',
        },
        createTemplate: {
          method: 'POST',
          url: '/ssi/templates/quotaPlan',
        },
        updateTemplate: {
          method: 'POST',
          url: '/ssi/templates/quotaPlan/:id',
        },
        deleteTemplate: {
          method: 'DELETE',
          url: '/ssi/templates/quotaPlan/:id',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('subscriberActivations', {
      url: '/activations',
      actions: {
        activate: {
          method: 'POST',
        },
        createUserViaToken: {
          method: 'POST',
          command: 'RedeemCreateUserTokenCommand',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('subscriberCredits', {
      url: '/credit/:subscriberId',
      params: {
        subscriberId: '@subscriberId',
      },
      actions: {
        getBalance: {
          url: '/credit/:subscriberId/balance',
          method: 'GET',
        },
        getAutoRenewal: {
          url: '/credit/:subscriberId/auto-renewal',
          method: 'GET',
        },
        saveAutoRenewal: {
          url: '/credit/:subscriberId/auto-renewal',
          method: 'PUT',
        },
        topUp: {
          url: '/credit/:subscriberId/topup',
          method: 'POST',
        },
        getCostsByUnit: {
          url: '/credit/unit-costs',
          method: 'GET',
        },
        listClaimedIncentives: {
          url: '/credit/:subscriberId/incentives',
          method: 'GET',
        },
        claimIncentive: {
          url: '/credit/:subscriberId/incentives',
          method: 'POST',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('subscriberInteractions', {
      url: '/subscribers/:id/interactions',
      params: {
        id: '@id',
        interactionId: '@interactionId', // Is actually a PostID
      },
      actions: {
        query: {
          method: 'GET',
        },
        markAsActioned: {
          command: 'UpdateSubscriberInteractionStateCommand',
          method: 'PUT',
          url: '/subscribers/:id/interactions/:interactionId',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('subscriberMembers', {
      url: '/subscribers/:id/members',
      params: {
        id: '@id',
        memberId: '@memberId',
      },
      actions: {
        invite: {
          method: 'POST',
        },
        list: {
          method: 'GET',
        },
        remove: {
          method: 'DELETE',
          url: '/subscribers/:id/members/:memberId',
        },
        updateUAC: {
          method: 'PUT',
          url: '/subscribers/:id/members/:memberId',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('subscriberStats', {
      url: '/subscribers/:id/stats',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
        },
        getInboxUnread: {
          method: 'GET',
          view: 'InboxUnread',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('subscriberUsers', {
      url: '/subscribers/:id/users',
      params: {
        id: '@id',
      },
      actions: {
        query: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('subscribers', {
      url: '/subscribers/:id',
      params: {
        id: '@id',
        elementId: '@elementId',
      },
      actions: {
        create: {
          method: 'POST',
          transformRequest: createTransformRequest,
        },
        createSubscriberOnly: {
          method: 'POST',
          command: 'CreateAStandaloneSubscriberCommand',
          transformRequest: createTransformRequest,
        },
        createWithCurrentUser: {
          method: 'POST',
          command: 'CreateASubscriberAndAssociateUserCommand',
          transformRequest: createTransformRequest,
        },
        query: {
          method: 'GET',
        },
        get: {
          method: 'GET',
        },
        save: {
          method: 'PUT',
          transformRequest: saveTransformRequest,
          // transformResponse: saveTransformResponse
        },
        claimElements: {
          method: 'POST',
          url: '/subscribers/:id/elements',
          command: 'SubscriberClaimElementsCommand',
        },
        deleteElement: {
          method: 'DELETE',
          url: '/subscribers/:id/elements/:elementId',
          transformRequest: emptyRequestBody,
        },
        // subscriber - (purchase) plan upgrade
        subscribeToPlan: {
          method: 'PUT',
          url: '/subscribers/:id/plans',
          command: 'TransitionPlan',
        },
        // admin - (promoted) plan upgrade
        assignPlan: {
          method: 'PUT',
          url: '/subscribers/:id/plans',
          command: 'AssignPlan',
        },
        addCredit: {
          method: 'POST',
          url: '/subscribers/:id/account',
          command: 'AddCreditToAccount',
        },
        // subscriber initiated request to be invoiced
        requestToBeInvoiced: {
          method: 'PUT',
          url: '/subscribers/:id/plans',
          command: 'RequestToBeInvoiced',
        },
        issueAddPackToken: {
          method: 'PUT',
          url: '/subscribers/:id/issue-token',
          command: 'IssueAddPackToken',
        },
        getPlanQuota: {
          method: 'GET',
          url: '/subscribers/:id/plan-quota',
        },
        updateContentGroups: {
          method: 'PUT',
          url: '/subscribers/:id/content-groups',
          command: 'UpdateSubscriberContentGroups',
        },
        getProfile: {
          method: 'GET',
          url: '/subscriber-profiles/:id',
        },
        updatePaymentType: {
          method: 'PUT',
          url: '/subscribers/:id/update-payment-type',
        },
        setCurrency: {
          method: 'PUT',
          url: '/subscribers/:id/set-currency',
        },
        activityReport: {
          method: 'GET',
          url: '/subscribers/activity-report',
        },
      },
    })

    function saveTransformRequest(data) {
      return {
        id: data.id,
        name: data.name,
        industry: data.industry,
        billing: data.billing,
        address: data.address,
        city: data.city,
        state: data.state,
        postcode: data.postcode,
        country: data.country,
        phoneNumber: data.phoneNumber,
        subscriptionCode: data.subscriptionCode,
        portalTheme: data.portalTheme,
        plan: data.plan,
        canViewProfilingQuestions: data.canViewProfilingQuestions,
        taxReferenceNumber: data.taxReferenceNumber,
        businessType: data.businessType,
        accountManager: data.accountManager,
        srsSubscriberId: data.srsSubscriberId,
        ntsSubscriberId: data.ntsSubscriberId,
        data: data.data,
        enabled: data.enabled,
      }
    }

    function emptyRequestBody() {
      return {}
    }

    function createTransformRequest(data) {
      // ensure email is omitted because BE no longer need email to create subscriber
      delete data.email
      return data
    }
  }
})()

;(function () {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config (resourcesProvider) {
    resourcesProvider.create('suggestions', {
      url: '/suggestions',
      params: {},
      actions: {
        get: {
          method: 'GET'
        }
      }
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('surveyReportFilters', {
      url: '/surveys/:surveyId/report-filters/:id',
      params: {
        id: '@id',
        surveyId: '@surveyId',
      },
      actions: {
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('surveyReportShares', {
      url: '/surveys/:surveyId/report-shares',
      params: {
        surveyId: '@surveyId',
      },
      actions: {
        getBySurveyId: {
          method: 'GET',
        },
        getByToken: {
          url: '/surveys/report-shares',
          method: 'GET',
        },
        create: {
          method: 'POST',
        },
        get: {
          url: '/surveys/report-shares/:id',
          method: 'GET',
        },
        update: {
          url: '/surveys/report-shares/:id',
          method: 'PUT',
        },
        remove: {
          url: '/surveys/:surveyId/report-shares/:id',
          method: 'DELETE',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('surveyReports', {
      url: '/surveys/:id/reports',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
        },
        getTextAnswers: {
          method: 'GET',
          url: '/questions/:id/text-answer-report',
        },
        getOtherAnswers: {
          method: 'GET',
          url: '/questions/:id/other-answer-report',
        },
        getSurveyResponses: {
          method: 'GET',
          view: 'SurveyResponseView',
        },
        getResponseTimeSeries: {
          url: '/survey-responses',
          method: 'GET',
          view: 'ResponseTimeSeriesReport',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('surveyTemplates', {
      url: '/survey-templates/:id',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
          view: 'MySurveyTemplates',
        },
        getAvailable: {
          method: 'GET',
          view: 'AssignedSurveyTemplates',
        },
        getForKit: {
          method: 'GET',
          view: 'SurveyTemplatesForKit',
        },
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        getVersion: {
          method: 'GET',
          url: '/survey-templates/:id/version',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('surveys', {
      url: '/surveys/:id',
      params: {
        id: '@id',
        elementId: '@elementId',
        subscriberId: '@subscriberId',
      },
      actions: {
        get: {
          method: 'GET',
        },
        getStream: {
          url: '/surveys?stream',
          method: 'GET',
        },
        update: {
          method: 'PUT',
          transformRequest: updateTransform,
        },
        getVersion: {
          url: '/surveys/:id/version',
          method: 'GET',
        },
        getByElement: {
          method: 'GET',
          url: '/elements/:elementId/surveys',
        },
        getBySubscriber: {
          method: 'GET',
          url: '/subscribers/:subscriberId/surveys',
        },
        getSummariesBySubscriber: {
          method: 'GET',
          url: '/subscribers/:subscriberId/survey-summaries',
        },
        sendViaEmail: {
          url: '/survey-emails',
          method: 'POST',
        },
        saveImage: {
          url: '/surveys/:id/image',
          method: 'POST',
        },
        saveListImage: {
          url: '/surveys/:id/list-image',
          method: 'POST',
        },
        saveQuestionImage: {
          url: '/surveys/:id/questions/:questionId/image',
          method: 'POST',
        },
        deleteQuestion: {
          method: 'DELETE',
          url: '/surveys/:id/questions/:questionId',
        },
        getSurveyById: {
          method: 'GET',
          url: '/surveys/:id',
        },
        archive: {
          method: 'PUT',
          command: 'ArchiveASurveyCommand',
        },
        unArchive: {
          method: 'PUT',
          command: 'UnArchiveASurveyCommand',
        },
        changeProject: {
          method: 'PUT',
          command: 'MoveSurveyCommand',
        },
        respond: {
          url: '/survey-responses',
          method: 'POST',
        },
        deleteResponse: {
          url: '/survey-responses/:id',
          method: 'DELETE',
        },
        batchDeleteResponses: {
          url: '/survey-responses',
          method: 'DELETE',
          command: 'BatchDeleteResponses',
        },
        getSurveyResponseReport: {
          url: '/survey-responses',
          method: 'GET',
          view: 'SurveyResponseReport',
        },
        getSurveyTimeSeriesReport: {
          url: '/survey-responses',
          method: 'GET',
          view: 'ResponseTimeSeriesReport',
        },
        saveNote: {
          url: '/surveys/:surveyId/notes',
          method: 'POST',
        },
        getNotes: {
          url: '/surveys/:id/notes',
          method: 'GET',
        },
        getSurveyTransaction: {
          url: '/survey-transactions',
          method: 'GET',
        },
        getSurveyTransactions: {
          url: '/survey-transactions',
          method: 'GET',
          query: 'GetPaginatedSurveyTransactions',
        },
        updateSurveyTransactionNameAndEmail: {
          url: '/survey-transactions',
          method: 'PUT',
          command: 'UpdateNameAndEmailOnSurveyTransaction',
        },
        verifySurveyTransaction: {
          url: '/survey-transactions',
          method: 'PUT',
          command: 'VerifySurveyTransaction',
        },
      },
    })

    function updateTransform(data) {
      ;[
        'state',
        'rewards',
        'expired',
        'createdAt',
        'presentation',
        'elementId',
        'elementName',
        'responseCount',
        'element',
      ].forEach(function(removeMe) {
        if (typeof data[removeMe] !== 'undefined') {
          delete data[removeMe]
        }
      })

      return data
    }
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('transactions', {
      url: '/transactions',
      params: {
        id: '@id',
      },
      actions: {
        // Get the last transaction(s) by subscriber (and limit)
        // **Used for tests**
        getLast: {
          method: 'GET',
          query: 'GetLastTransactions',
        },
        // Get usage statement (aggregate of transactions) by subscriber & period
        getUsageStatement: {
          url: '/transaction-statements',
          method: 'GET',
          query: 'GetTransactionStatementByRange',
        },
        // Get a list of processed usage statements by subscriber
        listPreviousUsageStatements: {
          url: '/transaction-statements',
          method: 'GET',
          query: 'ListPreviousTransactionStatementsBySubscriber',
        },
        // Get a processed usage statements by id
        getPreviousUsageStatement: {
          url: '/transaction-statements/:id',
          method: 'GET',
          query: 'GetPreviousTransactionStatementById',
        },
        // Create an adjustment statement by type & date
        createAdjustmentTransaction: {
          method: 'POST',
          command: 'CreateAdjustmentTransaction',
        },
        // Mark transactions as within a statement as processed
        processUsageStatement: {
          url: '/transaction-statements',
          method: 'POST',
          command: 'ProcessUsageStatement',
        },
        sendUsageStatementToXero: {
          url: '/transaction-statements',
          method: 'POST',
          command: 'SendUsageStatementToXero',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('translations', {
      url: '/translations/:id',
      params: {
        id: '@id',
        surveyId: '@surveyId',
      },
      actions: {
        create: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
        get: {
          method: 'GET',
        },
        listBySurvey: {
          method: 'GET',
          url: '/surveys/:surveyId/translations',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('userCoupons', {
      url: '/user-coupons/:id',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('userElements', {
      url: '/user-elements/:id',
      params: {
        id: '@id',
      },
      actions: {
        get: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
        delete: {
          method: 'DELETE',
        },
        create: {
          method: 'POST',
          url: '/user-elements',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('userPublications', {
      url: '/subscription/:ownerId/publications/:publicationId',
      params: {
        userId: '@userId',
        publicationId: '@publicationId',
      },
      actions: {
        create: {
          method: 'POST',
        },
        createWithToken: {
          method: 'POST',
          command: 'CreateFromTokenCommand',
        },
        get: {
          method: 'GET',
        },
        assign: {
          method: 'POST',
          command: 'AssignUserAnalysisPackCommand',
        },
        unAssign: {
          method: 'DELETE',
          command: 'UnAssignUserAnalysisPackCommand',
        },
        acquiredReport: {
          method: 'GET',
          url: '/acquired-publications',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('userStats', {
      url: '/user-stats',
      actions: {
        get: {
          method: 'GET',
        },
      },
    })
  }
})()

;(function() {
  'use strict'

  config.$inject = ["resourcesProvider"];
  angular.module('glow.resources').config(config)

  function config(resourcesProvider) {
    resourcesProvider.create('users', {
      url: '/users/:id',
      params: {
        id: '@id',
        subscriberId: '@subscriberId',
      },
      actions: {
        login: {
          method: 'POST',
          url: '/user',
        },
        me: {
          method: 'POST',
          url: '/user',
        },
        tokenLogin: {
          method: 'POST',
          url: '/tokens',
          transformResponse: transformLoginSignupResponse,
          generateAuthHeader: true,
        },
        signup: {
          method: 'POST',
          url: '/customers',
          transformResponse: transformLoginSignupResponse,
          generateAuthHeader: true,
        },
        passwordReset: {
          method: 'POST',
          url: '/password-resets',
          insecure: true,
        },
        updatePasswordReset: {
          method: 'PUT',
          url: '/password-resets/:id',
        },
        getActivityStreams: {
          method: 'GET',
          url: '/activity-streams',
          transformRequest: transformActivityStreamRequest,
        },
        getNotificationLists: {
          method: 'GET',
          url: '/notification-lists',
          transformRequest: transformNotificationRequest,
        },
        verifyUsername: {
          method: 'HEAD',
          url: '/usernames/:username',
          insecure: true,
        },
        getCustomer: {
          method: 'GET',
          url: '/customers/:id',
        },
        updateCustomer: {
          method: 'PUT',
          url: '/customers/:id',
          transformRequest: transformUpdateRequest,
        },
        updateCurrent: {
          method: 'PUT',
          url: '/user',
          transformRequest: transformUpdateRequest,
        },
        get: {
          method: 'GET',
        },
        create: {
          method: 'POST',
          command: 'CreateAUserCommand',
        },
        createEmailUser: {
          insecure: true,
          method: 'POST',
          command: 'CreateAnEmailUserCommand',
        },
        createSubscriberSupportUser: {
          method: 'POST',
          command: 'CreateASubscriberSupportUserCommand',
        },
        update: {
          method: 'PUT',
          transformRequest: transformUpdateRequest,
          command: 'UpdateAUserCommand', // same as in create
        },
        getBySubscriber: {
          url: '/subscribers/:subscriberId/users',
          method: 'GET',
        },
        associateUserWithGroup: {
          url: '/subscribers/:groupId/users/:id',
          method: 'PUT',
          command: 'AssociateUserWithGroup',
        },
        removeUserFromGroup: {
          url: '/subscribers/:groupId/users/:id',
          method: 'PUT',
          command: 'RemoveUserGroupAssociation',
        },
        getRolesByEmail: {
          method: 'GET',
          url: '/useremails/:email',
          insecure: true,
        },
        updateNextLogin: {
          method: 'PUT',
          command: 'UpdateNextLoginCommand',
        },
        getSubscribers: {
          method: 'GET',
          url: '/users/:id/subscribers',
        },
      },
    })

    function transformUpdateRequest(data) {
      return _.pick(data, [
        'fullname',
        'username',
        'email',
        'suburb',
        'state',
        'sex',
        'yearOfBirth',
        'password',
        'data',
        'weeklyActivitySummaryEmail',
        'jobRole',
        'registrationContext',
        'enabled'
      ])
    }

    function transformLoginSignupResponse(data, headersGetter, resources) {
      if (data.status === 401) {
        resources.setAuth()
      }
      return data
    }

    function transformActivityStreamRequest(data) {
      data.params.followedBy = data.id
    }

    function transformNotificationRequest(data) {
      console.log(
        'DEPRECATED: use notificationsResource.list instead of usersResource.getNotificationLists'
      )
      return data
    }
  }
})()

/* globals xdomain */
;(function() {
  'use strict'

  xhrDecorator.$inject = ["$delegate", "$injector"];
  Resources.$inject = ["$provide"];
  angular
    .module('glow.resources')
    .decorator('$xhrFactory', xhrDecorator)
    .provider('resources', Resources)

  function xhrDecorator($delegate, $injector) {
    return function(method, url) {
      var xhr = $delegate(method, url)
      var $http = $injector.get('$http')
      var config = $http.pendingRequests[$http.pendingRequests.length - 1]
      if (_.isFunction(config.onXhr)) {
        config.onXhr(xhr)
      }
      return xhr
    }
  }

  /*
   * Resources Provider
   * used by the models and properties to create resources during the config phase.
   */
  function Resources($provide) {
    Service.$inject = ["$http", "$q", "$rootScope", "configService"];
    var log = new Logger()
    var authData = {}
    var configs = {}
    var services = {}
    var subscriberId = null

    this.debugEnabled = debugEnabled
    this.create = create
    this.$get = Service

    // ----------------------------------------

    function debugEnabled(isEnabled) {
      log.isEnabled = isEnabled
    }

    /*
     * Create
     * adds a new resource, duplicate names will be overwritten.
     */
    function create(name, config) {
      log.debug("resource config '" + name + "' created")
      configs[name] = config
    }

    /*
     * Resources Service
     */
    function Service($http, $q, $rootScope, configService) {
      var service = this

      setupXDomain()
      makeServices()
      _.extend(this, services)

      this.getAll = getAll
      this.setAuth = setAuth
      this.getAuth = getAuth
      this.isResource = isResource
      this.setSubscriberId = setSubscriberId

      function getAll() {
        return services
      }

      // ----------------------------------------

      /*
       * XDomain Setup
       * If the browser only supports XDomainRequest (< IE9)
       */
      function setupXDomain() {
        if (!window.XDomainRequest) {
          return // we dont need XDomain!
        }
        if (!window.xdomain) {
          throw new Error(
            'resources: XDomain lib must be the FIRST script included in the page.'
          )
        }
        if (log.isEnabled) {
          xdomain.debug = true
        }
        xdomain.slaves({
          'http://api.glowfeed.com': '/proxy.html',
          'https://api.glowfeed.com': '/proxy.html',
          'http://api-staging.glowfeed.com': '/proxy.html',
          'http://api-local.glowfeed.com': '/proxy.html',
        })
      }

      /*
       * Get/Set Auth
       * sets the auth credentials that will be added to request headers.
       * if called without arguments, it will reset auth and not add the header to any more requests.
       */
      function setAuth(data) {
        authData = data || {}
      }

      function getAuth() {
        return authData
      }

      /*
       * isResource
       * check if function is an instance of Resource
       */
      function isResource(func) {
        return func instanceof Resource
      }

      /*
       * setSubscriberId
       * set the subscriber ID that will be added to request headers
       */
      function setSubscriberId(id) {
        subscriberId = id
      }

      /*
       * Make All Headers
       */
      function makeHeaders(actionOpts, data) {
        // base headers
        var headers = {
          Accept: makeAcceptHeader(actionOpts.view),
          'Content-Type': makeContentTypeHeader(actionOpts),
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: makeAuthHeader(actionOpts, data),
        }

        if (subscriberId) {
          headers['X-Subscriber-ID'] = subscriberId
        }

        if (actionOpts.headers) {
          headers = _.assign(headers, actionOpts.headers)
        }

        return headers
      }

      /*
       * Accept Header
       * builds the accept header, appending some build info
       */
      function makeAcceptHeader(view) {
        var header = 'application/json'
        function append(key, value) {
          header += ',' + key + '=' + value
        }
        append('appPlatform', 'Desktop')
        append('appName', configService.getBuildProperty())
        append('appVersion', configService.getBuildVersion())
        append('appCommit', configService.getBuildCommit())
        if (view) {
          append('view', view)
        }
        return header
      }

      /*
       * Content-Type Header
       * All requests are JSON format and,
       * we add commands if they were specified for the current resource action
       */
      function makeContentTypeHeader(actionOpts) {
        var header = 'application/json'
        if (actionOpts.command) {
          header += ';command=' + actionOpts.command
        }
        if (actionOpts.query) {
          header += ';query=' + actionOpts.query
        }
        return header
      }

      /*
       * Make Auth Header
       */
      function makeAuthHeader(actionOpts, reqData) {
        // Auth data can come from 3 places, in order:
        // 1. if generateAuthHeader is true get it from the request data
        // 2. if action options have auth data use that
        // 3. otherwise attempt to use data set with `setAuth()`
        var auth = actionOpts.generateAuthHeader
          ? reqData
          : actionOpts.auth || authData

        // if insecure, dont make an auth header
        if (actionOpts.insecure) {
          return
        }

        // update core auth if using `generateAuthData`
        if (actionOpts.generateAuthHeader) {
          setAuth(reqData)
        }

        // try token based auth
        if (auth.token) {
          return 'Bearer ' + auth.token
        }

        // try fallback to basic-auth
        if (auth.email && auth.password) {
          return 'Basic ' + btoa(auth.email + ':' + auth.password)
        }
      }

      /*
       * Resource Service Name
       * returns the name of the service
       */
      function resourceServiceName(name) {
        var suffix = 'Resource'
        return name + suffix
      }

      /*
       * Make All Resources
       * Our config phase is over, so now we "compile" all of the resourceConfig's
       * into usable resources, and create a service for each one.
       */
      function makeServices() {
        _.each(configs, function(config, name) {
          var resourceService

          // Validate
          try {
            if (!config.url) {
              throw new Error('no url')
            }
          } catch (err) {
            console.error(
              "Error creating resource '" + name + "' (" + err.message + ')'
            )
            console.error(err.stack)
            return
          }

          // Create the ResourceService
          resourceService = services[name] = new ResourceService(config, name)

          // Create the actual injectable service for it
          $provide.service(resourceServiceName(name), function() {
            return resourceService
          })
          log.debug("created '" + resourceServiceName(name) + "' ...")
        })
      }

      /*
       * Resource Service
       * This service is created, initialised and provided for each resource
       */
      function ResourceService(config, resourceName) {
        setActions(this)

        // User can add extra properties to this resource
        // via exportProperties
        _.assign(this, config.addToResource)

        // ----------------------------------------

        function setData(Resource, data) {
          // console.log('before Resource', JSON.parse(JSON.stringify(Resource)));
          if (!Resource) {
            console.error('no resource')
            return
          }
          _.each(Resource, function(value, key) {
            if (key.charAt(0) !== '$') {
              delete Resource[key]
            }
          })
          _.each(data, function(value, key) {
            Resource[key] = value
          })
          // console.log('after Resource', JSON.parse(JSON.stringify(Resource)));
        }

        function setActions(Class, usePrefix) {
          _.each(config.actions, function(options, actionName) {
            if (
              Class instanceof Resource &&
              ['GET', 'HEAD'].indexOf(options.method) !== -1
            ) {
              // dont add GET method actions to Resources
              return
            }
            var prefix = usePrefix ? '$' : ''
            Class[prefix + actionName] = newActionMethod(
              Class,
              options,
              actionName
            )
          })
        }

        function newActionMethod(Class, options, actionName) {
          return actionMethod

          // ------------------------------

          /*
           * Action Method
           * handles the action, request and promise for the action
           */
          function actionMethod(a1, a2, optionsOverride) {
            var isGET = ['GET', 'HEAD'].indexOf(options.method) !== -1
            var isResource = Class instanceof Resource
            var params = {}
            var data = {}
            var promise
            var paramDict = []

            // allow options overriding
            var actionOpts = _.extend({}, options, optionsOverride || {})

            // sort out which arguments are params/data
            decipherArgs()

            // default insecure to false - add auth header if auth data is available
            actionOpts.insecure = actionOpts.insecure || false

            // use the action url, or fallback to the resource url
            var url = actionOpts.url || config.url

            // use the action params, or fallback to the resource params
            var paramDefaults = _.extend({}, config.params, actionOpts.params)

            // make our $http config
            var httpConfig = {
              method: actionOpts.method,
              url: makeRequestUrl(),
              params: makeQueryParams(),
              data: serialiseData(),
              headers: makeHeaders(actionOpts, data),
              transformRequest: resourceTransformRequest,
              transformResponse: resourceTransformResponse,
              uploadEventHandlers: actionOpts.uploadEventHandlers,
            }

            // Add XHR to development requests
            var xhr
            if (configService.isDevelopment()) {
              httpConfig.onXhr = function(xhrObject) {
                xhr = xhrObject
              }
            }

            performRequest()

            return promise

            // --------------------------------------------

            /*
             * Decipher Arguments
             *
             * ResourceService (not data, just actions)
             * - GET (params)
             * - POST ([params], data)
             *
             * Resource (has data)
             * - POST ([params])
             *
             */
            function decipherArgs() {
              // ResourceService
              if (!isResource) {
                if (isGET) {
                  params = a1 || {}
                } else {
                  if (a2) {
                    params = a1 || {}
                    data = a2 || {}
                  } else {
                    data = a1 || {}
                  }
                }
                // Resource
              } else {
                params = a1 || {}
                data = Class || {}
              }
            }

            /*
             * Transform Request Wrapper
             * - injects data as a JSON object (instead of string)
             * - provides a reference to the resource if absolutely needed (be careful)
             */
            function resourceTransformRequest(data, headersGetter) {
              data = JSON.parse(data || '{}')
              if (actionOpts.transformRequest) {
                var resource = isResource ? Class : undefined
                data = actionOpts.transformRequest(
                  data,
                  headersGetter,
                  service,
                  resource
                )
              }
              return JSON.stringify(data)
            }

            /*
             * Transform Response Wrapper
             * - injects data as a JSON object (instead of string)
             * - provides a reference to the resource if absolutely needed (be careful)
             */
            function resourceTransformResponse(data, headersGetter) {
              try {
                data = JSON.parse(data || '{}')
              } catch (e) {
                // In case the response is not JSON
                // report an error
                log.error(
                  resourceName + '.resourceTransformResponse JSON.parse failed'
                )
                log.error(data)
                throw e
              }

              if (actionOpts.transformResponse) {
                var resource = isResource ? Class : undefined
                data = actionOpts.transformResponse(
                  data,
                  headersGetter,
                  service,
                  resource
                )
              }
              return JSON.stringify(data)
            }

            /*
             * Make Request Url
             */
            function makeRequestUrl() {
              var pieces = url.split('/')
              var toDelete = []
              paramDict = []

              // find parameter pieces in a url (eg: ':elementId')
              _.each(pieces, function(piece, index) {
                if (piece.charAt(0) === ':') {
                  var param = piece.substr(1)

                  // add it to our dictionary so we know what we have
                  paramDict.push(param)

                  if (data[param] || params[param]) {
                    // the programmer defined this param manually.
                    // change the piece.
                    pieces[index] = params[param] || data[param]
                  } else if (paramDefaults[param]) {
                    // the resource has an idea where to find this param
                    if (paramDefaults[param].charAt(0) === '@') {
                      // its an attribute we might find on the data object
                      var key = paramDefaults[param].substr(1)
                      var value = Class[key]
                      if (value) {
                        // value found! update it
                        pieces[index] = value
                      } else {
                        // no value found, let's remove this piece
                        toDelete.push(index)
                      }
                    } else {
                      // its a fixed value
                      pieces[index] = paramDefaults[param]
                    }
                  } else {
                    // the resource has no way of using this param
                    // we will remove it below
                    toDelete.push(index)
                  }
                }
              })

              // remove pieces that were flagged to delete (undefined params)
              _.each(toDelete, function(index) {
                pieces.splice(index, 1)
              })

              return configService.getApiUrl(pieces.join('/'))
            }

            /*
             * Query Params
             */
            function makeQueryParams() {
              var queryParams = {}
              _.each(params, function(value, key) {
                // only add params that are not url-params!
                if (paramDict.indexOf(key) === -1) {
                  queryParams[key] = value
                }
              })
              return queryParams
            }

            /*
             * Serialise Data
             * removes action methods etc
             */
            function serialiseData() {
              var newData = {}
              _.each(data, function(value, key) {
                if (!_.isFunction(value)) {
                  newData[key] = value
                }
              })
              return JSON.stringify(newData)
            }

            /**
             * Extract the Chrome Logger data
             */
            function extractLoggerData(headers) {
              var loggerData = headers('X-ChromeLogger-Data')

              if (loggerData) {
                return JSON.parse(atob(loggerData))
              }
            }

            /*
             * Broadcast Unauthorised
             * properties can subscribe to the 'resources:unauthorised' event
             * to log users out etc.
             */
            function broadcastUnauthorised() {
              $rootScope.$broadcast('resources:unauthorised')
            }

            /*
             * Broadcast Message
             * properties can subscribe to the 'resources:message' event
             * to display custom messages from the service
             */
            function broadcastMessage(data) {
              $rootScope.$broadcast('resources:message', data)
            }

            /*
             * Perform Request
             * - makes the $http request
             * - build our promise infrastructure (custom callback arguments)
             */
            function performRequest() {
              promise = $q.when(httpConfig)
              var httpPromise

              function startRequest() {
                if (!httpPromise) {
                  httpPromise = $http(httpConfig)
                  log.debug(
                    resourceName + '.' + actionName + ' started',
                    httpConfig
                  )
                }
              }

              // we wrap the promise with success/error methods
              // which allow us to provide multiple arguments on resolve/reject

              promise.success = function(fn) {
                startRequest() // start if not already

                httpPromise.then(function(resp) {
                  var status = resp.status
                  var headers = resp.headers
                  var data = resp.data ? JSON.parse(resp.data) : null
                  log.debug(
                    resourceName +
                      '.' +
                      actionName +
                      ' success (' +
                      status +
                      ')',
                    data
                  )

                  var loggerData = extractLoggerData(headers)

                  var messageHeader = headers('X-Glow-App-Message')
                  if (messageHeader) {
                    var jsonMessage
                    try {
                      jsonMessage = JSON.parse(messageHeader)
                    } catch (e) {
                      // do nothing
                    }
                    if (jsonMessage) {
                      broadcastMessage(jsonMessage)
                    }
                  }

                  var response

                  // if we are a resource, just fire off success
                  if (isResource) {
                    response = Class
                    fn(response, data, status, loggerData, xhr)
                    return
                  }

                  // we are a resourceService, we need to create the resource(s)
                  if (_.isArray(data)) {
                    // response is an array,
                    // return an array of new resources for each item
                    response = []
                    _.each(data, function(item) {
                      var resource = new Resource()
                      setData(resource, item)
                      setActions(resource, true)
                      response.push(resource)
                    })
                  } else {
                    // response is an object, turn it into a
                    // resource and return it.
                    response = new Resource()
                    setData(response, data)
                    setActions(response, true)
                  }
                  fn(response, data, status, loggerData, xhr)
                })
                return promise
              }

              promise.error = function(fn) {
                startRequest() // start if not already

                httpPromise.catch(function(resp) {
                  var data = resp.data
                  var status = resp.status
                  var headers = resp.headers

                  if (status === 401) {
                    broadcastUnauthorised()
                  }
                  log.debug(
                    resourceName + '.' + actionName + ' error (' + status + ')',
                    data
                  )

                  var loggerData = extractLoggerData(headers)
                  fn(data, status, loggerData, xhr)
                })
                return promise
              }

              // we add a debug promise method, which bypasses the request
              // and provides callback with the httpConfig

              promise.debug = function(fn) {
                fn(httpConfig)
              }
            }
          }
        }
      }

      /*
       * Resource Class
       * inherits the data response from the request,
       * and prefixed $actions
       */
      function Resource() {
        // ...
      }

      return this
    }
  }

  function Logger() {
    // var self = this;
    this.isEnabled = false
    this.debug = debug
    this.error = error

    // ------------------------

    function debug() {
      if (!this.isEnabled) {
        return
      }
      ;[].unshift.call(arguments, 'resources:')
      console.debug.apply(console, arguments)
    }

    function error() {
      ;[].unshift.call(arguments, 'resources:')
      console.error.apply(console, arguments)
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('Asset', Factory)

  function Factory() {
    var Defaults = {
      isSecure: true,
    }

    var Transform = {
      quality: 50,
      format: 'jpg',
    }

    // http://www.iana.org/assignments/media-types/media-types.xhtml
    var FILETYPE_INFO = [
      { type: 'image/bmp', hasTransform: true },
      { type: 'image/gif', hasTransform: true },
      { type: 'image/jpeg', hasTransform: true },
      { type: 'image/png', hasTransform: true },
      { type: 'image/svg+xml', hasTransform: true },
      { type: 'image/tiff', hasTransform: true },
      { type: 'image/vnd.microsoft.icon', hasTransform: true },
      { type: 'application/msword' },
      {
        type:
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      },
      { type: 'application/vnd.ms-powerpoint' },
      {
        type:
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      },
      { type: 'application/vnd.ms-excel' },
      {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      { type: 'application/pdf' },
      { type: 'application/zip' },
      { type: 'application/x-zip-compressed' }, // Windows
      { type: 'text/csv' },
      { type: 'text/plain' },
      // video
      { type: 'video/mp4' },
      { type: 'video/quicktime' },
    ]

    var FILETYPES = _.mapValues(FILETYPE_INFO, 'type')
    var TRANSFORM_FILETYPES = _(FILETYPE_INFO)
      .filter({ hasTransform: true })
      .mapValues('type')
      .value()

    function Asset() {
      _.defaultsDeep(this, Defaults)
    }

    Asset.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.ownerId = this.ownerId
      data.assetData = this.data
      data.mime = this.mime
      data.filename = this.filename
      data.publicTransformUrl = this.imageUrl
      data.transform = _.includes(TRANSFORM_FILETYPES, this.filetype)
        ? Transform
        : null
      data.secure = this.isSecure
      data.createdAt = this.createdAt && this.createdAt.toISOString()
      data.updatedAt = this.updatedAt && this.updatedAt.toISOString()
      return data
    }

    Asset.prototype.deserialize = function(data) {
      this.id = data.id
      this.ownerId = data.ownerId
      this.data = data.assetData
      this.mime = data.mime
      this.filename = data.filename
      this.imageUrl = data.publicTransformUrl
      this.transform = data.transform
      this.isSecure = data.secure
      this.createdAt = data.createdAt && moment(this.createdAt)
      this.updatedAt = data.updatedAt && moment(this.updatedAt)
      return this
    }

    Asset.prototype.isNew = function() {
      return !this.id
    }

    Asset.prototype.hasNewData = function() {
      return !!this.data
    }

    Asset.prototype.isValid = function() {
      var errors = []
      if (!_.includes(FILETYPES, this.filetype)) {
        errors.push('Invalid file type.')
      }
      this.errors = errors.length ? errors : null
      return !this.errors
    }

    return Asset
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "glDialog", "Asset", "assetsResource", "subscriberService", "assetTokensResource"];
  angular.module('glow.components').factory('assetService', Service)

  /* @ngInject */
  function Service(
    $q,
    glDialog,
    Asset,
    assetsResource,
    subscriberService,
    assetTokensResource
  ) {
    return {
      save: save,
      getBlank: getBlank,
      get: get,
      download: download,
    }

    function save(asset) {
      if (!asset.hasNewData()) {
        // we only create/update if there is data
        // are there cases where we need to update other fields?
        return $q.resolve()
      }

      return asset.id ? update(asset) : create(asset)
    }

    function create(asset) {
      return $q(function(resolve, reject) {
        var data = asset.serialize()

        assetsResource
          .create(data)
          .success(function(x, response) {
            asset.id = response.id
            asset.imageUrl = response.publicTransformUrl
            resolve()
          })
          .error(reject)
      })
    }

    function update(asset) {
      return $q(function(resolve, reject) {
        var data = asset.serialize()

        assetsResource
          .update(data)
          .success(function(x, response) {
            asset.id = response.id
            asset.imageUrl = response.publicTransformUrl
            resolve()
          })
          .error(reject)
      })
    }

    function getBlank() {
      return new Asset()
    }

    function get(id) {
      if (id === 'new') {
        return $q.resolve(new Asset())
      }
      return $q(function(resolve, reject) {
        assetsResource
          .get({ id: id })
          .success(function(x, asset) {
            resolve(new Asset().deserialize(asset))
          })
          .error(reject)
      })
    }

    function getDownloadUrl(assetId) {
      return $q(function(resolve, reject) {
        var subscriber = subscriberService.getSubscriber()
        var data = {
          assetId: assetId,
          ownerId: subscriber && subscriber.id,
        }

        assetTokensResource
          .create(data)
          .success(function(data) {
            resolve(data.downloadUrl)
          })
          .error(reject)
      })
    }

    function download(assetId, title, desc) {
      return getDownloadUrl(assetId).then(function(url) {
        return glDialog.show({
          templateUrl: 'asset-download.html',
          clickOutsideToClose: true,
          locals: {
            title: title,
            desc: desc,
            url: url,
          },
        })
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["countryService"];
  angular.module('glow.components').factory('Address', Factory)

  /* @ngInject */
  function Factory(countryService) {
    function Address(options) {
      _.defaults(this, options, {
        address: null,
        city: null,
        state: null,
        postalCode: null,
        country: {
          cc: null,
          name: null,
          id: null,
        },
      })
    }

    Address.prototype.deserialize = function(data) {
      this.address = data.address
      this.city = data.city
      this.state = data.state
      this.postalCode = data.postalCode
      this.country = data.country && {
        cc: data.country.cc,
        name: data.country.name,
        id: data.country.id,
      }
      return this
    }

    Address.prototype.serialize = function() {
      var data = {}
      data.address = this.address
      data.city = this.city
      data.state = this.state
      data.postalCode = this.postalCode
      data.country = {
        cc: this.country.cc,
        name: this.country.name,
        id: this.country.id,
      }
      return data
    }

    Address.prototype.setCountryByCc = function(cc) {
      this.country = countryService.getByCC(cc)
    }

    return Address
  }
})()

;(function() {
  'use strict'

  angular
    .module('glow.components.autofocus')
    .directive('glAutofocus', glAutofocusDirective)

  /* @ngInject */
  function glAutofocusDirective() {
    return {
      restrict: 'A',
      link: link,
    }

    function link(scope, element, attrs) {
      var el = element[0]

      if (attrs['glAutofocus']) {
        scope.$watch(attrs['glAutofocus'], focus)
      } else {
        focus(true)
      }

      function focus(condition) {
        if (condition) {
          scope.$evalAsync(function() {
            el.focus()
          })
        }
      }
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["distanceService"];
  angular.module('glow.components').factory('Beacon', Factory)

  /* @ngInject */
  function Factory(distanceService) {
    var Types = {
      PLACES: 'PLACES',
      PRODUCTS: 'PRODUCTS',
    }

    var MeasurementSystems = distanceService.MeasurementSystems
    var MeterConversion = distanceService.MeterConversion

    function Beacon(options) {
      this.applyDefaults(options)
    }

    Beacon.prototype.Types = Beacon.Types = Types
    Beacon.prototype.MeasurementSystems = Beacon.MeasurementSystems = MeasurementSystems
    Beacon.prototype.MeterConversion = Beacon.MeterConversion = MeterConversion

    Beacon.prototype.applyDefaults = function(options) {
      _.defaults(this, options, {
        id: null,
        ownerId: null,
        slug: null,
        type: Types.PLACES,
        logoUrl: null,
        title: null,
        description: null,
        bannerColor: null,
        themeColor: null,
        isPublished: false, // not being used
        disabled: false,
        filteredVisiblePlaceIds: [], // Array of specific place IDs to show; empty array means all places are visible
        filteredVisibleProductIds: [], // Array of specific product IDs to show; empty array means all products are visible
        measurementSystem: MeasurementSystems.METRIC,
        placesMaxDistance: 2, // unit is based on measurement system (km or miles)
        productInstructions: 'Enter the last 5 digits of the barcode.',
        createdAt: moment(),
        updatedAt: moment(),
        mode: 'view',
      })
    }

    Beacon.prototype.deserialize = function(data) {
      this.id = data.id
      this.ownerId = data.ownerId
      this.slug = data.slug
      this.type = data.type
      this.logoUrl = data.logoUrl
      this.title = data.title
      this.description = data.description
      this.bannerColor = data.bannerColor
      this.themeColor = data.themeColor
      this.isPublished = data.isPublished

      data.data = _.isPlainObject(data.data) ? data.data : {}
      this.filteredVisiblePlaceIds = data.data.filteredVisiblePlaceIds
      this.filteredVisibleProductIds = data.data.filteredVisibleProductIds
      this.measurementSystem = data.data.measurementSystem
      this.placesMaxDistance = data.data.placesMaxDistance
      this.productInstructions = data.data.productInstructions
      this.disabled = data.data.disabled

      this.createdAt = data.createdAt && moment(data.createdAt)
      this.updatedAt = data.updatedAt && moment(data.updatedAt)

      this.applyDefaults()
      this.snapshot()
      return this
    }

    Beacon.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.ownerId = this.ownerId
      data.slug = this.slug
      data.type = this.type
      data.logoUrl = this.logoUrl
      data.title = this.title
      data.description = this.description
      data.bannerColor = this.bannerColor
      data.themeColor = this.themeColor
      data.isPublished = this.isPublished

      data.data = {}
      data.data.filteredVisiblePlaceIds = this.filteredVisiblePlaceIds
      data.data.filteredVisibleProductIds = this.filteredVisibleProductIds
      data.data.measurementSystem = this.measurementSystem
      data.data.placesMaxDistance = this.placesMaxDistance
      data.data.productInstructions = this.productInstructions
      data.data.disabled = this.disabled

      data.createdAt = this.createdAt && this.createdAt.toISOString()
      data.updatedAt = this.updatedAt && this.updatedAt.toISOString()
      return data
    }

    Beacon.prototype.isNew = function() {
      return !this.id
    }

    Beacon.prototype.isPlaces = function() {
      return this.type === Types.PLACES
    }

    Beacon.prototype.isProducts = function() {
      return this.type === Types.PRODUCTS
    }

    Beacon.prototype.isPlaceIdVisible = function(placeId) {
      return this.filteredVisiblePlaceIds.length
        ? _.includes(this.filteredVisiblePlaceIds, placeId)
        : true
    }

    Beacon.prototype.isProductIdVisible = function(productId) {
      return this.filteredVisibleProductIds.length
        ? _.includes(this.filteredVisibleProductIds, productId)
        : true
    }

    Beacon.prototype.getMaxDistanceInMeters = function() {
      return this.placesMaxDistance * MeterConversion[this.measurementSystem]
    }

    Beacon.prototype.clone = function() {
      // clone means an exact copy, don't modify fields here.
      return new Beacon().deserialize(this.serialize())
    }

    Beacon.prototype.become = function(beacon) {
      this.deserialize(beacon.serialize())
    }

    Beacon.prototype.cleanUp = function() {
      this.slug = this.slug.replace(/ /g, '') // remove spaces
    }

    Beacon.prototype.validate = function() {
      var self = this
      var isValid = true
      self.errors = []
      if (!self.slug) {
        self.errors.push('Slug is required')
        isValid = false
      }
      if (!self.type) {
        self.errors.push('Type is required')
        isValid = false
      }
      if (self.isPlaces() && !self.placesMaxDistance) {
        self.errors.push('Max Distance is required')
        isValid = false
      }
      if (self.isProducts() && !self.productInstructions) {
        self.errors.push('Product Instructions is required')
        isValid = false
      }
      return isValid
    }

    Beacon.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    Beacon.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    Beacon.prototype.Errors = Beacon.Errors = {
      UniqueSlug: {
        type: 'UniqueSlug',
        message:
          "You can't use this slug as this has been taken. Please try another one.",
      },
      Unknown: {
        type: 'Unknown',
        message: 'Something went wrong, please try again.',
      },
    }

    return Beacon
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "Beacon", "beaconsResource"];
  angular.module('glow.components').service('beaconService', Service)

  /* @ngInject */
  function Service($q, Beacon, beaconsResource) {
    var self = this

    self.list = list
    self.get = get
    self.getBySlug = getBySlug
    self.create = create
    self.save = save
    self.remove = remove

    function list(ownerId) {
      return $q(function(resolve, reject) {
        beaconsResource
          .getBySubscriber({ id: ownerId })
          .success(function(x, beaconsData) {
            var beacons = _.map(beaconsData, function(beacon) {
              return new Beacon().deserialize(beacon)
            })
            resolve(beacons)
          })
          .error(reject)
      })
    }

    function get(id) {
      return $q(function(resolve, reject) {
        beaconsResource
          .get({ id: id })
          .success(function(x, beaconData) {
            var beacon = new Beacon().deserialize(beaconData)
            resolve(beacon)
          })
          .error(reject)
      })
    }

    function getBySlug(slug) {
      return $q(function(resolve, reject) {
        beaconsResource
          .getBySlug({ slug: slug })
          .success(function(x, beaconData) {
            var beacon = new Beacon().deserialize(beaconData)
            resolve(beacon)
          })
          .error(reject)
      })
    }

    function create(data) {
      return new Beacon(data)
    }

    function save(beacon) {
      return $q(function(resolve, reject) {
        var action = beacon.isNew() ? 'create' : 'update'
        beacon.isSaving = true
        beacon.error = null

        beaconsResource[action](beacon.serialize())
          .success(function(response) {
            if (response.id) {
              beacon.id = response.id
            }
            beacon.snapshot()
            beacon.isSaving = false
            resolve()
          })
          .error(function(error) {
            beacon.isSaving = false
            if (error && error.__status === 409) {
              beacon.error = beacon.Errors.UniqueSlug
            } else {
              beacon.error = beacon.Errors.Unknown
            }
            reject()
          })
      })
    }

    function remove(beacon) {
      return $q(function(resolve, reject) {
        if (beacon.isNew()) {
          return resolve()
        }
        beacon.isRemoving = true
        beaconsResource
          .delete({ id: beacon.id })
          .success(function(response) {
            resolve()
          })
          .error(function(error) {
            beacon.isRemoving = false
            reject(error)
          })
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["$rootScope"];
  angular.module('glow.components').factory('AudioPlayer', Factory)

  function Factory($rootScope) {
    function AudioPlayer(url) {
      this.url = url
      this.isPlaying = false
      this.elem = document.createElement('audio')
      this.elem.setAttribute('src', url)
      this.elem.addEventListener('timeupdate', this.onTimeUpdate.bind(this))
      this.elem.addEventListener('ended', this.onEnded.bind(this))
    }

    AudioPlayer.prototype.onTimeUpdate = function() {
      var self = this
      $rootScope.$applyAsync(function() {
        self.progress = (self.elem.currentTime / self.elem.duration) * 100
      })
    }

    AudioPlayer.prototype.onEnded = function() {
      var self = this
      $rootScope.$applyAsync(function() {
        self.pause()
        self.elem.currentTime = 0
      })
    }

    AudioPlayer.prototype.play = function() {
      if (this.isPlaying) return
      this.elem.play()
      this.isPlaying = true
    }

    AudioPlayer.prototype.pause = function() {
      if (!this.isPlaying) return
      this.elem.pause()
      this.isPlaying = false
    }

    AudioPlayer.prototype.toggle = function() {
      return this.isPlaying ? this.pause() : this.play()
    }

    AudioPlayer.prototype.destroy = function() {
      if (this.isPlaying) {
        this.pause()
        this.elem.currentTime = 0
        this.elem.removeAttribute('src')
        this.elem.load()
      }
    }

    return AudioPlayer
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["Money", "Price"];
  angular.module('glow.components').factory('Bundle', Factory)

  function Factory(Money, Price) {
    var Status = {
      DRAFT: 'DRAFT',
      PUBLIC: 'PUBLIC',
      ARCHIVED: 'ARCHIVED',
    }

    function Bundle() {
      this.applyDefaults()
    }

    Bundle.prototype.Status = Bundle.Status = Status

    Bundle.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: null,
        name: null,
        desc: null,
        price: new Price(),
        credit: new Price(),
        reviewPrice: new Price(),
        status: Status.DRAFT,
        canPurchaseMultiple: true,
        createdAt: null,
        updatedAt: null,
      })
    }

    Bundle.prototype.deserialize = function(data) {
      this.id = data.id
      this.name = data.name
      this.desc = data.desc
      this.price = new Price().deserialize(data.prices)
      this.credit = new Price().deserialize(data.credits)
      this.reviewPrice = new Price().deserialize({
        // Review pricing stems from USD.
        // In the future we probably want to manage this
        // inside the BE model itself.
        USD: 44000, // 1x
        AUD: 57000, // ~1.3x
        GBP: 33000, // ~0.75x
      })
      this.status = data.status
      this.canPurchaseMultiple = data.canPurchaseMultiple
      this.createdAt = data.createdAt && moment(data.createdAt)
      this.updatedAt = data.updatedAt && moment(data.updatedAt)
      this.applyDefaults()
      return this
    }

    Bundle.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.name = this.name
      data.desc = this.desc
      data.prices = this.price.serialize()
      data.credits = this.credit.serialize()
      data.reviewPrice = this.reviewPrice.serialize()
      data.status = this.status
      data.canPurchaseMultiple = this.canPurchaseMultiple
      data.createdAt = this.createdAt && this.createdAt.toISOString()
      data.updatedAt = this.updatedAt && this.updatedAt.toISOString()
      return data
    }

    Bundle.prototype.getSubtotal = function(currency) {
      var amount = 0
      amount += this.credit.byCurrency(currency).amount
      amount += this.reviewPrice.byCurrency(currency).amount
      return new Money({ amount: amount, currency: currency })
    }

    Bundle.prototype.getSavingsCost = function(currency) {
      return new Money({
        amount:
          this.getSubtotal(currency).amount -
          this.price.byCurrency(currency).amount,
        currency: currency,
      })
    }

    Bundle.prototype.getSavingsPercent = function(currency) {
      var percent =
        100 -
        (this.price.byCurrency(currency).amount /
          this.getSubtotal(currency).amount) *
          100
      return Math.round(percent) + '%'
    }

    Bundle.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    Bundle.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    Bundle.prototype.validate = function() {
      var errors = []
      if (!this.name) {
        errors.push('Name is required')
      }
      if (!this.desc) {
        errors.push('Description is required')
      }
      _.each(this.price.list, function(price) {
        if (price.amount <= 0) {
          errors.push('Cost amount is required')
        }
      })
      _.each(this.credit.list, function(price) {
        if (!_.isNumber(price.amount) || price.amount < 0) {
          errors.push('Credit amount is required')
        }
      })

      if (!this.status) {
        errors.push('Status is required')
      }
      if (errors.length) {
        this.errors = errors
        return false
      }
      this.errors = null
      return true
    }

    Bundle.prototype.copy = function(bundle) {
      this.deserialize(bundle.serialize())
    }

    Bundle.prototype.clone = function() {
      return new Bundle().deserialize(this.serialize())
    }

    Bundle.prototype.isNew = function() {
      return !this.id
    }

    return Bundle
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "glDialog", "bundlesResource", "Bundle"];
  angular.module('glow.components').service('bundleService', Service)

  /* @ngInject */
  function Service($q, glDialog, bundlesResource, Bundle) {
    var self = this

    self.Status = Bundle.Status
    self.spawn = spawn
    self.save = save
    self.loadAll = loadAll
    self.load = load
    self.showSelector = showSelector

    function spawn() {
      return new Bundle()
    }

    function save(bundle) {
      if (bundle.isNew()) {
        return create(bundle)
      } else {
        return update(bundle)
      }
    }

    function create(bundle) {
      return $q(function(resolve, reject) {
        bundlesResource
          .create(bundle.serialize())
          .success(function(resp) {
            bundle.id = resp.id
            bundle.snapshot()
            resolve()
          })
          .error(reject)
      })
    }

    function update(bundle) {
      return $q(function(resolve, reject) {
        bundlesResource
          .update(bundle.serialize())
          .success(function() {
            bundle.snapshot()
            resolve()
          })
          .error(reject)
      })
    }

    function loadAll() {
      return $q(function(resolve, reject) {
        bundlesResource
          .get()
          .success(function(_, bundles) {
            bundles = bundles.map(function(bundle) {
              bundle = new Bundle().deserialize(bundle)
              bundle.snapshot()
              return bundle
            })
            resolve(bundles)
          })
          .error(reject)
      })
    }

    function load(id) {
      return $q(function(resolve, reject) {
        bundlesResource
          .get({ id: id })
          .success(function(_, bundle) {
            bundle = new Bundle().deserialize(bundle)
            bundle.snapshot()
            resolve(bundle)
          })
          .error(reject)
      })
    }

    function showSelector() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="bundle-selector__dialog">',
          '<g-dialog-header ',
            'title="Bundles" ',
            'on-close="dialog.cancel()"',
          '></g-dialog-header>',
          '<bundle-selector ',
            'on-select="dialog.close($bundle)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>'
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {},
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["Money"];
  angular.module('glow.components').factory('Charge', Factory)

  function Factory(Money) {
    function Charge() {
      this.applyDefaults()
    }

    Charge.prototype.applyDefaults = function() {
      var amount = new Money({ currency: 'AUD' })
      _.defaultsDeep(this, {
        id: null,
        amount: amount.clone(),
        currency: amount.currency,
        description: '',
        metadata: {},
        paid: false,
        receiptUrl: null,
        status: null,
        invoiceId: null,
        createdAt: null,
      })
    }

    Charge.prototype.deserialize = function(data) {
      var currency = data.currency.toUpperCase()
      var metadata = _.isPlainObject(data.metadata) ? data.metadata : {}
      this._ = _.cloneDeep(data)
      this.id = data.id
      this.currency = currency
      this.amount = new Money({
        amount: data.amount,
        currency: currency,
      })
      this.price = new Money({
        amount: metadata.price,
        currency: currency,
      })
      this.tax = new Money({
        amount: metadata.taxAmount,
        currency: currency,
      })
      this.taxName = metadata.taxName
      this.taxPercent = metadata.taxPercent
      this.description = data.description
      this.paid = data.paid
      this.receiptUrl = data.receipt_url
      this.status = data.status
      this.invoiceId = data.invoice
      this.createdAt = data.created ? moment.unix(data.created) : null
      return this
    }

    Charge.prototype.serialize = function() {
      return this._
    }

    Charge.prototype.setCurrency = function(currency) {
      this.amount.currency = currency
      this.currency = currency
    }

    Charge.prototype.getStatusLabel = function() {
      return {
        succeeded: 'Paid',
        pending: 'Pending',
        failed: 'Failed',
      }[this.status]
    }

    return Charge
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "Charge", "chargesResource"];
  angular.module('glow.components').factory('chargeService', Service)

  /* @ngInject */
  function Service($q, Charge, chargesResource) {
    return {
      getBySubscriber: getBySubscriber,
    }

    function getBySubscriber(subscriberId) {
      return $q(function(resolve, reject) {
        chargesResource
          .get({ groupId: subscriberId }) // TODO: add limit to max 100
          .success(function(x, resp) {
            var charges = _.map(resp.data, function(data) {
              return new Charge().deserialize(data)
            })
            resolve(charges)
          })
          .error(reject)
      })
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('ChannelEmbedData', Factory)

  /* @ngInject */
  function Factory() {
    var NAME_REGEX = /^[A-Za-z][A-Za-z0-9._~-]*$/

    var DEFAULT_PARAM = {
      name: null,
      template: null,
      forwardName: null,
      isRespondentId: false,
      isAddToFilters: false,
    }

    function paramMap(data) {
      return _.assign({}, DEFAULT_PARAM, data)
    }

    function ChannelEmbedData() {
      this.applyDefaults()
    }

    ChannelEmbedData.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        enabled: false,
        params: [paramMap()],
      })
    }

    ChannelEmbedData.prototype.serialize = function() {
      var data = {}
      data.enabled = this.enabled
      data.params = this.params.map(paramMap)
      return data
    }

    ChannelEmbedData.prototype.deserialize = function(data) {
      data = _.isPlainObject(data) ? data : {}
      this.enabled = data.enabled
      data.params = _.isArray(data.params) ? data.params : []
      this.params = data.params.map(paramMap)
      this.applyDefaults()
      return this
    }

    ChannelEmbedData.prototype.addParam = function() {
      this.params.push(paramMap())
    }

    ChannelEmbedData.prototype.removeParam = function(param) {
      _.remove(this.params, param)
    }

    ChannelEmbedData.prototype.validateName = function(name) {
      return NAME_REGEX.test(name)
    }

    ChannelEmbedData.prototype.validate = function(redirectsEnabled) {
      var self = this
      var errors = []

      if (this.enabled) {
        var nameNotEmpty = true
        var templateNotEmpty = true
        var nameIsValid = true
        var forwardNameIsValid = true
        var names = []
        var forwardNames = []
        var respondentIdCount = 0

        this.params.forEach(function(param) {
          if (!param.name) {
            nameNotEmpty = false
          }
          if (!param.template) {
            templateNotEmpty = false
          }
          if (param.name) {
            if (!self.validateName(param.name)) {
              nameIsValid = false
            }
            names.push(param.name)
          }
          if (redirectsEnabled && param.forwardName) {
            if (!self.validateName(param.forwardName)) {
              forwardNameIsValid = false
            }
            forwardNames.push(param.forwardName)
          }
          if (param.isRespondentId) {
            respondentIdCount++
          }
        })

        if (!nameNotEmpty) {
          errors.push('Name is required and cannot be empty')
        }

        if (!templateNotEmpty) {
          errors.push('Template is required and cannot be empty')
        }

        if (!nameIsValid) {
          errors.push(
            'Invalid Name. Start with a letter; use letters/numbers . _ ~ -'
          )
        }

        if (!forwardNameIsValid) {
          errors.push(
            'Invalid Forward Name. Start with a letter; use letters/numbers . _ ~ -'
          )
        }

        if (_.uniq(names).length !== names.length) {
          errors.push('Name must be unique')
        }

        if (_.uniq(forwardNames).length !== forwardNames.length) {
          errors.push('Forward Name must be unique')
        }

        if (respondentIdCount > 1) {
          errors.push('Only one data can be marked as Respondent ID')
        }
      }

      if (errors.length) {
        this.errors = errors
        return false
      }
      this.errors = null
      return true
    }

    ChannelEmbedData.prototype.copy = function(data) {
      this.deserialize(data.serialize())
    }

    ChannelEmbedData.prototype.clone = function() {
      return new ChannelEmbedData().deserialize(this.serialize())
    }

    ChannelEmbedData.prototype.getRespondentLink = function(
      channelLongUrl,
      test
    ) {
      var url = new URL(channelLongUrl)
      if (test) url.searchParams.set('readOnly', true)
      this.params.forEach(function(param) {
        url.searchParams.set(param.name, param.template)
      })
      return decodeURI(url.toString())
    }

    return ChannelEmbedData
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils", "gUrl", "configService", "Link", "Money", "Panel", "ExternalPanel", "ExternalPanelValueStore", "LeastFill", "TagQuotaSettings", "ChannelEmbedData"];
  angular.module('glow.components').factory('Channel', Factory)

  function Factory(
    glUtils,
    gUrl,
    configService,
    Link,
    Money,
    Panel,
    ExternalPanel,
    ExternalPanelValueStore,
    LeastFill,
    TagQuotaSettings,
    ChannelEmbedData
  ) {
    // Eg: https://app.glowfeed.com/audience-channels/
    var ChannelBaseUrl = configService.getUserPortalUrl('/audience-channels/')
    var FragmentRegex = /^[a-zA-Z0-9._-]+$/

    var Type = {
      CUSTOM: 'custom', // BUG: https://engagementinnovation.atlassian.net/browse/GLOWSYS-2281
      EXTERNAL_PANEL: 'external_panel',
      PANEL: 'panel',
      PRODUCTS: 'product', // BUG: must be lowercase :/
      PLACES: 'place',
      KIOSK: 'kiosk',
    }

    // a channel's place in a chain of surveys linked by redirects
    var ForwardTagsRole = {
      OFF: 'OFF',
      SEND: 'SEND',
      RECEIVE_AND_SEND: 'RECEIVE_AND_SEND',
      RECEIVE: 'RECEIVE',
    }

    // the link param that carries the tags between chained surveys
    var FORWARD_TAGS_PARAM = 'tags'

    var Category = {
      PRIMARY: 'primary',
      OTHER: 'other',
      PREMIUM: 'premium',
    }

    var types = [
      {
        value: Type.CUSTOM,
        name: 'Universal Link',
        imageUrl: '/img/channel-type-custom.png',
        desc:
          'Create a universal link for your survey and send it to your audience.',
        category: Category.PRIMARY,
      },
      {
        value: Type.PANEL,
        name: 'Integrated Consumer Panel',
        imageUrl: '/img/channel-type-panel.png',
        desc: 'Get responses to your survey from our integrated consumer panel',
        category: Category.PREMIUM,
      },
      {
        value: Type.EXTERNAL_PANEL,
        name: 'Panel Partners',
        imageUrl: '/img/channel-type-panel.png',
        desc:
          'Get responses using redirect links from your preferred online panel provider.',
        category: Category.PRIMARY,
      },
      {
        value: Type.PRODUCTS,
        name: 'Products (Beta)',
        imageUrl: '/img/channel-type-products.png',
        desc:
          'Engage your audience at the best time possible - when they have your product in their hands.',
        infoUrl: 'https://glo.link/products-info',
        category: Category.OTHER,
      },
      {
        value: Type.PLACES,
        name: 'Places',
        imageUrl: '/img/channel-type-places.png',
        desc:
          "Get great feedback from your customers while they're at (or close to) your location.",
        // infoUrl: 'https://glo.link/places-info',
        category: Category.OTHER,
      },
      {
        value: Type.KIOSK,
        name: 'Kiosk',
        imageUrl: '/img/channel-type-kiosk.png',
        desc:
          'Turn any smartphone or tablet into a simple, repeating data capture device in minutes.',
        category: Category.OTHER,
      },
      {
        // coming soon
        value: 'CROWD',
        name: 'Your Crowd (Coming Soon)',
        imageUrl: '/img/channel-type-crowd.png',
        desc: 'Tap into your crowd any time to get answers on demand',
        category: Category.OTHER,
      },
    ]

    var Events = {
      CREATED: 'channel:created',
      ENABLED: 'channel:enabled',
      DISABLED: 'channel:disabled',
    }

    var FixedMultipleResponsesTypes = [Type.KIOSK]

    var DefaultNotificationFrequency = 50
    var DefaultSpendTarget = 50000

    function Channel(currency) {
      this.currency = currency || 'AUD'
      this.applyDefaults()
    }

    Channel.prototype.types = Channel.types = types
    Channel.prototype.Type = Channel.Type = Type
    Channel.prototype.ForwardTagsRole = Channel.ForwardTagsRole = ForwardTagsRole
    Channel.prototype.FORWARD_TAGS_PARAM = Channel.FORWARD_TAGS_PARAM = FORWARD_TAGS_PARAM
    Channel.prototype.Category = Channel.Category = Category
    Channel.prototype.Events = Channel.Events = Events

    Channel.prototype.applyDefaults = function() {
      var now = moment()
      var id = glUtils.uuid()
      var surveyUrl = ChannelBaseUrl + id
      var link = new Link(surveyUrl)
      var panel = new Panel()
      panel.id = id
      panel.setSurveyUrls(surveyUrl)
      _.defaults(this, {
        panel: panel,
        link: link,
      })
      _.defaultsDeep(this, {
        id: id,
        isNew: true,
        enabled: false,
        survey: {
          id: null,
          allowMultipleResponses: false,
        },
        translationId: null,
        targeting: {
          enabled: false,
          presetId: null,
        },
        redirects: {
          enabled: false,
          submitLink: null,
          exitLink: null,
          quotaLink: null,
          qualityExitLink: null,
        },
        embedData: new ChannelEmbedData(),
        forwardTags: {
          role: ForwardTagsRole.OFF,
          allTags: true,
          tags: [],
        },
        webhook: {
          enabled: false,
          url: null,
        },
        billing: {
          closeOnBudget: false,
          maxBudget: new Money({ amount: 0, currency: this.currency }),
          balance: new Money({ amount: 0, currency: this.currency }),
        },
        estimate: {
          estimatedIncidenceRate: 0,
          currentIncidenceRate: 0,
          estimatedBudget: new Money({ amount: 0, currency: this.currency }),
        },
        provider: null,
        providerValues: new ExternalPanelValueStore(),
        reward: null,
        products: [],
        places: [],
        responseLimit: 50,
        responseCount: 0,
        lastResponseCollectedAt: null,
        exitCount: 0,
        quotaCount: 0,
        cost: new Money({ amount: 0, currency: this.currency }),
        notifyOnEvery: null,
        tagQuotasEnabled: false,
        tags: [],
        injectedTags: [],
        leastFills: [],
        injectedVariables: [],
        useGlobalTagCounts: true,
        ipProtectionEnabled: false,

        // these 2 attributes are SSR only feature. We need to be careful when introducing user feature to clone/copy a channel
        // when we do introduce clone channel, we need to ensure these attributes are set to their default values on the copy
        consumesCredit: true,
        isCharged: true,

        ownerId: null,
        createdAt: now,
        updatedAt: now,
      })
    }

    Channel.prototype.serialize = function() {
      var self = this
      var data = {}
      data.id = this.id
      data.name = this.name
      data.enabled = this.enabled
      data.type = this.type
      data.currency = this.currency

      data.survey = {}
      data.survey.id = this.survey.id
      data.survey.allowMultipleResponses = this.survey.allowMultipleResponses

      data.data = {}
      data.data.translationId = this.translationId

      data.data.targeting = {}
      data.data.targeting.enabled = this.targeting.enabled
      data.data.targeting.presetId = this.targeting.presetId

      if (this.webhook.enabled) {
        data.webhook = this.webhook.url
      }

      if (!data.data.targeting.enabled && this.panel) {
        data.data.targeting.presetId = null
        _.remove(this.panel.targets)
      }

      data.redirects = {}
      data.redirects.enabled = this.redirects.enabled
      data.redirects.submitLink = gUrl.fullyForm(this.redirects.submitLink)
      data.redirects.exitLink = gUrl.fullyForm(this.redirects.exitLink)
      data.redirects.quotaLink = gUrl.fullyForm(this.redirects.quotaLink)
      data.redirects.qualityExitLink = gUrl.fullyForm(
        this.redirects.qualityExitLink
      )

      data.data.embedData = this.embedData.serialize()

      data.data.forwardTags = {
        role: this.forwardTags.role,
        allTags: this.forwardTags.allTags,
        tags: this.forwardTags.tags.slice(),
      }

      data.data.provider = this.provider ? this.provider.serialize() : null
      if (this.provider) {
        // providers override redirect links
        data.redirects.enabled = true
        data.redirects.submitLink = this.provider.submitLink
        data.redirects.exitLink = this.provider.exitLink
        data.redirects.quotaLink = this.provider.quotaLink
        data.redirects.qualityExitLink = this.provider.qualityExitLink
      }
      data.data.providerValues = this.providerValues.serialize()

      if (this.reward) {
        data.reward = {}
        data.reward.spendTarget = Math.round(this.reward.spendTarget.amount) // must be int
        data.reward.currentSpend = this.reward.currentSpend.amount
        data.reward.notifyOnSpendTarget = this.reward.notifyOnSpendTarget
        data.reward.disableChannelOnSpendTarget = this.reward.disableChannelOnSpendTarget
      }

      if (
        _.includes(
          [Type.CUSTOM, Type.EXTERNAL_PANEL, Type.KIOSK, Type.PANEL],
          this.type
        )
      ) {
        data.link = {}
        data.link.lcShortUrlFragment = this.link.fragment
        data.link.shortUrl = this.link.shortUrl
        data.link.longUrl = this.link.longUrl
      }

      if (_.includes([Type.PRODUCTS], this.type)) {
        data.products = _.clone(this.products)
      }

      if (_.includes([Type.PLACES], this.type)) {
        data.places = _.clone(this.places)
      }

      if (_.includes([Type.PANEL], this.type)) {
        data.panel = this.panel.serialize()
        // keep a copy of panel exclusions on channel model
        // this is used by BE to do precheck on survey start
        // we don't need to deserialize it because it's stored in Panel
        data.exclusions = data.panel.exclusions.list.slice()
      }

      data.data.tagQuotasEnabled = self.tagQuotasEnabled
      data.tagQuotas = {}
      data.tagCounts = {}
      _.each(this.tags, function(tag) {
        data.tagQuotas[tag.name] = self.tagQuotasEnabled ? tag.quota : null
        data.tagCounts[tag.name] = tag.count
      })

      data.data.injectedTags = this.injectedTags.slice()
      data.data.injectedVariables = this.injectedVariables.slice()

      data.data.leastFills = _.map(this.leastFills, function(leastFill) {
        return leastFill.serialize()
      })

      // console.log('TAGS: Channel.serialize', {
      //   tagQuotasEnabled: data.data.tagQuotasEnabled,
      //   tagCounts: _.cloneDeep(data.tagCounts),
      //   tagQuotas: _.cloneDeep(data.tagQuotas),
      // })

      data.responseLimit =
        this.type === Type.PANEL
          ? this.panel.requiredCompletes
          : this.responseLimit
      data.responseCount = this.responseCount
      data.lastResponseCollectedAt = this.lastResponseCollectedAt
      data.exitCount = this.exitCount
      data.quotaCount = this.quotaCount
      data.totalCost = this.cost.amount

      data.billing = {}
      data.billing.closeOnBudget = this.billing.closeOnBudget
      data.billing.maxBudget = this.billing.maxBudget.amount
      data.billing.balance = this.billing.balance.amount

      data.estimate = {}
      data.estimate.targetCompletesCount = data.responseLimit // redundantly added twice here
      data.estimate.estimatedIncidenceRate = this.type === Type.PANEL ? this.panel.incidenceRate : 100 // prettier-ignore
      data.estimate.estimatedBudget = this.estimate.estimatedBudget.amount

      data.notifyOnEvery = _.isNumber(this.notifyOnEvery)
        ? Math.round(this.notifyOnEvery)
        : null // must be int or null

      data.data.useGlobalTagCounts = this.useGlobalTagCounts
      data.ipProtectionEnabled = this.ipProtectionEnabled

      data.consumesCredit = this.consumesCredit
      data.isCharged = this.isCharged
      data.ownerId = this.ownerId
      data.updatedAt = this.updatedAt
      data.createdAt = this.createdAt

      return data
    }

    function lazyMigrate(data) {
      data.data = _.isPlainObject(data.data) ? data.data : {}
      if (data.data.useGlobalTagCounts === undefined) {
        data.data.useGlobalTagCounts = false
      }
    }

    Channel.prototype.deserialize = function(data) {
      lazyMigrate(data)

      var self = this
      data.custom = _.isPlainObject(data.custom) ? data.custom : {}
      data.data = _.isPlainObject(data.data) ? data.data : {}
      data.data.targeting = _.isPlainObject(data.data.targeting)
        ? data.data.targeting
        : {}
      data.redirects = _.isPlainObject(data.redirects) ? data.redirects : {}
      this.id = data.id
      this.isNew = !data.id
      this.name = data.name
      this.enabled = data.enabled
      this.type = data.type
      this.translationId = data.data.translationId

      // migrate data.redirects to root
      if (_.isPlainObject(data.data.redirects)) {
        data.redirects = data.data.redirects
        data.data.redirects = undefined
      }

      // redirect links
      this.redirects.enabled = data.redirects.enabled || false
      this.redirects.submitLink = data.redirects.submitLink || null
      this.redirects.exitLink = data.redirects.exitLink || null
      this.redirects.quotaLink = data.redirects.quotaLink || null
      this.redirects.qualityExitLink = data.redirects.qualityExitLink || null
      if (
        this.redirects.enabled &&
        !(
          this.redirects.submitLink ||
          this.redirects.exitLink ||
          this.redirects.quotaLink ||
          this.redirects.qualityExitLink
        )
      ) {
        this.redirects.enabled = false
      }

      this.embedData.deserialize(data.data.embedData)

      // missing values are filled by applyDefaults
      var forwardTags = _.isPlainObject(data.data.forwardTags)
        ? data.data.forwardTags
        : {}
      this.forwardTags = {
        role: forwardTags.role,
        allTags: forwardTags.allTags,
        tags: _.isArray(forwardTags.tags)
          ? forwardTags.tags.slice()
          : undefined,
      }

      this.webhook.enabled = !!data.webhook
      this.webhook.url = data.webhook

      // billing info only available on panel channels
      if (data.billing) {
        this.billing.closeOnBudget = data.billing.closeOnBudget
        this.billing.maxBudget.amount = data.billing.maxBudget
        this.billing.balance.amount = data.billing.balance
      }

      // estimate info only available on panel channels
      if (data.estimate) {
        this.estimate.targetCompletesCount = data.estimate.targetCompletesCount
        this.estimate.estimatedIncidenceRate = data.estimate.estimatedIncidenceRate // prettier-ignore
        this.estimate.estimatedBudget.amount = data.estimate.estimatedBudget
      }

      this.provider = data.data.provider
        ? new ExternalPanel().deserialize(data.data.provider)
        : null
      this.providerValues.deserialize(data.data.providerValues)

      if (data.currency) {
        this.currency = data.currency
      }

      this.survey = {}
      this.survey.id = data.survey.id
      this.survey.allowMultipleResponses = data.survey.allowMultipleResponses

      this.link = new Link()
      if (
        _.includes(
          [Type.CUSTOM, Type.EXTERNAL_PANEL, Type.KIOSK, Type.PANEL],
          data.type
        )
      ) {
        this.link.fragment = data.link.lcShortUrlFragment
        this.link.shortUrl = data.link.shortUrl
        this.link.longUrl = data.link.longUrl
      }

      this.reward = null
      if (data.reward) {
        this.reward = {}
        this.reward.spendTarget = new Money({
          amount: data.reward.spendTarget,
          currency: this.currency,
        })
        this.reward.currentSpend = new Money({
          amount: data.reward.currentSpend,
          currency: this.currency,
        })
        this.reward.notifyOnSpendTarget = data.reward.notifyOnSpendTarget
        this.reward.disableChannelOnSpendTarget =
          data.reward.disableChannelOnSpendTarget
      }

      this.panel = new Panel()
      this.panel.id = data.id
      if (data.panel) {
        this.panel.deserialize(data.panel)
      }

      this.targeting = {}
      this.targeting.enabled = data.data.targeting.enabled
      this.targeting.presetId = data.data.targeting.presetId

      this.products = data.products || []
      this.places = data.places || []

      this.responseLimit = data.responseLimit
      this.responseCount = data.responseCount
      this.lastResponseCollectedAt =
        data.lastResponseCollectedAt && moment(data.lastResponseCollectedAt)
      this.exitCount = data.exitCount
      this.quotaCount = data.quotaCount
      this.cost.amount = data.totalCost

      var tags = []
      data.tagQuotas = data.tagQuotas || {}
      data.tagCounts = data.tagCounts || {}
      _.each(data.tagQuotas, function(quota, name) {
        var tag = {}
        tag.name = name
        tag.quota = _.isNumber(quota) ? quota : null
        tag.count = data.tagCounts[tag.name] || 0
        tag.full = _.isNumber(tag.quota) && tag.count >= tag.quota
        tag.active = _.some(self.tags, { name: tag.name, active: true }) // keep track of active
        tags.push(tag)
      })
      _.each(data.tagCounts, function(count, name) {
        var tagExist = !!_.find(tags, { name: name })
        if (tagExist) return // continue
        var tag = {}
        tag.name = name
        tag.quota = null
        tag.count = count
        tag.full = false
        tag.active = _.some(self.tags, { name: tag.name, active: true }) // keep track of active
        tags.push(tag)
      })
      this.tags = tags
      this.tagQuotasEnabled = data.data.tagQuotasEnabled
      // console.log('TAGS: Channel.deserialize', {
      //   tagQuotasEnabled: this.tagQuotasEnabled,
      //   tags: _.cloneDeep(this.tags),
      // })

      this.injectedTags = data.data.injectedTags
      this.injectedVariables = data.data.injectedVariables

      this.leastFills = _.map(data.data.leastFills, function(leastFill) {
        return new LeastFill().deserialize(leastFill)
      })

      this.notifyOnEvery = data.notifyOnEvery

      this.useGlobalTagCounts = data.data.useGlobalTagCounts
      this.ipProtectionEnabled = data.ipProtectionEnabled

      this.consumesCredit = data.consumesCredit
      this.isCharged = data.isCharged
      this.ownerId = data.ownerId
      // BE: https://engagementinnovation.atlassian.net/browse/GLOWSYS-2283
      this.createdAt = data.createdAt && moment(data.createdAt)
      this.updatedAt = data.updatedAt && moment(data.updatedAt)

      this.applyDefaults()
      this.snapshot()
      return this
    }

    Channel.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    Channel.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    Channel.prototype.setType = function(type) {
      this.type = type
      this.name = this.getType().name
    }

    Channel.prototype.addReward = function() {
      this.reward = {
        isNew: true,
        spendTarget: new Money({
          amount: DefaultSpendTarget,
          currency: this.currency,
        }),
        currentSpend: new Money({ currency: this.currency }),
        notifyOnSpendTarget: false,
        disableChannelOnSpendTarget: false,
      }
    }

    Channel.prototype.removeReward = function() {
      this.reward = null
    }

    Channel.prototype.enableNotifications = function() {
      if (!this.notifyOnEvery) {
        this.notifyOnEvery = DefaultNotificationFrequency
      }
    }

    Channel.prototype.disableNotifications = function() {
      this.notifyOnEvery = null
    }

    Channel.prototype.canEditAllowMultipleResponses = function() {
      return !_.includes(FixedMultipleResponsesTypes, this.type)
    }

    Channel.prototype.addProductToTake = function(productId, otherChannelId) {
      if (!this.productsToTakeByChannel) {
        this.productsToTakeByChannel = []
      }
      var otherChannel = _.find(this.productsToTakeByChannel, {
        id: otherChannelId,
      })
      if (otherChannel) {
        otherChannel.productIds.push(productId)
      } else {
        this.productsToTakeByChannel.push({
          id: otherChannelId,
          productIds: [productId],
        })
      }
    }

    Channel.prototype.removeProductToTake = function(productId) {
      this.productsToTakeByChannel = _(this.productsToTakeByChannel)
        .map(function(channel) {
          _.pull(channel.productIds, productId)
          return channel
        })
        .filter(function(channel) {
          return channel.productIds.length
        })
        .value()
    }

    Channel.prototype.addPlaceToTake = function(placeId, otherChannelId) {
      if (!this.placesToTakeByChannel) {
        this.placesToTakeByChannel = []
      }
      var otherChannel = _.find(this.placesToTakeByChannel, {
        id: otherChannelId,
      })
      if (otherChannel) {
        otherChannel.placeIds.push(placeId)
      } else {
        this.placesToTakeByChannel.push({
          id: otherChannelId,
          placeIds: [placeId],
        })
      }
    }

    Channel.prototype.removePlaceToTake = function(placeId) {
      this.placesToTakeByChannel = _(this.placesToTakeByChannel)
        .map(function(channel) {
          _.pull(channel.placeIds, placeId)
          return channel
        })
        .filter(function(channel) {
          return channel.placeIds.length
        })
        .value()
    }

    Channel.prototype.validate = function() {
      var self = this
      var errors = []
      if (!this.name) {
        errors.push('Name is required')
      }
      if (_.includes([Type.CUSTOM, Type.EXTERNAL_PANEL], this.type)) {
        if (!this.responseLimit) {
          errors.push('Response Limit is required.')
        } else if (!_.isNumber(this.responseLimit) || this.responseLimit < 1) {
          errors.push('Response Limit amount must be a positive number.')
        }
      }
      if (this.type === Type.CUSTOM) {
        // keep in mind a blank fragment will result in one being generated
        if (this.link.fragment) {
          if (
            this.link.fragment.length < 2 ||
            this.link.fragment.length > 120
          ) {
            errors.push('Short URL must be between 2 and 120 characters')
          }
          if (!FragmentRegex.test(this.link.fragment)) {
            errors.push(
              'Short URL can only contain alphanumeric characters, periods, underscores and dashes'
            )
          }
        }
      }
      var willEnable =
        this.lastSnapshot && !this.lastSnapshot.enabled && this.enabled
      if (this.type === Type.PRODUCTS) {
        if ((willEnable || this.enabled) && !this.products.length) {
          errors.push('You must add at least one product')
        }
      }
      if (this.type === Type.PLACES) {
        if ((willEnable || this.enabled) && !this.places.length) {
          errors.push('You must add at least one place')
        }
      }
      if (this.type === Type.PANEL) {
        var valid = this.panel.validate()
        if (!valid) {
          this.panel.errors.forEach(function(error) {
            errors.push(error)
          })
        }
      }
      if (this.type === Type.EXTERNAL_PANEL) {
        if (!this.provider) {
          errors.push('Provider is required')
        }
        if (this.provider) {
          var userDefinedLinks =
            this.provider.linkMode === this.provider.LinkMode.USER_DEFINED
          if (userDefinedLinks && !this.provider.submitLink) {
            errors.push('Submit Link required')
          }
          if (userDefinedLinks && !this.provider.exitLink) {
            errors.push('Exit Link required')
          }
          if (userDefinedLinks && !this.provider.quotaLink) {
            errors.push('Overquota Link required')
          }
          if (userDefinedLinks && !this.provider.qualityExitLink) {
            errors.push('Quality Exit Link required')
          }

          _.each(this.provider.transforms, function(transform) {
            if (transform.type === transform.Types.FORWARD_VALUE) {
              if (!self.providerValues.get(transform.id)) {
                errors.push('Value ' + transform.name + ' is required')
              }
            }
          })
        }
      }
      if (this.reward) {
        var reward = this.reward
        if (!reward.spendTarget || !reward.spendTarget.amount) {
          errors.push('Spend target must be set')
        }
        // Can ignore if disabling the channel
        if (
          !this.enabled &&
          reward &&
          reward.spendTarget.amount <= reward.currentSpend.amount
        ) {
          errors.push('Spend target must be greater than current spend')
        }
      } else {
        if (this.lastSnapshot && this.lastSnapshot.reward) {
          errors.push('Cannot remove existing reward')
        }
      }
      if (_.isNumber(this.notifyOnEvery) && this.notifyOnEvery <= 0) {
        errors.push('Notification frequency must be greater than 0')
      }
      var incompleteVariables = _.some(this.injectedVariables, function(
        variable
      ) {
        return !variable.key || !variable.value
      })
      if (incompleteVariables) {
        errors.push('Injected variables must have a key and value')
      }
      if (this.billing.closeOnBudget && !this.billing.maxBudget.amount) {
        errors.push('Stop channel on cost requires a value')
      }

      // Disabled as this is incorrect. See https://engagementinnovation.slack.com/archives/C04AXA92V/p1576203314233700
      // var tagQuotaTotal = this.getTagQuotaTotal()
      // if (
      //   this.type === Type.PANEL &&
      //   tagQuotaTotal > 0 &&
      //   tagQuotaTotal > this.panel.requiredCompletes
      // ) {
      //   errors.push('Tag quota total is larger than responses needed')
      // }

      if (this.leastFills.length) {
        _.each(this.leastFills, function(leastFill) {
          leastFill.validate()
          switch (leastFill.errorType) {
            case LeastFill.ErrorTypes.INCOMPLETE:
              errors.push('Least fill is incomplete')
              break
            case LeastFill.ErrorTypes.INVALID_TAGS:
              errors.push('Least fill contain invalid tags')
              break
          }
        })
      }

      if (
        this.embedData.enabled &&
        !this.embedData.validate(this.redirects.enabled)
      ) {
        errors = _.concat(errors, this.embedData.errors)
      }

      if (errors.length) {
        this.errors = errors
        return false
      }
      this.errors = null
      return true
    }

    Channel.prototype.copy = function(channel) {
      this.deserialize(channel.serialize())
    }

    Channel.prototype.clone = function() {
      var channel = new Channel().deserialize(this.serialize())
      channel.setActiveTags(this.getActiveTags())
      return channel
    }

    Channel.prototype.getType = function() {
      return _.find(Channel.types, { value: this.type })
    }

    Channel.prototype.canSave = function() {
      if (this.type === this.Type.PANEL) {
        // LAUNCHED only updates supported fields
        return _.includes(
          ['NEW', 'REJECTED', 'PROVISIONED', 'LAUNCHED'],
          this.panel.state
        )
      }
      return true
    }

    Channel.prototype.canEdit = function() {
      if (this.type === this.Type.PANEL) {
        return _.includes(['PROVISIONED', 'REJECTED'], this.panel.state)
      }
      return true
    }

    Channel.prototype.canEnable = function() {
      if (this.isNew) return false
      if (this.type === this.Type.PANEL && this.panel.state === 'CANCELLED')
        return false
      if (
        this.type === this.Type.PANEL &&
        this.panel.state === 'AWAITING_CLIENT_APPROVAL'
      )
        return true
      return !this.enabled
    }

    Channel.prototype.canDisable = function() {
      if (this.isNew || this.isEnabling) return false
      if (
        this.type === this.Type.PANEL &&
        _.includes(
          ['AWAITING_CLIENT_APPROVAL', 'QA_APPROVED'],
          this.panel.state
        )
      )
        return false
      return this.enabled
    }

    Channel.prototype.canRemove = function() {
      return !this.isNew && !this.enabled && !this.responseCount
    }

    Channel.prototype.sendsTags = function() {
      return (
        this.type === Type.CUSTOM &&
        _.includes(
          [ForwardTagsRole.SEND, ForwardTagsRole.RECEIVE_AND_SEND],
          this.forwardTags.role
        )
      )
    }

    Channel.prototype.receivesTags = function() {
      return (
        this.type === Type.CUSTOM &&
        _.includes(
          [ForwardTagsRole.RECEIVE, ForwardTagsRole.RECEIVE_AND_SEND],
          this.forwardTags.role
        )
      )
    }

    // with Redirects on, a sending channel sets or removes the tags param on the
    // Submit, Exit and Quota links when the respondent leaves, replacing what
    // was there
    Channel.prototype.replacesEmbedDataTags = function() {
      if (!this.sendsTags() || !this.redirects.enabled) return false
      if (!this.embedData.enabled) return false
      return _.some(this.embedData.params, function(param) {
        return (param.forwardName || param.name) === FORWARD_TAGS_PARAM
      })
    }

    Channel.prototype.replacesRedirectTags = function() {
      if (!this.sendsTags() || !this.redirects.enabled) return false
      var redirects = this.redirects
      return _.some(['submitLink', 'exitLink', 'quotaLink'], function(key) {
        try {
          var url = new URL(gUrl.fullyForm(redirects[key]))
          return url.searchParams.has(FORWARD_TAGS_PARAM)
        } catch (err) {
          return false
        }
      })
    }

    Channel.prototype.usesPanel = function() {
      return this.type === this.Type.PANEL
    }

    Channel.prototype.isManaged = function() {
      return this.usesPanel()
        ? !this.consumesCredit && !this.isCharged
        : !this.consumesCredit
    }

    Channel.prototype.setActiveTags = function(activeTagNames) {
      var self = this
      self.tags.forEach(function(tag) {
        tag.active = false
      })
      _.each(activeTagNames, function(name) {
        var tag = _.find(self.tags, { name: name })
        if (tag) {
          tag.active = true
        } else {
          self.tags.push({
            name: name,
            count: 0,
            quota: null,
            active: true,
          })
        }
      })
      // console.log(
      //   'TAGS: Channel.setActiveTags',
      //   _.cloneDeep(activeTagNames),
      //   _.cloneDeep(this.tags),
      //   { tagQuotasEnabled: self.tagQuotasEnabled }
      // )
    }

    Channel.prototype.getActiveTags = function() {
      return _(this.tags)
        .filter({ active: true })
        .map('name')
        .value()
    }

    Channel.prototype.getTagQuotaTotal = function() {
      var total = _.sumBy(this.tags, 'quota') || 0
      if (!this.tagQuotasEnabled) total = 0
      // console.log('TAGS: Channel.getTagQuotaTotal', total)
      return total
    }

    Channel.prototype.hasActiveTags = function() {
      var bool = _.some(this.tags, { active: true })
      // console.log('TAGS: Channel.hasActiveTags', bool)
      return bool
    }

    Channel.prototype.hasActiveTagQuotas = function() {
      var bool = _.some(this.tags, function(tag) {
        return _.isNumber(tag.quota) && tag.active
      })
      // console.log('TAGS: Channel.hasTagsWithQuotas', bool)
      return bool
    }

    Channel.prototype.getTagQuotaGroups = function(survey) {
      var groups = {
        complete: [],
        incomplete: [],
      }
      if (this.tagQuotasEnabled) {
        _.each(this.tags, function(tag) {
          if (!_.isNumber(tag.quota)) return // unlimited quota
          if (tag.count >= tag.quota) {
            groups.complete.push(tag.name)
          } else {
            groups.incomplete.push(tag.name)
          }
        })
      } else if (this.usesGlobalTagQuotas(survey)) {
        var tagQuotas = survey.data.tagQuotaSettings.tagQuotas || {}
        var tagCounts = survey.tagCounts || {}
        _.each(this.tags, function(tag) {
          var quota = tagQuotas[tag.name]
          if (!_.isNumber(quota)) return // unlimited quota
          var count = tagCounts[tag.name] || 0
          if (count >= quota) {
            groups.complete.push(tag.name)
          } else {
            groups.incomplete.push(tag.name)
          }
        })
      }
      return groups
    }

    Channel.prototype.usesGlobalTagQuotas = function(survey) {
      var tagQuotaSettings = _.isPlainObject(survey.data.tagQuotaSettings)
        ? survey.data.tagQuotaSettings
        : {}
      if (!tagQuotaSettings.enabled) {
        return false
      }

      var self = this
      var QuotasTypes = TagQuotaSettings.Types
      switch (tagQuotaSettings.type) {
        case QuotasTypes.ALL:
          return true
        case QuotasTypes.ANY:
          return _.includes(tagQuotaSettings.channelIds, self.id)
        case QuotasTypes.NONE:
          return false
      }
    }

    Channel.prototype.getTagCounts = function() {
      var tagCounts = {}
      _.each(this.tags, function(tag) {
        tagCounts[tag.name] = tag.count
      })
      return tagCounts
    }

    Channel.prototype.getStatus = function(isSSR) {
      if (this.isNew) return { label: 'New', color: null }
      if (this.type === this.Type.PANEL) {
        // if (!this.enabled) return { label: 'Inactive', color: null }
        switch (this.panel.state) {
          case 'PROVISIONED':
            return { label: 'Inactive', color: null }
          case 'CANCELLED':
            return { label: 'Cancelled', color: null }
          case 'REJECTED':
            return isSSR
              ? { label: 'In Review [SSR: Rejected]', color: 'red' }
              : { label: 'In Review', color: 'green' }
          case 'AWAITING_CLIENT_APPROVAL':
            return { label: 'Awaiting your approval', color: 'orange' }
          case 'AWAITING_APPROVAL':
          case 'QA_APPROVED':
            return { label: 'Awaiting Approval', color: 'orange' }
          case 'LAUNCHED':
            return { label: 'Active', color: 'green' }
          case 'PAUSED':
            return { label: 'Paused', color: 'orange' }
          case 'CLOSED':
          case 'INVOICED':
            return { label: 'Completed', color: null }
        }
      } else {
        return this.enabled
          ? { label: 'Active', color: 'green' }
          : { label: 'Inactive', color: null }
      }
    }

    Channel.prototype.getShareableLink = function(sharedBy) {
      var url = configService.getSubscriberPortalUrl(
        '/channel-stats/' + this.id
      )
      if (sharedBy) {
        url += '?sharedBy=' + sharedBy
      }
      return url
    }

    return Channel
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "$rootScope", "glAuthService", "glDialog", "glAnalytics", "Channel", "linkService", "panelService", "audienceChannelsResource"];
  angular.module('glow.components').service('channelService', Service)

  function Service(
    $q,
    $rootScope,
    glAuthService,
    glDialog,
    glAnalytics,
    Channel,
    linkService,
    panelService,
    audienceChannelsResource
  ) {
    var getCurrency = function() {
      return 'AUD'
    }
    var Policy = {
      CACHE_ONLY: 'cache-only',
      NETWORK_ONLY: 'network-only',
      CACHE_THEN_NETWORK: 'cache-then-network',
    }
    var cache = {
      byId: {
        // <channelId>: <Channel>
      },
      bySurvey: {
        // <surveyId>: [<Channel>]
      },
      byOwner: {
        // <ownerId>: [<Channel>]
      },
      byList: {
        // <optionsHash>: [<Channel>]
      },
    }

    $rootScope.$on(glAuthService.Events.USER_CHANGE, resetCache)

    return {
      setCurrencyGetter: setCurrencyGetter,
      instantiate: instantiate,
      get: get,
      getBySurvey: getBySurvey,
      getByOwner: getByOwner,
      getByProduct: getByProduct,
      getByPlace: getByPlace,
      list: list,
      save: save,
      enable: enable,
      disable: disable,
      remove: remove,
      disableSurveyChannels: disableSurveyChannels,
      showPicker: showPicker,
      confirmCharges: confirmCharges,
      confirmReward: confirmReward,
      showRewardInfo: showRewardInfo,
      getTypes: getTypes,
      getChannelName: getChannelName,
      Types: Channel.Type,
      Policy: Policy,
    }

    function setCurrencyGetter(getter) {
      getCurrency = getter
    }

    function instantiate() {
      return new Channel(getCurrency())
    }

    function get(channelId, callback, options) {
      return getByConfig({
        key: channelId,
        request: audienceChannelsResource.get,
        params: { id: channelId },
        callback: callback,
        options: options,
      })
    }

    function getBySurvey(surveyId, callback, options) {
      return getByConfig({
        groupCache: cache.bySurvey,
        key: surveyId,
        request: audienceChannelsResource.getBySurvey,
        params: { surveyId: surveyId },
        callback: callback,
        options: options,
      })
    }

    function getByOwner(ownerId, callback, options) {
      return getByConfig({
        groupCache: cache.byOwner,
        key: ownerId,
        request: audienceChannelsResource.getBySubscriber,
        params: { subscriberId: ownerId },
        callback: callback,
        options: options,
      })
    }

    function list(params, callback, options) {
      return getByConfig({
        groupCache: cache.byList,
        key: JSON.stringify(params),
        request: audienceChannelsResource.list,
        params: params,
        callback: callback,
        options: options,
      })
    }

    function getByProduct(productId) {
      return $q(function(resolve, reject) {
        audienceChannelsResource
          .getByProduct({ productId: productId })
          .success(function(channel) {
            resolve(new Channel(getCurrency()).deserialize(channel))
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function getByPlace(placeId) {
      return $q(function(resolve, reject) {
        audienceChannelsResource
          .getByPlace({ placeId: placeId })
          .success(function(channel) {
            resolve(new Channel(getCurrency()).deserialize(channel))
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function getByConfig(config) {
      return $q(function(resolve, reject) {
        var groupCache = config.groupCache
        var key = config.key
        var request = config.request
        var params = config.params
        var callback = config.callback || angular.noop
        var options = _.defaults({}, config.options, {
          policy: Policy.CACHE_THEN_NETWORK,
          token: null,
        })

        var result
        if (groupCache) {
          if (!groupCache[key]) {
            groupCache[key] = []
          }
          result = groupCache[key]
        } else {
          result = cache.byId[key]
        }

        // initial callback

        if (options.policy === Policy.CACHE_ONLY) {
          callback(result, false, null)
          return resolve(result)
        } else if (options.policy === Policy.CACHE_THEN_NETWORK) {
          callback(result, true, null)
        } else if (options.policy === Policy.NETWORK_ONLY) {
          result = groupCache ? [] : null
          callback(result, true, null)
        }

        // network callback

        if (
          options.policy === Policy.CACHE_THEN_NETWORK ||
          options.policy === Policy.NETWORK_ONLY
        ) {
          // fetch from server
          params.token = options.token

          // only work for endpoint that has no paginator
          if (!params.filter && _.isBoolean(options.isArchived)) {
            params.isArchived = options.isArchived
          }

          request(params)
            .success(function(x, response) {
              if (!_.isArray(response)) {
                response = [response]
              }

              populatePanels(response).then(function() {
                lazyMigrate(response)

                // convert to factory instances
                var newChannels = _.map(response, function(newChannel) {
                  return new Channel(getCurrency()).deserialize(newChannel)
                })

                // update global cache
                _.each(newChannels, function(newChannel) {
                  if (cache.byId[newChannel.id]) {
                    cache.byId[newChannel.id].copy(newChannel)
                  } else {
                    cache.byId[newChannel.id] = newChannel
                  }
                })

                if (groupCache) {
                  // order
                  newChannels = _.orderBy(
                    newChannels,
                    function(channel) {
                      return channel.createdAt && channel.createdAt.unix()
                    },
                    'desc'
                  )
                  // repopulate group cache
                  result = groupCache[key]
                  _.remove(result)
                  _.each(newChannels, function(newChannel) {
                    result.push(newChannel)
                  })
                } else {
                  result = newChannels[0]
                }

                callback(result, false, null)
                resolve(result)
              })
            })
            .error(function(error) {
              callback(result, false, true)
              reject(error)
            })
        }
      })
    }

    function populatePanels(channelsData) {
      var promises = _.chain(channelsData)
        .filter({ type: Channel.Type.PANEL })
        .map(function(channelData) {
          return panelService
            .getRaw(channelData.id)
            .then(function(panel) {
              channelData.panel = panel
            })
            .catch(function() {
              // This shouldn't happen but if it does
              // then we don't want it to fail.
              // I saw this happen when trying to add a product
              // to a channel
            })
        })
        .value()
      return $q.all(promises)
    }

    function lazyMigrate(channelsData) {
      _.each(channelsData, function(data) {
        data.data = _.isPlainObject(data.data) ? data.data : {}

        if (!data.panel) return
        // pre Panel Targeting lazy migration
        if (!data.data.targeting) data.data.targeting = {}
        if (!_.isBoolean(data.data.targeting.enabled)) {
          var filters = data.panel.lineItems[0].quotaPlan.filters
          var quotaGroups = data.panel.lineItems[0].quotaPlan.quotaGroups
          // before `Panel Targeting` existed, panel with filters was "custom"
          // before `Panel Targeting` existed, panel with quotaGroups was "repsample"
          // it wasn't possible to have both filters and quotaGroups before this
          // enable targeting when either filter or quotaGroups exist
          if (
            (filters && filters.length) ||
            (quotaGroups && quotaGroups.length)
          ) {
            data.data.targeting.enabled = true
          }
        }
        // with the new Panel Targeting Presets, representative/repsample is replaced with a template from Dynata API
        if (data.data.targeting.enabled && data.data.targeting.representative) {
          var country = data.panel.lineItems[0].countryISOCode
          var language = data.panel.lineItems[0].languageISOCode
          var templateIdMappings = panelService.getTemplateIdMappings()
          var key = country + '/' + language
          data.data.targeting.presetId = templateIdMappings[key] || null
        }
      })
    }

    function removeProductsFromChannel(channelId, productIds) {
      return get(channelId, null, { policy: Policy.NETWORK_ONLY }) // Channel may be on other survey
        .then(function(channel) {
          channel.products = _.pullAll(channel.products, productIds)
          return save(channel)
        })
    }

    function releaseProductsForChannel(channel) {
      if (
        !channel.productsToTakeByChannel ||
        !channel.productsToTakeByChannel.length
      ) {
        return $q.resolve(channel)
      }
      var promises = _.map(channel.productsToTakeByChannel, function(
        otherChannel
      ) {
        return removeProductsFromChannel(
          otherChannel.id,
          otherChannel.productIds
        ).then(function() {
          // Successfully removed so pop off the list
          _.remove(channel.productsToTakeByChannel, otherChannel)
        })
      })
      return $q.all(promises).then(function() {
        return channel
      })
    }

    function removePlacesFromChannel(channelId, placeIds) {
      return get(channelId, null, { policy: Policy.NETWORK_ONLY }) // Channel may be on other survey
        .then(function(channel) {
          channel.places = _.pullAll(channel.places, placeIds)
          return save(channel)
        })
    }

    function releasePlacesForChannel(channel) {
      if (
        !channel.placesToTakeByChannel ||
        !channel.placesToTakeByChannel.length
      ) {
        return $q.resolve(channel)
      }
      var promises = _.map(channel.placesToTakeByChannel, function(
        otherChannel
      ) {
        return removePlacesFromChannel(
          otherChannel.id,
          otherChannel.placeIds
        ).then(function() {
          // Successfully removed so pop off the list
          _.remove(channel.placesToTakeByChannel, otherChannel)
        })
      })
      return $q.all(promises).then(function() {
        return channel
      })
    }

    function save(channel) {
      var self = this
      if (!channel.validate()) {
        return $q.reject()
      }
      channel.error = null
      channel.isSaving = true
      var persist = channel.isNew ? create : update
      return releaseProductsForChannel(channel)
        .then(releasePlacesForChannel)
        .then(persist)
        .then(function() {
          return self.get(channel.id).then(function(updatedChannel) {
            upsert(updatedChannel)
          })
        })
        .finally(function() {
          channel.isSaving = false
        })
    }

    function create(channel) {
      function createPanel() {
        if (channel.type !== Channel.Type.PANEL) return $q.resolve()
        return panelService.save(channel.panel)
      }
      function createLink() {
        return linkService.create(channel.link).catch(function(error) {
          if (error.status === 409) {
            return $q.reject({
              name: 'LinkTaken',
              message:
                'That link has already been taken (' +
                channel.link.fragment +
                ')',
            })
          } else {
            return $q.reject({
              name: 'LinkError',
              message: 'Error creating link',
            })
          }
        })
      }
      function createChannel() {
        return $q(function(resolve, reject) {
          audienceChannelsResource
            .create(channel.serialize())
            .success(function(response) {
              channel.isNew = false
              channel.id = response.id
              upsert(channel)
              resolve(channel)
              glAnalytics.track(
                'channel',
                'create',
                channel.id + ' - ' + channel.name
              )
              $rootScope.$broadcast(Channel.Events.CREATED, channel)
            })
            .error(function() {
              reject({
                name: 'ChannelError',
                message: 'Error creating channel',
              })
            })
        })
      }
      prepare(channel)
      return createPanel()
        .then(createLink)
        .then(createChannel)
    }

    function update(channel) {
      function updatePanel() {
        if (channel.type !== Channel.Type.PANEL) return $q.resolve()
        if (
          _.includes(
            ['PROVISIONED', 'REJECTED', 'LAUNCHED'],
            channel.panel.state
          )
        ) {
          // LAUNCHED only updates supported fields
          return panelService.save(channel.panel)
        }
        return $q.resolve()
      }
      function updateChannel() {
        return $q(function(resolve, reject) {
          audienceChannelsResource
            .update(channel.serialize())
            .success(function() {
              cache.byId[channel.id] = channel
              upsert(channel)
              resolve(channel)
              glAnalytics.track(
                'channel',
                'update',
                channel.id + ' - ' + channel.name
              )
            })
            .error(function() {
              channel.error = "Couldn't update channel"
              reject()
            })
        })
      }
      prepare(channel)
      return updatePanel().then(updateChannel)
    }

    function remove(channel) {
      // we don't have endpoint to remove a channel, instead we update
      // the channel to archived and make sure it's removed on GET
      var data = channel.serialize()
      data.isArchived = true
      return $q(function(resolve, reject) {
        audienceChannelsResource
          .update(data)
          .success(function() {
            // remove from cache
            delete cache.byId[channel.id]
            _.remove(cache.bySurvey[channel.survey.id], { id: channel.id })
            _.remove(cache.byOwner[channel.ownerId], { id: channel.id })
            resolve()
            glAnalytics.track(
              'channel',
              'remove',
              channel.id + ' - ' + channel.name
            )
          })
          .error(function() {
            channel.error = "Couldn't remove channel"
            reject()
          })
      })
    }

    function prepare(channel) {
      if (channel.type === Channel.Type.PANEL) {
        if (!channel.targeting.enabled) {
          // when targeting is disabled, remove presetId and targets
          channel.targeting.presetId = null
          _.remove(channel.panel.targets)
        }
      }
    }

    function upsert(channel) {
      channel = channel.clone()
      var surveyChannels = cache.bySurvey[channel.survey.id]
      // Channl was most likely updated as a side-effect of another operation so nothing to upsert to
      if (!surveyChannels) {
        return
      }
      var index = _.findIndex(surveyChannels, { id: channel.id })
      if (index !== -1) {
        surveyChannels[index] = channel
      } else {
        surveyChannels.unshift(channel)
      }
      // NOTE: upsert can't add to the byOwner group-cache
      // because channels have no data to show this.
      // We also cant' depend on subscriberService because this
      // service is used by the user-portal.
    }

    function disable(channel) {
      return $q(function(resolve, reject) {
        if (!channel.enabled) {
          return resolve()
        }
        if (!channel.validate()) {
          channel.error = "Couldn't disable channel"
          return reject()
        }
        channel.isDisabling = true
        channel.enabled = false
        return disablePanel(channel).then(function() {
          return update(channel)
            .then(function() {
              glAnalytics.track(
                'channel',
                'disable',
                channel.id + ' - ' + channel.name
              )
              $rootScope.$broadcast(Channel.Events.DISABLED, channel)
              resolve()
            })
            .catch(function() {
              channel.enabled = true
              channel.error = "Couldn't disable channel"
              reject()
            })
            .finally(function() {
              channel.isDisabling = false
            })
        })
      })
    }

    function disablePanel(channel) {
      if (channel.type !== channel.Type.PANEL) return $q.resolve()
      var origState = channel.panel.state
      channel.panel.state = 'CANCELLED'
      return panelService.close(channel.panel).catch(function() {
        channel.panel.state = origState
      })
    }

    function enable(channel) {
      function checkPanelFeasibility() {
        if (channel.type !== Channel.Type.PANEL) return $q.resolve()
        return panelService
          .awaitFeasibility(channel.panel)
          .then(function(feasibility) {
            if (!feasibility.feasible) {
              return $q.reject({
                name: 'PanelNotFeasible',
                message:
                  'Cannot fulfill ' +
                  channel.panel.requiredCompletes +
                  ' responses. Only ' +
                  feasibility.totalCount +
                  ' meet your requirements.',
              })
            }
          })
      }
      function buyPanel() {
        if (channel.type !== Channel.Type.PANEL) return $q.resolve()
        if (channel.panel.state === 'AWAITING_CLIENT_APPROVAL') {
          return panelService.acceptReprice(channel.panel)
        }
        return panelService.buy(channel.panel)
      }
      function enableChannel() {
        if (wasAlreadyEnabled) return $q.resolve()
        return update(channel).then(function() {
          glAnalytics.track(
            'channel',
            'enable',
            channel.id + ' - ' + channel.name
          )
          $rootScope.$broadcast(Channel.Events.ENABLED, channel)
        })
      }
      var wasAlreadyEnabled = !!channel.enabled
      channel.enabled = true
      if (!channel.validate()) {
        channel.error = "Couldn't enable channel"
        channel.enabled = false
        return $q.reject()
      }
      channel.isEnabling = true
      return checkPanelFeasibility()
        .then(buyPanel)
        .then(enableChannel)
        .catch(function(error) {
          channel.enabled = false
          if (error && error.name === 'PanelNotFeasible') {
            channel.error = error.message
          } else {
            channel.error = "Couldn't enable channel"
          }
          return $q.reject()
        })
        .finally(function() {
          channel.isEnabling = false
        })
    }

    function disableSurveyChannels(surveyId, ownerId) {
      return $q(function(resolve, reject) {
        audienceChannelsResource
          .disableBySurvey({ surveyId: surveyId, ownerId: ownerId })
          .success(function() {
            // set cached channels to disabled
            _.each(cache.bySurvey[surveyId], function(channel) {
              channel.enabled = false
            })
            resolve()
          })
          .error(reject)
      })
    }

    function showPicker(options) {
      options = options || {}
      var channel
      if (!options.surveyId) {
        throw new Error('New channels require a surveyId')
      }
      channel = instantiate()
      channel.survey.id = options.surveyId
      // prettier-ignore
      var template = [
        '<gl-dialog class="channel-picker__dialog">',
          '<channel-picker ',
            'channel="channel"',
            'on-done="dialog.close($channel)" ',
            'on-close="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          channel: channel,
        },
      })
    }

    function confirmCharges(channel) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="channel-confirm-charges__dialog">',
          '<g-dialog-header ',
            'title="Review Channel Configuration" ',
            'on-close="dialog.cancel()"',
          '></g-dialog-header>',
          '<channel-confirm-charges ',
            'channel="channel" ',
            'on-confirm="dialog.close()" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          channel: channel,
        },
      })
    }

    function confirmReward(channel, survey) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="channel-confirm-reward__dialog">',
          '<g-dialog-header ',
            'title="Confirm Rewards Options" ',
            'on-close="dialog.cancel()"',
          '></g-dialog-header>',
          '<channel-confirm-reward ',
            'channel="channel" ',
            'survey="survey" ',
            'on-confirm="dialog.close()" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          channel: channel,
          survey: survey,
        },
      })
    }

    function showRewardInfo(options) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="channel-reward-info__dialog">',
          '<g-dialog-header ',
            'title="Rewards" ',
            'on-close="dialog.cancel()"',
            '></g-dialog-header>',
          '<channel-reward-info ',
            'survey="survey" ',
          '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          survey: options.survey,
        },
      })
    }

    function resetCache() {
      cache.byId = {}
      cache.bySurvey = {}
      cache.byOwner = {}
    }

    function getTypes() {
      return Channel.types
    }

    function getChannelName(type) {
      return _.find(Channel.types, { value: type }).name
    }
  }
})()

/* globals copyToClipboard */
;(function() {
  'use strict'

  Service.$inject = ["glToast"];
  angular.module('glow.services').factory('clipboardService', Service)

  /* @ngInject */
  function Service(glToast) {
    var DefaultOptions = {
      showToast: true,
      toastMessage: 'Copied to clipboard',
    }

    // uses the copy-to-clipboard npm package

    return {
      copy: copy,
    }

    function copy(data, options) {
      options = _.defaults({}, options, DefaultOptions)
      copyToClipboard(data)
      if (options.showToast) {
        glToast.show(options.toastMessage)
      }
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.services').factory('cloudinaryService', Service)

  /* @ngInject */
  function Service() {
    var EXT_REGEX = /\.[^/.]+$/

    return {
      optimize: optimize,
      format: format,
      resize: resize,
      transform: transform,
      isCloudinaryUrl: isCloudinaryUrl,
    }

    function optimize(url) {
      if (!isCloudinaryUrl(url)) {
        return url
      }
      var transforms = []
      transforms.push('f_auto') // https://cloudinary.com/documentation/image_transformation_reference#fetch_format_parameter
      transforms.push('q_auto') // https://cloudinary.com/documentation/image_transformation_reference#quality_parameter
      transforms.push('w_2000') // https://cloudinary.com/documentation/image_transformation_reference#width_parameter
      transforms.push('c_limit') // https://cloudinary.com/documentation/image_transformation_reference#crop_parameter
      transforms = transforms.join(',')
      var optimizedUrl = url.replace('upload/', 'upload/' + transforms + '/')
      return optimizedUrl
    }

    function resize(url, width, height) {
      if (!isCloudinaryUrl(url)) {
        return url
      }
      if (!width && !height) {
        return url
      }
      var transforms = []
      if (width) {
        transforms.push('w_' + width)
      }
      if (height) {
        transforms.push('h_' + height)
      }
      transforms = transforms.join(',')
      var resizedUrl = url.replace('upload/', 'upload/' + transforms + '/')
      return resizedUrl
    }

    function format(url, ext) {
      if (!isCloudinaryUrl(url)) {
        return url
      }
      var match = url.match(EXT_REGEX)
      if (!match) return url
      if (match[0].length > 4) return url // highly unlikely that's an extension O.o
      return url.replace(EXT_REGEX, '.' + ext)
    }

    function transform(url, mWidth, ext) {
      return resize(format(url, ext), mWidth)
    }

    function isCloudinaryUrl(url) {
      // TODO: write a simple regex to check a bit more
      return _.includes(url, 'cloudinary.com') && _.includes(url, 'upload/')
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('ContentGroup', Factory)

  function Factory() {
    var Defaults = {
      log: [],
      tags: [],
      data: {},
    }

    function ContentGroup(options) {
      _.defaults(this, options, Defaults)
    }

    ContentGroup.prototype.deserialize = function(data) {
      this.id = data.id
      this.name = data.name
      this.description = data.description
      this.imageUrl = data.imageUrl
      this.log = data.log
      this.tags = data.tags
      this.createdAt = data.createdAt && moment(data.createdAt)
      this.updatedAt = data.updatedAt && moment(data.updatedAt)
      this.data = _.isPlainObject(data.data) ? data.data : {}
      return this
    }

    ContentGroup.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.name = this.name
      data.description = this.description
      data.imageUrl = this.imageUrl
      data.log = this.log
      data.tags = this.tags
      data.createdAt = this.createdAt && this.createdAt.toISOString()
      data.updatedAt = this.updatedAt && this.updatedAt.toISOString()
      data.data = this.data
      return data
    }

    ContentGroup.prototype.isNew = function() {
      return !this.id
    }

    ContentGroup.prototype.isValid = function() {
      var errors = []
      if (!this.name) {
        errors.push('Name is required')
      }
      if (errors.length) {
        this.errors = errors
        return false
      }
      return true
    }

    return ContentGroup
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "contentGroupsResource", "ContentGroup", "imageService"];
  angular.module('glow.components').service('contentGroupsService', Service)

  function Service($q, contentGroupsResource, ContentGroup, imageService) {
    return {
      search: search,
      get: get,
      save: save,
    }

    function search(options) {
      return $q(function(resolve, reject) {
        options = _.defaults(options, {
          top: 50,
          skip: 0,
          orderby: 'updatedAt desc',
          query: null,
          filters: [],
        })
        if (options.query) {
          options.filters.push('name regex /' + options.query + '/i')
          delete options.query
        }
        options.filter = options.filters.join(' and ')
        delete options.filters

        contentGroupsResource
          .get(options)
          .success(function(data) {
            var contentGroups = _.map(data, function(contentGroup) {
              return new ContentGroup().deserialize(contentGroup)
            })
            resolve(contentGroups)
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function get(id) {
      if (id === 'new') {
        return $q.resolve(new ContentGroup())
      }
      return $q(function(resolve, reject) {
        contentGroupsResource
          .get({ id: id })
          .success(function(data) {
            resolve(new ContentGroup().deserialize(data))
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function save(contentGroup) {
      return saveImage(contentGroup).then(function(contentGroup) {
        return contentGroup.isNew()
          ? create(contentGroup)
          : update(contentGroup)
      })
    }

    function saveImage(contentGroup) {
      return $q(function(resolve) {
        if (contentGroup.imageData) {
          imageService.create(contentGroup.imageData).then(function(url) {
            contentGroup.imageUrl = url
            contentGroup.imageData = undefined
            resolve(contentGroup)
          })
        } else {
          resolve(contentGroup)
        }
      })
    }

    function create(contentGroup) {
      return $q(function(resolve, reject) {
        contentGroupsResource
          .create(contentGroup.serialize())
          .success(function(x, response) {
            contentGroup.id = response.id
            resolve(contentGroup.id)
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function update(contentGroup) {
      return $q(function(resolve, reject) {
        contentGroupsResource
          .update(contentGroup.serialize())
          .success(function() {
            resolve()
          })
          .error(function(error) {
            reject(error)
          })
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils"];
  angular.module('glow.components').factory('CreditPromotion', Factory)

  function Factory(glUtils) {
    var SUBSCRIPTION_CODE_REGEX = new RegExp(
      '^' + glUtils.SubscriptionCodeValidation + '$'
    )

    var Statuses = {
      ACTIVE: 'active',
      PENDING: 'pending',
      EXHAUSTED: 'exhausted',
      EXPIRED: 'expired',
      DISABLED: 'disabled',
    }

    function CreditPromotion() {
      this.applyDefaults()
    }

    CreditPromotion.prototype.Statuses = CreditPromotion.Statuses = Statuses

    CreditPromotion.prototype.applyDefaults = function() {
      var now = moment()
      _.defaultsDeep(this, {
        id: null,
        subscriptionCode: null,
        name: null,
        description: null,
        imageUrl: null,
        duration: null,
        creditPortions: null,
        maxCredit: null,
        hubspotId: null,
        createdAt: now,
        updatedAt: now,

        status: null,

        // read only
        subscriberId: null,
        subscriberEmail: null,
        token: null,
        codePrefix: null,
        balance: null,
        totalBalance: null,
        totalAllocated: null,
        statusLog: [],
        expiresAt: null,
        createdById: null,
        createdByEmail: null,
        activatedAt: null,
      })
    }

    CreditPromotion.prototype.serialize = function() {
      var data = {}

      data.id = this.id
      data.subscriptionCode = this.subscriptionCode
      data.name = this.name
      data.description = this.description
      data.imageUrl = this.imageUrl
      data.duration = this.duration
      data.creditPortions = this.creditPortions
      data.maxCredit = this.maxCredit
      data.hubspotId = this.hubspotId
      data.createdAt = this.createdAt ? this.createdAt.toISOString() : null
      data.updatedAt = this.updatedAt ? this.updatedAt.toISOString() : null

      // status can only ever be updated to `disabled` from the FE
      data.status = this.status

      // read only
      data.subscriberId = this.subscriberId
      data.subscriberEmail = this.subscriberEmail
      data.token = this.token
      data.codePrefix = this.codePrefix
      data.balance = this.balance
      data.totalBalance = this.totalBalance
      data.totalAllocated = this.totalAllocated
      data.statusLog = this.statusLog
      data.expiresAt = this.expiresAt ? this.expiresAt.toISOString() : null
      data.createdByid = this.createdById
      data.createdByEmail = this.createdByEmail
      data.activatedAt = this.activatedAt
        ? this.activatedAt.toISOString()
        : null

      return data
    }

    CreditPromotion.prototype.deserialize = function(data) {
      this.id = data.id
      this.subscriptionCode = data.subscriptionCode
      this.name = data.name
      this.description = data.description
      this.imageUrl = data.imageUrl
      this.duration = data.duration
      this.creditPortions = data.creditPortions
      this.maxCredit = data.maxCredit
      this.hubspotId = data.hubspotId
      this.createdAt = data.createdAt ? moment(data.createdAt) : null
      this.updatedAt = data.updatedAt ? moment(data.updatedAt) : null

      // status can only ever be updated to `disabled` from the FE
      this.status = data.status

      // Read only
      this.subscriberId = data.subscriberId
      this.subscriberEmail = data.subscriberEmail
      this.token = data.token
      this.codePrefix = data.codePrefix
      this.balance = data.balance
      this.totalBalance = data.totalBalance
      this.totalAllocated = data.totalAllocated
      this.statusLog = data.statusLog
      this.createdById = data.createdById
      this.createdByEmail = data.createdByEmail
      this.activatedAt = data.activatedAt ? moment(data.activatedAt) : null
      this.expiresAt = data.expiresAt ? moment(data.expiresAt) : null

      this.applyDefaults()

      return this
    }

    CreditPromotion.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    CreditPromotion.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    CreditPromotion.prototype.validate = function() {
      var errors = []
      if (!this.subscriptionCode) {
        errors.push('Subscription Code is required')
      } else if (!this.isSubscriptionCodeValid()) {
        errors.push(
          'Subscription Code characters only accept: Upper or lower case letters, numbers, a hyphen or an underscore'
        )
      }

      if (!this.name) {
        errors.push('Name is required')
      }

      if (!this.description) {
        errors.push('Description is required')
      }

      if (!this.maxCredit) {
        errors.push('Maximum Credit is required')
      }

      if (!this.creditPortions) {
        errors.push('Portion Size is required')
      }

      if (errors.length) {
        this.errors = errors
        return false
      }

      this.errors = null
      return true
    }

    CreditPromotion.prototype.isSubscriptionCodeValid = function() {
      return SUBSCRIPTION_CODE_REGEX.test(this.subscriptionCode || '')
    }

    CreditPromotion.prototype.copy = function(promotion) {
      this.deserialize(promotion.serialize())
    }

    CreditPromotion.prototype.clone = function() {
      return new CreditPromotion().deserialize(this.serialize())
    }

    CreditPromotion.prototype.isNew = function() {
      return !this.id
    }

    CreditPromotion.prototype.isActive = function() {
      return this.status === this.Statuses.ACTIVE
    }

    CreditPromotion.prototype.isPending = function() {
      return this.status === this.Statuses.PENDING
    }

    CreditPromotion.prototype.isExhausted = function() {
      return this.status === this.Statuses.EXHAUSTED
    }

    CreditPromotion.prototype.isExpired = function() {
      return this.status === this.Statuses.EXPIRED
    }

    CreditPromotion.prototype.isDisabled = function() {
      return this.status === this.Statuses.DISABLED
    }

    return CreditPromotion
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "api", "glDialog", "CreditPromotion", "imageService"];
  angular.module('glow.components').service('creditPromotionService', Service)

  function Service($q, api, glDialog, CreditPromotion, imageService) {
    this.instantiate = instantiate
    this.get = get
    this.list = list
    this.save = save
    this.getByToken = getByToken
    this.activate = activate

    this.showThanksDialog = showThanksDialog

    function instantiate() {
      return new CreditPromotion()
    }

    function get(id) {
      return api.creditPromotions.get({ id: id }).then(function(resp) {
        var promotion = new CreditPromotion().deserialize(resp)
        promotion.snapshot()
        return promotion
      })
    }

    function getByToken(token) {
      return api.creditPromotions
        .getByToken({ token: token })
        .then(function(resp) {
          var promotion = new CreditPromotion().deserialize(resp)
          promotion.snapshot()
          return promotion
        })
    }

    function activate(token) {
      return api.creditPromotions.attemptActivation({ token: token })
    }

    function list(filter) {
      return api.creditPromotions.list({ filter: filter }).then(function(resp) {
        return resp.map(function(data) {
          var promotion = new CreditPromotion().deserialize(data)
          promotion.snapshot()
          return promotion
        })
      })
    }

    function save(promotion) {
      return saveImage(promotion).then(function(promotion) {
        var action = promotion.isNew() ? create : update
        return action(promotion).then(function() {
          promotion.snapshot()
        })
      })
    }

    function saveImage(promotion) {
      return $q(function(resolve) {
        if (promotion.imageData) {
          imageService.create(promotion.imageData).then(function(url) {
            promotion.imageUrl = url
            promotion.imageData = undefined
            resolve(promotion)
          })
        } else {
          resolve(promotion)
        }
      })
    }

    function create(promotion) {
      return api.creditPromotions
        .create(promotion.serialize())
        .then(function(resp) {
          promotion.id = resp.id
        })
    }

    function update(promotion) {
      return api.creditPromotions.update(promotion.serialize())
    }

    function showThanksDialog() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="credit-promotion-thanks-dialog__dialog">',
          '<credit-promotion-thanks-dialog',
            'on-done="dialog.close()"',
          '/>',
        '</gl-dialog>'
      ]
      return glDialog.show({
        template: template.join(' '),
        escapeToClose: true,
        clickOutsideToClose: true,
        locals: {},
      })
    }
  }
})()

;(function() {
  'use strict'

  credits.$inject = ["glUtils"];
  angular.module('glow.components').filter('credits', credits)

  /* @ngInject */
  function credits(glUtils) {
    return function(input, capitalize) {
      if (isNaN(input)) return input

      var number = parseFloat(input)
      var suffix = glUtils.numberSwitch(number, 'credit', 'credits')
      if (capitalize) {
        suffix = _.upperFirst(suffix)
      }
      var string = number.toLocaleString() + ' ' + suffix

      return string
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils"];
  angular.module('glow.components').factory('Crosstab', Factory)

  function Factory(glUtils) {
    function Crosstab(surveyId) {
      this.surveyId = surveyId
      this.uuid = glUtils.uuid() // draft crosstabs have no id, but we need one for ng-repeat tracking!
      this.applyDefaults()
    }

    Crosstab.prototype.applyDefaults = function() {
      var now = moment()
      _.defaultsDeep(this, {
        id: null,
        surveyId: null,
        name: null,
        filterSetId: null,
        crossFilterSetIds: [],
        primaryQuestionId: null,
        secondaryQuestionIds: [],
        // we store the counts shown in the crosstab table here.
        // generating data for the table requires multiple survey-report requests
        // so this is basically cached data.
        counts: {},
        // users may want to rename fields displayed on a crosstab table.
        // `renames` holds a mapping from questionId/choiceId to a custom label
        renames: {},
        // after the crosstab data has been generated from the survey-reports,
        // we copy over the survey.responseCount value into generatedAtResponseCount.
        // this is used to determine whether the generated data is out-of-date, and
        // shows a button to refresh the data.
        generatedAtResponseCount: null,
        // version is incremented every time the user makes a change to the crosstab.
        // the version value is used to invalidate the local cache when viewing a
        // crosstab, for ultimate performance.
        version: 0,
        order: null,
        createdAt: now,
        updatedAt: now,
      })
    }

    Crosstab.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.surveyId = this.surveyId
      data.data = {}
      data.data.name = this.name
      data.data.filterSetId = this.filterSetId
      data.data.crossFilterSetIds = this.crossFilterSetIds.slice()
      data.data.primaryQuestionId = this.primaryQuestionId
      data.data.secondaryQuestionIds = this.secondaryQuestionIds.slice()
      data.data.counts = _.cloneDeep(this.counts)
      data.data.renames = _.cloneDeep(this.renames)
      data.data.generatedAtResponseCount = this.generatedAtResponseCount
      data.data.version = this.version
      data.data.order = this.order
      data.createdAt = this.createdAt.toISOString()
      data.updatedAt = this.updatedAt.toISOString()
      return data
    }

    Crosstab.prototype.deserialize = function(data) {
      data.data = _.isPlainObject(data.data) ? data.data : {}
      this.id = data.id
      this.surveyId = data.surveyId
      this.name = data.data.name
      this.filterSetId = data.data.filterSetId
      this.crossFilterSetIds = data.data.crossFilterSetIds
      this.primaryQuestionId = data.data.primaryQuestionId
      this.secondaryQuestionIds = data.data.secondaryQuestionIds
      this.counts = _.isPlainObject(data.data.counts) ? data.data.counts : {}
      this.renames = _.isPlainObject(data.data.renames) ? data.data.renames : {}
      this.generatedAtResponseCount = data.data.generatedAtResponseCount
      this.version = data.data.version
      this.order = data.data.order
      this.createdAt = moment(data.createdAt)
      this.updatedAt = moment(data.updatedAt)
      this.applyDefaults()
      this.snapshot()
      return this
    }

    Crosstab.prototype.isGenerated = function() {
      return this.generatedAtResponseCount !== null
    }

    Crosstab.prototype.hasOldData = function(surveyResponseCount) {
      return (
        this.isGenerated() &&
        this.generatedAtResponseCount !== surveyResponseCount
      )
    }

    Crosstab.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    Crosstab.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    Crosstab.prototype.validate = function() {
      var errors = []
      if (!this.name) {
        errors.push('Name is required')
      }
      if (!this.primaryQuestionId) {
        errors.push('Primary question required')
      }
      if (!this.secondaryQuestionIds.length && !this.crossFilterSetIds.length) {
        errors.push('At least one cross filter or question required')
      }
      this.errors = errors.length ? errors : null
      return !errors.length
    }

    Crosstab.prototype.copy = function(crosstab) {
      this.deserialize(crosstab.serialize())
    }

    Crosstab.prototype.clone = function() {
      return new Crosstab().deserialize(this.serialize())
    }

    Crosstab.prototype.duplicate = function() {
      var dup = this.clone()
      dup.id = null
      dup.version = 0
      return dup
    }

    Crosstab.prototype.isNew = function() {
      return !this.id
    }

    return Crosstab
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "$http", "api", "glUtils", "glDialog", "configService", "Crosstab", "Question", "CSVExport"];
  angular.module('glow.components').service('crosstabService', Service)

  /* @ngInject */
  function Service(
    $q,
    $http,
    api,
    glUtils,
    glDialog,
    configService,
    Crosstab,
    Question,
    CSVExport
  ) {
    this.instantiate = instantiate

    this.save = save
    this.remove = remove
    this.getBySurvey = getBySurvey
    this.getById = getById

    this.showRenameDialog = showRenameDialog

    this.hasPrimaryAspect = hasPrimaryAspect
    this.hasPrimaryScore = hasPrimaryScore
    this.getPrimaryLabel = getPrimaryLabel
    this.getCrossFilterSetLabel = getCrossFilterSetLabel
    this.getSecondaryLabel = getSecondaryLabel
    this.getSecondaryItems = getSecondaryItems
    this.getCombinedSecondaryItems = getCombinedSecondaryItems
    this.getPrimaryItems = getPrimaryItems
    this.getCrossFilterSetCount = getCrossFilterSetCount
    this.getFilterSetTotal = getFilterSetTotal
    this.getFilterSetScore = getFilterSetScore
    this.getPrimaryItemCount = getPrimaryItemCount
    this.getPrimaryScore = getPrimaryScore
    this.getPrimaryTotal = getPrimaryTotal
    this.getCrossCount = getCrossCount
    this.getSecondaryItemTotal = getSecondaryItemTotal
    this.getSecondaryItemScore = getSecondaryItemScore
    this.getCountDisplay = getCountDisplay
    this.shouldAddScoreRow = shouldAddScoreRow
    this.exportCSV = exportCSV
    this.exportXLSX = exportXLSX
    this.exportWorkbook = exportWorkbook

    function instantiate(surveyId) {
      var crosstab = new Crosstab(surveyId)
      return crosstab
    }

    function save(crosstab) {
      var action = crosstab.isNew() ? create : update
      crosstab.version++
      return action(crosstab)
        .then(function() {
          crosstab.snapshot()
        })
        .catch(function(err) {
          crosstab.version--
          return $q.reject(err)
        })
    }

    function create(crosstab) {
      var data = crosstab.serialize()
      return api.crossTabs.create(data).then(function(resp) {
        crosstab.id = resp.id
      })
    }

    function update(crosstab) {
      var data = crosstab.serialize()
      return api.crossTabs.update(data)
    }

    function remove(crosstab) {
      return api.crossTabs.delete({ id: crosstab.id })
    }

    function getBySurvey(surveyId) {
      return api.crossTabs
        .getBySurvey({ surveyId: surveyId })
        .then(function(datas) {
          var crosstabs = _.map(datas, function(data) {
            return new Crosstab().deserialize(data)
          })
          return crosstabs
        })
    }

    function getById(crosstabId) {
      return api.crossTabs.get({ id: crosstabId }).then(function(data) {
        var crosstab = new Crosstab().deserialize(data)
        return crosstab
      })
    }

    function showRenameDialog(original, current) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="report-crosstab-renamer__dialog">',
          '<report-crosstab-renamer original="original" current="current" on-done="dialog.close($value)" on-cancel="dialog.cancel()"/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(' '),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          original: original,
          current: current,
        },
      }
      return glDialog.show(options)
    }

    function hasPrimaryAspect(crosstab, survey, getCached) {
      var key = 'hasPrimaryAspect-' + crosstab.primaryQuestionId
      function get() {
        var pQuestion = survey.getQuestion(crosstab.primaryQuestionId)
        return (
          pQuestion.isUsedAsMatrix() || pQuestion.isType(Question.Types.RANK)
        )
      }
      if (getCached) {
        return getCached(key, get)
      } else {
        return get()
      }
    }

    function hasPrimaryScore(crosstab, survey, getCached) {
      var key = 'hasPrimaryScore-' + crosstab.primaryQuestionId
      function get() {
        var pQuestion = survey.getQuestion(crosstab.primaryQuestionId)
        return pQuestion.isType(Question.Types.SCORE)
      }
      if (getCached) {
        return getCached(key, get)
      } else {
        return get()
      }
    }

    function getPrimaryLabel(crosstab, survey, getCached) {
      var key = 'primaryLabel-' + crosstab.primaryQuestionId
      function get() {
        var rename = crosstab.renames[key]
        return (
          rename ||
          survey
            .getQuestion(crosstab.primaryQuestionId)
            .getTitleLabel({ number: false })
        )
      }
      if (getCached) {
        return getCached(key, get)
      } else {
        return get()
      }
    }

    function getCrossFilterSetLabel(
      crosstab,
      filterSetGroup,
      filterSetId,
      getCached
    ) {
      var key = 'crossFilterSetLabel-' + filterSetId
      function get() {
        var rename = crosstab.renames[key]
        var filterSet = filterSetGroup.filterSets.find(function(filterSet) {
          return filterSet.id === filterSetId
        })
        return rename || filterSet ? filterSet.label : 'Unknown'
      }
      if (getCached) {
        return getCached(key, get)
      } else {
        return get()
      }
    }

    function getSecondaryLabel(crosstab, survey, questionId, getCached) {
      var key = 'secondaryLabel-' + questionId
      function get() {
        var rename = crosstab.renames[key]
        return (
          rename ||
          survey.getQuestion(questionId).getTitleLabel({ number: false })
        )
      }
      if (getCached) {
        return getCached(key, get)
      } else {
        return get()
      }
    }

    function getSecondaryItems(crosstab, survey, questionId, getCached) {
      var key = 'secondaryItems-' + questionId
      function get() {
        var question = survey.getQuestion(questionId)
        return question.getVisibleChoices().map(function(choice) {
          var renameKey = 'secondaryItemLabel-' + questionId + '-' + choice.id
          var rename = crosstab.renames[renameKey]
          return {
            id: choice.id,
            label: rename || choice.label,
            questionId: questionId,
          }
        })
      }
      if (getCached) {
        return getCached(key, get)
      } else {
        return get()
      }
    }

    function getCombinedSecondaryItems(crosstab, survey, getCached) {
      var key = 'combinedSecondaryItems'
      function get() {
        var items = []
        _.each(crosstab.secondaryQuestionIds, function(questionId) {
          _.each(
            getSecondaryItems(crosstab, survey, questionId, getCached),
            function(item) {
              items.push(item)
            }
          )
        })
        return items
      }
      if (getCached) {
        return getCached(key, get)
      } else {
        return get()
      }
    }

    function getPrimaryItems(crosstab, survey, getCached) {
      var key = 'primaryItems'
      function get() {
        var question = survey.getQuestion(crosstab.primaryQuestionId)
        var isMatrix = question.isUsedAsMatrix()
        var isRank = question.isType(Question.Types.RANK)
        var hasScore = question.isType(Question.Types.SCORE)
        var choices = question.getVisibleChoices()
        if (isMatrix) {
          var items = []
          var statements = question.getVisibleStatements()
          _.each(statements, function(statement) {
            _.each(choices, function(choice, index) {
              var renameKey = 'primaryItemLabel-' + choice.id
              var rename = crosstab.renames[renameKey]
              var item = {
                id: choice.id,
                label: rename || choice.label,
                aspect: {
                  id: statement.id,
                  label: statement.label,
                  span: hasScore ? choices.length + 1 : choices.length,
                  isFirst: index === 0,
                  isLast: index === choices.length - 1,
                },
              }
              items.push(item)
            })
          })
          return items
        } else if (isRank) {
          var items = []
          _.each(choices, function(choice, index) {
            _.times(question.getNumberOfRanks(), function(rankIndex) {
              var renameKey = 'primaryAspectLabel-' + choice.id
              var rename = crosstab.renames[renameKey]
              var item = {
                id: rankIndex + 1,
                label: 'Rank ' + (rankIndex + 1),
                aspect: {
                  id: choice.id,
                  label: rename || choice.label,
                  span: question.getNumberOfRanks(),
                  isFirst: rankIndex === 0,
                  isLast: rankIndex === question.getNumberOfRanks() - 1,
                },
              }
              items.push(item)
            })
          })
          return items
        } else {
          return choices.map(function(choice, index) {
            var renameKey = 'primaryItemLabel-' + choice.id
            var rename = crosstab.renames[renameKey]
            return {
              id: choice.id,
              label: rename || choice.label,
              aspect: null,
              isLast: index === choices.length - 1,
            }
          })
        }
      }
      if (getCached) {
        return getCached(key, get)
      } else {
        return get()
      }
    }

    function getCrossFilterSetCount(crosstab, pItem, filterSetId) {
      var aspectKey = pItem.aspect ? pItem.aspect.id + '|' : ''
      var key =
        'crossFilterSetCount-' + aspectKey + pItem.id + '|' + filterSetId
      return crosstab.counts[key]
    }

    function getFilterSetTotal(crosstab, filterSetId) {
      var key = 'crossFilterSetTotal-' + filterSetId
      return crosstab.counts[key]
    }

    function getFilterSetScore(crosstab, statementId, filterSetId) {
      var statementKey = statementId ? statementId + '-' : ''
      var key = 'crossFilterSetScore-' + statementKey + filterSetId
      return crosstab.counts[key]
    }

    function getPrimaryItemCount(crosstab, item) {
      var aspectKey = item.aspect ? item.aspect.id + '-' : ''
      var key = 'primaryItemCount-' + aspectKey + item.id
      return crosstab.counts[key]
    }

    function getPrimaryScore(crosstab, statementId) {
      var statementKey = statementId ? '-' + statementId : ''
      var key = 'primaryScore' + statementKey
      return crosstab.counts[key]
    }

    function getPrimaryTotal(crosstab) {
      var key = 'primaryTotal'
      return crosstab.counts[key]
    }

    function getCrossCount(crosstab, pItem, sItem) {
      var statementKey = pItem.aspect ? pItem.aspect.id + '|' : ''
      var key = 'crossCount|' + statementKey + pItem.id + '|' + sItem.id
      return crosstab.counts[key]
    }

    function getSecondaryItemTotal(crosstab, sItemId) {
      var key = 'secondaryItemTotal-' + sItemId
      return crosstab.counts[key]
    }

    function getSecondaryItemScore(crosstab, statementId, sItemId) {
      var statementKey = statementId ? statementId + '-' : ''
      var key = 'secondaryItemScore-' + statementKey + sItemId
      return crosstab.counts[key]
    }

    function getCountDisplay(count, absolute, unround) {
      // returns count as absolute or percent based on toggle
      if (!count) return '–'
      if (absolute) return count.total
      return unround ? count.percent + '%' : count.percent.toFixed(0) + '%'
    }

    function shouldAddScoreRow(pItem, crosstab, survey, getCached) {
      // check if score row should be added after pItem
      var hasScore = hasPrimaryScore(crosstab, survey, getCached)
      var isLastItem = pItem.aspect ? pItem.aspect.isLast : pItem.isLast
      return hasScore && isLastItem
    }

    function getExportRows(crosstab, survey, filterSetGroup, absolute, asXLSX) {
      var rows = []

      var topRow = ['', '']
      if (hasPrimaryAspect(crosstab, survey)) topRow.push('')
      topRow = _.concat(
        topRow,
        _.fill(new Array(crosstab.crossFilterSetIds.length), '')
      )

      var subRow = []
      subRow.push(getPrimaryLabel(crosstab, survey))
      if (hasPrimaryAspect(crosstab, survey)) subRow.push('')
      subRow.push('Total')
      _.each(crosstab.crossFilterSetIds, function(filterSetId) {
        subRow.push(
          getCrossFilterSetLabel(crosstab, filterSetGroup, filterSetId)
        )
      })

      if (asXLSX) {
        // switch topRow and subRow position
        // when generating XLSX, we need labels to be on top so that
        // it can be merge with the empty cell below it
        var temp = topRow.slice()
        topRow = subRow.slice()
        subRow = temp
      }

      _.each(crosstab.secondaryQuestionIds, function(sQuestionId) {
        var sQuestion = survey.getQuestion(sQuestionId)
        var sChoices = sQuestion.getVisibleChoices()
        sChoices.forEach(function(sChoice, idx) {
          topRow.push(
            idx === 0 ? getSecondaryLabel(crosstab, survey, sQuestionId) : ''
          )
        })
      })
      rows.push(topRow)

      getCombinedSecondaryItems(crosstab, survey).forEach(function(sItem) {
        subRow.push(sItem.label)
      })
      rows.push(subRow)

      _.each(getPrimaryItems(crosstab, survey), function(pItem) {
        var row = []
        if (pItem.aspect) {
          row.push(pItem.aspect.isFirst ? pItem.aspect.label : '')
        }
        row.push(pItem.label)
        row.push(
          getCountDisplay(getPrimaryItemCount(crosstab, pItem), absolute, true)
        )
        _.each(crosstab.crossFilterSetIds, function(filterSetId) {
          row.push(
            getCountDisplay(
              getCrossFilterSetCount(crosstab, pItem, filterSetId),
              absolute,
              true
            )
          )
        })
        getCombinedSecondaryItems(crosstab, survey).forEach(function(sItem) {
          row.push(
            getCountDisplay(
              getCrossCount(crosstab, pItem, sItem),
              absolute,
              true
            )
          )
        })
        rows.push(row)

        if (shouldAddScoreRow(pItem, crosstab, survey)) {
          var row = []
          if (pItem.aspect) {
            row.push('')
          }
          row.push('Score')
          row.push(getPrimaryScore(crosstab, pItem.aspect && pItem.aspect.id))
          _.each(crosstab.crossFilterSetIds, function(filterSetId) {
            row.push(
              getFilterSetScore(
                crosstab,
                pItem.aspect && pItem.aspect.id,
                filterSetId
              )
            )
          })
          getCombinedSecondaryItems(crosstab, survey).forEach(function(sItem) {
            row.push(
              getSecondaryItemScore(
                crosstab,
                pItem.aspect && pItem.aspect.id,
                sItem.id
              )
            )
          })
          rows.push(row)
        }
      })

      var baseRow = []
      baseRow.push('Base (n)')
      if (hasPrimaryAspect(crosstab, survey)) baseRow.push('')
      baseRow.push(getPrimaryTotal(crosstab))
      _.each(crosstab.crossFilterSetIds, function(filterSetId) {
        baseRow.push(getFilterSetTotal(crosstab, filterSetId))
      })
      getCombinedSecondaryItems(crosstab, survey).forEach(function(sItem) {
        baseRow.push(getSecondaryItemTotal(crosstab, sItem.id))
      })
      rows.push(baseRow)

      if (crosstab.filterSetId) {
        var filterSetLabel = getCrossFilterSetLabel(
          crosstab,
          filterSetGroup,
          crosstab.filterSetId
        )
        rows.push([
          '* This crosstab is pre-filtered using the filter "' +
            filterSetLabel +
            '"',
        ])
      }
      return rows
    }

    function getMerges(rows, crosstab, survey) {
      /**
       * Merges is array of range objects corresponding to the merged cells in the worksheet.
       * Merge object example : { s: {r:0, c:0}, e: {r:0, c:1} }
       * s: start of range (cell position)
       * e: end of range (cell position)
       * r: row index position
       * c: column index position
       * Above example is equivalent to merge cells A1:B1 in excel
       * Ref : https://github.com/SheetJS/sheetjs#worksheet-object
       * Example 1 : https://github.com/SheetJS/sheetjs/issues/2128#issuecomment-704548201
       * Example 2 : https://github.com/SheetJS/sheetjs/issues/964#issuecomment-359823907
       */
      var merges = []
      // crosstab name cells merge
      merges.push({
        s: { c: 0, r: 0 },
        e: { c: rows[1].length - 1, r: 0 },
      })

      var colIdx = 0
      if (hasPrimaryAspect(crosstab, survey)) {
        colIdx++
      }
      // primary label cells merge
      merges.push({
        s: { c: 0, r: 1 },
        e: { c: colIdx, r: 2 },
      })
      colIdx++
      // total label cells merge
      merges.push({
        s: { c: colIdx, r: 1 },
        e: { c: colIdx, r: 2 },
      })
      colIdx++
      // cross filter label cells merge
      _.each(crosstab.crossFilterSetIds, function() {
        merges.push({
          s: { c: colIdx, r: 1 },
          e: { c: colIdx, r: 2 },
        })
        colIdx++
      })
      // secondary question label cells merge
      _.each(crosstab.secondaryQuestionIds, function(sQuestionId) {
        var sQuestion = survey.getQuestion(sQuestionId)
        var sChoices = sQuestion.getVisibleChoices()
        merges.push({
          s: { c: colIdx, r: 1 },
          e: { c: colIdx + (sChoices.length - 1), r: 1 },
        })
        colIdx += sChoices.length
      })

      if (hasPrimaryAspect(crosstab, survey)) {
        var rowIdx = 3
        // aspect label cells merge
        var hasScore = hasPrimaryScore(crosstab, survey)
        var primaryItems = getPrimaryItems(crosstab, survey)
        var groupByAspect = _.groupBy(primaryItems, 'aspect.id')
        _.each(groupByAspect, function(items) {
          var totalItems = items.length
          if (hasScore) {
            totalItems += 1
          }
          merges.push({
            s: { c: 0, r: rowIdx },
            e: { c: 0, r: rowIdx + (totalItems - 1) },
          })
          rowIdx += totalItems
        })
        // base label cells merge
        merges.push({ s: { c: 0, r: rowIdx }, e: { c: 1, r: rowIdx } })
      }

      // crosstab pre-filter info cells merge
      if (crosstab.filterSetId) {
        merges.push({
          s: { c: 0, r: rows.length - 1 },
          e: { c: rows[1].length - 1, r: rows.length - 1 },
        })
      }

      return merges
    }

    function exportCSV(crosstab, survey, filterSetGroup, absolute) {
      var rows = getExportRows(crosstab, survey, filterSetGroup, absolute)
      // console.table(rows)
      var filename = 'crosstab_' + moment().format('YYYY-M-D_h-mma')
      var csv = new CSVExport(rows, filename)
      csv.download()
    }

    function exportXLSX(crosstab, survey, filterSetGroup, absolute) {
      var rows = getExportRows(crosstab, survey, filterSetGroup, absolute, true)
      rows.unshift([crosstab.name]) // append crosstab name row to the top
      var merges = getMerges(rows, crosstab, survey)
      var data = { rows: rows, merges: merges }
      return $q.resolve(data)
    }

    function exportWorkbook(crosstabs, survey, filterSetGroup, absolute) {
      return $q(function(resolve, reject) {
        var workbook = {
          name: survey.title + '_crosstabs-workbook',
          sheets: [],
        }
        var promises = _(crosstabs)
          .reject(function(crosstab) {
            return crosstab.isNew()
          })
          .map(function(crosstab, index) {
            return exportXLSX(crosstab, survey, filterSetGroup, absolute).then(
              function(data) {
                var sheetName = index + 1 + '. ' + crosstab.name
                sheetName = formatSheetName(sheetName)
                workbook.sheets[index] = {
                  name: sheetName,
                  rows: data.rows,
                  merges: data.merges,
                }
              }
            )
          })
          .value()
        $q.all(promises).then(function() {
          $http({
            method: 'POST',
            url: configService.getNodeUrl('/export-workbook'),
            data: workbook,
            responseType: 'application/json',
          })
            .then(function(resp) {
              var fileName = workbook.name + '.xlsx'
              glUtils.downloadUrl(resp.data.url, fileName)
              resolve()
            })
            .catch(function(err) {
              var errMessage = err.statusText + ' (' + err.status + ')'
              reject(errMessage)
            })
        })
      })
    }

    function formatSheetName(sheetName) {
      sheetName = sheetName.replace(/\\|\/|\?|\*|\[|\]|\:/g, '') // sheet name cannot contain \ / ? * [ ] :
      sheetName = sheetName.slice(0, 31) // sheet name must be less than 31 chars
      return sheetName
    }
  }
})()

/* globals copyToClipboard,download */
;(function() {
  'use strict'

  Factory.$inject = ["glToast"];
  angular.module('glow.components').factory('CSVExport', Factory)

  function Factory(glToast) {
    var CSV_MIME_TYPE = 'text/csv'

    function CSVExport(rows, filename) {
      this.rows = rows
      this.data = this.arrayToCSV(rows)
      this.filename = this.formatFilename(filename)
    }

    CSVExport.prototype.copy = function(showToast) {
      showToast = _.isBoolean(showToast) ? showToast : true
      copyToClipboard(this.data)
      if (showToast) {
        glToast.show('Copied to Clipboard')
      }
    }

    CSVExport.prototype.download = function(showToast) {
      showToast = _.isBoolean(showToast) ? showToast : true
      // NOTE: leaving papaparse in case we want it later
      // var data = Papa.unparse(this.rows);
      download(this.data, this.filename, CSV_MIME_TYPE)
      if (showToast) {
        glToast.show('Downloading...')
      }
    }

    CSVExport.prototype.formatFilename = function(filename) {
      filename = filename.slice(0, 200) // limit the filename length to maximum 200 characters
      filename = filename.replace(/\s/g, '-')
      return filename + '.csv'
    }

    CSVExport.prototype.arrayToCSV = function(array, isRow) {
      var self = this
      return _.map(array, function(value) {
        if (_.isArray(value)) {
          return self.arrayToCSV(value, true)
        }
        return '"' + value + '"'
      }).join(isRow ? ',' : '\r\n')
    }

    return CSVExport
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('Currency', Factory)

  function Factory() {
    var Codes = {
      AUD: 'AUD',
      USD: 'USD',
      GBP: 'GBP',
    }

    function Currency() {
      // ...
    }

    Currency.prototype.Codes = Currency.Codes = Codes

    Currency.prototype.deserialize = function(data) {
      this.code = data.code
      this.name = data.name
      this.symbol = data.symbol
      this.country = data.country
      return this
    }

    Currency.prototype.serialize = function() {
      var data = {}
      data.code = this.code
      data.name = this.name
      data.symbol = this.symbol
      data.country = this.country
      return data
    }

    return Currency
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["Currency"];
  angular.module('glow.services').factory('currencyService', Service)

  /* @ngInject */
  function Service(Currency) {
    var cache = []
    var data = [
      {
        code: Currency.Codes.AUD,
        name: 'Australian Dollar',
        symbol: '$',
        country: 'AU',
      },
      {
        code: Currency.Codes.USD,
        name: 'United States Dollar',
        symbol: '$',
        country: 'US',
      },
      {
        code: Currency.Codes.GBP,
        name: 'Pound Sterling',
        symbol: '£',
        country: 'GB',
      },
    ]
    _.each(data, function(data) {
      cache.push(new Currency().deserialize(data))
    })

    return {
      getAll: getAll,
      getByCode: getByCode,
      getByCountry: getByCountry,
      Currency: Currency,
    }

    function getAll() {
      return cache
    }

    function getByCode(code) {
      return _.find(cache, { code: code })
    }

    function getByCountry(country) {
      return _.find(cache, { country: country })
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('definitionPopup', {
    controller: Controller,
    templateUrl: 'definition-popup.html',
    bindings: {
      label: '@',
      definition: '@',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()

;(function() {
  'use strict'

  Filter.$inject = ["definitionPopupService"];
  angular.module('glow.components').filter('definitionPopup', Filter)

  /* @ngInject */
  function Filter(definitionPopupService) {
    return function(string) {
      return definitionPopupService.parse(string)
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').service('definitionPopupService', Service)

  /* @ngInject */
  function Service() {
    this.parse = parse

    function parse(string) {
      var REGEX = /\[([^\]]+)\]\<([^\>]+)>/g
      var result
      while ((result = REGEX.exec(string)) !== null) {
        var match = result[0]
        var label = result[1]
        var definition = result[2]
        var html =
          '<definition-popup label="' +
          label +
          '" definition="' +
          definition +
          '"></definition-popup>'
        string = string.replace(match, html)
      }
      return string
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["glPrefs", "glUtils"];
  angular.module('glow.components').service('deviceService', Service)

  function Service(glPrefs, glUtils) {
    var prefs = glPrefs.create('device')

    return {
      getId: getId,
    }

    function getId() {
      var deviceId = prefs.get('deviceId')
      if (!deviceId) {
        deviceId = glUtils.uuid()
        prefs.set('deviceId', deviceId)
      }
      return deviceId
    }
  }
})()

;(function() {
  'use strict'

  /**
   * @name components.dialog
   * @description dialog and backdrop directives
   */
  glDialog.$inject = ["$animate", "$animateCss", "$compile", "$controller", "$document", "$http", "$q", "$rootElement", "$$rAF", "$rootScope", "$templateCache", "$timeout", "glPrefs", "keyEventService"];
  angular
    .module('glow.components.dialog')
    .service('glDialog', glDialog)
    .directive('glBackdrop', glBackdropDirective)

  /* @ngInject */
  function glBackdropDirective() {
    return {
      restrict: 'EA',
      replace: true,
      template:
        '<div class="gl-backdrop-wrapper"><div class="gl-backdrop"></div></div>',
    }
  }

  /* @ngInject */
  function glDialog(
    $animate,
    $animateCss,
    $compile,
    $controller,
    $document,
    $http,
    $q,
    $rootElement,
    $$rAF,
    $rootScope,
    $templateCache,
    $timeout,
    glPrefs,
    keyEventService
  ) {
    var prefs = glPrefs.create('glDialog')

    var defaults = {
      hasBackdrop: true,
      clickOutsideToClose: false,
      enterToConfirm: false,
      escapeToClose: true,
      targetEvent: null,
      // disableParentScroll: true,
      bindToController: true,
      parent: 'body',
      transformTemplate: function(template) {
        return (
          '<div class="gl-dialog-wrapper"><div class="gl-dialog-container">' +
          validatedTemplate(template) +
          '</div></div>'
        )

        /**
         * The specified template should contain a <gl-dialog> wrapper element
         */
        function validatedTemplate(template) {
          template = template || ''
          return /<\/gl-dialog>/g.test(template)
            ? template
            : '<gl-dialog>' + template + '</gl-dialog>'
        }
      },
    }

    var activeDialogs = []
    var inactiveListeners = []

    var service = {
      show: show,
      alert: alert,
      confirm: confirm,
      waitUntilInactive: waitUntilInactive,
      isActive: isActive,
    }

    return service

    /**
     * @name show
     * @description show a dialog with the specified options
     * @param  {Object} options either an options preset or an options object
     * @return {Promise}        a promise that will be resolved on close/hide and rejected with cancel
     */
    function show(options) {
      options = angular.extend({}, defaults, options)

      var dialog = new Dialog(options)

      dialog.show()

      activeDialogs.push(dialog)
      dialog.deferred.promise.finally(function() {
        _.remove(activeDialogs, dialog)

        // this timeout provides enough time for chained dialogs
        // to appear,
        // Eg: showAccountSetupDialog().then(showSteadfastDialog)
        $timeout(function() {
          if (!activeDialogs.length) {
            while (inactiveListeners.length) {
              inactiveListeners.pop()()
            }
          }
        }, 100)
      })

      return dialog.deferred.promise
    }

    function waitUntilInactive() {
      // no active dialogs, go ahead!
      if (!activeDialogs.length) {
        return $q.resolve()
      }
      return $q(function(resolve) {
        inactiveListeners.push(resolve)
      })
    }

    function isActive() {
      return activeDialogs.length > 0
    }

    /**
     * @name  alert
     * @description alert dialog convenience method
     * @param  {String} title   title for alert (optional)
     * @param  {String} message alert message
     * @param  {Object} options options object
     * @return {Promise}        a promise that will be resolved on close/hide
     */
    function alert(title, message, options) {
      var defaults = {
        clickOutsideToClose: true,
        templateUrl: 'alert-dialog.template.html',
        controller: function() {},
        locals: {
          title: title,
          message: message,
        },
      }

      options = _.merge(defaults, options)
      return show(options)
    }

    /**
     * @name confirm
     * @description confirm dialog convenience method
     * @param  {String} title   title for alert (optional)
     * @param  {String} message alert message
     * @param  {Object} options options object
     * @return {Promise}        a promise that will be resolved on close/hide and rejected with cancel
     */
    function confirm(title, message, options) {
      var defaults = {
        templateUrl: 'alert-dialog.template.html',
        /* @ngInject */
        controller: ["$scope", function($scope) {
          $scope.setDisengage = function(value) {
            prefs.set('disengage-' + $scope.disengageId, value)
          }
        }],
        enterToConfirm: true,
        locals: {
          title: title,
          message: message,
          confirm: true,
        },
      }

      options = _.merge(defaults, options)

      if (
        options.locals.disengageId &&
        prefs.get('disengage-' + options.locals.disengageId)
      ) {
        return $q.resolve()
      }

      return show(options)
    }

    /**
     * @name Dialog
     * @description internal dialog object used to manage new dialogs
     * @param {Object} options options object - see above for options
     */
    function Dialog(options) {
      var self

      self = {
        options: options,
        deferred: $q.defer(),
        show: createAndTransitionIn,
        remove: transitionOutAndRemove,
      }

      return self

      /**
       * compile, link and show dialog
       */
      function createAndTransitionIn() {
        getTemplate(options).then(function(template) {
          options.$template = template

          // create and link dialog
          options.$element = linkElement(options)

          attachResolutions(options)

          showDialog(options)
        })
      }

      /**
       * transition dialog out and remove from DOM
       */
      function transitionOutAndRemove(options) {
        if (options.hasRemoved) {
          return
        }
        options.hasRemoved = true

        var element = options.$element

        if (options.deactivateListeners) {
          options.deactivateListeners()
        }
        if (options.hideBackdrop) {
          options.hideBackdrop()
        }

        var dialogEl = element.find('gl-dialog')

        _.each(activeDialogs, function(dialog, index) {
          if (index !== activeDialogs.length - 2) return
          dialog.options.$element.css({ display: 'inherit' })
        })

        dialogEl.addClass('transition-out').removeClass('transition-in')

        $$rAF(function() {
          transformToClickElement(dialogEl, options.popInTarget, 'out').then(
            function() {
              if (!options.preserveScope) {
                options.scope.$destroy()
              }
              element.remove()
            }
          )
        })
      }

      /**
       * get dialog template
       */
      function getTemplate(options) {
        if (options.templateUrl) {
          // get template from URL
          return $http
            .get(options.templateUrl, { cache: $templateCache })
            .then(function(response) {
              return response.data
            })
        } else {
          // return template as promise
          return $q.when(options.template)
        }
      }

      /**
       * link element
       */
      function linkElement(options) {
        var compileData = compileDialog(options)

        // to not destroy scope if we are passing a scope in
        options.preserveScope = options.scope ? true : false

        // create new scope if none provided
        options.scope = options.scope || $rootScope.$new()

        return compileData.link(options.scope)
      }

      /**
       * attach close and cancel methods to dialog
       */
      function attachResolutions(options) {
        /**
         * Close dialog and resolve promise with any data if applicable - to be attached to $scope
         */
        function close(data) {
          self.remove(options)
          self.deferred.resolve(data)
        }

        /**
         * Close dialog and reject promise - to be attached to $scope
         */
        function cancel(reason) {
          self.remove(options)
          self.deferred.reject(reason || 'cancelled')
        }

        // attach close and cancel functions to scope
        options.scope.dialog = {
          close: close,
          cancel: cancel,
        }
      }

      /**
       * set parent to attach dialog to
       */
      function getParent(options) {
        // If the parent is a string selector then query for the DOM element
        if (angular.isString(options.parent)) {
          var container = $document[0].querySelectorAll(options.parent)
          options.parent = container.length ? container[0] : null
        }

        // If null find the default
        if (!options.parent) {
          options.parent = $rootElement[0].querySelector(':not(svg) > body')
        }

        options.parent = angular.element(options.parent || $rootElement)
      }

      /**
       * get source target
       */
      function getTarget(options) {
        var target = angular.element((options.targetEvent || {}).target)
        options.popInTarget = target && target.length ? target : null
      }

      /**
       * Show dialog
       */
      function showDialog(options) {
        var element = options.$element

        getParent(options)
        getTarget(options)
        showBackdrop(options)

        options.parent.append(element)

        var dialogEl = element.find('gl-dialog')

        _.each(activeDialogs, function(dialog, index) {
          if (index === activeDialogs.length - 1) return
          dialog.options.$element.css({ display: 'none' })
        })

        $$rAF(function() {
          dialogEl.addClass('transition-in').css('transform', '')

          transformToClickElement(dialogEl, options.popInTarget, 'in').then(
            function() {
              // attach listeners
              activateListeners(options)
            }
          )
        })
      }

      /**
       * activate listeners on dialog
       */
      function activateListeners(options) {
        // array of active listeners
        var removeListeners = []

        var target
        var element = options.$element

        if (_.isInteger(options.cancelTimeout)) {
          $timeout(function() {
            self.remove(options)
            self.deferred.reject('timeout')
          }, options.cancelTimeout)
        }

        if (options.enterToConfirm) {
          var enterHandler = keyEventService.registerKeyEvent(
            keyEventService.KEY.enter,
            function() {
              $timeout(function() {
                self.remove(options)
                self.deferred.resolve('closed')
              })
            },
            20
          )

          // Queue remove listeners function
          removeListeners.push(function() {
            keyEventService.unregisterKeyEvent(enterHandler)
          })
        }

        if (options.escapeToClose && confirm) {
          var escapeHandler = keyEventService.registerKeyEvent(
            keyEventService.KEY.escape,
            function() {
              $timeout(function() {
                self.remove(options)
                self.deferred.reject('cancelled')
              })
            },
            20
          )

          // Queue remove listeners function
          removeListeners.push(function() {
            keyEventService.unregisterKeyEvent(escapeHandler)
          })
        }

        if (options.clickOutsideToClose) {
          target = angular.element(element[0].children[0])
          var clickHandler = function(e) {
            if (e.target === target[0]) {
              e.stopPropagation()
              e.preventDefault()

              $timeout(function() {
                self.remove(options)
                self.deferred.reject('cancelled')
              })
            }
          }

          // Add click listener
          target.on('mousedown', clickHandler)

          // Queue rempove listeners function
          removeListeners.push(function() {
            target.off('mousedown', clickHandler)
          })
        }

        // Attach specific remove listener handler
        options.deactivateListeners = function() {
          removeListeners.forEach(function(removeFn) {
            removeFn()
          })
          options.deactivateListeners = null
        }
      }

      /**
       * show backdrop
       */
      function showBackdrop(options) {
        if (activeDialogs.length > 1) {
          return
        }
        if (options.hasBackdrop) {
          // disable parent scroll
          options.parent.addClass('no-scroll')

          var backdropEl = angular.element(
            '<gl-backdrop class="gl-dialog-backdrop">'
          )
          options.backdrop = $compile(backdropEl)($rootScope.$new())

          $animate.enter(options.backdrop, options.parent)
        }

        // hide backdrop function
        options.hideBackdrop = function hideBackdrop() {
          // re-enable parent scroll
          options.parent.removeClass('no-scroll')

          if (options.backdrop) {
            $animate.leave(options.backdrop)
          }

          options.hideBackdrop = null
        }
      }

      /**
       * compile dialog
       */
      function compileDialog(options) {
        var template = options.transformTemplate(options.$template)
        var element = angular
          .element('<div>')
          .html(template.trim())
          .contents()
        var linkFn = $compile(element)
        var locals = angular.extend({}, options.locals || {})
        var controllerAs = options.controllerAs
        var controller

        if (options.controller !== false) {
          controller = options.controller || angular.noop
        }

        var compiledData = {
          locals: locals,
          element: element,
          link: function link(scope) {
            locals.$scope = scope

            // Instatiate controller if it exists
            if (controller) {
              var invokeCtrl = $controller(controller, locals, true)

              if (options.bindToController) {
                angular.extend(invokeCtrl.instance, locals)
              }

              angular.extend(options.scope, locals)

              var ctrl = invokeCtrl()

              // See angular-route source for this logic
              element.data('$ngControllerController', ctrl)
              element.children().data('$ngControllerController', ctrl)

              if (controllerAs) {
                scope[controllerAs] = ctrl
              }

              // publish reference to this controller
              compiledData.controller = ctrl
            }
            return linkFn(scope)
          },
        }
        return compiledData
      }

      /**
       * Animate dialog expanding from / to clicked element
       */
      function transformToClickElement(dialogEl, clickElement, direction) {
        var classes = {
          from: null,
          to: null,
        }

        if (clickElement) {
          var clickRect = clickElement[0].getBoundingClientRect()
          var dialogRect = dialogEl[0].getBoundingClientRect()

          var scaleX = Math.min(0.5, clickRect.width / dialogRect.width)
          var scaleY = Math.min(0.5, clickRect.height / dialogRect.height)

          var resize =
            'translate(' +
            (-dialogRect.left +
              clickRect.left +
              clickRect.width / 2 -
              dialogRect.width / 2) +
            'px,' +
            (-dialogRect.top +
              clickRect.top +
              clickRect.height / 2 -
              dialogRect.height / 2) +
            'px' +
            ') scale(' +
            scaleX +
            ',' +
            scaleY +
            ')'

          classes = {
            from: {
              transform: direction === 'in' ? resize : '',
            },
            to: {
              transform: direction === 'in' ? '' : resize,
            },
          }
        }

        return $animateCss(dialogEl, classes).start()
      }
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').service('distanceService', Service)

  /* @ngInject */
  function Service() {
    var self = this

    var MeasurementSystems = {
      METRIC: 'METRIC', // uses kilometers
      IMPERIAL: 'IMPERIAL', // uses miles
    }

    var MeterConversion = {
      METRIC: 1000, // 1km = 1000 meters
      IMPERIAL: 1609.34, // 1mi = 1609.34 meters
    }

    self.MeasurementSystems = MeasurementSystems
    self.MeterConversion = MeterConversion
    self.getUserMeasurementSystem = getUserMeasurementSystem
    self.metersToLabel = metersToLabel

    function getUserMeasurementSystem() {
      var userLocale = navigator.language || navigator.userLanguage
      var countryCode = userLocale.split('-')[1]
      // List of countries using the imperial system
      var imperialCountries = ['US', 'GB', 'LR', 'MM'] // United States, UK, Liberia, Myanmar
      // Determine the measurement system based on the country code
      return imperialCountries.includes(countryCode)
        ? MeasurementSystems.IMPERIAL
        : MeasurementSystems.METRIC
    }

    function metersToLabel(distanceInMeters, measurementSystem) {
      var meterConversion = MeterConversion[measurementSystem]
      var toFeet = distanceInMeters * 3.28084
      var toMiles = distanceInMeters / meterConversion
      var toKilometers = distanceInMeters / meterConversion

      if (measurementSystem === MeasurementSystems.IMPERIAL) {
        return toFeet < 1000
          ? _.round(toFeet) + 'ft'
          : _.round(toMiles, 1) + 'mi'
      } else {
        return distanceInMeters < 1000
          ? _.round(distanceInMeters) + 'm'
          : _.round(toKilometers, 1) + 'km'
      }
    }
  }
})()

;(function() {
  'use strict'

  Directive.$inject = ["glEmail"];
  angular.module('glow.components.email').directive('glEmail', Directive)

  function Directive(glEmail) {
    return {
      restict: 'A',
      require: '?ngModel',
      link: PostLink,
    }

    function PostLink(scope, elem, attrs, ctrl) {
      // only apply the validator if ngModel is present and angular has added the email validator
      if (ctrl && ctrl.$validators.email) {
        // overwrite default angular email validator
        ctrl.$validators.email = validate
      }

      function validate(modelValue) {
        return ctrl.$isEmpty(modelValue) || glEmail.isValid(modelValue)
      }
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components.email').service('glEmail', Service)

  function Service() {
    var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    return {
      isValid: isValid,
    }

    function isValid(email) {
      return EMAIL_REGEX.test(email)
    }
  }
})()

;(function() {
  'use strict'

  angular
    .module('glow.components.emptyToNull')
    .directive('emptyToNull', emptyToNullDirective)

  /* @ngInject */
  function emptyToNullDirective() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: link,
    }

    function link(scope, elem, attrs, ctrl) {
      ctrl.$parsers.push(function(viewValue) {
        if (viewValue === '') {
          return null
        }
        return viewValue
      })
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$element"];
  angular.module('glow.components').component('errors', {
    controller: Controller,
    templateUrl: 'errors.html',
    bindings: {
      errors: '<',
      small: '<',
    },
  })

  /* @ngInject */
  function Controller($element) {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      $element.addClass('errors')
      if (ctrl.small) {
        $element.addClass('-small')
      }
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$transitions", "$log", "$window"];
  angular.module('glow.components').component('exitConfirmation', {
    controller: Controller,
    bindings: {
      message: '@',
      ignoredParam: '@',
    },
  })

  /* @ngInject */
  function Controller($transitions, $log, $window) {
    var ctrl = this
    // var log = $log.create('ExitConfirmation');
    var locationTriggered = false

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy

    function onInit() {
      // log.info('onInit');
      ctrl.message =
        ctrl.message || 'Unsaved changes will be lost, are you sure?'

      $window.addEventListener('beforeunload', onBeforeUnload)
      ctrl.removeListener = $transitions.onStart(null, onRouteChange)
      // $scope.$on('$locationChangeStart', onRouteChange);
    }

    function onBeforeUnload(event) {
      // log.info('onBeforeUnload');
      event.returnValue = ctrl.message
      return ctrl.message
    }

    function onRouteChange(trans) {
      if (locationTriggered) return

      if (ctrl.ignoredParam) {
        const changedParams = Object.keys(trans.paramsChanged() || {})
        if (
          changedParams.length === 1 &&
          changedParams[0] === ctrl.ignoredParam
        ) {
          return
        }
      }

      if (!$window.confirm(ctrl.message)) {
        trans.abort()
      } else {
        locationTriggered = true
      }
    }

    function onDestroy() {
      // log.info('onDestroy');
      $window.removeEventListener('beforeunload', onBeforeUnload)
      ctrl.removeListener()
      // $scope listeners are automatically removed
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils"];
  angular.module('glow.components').factory('ExternalPanelTransform', Factory)

  /* @ngInject */
  function Factory(glUtils) {
    var Types = {
      FORWARD_PARAM: 'FORWARD_PARAM',
      FORWARD_VALUE: 'FORWARD_VALUE',
      CAPTURE_PARAM: 'CAPTURE_PARAM',
    }

    function ExternalPanelTransform() {
      this.applyDefaults()
    }

    ExternalPanelTransform.prototype.Types = ExternalPanelTransform.Types = Types

    ExternalPanelTransform.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: glUtils.uuid(),
        type: Types.FORWARD_PARAM,
        name: null,
        in: null,
        out: null,
        isRespondentId: false,
        hint: null,
        template: null,
        dimension: null,
      })
    }

    ExternalPanelTransform.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.type = this.type
      data.name = this.name
      data.in = this.in
      data.out = this.out
      data.isRespondentId = this.isRespondentId
      data.hint = this.hint
      data.template = this.template
      data.dimension = this.dimension
      return data
    }

    ExternalPanelTransform.prototype.deserialize = function(data) {
      this.id = data.id
      this.type = data.type
      this.name = data.name
      this.in = data.in
      this.out = data.out
      this.isRespondentId = data.isRespondentId
      this.hint = data.hint
      this.template = data.template
      this.dimension = data.dimension
      this.applyDefaults()
      return this
    }

    ExternalPanelTransform.prototype.validate = function() {
      var errors = []
      if (!this.type) {
        errors.push('Type required')
      }
      if (this.usesName() && !this.name) {
        errors.push('Name required')
      }
      if (this.usesIn() && !this.in) {
        errors.push('In value required')
      }
      if (this.usesOut() && !this.out) {
        errors.push('Out value required')
      }
      if (this.usesDimension() && !this.dimension) {
        errors.push('Dimension required')
      }
      if (errors.length) {
        this.errors = errors
        return false
      }
      this.errors = null
      return true
    }

    ExternalPanelTransform.prototype.copy = function(param) {
      this.deserialize(param.serialize())
    }

    ExternalPanelTransform.prototype.clone = function() {
      var param = new ExternalPanelTransform().deserialize(this.serialize())
      return param
    }

    ExternalPanelTransform.prototype.usesName = function() {
      return _.includes([Types.FORWARD_VALUE, Types.CAPTURE_PARAM], this.type)
    }

    ExternalPanelTransform.prototype.usesIn = function() {
      return _.includes([Types.FORWARD_PARAM, Types.CAPTURE_PARAM], this.type)
    }

    ExternalPanelTransform.prototype.usesOut = function() {
      return _.includes([Types.FORWARD_PARAM, Types.FORWARD_VALUE], this.type)
    }

    ExternalPanelTransform.prototype.usesRespondentId = function() {
      return _.includes([Types.FORWARD_PARAM], this.type)
    }

    ExternalPanelTransform.prototype.usesHint = function() {
      return _.includes([Types.FORWARD_VALUE], this.type)
    }

    ExternalPanelTransform.prototype.usesTemplate = function() {
      return _.includes([Types.FORWARD_PARAM, Types.CAPTURE_PARAM], this.type)
    }

    ExternalPanelTransform.prototype.usesDimension = function() {
      return _.includes([Types.CAPTURE_PARAM], this.type)
    }

    return ExternalPanelTransform
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('ExternalPanelValueStore', Factory)

  /* @ngInject */
  function Factory() {
    function ExternalPanelValueStore() {
      this.values = {}
    }

    ExternalPanelValueStore.prototype.serialize = function() {
      var data = []
      _.each(this.values, function(value, key) {
        data.push({ key: key, value: value })
      })
      return data
    }

    ExternalPanelValueStore.prototype.deserialize = function(data) {
      var values = {}
      data = _.isArray(data) ? data : []
      _.each(data, function(item) {
        values[item.key] = item.value
      })
      this.values = values
      return this
    }

    ExternalPanelValueStore.prototype.get = function(key) {
      return this.values[key]
    }

    ExternalPanelValueStore.prototype.set = function(key, value) {
      this.values[key] = value
    }

    ExternalPanelValueStore.prototype.remove = function(key) {
      delete this.values[key]
    }

    ExternalPanelValueStore.prototype.clearAll = function() {
      this.values = {}
    }

    return ExternalPanelValueStore
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["ExternalPanelTransform"];
  angular.module('glow.components').factory('ExternalPanel', Factory)

  /* @ngInject */
  function Factory(ExternalPanelTransform) {
    var Status = {
      ACTIVE: 'ACTIVE',
      INACTIVE: 'INACTIVE',
    }

    var LinkMode = {
      BUILT_IN: 'BUILT_IN',
      USER_DEFINED: 'USER_DEFINED',
    }

    function ExternalPanel() {
      this.applyDefaults()
    }

    ExternalPanel.prototype.Status = ExternalPanel.Status = Status
    ExternalPanel.prototype.LinkMode = ExternalPanel.LinkMode = LinkMode

    ExternalPanel.prototype.applyDefaults = function() {
      var now = moment()
      _.defaultsDeep(this, {
        id: null,
        name: null,
        desc: null,
        logoUrl: null,
        websiteUrl: null,
        linkMode: LinkMode.BUILT_IN,
        submitLink: null,
        exitLink: null,
        quotaLink: null,
        qualityExitLink: null,
        transforms: [],
        status: Status.INACTIVE,
        ssrOnly: false,
        createdAt: now,
        updatedAt: now,
      })
    }

    ExternalPanel.prototype.serialize = function() {
      var data = {}
      data.data = {}
      data.id = this.id
      data.name = this.name
      data.desc = this.desc
      data.logoUrl = this.logoUrl
      data.data.linkMode = this.linkMode
      data.websiteUrl = this.websiteUrl
      data.submitLink = this.submitLink
      data.exitLink = this.exitLink
      data.quotaLink = this.quotaLink
      data.qualityExitLink = this.qualityExitLink
      data.params = this.transforms.map(function(transform) {
        return transform.serialize()
      })
      data.status = this.status
      data.data.ssrOnly = this.ssrOnly
      data.updatedAt = this.updatedAt && this.updatedAt.toISOString()
      data.createdAt = this.createdAt && this.createdAt.toISOString()
      return data
    }

    ExternalPanel.prototype.deserialize = function(data) {
      data.data = _.isPlainObject(data.data) ? data.data : {}
      this.id = data.id
      this.name = data.name
      this.desc = data.desc
      this.logoUrl = data.logoUrl
      this.linkMode = data.data.linkMode
      this.websiteUrl = data.websiteUrl
      this.submitLink = data.submitLink
      this.exitLink = data.exitLink
      this.quotaLink = data.quotaLink
      this.qualityExitLink = data.qualityExitLink
      this.transforms = data.params.map(function(data) {
        return new ExternalPanelTransform().deserialize(data)
      })
      this.status = data.status
      this.ssrOnly = data.data.ssrOnly
      this.createdAt = data.createdAt ? moment(data.createdAt) : undefined
      this.updatedAt = data.updatedAt ? moment(data.updatedAt) : undefined
      this.applyDefaults()
      this.snapshot()
      return this
    }

    ExternalPanel.prototype.getRespondentLink = function(channelLongUrl, test) {
      var url = new URL(channelLongUrl)
      if (test) url.searchParams.set('readOnly', true)
      this.transforms.forEach(function(transform) {
        if (
          transform.type === transform.Types.FORWARD_PARAM &&
          transform.template
        ) {
          url.searchParams.set(transform.in, transform.template)
        }
        if (
          transform.type === transform.Types.CAPTURE_PARAM &&
          transform.template
        ) {
          url.searchParams.set(transform.in, transform.template)
        }
      })
      return decodeURI(url.toString())
    }

    ExternalPanel.prototype.generateEndLinks = function(urlParams, valueStore) {
      var submitLink = new URL(this.submitLink)
      var exitLink = new URL(this.exitLink)
      var quotaLink = new URL(this.quotaLink)
      var qualityExitLink = new URL(this.qualityExitLink)
      var valid = true
      this.transforms.forEach(function(transform) {
        // FORWARD_PARAM
        if (transform.type === transform.Types.FORWARD_PARAM) {
          var value = urlParams.get(transform.in)
          if (value) {
            submitLink.searchParams.set(transform.out, value)
            exitLink.searchParams.set(transform.out, value)
            quotaLink.searchParams.set(transform.out, value)
            qualityExitLink.searchParams.set(transform.out, value)
          } else {
            console.error(
              'ExternalPanel: missing in param "' + transform.in + '"'
            )
            valid = false
          }
        }
        // FORWARD_VALUE
        if (transform.type === transform.Types.FORWARD_VALUE) {
          var value = valueStore.get(transform.id)
          if (value) {
            submitLink.searchParams.set(transform.out, value)
            exitLink.searchParams.set(transform.out, value)
            quotaLink.searchParams.set(transform.out, value)
            qualityExitLink.searchParams.set(transform.out, value)
          } else {
            console.error(
              'ExternalPanel: missing value "' + transform.name + '"'
            )
            valid = false
          }
        }
      })
      var endLinks = {
        submitLink: submitLink.toString(),
        exitLink: exitLink.toString(),
        quotaLink: quotaLink.toString(),
        qualityExitLink: qualityExitLink.toString(),
        valid: valid,
      }
      console.log(endLinks)
      return endLinks
    }

    ExternalPanel.prototype.getRespondentId = function(urlParams) {
      var transform = _.find(this.transforms, function(transform) {
        return transform.isRespondentId
      })
      if (!transform) return null
      return urlParams.get(transform.in)
    }

    ExternalPanel.prototype.getCaptured = function(urlParams, callback) {
      this.transforms.forEach(function(transform) {
        if (transform.type === transform.Types.CAPTURE_PARAM) {
          var value = urlParams.get(transform.in)
          if (value) {
            callback(transform.dimension, transform.name, value)
          }
        }
      })
    }

    ExternalPanel.prototype.isNew = function() {
      return !this.id
    }

    ExternalPanel.prototype.isActive = function() {
      return this.status === Status.ACTIVE
    }

    ExternalPanel.prototype.addTransform = function() {
      this.transforms.push(new ExternalPanelTransform())
    }

    ExternalPanel.prototype.removeTransform = function(transform) {
      _.remove(this.transforms, transform)
    }

    ExternalPanel.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    ExternalPanel.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    ExternalPanel.prototype.validate = function() {
      var errors = []
      var builtin = this.linkMode === LinkMode.BUILT_IN
      if (!this.name) {
        errors.push('Name is required')
      }
      if (!this.desc) {
        errors.push('Description is required')
      }
      if (!this.logoUrl && !this.logoData) {
        errors.push('Logo is required')
      }
      if (!this.websiteUrl) {
        errors.push('Website URL is required')
      }
      if (builtin && !this.submitLink) {
        errors.push('Submit link is required')
      }
      if (builtin && !this.exitLink) {
        errors.push('Exit link is required')
      }
      if (builtin && !this.quotaLink) {
        errors.push('Quota full link is required')
      }
      if (builtin && !this.qualityExitLink) {
        errors.push('Quality exit link is required')
      }
      if (!this.transforms.length) {
        errors.push('At least one transform must be defined.')
      }
      var respondentIdFields = 0
      _.each(this.transforms, function(transform) {
        if (!transform.validate()) {
          errors.push('Invalid transform options')
          return false
        }
        if (transform.isRespondentId) {
          respondentIdFields++
        }
      })
      if (!respondentIdFields) {
        errors.push('Respondent ID field required')
      }
      if (respondentIdFields > 1) {
        errors.push('There can only be one respondent ID field')
      }
      if (errors.length) {
        this.errors = errors
        return false
      }
      this.errors = null
      return true
    }

    ExternalPanel.prototype.copy = function(externalPanel) {
      this.deserialize(externalPanel.serialize())
    }

    ExternalPanel.prototype.clone = function() {
      var externalPanel = new ExternalPanel().deserialize(this.serialize())
      return externalPanel
    }

    return ExternalPanel
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "api", "configService", "imageService", "ExternalPanel", "glDialog"];
  angular.module('glow.components').service('externalPanelService', Service)

  /* @ngInject */
  function Service(
    $q,
    api,
    configService,
    imageService,
    ExternalPanel,
    glDialog
  ) {
    var cached = null
    var DEFAULT_PANEL_ID = configService.isStaging()
      ? '462dad7f-b79b-4af3-9111-0261a9546311'
      : 'TBD'

    this.spawn = spawn
    this.list = list
    this.get = get
    this.save = save
    this.showSelectorDialog = showSelectorDialog

    function spawn() {
      return new ExternalPanel()
    }

    function list(options) {
      // optimised for speed using a cache
      var promise = api.externalPanels.get(options).then(function(data) {
        if (!cached) cached = []
        _.remove(cached)
        _.each(data, function(data) {
          var panel = new ExternalPanel().deserialize(data)
          cached.push(panel)
        })
        return cached
      })
      return cached ? $q.resolve(cached) : promise
    }

    function get(id) {
      return api.externalPanels.get({ id: id }).then(function(data) {
        return new ExternalPanel().deserialize(data)
      })
    }

    function save(panel) {
      var action = panel.id ? update : create
      return saveImages(panel).then(function() {
        return action(panel).then(function() {
          panel.snapshot()
          return panel
        })
      })
    }

    function saveImages(panel) {
      if (!panel.logoData) return $q.resolve(panel)
      return imageService.create(panel.logoData).then(function(logoUrl) {
        panel.logoUrl = logoUrl
        panel.logoData = undefined
        return panel
      })
    }

    function create(panel) {
      return api.externalPanels.create(panel.serialize()).then(function(data) {
        panel.id = data.id
        if (cached) cached.unshift(panel)
        return panel
      })
    }

    function update(panel) {
      return api.externalPanels.update(panel.serialize())
    }

    function showSelectorDialog(providers) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="external-panel-selector__dialog">',
          '<g-dialog-header ',
            'title="Panel Providers" ',
            'on-close="dialog.cancel()"',
          '></g-dialog-header>',
          '<external-panel-selector ',
            'providers="providers" ',
            'on-select="dialog.close($provider)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>'
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          providers: providers,
        },
      })
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('fieldError', {
    controller: Controller,
    templateUrl: 'field-error.html',
    transclude: true,
    bindings: {
      form: '<',
      field: '@',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {}
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["findAndReplaceService", "userService", "glToast"];
  angular.module('glow.components').component('findAndReplace', {
    controller: Controller,
    templateUrl: 'find-and-replace.template.html',
    bindings: {
      survey: '<',
      onClose: '&',
    },
  })

  /* @ngInject */
  function Controller(findAndReplaceService, userService, glToast) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.find = find
    ctrl.replace = replace
    ctrl.cancelReplace = cancelReplace
    ctrl.confirmReplace = confirmReplace
    ctrl.getSelected = getSelected
    ctrl.isAllSelected = isAllSelected
    ctrl.toggleSelectAll = toggleSelectAll

    function onInit() {
      ctrl.isSSR = userService.isSSR()
      ctrl.searchInput = ''
      ctrl.replaceInput = ''
      ctrl.matchCase = false
    }

    function find(searchQuery) {
      ctrl.searchQuery = searchQuery
      ctrl.replaceStr = null
      ctrl.results = ctrl.searchResults = findOrReplace()
    }

    function replace(replaceStr) {
      if (isNoneSelected()) {
        ctrl.replaceErrorText = 'Please select results to replace.'
        return
      }
      ctrl.replaceErrorText = ''
      ctrl.replaceStr = replaceStr
      ctrl.isReplacePreview = true
      ctrl.results = ctrl.replacePreviewResults = findOrReplace(
        getSkipIndexes()
      )
    }

    function cancelReplace() {
      ctrl.results = ctrl.searchResults
      ctrl.isReplacePreview = false
    }

    function confirmReplace() {
      ctrl.isReplacePreview = false
      var replaceResults = findOrReplace(getSkipIndexes())
      ctrl.onClose()
      glToast.show(replaceResults.length + ' results have been replaced')
    }

    function findOrReplace(skipIndexes) {
      var options = {
        survey: ctrl.survey,
        query: ctrl.searchQuery,
        exact: ctrl.matchCase,
        replacement: ctrl.replaceStr,
        isReplacePreview: ctrl.isReplacePreview,
        skipIndexes: skipIndexes,
        isSSR: ctrl.isSSR,
      }
      return findAndReplaceService.findOrReplace(options)
    }

    function getSkipIndexes() {
      var skipIndexes = []
      _.each(ctrl.searchResults, function(result, index) {
        if (!result.skipReplace) return
        skipIndexes.push(index)
      })
      return skipIndexes
    }

    function getSelected() {
      if (!ctrl.results) return []
      return ctrl.results.filter(function(result) {
        return !result.skipReplace
      })
    }

    function isAllSelected() {
      var selected = getSelected().length
      return selected > 0 && selected === ctrl.results.length
    }

    function isNoneSelected() {
      var selected = getSelected().length
      return selected === 0
    }

    function toggleSelectAll() {
      var value = isAllSelected() ? false : true
      ctrl.results.forEach(function(result) {
        result.skipReplace = !value
      })
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["glDialog", "glUtils"];
  angular.module('glow.components').service('findAndReplaceService', Service)

  /* @ngInject */
  function Service(glDialog, glUtils) {
    var self = this

    self.showDialog = showDialog
    self.findOrReplace = findOrReplace

    function showDialog(survey) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="find-and-replace__dialog">',
          '<find-and-replace ',
            'survey="survey" ',
            'on-close="dialog.close()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        locals: {
          survey: survey,
        },
        escapeToClose: true,
        clickOutsideToClose: true,
      }
      return glDialog.show(options)
    }

    function findOrReplace(options) {
      options = _.defaults(options, {
        survey: null,
        query: null,
        exact: false,
        replacement: null,
        isReplacePreview: false,
        skipIndexes: [],
        isSSR: false,
      })

      if (!_.isString(options.query) || !options.query.length) return []

      var matches = []
      var survey = options.survey
      var isSSR = options.isSSR

      // intro
      search(survey, 'title', 'Survey Intro > Title')
      if (isSSR) {
        search(survey, 'introText', 'Survey Intro > Intro Text')
        search(survey, 'introTextUrl', 'Survey Intro > Intro Text URL')
      }

      // survey settings - general
      search(survey, 'reference', 'Survey Settings - General > Reference')
      _.each(survey.viewGroups, function(viewGroup, index) {
        search(
          viewGroup,
          'name',
          'Survey Settings - General > Groups (' + (index + 1) + ')'
        )
      })
      if (isSSR) {
        search(
          survey,
          'comparisonKey',
          'Survey Settings - General > Comparison Key'
        )
      }

      // survey settings - outro
      search(
        survey,
        'outroText',
        'Survey Settings - Outro > Survey Completed Message'
      )
      search(survey, 'submitRoute', 'Survey Settings - Outro > Done URL')
      if (isSSR) {
        search(survey.share, 'title', 'Survey Settings - Outro > Share Title')
        search(survey.share, 'text', 'Survey Settings - Outro > Share Text')
        search(survey.share, 'url', 'Survey Settings - Outro > Share URL')
        search(
          survey.share,
          'imageUrl',
          'Survey Settings - Outro > Share Image URL'
        )
        search(
          survey,
          'restartButton',
          'Survey Settings - Outro > Restart Button Text'
        )
        search(
          survey,
          'nextSurveyId',
          'Survey Settings - Outro > Next Survey ID'
        )
      }

      // questions
      var questions = survey.getQuestions()
      console.log('questions', questions)
      _.each(questions, function(question, index) {
        var preTitle =
          'Question ' + (index + 1) + ' (' + question.label + ') > '

        search(question, 'title', preTitle + 'Question')
        search(question, 'description', preTitle + 'Description')

        _.each(question.statements, function(statement, sIndex) {
          search(
            statement,
            'value',
            preTitle + 'Statements (' + (sIndex + 1) + ')'
          )
        })

        // PLACES NEAR ME has choices added by the BE automatically when response is submitted
        // these choices are not available for editing on question editor and is not exposed
        // to users. We shouldn't include the choices on the search results.
        if (question.type !== question.Types.PLACES_NEAR_ME) {
          _.each(question.choices, function(choice, cIndex) {
            search(choice, 'value', preTitle + 'Choices (' + (cIndex + 1) + ')')
          })
        }

        search(question, 'defaultSearchQuery', preTitle + 'Search Term')
        search(question, 'textPrefix', preTitle + 'Prefix')
        search(question, 'textSuffix', preTitle + 'Suffix')
        search(question, 'numericDiffLeft', preTitle + 'Left Text')
        search(question, 'numericDiffRight', preTitle + 'Right Text')
        search(
          question,
          'scoreLeftExtremityLabel',
          preTitle + 'Range Labels - Left Text'
        )
        search(
          question,
          'scoreRightExtremityLabel',
          preTitle + 'Range Labels - Right Text'
        )
        search(question, 'scoreLabel', preTitle + 'Score Label')
        search(question, 'scoreDefinition', preTitle + 'Score Definition')
        search(question, 'reference', preTitle + 'Reference')

        if (isSSR) {
          search(question, 'comparisonKey', preTitle + 'Comparison Key')
        }

        _.each(question.logic, function(logic) {
          _.each(logic.actions, function(action) {
            searchLogicAction(action, preTitle)
          })
        })
      })

      // sections
      var sections = survey.getSections()
      _.each(sections, function(section, index) {
        var preTitle = 'Section ' + (index + 1) + ' > '

        search(section, 'title', preTitle + 'Text')
        search(section, 'mediaLabel', preTitle + 'Media Label')
        search(section, 'youTubeVideoUrl', preTitle + 'YouTube Video URL')
        search(section, 'audioUrl', preTitle + 'Audio URL (mp3)')
        search(section, 'iframeUrl', preTitle + 'Iframe URL')
        search(section, 'reference', preTitle + 'Reference')

        _.each(section.logic, function(logic) {
          _.each(logic.actions, function(action) {
            searchLogicAction(action, preTitle)
          })
        })
      })

      // generate results
      var results = []
      _.each(matches, function(item, index) {
        var matchStart = item.match.index
        var matchEnd = item.match.index + item.match[0].length
        var matchInput = item.match.input

        var inputStart = matchInput.slice(0, matchStart)
        var inputCenter = matchInput.slice(matchStart, matchEnd)
        var inputEnd = matchInput.slice(matchEnd)

        var contentStart = glUtils.stringReverse(
          _.truncate(glUtils.stringReverse(inputStart), { length: 40 })
        )
        var contentCenter = ''
        var contentEnd = _.truncate(inputEnd, { length: 40 })

        // replace or find
        var replacement = options.replacement
        if (_.isString(replacement)) {
          if (_.includes(options.skipIndexes, index)) {
            return // skip match
          }
          contentCenter = '<s>' + inputCenter + '</s><b>' + replacement + '</b>'

          if (!options.isReplacePreview) {
            // not a preview, do actual replace
            item.node[item.key] = glUtils.stringReplaceAt(
              item.node[item.key],
              matchStart,
              matchEnd,
              replacement
            )
          }
        } else {
          // find only
          contentCenter = '<b>' + inputCenter + '</b>'
        }

        results.push({
          title: item.title,
          content: contentStart + contentCenter + contentEnd,
        })
      })

      return results

      function search(node, key, title) {
        var value = node[key]
        var flags = 'g' + (options.exact ? '' : 'i')
        var escapedQuery = _.escapeRegExp(options.query) // escape special character for regex
        var regex = new RegExp(escapedQuery, flags)
        var match
        while ((match = regex.exec(value))) {
          matches.push({
            match: match,
            node: node,
            key: key,
            title: title,
          })
        }
      }

      function searchLogicAction(action, preTitle) {
        preTitle += 'Logic > '

        if (action.type === action.Types.TAG) {
          search(action, 'tag', preTitle + 'add tag')
        }
        if (action.type === action.Types.UNTAG) {
          _.each(action.tags, function(tag, index) {
            search(action.tags, index, preTitle + 'remove tags')
          })
        }
        if (action.type === action.Types.ADD_LEAST_FILLED_TAGS) {
          _.each(action.leastFill.tags, function(tag, index) {
            search(
              action.leastFill.tags,
              index,
              preTitle + 'add least filled tags'
            )
          })
        }
        if (action.type === action.Types.RETAIN_LEAST_FILLED_TAGS) {
          _.each(action.leastFill.tags, function(tag, index) {
            search(
              action.leastFill.tags,
              index,
              preTitle + 'retain least filled tags'
            )
          })
        }
        if (action.type === action.Types.ADD_TO_LIST) {
          search(action, 'list', preTitle + 'add to list > list')
          search(action, 'listItem', preTitle + 'add to list > item')
        }
        if (action.type === action.Types.SET_VARIABLE) {
          search(action, 'variableKey', preTitle + 'set variable > key')
          search(action, 'variableValue', preTitle + 'set variable > value')
        }
      }
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$element", "$state"];
  angular.module('glow.components').component('gBtn', {
    controller: Controller,
    templateUrl: 'g-btn.html',
    bindings: {
      secondary: '<',
      tertiary: '@',
      danger: '@',
      icon: '@',
      label: '@',
      disabled: '<',
      link: '@',
      linkNewTab: '<',
      state: '@',
      stateParams: '<',
      loading: '<',
      onClick: '&',
      small: '<',
      block: '<',
      hint: '@',
    },
  })

  /* @ngInject */
  function Controller($element, $state) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges
    ctrl.click = click

    function onInit() {
      if (ctrl.state) {
        ctrl.link = $state.href(ctrl.state, ctrl.stateParams)
      }
      if (ctrl.linkNewTab) {
        ctrl.target = '_blank'
      }
    }

    function onChanges(props) {
      if (props.loading && props.loading.currentValue === true) {
        var width = $element[0].offsetWidth
        ctrl.loader = {
          width: width,
        }
      }
      if (props.loading && props.loading.currentValue === false) {
        ctrl.loader = null
      }
    }

    function click(event) {
      if (event.defaultPrevented || ctrl.disabled) {
        return
      }
      ctrl.onClick({ $event: event })
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$element"];
  angular.module('glow.components').component('gCalendar', {
    controller: Controller,
    templateUrl: 'g-calendar.html',
    bindings: {
      model: '<',
      join: '<',
      min: '<',
      max: '<',
      onChange: '&',
    },
  })

  /* @ngInject */
  function Controller($element) {
    var ctrl = this

    // Sun = 0, Sat = 6
    var StartOfWeek = 1

    $element.addClass('g-calendar')

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges
    ctrl.next = next
    ctrl.prev = prev
    ctrl.select = select

    function onInit() {
      buildPoints()
    }

    function onChanges(changes) {
      if (!ctrl.month) {
        ctrl.month = ctrl.model
          ? ctrl.model.clone().startOf('day')
          : moment().startOf('day')
      }
      if (changes.model && !ctrl.model.isSame(ctrl.month)) {
        ctrl.month = ctrl.model.clone().startOf('day')
      }
      buildPoints()
    }

    function buildPoints() {
      var numDates = ctrl.month.daysInMonth()
      // Calculate and wrap the number of days to skip
      var toSkip =
        parseInt(ctrl.month.startOf('month').format('d')) - StartOfWeek
      toSkip = toSkip < 0 ? 7 + toSkip : toSkip

      var skip = toSkip
      var points = []
      // Avoid skipping an entire week
      while (skip !== 7 && skip > 0) {
        points.push({ disabled: true })
        skip--
      }

      _.times(numDates, function(idx) {
        var point = {}
        point.number = idx + 1
        point.date = ctrl.month.clone().date(idx + 1)

        var outOfBounds =
          (ctrl.max && point.date.isAfter(ctrl.max, 'day')) ||
          (ctrl.min && point.date.isBefore(ctrl.min, 'day'))

        if (outOfBounds) {
          point.disabled = true
          points.push(point)
          return
        }

        var isModel = point.date.isSame(ctrl.model, 'day')
        var isJoin = point.date.isSame(ctrl.join, 'day')
        var isEdge = isModel || isJoin
        var isRanged = ctrl.model && ctrl.join
        var isStart =
          isRanged &&
          ((isModel && ctrl.model.isBefore(ctrl.join, 'day')) ||
            (isJoin && ctrl.join.isBefore(ctrl.model, 'day')))
        var isEnd =
          isRanged &&
          ((isModel && ctrl.model.isAfter(ctrl.join, 'day')) ||
            (isJoin && ctrl.join.isAfter(ctrl.model, 'day')))
        var isBetweenRange =
          isRanged &&
          (point.date.isBetween(ctrl.model, ctrl.join, 'day') ||
            point.date.isBetween(ctrl.join, ctrl.model, 'day'))
        var isInRange = isRanged && (isModel || isJoin || isBetweenRange)
        var divis = (toSkip + idx) % 7
        var isWeekStart = divis === 0
        var isWeekEnd = divis === 6
        var isWeekEdge = isWeekStart || isWeekEnd
        var isMonthStart = idx + 1 === 1
        var isMonthEnd = idx + 1 === numDates

        point.selected = isModel
        point.active = isEdge || isInRange
        point.left = isEnd
          ? !isWeekStart && !isMonthStart
          : isBetweenRange && (!isWeekEdge || isWeekEnd) && !isMonthStart
        point.right = isStart
          ? !isWeekEnd && !isMonthEnd
          : isBetweenRange && (!isWeekEdge || isWeekStart) && !isMonthEnd
        points.push(point)
      })
      ctrl.points = points
    }

    function next() {
      ctrl.month.add(1, 'month')
      buildPoints()
    }

    function prev() {
      ctrl.month.subtract(1, 'month')
      buildPoints()
    }

    function select(point) {
      if (point.disabled || !point.date) {
        return
      }
      ctrl.onChange({ $date: point.date })
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$element"];
  angular.module('glow.components').component('gCheckbox', {
    controller: Controller,
    templateUrl: 'g-checkbox.html',
    bindings: {
      isSelected: '<selected',
      isDisabled: '<disabled',
      isStatic: '<static',
      onChange: '&',
    },
  })

  /* @ngInject */
  function Controller($element) {
    var ctrl = this

    $element.addClass('g-checkbox')

    ctrl.toggle = toggle

    function toggle(event) {
      if (ctrl.isStatic) {
        return
      }
      event.preventDefault()
      event.stopPropagation()

      if (ctrl.isDisabled) {
        return
      }

      ctrl.isSelected = !ctrl.isSelected
      ctrl.onChange({ $value: ctrl.isSelected })
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('gColoredDot', {
    templateUrl: 'g-colored-dot.html',
    bindings: {
      color: '@',
    },
  })
})()

;(function() {
  'use strict'

  Controller.$inject = ["$element"];
  angular.module('glow.components').component('gDialogHeader', {
    controller: Controller,
    templateUrl: 'g-dialog-header.html',
    bindings: {
      title: '@',
      subTitle: '@',
      message: '@',
      tabs: '<',
      selectedTab: '<',
      onTabChange: '&',
      hideBack: '<',
      onBack: '&?',
      btn: '@',
      onBtnClick: '&',
      hideClose: '<',
      onClose: '&?',
    },
  })

  /* @ngInject */
  function Controller($element) {
    $element.addClass('g-dialog-header')
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$element", "$timeout", "$q", "glToast"];
  angular.module('glow.components').component('gFileInput', {
    controller: Controller,
    templateUrl: 'g-file-input.html',
    bindings: {
      accept: '@',
      asText: '<',
      multiple: '<',
      disabled: '<',
      maxSize: '<',
      onChange: '&',
      onError: '&?',
    },
    transclude: {
      control: '?gFileInputControl',
    },
  })

  /* @ngInject */
  function Controller($element, $timeout, $q, glToast) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.triggerInputClick = triggerInputClick

    function onInit() {
      $timeout(function() {
        ctrl.input = $element.find('input')
        if (ctrl.multiple) {
          ctrl.input.attr('multiple', true)
        }
        ctrl.input.on('change', onInputChange)
      })
    }

    function triggerInputClick() {
      if (ctrl.disabled || ctrl.loading) return
      ctrl.input[0].click()
    }

    function onInputChange(e) {
      var files = e.target.files
      if (!files.length) {
        return
      }

      // no need to validate the file extension for now
      // just return back the data to onChange
      var oversizedFile = _.find(files, function(file) {
        return ctrl.maxSize && file.size > ctrl.maxSize
      })
      if (oversizedFile) {
        reportError({
          type: 'maxSize',
          name: oversizedFile.name,
          size: oversizedFile.size,
          maxSize: ctrl.maxSize,
          message: 'File is too large.',
        })
        rebuild()
        return
      }

      var promises = _.map(files, function(file) {
        var deferred = $q.defer()
        var reader = new FileReader()
        reader.onload = function(e) {
          deferred.resolve({
            data: e.target.result,
            name: file.name,
            size: file.size,
            type: file.type,
          })
        }
        reader.onerror = function(e) {
          deferred.reject(e.target.error)
        }
        if (ctrl.asText) {
          reader.readAsText(file)
        } else {
          reader.readAsDataURL(file)
        }
        return deferred.promise
      })

      ctrl.loading = true
      $q.all(promises)
        .then(function(result) {
          ctrl.onChange({ $files: result })
        })
        .catch(function(err) {
          console.error(err)
          glToast.show('Error encountered on importing files')
        })
        .finally(function() {
          ctrl.loading = false
          rebuild()
        })
    }

    function reportError(error) {
      if (ctrl.onError) {
        ctrl.onError({ $error: error })
        return
      }
      glToast.show(error.message)
    }

    function rebuild() {
      // this is to trigger the onInputChange when selecting the same selected files
      ctrl.input.off('change', onInputChange)
      ctrl.isRebuilding = true
      $timeout(function() {
        ctrl.isRebuilding = false
        onInit()
      })
    }
  }
})()

;(function() {
  'use strict'

  /**
   * IMPORTANT
   *
   * Only use this when necessary. Since it has a perfmance impact,
   * you would likely want to avoid using it with ng-repeat or on
   * a screen that is already doing a lot of work.
   */

  Controller.$inject = ["$scope", "$q", "$window", "$element", "cloudinaryService"];
  angular.module('glow.components').component('gImage', {
    controller: Controller,
    templateUrl: 'g-image.html',
    bindings: {
      src: '<',
      maxWidth: '<',
      maxHeight: '<',
      bg: '@',
      expandWidth: '<', // expand image width to element width
    },
  })

  var testUrls = [
    // long
    'http://www.longrunexploration.com/upload/main_banner/2/05/banner.jpg',
    // tall
    'https://upload.wikimedia.org/wikipedia/commons/3/38/Tampa_FL_Sulphur_Springs_Tower_tall_pano01.jpg',
    // large
    'https://www.highreshdwallpapers.com/wp-content/uploads/2011/09/Large-Format-HD-Wallpaper.jpg?w=640',
    // tiny
    'http://icons.iconarchive.com/icons/papirus-team/papirus-status/24/view-private-icon.png',
  ]
  var cache = {}

  /* @ngInject */
  function Controller($scope, $q, $window, $element, cloudinaryService) {
    var ctrl = this

    ctrl.cycleTest = false
    ctrl.$onChanges = onChanges
    ctrl.onClick = onClick

    function onChanges(changed) {
      if (!ctrl.hasInit) {
        $element.addClass('g-image')
        angular.element($window).on('resize', onBrowserResize)
        ctrl.hasInit = true
      }
      if (changed.src) {
        setSrc(ctrl.src)
      }
    }

    function setSrc(url) {
      ctrl.url = null
      url = cloudinaryService.optimize(url)
      loadImage(url)
        .then(function(image) {
          // clamp by max width/height
          image.maxSize = clamp(
            image.width,
            image.height,
            ctrl.maxWidth,
            ctrl.maxHeight,
            ctrl.expandWidth
          )
          // clamp by DOM width
          var elemWidth = $element[0].offsetWidth
          image.domSize = clamp(
            image.maxSize.width,
            image.maxSize.height,
            elemWidth
          )
          // layout
          ctrl.image = image
          ctrl.styles = {
            width: image.domSize.width + 'px',
            height: image.domSize.height + 'px',
            backgroundColor: ctrl.bg,
          }
          ctrl.url = url
        })
        .catch(function() {
          // faily silently we don't care :)
        })
    }

    function onBrowserResize() {
      $scope.$applyAsync(function() {
        if (!ctrl.image) {
          return
        }
        var elemWidth = $element[0].offsetWidth
        var elemHeight = $element[0].offsetHeight
        var image = ctrl.image
        image.domSize = clamp(
          image.maxSize.width,
          image.maxSize.height,
          elemWidth,
          elemHeight, // ensure image height does not revert to original
          ctrl.expandWidth // ensure expand width applied after browser resize
        )
        ctrl.styles = {
          width: image.domSize.width + 'px',
          height: image.domSize.height + 'px',
        }
      })
    }

    function loadImage(url) {
      return $q(function(resolve, reject) {
        var cached = cache[url]
        if (cached) {
          resolve(cached)
        } else {
          var image = new Image()
          image.onload = function() {
            resolve(image)
            cache[url] = image
          }
          image.onerror = function(error) {
            reject(error)
          }
          image.src = url
        }
      })
    }

    function clamp(
      originalWidth,
      originalHeight,
      maxWidth,
      maxHeight,
      expandWidth
    ) {
      // clamp width first
      var width = _.clamp(originalWidth, maxWidth)

      if (expandWidth) {
        // when expandWidth is true, use element width if original width is smaller
        var elemWidth = $element[0].offsetWidth
        width = width < elemWidth ? elemWidth : width
      }

      var ratio = width / originalWidth
      var height = ratio * originalHeight
      // then adjust height
      if (maxHeight) {
        height = _.clamp(height, maxHeight)
        ratio = height / originalHeight
        width = ratio * originalWidth
      }
      return {
        width: width,
        height: height,
      }
    }

    function onClick() {
      if (!ctrl.cycleTest) {
        return
      }
      var url = testUrls.pop()
      testUrls.unshift(url)
      setSrc(url)
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').directive('gMenuBox', Directive)

  /* @ngInject */
  function Directive() {
    return {
      restrict: 'E',
      link: PostLink,
    }

    function PostLink(scope, elem, attrs) {
      elem.addClass('g-menu-box')
      if (attrs.maxWidth) {
        elem.css('max-width', attrs.maxWidth)
      }
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').directive('gMenuContent', Directive)

  function Directive() {
    return {
      restrict: 'A',
      scope: true,
      compile: compile,
      require: '^gMenu',
    }

    function compile(tElement) {
      tElement.removeAttr('g-menu-content')
      var html = tElement[0].outerHTML
      tElement.empty()
      return postLink

      function postLink(scope, elem, attrs, ctrl) {
        ctrl.register(html, scope)
        elem.remove()
      }
    }
  }
})()

;(function() {
  'use strict'

  Directive.$inject = ["$window", "$document", "$timeout", "$animate"];
  angular.module('glow.components').directive('gMenuMount', Directive)

  /* @ngInject */
  function Directive($window, $document, $timeout, $animate) {
    return {
      restrict: 'E',
      link: PostLink,
    }

    function PostLink(scope, elem) {
      var body = angular.element($document[0].body)

      elem.addClass('g-menu-mount')
      scope.$apply()

      $timeout(position, 10)

      scope.$on('$destroy', onDestroy)

      function position() {
        var scrollY = $window.pageYOffset
        var offset = 0
        var options = elem[0].getBoundingClientRect()
        var target = scope.target[0].getBoundingClientRect()

        // console.log('options', options);
        // console.log('target', target);

        if (scope.fixed) {
          elem.addClass('-fixed')
        }

        var alignment = scope.align || 'bottom'
        elem.addClass('-align-' + alignment)

        alignment = alignment.split('-')
        var vertical = alignment[0] || 'bottom'
        var horizontal = alignment[1]

        // console.log('pos', vertical, horizontal);

        switch (vertical) {
          case 'bottom':
            elem.css(
              'top',
              target.bottom + (scope.fixed ? 0 : scrollY) + offset + 'px'
            )
            break
          case 'top':
            elem.css(
              'top',
              target.top -
                options.height -
                offset +
                (scope.fixed ? 0 : scrollY) +
                'px'
            )
            break
        }

        switch (horizontal) {
          case 'left':
            elem.css('left', target.left + 'px')
            break
          case 'right':
            elem.css('left', target.right - options.width + 'px')
            break
          case 'attach':
            var left = target.left
            var width = Math.max(target.width, 250)
            if (left + width > body[0].offsetWidth) {
              console.log('width overshoots page, clamping back')
              left = body[0].offsetWidth - width
            }
            elem.css({
              left: left + 1 + 'px',
              width: width - 2 + 'px',
            })
            break
          default:
            elem.css(
              'left',
              target.left + target.width / 2 - options.width / 2 + 'px'
            )
            break
        }

        // if the height overflows the window, cap it!
        var box = elem[0].getBoundingClientRect()
        var overflow = box.bottom - window.innerHeight
        // console.log('box', box)
        if (overflow > 0) {
          elem.css('max-height', box.height - overflow + 'px')
          // console.log('clamp!')
        }

        $animate.addClass(elem, '-visible')
        body.on('click', onBodyClick)
      }

      function onBodyClick(e) {
        // do nothing if input focused
        if (
          !scope.closeOnInputFocus &&
          document.activeElement &&
          document.activeElement.nodeName === 'INPUT'
        ) {
          return
        }
        scope.$applyAsync(function() {
          close()
        })
      }

      function close() {
        $animate.removeClass(elem, '-visible').then(function() {
          scope.close()
        })
      }

      function onDestroy() {
        body.off('click', onBodyClick)
      }
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').directive('gMenuOpen', Directive)

  /* @ngInject */
  function Directive() {
    return {
      restrict: 'A',
      scope: {
        gMenuOpen: '<',
      },
      link: PostLink,
    }

    function PostLink(scope, elem) {
      scope.$on('$destroy', onDestroy)
      elem.on('click', onClick)

      function onClick(e) {
        if (scope.gMenuOpen === true || scope.gMenuOpen === 0) {
          e.stopPropagation()
        }
      }

      function onDestroy() {
        elem.off('click', onClick)
      }
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$element", "gMenu"];
  angular.module('glow.components').component('gMenu', {
    templateUrl: 'g-menu.html',
    controller: Controller,
    bindings: {
      fixed: '<',
      align: '@',
      inline: '=',
      disabled: '<',
      closeOnInputFocus: '<',
      onRemote: '&',
      onBeforeOpen: '&',
      onOpen: '&',
      onClose: '&',
    },
    transclude: true,
  })

  /* @ngInject */
  function Controller($element, gMenu) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy
    ctrl.register = register
    ctrl.onClick = onClick

    function onInit() {
      $element.addClass('g-menu')
      if (ctrl.inline) {
        $element.addClass('-inline')
      }
      $element.on('click', onClick)
    }

    function register(content, scope) {
      ctrl.id = gMenu.register({
        content: content,
        scope: scope,
        target: $element,
        fixed: ctrl.fixed,
        align: ctrl.align,
        closeOnInputFocus: ctrl.closeOnInputFocus,
        onBeforeOpen: ctrl.onBeforeOpen,
        onOpen: ctrl.onOpen,
        onClose: ctrl.onClose,
      })
      ctrl.onRemote({ $remote: { open: open, close: close } })
    }

    function onClick(event) {
      open(event)
    }

    function open(event) {
      if (ctrl.disabled || !ctrl.id) {
        return
      }
      gMenu.open(ctrl.id, event)
    }

    function close(event) {
      gMenu.close(ctrl.id, event)
    }

    function onDestroy() {
      $element.off('click', onClick)
      gMenu.unregister(ctrl.id)
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$log", "$q", "$rootScope", "$document", "$compile"];
  angular.module('glow.components').service('gMenu', Service)

  function Service($log, $q, $rootScope, $document, $compile) {
    var log = $log.create('gMenu')
    var body = angular.element($document[0].body)
    var menus = {}
    var lastId = 0

    return {
      register: register,
      open: open,
      close: close,
      unregister: unregister,
    }

    function register(options) {
      var id = ++lastId
      menus[id] = options
      return id
    }

    function open(id, event) {
      var menu = menus[id]

      if (menu.mount) {
        return // already open
      }

      var result = menu.onBeforeOpen({ $event: event })
      if (result === false) {
        log.info('menu will not open')
        return
      }

      var mount = (menu.mount = {})
      mount.scope = menu.scope.$new()
      mount.scope.target = menu.target
      mount.scope.fixed = menu.fixed
      mount.scope.align = menu.align
      mount.scope.contentMaxWidth = menu.contentMaxWidth
      mount.scope.closeOnInputFocus = menu.closeOnInputFocus
      mount.scope.close = function() {
        close(id)
      }
      mount.elem = $compile(
        '<g-menu-mount>' + menu.content + '</g-menu-mount>'
      )(mount.scope)
      body.append(mount.elem)
      menu.onOpen()
    }

    function close(id) {
      var menu = menus[id]
      if (menu && menu.mount) {
        menu.mount.scope.$destroy()
        menu.mount.elem.remove()
        menu.mount = undefined
        menu.onClose()
      }
    }

    function unregister(id) {
      var mount = menus[id] && menus[id].mount
      if (mount) {
        mount.scope.$destroy()
        mount.elem.remove()
      }
      delete menus[id]
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["colors", "$element"];
  angular.module('glow.components').component('gSpinner', {
    controller: Controller,
    templateUrl: 'g-spinner.html',
    bindings: {
      sizeProp: '@size',
      colorProp: '@color',
      block: '<',
    },
  })

  /* @ngInject */
  function Controller(colors, $element) {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      ctrl.size = parseSize(ctrl.sizeProp)
      ctrl.color = parseColor(ctrl.colorProp)
      if (ctrl.block) {
        $element.addClass('-block')
      }
    }

    function parseSize(sizeProp) {
      if (!sizeProp) {
        return 30
      }
      if (sizeProp.toLowerCase() === 'small') {
        return 15
      }
      if (sizeProp.toLowerCase() === 'large') {
        return 40
      }
      return parseInt(sizeProp)
    }

    function parseColor(colorProp) {
      if (!colorProp) {
        colorProp = 'BLACK'
      }
      if (colorProp.toLowerCase() === 'rainbow') {
        ctrl.rainbow = true
        return null
      }
      return colors.parse(colorProp)
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$element"];
  angular.module('glow.components.glClouds').component('glClouds', {
    controller: Controller,
    templateUrl: 'gl-clouds.template.html',
    transclude: true,
    bindings: {
      bottom: '=',
    },
  })

  /* @ngInject */
  function Controller($element) {
    $element.addClass('gl-clouds')
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('gGtin', Service)

  function Service() {
    // GTIN barcodes are 8, 12, 13 or 14 digits long
    var VALID_GTIN_REGEX = /^[\d]{8}(?:\d{4,6})?$/

    return {
      isValid: isValid,
    }

    function isValid(barcode) {
      return VALID_GTIN_REGEX.test(barcode)
    }
  }
})()

;(function() {
  'use strict'

  Directive.$inject = ["gGtin"];
  angular.module('glow.components').directive('gGtin', Directive)

  /* @ngInject */
  function Directive(gGtin) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: link,
    }

    function link(scope, elem, attrs, ctrl) {
      ctrl.$validators.gtin = function(barcode) {
        return gGtin.isValid(barcode)
      }
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$rootScope", "glToast", "subscriberService", "userService", "configService"];
  angular.module('glow.components').service('helpService', Service)

  /* @ngInject */
  function Service(
    $rootScope,
    glToast,
    subscriberService,
    userService,
    configService
  ) {
    var BEACON_ID = 'a396deb1-4c38-4d4c-807a-ed6fc0963598'
    var isProduction = configService.isProduction()

    // For more info see docs:-
    // https://developer.helpscout.com/beacon-2/web/javascript-api/

    this.isSupported = isSupported
    this.init = init
    this.open = open
    this.close = close
    this.hide = hide
    this.show = show
    this.chat = chat
    this.search = search
    this.suggest = suggest
    this.article = article

    function isSupported(errorMessage) {
      var supported = isProduction && !!window.Beacon
      if (!supported && errorMessage) {
        glToast.show(errorMessage)
      }
      return supported
    }

    function init() {
      if (!isSupported()) return
      window.Beacon('init', BEACON_ID)
      identify()
      $rootScope.$on(subscriberService.Events.CHANGE, identify)
      $rootScope.$on(userService.Events.CHANGE, identify)
    }

    function identify() {
      if (!isSupported()) return
      var user = userService.getUser()
      var subscriber = subscriberService.getSubscriber()
      var loggedIn = user && subscriber
      if (loggedIn) {
        window.Beacon('identify', {
          name: user.fullname || user.username,
          email: user.email,
          userId: user.id,
          subscriberId: subscriber.id,
          subscriberName: subscriber.name,
          planId: subscriber.plan.id,
          planName: subscriber.plan.name,
          country: subscriber.country ? subscriber.country.name : null,
        })
      } else {
        window.Beacon('logout')
      }
    }

    function open() {
      if (!isSupported('Could not open help')) return
      window.Beacon('open')
    }

    function close() {
      if (!isSupported()) return
      window.Beacon('close')
    }

    function hide() {
      if (!isSupported()) return
      window.Beacon('config', { display: { style: 'manual' } })
    }

    function show() {
      if (!isSupported()) return
      window.Beacon('config', { display: { style: 'icon' } })
    }

    function chat() {
      if (!isSupported('Could not open chat')) return
      window.Beacon('open')
      window.Beacon('navigate', '/ask/chat/')
    }

    function search(query) {
      if (!isSupported('Could not open help')) return
      window.Beacon('search', query)
    }

    function suggest(articleIds) {
      if (!isSupported('Could not open articles')) return
      window.Beacon('suggest', articleIds)
    }

    function article(articleId, type) {
      if (!isSupported('Could not open article')) return
      // if no type is specified, it will open in the beacon.
      // alternative you can open it in a sidebar or modal :)
      var options
      if (_.includes(['sidebar', 'modal'], type)) {
        options = { type: type }
      }
      window.Beacon('article', articleId, options)
    }
  }
})()

;(function() {
  'use strict'

  Directive.$inject = ["$window", "$document"];
  angular.module('glow.components.hint').directive('glHintBox', Directive)

  function Directive($window, $document) {
    return {
      restict: 'E',
      link: PostLink,
      transclude: true,
      templateUrl: 'hint-box.template.html',
    }

    function PostLink(scope, elem) {
      var pointerElem
      var targetBounds
      var hintBounds
      var scrollY
      var pageHeight
      var pointerAbove
      var hintPos = {}

      scope.$applyAsync(activate)

      function activate() {
        elem.addClass('hint')

        pointerElem = angular.element(
          elem[0].getElementsByClassName('hint__pointer')
        )
        targetBounds = scope.target[0].getBoundingClientRect()
        hintBounds = elem[0].getBoundingClientRect()
        scrollY = $window.pageYOffset
        pageHeight = $document[0].body.scrollHeight

        // console.log('targetBounds', targetBounds);
        // console.log('hintBounds', hintBounds);
        // console.log('scrollY', scrollY);
        // console.log('pageHeight', pageHeight);

        positionHorizontally()
        positionVertically()
        positionPointer()

        // display hint
        elem.css({ opacity: 1 })
      }

      function positionHorizontally() {
        // start by centering
        hintPos.x =
          targetBounds.left + targetBounds.width / 2 - hintBounds.width / 2

        // ensure it doesn't go off the left edge (right side adjusts with page flow)
        hintPos.x = _.clamp(hintPos.x, 3, 9999999)

        // update position
        elem.css({ left: hintPos.x + 'px' })
      }

      function positionVertically() {
        // recalculate hintBounds (horizontally position could have changed it)
        hintBounds = elem[0].getBoundingClientRect()

        // prefer to put above target
        if (targetBounds.top >= hintBounds.height) {
          hintPos.y = targetBounds.top + scrollY - hintBounds.height - 3
          pointerAbove = false

          // otherwise try below
        } else if (pageHeight - targetBounds.bottom >= hintBounds.height) {
          hintPos.y = targetBounds.top + targetBounds.height + scrollY + 3
          pointerAbove = true

          // if it doesnt fit anywhere, just go above
        } else {
          hintPos.y = targetBounds.top + scrollY - hintBounds.height - 3
          pointerAbove = false
        }

        // update position
        elem.css({ top: hintPos.y + 'px' })
      }

      function positionPointer() {
        // add class for above/below
        pointerElem.addClass(pointerAbove ? '-above' : '-below')

        // move pointer horizontally to be right above element
        var left = targetBounds.left + targetBounds.width / 2 - hintPos.x

        // ensure it doesnt go past the edges
        left = _.clamp(left, 12, hintBounds.width - 12)

        // update position
        pointerElem.css({ left: left + 'px' })
      }
    }
  }
})()

;(function() {
  'use strict'

  Directive.$inject = ["$log", "$timeout"];
  angular.module('glow.components.hint').directive('glHint', Directive)

  /*
   * @name gl-hint
   * @desc Display a hint popup on hover or focus
   * @example
   * // Use as an attribute
   * .button(gl-hint='Hello {{ name }}')
   * // Use as an element
   * .button
   *     gl-hint
   *         h4 Hello {{ name }}
   *         p I fully support jade and child scope/directive logic!
   */

  function Directive($log, $timeout) {
    Controller.$inject = ["$scope", "glHint"];
    var log = $log.create('glHint')
    var lastFocusId = 0

    return {
      restict: 'EA',
      scope: true,
      link: PostLink,
      controller: Controller,
    }

    function PostLink(scope, elem) {
      var isAttribute = elem[0].nodeName !== 'GL-HINT'

      if (isAttribute) {
        scope.target = elem
        scope.content = elem.attr('gl-hint')
      } else {
        scope.target = elem.parent()
        scope.attachment = elem.attr('attach-to')
        scope.content = elem.html()
        elem.empty()
      }

      scope.activate()
    }

    function Controller($scope, glHint) {
      $scope.activate = activate

      function activate() {
        $scope.target.on('mouseenter focus touchstart', onEnter)
        $scope.target.on('mouseleave blur', onLeave)
        $scope.$on('$destroy', onDestroy)
      }

      function onEnter(e) {
        if ($scope.isFocused) return

        $scope.isFocused = true
        var focusId = ++lastFocusId
        var isTouch = e.type === 'touchstart'

        $timeout(
          function() {
            if (!$scope.isFocused || focusId !== lastFocusId) {
              return
            }

            var attachElem = $scope.attachment
              ? $scope.target[0].getElementsByClassName($scope.attachment)
              : null

            if ($scope.attachment && !attachElem.length) {
              log.warn('target not found, falling back to root element')
              attachElem = null
            }

            glHint.show($scope, attachElem || $scope.target, $scope.content)

            // track outside touch to leave (eg for mobile)
            if (isTouch) {
              document.body.addEventListener('touchstart', checkTouchLeave)
            }
          },
          isTouch ? 0 : 350
        )
      }

      function checkTouchLeave(e) {
        var didLeave = true
        var node = e.target
        while (node) {
          if (node === $scope.target[0]) {
            didLeave = false
            break
          }
          node = node.parentNode
        }
        if (didLeave) onLeave()
      }

      function onLeave() {
        $scope.isFocused = false
        glHint.hide()
        document.body.removeEventListener('touchstart', checkTouchLeave)
      }

      function onDestroy() {
        $scope.target.off('mouseenter focus touchstart', onEnter)
        $scope.target.off('mouseleave blur', onLeave)
        onLeave()
      }
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$rootScope", "$document", "$compile"];
  angular.module('glow.components.hint').service('glHint', Service)

  function Service($rootScope, $document, $compile) {
    var body = angular.element($document[0].body)
    var active = []

    return {
      show: show,
      hide: hide,
    }

    function show(scope, elem, content) {
      scope = scope.$new()
      scope.target = elem

      var hint = $compile(
        '<gl-hint-box class="hint">' + content + '</gl-hint-box>'
      )(scope)
      body.append(hint)

      active.push({
        elem: hint,
        scope: scope,
      })
    }

    function hide() {
      while (active.length) {
        var hint = active.pop()
        hint.scope.$destroy()
        hint.elem.remove()
      }
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["$filter", "Price"];
  angular.module('glow.components').factory('HostingCreditPurchase', Factory)

  /* @ngInject */
  function Factory($filter, Price) {
    var creditsFilter = $filter('credits')

    function HostingCreditPurchase(pricing, units) {
      this.pricing = pricing
      this.applyDefaults()
      this.setUnits(units)
    }

    HostingCreditPurchase.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        units: null,
        price: new Price(),
        pricePerUnit: new Price(),
        autoRenewEnabled: false,
      })
    }

    HostingCreditPurchase.prototype.setUnits = function(units) {
      this.units = units
      this.updatePricing()
    }

    HostingCreditPurchase.prototype.isValid = function() {
      return _.isNumber(this.units)
    }

    HostingCreditPurchase.prototype.updatePricing = function() {
      if (!this.isValid()) {
        // reset prices
        this.price = new Price()
        this.pricePerUnit = new Price()
        return
      }

      var self = this
      var priceData = {}
      var pricePerUnitData = {}
      var tier = this.findPricingTier()
      _.each(tier.pricePerUnit.list, function(money) {
        var currency = money.currency
        var startingTotal = tier.startingTotalPrice.byCurrency(currency)
        var total =
          (self.units - tier.startingUnits) * money.amount +
          startingTotal.amount
        priceData[currency] = total
        pricePerUnitData[currency] = total / self.units
      })
      this.price.deserialize(priceData)
      this.pricePerUnit.deserialize(pricePerUnitData)
    }

    HostingCreditPurchase.prototype.findPricingTier = function() {
      var self = this
      var tier = _.find(this.pricing, function(tier) {
        return self.units <= tier.maxUnits
      })
      // If no tier found (units exceed all tiers), return the highest tier
      return tier || _.last(this.pricing)
    }

    HostingCreditPurchase.prototype.formatUnits = function(capitalize) {
      return creditsFilter(this.units, capitalize)
    }

    return HostingCreditPurchase
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["$filter", "CreditPromotion"];
  angular.module('glow.components').factory('HostingCredit', Factory)

  /* @ngInject */
  function Factory($filter, CreditPromotion) {
    var creditsFilter = $filter('credits')

    function HostingCredit(pricing) {
      this.pricing = pricing
      this.applyDefaults()
    }

    HostingCredit.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        balance: null,
        autoRenewal: {
          enabled: false,
          units: null,
        },
        promotion: null,
      })
    }

    HostingCredit.prototype.deserialize = function(data) {
      this.balance = data.balance
      this.autoRenewal.enabled = data.autoRenewal.enabled
      this.autoRenewal.units = data.autoRenewal.units

      this.updatePromotion(data)
      this.applyDefaults()
      return this
    }

    HostingCredit.prototype.updatePromotion = function(data) {
      var promo = data && data.promotion
      if (!promo) {
        this.promotion = null
        return
      }
      if (this.promotion) {
        this.promotion.deserialize(promo)
      } else {
        this.promotion = new CreditPromotion().deserialize(promo)
      }
    }

    HostingCredit.prototype.updateBalance = function(data) {
      this.balance = data.balance
      this.updatePromotion(data)
      this.applyDefaults()
    }

    HostingCredit.prototype.updateAutoRenewal = function(data) {
      this.autoRenewal.enabled = data.enabled
      this.autoRenewal.units = data.units
      this.applyDefaults()
    }

    HostingCredit.prototype.isZero = function() {
      return this.getTotalBalance() === 0
    }

    HostingCredit.prototype.isAutoRenew = function() {
      return this.autoRenewal.enabled
    }

    HostingCredit.prototype.getPromotionBalance = function() {
      return this.hasActivePromotion() ? this.promotion.totalBalance : 0
    }

    HostingCredit.prototype.getTotalBalance = function() {
      return this.balance + this.getPromotionBalance()
    }

    HostingCredit.prototype.formatBalance = function(capitalize) {
      return creditsFilter(this.balance, capitalize)
    }

    HostingCredit.prototype.formatPromotionBalance = function(capitalize) {
      return creditsFilter(this.getPromotionBalance(), capitalize)
    }

    HostingCredit.prototype.formatTotalBalance = function(capitalize) {
      return creditsFilter(this.getTotalBalance(), capitalize)
    }

    HostingCredit.prototype.hasActivePromotion = function() {
      return this.promotion && this.promotion.isActive()
    }

    HostingCredit.prototype.hasPendingPromotion = function() {
      return this.promotion && this.promotion.isPending()
    }

    HostingCredit.prototype.getBalanceHint = function() {
      if (!this.promotion) return ''

      var subscriptionCode = this.promotion.subscriptionCode
      return `${subscriptionCode} Credits: ${this.formatPromotionBalance()}
              <br> Other Credits: ${this.formatBalance()}
              <br>
              <br> Note: While ${subscriptionCode} is active any available credits from this will be used prior to other credits being consumed.`
    }

    return HostingCredit
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "api", "Price", "HostingCredit"];
  angular.module('glow.components').service('hostingCreditService', Service)

  /* @ngInject */
  function Service($q, api, Price, HostingCredit) {
    var self = this

    var COST_PER_COMPLETE = 1
    var COST_PER_EXIT = 0

    self.COST_PER_COMPLETE = COST_PER_COMPLETE
    self.COST_PER_EXIT = COST_PER_EXIT

    self.load = load
    self.getBalance = getBalance
    self.getAutoRenewal = getAutoRenewal
    self.refreshBalance = refreshBalance
    self.refreshAutoRenewal = refreshAutoRenewal
    self.getPricing = getPricing
    self.topUp = topUp
    self.saveAutoRenewal = saveAutoRenewal
    self.listClaimedIncentives = listClaimedIncentives
    self.claimIncentive = claimIncentive

    function load(subscriberId) {
      return $q
        .all({
          balance: self.getBalance(subscriberId),
          autoRenewal: self.getAutoRenewal(subscriberId),
          pricing: self.getPricing(),
        })
        .then(function(result) {
          var data = {
            balance: result.balance.balance,
            autoRenewal: result.autoRenewal,
            promotion: result.balance.promotion || null,
          }
          return new HostingCredit(result.pricing).deserialize(data)
        })
    }

    function getBalance(subscriberId) {
      return api.subscriberCredits.getBalance({ subscriberId: subscriberId })
    }

    function getAutoRenewal(subscriberId) {
      return api.subscriberCredits.getAutoRenewal({
        subscriberId: subscriberId,
      })
    }

    function refreshBalance(subscriber) {
      return getBalance(subscriber.id).then(function(data) {
        subscriber.hostingCredit.updateBalance(data)
        return subscriber
      })
    }

    function refreshAutoRenewal(subscriber) {
      return getAutoRenewal(subscriber.id).then(function(data) {
        subscriber.hostingCredit.updateAutoRenewal(data)
        return subscriber
      })
    }

    function getPricing() {
      return api.subscriberCredits.getCostsByUnit().then(makePricing)
    }

    function makePricing(costData) {
      var tiers = _.sortBy(costData[0].costs, 'units')
      var prevUnits = 0
      var prevTotalPriceData = {}
      return _.map(tiers, function(tier) {
        var startingUnits = prevUnits
        prevUnits = tier.units
        var pricePerUnitData = {}
        var startingTotalPriceData = {}
        costData.forEach(function(costByCurrency) {
          var currency = costByCurrency.currency
          var matchingTier = _.find(costByCurrency.costs, { units: tier.units })
          pricePerUnitData[currency] = matchingTier.perUnit
          startingTotalPriceData[currency] = prevTotalPriceData[currency] || 0
          prevTotalPriceData[currency] =
            startingTotalPriceData[currency] +
            (prevUnits - startingUnits) * matchingTier.perUnit
        })
        return {
          maxUnits: tier.units,
          pricePerUnit: new Price().deserialize(pricePerUnitData),
          startingUnits: startingUnits,
          startingTotalPrice: new Price().deserialize(startingTotalPriceData),
        }
      })
    }

    function topUp(subscriber, units, reason) {
      var options = {
        subscriberId: subscriber.id,
        units: units,
      }
      if (reason) {
        // Admin portal user need a reason to allocate credits
        options.reference = { reason: reason }
      }
      return api.subscriberCredits
        .topUp(options)
        .then(refreshBalance.bind(self, subscriber))
    }

    function saveAutoRenewal(subscriber, enabled, units) {
      var options = {
        subscriberId: subscriber.id,
        enabled: enabled,
      }
      if (units) {
        options.units = units
      }
      return api.subscriberCredits
        .saveAutoRenewal(options)
        .then(refreshAutoRenewal.bind(self, subscriber))
    }

    function listClaimedIncentives(subscriberId) {
      return api.subscriberCredits.listClaimedIncentives({
        subscriberId: subscriberId,
      })
    }

    function claimIncentive(subscriber, data) {
      var options = _.assign({ subscriberId: subscriber.id }, data)
      return api.subscriberCredits
        .claimIncentive(options)
        .then(refreshBalance.bind(self, subscriber))
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$scope", "colors"];
  angular.module('glow.components.icon').component('gIcon', {
    controller: Controller,
    templateUrl: 'icon.template.html',
    bindings: {
      colorValue: '@color',
      icon: '@',
      strike: '<',
      sizeProp: '@size',
      shadow: '@',
      inherit: '<',
    },
  })

  /* @ngInject */
  function Controller($scope, colors) {
    var Colors = colors.Colors
    var ctrl = this

    var Sizes = {
      tiny: 10,
      small: 16,
      medium: 24,
      large: 36,
      extraLarge: 56,
    }

    var DEFAULT_ICON = 'important'
    var DEFAULT_SIZE = Sizes.medium
    var DEFAULT_COLOR = Colors.BLACK

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges

    function onInit() {
      update()
    }

    function onChanges() {
      update()
    }

    function update() {
      var size = parseInt(Sizes[ctrl.sizeProp] || ctrl.sizeProp || DEFAULT_SIZE)
      ctrl.icon = ctrl.icon || DEFAULT_ICON

      ctrl.class = {}
      ctrl.class['gi-' + ctrl.icon] = true
      ctrl.class['-strike'] = ctrl.strike

      ctrl.style = {
        fontSize: size + 'px',
        width: size + 2 + 'px',
        height: size + 2 + 'px',
      }

      if (!ctrl.inherit) {
        ctrl.style.color = colors.parse(ctrl.colorValue) || DEFAULT_COLOR
        ctrl.style.textShadow = ctrl.shadow
      }
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["colors"];
  angular.module('glow.components.iconButton').component('gIconButton', {
    controller: Controller,
    templateUrl: 'icon-button.template.html',
    bindings: {
      icon: '@',
      colorValue: '@color',
      hoverColorValue: '@hoverColor',
      size: '@',
      shadow: '@',
      hoverShadow: '@',
      disabled: '<',
      disabledColorValue: '@disabledColor',
      hint: '@',
      onClick: '&',
    },
  })

  /* @ngInject */
  function Controller(colors) {
    var ctrl = this
    var Colors = colors.Colors

    var DEFAULT_COLOR = 'rgba(BLACK, 0.6)'
    var DEFAULT_HOVER_COLOR = Colors.BLACK
    var DEFAULT_DISABLED_COLOR = 'rgba(BLACK, .2)'

    ctrl.$onChanges = onChanges
    ctrl.click = click

    function onChanges() {
      update()
    }

    function click($event) {
      $event.preventDefault()
      if (!ctrl.disabled) {
        ctrl.onClick({ $event: $event })
      }
    }

    function update() {
      ctrl.color = ctrl.colorValue || DEFAULT_COLOR
      ctrl.hoverColor = ctrl.hoverColorValue || DEFAULT_HOVER_COLOR
      ctrl.disabledColor = ctrl.disabledColorValue || DEFAULT_DISABLED_COLOR
    }
  }
})()

;(function() {
  'use strict'

  var VALID_FILETYPES = [
    'image/bmp',
    'image/gif',
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
  ]

  angular
    .module('glow.components.imageInput')
    .directive('glImageInput', imageInputDirective)

  /* @ngInject */
  function imageInputDirective() {
    controller.$inject = ["$scope", "$timeout", "$element"];
    return {
      restrict: 'E',
      templateUrl: 'image-input.template.html',
      replace: true,
      scope: {
        src: '=',
        onChange: '&',
        canRemove: '=?',
        onError: '&',
        hint: '@',
        ratio: '@',
      },
      controller: controller,
    }

    function controller($scope, $timeout, $element) {
      if ($scope.canRemove !== false) {
        $scope.canRemove = true
      }

      $scope.isValidFile = isValidFile
      $scope.imageUrl = imageUrl
      $scope.imageStyle = imageStyle
      $scope.clear = clear
      $scope.rebuild = rebuild
      $scope.ratioStyle = ratioStyle

      $timeout(init)

      function init() {
        $element.find('input').bind('change', onInputChange)
      }

      function onInputChange(e) {
        if (!isValidFile(e.target.files[0])) {
          return displayInvalidError()
        }

        var reader = new FileReader()
        reader.onload = onReaderLoad
        reader.readAsDataURL(e.target.files[0])
      }

      function onReaderLoad(event) {
        // Logic to extract size if needed in future
        // var img = new Image();
        // img.onload = function () {
        //     // console.log('image size: ' + img.width + 'x' + img.height + 'px');
        // };
        // img.src = reader.result;
        $scope.error = null

        // Make changes and fire onChange method
        $scope.$apply(function() {
          var imageData = event.target.result
          $scope.imageData = imageData
          if ($scope.onChange) {
            $scope.onChange({ $imageData: $scope.imageData })
          }
        })
      }

      function displayInvalidError() {
        $element.find('input').unbind('change', onInputChange)
        clear()
        rebuild()
        var error = 'Invalid File. Must be PNG, JPEG, JPG, BMP, GIF or SVG.'
        $scope.onError({ $error: error })
        $scope.error = error
        return
      }

      function imageUrl() {
        return $scope.imageData || $scope.src
      }

      function imageStyle() {
        var url = imageUrl()
        return url && { backgroundImage: 'url(' + url + ')' }
      }

      function isValidFile(file) {
        return file && _.indexOf(VALID_FILETYPES, file.type) >= 0
      }

      function clear() {
        $scope.src = null
        $scope.imageData = null
        if ($scope.onChange) {
          $scope.onChange({ $imageData: $scope.imageData })
        }
      }

      function rebuild() {
        $scope.rebuilding = true
        $timeout(function() {
          $scope.rebuilding = false
          $timeout(init)
        })
      }

      function ratioStyle() {
        return {
          display: 'block',
          paddingTop: $scope.ratio * 100 + '%',
        }
      }
    }
  }
})()

;(function() {
  'use strict'

  /**
   * @name components.imageViewer
   * @description
   */
  glImageViewerDirective.$inject = ["$log", "glImageViewerService"];
  angular
    .module('glow.components.imageviewer')
    .directive('glImageViewer', glImageViewerDirective)

  /* @ngInject */
  function glImageViewerDirective($log, glImageViewerService) {
    var log = $log.create ? $log.create('glImageViewDirective') : $log

    return {
      restrict: 'A',
      link: link,
    }

    function link(scope, element, attrs) {
      // check ng-src attribute exists
      if (typeof attrs.ngSrc !== 'string' || (attrs.ngSrc + '').length === 0) {
        element.addClass('invalid')
        log.error('ng-src must be defined on image-viewer element')
      }

      // add class to element to attach styling
      element.addClass('gl-img-view-base')

      // event listeners
      element.on('load', onLoad)
      element.on('error', onError)
      element.on('click', onClick)

      // on image load
      function onLoad() {
        element.addClass('loaded')
      }

      // on image load error
      function onError() {
        element.addClass('load-error')
        log.error('image could not be loaded')
      }

      // click event handler - show image viewer modal
      function onClick() {
        scope.$evalAsync(function() {
          glImageViewerService.show(attrs.ngSrc, element)
        })
      }
    }
  }
})()

;(function() {
  'use strict'

  /**
   * @name components.imageViewer
   * @description
   */
  glImageViewerService.$inject = ["$animate", "$compile", "$rootElement", "$rootScope", "$window", "keyEventService"];
  angular
    .module('glow.components.imageviewer')
    .service('glImageViewerService', glImageViewerService)

  /* @ngInject */
  function glImageViewerService(
    $animate,
    $compile,
    $rootElement,
    $rootScope,
    $window,
    keyEventService
  ) {
    var WINDOW_PADDING = 20

    var modalElem
    var imageElem
    var img
    var keyHandlerHash

    var template =
      '<div class="image-modal" ng-click="close()"><img class="image" ng-src={{data.src}}></div>'

    var service = {
      show: show,
    }
    return service

    function show(src, origElement) {
      var animationActive = false

      // initialise
      init()

      /**
       * initialise image viewer modal
       */
      function init() {
        loadImage(src)
        angular.element($window).on('resize', _.debounce(onWindowResize, 200))
      }

      /**
       * resize the image to new window size
       */
      function onWindowResize() {
        $rootScope.$evalAsync(function() {
          $animate
            .animate(imageElem, {}, getFinalDims(), 'animate')
            .then(onOpen)

          function onOpen() {
            animationActive = false
          }
        })
      }

      /**
       * load the required image so we can get the dimensions
       */
      function loadImage() {
        img = new Image()
        img.onload = onImageLoaded()
        img.src = src
      }

      /**
       * image laoded
       */
      function onImageLoaded() {
        showModal()
      }

      /**
       * display image viewer modal - compile against new scope and append to DOM
       */
      function showModal() {
        modalElem = null

        // element to add modal window to - if cannot find body, use the app's root element
        var parent = $rootElement.find('body')
        if (!parent.length) {
          parent = $rootElement
        }

        // create new scope and attatch image source and close method
        var scope = $rootScope.$new()
        scope.data = {}
        scope.data.src = src
        scope.close = closeModal

        modalElem = $compile(template)(scope)
        imageElem = angular.element(
          modalElem[0].getElementsByClassName('image')
        )

        // add modalElem to DOM
        parent.append(modalElem)

        openModal()
      }

      /**
       * close image view modal, once animation is complete remove element from DOM
       */
      function closeModal() {
        if (animationActive) {
          return
        }

        animationActive = true
        $animate.removeClass(modalElem, 'active')
        $rootScope.$evalAsync(function() {
          $animate
            .animate(imageElem, getFinalDims(), getStartDims(), 'animate')
            .then(onClosed)

          function onClosed() {
            animationActive = false
            modalElem.remove()
          }
        })

        // unregister escape key
        keyEventService.unregisterKeyEvent(keyHandlerHash)
      }

      /**
       * animate opening modal window and image
       */
      function openModal() {
        animationActive = true
        $animate.addClass(modalElem, 'active')
        $rootScope.$evalAsync(function() {
          $animate
            .animate(imageElem, getStartDims(), getFinalDims(), 'animate')
            .then(onOpen)

          function onOpen() {
            animationActive = false
          }
        })

        // register escape key
        keyHandlerHash = keyEventService.registerKeyEvent(
          keyEventService.KEY.escape,
          function() {
            closeModal()
          },
          50
        )
      }

      /**
       * get starting dimentions for the image
       * @return {Object} object containing top, left, height and width properties of image
       */
      function getStartDims() {
        var rect = origElement[0].getBoundingClientRect()

        return {
          top: rect.top + 'px',
          left: rect.left + 'px',
          height: origElement[0].clientHeight + 'px',
          width: origElement[0].clientWidth + 'px',
        }
      }

      /**
       * get final dimentions for the image based on the current window size
       * @return {Object} object containing top, left, height and width properties of image
       */
      function getFinalDims() {
        var top
        var left
        var width
        var height
        var maxWidth = modalElem[0].clientWidth - WINDOW_PADDING * 2
        var maxHeight = modalElem[0].clientHeight - WINDOW_PADDING * 2
        var imgWidth = img.width
        var imgHeight = img.height
        var winWidth = modalElem[0].clientWidth
        var winHeight = modalElem[0].clientHeight

        var widthScaler = imgWidth / imgHeight
        var heightScaler = imgHeight / imgWidth

        // portrait
        if (imgHeight > imgWidth) {
          height = imgHeight > maxHeight ? maxHeight : imgHeight
          width = height * widthScaler

          // landscape / square
        } else {
          width = imgWidth > maxWidth ? maxWidth : imgWidth
          height = width * heightScaler
        }

        // check over-height
        if (height > maxHeight) {
          height = maxHeight
          width = height * widthScaler
        }

        // check over-width
        if (width > maxWidth) {
          width = maxWidth
          height = width * heightScaler
        }

        // position
        top = (winHeight - height) / 2
        left = (winWidth - width) / 2

        return {
          top: top + 'px',
          left: left + 'px',
          width: width + 'px',
          height: height + 'px',
        }
      }
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["Money"];
  angular.module('glow.components').factory('InvoiceItem', Factory)

  function Factory(Money) {
    var types = [
      { name: 'Plan', id: '215-PLAN' },
      { name: 'Data', id: '215-DATA' },
      { name: 'Support', id: '215-SPPT' },
      { name: 'Report', id: '215-PUBN' },
    ]

    function InvoiceItem(invoice) {
      if (!invoice) {
        throw new Error('Invoice is required')
      }
      this._invoice = invoice
      this.invoice = invoice.id
      this.applyDefaults()
    }

    InvoiceItem.prototype.types = InvoiceItem.types = types

    InvoiceItem.prototype.applyDefaults = function() {
      var amount = new Money({ currency: 'AUD' })
      var now = moment()
      _.defaultsDeep(this, {
        id: null,
        amount: amount.clone(),
        currency: amount.currency,
        groupId: null,
        description: '',
        discountable: false,
        invoice: null,
        liveMode: false,
        typeId: null,
        consumesCredit: false,
        creator: {
          id: null,
          name: null,
          email: null,
        },
        channel: {
          id: null,
          type: null,
          name: null,
        },
        project: {
          id: null,
          name: null,
        },
        period: {
          start: now,
          end: now,
        },
        plan: null,
        proration: false,
        quantity: null,
        subscriptionId: null,
      })
    }

    InvoiceItem.prototype.deserialize = function(data) {
      this._ = _.cloneDeep(data)
      this.id = data.id
      this.amount = new Money({
        amount: data.amount,
        currency: data.currency.toUpperCase(),
      })
      this.currency = data.currency.toUpperCase()
      if (data.groupId) this.groupId = data.groupId
      this.description = data.description
      this.discountable = data.discountable
      this.liveMode = data.livemode
      this.typeId = data.metadata.typeId
      this.consumesCredit = data.metadata.consumesCredit
      this.creator = {
        id: data.metadata.creatorId,
        name: data.metadata.creatorName,
        email: data.metadata.creatorEmail,
      }
      this.channel = {
        id: data.metadata.channelId,
        type: data.metadata.channelType,
        name: data.metadata.channelName,
      }
      this.project = {
        id: data.metadata.projectId,
        name: data.metadata.projectName,
      }
      this.period = {
        start: data.period.start ? moment.unix(data.period.start) : null,
        end: data.period.end ? moment.unix(data.period.end) : null,
      }
      this.plan = data.plan
      this.proration = data.proration
      this.quantity = data.quantity
      this.unitAmount = data.unit_amount
      this.subscriptionId = data.subscription
      if (data.invoice) this.invoice = data.invoice

      // NOTE: these are additional fields on the stripe model but
      // are not available when populated in an invoice
      // this.customerId = data.customer
      // this.date = data.date ? moment.unix(data.date) : null
      // this.invoiceId = data.invoiceId
      // this.unitAmount = new Money({
      //   amount: data.unit_amount,
      //   currency: data.currency.toUpperCase(),
      // })
      return this
    }

    InvoiceItem.prototype.serialize = function() {
      var data = {}
      data.amount = this.amount.amount
      data.currency = this.currency.toLowerCase()
      data.groupId = this.groupId
      data.description = this.description
      data.discountable = this.discountable
      // data.live_mode = this.liveMode
      data.metadata = {
        typeId: this.typeId,
        consumesCredit: this.consumesCredit,
        creatorId: this.creator.id,
        creatorName: this.creator.name,
        creatorEmail: this.creator.email,
        channelId: this.channel.id,
        channelType: this.channel.type,
        channelName: this.channel.name,
        projectId: this.project.id,
        projectName: this.project.name,
      }
      data.period = {
        start: this.period.start ? this.period.start.unix() : null,
        end: this.period.end ? this.period.end.unix() : null,
      }
      data.plan = this.plan
      data.quantity = this.quantity
      data.unit_amount = this.unitAmount
      data.subscriptionId = this.subscriptionId
      data.invoice = this.invoice
      return data
    }

    InvoiceItem.prototype.getType = function() {
      return _.find(types, { id: this.typeId })
    }

    InvoiceItem.prototype.validate = function() {
      var errors = []
      if (!this.typeId) {
        errors.push('Type is required')
      }
      if (!this.description) {
        errors.push('Description is required')
      }
      if (!_.isNumber(this.amount.amount) || this.amount.amount === 0) {
        errors.push('Total must be greater than zero')
      }
      if (errors.length) {
        this.errors = errors
        return false
      }
      this.errors = null
      return true
    }

    InvoiceItem.prototype.setCurrency = function(currency) {
      this.currency = currency
      this.amount.currency = currency
    }

    InvoiceItem.prototype.isCredit = function() {
      return this.amount.amount < 0
    }

    return InvoiceItem
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["Money", "InvoiceItem"];
  angular.module('glow.components').factory('Invoice', Factory)

  function Factory(Money, InvoiceItem) {
    var Status = {
      UPCOMING: 'upcoming',
      DRAFT: 'draft',
      OPEN: 'open',
      PAID: 'paid',
      UNCOLLECTABLE: 'uncollectable',
      VOID: 'void',
    }

    function Invoice() {
      this.applyDefaults()
    }

    Invoice.prototype.Status = Invoice.Status = Status

    Invoice.prototype.applyDefaults = function() {
      var amount = new Money({ currency: 'AUD' })
      _.defaultsDeep(this, {
        id: null,
        amountDue: amount.clone(),
        amountPaid: amount.clone(),
        amountRemaining: amount.clone(),
        attemptCount: 0,
        attempted: false,
        autoAdvance: false,
        billing: 'charge_automatically',
        billingReason: 'manual',
        charge: null,
        currency: amount.currency,
        customerId: null,
        created: null,
        defaultSourceId: null,
        description: '',
        discount: null,
        dueDate: null,
        endingBalance: amount.clone(),
        finalizedAt: null,
        hostedInvoiceUrl: null,
        invoicePdf: null,
        items: [],
        liveMode: false,
        metadata: {},
        xeroId: null,
        nextPaymentAttempt: null,
        number: null,
        paid: false,
        periodEnd: null,
        periodStart: null,
        receiptNumber: null,
        startingBalance: amount.clone(),
        statementDescriptor: null,
        status: Status.DRAFT,
        subscription: null,
        subscriptionProrationDate: null,
        subtotal: amount.clone(),
        tax: amount.clone(),
        taxPercent: 0,
        total: amount.clone(),
        webhooksDeliveredAt: null,
      })
    }

    Invoice.prototype.deserialize = function(data) {
      var self = this
      this._ = _.cloneDeep(data)
      this.id = data.id
      this.amountDue = new Money({
        amount: data.amount_due,
        currency: data.currency.toUpperCase(),
      })
      this.amountPaid = new Money({
        amount: data.amount_paid,
        currency: data.currency.toUpperCase(),
      })
      this.amountRemaining = new Money({
        amount: data.amount_remaining,
        currency: data.currency.toUpperCase(),
      })
      this.attemptCount = data.attempt_count
      this.attempted = data.attempted
      this.autoAdvance = data.auto_advance
      this.billing = data.billing
      this.billingReason = data.billing_reason
      this.charge = data.charge
      this.currency = data.currency.toUpperCase()
      this.customerId = data.customer
      this.created = data.created ? moment.unix(data.created) : null
      this.defaultSourceId = data.default_source
      // HACK: don't show "All charges are displayed in USD." as a fucking description
      if (data.description === 'All charges are displayed in USD.') {
        this.description = 'Billing Cycle'
      } else {
        this.description = data.description
      }
      this.discount = data.discount
      this.dueDate = data.due_date ? moment.unix(data.due_date) : null
      this.endingBalance = new Money({
        amount: data.ending_balance,
        currency: data.currency.toUpperCase(),
      })
      this.finalizedAt = data.finalized_at
        ? moment.unix(data.finalized_at)
        : null
      this.hostedInvoiceUrl = data.hosted_invoice_url
      this.invoicePdf = data.invoice_pdf
      this.items = data.lines.data.map(function(invoiceItem) {
        return new InvoiceItem(self).deserialize(invoiceItem)
      })
      this.liveMode = data.livemode
      this.metadata = _.isPlainObject(data.metadata) ? data.metadata : {}
      this.xeroId = this.metadata.xeroInvoice
      this.nextPaymentAttempt = data.nextPaymentAttempt
        ? moment.unix(data.nextPaymentAttempt)
        : null
      this.number = data.number
      this.isPaid = data.paid
      this.periodEnd = data.period_end ? moment.unix(data.period_end) : null
      this.periodStart = data.period_start
        ? moment.unix(data.period_start)
        : null
      this.receiptNumber = data.receipt_number
      this.startingBalance = new Money({
        amount: data.starting_balance,
        currency: data.currency.toUpperCase(),
      })
      this.statementDescriptor = data.statement_descriptor
      this.status = data.status
      this.subscription = data.subscription
      this.subscriptionProrationDate = data.subscription_proration_date
        ? moment.unix(data.subscription_proration_date)
        : null
      this.subtotal = new Money({
        amount: data.subtotal,
        currency: data.currency.toUpperCase(),
      })
      this.tax = new Money({
        amount: data.tax || 0,
        currency: data.currency.toUpperCase(),
      })
      this.taxPercent = data.tax_percent || 0
      this.total = new Money({
        amount: data.total,
        currency: data.currency.toUpperCase(),
      })
      this.webhooksDeliveredAt = data.webhooks_delivered_at
        ? moment.unix(data.webhooks_delivered_at)
        : null

      return this
    }

    Invoice.prototype.serialize = function() {
      return this._
    }

    Invoice.prototype.setCurrency = function(currency) {
      this.currency = currency
      this.amountDue.currency = currency
      this.amountPaid.currency = currency
      this.amountRemaining.currency = currency
      this.endingBalance.currency = currency
      this.subtotal.currency = currency
      this.tax.currency = currency
      this.total.currency = currency
    }

    Invoice.prototype.add = function(item) {
      this.items.push(item)
      this.subtotal.amount += item.amount.amount
      this.tax.amount = this.subtotal.amount * (this.taxPercent / 100)
      this.total.amount = this.subtotal.amount + this.tax.amount
      this.amountDue.amount = this.total.amount
    }

    Invoice.prototype.remove = function(item) {
      _.remove(this.items, item)
      this.subtotal.amount -= item.amount.amount
      this.tax.amount = this.subtotal.amount * (this.taxPercent / 100)
      this.total.amount = this.subtotal.amount + this.tax.amount
      this.amountDue.amount = this.total.amount
    }

    Invoice.prototype.getStatusLabel = function() {
      return {
        upcoming: 'Upcoming',
        draft: 'Draft',
        open: 'New',
        paid: 'Paid',
        uncollectible: 'Uncollectible',
        void: 'Void',
      }[this.status]
    }

    Invoice.prototype.canAddItems = function() {
      return this.status === Status.DRAFT || this.status === Status.UPCOMING
    }

    Invoice.prototype.canFinalise = function() {
      return this.status === 'draft' && this.customerId
    }

    Invoice.prototype.hasCredits = function() {
      return _.some(this.items, function(item) {
        return item.isCredit()
      })
    }

    return Invoice
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "Invoice", "InvoiceItem", "invoicesResource", "invoiceItemsResource"];
  angular.module('glow.components').factory('invoicesService', Service)

  /* @ngInject */
  function Service(
    $q,
    Invoice,
    InvoiceItem,
    invoicesResource,
    invoiceItemsResource
  ) {
    return {
      getBySubscriber: getBySubscriber,
      add: add,
      finalise: finalise,
      getUpcomingBySubscriber: getUpcomingBySubscriber,
    }

    function getUpcomingBySubscriber(subscriberId) {
      return $q(function(resolve, reject) {
        invoicesResource
          .upcoming({ groupId: subscriberId })
          .success(function(x, resp) {
            var invoice = new Invoice().deserialize(resp)
            invoice.status = 'upcoming'
            populateInvoiceItems(subscriberId, [invoice])
            resolve(invoice)
          })
          .error(function(err) {
            reject()
          })
      })
    }

    function getBySubscriber(subscriberId) {
      return $q(function(resolve, reject) {
        // get all existing invoices
        // default limit is 10, we want to get the max (100)
        invoicesResource
          .get({
            subscriberId: subscriberId,
            limit: 100,
            'expand[]': 'data.charge',
          })
          .success(function(x, resp) {
            var invoices = _.filter(resp.data, function(invoice) {
              // hide void and draft invoices
              return !_.includes(
                [Invoice.Status.VOID, Invoice.Status.DRAFT],
                invoice.status
              )
            }).map(function(invoice) {
              return new Invoice().deserialize(invoice)
            })
            resolve(invoices)
          })
          .error(reject)
      })
    }

    function populateInvoiceItems(subscriberId, invoices) {
      var promises = []
      invoices.forEach(function(invoice) {
        if (invoice._.lines.has_more) {
          var startingAfterId = _.last(invoice._.lines.data).id
          var promise = getItems(
            subscriberId,
            invoice.id,
            startingAfterId
          ).then(function(invoiceItems) {
            invoiceItems.forEach(function(invoiceItem) {
              invoiceItem = new InvoiceItem(invoice).deserialize(invoiceItem)
              invoice.items.push(invoiceItem)
            })
          })
          promises.push(promise)
        }
      })
      return $q.all(promises)
    }

    function getItems(subscriberId, invoiceId, startingAfterId) {
      return $q(function(resolve, reject) {
        invoiceItemsResource
          .get({
            groupId: subscriberId,
            invoice: invoiceId,
            starting_after: startingAfterId,
            limit: 100,
            // upcoming items have no invoice so use `pending` to get them
            pending: invoiceId ? undefined : true,
          })
          .success(function(x, resp) {
            resolve(resp.data)
          })
          .error(reject)
      })
    }

    function add(invoice, item) {
      return $q(function(resolve, reject) {
        invoice.add(item)
        invoiceItemsResource
          .create(item.serialize())
          .success(function(x, resp) {
            item.deserialize(resp)
            resolve()
          })
          .error(function() {
            invoice.remove(item)
            reject()
          })
      })
    }

    function finalise(invoice) {
      return $q(function(resolve, reject) {
        if (!invoice.canFinalise()) {
          return reject({ message: 'This invoice cannot be finalised' })
        }
        var originalStatus = invoice.status
        var originalCustomerId = invoice.customerId
        invoice.status = 'open'
        invoice.customerId = true // faux
        invoicesResource
          .finalize({ invoice: invoice.id, auto_advance: true })
          .success(function(x, resp) {
            invoice.deserialize(resp)
            resolve()
          })
          .error(function(err) {
            invoice.status = originalStatus
            invoice.customerId = originalCustomerId
            reject(err)
          })
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["$rootScope", "$q", "$log", "kitsResource", "imagesResource", "Queue"];
  angular.module('glow.components').factory('kitFactory', Factory)

  /* @ngInject */
  function Factory($rootScope, $q, $log, kitsResource, imagesResource, Queue) {
    var log = $log.create('kitFactory')

    // states used for kit
    var States = {
      DRAFT: 'DRAFT',
      PUBLISHED: 'PUBLISHED',
      ARCHIVED: 'ARCHIVED',
    }

    var Events = {
      CREATED: 'kit:created',
      UPDATED: 'kit:updated',
      REFRESH: 'kit:refresh',
    }

    function Kit() {
      this.errors = []
      this.queue = new Queue()

      // give kits a default state
      this.state = States.DRAFT
    }

    Kit.prototype.States = States

    /**
     * @name From Server
     * @desc serializes service kit data
     * @param {Object} data The data from the service
     * @returns {Kit} kit This kit
     */
    Kit.prototype.fromServer = function(data) {
      var self = this

      self.code = data.code
      self.createdAt = data.createdAt
      self.description = data.description
      self.groupCount = data.groupCount
      self.groupIds = data.groupIds
      self.guideUrl = data.guideUrl
      self.id = data.id
      self.imageUrl = data.imageUrl
      self.name = data.name
      self.ownerId = data.ownerId
      self.publishedAt = data.publishedAt
      self.state = data.state
      self.updatedAt = data.updatedAt
      self.usp = data.usp
      self.country = data.country
      self.industry = data.industry
      self.surveyTemplateCount = data.surveyTemplateCount
      self.bespoke = data.bespoke

      return this
    }

    /**
     * @name To Server
     * @desc deserializes this kit into data for the service
     * @returns {Object} data The data for use with the service
     */
    Kit.prototype.toServer = function() {
      var self = this
      var data = {}

      data.code = self.code
      data.createdAt = self.createdAt
      data.description = self.description
      data.groupCount = self.groupCount
      data.groupIds = self.groupIds
      data.guideUrl = self.guideUrl
      data.id = self.id
      data.imageUrl = self.imageUrl
      data.name = self.name
      data.ownerId = self.ownerId
      data.publishedAt = self.publishedAt
      data.state = self.state
      data.updatedAt = self.updatedAt
      data.usp = self.usp
      data.country = self.country
      data.industry = self.industry

      return data
    }

    /**
     * @name Set Image
     * @desc sets the kit intro image
     * @param {String} imageData the base64 encoded image
     */
    Kit.prototype.setImage = function(imageData) {
      var self = this

      var uploadKitImage = uploadImage.bind(self)
      var promise = uploadKitImage(imageData, 'imageUrl')
      self.queue.add(promise, 'Uploading Image')
      return promise
    }

    /**
     * @name Upload Image
     * @desc uploads an image or clears the existing reference
     * @param {String} imageData the base64 encoded image
     * @param {String} key the key on the kit model to which the returned url should be saved
     */
    function uploadImage(imageData, key) {
      var self = this
      return $q(function(resolve, reject) {
        if (!imageData) {
          self[key] = null
          return resolve()
        }
        imagesResource
          .create({ imageData: imageData })
          .success(function(resource, response) {
            self[key] = response.imageUrl
            resolve()
          })
          .error(reject)
      })
    }

    /**
     * @name Is Published
     * @desc determine if the kit is published
     * @returns {Boolean} Whether the kit is published
     */
    Kit.prototype.isPublished = function() {
      return this.state === States.PUBLISHED
    }

    /**
     * @name Is Draft
     * @desc determine if the kit is draft
     * @returns {Boolean} Whether the kit is draft
     */
    Kit.prototype.isDraft = function() {
      return this.state === States.DRAFT
    }

    Kit.prototype.isNew = function() {
      return !this.id
    }

    /**
     * @name Validate
     * @desc validates the kit and updates errors list
     * @returns {Boolean} isValid Whether the question is valid
     */
    Kit.prototype.validate = function() {
      var self = this
      var isValid = true

      self.errors.splice(0, self.errors.length) // clear errors

      if (!self.name) {
        self.errors.push('Name is required')
        isValid = false
      }

      if (!self.usp) {
        self.errors.push('Unique Selling Proposition is required')
        isValid = false
      }

      if (!self.code) {
        self.errors.push('Code is required')
        isValid = false
      }

      if (!self.description) {
        self.errors.push('Description is required')
        isValid = false
      }

      return isValid
    }

    /**
     * @name Save
     * @desc creates/updates the kit and refreshes the data from the backend
     * @returns {Promise}
     */
    Kit.prototype.save = function() {
      var self = this
      return self.queue.all().then(function() {
        var promise = self._saveToBackend().then(self._refresh.bind(self))
        self.queue.add(promise, 'Saving')

        return promise
      })
    }

    /**
     * @name Save To Backend
     * @private
     * @desc saves the kit to the backend
     * @returns {Promise}
     */
    Kit.prototype._saveToBackend = function() {
      var self = this

      return $q(function(resolve, reject) {
        var isValid = self.validate()
        if (!isValid) {
          return reject({ errors: true })
        }

        var data = self.toServer()
        var action = data.id ? 'update' : 'create'
        var options = { ownerId: self.ownerId }
        var eventName = data.id ? Events.UPDATED : Events.CREATED

        kitsResource[action](options, data)
          .success(function(x, data) {
            if (data.id) {
              self.id = data.id
            }
            resolve()
            $rootScope.$broadcast(eventName, data)
          })
          .error(function(data, status) {
            reject({ data: data, status: status })
          })
      })
    }

    /**
     * @name Refresh
     * @desc refresh the kit from the server
     * @returns {Promise}
     */
    Kit.prototype._refresh = function() {
      var self = this

      return $q(function(resolve, reject) {
        if (!self.id) {
          log.error('tried to refresh but kit has no id')
          reject()
        }

        kitsResource
          .get({ ownerId: self.ownerId, id: self.id })
          .success(function(x, data) {
            self.fromServer(data)
            resolve(self)
          })
          .error(function(data, status) {
            reject({ data: data, status: status })
          })
      })
    }

    return {
      create: create,
      States: States,
    }

    function create(options) {
      return new Kit(options)
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils"];
  angular.module('glow.components').factory('LeastFill', Factory)

  /* @ngInject */
  function Factory(glUtils) {
    var TAG_REGEX = /^[^.$]+$/

    var ErrorTypes = {
      INCOMPLETE: 'INCOMPLETE',
      INVALID_TAGS: 'INVALID_TAGS',
    }

    function LeastFill() {
      this.applyDefaults()
    }

    LeastFill.ErrorTypes = LeastFill.prototype.ErrorTypes = ErrorTypes

    LeastFill.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: glUtils.uuid(),
        tags: [],
        amount: null,
        amountOptions: [],
        errorType: null,
      })
    }

    LeastFill.prototype.deserialize = function(data) {
      data = data || {}
      this.id = data.id
      this.tags = data.tags
      this.amount = data.amount
      this.applyDefaults()
      return this
    }

    LeastFill.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.tags = this.tags.slice()
      data.amount = this.amount
      return data
    }

    LeastFill.prototype.validate = function() {
      this.errorType = null
      if (this.tags.length < 2) {
        this.errorType = ErrorTypes.INCOMPLETE
        return false
      }
      if (!this.amount) {
        this.errorType = ErrorTypes.INCOMPLETE
        return false
      }
      var hasInvalidTag = _.some(this.tags, function(tag) {
        return !TAG_REGEX.test(tag)
      })
      if (hasInvalidTag) {
        this.errorType = ErrorTypes.INVALID_TAGS
        return false
      }
      return true
    }

    LeastFill.prototype.populateAmountOptions = function() {
      var self = this
      self.amountOptions = []
      _.times(self.tags.length - 1, function(i) {
        self.amountOptions.push({ label: i + 1, value: i + 1 })
      })
    }

    LeastFill.prototype.cleanUp = function() {
      if (this.amount > this.amountOptions.length) {
        this.amount = null
      }
    }

    LeastFill.prototype.getSortedTags = function(tags, tagCounts) {
      // returns tags sorted by count, ascending.
      // group tags by count/group and flatten it back
      var sorted = _.orderBy(tags, function(tag) {
        return tagCounts[tag] || 0
      })
      var grouped = _.groupBy(sorted, function(tag) {
        return tagCounts[tag] || 0
      })
      var result = []
      _.each(grouped, function(group) {
        result = _.concat(result, group)
      })
      return result
    }

    LeastFill.prototype.getTagsToAdd = function(tagCounts) {
      // returns tags that should be added (add least filled tags)
      return this.getSortedTags(this.tags, tagCounts).slice(0, this.amount)
    }

    LeastFill.prototype.getTagsToRemove = function(tagCounts, allTags) {
      // returns tags that should be removed (retain least filled tags)
      var tags = _.chain(this.tags)
        .filter(function(tag) {
          return _.includes(allTags, tag)
        })
        .value()
      return this.getSortedTags(tags, tagCounts).slice(this.amount)
    }

    LeastFill.prototype.randomize = function() {
      // this is called by the UP to make things like LeastFill tags
      // randomized for each respondent
      this.tags = _.shuffle(this.tags)
    }

    return LeastFill
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["$q", "configService", "paramService"];
  angular.module('glow.components').factory('Link', Factory)

  /* @ngInject */
  function Factory($q, configService, paramService) {
    function Link(longUrl, fragment) {
      this.host = configService.getGlowLinkHost()
      this.longUrl = longUrl
      this.fragment = fragment
      this.isNew = true
    }

    Link.prototype.deserialize = function(data) {
      this.shortUrl = data.shortUrl
      this.longUrl = data.longUrl
      this.context = data.context
      this.fragment = data.lcShortUrlFragment
      this.isNew = false

      // TODO: get rid of this. It should be manually added in the route controller
      this.crds = getCrds(this.longUrl)

      return this
    }

    Link.prototype.serialize = function(savingSurvey) {
      var data = {}
      data.shortUrl = this.shortUrl
      data.longUrl = this.longUrl
      data.context = this.context

      // TODO: different keys are required by BE based on what is being saved where. Try to simplify this with BE.
      var savingLinkFragmentKey = this.isNew ? 'fragmentRequest' : 'fragment'
      data[
        savingSurvey ? 'lcShortUrlFragment' : savingLinkFragmentKey
      ] = this.fragment

      return data
    }

    function getCrds(url) {
      if (!url) {
        return
      }
      return paramService.get(null, url).crd
    }

    return Link
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "$document", "Link", "glDialog", "configService", "pageLinksResource", "linksResource"];
  angular.module('glow.components').factory('linkService', Service)

  /* @ngInject */
  function Service(
    $q,
    $document,
    Link,
    glDialog,
    configService,
    pageLinksResource,
    linksResource
  ) {
    var pageLinks = {} // cache of page links by page ID

    return {
      getByPage: getByPage,
      addToPage: addToPage,
      create: create,
      update: update,
      deleteLink: deleteLink,
      generate: generate,
    }

    /**
     * PRIVATE - transform/add link properties
     * @param { Array } links array of link resources
     * @return { array } array of transformed links
     */
    function transformLinks(links) {
      _.forEach(links, function(link) {
        parseUrl(link)
      })

      return links

      /* parse short URL and add usefull properties */
      function parseUrl(link) {
        var parser = $document[0].createElement('a')
        parser.href = link.shortUrl
        link.fragment = _.trimStart(parser.pathname, '/')
        link.host = parser.host
      }
    }

    /**
     * @name getByPage
     * @description Get links associated with a page
     * @param {String} pageId page ID
     * @return {Promise}
     */
    function getByPage(pageId) {
      var deferred = $q.defer()

      // if already cached, return links
      if (pageLinks[pageId]) {
        return $q.when(pageLinks[pageId])
      }

      pageLinksResource
        .get({ pageId: pageId })
        .success(function(data) {
          // cache data
          pageLinks[pageId] = transformLinks(data)

          deferred.resolve(pageLinks[pageId])
        })
        .error(deferred.reject)

      return deferred.promise
    }

    /**
     * @name addToPage
     * @description create a link and add it to a page
     * @param  {String} pageId    page ID to be associated with
     * @param  {Object} link link object - can be empty for randomly generated string
     * @return {Promise}
     */
    function addToPage(pageId, link) {
      var deferred = $q.defer()

      link.pageId = pageId

      pageLinksResource
        .create(link)
        .success(addSuccess)
        .error(deferred.reject)

      function addSuccess(data) {
        // add link to page links - add host, fragment and shortUrl for display
        link.host = configService.getGlowLinkHost()
        link.fragment = link.fragmentRequest || data.shortUrl.split('/').pop()
        link.shortUrl = data.shortUrl
        pageLinks[pageId].push(link)
        deferred.resolve()
      }

      return deferred.promise
    }

    /**
     * @name create
     * @desc create a new link
     * @param {Link} link the link
     * @return {Promise}
     */
    function create(link) {
      return $q(function(resolve, reject) {
        linksResource
          .create(link.serialize())
          .success(onSuccess)
          .error(onError)

        function onSuccess(data) {
          resolve(link.deserialize(data))
        }

        function onError(data, status) {
          reject({ data: data, status: status })
        }
      })
    }

    /**
     * @name update
     * @desc update an existing link
     * @param {Link} link the link
     * @return {Promise}
     */
    function update(link) {
      return $q(function(resolve, reject) {
        linksResource
          .modifyByFragment(link.serialize())
          .success(onSuccess)
          .error(onError)

        function onSuccess() {
          resolve(link)
        }

        function onError(data, status) {
          reject({ data: data, status: status })
        }
      })
    }

    /**
     * @name deleteLink
     * @desc delete an existing link
     * @param {Link} link the link
     * @return {Promise}
     */
    function deleteLink(link) {
      return $q(function(resolve, reject) {
        linksResource
          .delete({ fragment: link.shortUrl })
          .success(onSuccess)
          .error(onError)

        function onSuccess() {
          resolve()
        }

        function onError(data, status) {
          reject({ data: data, status: status })
        }
      })
    }

    function generate(url, showShareDialog) {
      var link = new Link(url)
      return create(link).then(function() {
        if (showShareDialog) {
          glDialog.alert('Share this link', link.shortUrl)
        }
        return link
      })
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$location", "glUtils"];
  angular.module('glow.components').service('linkedinService', Service)

  /* @ngInject */
  function Service($location, glUtils) {
    var self = this
    var baseUrl = 'https://www.linkedin.com/shareArticle'

    // Api: https://developer.linkedin.com/docs/share-on-linkedin
    var defaultShareParams = {
      url: null,
      mini: true,
      title: null,
      summary: null,
      source: 'Glow',
    }

    self.createShareUrl = createShareUrl

    function createShareUrl(params) {
      var defaultContextParams = {
        url: $location.absUrl(),
      }
      params = _.defaults({}, params, defaultContextParams, defaultShareParams)
      return glUtils.addParams(baseUrl, params)
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$document", "$element", "$timeout", "glUtils", "clipboardService", "Lender"];
  angular.module('glow.components.listInput').component('listInput', {
    controller: Controller,
    templateUrl: 'list-input.html',
    bindings: {
      label: '@',
      survey: '<',
      lender: '<',
      getPrevQuestions: '&',
      items: '=model',
      presets: '<',
      maxItems: '=',
      randomizeHeadings: '<',
      randomizeItems: '<',
      imagesEnabled: '<',
      labelsHidden: '<',
      gridColumnMax: '<',
      parentId: '<',
      isAddOnly: '=addOnly',
      isDisabled: '=disabled',
      isTemplate: '<',
      isTextCaptureOption: '<',
      isUniqueTextCapture: '<',
      isExclusiveOption: '<',
      isAnchorOption: '<',
      isIndependentOption: '<',
      isHeadingOption: '<',
      isRandomizeOption: '<',
      isScoreOption: '<',
      isBorrowFromOption: '<',
      isBorrowFromPersistOption: '<',
      isBorrowFromDisplayedOptions: '<',
      isCopyFromOption: '<',
      isHideLabelsOption: '<',
      isImagesOption: '<',
      isGridColumnMaxOption: '<',
      isLogicEditorOption: '<',
      onRandomizeHeadings: '&',
      onRandomizeItems: '&',
      onHiddenLabelsToggle: '&',
      onCopyFrom: '&',
      onBorrowFrom: '&',
      onImageChange: '&',
      onImagesToggle: '&',
      onItemAdd: '&',
      onTagsAdd: '&',
      onGridColumnMax: '&',
    },
    require: {
      formCtrl: '^form',
    },
  })

  /* @ngInject */
  function Controller(
    $document,
    $element,
    $timeout,
    glUtils,
    clipboardService,
    Lender
  ) {
    var ctrl = this
    var NEW_LINE_REGEX = /\r\n|\r|\n/g
    var SCORE_REGEX = /\s+\(-?\d+\)$/
    var TAG_SYNTAX_REGEX = /\[\[(.+?)\]\]/g
    var focusIndex

    ctrl.$onInit = onInit

    ctrl.addItem = addItem
    ctrl.canAddItem = canAddItem
    ctrl.canRemoveItem = canRemoveItem
    ctrl.canToggleHideItem = canToggleHideItem
    ctrl.removeItem = removeItem
    ctrl.toggleHideItem = toggleHideItem
    ctrl.toggleTextCapture = toggleTextCapture
    ctrl.toggleExclusive = toggleExclusive
    ctrl.toggleAnchor = toggleAnchor
    ctrl.toggleIndependent = toggleIndependent
    ctrl.moveItem = moveItem
    ctrl.canMoveUp = canMoveUp
    ctrl.canMoveDown = canMoveDown
    ctrl.onPasteItem = onPasteItem
    ctrl.onFocus = onFocus
    ctrl.onBlur = onBlur
    ctrl.copyToClipboard = copyToClipboard
    ctrl.clearItems = clearItems
    ctrl.undoClearItems = undoClearItems
    ctrl.getPlaceholder = getPlaceholder

    ctrl.usePreset = usePreset
    ctrl.borrowFrom = borrowFrom
    ctrl.copyFrom = copyFrom
    ctrl.getReducerOptions = getReducerOptions
    ctrl.formatMultiOptions = formatMultiOptions

    ctrl.hasHeadings = hasHeadings
    ctrl.getRandomizeHeadings = getRandomizeHeadings
    ctrl.setRandomizeHeadings = setRandomizeHeadings
    ctrl.getRandomizeItems = getRandomizeItems
    ctrl.setRandomizeItems = setRandomizeItems
    ctrl.togglePersistOrder = togglePersistOrder

    ctrl.$onDestroy = onDestroy

    function onInit() {
      $element.addClass('list-input')
      $document.on('keydown', onKeyDown)

      ctrl.view = ctrl.survey.getView(ctrl.parentId)

      if (ctrl.lender.id) {
        ctrl.lenderQuestion = ctrl.survey.getQuestion(ctrl.lender.id)
        makeChoiceAndStatementOptions()
        makeLoopVariableOptions()
      }

      // get previous questions for "Borrow From" and "Copy From" options
      // question template don't have previous questions
      if (!ctrl.isTemplate) {
        var prevQuestionOptions = ctrl
          .getPrevQuestions()
          .filter(function(question) {
            return question.isType([
              question.Types.CHOICE,
              question.Types.RANK,
              question.Types.MATRIX,
              question.Types.HIDDEN_VARIABLES,
            ])
          })
          .map(function(question) {
            return {
              label: question.getTitleLabel({ number: true }),
              value: question.id,
              isMatrix: question.isUsedAsMatrix(),
            }
          })
        ctrl.copiers = _.chain(prevQuestionOptions)
          .map(function(option) {
            option = _.clone(option)
            option.condition = function() {
              return !ctrl.copyTargetQuestionId
            }
            if (!option.isMatrix) return option

            option.persistent = true
            var targetOptions = ['Choices', 'Statements'].map(function(label) {
              return {
                label: 'Copy ' + label,
                value: option.value + '|' + label.toUpperCase(),
                condition: function() {
                  return ctrl.copyTargetQuestionId === option.value
                },
              }
            })
            return [option, targetOptions[0], targetOptions[1]]
          })
          .flatten()
          .value()
        ctrl.lenders = prevQuestionOptions.slice()
      }

      // lender target dropdown options
      ctrl.targetOptions = [
        {
          label: 'Statements',
          value: Lender.Target.STATEMENTS,
        },
        {
          label: 'Choices',
          value: Lender.Target.CHOICES,
        },
      ]
      ctrl.matrixStatementReducerOptions = Lender.MatrixStatementReducerOptions.slice()
      ctrl.matrixChoiceReducerOptions = Lender.MatrixChoiceReducerOptions.slice()
      ctrl.choiceReducerOptions = Lender.ChoiceReducerOptions.slice()
      ctrl.hiddenVariableReducerOptions = Lender.HiddenVariableReducerOptions.slice()
      if (!ctrl.isBorrowFromDisplayedOptions) {
        function clear(arr) {
          _.remove(arr, { value: Lender.Reducer.DISPLAYED })
          _.remove(arr, { value: Lender.Reducer.NOT_DISPLAYED })
        }
        clear(ctrl.matrixStatementReducerOptions)
        clear(ctrl.matrixChoiceReducerOptions)
        clear(ctrl.choiceReducerOptions)
        clear(ctrl.hiddenVariableReducerOptions)
      }

      // grid column max options
      ctrl.gridColumnMaxOptions = [
        { label: 'Auto', value: null },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
      ]
    }

    function makeChoiceAndStatementOptions() {
      if (!ctrl.lenderQuestion) {
        return
      }

      // lender choiceIds dropdown options
      ctrl.choiceOptions = ctrl.lenderQuestion
        .getProjectedChoices(true)
        .map(function(choice) {
          return { value: choice.id, label: choice.value }
        })

      // lender statementIds dropdown options
      ctrl.statementOptions = ctrl.lenderQuestion
        .getProjectedStatements(true)
        .map(function(statement) {
          return {
            value: statement.id,
            label: statement.value,
          }
        })

      // matrix target choice dropdown options
      ctrl.choiceOptionsSansHeadings = ctrl.lenderQuestion
        .getProjectedChoices()
        .map(function(choice) {
          return { value: choice.id, label: choice.value }
        })

      // matrix target statement dropdown options
      ctrl.statementOptionsSansHeadings = ctrl.lenderQuestion
        .getProjectedStatements()
        .map(function(statement) {
          return {
            value: statement.id,
            label: statement.value,
          }
        })
    }

    function makeLoopVariableOptions() {
      var viewGroup = ctrl.lenderQuestion && ctrl.lenderQuestion.getViewGroup()
      if (!viewGroup) {
        return
      }
      ctrl.loopVariableOptions = viewGroup.getLoopVariableOptions(ctrl.survey)
    }

    function addItem(event, atIndex) {
      event.preventDefault()
      event.stopPropagation()

      if (!_.isNumber(atIndex)) {
        atIndex = ctrl.items.length
      }
      ctrl.onItemAdd({ $item: { value: '' }, $index: atIndex })
      focusItem(atIndex)
      clearTempClearedItems()
    }

    function focusItem(atIndex, cursorPos) {
      $timeout(function() {
        var input = angular.element(
          $element[0].querySelectorAll('[item-index="' + atIndex + '"]')
        )
        input[0].focus()
        if (_.isNumber(cursorPos)) {
          input[0].setSelectionRange(cursorPos, cursorPos)
        }
      })
    }

    function canAddItem() {
      if (ctrl.isDisabled) {
        return false
      }
      if (
        !ctrl.maxItems ||
        (ctrl.maxItems > 0 && ctrl.maxItems > ctrl.items.length)
      ) {
        return true
      }
      return false
    }

    function canRemoveItem(index) {
      if (ctrl.isAddOnly) {
        return ctrl.items[index].isNew
      }
      return true
    }

    function canToggleHideItem(index) {
      if (ctrl.isRestricted) return true
      if (ctrl.isAddOnly) {
        return !ctrl.items[index].isNew
      }
      return false
    }

    function removeItem(atIndex) {
      ctrl.items.splice(atIndex, 1)
      ctrl.formCtrl.$setDirty()
    }

    function toggleHideItem(index) {
      var item = ctrl.items[index]
      item.isHidden = !item.isHidden
      ctrl.formCtrl.$setDirty()
    }

    function toggleTextCapture(index) {
      var item = ctrl.items[index]
      item.isCapture = !item.isCapture
      if (item.isCapture && ctrl.isUniqueTextCapture) {
        // when unique, toggle off other items text capture
        _.each(ctrl.items, function(data) {
          if (data.id === item.id) return true // continue
          data.isCapture = false
        })
      }
      ctrl.formCtrl.$setDirty()
    }

    function toggleExclusive(index) {
      var item = ctrl.items[index]
      item.isExclusive = !item.isExclusive
      ctrl.formCtrl.$setDirty()
    }

    function toggleAnchor(index) {
      var item = ctrl.items[index]
      item.isAnchored = !item.isAnchored
      ctrl.formCtrl.$setDirty()
    }

    function toggleIndependent(index) {
      var item = ctrl.items[index]
      if (item.isIndependent) {
        item.isIndependent = false
      } else {
        // remove from other choices as we only support 1 right now
        _.each(ctrl.items, function(item) {
          item.isIndependent = false
        })
        item.isIndependent = true
        item.score = null // clear score value
      }
      ctrl.formCtrl.$setDirty()
    }

    function moveItem(fromIndex, amount) {
      var toIndex = fromIndex + amount
      ctrl.items.splice(toIndex, 0, ctrl.items.splice(fromIndex, 1)[0])
      ctrl.formCtrl.$setDirty()
    }

    function canMoveUp(index) {
      return index > 0
    }

    function canMoveDown(index) {
      return index < ctrl.items.length - 1
    }

    function onPasteItem(event, index) {
      var cursorIndex = event.target.selectionStart
      var pasteText = glUtils.getClipboardData(event)
      var pasteItems = pasteText
        .split(NEW_LINE_REGEX)
        .filter(function(text) {
          text = text.trim()
          return text
        })
        .map(function(text) {
          // Each line can be one of two things:
          // 1) a simple choice label, eg "My Choice"
          // 2) a choice label with a score, eg "My Choice (-100)"
          // Additionally each line can also contain tag syntax, eg "My Choice [[Australia]]"
          // the tag can be used to attach display logic to the choice
          var item = {
            value: '',
            score: null,
            tags: [],
          }

          // extract tags from text and store it in item.tags
          // then remove the tags from original text
          var tagMatches = text.match(TAG_SYNTAX_REGEX) || []
          tagMatches.forEach(function(match) {
            var sansBrackets = match.slice(2, match.length - 2)
            var tag = sansBrackets.trim()
            item.tags.push(tag)
          })
          text = text.replace(TAG_SYNTAX_REGEX, '').trim()

          // extract the score from text (if any) and store it in item.score
          // then remove the score from original text
          var matches = text.match(SCORE_REGEX) || ['']
          var trimmed = matches[0].trim()
          if (trimmed) {
            var score = trimmed.slice(1, trimmed.length - 1)
            item.score = +score // coerce to number
            text = text.replace(SCORE_REGEX, '')
          }

          item.value = text.trim()
          return item
        })

      // The first item replaces the existing item, which may or may not have a value
      var firstItem = pasteItems.shift()
      var currentItem = ctrl.items[index]
      var currentValue = currentItem.value
      // If there's a value on existing item, then add the first paste item value
      // on where the cursor is.
      // Otherwise set current item value to first paste item value
      currentItem.value = currentValue
        ? currentValue.slice(0, cursorIndex) +
          firstItem.value +
          currentValue.slice(cursorIndex, currentValue.length)
        : firstItem.value
      currentItem.score = firstItem.score

      // update the item
      ctrl.onItemAdd({
        $item: currentItem,
        $index: index,
        $shouldReplace: true,
      })

      if (firstItem.tags.length) {
        ctrl.onTagsAdd({ $item: currentItem, $tags: firstItem.tags })
      }

      // The rest of the items are added as new
      while (pasteItems.length) {
        var pasteItem = pasteItems.shift()
        var newItem = ctrl.onItemAdd({ $item: pasteItem, $index: ++index })

        if (pasteItem.tags.length) {
          ctrl.onTagsAdd({ $item: newItem, $tags: pasteItem.tags })
        }
      }

      ctrl.formCtrl.$setDirty()
    }

    function onFocus(index) {
      focusIndex = index
    }

    function onBlur() {
      focusIndex = null
    }

    function getCursorPos() {
      if (!_.isNumber(focusIndex)) return null
      var input = angular.element(
        $element[0].querySelectorAll('[item-index="' + focusIndex + '"]')
      )[0]
      return input && input.selectionStart
    }

    function copyToClipboard() {
      var string = ctrl.items
        .map(function(item) {
          // if score option, append the score value, eg "My Choice (-100)"
          if (ctrl.isScoreOption && _.isNumber(item.score)) {
            return item.value + ' (' + item.score + ')'
          } else {
            return item.value
          }
        })
        .join('\n')
      clipboardService.copy(string, {
        toastMessage: 'Copied choices to clipboard',
      })
    }

    function clearItems() {
      ctrl.tempClearedItems = _.remove(ctrl.items)
      ctrl.formCtrl.$setDirty()
    }

    function undoClearItems() {
      ctrl.items = ctrl.tempClearedItems.slice()
      clearTempClearedItems()
    }

    function getPlaceholder(idx) {
      var item = ctrl.items[idx]
      if (item.isHeading) return ''
      var num = 0
      for (var $item of ctrl.items) {
        if (!$item.isHeading) num++
        if ($item === item) break
      }
      return num
    }

    function clearTempClearedItems() {
      _.remove(ctrl.tempClearedItems)
      ctrl.formCtrl.$setDirty()
    }

    function onKeyDown(event) {
      if (!_.isNumber(focusIndex)) {
        return
      }
      var i = focusIndex // capture before event-change
      switch (event.keyCode) {
        case 13: // ENTER
        case 9: // TAB
          event.preventDefault()
          if (!canAddItem() || !ctrl.items[i].value) {
            break
          }
          $timeout(function() {
            addItem(event, i + 1)
          })
          break
        case 40: // DOWN
          if (i < ctrl.items.length - 1) {
            if (event.shiftKey) {
              event.preventDefault() // prevents text selection
              moveItem(i, 1)
              focusItem(i + 1)
            }
            focusItem(i + 1, getCursorPos())
          }
          break
        case 38: // UP
          if (i > 0) {
            if (event.shiftKey) {
              event.preventDefault() // prevents text selection
              moveItem(i, -1)
              focusItem(i - 1)
            }
            focusItem(i - 1, getCursorPos())
          }
          break
        case 8: // BACKSPACE
          if (i > 0 && canRemoveItem(i) && !ctrl.items[i].value) {
            removeItem(i)
            focusItem(i - 1, Number.MAX_SAFE_INTEGER)
          }
          break
      }
    }

    function usePreset(value) {
      if (!ctrl.isTemplate) {
        borrowFrom(null)
      }
      _.remove(ctrl.items)
      var items = _.find(ctrl.presets, { value: value }).items
      _.each(items, function(item) {
        ctrl.onItemAdd({ $item: item })
      })
    }

    function copyFrom(value) {
      var splitted = value.split('|')
      var questionId = splitted[0]
      var target = splitted[1]

      if (!target && _.find(ctrl.copiers, { value: questionId }).isMatrix) {
        ctrl.copyTargetQuestionId = questionId
        return
      }

      ctrl.lenderQuestion = null
      ctrl.onCopyFrom({ $questionId: questionId, $target: target })
      clearTempClearedItems()
    }

    function borrowFrom(questionId) {
      ctrl.lenderQuestion = ctrl.survey.getQuestion(questionId)
      ctrl.onBorrowFrom({ $questionId: questionId })
      makeChoiceAndStatementOptions()
      makeLoopVariableOptions()
      clearTempClearedItems()
    }

    function getReducerOptions() {
      if (ctrl.lenderQuestion.isUsedAsMatrix()) {
        return ctrl.lender.targetsStatements()
          ? ctrl.matrixStatementReducerOptions
          : ctrl.matrixChoiceReducerOptions
      }
      if (ctrl.lenderQuestion.isHiddenVariables()) {
        return ctrl.hiddenVariableReducerOptions
      }
      return ctrl.choiceReducerOptions
    }

    function formatMultiOptions(options, prefix) {
      return (prefix || '') + _.map(options, 'label').join(', ')
    }

    function hasHeadings() {
      return (
        ctrl.isHeadingOption &&
        _.some(ctrl.items, function(item) {
          return item.isHeading
        })
      )
    }

    function getRandomizeHeadings(value) {
      return value === undefined
        ? ctrl.randomizeHeadings
        : value === ctrl.randomizeHeadings
    }

    function setRandomizeHeadings(value) {
      ctrl.onRandomizeHeadings({ $value: value })
      // persist order cannot be used with randomize
      if (value) {
        ctrl.lender.persistOrder = false
      }
    }

    function getRandomizeItems(value) {
      return value === undefined
        ? ctrl.randomizeItems
        : value === ctrl.randomizeItems
    }

    function setRandomizeItems(value) {
      ctrl.onRandomizeItems({ $value: value })
      // persist order cannot be used with randomize
      if (value) {
        ctrl.lender.persistOrder = false
      }
    }

    function togglePersistOrder() {
      ctrl.lender.persistOrder = !ctrl.lender.persistOrder
      // randomize cannot be used with persist order
      if (!getRandomizeItems(null)) setRandomizeItems(null)
      if (!getRandomizeHeadings(null)) setRandomizeHeadings(null)
    }

    function onDestroy() {
      $document.off('keydown', onKeyDown)
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('LocationSet', Factory)

  /* @ngInject */
  function Factory() {
    var Type = {
      COUNTRY: 'country',
      STATE: 'state',
      CITY: 'city',
      SUBURB: 'suburb',
      POSTCODE: 'postcode',
      LATLNG: 'latlng',
      NAME: 'name',
      ADDRESS: 'address',
      PLACE_TYPE: 'place_type',
      PLACE_ID: 'place_id',
    }

    var TypeInfo = [
      {
        type: Type.COUNTRY,
        name: 'Country',
        slot: 0,
        parentType: null,
        childType: Type.STATE,
      },
      {
        type: Type.STATE,
        name: 'State',
        slot: 1,
        parentType: Type.COUNTRY,
        childType: Type.CITY,
      },
      {
        type: Type.CITY,
        name: 'City',
        slot: 2,
        parentType: Type.STATE,
        childType: Type.SUBURB,
      },
      {
        type: Type.SUBURB,
        name: 'Suburb',
        slot: 3,
        parentType: Type.CITY,
        childType: null,
      },
      {
        type: Type.POSTCODE,
        name: 'Postcode',
        slot: 4,
        parentType: null,
        childType: null,
      },
      {
        type: Type.LATLNG,
        name: 'LatLng',
        slot: 5,
        parentType: null,
        childType: null,
      },
      {
        type: Type.NAME,
        name: 'Name',
        slot: 6,
        parentType: null,
        childType: null,
      },
      {
        type: Type.ADDRESS,
        name: 'Address',
        slot: 7,
        parentType: null,
        childType: null,
      },
      {
        type: Type.PLACE_TYPE,
        name: 'Place Type',
        slot: 8,
        parentType: null,
        childType: null,
      },
      {
        type: Type.PLACE_ID,
        name: 'Place ID',
        slot: 9,
        parentType: null,
        childType: null,
      },
    ]

    function LocationSet() {
      this.collections = []
    }

    LocationSet.prototype.Type = LocationSet.Type = Type

    LocationSet.prototype.TypeInfo = LocationSet.TypeInfo = TypeInfo

    LocationSet.prototype.fromTextAnswers = function(textAnswers) {
      var self = this
      var startTime = moment()

      textAnswers = textAnswers || []

      self.sanitizeTextAnswers(textAnswers)
      self.locations = self.buildLocations(textAnswers)
      self.collections = self.buildCollections(self.locations)

      console.info(
        'parsed ' +
          self.locations.length +
          ' locations in ' +
          moment().diff(startTime) +
          'ms'
      )

      return self
    }

    LocationSet.prototype.fromElements = function(elements) {
      var self = this
      var startTime = moment()

      elements = elements || {}
      elements = _.map(elements) // turn into an array
      elements = _.cloneDeep(elements)

      self.locations = _.map(elements, function(element) {
        var location = {
          country: element.country,
          state: element.state,
          city: element.city,
          suburb: null, // not available on element data
          postcode: element.postalCode,
          latlng: element.lat + ',' + element.lng,
          name:
            element.name + (element.location ? ', ' + element.location : ''),
          label: element.label, // used for focus
          color: element.color,
          value: element.sourceId,
        }
        return location
      })
      self.collections = self.buildCollections(self.locations)

      console.info(
        'parsed ' +
          self.locations.length +
          ' locations in ' +
          moment().diff(startTime) +
          'ms'
      )

      return self
    }

    LocationSet.prototype.sanitizeTextAnswers = function(textAnswers) {
      // remove un-answered
      _.remove(textAnswers, function(answer) {
        return !answer.textAnswer
      })
    }

    LocationSet.prototype.buildLocations = function(textAnswers) {
      var locations = []

      _.each(textAnswers, function(answer) {
        var location = {}
        var slots = answer.textAnswer.split('|')

        _.each(slots, function(value, index) {
          if (!value) {
            return
          }

          var info = _.find(TypeInfo, { slot: index })
          if (!info) {
            return console.error('no TypeInfo found for "' + value + '"')
          }

          location[info.type] = value
          location.interactionId = answer.responseId
        })

        location.value = answer

        locations.push(location)
      })

      return locations
    }

    LocationSet.prototype.buildCollections = function(locations) {
      var collections = {}

      // initialise the collections
      _.each(TypeInfo, function(info) {
        if (!collections[info.type]) {
          collections[info.type] = {
            seek: {},
            items: [],
            count: 0,
          }
        }
      })

      _.each(locations, function(location) {
        _.each(TypeInfo, function(info) {
          var name = location[info.type]

          if (!name) {
            return
          }

          var item = upsertItem(info.type, name)

          if (info.childType && location[info.childType]) {
            var childName = location[info.childType]
            var child = upsertItem(info.childType, childName)
            if (!_.includes(item.children, child)) {
              item.children.push(child)
            }
          }

          if (info.parentType && location[info.parentType]) {
            var parentName = info.parentType && location[info.parentType]
            var parent = upsertItem(info.parentType, parentName)
            if (!_.includes(item.parents, parent)) {
              item.parents.push(parent)
            }
          }
        })
      })

      function upsertItem(type, name) {
        var item = collections[type].seek[name]

        if (!item) {
          var info = _.find(TypeInfo, { type: type })

          item = {
            name: name,
            nameLowerCase: name.toLowerCase(),
            count: 0,
            info: {
              name: info.name,
              type: info.type,
              slot: info.slot,
            },
            children: [],
            parents: [],
          }

          collections[type].seek[name] = item
          collections[type].items.push(item)
        }

        item.count++
        collections[type].count++

        return item
      }

      return collections
    }

    LocationSet.prototype.getByType = function(type) {
      var collection = this.collections[type]
      return collection ? collection.items : []
    }

    LocationSet.prototype.getTop = function(type) {
      var self = this
      var collection = self.collections[type]
      if (!collection) {
        return
      }
      var top = _.orderBy(collection.items, 'count', 'desc')[0]
      if (top) {
        top.percent = Math.floor((top.count / collection.count) * 100)
      }
      return top
    }

    return LocationSet
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["LocationSet"];
  angular.module('glow.components').service('locationSetService', Service)

  /* @ngInject */
  function Service(LocationSet) {
    var self = this

    self.Type = LocationSet.Type
    self.TypeInfo = LocationSet.TypeInfo
    self.create = create
    self.getInfoByType = getInfoByType

    function create() {
      return new LocationSet()
    }

    function getInfoByType(type) {
      return _.find(self.TypeInfo, { type: type })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils", "LeastFill"];
  angular.module('glow.components').factory('LogicAction', Factory)

  /* @ngInject */
  function Factory(glUtils, LeastFill) {
    var TAG_REGEX = /^[^.$]+$/

    var Types = {
      SUBMIT: 'SUBMIT',
      EXIT: 'EXIT',
      QUALITYEXIT: 'QUALITYEXIT',
      JUMP_TO_QUESTION: 'JUMP_TO_QUESTION',
      JUMP_TO_SECTION: 'JUMP_TO_SECTION',
      JUMP_TO_FOLLOWUP: 'JUMP_TO_FOLLOWUP', // DEPRECATED
      JUMP_TO_PROFILING: 'JUMP_TO_PROFILING', // DEPRECATED
      TAG: 'TAG',
      UNTAG: 'UNTAG',
      ADD_TO_LIST: 'ADD_TO_LIST',
      HIDE_VIEW_GROUPS: 'HIDE_VIEW_GROUPS',
      ADD_LEAST_FILLED_TAGS: 'ADD_LEAST_FILLED_TAGS',
      RETAIN_LEAST_FILLED_TAGS: 'RETAIN_LEAST_FILLED_TAGS',
      SET_VARIABLE: 'SET_VARIABLE',
    }

    var errors = {
      incomplete: function() {
        return 'Action is incomplete'
      },
      invalidTag: function() {
        return 'Tags cannot contain periods (.) or dollar signs ($)'
      },
    }

    function LogicAction(logic) {
      this.logic = logic
      this.applyDefaults()
    }

    LogicAction.Types = LogicAction.prototype.Types = Types

    LogicAction.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: glUtils.uuid(),
        type: null,
        questionId: null,
        sectionId: null,
        viewGroupIds: [],
        tag: null,
        tags: [],
        list: null,
        listItem: null,
        leastFill: new LeastFill(),
        variableKey: null,
        variableValue: null,
        loopKey: null,
      })
    }

    LogicAction.prototype.deserialize = function(data) {
      var self = this
      this.id = data.id
      this.type = data.type
      this.questionId = data.questionId
      this.sectionId = data.sectionId
      this.viewGroupIds = data.viewGroupIds
      this.tag = data.tag
      this.tags = data.tags
      this.list = data.list
      this.listItem = data.listItem
      if (data.leastFill) {
        this.leastFill.deserialize(data.leastFill)
      }
      this.variableKey = data.variableKey
      this.variableValue = data.variableValue
      this.loopKey = data.loopKey
      this.applyDefaults()
      return self
    }

    LogicAction.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.type = this.type
      if (this.usesQuestion()) {
        data.questionId = this.questionId
      }
      if (this.usesSection()) {
        data.sectionId = this.sectionId
      }
      if (this.usesTag()) {
        data.tag = this.tag
      }
      if (this.usesTags()) {
        data.tags = this.tags.slice()
      }
      if (this.usesList()) {
        data.list = this.list
        data.listItem = this.listItem
      }
      if (this.usesViewGroups()) {
        data.viewGroupIds = this.viewGroupIds.slice()
      }
      if (this.usesLeastFill()) {
        data.leastFill = this.leastFill.serialize()
      }
      if (this.usesVariables()) {
        data.variableKey = this.variableKey
        data.variableValue = this.variableValue
      }
      if (this.usesLoopKey()) {
        data.loopKey = this.loopKey
      }
      return data
    }

    LogicAction.prototype.cleanUp = function() {
      var viewGroups = this.logic.helpers.getViewGroupInfo(this.viewGroupIds)
      _.remove(this.viewGroupIds, function(viewGroupId) {
        return !_.find(viewGroups, { id: viewGroupId })
      })

      // remove loopKey if question/section is not in loop or loop variable doesn't exist
      if (this.loopKey && (!this.usesLoopKey() || !this.getLoopVariable())) {
        this.loopKey = null
      }
    }

    LogicAction.prototype.validate = function(parentErrors) {
      var self = this
      var isValid = true
      parentErrors = parentErrors || []

      if (!self.type) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesQuestion() && (!self.questionId || !self.getQuestion())) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesSection() && (!self.sectionId || !self.getSection())) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesTag() && !self.tag) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesTag() && !TAG_REGEX.test(self.tag)) {
        parentErrors.push(errors.invalidTag())
        return false // hard stop!
      }
      if (self.usesTags() && !self.tags.length) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesTags()) {
        for (var i = 0; i < self.tags.length; i++) {
          var tag = self.tags[i]
          if (!TAG_REGEX.test(tag)) {
            parentErrors.push(errors.invalidTag())
            return false // hard stop!
          }
        }
      }
      if (self.usesList() && (!self.list || !self.listItem)) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesViewGroups() && !self.viewGroupIds.length) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesLeastFill() && !self.leastFill.validate()) {
        switch (self.leastFill.errorType) {
          case LeastFill.ErrorTypes.INCOMPLETE:
            parentErrors.push(errors.incomplete())
            return false // hard stop!
          case LeastFill.ErrorTypes.INVALID_TAGS:
            parentErrors.push(errors.invalidTag())
            return false // hard stop!
        }
      }
      if (self.usesVariables() && !self.variableKey) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesVariables() && !self.variableValue) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesLoopKey() && !self.loopKey) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }

      return isValid
    }

    LogicAction.prototype.getQuestion = function() {
      var self = this
      if (self.usesQuestion()) {
        return self.logic.helpers.getQuestionInfo(self.questionId)
      }
    }

    LogicAction.prototype.getSection = function() {
      var self = this
      if (self.usesSection()) {
        return self.logic.helpers.getSectionInfo(self.sectionId)
      }
    }

    LogicAction.prototype.getViewGroups = function() {
      if (this.usesViewGroups()) {
        return this.logic.helpers.getViewGroupInfo(this.viewGroupIds)
      }
    }

    LogicAction.prototype.usesQuestion = function() {
      return this.type === Types.JUMP_TO_QUESTION
    }

    LogicAction.prototype.usesSection = function() {
      return this.type === Types.JUMP_TO_SECTION
    }

    LogicAction.prototype.usesTag = function() {
      return this.type === Types.TAG
    }

    LogicAction.prototype.usesTags = function() {
      return this.type === Types.UNTAG
    }

    LogicAction.prototype.usesList = function() {
      return this.type === Types.ADD_TO_LIST
    }

    LogicAction.prototype.usesViewGroups = function() {
      return this.type === Types.HIDE_VIEW_GROUPS
    }

    LogicAction.prototype.usesLeastFill = function() {
      return _.includes(
        [Types.ADD_LEAST_FILLED_TAGS, Types.RETAIN_LEAST_FILLED_TAGS],
        this.type
      )
    }

    LogicAction.prototype.usesVariables = function() {
      return this.type === Types.SET_VARIABLE
    }

    LogicAction.prototype.usesLoopKey = function() {
      // ensure the selected question/section is in loop
      var viewGroup = this.logic.helpers.getViewGroupByViewId(this.getViewId())
      if (!viewGroup || !viewGroup.loop) return false

      // ensure the view owning this logic is not in
      // the same group with the selected question/section
      var ownerView = this.logic.getOwnerView()
      return !viewGroup.viewIds.includes(ownerView.value.id)
    }

    LogicAction.prototype.getViewId = function() {
      if (this.usesQuestion()) return this.questionId
      if (this.usesSection()) return this.sectionId
      return null
    }

    LogicAction.prototype.getLoopVariable = function() {
      var viewId = this.getViewId()
      return (
        viewId &&
        this.loopKey &&
        this.logic.helpers.getLoopVariableInfo(viewId, this.loopKey)
      )
    }

    LogicAction.prototype.toString = function() {
      if (!this.validate()) {
        return '[incomplete]'
      }
      var loopVariableLabel = ''
      if (this.usesLoopKey()) {
        var loopVariable = this.getLoopVariable()
        loopVariableLabel +=
          ' <b>(' + (loopVariable ? loopVariable.label : '') + ')</b>'
      }
      switch (this.type) {
        case Types.SUBMIT:
          return 'Submit the survey'
        case Types.EXIT:
          return 'Exit the survey'
        case Types.QUALITYEXIT:
          return 'Quality exit the survey'
        case Types.JUMP_TO_QUESTION:
          return 'Jump to Q' + this.getQuestion().number + loopVariableLabel
        case Types.JUMP_TO_SECTION:
          return 'Jump to S' + this.getSection().number + loopVariableLabel
        case Types.JUMP_TO_FOLLOWUP: // DEPRECATED
          return 'Jump to Follow-Up'
        case Types.JUMP_TO_PROFILING: // DEPRECATED
          return 'Jump to Profiling'
        case Types.TAG:
          return 'Add tag ' + this.tag
        case Types.UNTAG:
          return 'Remove tags [' + this.tags.join(', ') + ']'
        case Types.ADD_TO_LIST:
          return "Add '" + this.listItem + "' to list '" + this.list + "'"
        case Types.HIDE_VIEW_GROUPS:
          return (
            'Hide groups: ' + _.map(this.getViewGroups(), 'name').join(', ')
          )
        case Types.ADD_LEAST_FILLED_TAGS:
          return (
            'Add ' +
            this.leastFill.amount +
            ' least filled tag' +
            (this.leastFill.amount > 1 ? 's' : '') +
            ': [' +
            this.leastFill.tags.join(', ') +
            ']'
          )
        case Types.RETAIN_LEAST_FILLED_TAGS:
          return (
            'Retain up to ' +
            this.leastFill.amount +
            ' least filled tag' +
            (this.leastFill.amount > 1 ? 's' : '') +
            ': [' +
            this.leastFill.tags.join(', ') +
            ']'
          )
        case Types.SET_VARIABLE:
          return (
            "Set variable '" +
            this.variableKey +
            "' to '" +
            this.variableValue +
            "'"
          )
      }
    }

    LogicAction.prototype.randomize = function() {
      // this is called by the UP to make things like LeastFill tags
      // randomized for each respondent
      this.leastFill.randomize()
    }

    return LogicAction
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils"];
  angular.module('glow.components').factory('LogicCondition', Factory)

  /* @ngInject */
  function Factory(glUtils) {
    var TAG_REGEX = /^[^.$]+$/
    var NUMBER_REGEX = /^\s*\d+\s*$/

    var Types = {
      SELECTED: 'SELECTED',
      ANSWER_COUNT: 'ANSWERED_AMOUNT',
      ANSWERED: 'ANSWERED',
      DIDNT_ANSWER: 'DIDNT_ANSWER',
      IS_TAGGED: 'IS_TAGGED',
      IS_PRIOR_TAGGED: 'IS_PRIOR_TAGGED',
      LIST: 'LIST',
      DISPLAYED: 'DISPLAYED',
      IS_INSIDE_LOOP: 'IS_INSIDE_LOOP',
    }

    var SelectionQuantifiers = {
      ALL: 'ALL',
      NONE: 'NONE',
      ANY: 'ANY',
      EXACTLY: 'EXACTLY',
    }

    var ChoiceQuantifiers = {
      ALL: 'ALL',
      ANY: 'ANY',
    }

    var TextQuantifiers = {
      ALL: 'ALL',
      NONE: 'NONE',
      ANY: 'ANY',
    }

    var NumericQuantifiers = {
      NONE: 'NONE',
      ANY: 'ANY',
      LESS_THAN: 'LESS_THAN',
      GREATER_THAN: 'GREATER_THAN',
      EQUALS: 'EQUALS',
    }

    var ListQuantifiers = {
      ALL: 'ALL',
      NONE: 'NONE',
      ANY: 'ANY',
      LESS_THAN: 'LESS_THAN',
      GREATER_THAN: 'GREATER_THAN',
      EQUALS: 'EQUALS',
    }

    var DisplayedQuantifiers = {
      ALL: 'ALL',
      NONE: 'NONE',
      ANY: 'ANY',
    }

    var InsideLoopQuantifiers = {
      ANY: 'ANY',
      NONE: 'NONE',
    }

    var selectedQuantifierLabels = {
      ALL: 'Selected all of',
      NONE: 'Selected none of',
      ANY: 'Selected any of',
      EXACTLY: 'Selected exactly',
      LESS_THAN: 'Entered less than',
      GREATER_THAN: 'Entered greater than',
      EQUALS: 'Entered',
    }

    var tagQuantifierLabels = {
      ALL: 'Has all of these tags:',
      NONE: 'Has none of these tags:',
      ANY: 'Has any of these tags:',
      EXACTLY: 'Has exactly these tags:',
    }

    var listQuantifierLabels = {
      ALL: 'Has all of',
      NONE: 'Has none of',
      ANY: 'Has any of',
      LESS_THAN: 'Has less than',
      GREATER_THAN: 'Has greater than',
      EQUALS: 'Has',
    }

    var displayedQuantifierLabels = {
      ALL: 'Displayed all of',
      NONE: 'Displayed all of',
      ANY: 'Displayed any of',
    }

    var insideLoopQuantifierLabels = {
      ANY: 'Is inside any of these loop variables:',
      NONE: 'Is inside none of these loop variables:',
    }

    var DisplayedTargets = {
      CHOICES: 'CHOICES',
      STATEMENTS: 'STATEMENTS',
    }

    var errors = {
      incomplete: function() {
        return 'Condition is incomplete'
      },
      invalidTag: function() {
        return 'Tags cannot contain periods (.) or dollar signs ($)'
      },
      invalidNumbers: function() {
        return 'Numbers must be comma separated numeric values only'
      },
    }

    function LogicCondition(logic) {
      this.logic = logic
      this.applyDefaults()
    }

    LogicCondition.Types = LogicCondition.prototype.Types = Types
    LogicCondition.SelectionQuantifiers = LogicCondition.prototype.SelectionQuantifiers = SelectionQuantifiers
    LogicCondition.ChoiceQuantifiers = LogicCondition.prototype.ChoiceQuantifiers = ChoiceQuantifiers
    LogicCondition.TextQuantifiers = LogicCondition.prototype.TextQuantifiers = TextQuantifiers
    LogicCondition.NumericQuantifiers = LogicCondition.prototype.NumericQuantifiers = NumericQuantifiers
    LogicCondition.ListQuantifiers = LogicCondition.prototype.ListQuantifiers = ListQuantifiers
    LogicCondition.DisplayedQuantifiers = LogicCondition.prototype.DisplayedQuantifiers = DisplayedQuantifiers
    LogicCondition.InsideLoopQuantifiers = LogicCondition.prototype.InsideLoopQuantifiers = InsideLoopQuantifiers
    LogicCondition.DisplayedTargets = LogicCondition.prototype.DisplayedTargets = DisplayedTargets

    LogicCondition.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: glUtils.uuid(),
        type: null,
        questionId: null,
        statementIds: [],
        list: null,
        selectionQuantifier: null,
        choiceQuantifier: null,
        textQuantifier: null,
        numericQuantifier: null,
        listQuantifier: null,
        displayedQuantifier: null,
        insideLoopQuantifier: null,
        tags: [],
        choiceIds: [],
        listItems: [],
        number: null,
        numbers: [],
        numbersStr: '',
        text: null,
        ranks: [],
        period: null,
        displayedTarget: null,
        loopKey: null,
        loopKeys: [],
      })
    }

    LogicCondition.prototype.deserialize = function(data) {
      var self = this
      this.id = data.id
      this.type = data.type
      this.questionId = data.questionId
      this.statementIds = data.statementIds
      this.list = data.list
      this.selectionQuantifier = data.selectionQuantifier
      this.choiceQuantifier = data.choiceQuantifier
      this.textQuantifier = data.textQuantifier
      this.numericQuantifier = data.numericQuantifier
      this.listQuantifier = data.listQuantifier
      this.displayedQuantifier = data.displayedQuantifier
      this.insideLoopQuantifier = data.insideLoopQuantifier
      this.tags = data.tags
      this.choiceIds = data.choiceIds
      this.listItems = data.listItems
      this.number = data.number
      this.numbers = data.numbers
      this.numbersStr = data.numbersStr
      this.text = data.text
      this.ranks = data.ranks
      this.period = data.period
      this.displayedTarget = data.displayedTarget
      this.loopKey = data.loopKey
      this.loopKeys = data.loopKeys
      this.applyDefaults()
      return self
    }

    LogicCondition.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.type = this.type
      data.questionId = this.questionId
      data.statementIds = this.statementIds
      data.choiceIds = this.choiceIds
      data.tags = this.tags
      data.list = this.list
      data.listItems = this.listItems
      data.selectionQuantifier = this.selectionQuantifier
      data.choiceQuantifier = this.choiceQuantifier
      data.textQuantifier = this.textQuantifier
      data.numericQuantifier = this.numericQuantifier
      data.listQuantifier = this.listQuantifier
      data.displayedQuantifier = this.displayedQuantifier
      data.insideLoopQuantifier = this.insideLoopQuantifier
      data.text = this.text
      data.number = this.number
      data.numbers = this.getNumbersFromStr()
      data.numbersStr = this.numbersStr
      data.ranks = this.ranks.slice()
      data.period = this.period
      data.displayedTarget = this.displayedTarget
      data.loopKey = this.loopKey
      data.loopKeys = this.loopKeys
      return data
    }

    LogicCondition.prototype.getNumbersFromStr = function() {
      return this.numbersStr.split(',').map(function(str) {
        return NUMBER_REGEX.test(str) ? +str : str
      })
    }

    LogicCondition.prototype.cleanUp = function() {
      // remove invalid and hidden statement ids
      var statements = this.getStatements() || []
      _.remove(this.statementIds, function(statementId) {
        var statement = _.find(statements, { id: statementId })
        return !statement || statement.isHidden
      })

      // remove invalid and hidden choice ids
      var choices = this.getChoices() || []
      _.remove(this.choiceIds, function(choiceId) {
        var choice = _.find(choices, { id: choiceId })
        return !choice || choice.isHidden
      })

      // remove statementIds if displayed target is CHOICES
      if (this.displayedTargetsChoices()) {
        this.statementIds = []
      }
      // remove choiceIds if displayed target is STATEMENTS
      if (this.displayedTargetsStatements()) {
        this.choiceIds = []

        if (!this.getQuestion().hasStatements) {
          // score & constant-sum can toggle between matrix and non-matrix.
          // the user may have set up matrix logic but then toggled the question
          // to be non-matrix, so we clear these fields and let validation
          // point out the error.
          this.displayedTarget = null
          this.statementIds = []
        }
      }

      // remove loopKey if question is not in loop or loop variable doesn't exist
      if (this.loopKey && (!this.usesLoopKey() || !this.getLoopVariable())) {
        this.loopKey = null
      }

      // IS_INSIDE_LOOP type is only available if logic is owned by view in loop,
      // otherwise remove the type
      if (
        this.type === Types.IS_INSIDE_LOOP &&
        !this.logic.isOwnedByViewInLoop()
      ) {
        this.type = null
      }

      // remove loopKeys if not uses loopKeys
      if (!this.usesLoopKeys()) {
        _.remove(this.loopKeys)
      }

      // remove invalid loopKeys
      if (this.loopKeys.length) {
        var loopVariables = this.getLoopVariables()
        _.remove(this.loopKeys, function(loopKey) {
          return !_.find(loopVariables, { id: loopKey })
        })
      }
    }

    LogicCondition.prototype.validate = function(parentErrors) {
      var self = this
      var isValid = true
      parentErrors = parentErrors || []

      if (!self.type) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesQuestion() && (!self.questionId || !self.getQuestion())) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesSelectionQuantifier() && !self.selectionQuantifier) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesChoiceQuantifier() && !self.choiceQuantifier) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesTextQuantifier() && !self.textQuantifier) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesNumericQuantifier() && !self.numericQuantifier) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesListQuantifier() && !self.listQuantifier) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesDisplayedQuantifier() && !self.displayedQuantifier) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesInsideLoopQuantifier() && !self.insideLoopQuantifier) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesTags()) {
        if (!self.tags.length) {
          parentErrors.push(errors.incomplete())
          return false // hard stop!
        }
        for (var i = 0; i < self.tags.length; i++) {
          var tag = self.tags[i]
          if (!TAG_REGEX.test(tag)) {
            parentErrors.push(errors.invalidTag())
            return false // hard stop!
          }
        }
      }
      if (self.usesList() && !self.list) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesStatements() && !self.statementIds.length) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesChoices() && !self.choiceIds.length) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesListItems() && !self.listItems.length) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesNumber() && !_.isNumber(self.number)) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesNumbers() && !this.numbersStr) {
        parentErrors.push(errors.incomplete())
        return false
      }
      if (self.usesNumbers()) {
        var numbers = this.getNumbersFromStr()
        for (var i = 0; i < numbers.length; i++) {
          var number = numbers[i]
          if (!_.isNumber(number)) {
            parentErrors.push(errors.invalidNumbers())
            return false
          }
        }
      }
      if (self.usesText() && !_.trim(self.text)) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesPeriod() && !this.period) {
        parentErrors.push(errors.incomplete())
        return false
      }
      if (self.usesRanks() && !self.ranks.length) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesDisplayedTarget() && !self.displayedTarget) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesLoopKey() && !self.loopKey) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      if (self.usesLoopKeys() && !self.loopKeys.length) {
        parentErrors.push(errors.incomplete())
        return false // hard stop!
      }
      return isValid
    }

    LogicCondition.prototype.getQuestion = function() {
      var self = this
      return (
        self.questionId && self.logic.helpers.getQuestionInfo(self.questionId)
      )
    }

    LogicCondition.prototype.getStatements = function() {
      var self = this
      return (
        self.questionId &&
        self.statementIds.length &&
        self.logic.helpers.getStatementInfo(self.questionId, self.statementIds)
      )
    }

    LogicCondition.prototype.getChoices = function() {
      var self = this
      return (
        self.questionId &&
        self.choiceIds.length &&
        self.logic.helpers.getChoiceInfo(self.questionId, self.choiceIds)
      )
    }

    LogicCondition.prototype.isSelectionType = function() {
      return _.includes([Types.SELECTED, Types.ANSWER_COUNT], this.type)
    }

    LogicCondition.prototype.usesQuestion = function() {
      return _.includes(
        [
          Types.SELECTED,
          Types.ANSWER_COUNT,
          Types.ANSWERED,
          Types.DIDNT_ANSWER,
          Types.DISPLAYED,
        ],
        this.type
      )
    }

    LogicCondition.prototype.usesSelectionQuantifier = function() {
      var question = this.getQuestion()
      return (
        this.type === Types.IS_TAGGED ||
        this.type === Types.IS_PRIOR_TAGGED ||
        (this.type === Types.SELECTED &&
          question &&
          !question.isConstantSum &&
          question.hasChoices)
      )
    }

    LogicCondition.prototype.usesChoiceQuantifier = function() {
      var question = this.getQuestion()
      return (
        this.type === Types.SELECTED &&
        question &&
        question.hasChoices &&
        question.isConstantSum
      )
    }

    LogicCondition.prototype.usesTextQuantifier = function() {
      var question = this.getQuestion()
      return this.type === Types.SELECTED && question && question.isText
    }

    LogicCondition.prototype.usesNumericQuantifier = function() {
      var question = this.getQuestion()
      return (
        this.type === Types.ANSWER_COUNT ||
        (this.type === Types.SELECTED && question && question.isNumeric)
      )
    }

    LogicCondition.prototype.usesListQuantifier = function() {
      return this.type === Types.LIST
    }

    LogicCondition.prototype.usesDisplayedQuantifier = function() {
      return this.type === Types.DISPLAYED && this.questionId
    }

    LogicCondition.prototype.usesInsideLoopQuantifier = function() {
      return (
        this.logic.isOwnedByViewInLoop() && this.type === Types.IS_INSIDE_LOOP
      )
    }

    LogicCondition.prototype.usesPeriod = function() {
      return this.type === Types.IS_PRIOR_TAGGED
    }

    // usesRangeType = NUMERIC

    LogicCondition.prototype.usesTags = function() {
      return (
        this.type === Types.IS_TAGGED || this.type === Types.IS_PRIOR_TAGGED
      )
    }

    LogicCondition.prototype.usesList = function() {
      return this.type === Types.LIST
    }

    LogicCondition.prototype.usesStatements = function() {
      var question = this.getQuestion()
      return (
        (this.isSelectionType() || this.displayedTargetsStatements()) &&
        question &&
        question.hasStatements
      )
    }

    LogicCondition.prototype.usesChoices = function() {
      var question = this.getQuestion()
      return (
        (this.type === Types.SELECTED || this.displayedTargetsChoices()) &&
        question &&
        question.hasChoices
      )
    }

    LogicCondition.prototype.usesListItems = function() {
      if (this.type === Types.LIST) {
        return _.includes(
          [ListQuantifiers.ALL, ListQuantifiers.NONE, ListQuantifiers.ANY],
          this.listQuantifier
        )
      }
      return false
    }

    LogicCondition.prototype.usesNumber = function() {
      if (this.type === Types.LIST && !this.usesListItems()) return true
      var numberQuantifier = _.includes(
        [
          NumericQuantifiers.LESS_THAN,
          NumericQuantifiers.GREATER_THAN,
          NumericQuantifiers.EQUALS,
        ],
        this.numericQuantifier
      )
      return this.usesNumericQuantifier() && numberQuantifier
    }

    LogicCondition.prototype.usesNumbers = function() {
      var numbersQuantifier = _.includes(
        [NumericQuantifiers.ANY, NumericQuantifiers.NONE],
        this.numericQuantifier
      )
      return this.usesNumericQuantifier() && numbersQuantifier
    }

    LogicCondition.prototype.usesText = function() {
      var textQuantifier = _.includes(
        [TextQuantifiers.ALL, TextQuantifiers.NONE, TextQuantifiers.ANY],
        this.textQuantifier
      )
      return this.usesTextQuantifier() && textQuantifier
    }

    LogicCondition.prototype.usesRanks = function() {
      var question = this.getQuestion()
      return this.type === Types.SELECTED && question && question.isRank
    }

    LogicCondition.prototype.usesDisplayedTarget = function() {
      return this.type === Types.DISPLAYED && this.questionId
    }

    LogicCondition.prototype.displayedTargetsChoices = function() {
      return (
        this.type === Types.DISPLAYED &&
        this.displayedTarget === DisplayedTargets.CHOICES
      )
    }

    LogicCondition.prototype.displayedTargetsStatements = function() {
      return (
        this.type === Types.DISPLAYED &&
        this.displayedTarget === DisplayedTargets.STATEMENTS
      )
    }

    LogicCondition.prototype.usesLoopKey = function() {
      // ensure the selected question is in loop
      var viewGroup = this.logic.helpers.getViewGroupByViewId(this.getViewId())
      if (!viewGroup || !viewGroup.loop) return false

      // ensure the view owning this logic is not in
      // the same group with the selected question
      var ownerView = this.logic.getOwnerView()
      return !viewGroup.viewIds.includes(ownerView.value.id)
    }

    LogicCondition.prototype.usesLoopKeys = function() {
      return (
        this.logic.isOwnedByViewInLoop() && this.type === Types.IS_INSIDE_LOOP
      )
    }

    LogicCondition.prototype.getViewId = function() {
      return this.usesQuestion() ? this.questionId : null
    }

    LogicCondition.prototype.getLoopVariable = function() {
      var viewId = this.getViewId()
      return (
        viewId &&
        this.loopKey &&
        this.logic.helpers.getLoopVariableInfo(viewId, this.loopKey)
      )
    }

    LogicCondition.prototype.getLoopVariables = function() {
      // currently loopKeys is only used for IS_INSIDE_LOOP type and the value
      // comes from: view owning this logic > view group > loop variables
      // so we pass the ownerViewId instead of getViewId()
      var ownerViewId = this.logic.getOwnerView().value.id
      return (
        (ownerViewId &&
          this.loopKeys.length &&
          this.logic.helpers.getLoopVariableInfo(ownerViewId, this.loopKeys)) ||
        []
      )
    }

    LogicCondition.prototype.buildString = function() {
      var self = this
      if (!this.validate()) {
        return '[ Incomplete ]'
      }
      var loopVariableLabel = ''
      if (this.usesLoopKey()) {
        var loopVariable = this.getLoopVariable()
        loopVariableLabel +=
          ' <b>(' + (loopVariable ? loopVariable.label : '') + ')</b>'
      }
      if (self.type === Types.LIST) {
        if (self.usesListItems()) {
          return (
            self.list +
            ' > ' +
            listQuantifierLabels[self.listQuantifier] +
            ' [' +
            self.listItems.join(', ') +
            ']'
          )
        }
        return (
          self.list +
          ' > ' +
          listQuantifierLabels[self.listQuantifier] +
          ' ' +
          self.number +
          ' items'
        )
      }
      if (self.type === Types.IS_TAGGED) {
        return (
          tagQuantifierLabels[self.selectionQuantifier] +
          ' [' +
          self.tags.join(', ') +
          ']'
        )
      }
      if (self.type === Types.IS_PRIOR_TAGGED) {
        return (
          tagQuantifierLabels[self.selectionQuantifier] +
          ' [' +
          self.tags.join(', ') +
          '] <' +
          self.period +
          ' days'
        )
      }
      if (self.type === Types.ANSWERED) {
        return 'Answered Q' + self.getQuestion().number + loopVariableLabel
      }
      if (self.type === Types.DIDNT_ANSWER) {
        return "Didn't answer Q" + self.getQuestion().number + loopVariableLabel
      }
      if (self.type === Types.IS_INSIDE_LOOP) {
        return (
          insideLoopQuantifierLabels[self.insideLoopQuantifier] +
          '[' +
          _.map(self.getLoopVariables(), 'label').join(', ') +
          ']'
        )
      }
      var blocks = []
      if (self.usesSelectionQuantifier()) {
        blocks.push(selectedQuantifierLabels[self.selectionQuantifier])
      }
      if (self.usesChoiceQuantifier()) {
        blocks.push(selectedQuantifierLabels[self.choiceQuantifier])
      }
      if (self.usesDisplayedQuantifier()) {
        blocks.push(displayedQuantifierLabels[self.displayedQuantifier])
      }
      if (self.usesDisplayedTarget()) {
        var displayedTargetLabel = self.getQuestion().isHiddenVariables
          ? 'VARIABLES'
          : DisplayedTargets[self.displayedTarget]
        blocks.push(displayedTargetLabel)
      }
      blocks.push('Q' + self.getQuestion().number + loopVariableLabel + ' > ')
      if (self.usesStatements()) {
        blocks.push('[' + _.map(self.getStatements(), 'label').join(', ') + ']')
      }
      if (self.usesChoices()) {
        var label = '[' + _.map(self.getChoices(), 'label').join(', ') + ']'
        if (self.usesStatements()) {
          label = ' > ' + label
        }
        blocks.push(label)
      }
      if (self.usesTextQuantifier()) {
        blocks.push(selectedQuantifierLabels[self.textQuantifier])
      }
      if (self.usesNumericQuantifier()) {
        var label = selectedQuantifierLabels[self.numericQuantifier]
        if (self.usesChoiceQuantifier()) {
          label = ' > ' + label
        }
        blocks.push(label)
      }
      if (self.usesNumber()) {
        blocks.push(self.number)
      }
      if (self.usesNumbers()) {
        blocks.push(self.numbersStr)
      }
      if (self.usesText()) {
        blocks.push(self.text)
      }
      if (self.usesRanks()) {
        var ranks = self.ranks.map(function(n) {
          return n + 1
        })
        blocks.push('[' + ranks.join(', ') + ']')
      }
      return blocks.join(' ')
    }

    LogicCondition.prototype.toString = function() {
      // IMPORTANT: buildString() is a huge performance issue so we cache
      // the result and only regenerate it after 5 seconds
      // see: https://trello.com/c/DfkrpQdN/277-large-survey-performance
      var self = this
      var now = performance.now()
      if (self.string && now < self.stringCreated + 5000) {
        return self.string
      }
      self.string = self.buildString()
      self.stringCreated = now
      return self.string
    }

    return LogicCondition
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils", "LogicCondition", "LogicAction"];
  angular.module('glow.components').factory('Logic', Factory)

  /* @ngInject */
  function Factory(glUtils, LogicCondition, LogicAction) {
    var Types = {
      DISPLAY: 'DISPLAY',
      ACTION: 'ACTION',
    }

    var Targets = {
      QUESTION: 'QUESTION',
      SECTION: 'SECTION',
      CHOICES: 'CHOICES',
      STATEMENTS: 'STATEMENTS',
    }

    var errors = {
      noConditions: function() {
        return 'At least one condition is required'
      },
      noActions: function() {
        return 'At least one action is required'
      },
      noTarget: function() {
        return 'Target is required for display logic'
      },
      noTargetChoiceIds: function() {
        return 'At least one choice is required for display target Choices'
      },
      noTargetStatementIds: function() {
        return 'At least one statement is required for display target Statements'
      },
    }

    function Logic(helpers) {
      this.helpers = helpers
      this.applyDefaults()
    }

    Logic.Types = Logic.prototype.Types = Types
    Logic.Targets = Logic.prototype.Targets = Targets

    Logic.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: glUtils.uuid(),
        type: null,
        target: null,
        questionId: null, // deprecated
        sectionId: null, // deprecated
        choiceIds: [],
        statementIds: [],
        conditions: [],
        actions: [],
        errors: [],
      })
    }

    Logic.prototype.deserialize = function(data) {
      var self = this
      this.id = data.id
      this.type = data.type
      this.target = data.target
      this.questionId = data.questionId
      this.sectionId = data.sectionId
      this.choiceIds = data.choiceIds
      this.statementIds = data.statementIds
      this.conditions = data.conditions.map(function(condition) {
        return new LogicCondition(self).deserialize(condition)
      })
      this.actions = data.actions.map(function(action) {
        return new LogicAction(self).deserialize(action)
      })
      this.errors = []
      this.applyDefaults()
      return this
    }

    Logic.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.type = this.type
      data.target = this.target
      data.questionId = this.questionId
      data.sectionId = this.sectionId
      data.choiceIds = this.choiceIds
      data.statementIds = this.statementIds
      data.conditions = this.conditions.map(function(condition) {
        return condition.serialize()
      })
      data.actions = this.actions.map(function(action) {
        return action.serialize()
      })
      return data
    }

    Logic.prototype.setup = function() {
      this.addCondition()
      if (this.type === Types.ACTION) {
        this.addAction()
      }
    }

    Logic.prototype.addCondition = function() {
      this.conditions.push(new LogicCondition(this))
    }

    Logic.prototype.removeCondition = function(id) {
      _.remove(this.conditions, function(condition) {
        return condition.id === id
      })
    }

    Logic.prototype.addAction = function() {
      this.actions.push(new LogicAction(this))
    }

    Logic.prototype.removeAction = function(id) {
      _.remove(this.actions, function(action) {
        return action.id === id
      })
    }

    Logic.prototype.targetsQuestion = function() {
      return this.type === Types.DISPLAY && this.target === Targets.QUESTION
    }

    Logic.prototype.targetsSection = function() {
      return this.type === Types.DISPLAY && this.target === Targets.SECTION
    }

    Logic.prototype.targetsChoices = function() {
      return this.type === Types.DISPLAY && this.target === Targets.CHOICES
    }

    Logic.prototype.targetsStatements = function() {
      return this.type === Types.DISPLAY && this.target === Targets.STATEMENTS
    }

    Logic.prototype.isDisplay = function() {
      return this.type === Types.DISPLAY
    }

    Logic.prototype.isAction = function() {
      return this.type === Types.ACTION
    }

    Logic.prototype.getTags = function() {
      var tags = []
      _.each(this.actions, function(action) {
        if (action.tag) tags.push(action.tag)
        tags = _.concat(tags, action.leastFill.tags)
      })
      _.each(this.conditions, function(condition) {
        if (condition.tags.length) tags = _.concat(tags, condition.tags)
      })
      return _.uniq(tags)
    }

    Logic.prototype.isOwnedByViewInLoop = function() {
      var viewGroup = this.getOwnerView().value.getViewGroup()
      return viewGroup && viewGroup.loop
    }

    Logic.prototype.getOwnerView = function() {
      // since we deprecated questionId and sectionId in this factory,
      // logic has no reference to the owner, so we need to look up this
      // logic id on each views to get the owner view of this logic
      return this.helpers.getViewByLogicId(this.id)
    }

    Logic.prototype.cleanUp = function(question) {
      if (this.targetsStatements() && !question.isUsedAsMatrix()) {
        // score & constant-sum can toggle between matrix and non-matrix.
        // the user may have set up matrix logic but then toggled the question
        // to be non-matrix, so we clear these fields and let validation
        // point out the error.
        this.target = null
        this.statementIds = []
      }

      if (this.targetsChoices()) {
        // remove invalid target choice ids
        var choices =
          this.helpers.getChoiceInfo(question.id, this.choiceIds) || []
        _.remove(this.choiceIds, function(choiceId) {
          var choice = _.find(choices, { id: choiceId })
          return !choice || choice.isHidden
        })
      }

      if (this.targetsStatements()) {
        // remove invalid target statement ids
        var statements =
          this.helpers.getStatementInfo(question.id, this.statementIds) || []
        _.remove(this.statementIds, function(statementId) {
          var statement = _.find(statements, { id: statementId })
          return !statement || statement.isHidden
        })
      }

      // clean up conditions
      _.each(this.conditions, function(condition) {
        condition.cleanUp()
      })

      // clean up actions
      _.each(this.actions, function(action) {
        action.cleanUp()
      })
    }

    Logic.prototype.validate = function() {
      var self = this
      var isValid = true
      _.remove(self.errors)

      // must be at least one condition
      if (!self.conditions.length) {
        self.errors.push(errors.noConditions())
        isValid = false
      }

      // conditions must be valid
      for (var i = 0; i < self.conditions.length; i++) {
        var condition = self.conditions[i]
        if (!condition.validate(self.errors)) {
          isValid = false
        }
      }

      // action type logic require at least one action
      if (self.type === Types.ACTION && !self.actions.length) {
        self.errors.push(errors.noActions())
        isValid = false
      }

      // actions must be valid
      for (var x = 0; x < self.actions.length; x++) {
        var action = self.actions[x]
        if (!action.validate(self.errors)) {
          isValid = false
        }
      }

      // target is required for display logic
      if (self.type === Types.DISPLAY && !self.target) {
        self.errors.push(errors.noTarget())
        isValid = false
      }

      // must be at least one target choices
      if (self.targetsChoices() && !self.choiceIds.length) {
        self.errors.push(errors.noTargetChoiceIds())
        isValid = false
      }

      // must be at least one target statements
      if (self.targetsStatements() && !self.statementIds.length) {
        self.errors.push(errors.noTargetStatementIds())
        isValid = false
      }

      if (!isValid) return false // hard stop!

      // TODO: validate problems such as:
      //     - conditions referencing future questions/sections
      //     - actions jumping backward or influencing the past

      return isValid
    }

    Logic.prototype.refresh = function(getId) {
      var self = this
      this.id = getId(this.id)

      self.choiceIds = self.choiceIds.map(function(oldId) {
        return getId(oldId, true)
      })

      self.statementIds = self.statementIds.map(function(oldId) {
        return getId(oldId, true)
      })

      _.each(self.conditions, function(condition) {
        condition.id = getId(condition.id)
        condition.questionId = getId(condition.questionId, true)
        condition.statementIds = condition.statementIds.map(function(
          statementId
        ) {
          return getId(statementId, true)
        })
        condition.choiceIds = condition.choiceIds.map(function(choiceId) {
          return getId(choiceId, true)
        })
        condition.loopKey = getId(condition.loopKey, true)
        condition.loopKeys = condition.loopKeys.map(function(loopKey) {
          return getId(loopKey, true)
        })
      })
      _.each(self.actions, function(action) {
        action.id = getId(action.id)
        action.questionId = getId(action.questionId, true)
        action.sectionId = getId(action.sectionId, true)
        action.viewGroupIds = action.viewGroupIds.map(function(viewGroupId) {
          return getId(viewGroupId, true)
        })
        action.leastFill.id = getId(action.leastFill.id)
        action.loopKey = getId(action.loopKey, true)
      })
      return this
    }

    Logic.prototype.clone = function() {
      return new Logic(this.helpers).deserialize(this.serialize())
    }

    Logic.prototype.randomize = function() {
      // this is called by the UP to make things like LeastFill tags
      // randomized for each respondent
      this.actions.forEach(function(action) {
        action.randomize()
      })
      return this
    }

    Logic.prototype.makeSummaryTitle = function(question) {
      var self = this

      // question or section display logic
      if (self.targetsQuestion() || self.targetsSection()) {
        return 'Displayed if...'
      }

      // choice display logic
      if (self.targetsChoices()) {
        var choiceText = _(question.getAllChoices())
          .filter(function(choice) {
            return _.includes(self.choiceIds, choice.id)
          })
          .map(function(choice) {
            return choice.value || choice.label
          })
          .join(', ')
        return 'Displays [' + choiceText + '] if...'
      }

      // statement display logic
      if (self.targetsStatements()) {
        var statementsText = _(question.getAllStatements())
          .filter(function(statement) {
            return _.includes(self.statementIds, statement.id)
          })
          .map(function(statement) {
            return statement.value || statement.label
          })
          .join(', ')
        return 'Displays [' + statementsText + '] if...'
      }

      // action logic
      return 'If...'
    }

    Logic.prototype.hasMatchingChoicesOrStatements = function(values) {
      function includesAny(targetIds, values) {
        return targetIds.some(function(id) {
          return values.includes(id)
        })
      }
      if (includesAny(this.choiceIds, values)) return true
      if (includesAny(this.statementIds, values)) return true

      return this.conditions.some(function(condition) {
        return (
          includesAny(condition.choiceIds, values) ||
          includesAny(condition.statementIds, values)
        )
      })
    }

    return Logic
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils", "Money"];
  angular.module('glow.components').factory('LOI', Factory)

  /* @ngInject */
  function Factory(glUtils, Money) {
    var Types = {
      MICRO: 'MICRO',
      MID: 'MID',
      LONG: 'LONG',
      MAX: 'MAX',
    }

    var types = [
      {
        type: Types.MICRO,
        rangeLabel: '0-2 minutes',
        typeLabel: 'Micro',
        minSeconds: 0,
        maxSeconds: 120,
        entryUnits: 2,
        estimateSeconds: 60,
      },
      {
        type: Types.MID,
        rangeLabel: '2-5 minutes',
        typeLabel: 'Mid',
        minSeconds: 121,
        maxSeconds: 300,
        entryUnits: 3,
        estimateSeconds: 180,
      },
      {
        type: Types.LONG,
        rangeLabel: '5-10 minutes',
        typeLabel: 'Long',
        minSeconds: 301,
        maxSeconds: 600,
        entryUnits: 5,
        estimateSeconds: 450,
      },
      {
        type: Types.MAX,
        rangeLabel: '10-15 minutes',
        typeLabel: 'Max',
        minSeconds: 601,
        maxSeconds: 99999,
        entryUnits: 7,
        estimateSeconds: 700,
      },
    ]

    function LOI() {
      this.value = 0
    }

    LOI.prototype.Types = LOI.Types = Types
    LOI.prototype.types = LOI.types = types

    LOI.prototype.deserialize = function(value) {
      this.set(value)
      return this
    }

    LOI.prototype.serialize = function() {
      return this.value
    }

    LOI.prototype.set = function(value) {
      this.value = value
      this.type = _.find(types, function(type) {
        return value >= type.minSeconds && value <= type.maxSeconds
      })
      this.updateDurationLabel()
    }

    LOI.prototype.become = function(loi) {
      this.deserialize(loi.serialize())
    }

    LOI.prototype.updateDurationLabel = function() {
      var minutes = this.value / 60
      var minutesRounded = Math.ceil(minutes)
      var minutesDecimalRounded = _.round(minutes, 1)
      this.durationLabel =
        minutesDecimalRounded +
        glUtils.numberSwitch(minutesDecimalRounded, ' min', ' mins')
      if (minutes <= 0.5) {
        this.respondentDurationLabel = 'Less than 30 seconds'
      } else {
        this.respondentDurationLabel =
          'Less than ' +
          minutesRounded +
          ' ' +
          glUtils.numberSwitch(minutesRounded, ' minute', ' minutes')
      }
    }

    return LOI
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["LOI"];
  angular.module('glow.components').service('loiService', Service)

  /* @ngInject */
  function Service(LOI) {
    var self = this

    self.Types = LOI.Types
    self.types = LOI.types
    self.create = create

    function create() {
      return new LOI()
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "$window"];
  angular.module('glow.components').service('mapService', Service)

  /* @ngInject */
  function Service($q, $window) {
    var self = this

    self.load = load
    self.loadMarkerClusterer = loadMarkerClusterer
    self.loadDeckGl = loadDeckGl

    function load() {
      return cachedScript(
        'mapsPromise',
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyCFVjK6NhGloKzTYUzkpAKysxoqAdDuJzw&libraries=places,geometry'
      )
    }

    function loadMarkerClusterer() {
      return cachedScript(
        'markerClustererPromise',
        'https://unpkg.com/@googlemaps/markerclusterer@2.6.2/dist/index.min.js'
      )
    }

    function loadDeckGl() {
      return cachedScript(
        'deckGlPromise',
        'https://unpkg.com/deck.gl@^9.0.0/dist.min.js'
      )
    }

    // Appends the script once (cached on $window by key) and resolves on load.
    function cachedScript(key, src) {
      if (!$window[key]) {
        var deferred = $q.defer()
        var script = document.createElement('script')
        script.onload = function() {
          deferred.resolve()
        }
        script.src = src
        document.head.appendChild(script)
        $window[key] = deferred.promise
      }
      return $window[key]
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('MarginOfError', Factory)

  /* @ngInject */
  function Factory() {
    var DefaultPopulationSize = 20000 // default to 20000 population size
    var DefaultConfidenceLevel = 95 // default to 95% confidence level
    var TableValuePrefix = '\u00B1' // ± symbol to display in table

    function MarginOfError() {
      this.applyDefaults()
    }

    MarginOfError.prototype.DefaultPopulationSize = MarginOfError.DefaultPopulationSize = DefaultPopulationSize
    MarginOfError.prototype.DefaultConfidenceLevel = MarginOfError.DefaultConfidenceLevel = DefaultConfidenceLevel
    MarginOfError.prototype.TableValuePrefix = MarginOfError.TableValuePrefix = TableValuePrefix

    MarginOfError.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        enabled: false,
        populationSize: DefaultPopulationSize,
        confidenceLevel: DefaultConfidenceLevel,
        responseLevel: 50, // fixed 50% response level (hidden from the UI)
        isHiddenFromShared: false,
      })
    }

    MarginOfError.prototype.deserialize = function(data) {
      data = _.isPlainObject(data) ? data : {}

      this.enabled = data.enabled
      this.populationSize = data.populationSize
      this.confidenceLevel = data.confidenceLevel
      this.responseLevel = data.responseLevel
      this.isHiddenFromShared = data.isHiddenFromShared

      this.applyDefaults()
      return this
    }

    MarginOfError.prototype.serialize = function() {
      var data = {}
      data.enabled = this.enabled
      data.populationSize = this.populationSize
      data.confidenceLevel = this.confidenceLevel
      data.responseLevel = this.responseLevel
      data.isHiddenFromShared = this.isHiddenFromShared
      return data
    }

    MarginOfError.prototype.get = function(sample, dp) {
      dp = _.isNumber(dp) ? dp : 1
      var result =
        _.isNumber(sample) && sample > 0
          ? Calculate(
              sample,
              this.confidenceLevel,
              this.responseLevel,
              this.populationSize
            )
          : 0
      return result.toFixed(dp) + '%'
    }

    MarginOfError.prototype.validate = function() {
      var errors = []

      if (this.enabled) {
        if (!this.populationSize) {
          errors.push('Population Size is required to show Margin of Error')
        }
        if (!this.confidenceLevel) {
          errors.push('Confidence Level is required to show Margin of Error')
        }
      }

      this.errors = errors.length ? errors : null
      return !errors.length
    }

    function Calculate(sample, confidence, response, population) {
      // Origin: http://www.raosoft.com/samplesize.html

      var pcn = ProbCriticalNormal(confidence / 100.0)
      var d1 = pcn * pcn * response * (100.0 - response)
      var d2 = (d1 * (population - sample)) / (sample * (population - 1.0))
      if (d2 > 0.0) return Math.sqrt(d2)
      return 0.0
    }

    function ProbCriticalNormal(P) {
      // Origin: http://www.raosoft.com/samplesize.html

      // You can derive these formulas from first principles. The
      // ProbCriticalNormal function is adapted from an algorithm published
      // in Numerical Recipes in Fortran.

      // input p is confidence level convert it to
      // cumulative probability before computing critical
      var Y, Pr, Real1, Real2, HOLD
      var I
      var PN = [
        0, // ARRAY[1..5] OF REAL
        -0.322232431088,
        -1.0,
        -0.342242088547,
        -0.0204231210245,
        -0.453642210148e-4,
      ]

      var QN = [
        0, //  ARRAY[1..5] OF REAL
        0.099348462606,
        0.588581570495,
        0.531103462366,
        0.10353775285,
        0.38560700634e-2,
      ]

      Pr = 0.5 - P / 2 // one side significance

      if (Pr <= 1.0e-8) HOLD = 6
      else {
        if (Pr == 0.5) HOLD = 0
        else {
          Y = Math.sqrt(Math.log(1.0 / (Pr * Pr)))
          Real1 = PN[5]
          Real2 = QN[5]

          for (I = 4; I >= 1; I--) {
            Real1 = Real1 * Y + PN[I]
            Real2 = Real2 * Y + QN[I]
          }

          HOLD = Y + Real1 / Real2
        } // end of else pr = 0.5
      } // end of else Pr <= 1.0E-8
      return HOLD
    }

    return MarginOfError
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').filter('glMdImgToHtml', glMdImgToHtml)

  // --------------------

  function glMdImgToHtml() {
    return function(string) {
      var MD_IMAGE_MATCHER = /(!\[[^\]]*\]\([^\)]+\))/g
      var MD_IMAGE_URL = /!\[[^\]]*\]\(([^\)]+)\)/

      var images = string.match(MD_IMAGE_MATCHER)

      _.each(images, function(image) {
        var url = image.match(MD_IMAGE_URL)[1]
        string = string.replace(
          image,
          '<img style="max-width: 150px;" ng-src="' +
            url +
            '" gl-image-viewer />'
        )
      })

      return string
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$sce", "glUtils", "glToast", "mediaView"];
  angular.module('glow.components.mediaView').component('mediaView', {
    controller: Controller,
    templateUrl: 'media-view.html',
    bindings: {
      id: '<',
      type: '<',
      url: '<',
      video: '<',
      showDownload: '<',
    },
  })

  /* @ngInject */
  function Controller($sce, glUtils, glToast, mediaView) {
    var ctrl = this

    ctrl.Types = mediaView.Types

    ctrl.$onInit = onInit
    ctrl.getImageStyle = getImageStyle
    ctrl.downloadImage = downloadImage
    ctrl.close = close

    function onInit() {
      if (ctrl.type === ctrl.Types.YOUTUBE) {
        var youTubeVideoUrl = glUtils.addParamsV2(ctrl.url, {
          // controls: 0,
          rel: 0,
          modestbranding: 1,
        })
        ctrl.youTubeVideoUrl = $sce.trustAsResourceUrl(youTubeVideoUrl)
      }
      if (ctrl.type === ctrl.Types.IFRAME) {
        ctrl.iframeUrl = $sce.trustAsResourceUrl(ctrl.url)
      }
    }

    function getImageStyle() {
      return {
        maxHeight: window.innerHeight + 'px',
      }
    }

    function downloadImage() {
      glUtils
        .fetchBlobDataFromUrl(ctrl.url)
        .then(function(blob) {
          glUtils.downloadFile(blob, 'image/png', 'image.png')
          mediaView.close(ctrl.id)
        })
        .catch(function(error) {
          glToast.show('Error downloading image. Please try again.')
        })
    }

    function close(event) {
      // prevent closing when clicked on child elements except for image
      // clicking on image will close the fullscreen view
      if (
        !_.includes(event.target.className.split(' '), 'media-view') &&
        !_.includes(event.target.className.split(' '), 'media-view__content') &&
        event.target.nodeName !== 'IMG'
      ) {
        return
      }
      mediaView.close(ctrl.id)
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$rootScope", "$document", "$compile"];
  angular.module('glow.components.mediaView').service('mediaView', Service)

  function Service($rootScope, $document, $compile) {
    var body = angular.element($document[0].body)
    var nextId = 0
    var active = []

    var Types = {
      IMAGE: 'IMAGE',
      VIDEO: 'VIDEO',
      YOUTUBE: 'YOUTUBE',
      AUDIO: 'AUDIO',
      IFRAME: 'IFRAME',
    }

    return {
      Types: Types,
      showImage: showImage,
      showVideo: showVideo,
      showYoutubeVideo: showYoutubeVideo,
      showAudio: showAudio,
      showIframe: showIframe,
      close: close,
    }

    function showImage(imageUrl, showDownload) {
      compileElem(Types.IMAGE, imageUrl, null, showDownload)
    }

    function showVideo(video) {
      compileElem(Types.VIDEO, null, video)
    }

    function showYoutubeVideo(youTubeVideoUrl) {
      compileElem(Types.YOUTUBE, youTubeVideoUrl)
    }

    function showAudio(audioUrl) {
      compileElem(Types.AUDIO, audioUrl)
    }

    function showIframe(iframeUrl) {
      compileElem(Types.IFRAME, iframeUrl)
    }

    function compileElem(type, url, video, showDownload) {
      var id = (nextId++).toString()
      var scope = $rootScope.$new()
      scope.data = {
        id: id,
        type: type,
        url: url,
        video: video,
        showDownload: showDownload,
      }

      var elem = $compile(
        '<media-view id="data.id" type="data.type" url="data.url" video="data.video" show-download="data.showDownload" />'
      )(scope)
      body.append(elem)

      active.push({
        id: id,
        elem: elem,
        scope: scope,
      })
    }

    function close(id) {
      var view = _.remove(active, { id: id })[0]
      if (view) {
        view.scope.$destroy()
        view.elem.remove()
      }
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('microAction', {
    templateUrl: 'micro-action.html',
    transclude: true,
    bindings: {
      icon: '@',
    },
  })
})()

;(function() {
  'use strict'

  angular.module('glow.components').directive('money', function() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function(scope, element, attrs, ngModel) {
        if (ngModel && attrs.money) {
          // Don't do anything unless we have a model

          ngModel.$parsers.push(function(value) {
            // js math is incorrect so we coerce it here.
            // Example:
            // n = 1.14
            // n * 100 // 113.99999999999999
            // +(n * 100).toFixed(0) // 114
            return +(value * 100).toFixed(0)
          })

          ngModel.$formatters.push(function(value) {
            return value / 100
          })
        }
      },
    }
  })
})()

;(function() {
  'use strict'

  Factory.$inject = ["Currency", "currencyService"];
  angular.module('glow.components').factory('Money', Factory)

  /* @ngInject */
  function Factory(Currency, currencyService) {
    // e.g. $100 --> amount: 10000
    var Defaults = {
      amount: 0,
      currency: Currency.Codes.AUD,
    }

    function Money(options) {
      _.defaults(this, options, Defaults)
    }

    Money.prototype.format = function(options) {
      options = _.defaults({}, options, {
        currency: false,
        decimal: true,
      })
      var decimalPlaces = options.decimal ? 2 : 0
      var prefix = this.amount < 0 ? '- ' : ''
      var symbol = currencyService.getByCode(this.currency).symbol
      var amount = Math.abs(this.amount / 100)
      var suffix = options.currency ? ' ' + this.currency : ''
      return (
        prefix +
        symbol +
        amount.toLocaleString(undefined, {
          minimumFractionDigits: decimalPlaces,
          maximumFractionDigits: decimalPlaces,
        }) +
        suffix
      )
    }

    Money.prototype.setAmount = function(amount) {
      this.amount = amount
    }

    Money.prototype.clone = function() {
      return new Money({
        amount: this.amount,
        currency: this.currency,
      })
    }

    return Money
  }
})()

;(function() {
  'use strict'

  angular.module('glow.services').factory('taxService', Service)

  /* @ngInject */
  function Service() {
    // The country codes below should align to those in countryService
    var TaxByCountry = {
      AU: {
        code: 'GST',
        rate: 0.1,
        percent: 10,
      },
      GB: {
        code: 'VAT',
        rate: 0.2,
        percent: 20,
      },
      US: {
        code: 'Sales Tax',
        rate: 0.11725,
        percent: 11.725,
      },
    }

    return {
      getByCountry: getByCountry,
    }

    function getByCountry(country) {
      return _.cloneDeep(TaxByCountry[country])
    }
  }
})()

;(function() {
  'use strict'

  /**
   * @name components.multiselectDropdown
   * @description
   */
  glMultiselectDropdownDirective.$inject = ["$document", "$rootScope"];
  angular
    .module('glow.components.multiselectDropdown', [])
    .directive('glMultiselectDropdown', glMultiselectDropdownDirective)

  /* @ngInject */
  function glMultiselectDropdownDirective($document, $rootScope) {
    controller.$inject = ["$scope", "$element", "$attrs"];
    return {
      restrict: 'EA',
      scope: {
        selectedModel: '=',
        options: '=',
        extraSettings: '=',
        searchFilter: '=?',
        translationTexts: '=',
        onSelect: '&',
        onDeselect: '&',
        disabled: '=ngDisabled',
      },
      templateUrl: 'multiselect-dropdown.template.html',
      controller: controller,
    }

    function controller($scope, $element, $attrs) {
      var dropdownTrigger = $element.children()[0]

      // default text to display
      $scope.texts = {
        checkAll: 'Select All',
        uncheckAll: 'Unselect All',
        searchPlaceholder: 'Search...',
        buttonDefaultText: 'Select',
        dynamicButtonTextSuffix: 'selected',
      }

      // default settings
      $scope.settings = {
        dynamicTitle: true,
        scrollable: false,
        scrollableHeight: '300px',
        closeOnBlur: true,
        displayProp: 'label',
        idProp: 'id',
        externalIdProp: 'id',
        selectionLimit: 0,
        enableSearch: false,
        showCheckAll: true,
        showUncheckAll: true,
        closeOnSelect: false,
        buttonClasses: 'gl-btn',
        smartButtonMaxItems: 6,
        smartButtonTextConverter: angular.noop,
      }

      // handle attribute
      $scope.searchFilter = $scope.searchFilter || ''

      _.assign($scope.settings, $scope.extraSettings || [])
      // _.assign($scope.externalEvents, $scope.events || []);
      _.assign($scope.texts, $scope.translationTexts)

      if (angular.isDefined($attrs.singleSelect)) {
        $scope.settings.selectionLimit = 1
      }
      $scope.singleSelection = $scope.settings.selectionLimit === 1

      if ($scope.settings.closeOnBlur) {
        $document.on('click', closeOnBlur)
      }

      $scope.recommendedOptions = _.filter($scope.options, {
        recommended: true,
      })

      $scope.$on('$destroy', function() {
        $document.off('click', closeOnBlur)
      })

      $scope.$watch('disabled', function(newVal) {
        var button = angular.element(
          $element[0].querySelector('.dropdown-toggle')
        )
        if (newVal) {
          button[0].classList.add('disabled')
        } else {
          button[0].classList.remove('disabled')
        }
      })

      $rootScope.$on('glMultiselectDropdown:opening', function() {
        $scope.open = false
      })

      function closeOnBlur(e) {
        var target = e.target.parentElement
        var parentFound = false

        while (angular.isDefined(target) && target !== null && !parentFound) {
          if (
            typeof target.className === 'string' &&
            _.includes(
              target.className.split(' '),
              'gl-multiselect-dropdown'
            ) &&
            !parentFound
          ) {
            if (target === dropdownTrigger) {
              parentFound = true
            }
          }
          target = target.parentElement
        }

        if (!parentFound) {
          $scope.$applyAsync(function() {
            $scope.open = false
          })
        }
      }

      function getFindObj(id) {
        var findObj = {}

        if ($scope.settings.externalIdProp === '') {
          findObj[$scope.settings.idProp] = id
        } else {
          findObj[$scope.settings.externalIdProp] = id
        }

        return findObj
      }

      function clearObject(object) {
        for (var prop in object) {
          if (object.hasOwnProperty(prop)) {
            delete object[prop]
          }
        }
      }

      $scope.toggleDropdown = function() {
        if ($scope.disabled) return
        // doing a root$scope broadcast because the other
        // multiselect may not be on the same controller
        if (!$scope.open) {
          $rootScope.$broadcast('glMultiselectDropdown:opening')
        }
        $scope.open = !$scope.open
      }

      $scope.getPropertyForObject = function(object, property) {
        if (angular.isDefined(object) && object.hasOwnProperty(property)) {
          return object[property]
        }

        return ''
      }

      $scope.setSelectedItem = function(id, dontRemove) {
        var findObj = getFindObj(id)
        var finalObj = null
        var onSelect

        dontRemove = dontRemove || false

        if ($scope.settings.externalIdProp === '') {
          finalObj = _.find($scope.options, findObj)
        } else {
          finalObj = findObj
        }

        if ($scope.singleSelection) {
          clearObject($scope.selectedModel)
          _.assign($scope.selectedModel, finalObj)
          $scope.open = false
          // HACK: not using angular callbacks correctly
          onSelect = $scope.onSelect()
          if (onSelect) {
            onSelect(
              $scope.getPropertyForObject(
                $scope.selectedModel,
                $scope.settings.idProp
              )
            )
          }
          return
        }

        var exists = _.findIndex($scope.selectedModel, findObj) !== -1

        if (!dontRemove && exists) {
          // save temp state to use with onDeselect function - allow us to remove it first in case
          // controller/service is reliant on $scope.selectedModel instead of using the callback arguments
          var modelState = _.clone($scope.selectedModel)

          $scope.selectedModel.splice(
            _.findIndex($scope.selectedModel, findObj),
            1
          )

          if ($scope.onDeselect) {
            $scope.onDeselect()(
              $scope.getPropertyForObject(modelState, $scope.settings.idProp)
            )
          }
        } else if (
          !exists &&
          ($scope.settings.selectionLimit === 0 ||
            $scope.selectedModel.length < $scope.settings.selectionLimit)
        ) {
          $scope.selectedModel.push(finalObj)
          // HACK: not using angular callbacks correctly
          onSelect = $scope.onSelect()
          if (onSelect) {
            onSelect(
              $scope.getPropertyForObject(
                $scope.selectedModel,
                $scope.settings.idProp
              )
            )
          }
        }

        if ($scope.settings.closeOnSelect) {
          $scope.open = false
        }
      }

      $scope.isChecked = function(id) {
        if ($scope.singleSelection) {
          return (
            $scope.selectedModel !== null &&
            angular.isDefined($scope.selectedModel[$scope.settings.idProp]) &&
            $scope.selectedModel[$scope.settings.idProp] ===
              getFindObj(id)[$scope.settings.idProp]
          )
        }
        return _.findIndex($scope.selectedModel, getFindObj(id)) !== -1
      }

      $scope.checkAll = function() {
        _.forEach($scope.options, function(value) {
          $scope.setSelectedItem(value[$scope.settings.idProp], true)
        })
      }

      $scope.uncheckAll = function() {
        if ($scope.singleSelection) {
          clearObject($scope.selectedModel)
        } else {
          $scope.selectedModel.splice(0, $scope.selectedModel.length)
        }

        // call onDeselect to ensure event get's fired when clearing model - filters do not respond otherwise
        if ($scope.onDeselect) {
          $scope.onDeselect()(
            $scope.getPropertyForObject(
              $scope.selectedModel,
              $scope.settings.idProp
            )
          )
        }
      }

      $scope.getButtonText = function() {
        if (
          $scope.settings.dynamicTitle &&
          ($scope.selectedModel.length > 0 ||
            (angular.isObject($scope.selectedModel) &&
              _.keys($scope.selectedModel).length > 0))
        ) {
          if ($scope.settings.smartButtonMaxItems > 0) {
            var itemsText = []

            _.forEach($scope.options, function(optionItem) {
              if (
                $scope.isChecked(
                  $scope.getPropertyForObject(
                    optionItem,
                    $scope.settings.idProp
                  )
                )
              ) {
                var displayText = $scope.getPropertyForObject(
                  optionItem,
                  $scope.settings.displayProp
                )
                var converterResponse = $scope.settings.smartButtonTextConverter(
                  displayText,
                  optionItem
                )

                itemsText.push(
                  converterResponse ? converterResponse : displayText
                )
              }
            })

            if (
              $scope.selectedModel.length > $scope.settings.smartButtonMaxItems
            ) {
              itemsText = itemsText.slice(
                0,
                $scope.settings.smartButtonMaxItems
              )
              itemsText.push('...')
            }

            return itemsText.join(', ')
          } else {
            var totalSelected

            if ($scope.singleSelection) {
              totalSelected =
                $scope.selectedModel !== null &&
                angular.isDefined($scope.selectedModel[$scope.settings.idProp])
                  ? 1
                  : 0
            } else {
              totalSelected = angular.isDefined($scope.selectedModel)
                ? $scope.selectedModel.length
                : 0
            }

            if (totalSelected === 0) {
              return $scope.texts.buttonDefaultText
            } else {
              return totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix
            }
          }
        } else {
          return $scope.texts.buttonDefaultText
        }
      }
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').filter('glNToBr', nToBrFilter)

  /**
   * @name nToBr
   * @description converts linux and windows line breaks into html line breaks
   */
  function nToBrFilter() {
    return function(input) {
      if (input === undefined) {
        return ''
      }

      return _.isString(input)
        ? input.replace(/(?:\r\n|\r|\n)/g, '<br />')
        : input
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components.overlock').component('gOverlock', {
    controller: Controller,
    templateUrl: 'overlock.html',
    transclude: true,
    bindings: {
      opacity: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this
    ctrl.DefaultOpacity = 0.7
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["PanelTarget"];
  angular.module('glow.components').factory('PanelPreset', Factory)

  /* @ngInject */
  function Factory(PanelTarget) {
    var States = {
      ACTIVE: 'ACTIVE',
      DEPRECATED: 'DEPRECATED',
    }

    var DefaultTags = {
      GLOW: 'GLOW',
      DYNATA: 'Dynata',
    }

    var DefaultSelectedTag = 'GLOW_DEFAULT'
    var FileExtension = '.gpp' // stands for Glow Panel Preset

    var getCustomTag = function(subscriberId) {
      return 'subscriber:' + subscriberId
    }

    function PanelPreset(options) {
      _.defaults(this, options, {
        subscriberId: '',
      })
      this.applyDefaults()
    }

    PanelPreset.prototype.States = PanelPreset.States = States
    PanelPreset.prototype.DefaultTags = PanelPreset.DefaultTags = DefaultTags
    PanelPreset.prototype.DefaultSelectedTag = PanelPreset.DefaultSelectedTag = DefaultSelectedTag
    PanelPreset.prototype.getCustomTag = PanelPreset.getCustomTag = getCustomTag
    PanelPreset.prototype.FileExtension = PanelPreset.FileExtension = FileExtension

    PanelPreset.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: null,
        country: null,
        language: null,
        name: null,
        description: null,
        editable: true,
        state: null,
        tags: [],
        targets: [],
        updatedAt: null,
        createdAt: null,
      })
    }

    PanelPreset.prototype.deserialize = function(data) {
      var self = this
      this.id = data.id
      this.country = data.countryISOCode
      this.language = data.languageISOCode
      this.name = data.name
      this.description = data.description
      this.editable = data.editable
      this.state = data.state
      this.tags = data.tags

      this.targets = []
      _.each(data.quotaPlan.filters, function(filter) {
        var target = new PanelTarget().deserialize(filter)
        self.targets.push(target)
      })
      _.each(data.quotaPlan.quotaGroups, function(group) {
        var target = new PanelTarget().deserialize(group)
        self.targets.push(target)
      })

      this.updatedAt = data.updatedAt ? moment(new Date(data.updatedAt)) : null
      this.createdAt = data.createdAt ? moment(new Date(data.createdAt)) : null
      this.applyDefaults()
      return this
    }

    PanelPreset.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.countryISOCode = this.country
      data.languageISOCode = this.language
      data.name = this.name
      data.description = this.description
      data.editable = this.editable
      data.state = this.state || States.ACTIVE

      if (!this.tags.length && this.subscriberId) {
        this.tags = [getCustomTag(this.subscriberId)]
      }
      data.tags = this.tags.slice()

      data.quotaPlan = {}

      var filters = _.filter(this.targets, function(target) {
        return target.isFilter()
      })
      data.quotaPlan.filters = _.map(filters, function(target) {
        return target.serialize(true)
      })

      var allocations = _.filter(this.targets, function(target) {
        return target.isAllocation()
      })
      data.quotaPlan.quotaGroups = _.map(allocations, function(target) {
        return target.serialize(true)
      })

      return data
    }

    PanelPreset.prototype.isCustom = function() {
      if (!this.subscriberId) return false
      return _.includes(this.tags, getCustomTag(this.subscriberId))
    }

    PanelPreset.prototype.generateFileName = function() {
      return (
        (this.name || 'custom') +
        '-' +
        this.country +
        '-' +
        this.language +
        FileExtension
      )
    }

    PanelPreset.prototype.clone = function() {
      var options = { subscriberId: this.subscriberId }
      return new PanelPreset(options).deserialize(this.serialize())
    }

    return PanelPreset
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["PanelTargetNode"];
  angular.module('glow.components').factory('PanelTargetCell', Factory)

  /* @ngInject */
  function Factory(PanelTargetNode) {
    function PanelTargetCell() {
      this.applyDefaults()
    }

    PanelTargetCell.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: null,
        count: null,
        percent: null,
        nodes: [],
      })
    }

    PanelTargetCell.prototype.deserialize = function(data) {
      this.id = data.quotaCellId
      this.count = data.count
      this.percent = data.perc
      this.nodes =
        data.quotaNodes &&
        data.quotaNodes.map(function(node) {
          return new PanelTargetNode().deserialize(node)
        })
      this.applyDefaults()
      return this
    }

    PanelTargetCell.prototype.serialize = function(keepPercent) {
      var data = {}
      data.count = this.count

      if (keepPercent) {
        data.perc = this.percent
      }

      data.quotaCellId = this.id
      data.quotaNodes = this.nodes.map(function(node) {
        return node.serialize()
      })
      return data
    }

    PanelTargetCell.prototype.clone = function() {
      return new PanelTargetCell().deserialize(this.serialize(true))
    }

    return PanelTargetCell
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('PanelTargetNode', Factory)

  /* @ngInject */
  function Factory() {
    var Operators = {
      INCLUDE: 'INCLUDE',
      EXCLUDE: 'EXCLUDE',
    }

    function PanelTargetNode() {
      this.applyDefaults()
    }

    PanelTargetNode.prototype.Operators = PanelTargetNode.Operators = Operators

    PanelTargetNode.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        attributeId: null,
        options: [],
        operator: Operators.INCLUDE,
      })
    }

    PanelTargetNode.prototype.deserialize = function(data) {
      this.attributeId = data.attributeId
      this.options = data.options.slice()
      this.operator = data.operator
      this.applyDefaults()
      return this
    }

    PanelTargetNode.prototype.serialize = function() {
      var data = {}
      data.attributeId = this.attributeId
      data.operator = this.operator
      data.options = this.options.slice()
      return data
    }

    PanelTargetNode.prototype.clone = function() {
      return new PanelTargetNode().deserialize(this.serialize())
    }

    return PanelTargetNode
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["PanelTargetCell"];
  angular.module('glow.components').factory('PanelTarget', Factory)

  var gids = 0

  /* @ngInject */
  function Factory(PanelTargetCell) {
    var Types = {
      FILTER: 'FILTER',
      ALLOCATION: 'ALLOCATION',
    }

    function PanelTarget() {
      this.applyDefaults()
    }

    PanelTarget.prototype.Types = PanelTarget.Types = Types

    PanelTarget.prototype.applyDefaults = function() {
      /**
       * A note on ID's
       * --------------
       * Dynata provision these ID's automatically but we need to identify
       * these somehow so we generate glow id's for this purpose
       */
      _.defaultsDeep(this, {
        id: null,
        gid: ++gids,
        type: Types.FILTER,
        name: null,
        cells: [],
        attributeIds: [], // attributeIds are a vertical slice of attributes used in cells
      })
    }

    PanelTarget.prototype.deserialize = function(data) {
      var self = this

      if (data.attributeId) {
        // FILTER
        self.id = null
        self.type = Types.FILTER
        self.name = null
        self.cells = []
        data.options.forEach(function(option) {
          var cell = new PanelTargetCell().deserialize({
            quotaNodes: [
              {
                attributeId: data.attributeId,
                operator: data.operator,
                options: [option],
              },
            ],
          })
          self.cells.push(cell)
        })
        self.attributeIds = [data.attributeId]
      }

      if (data.quotaCells) {
        // ALLOCATION
        self.id = data.quotaGroupId
        self.type = Types.ALLOCATION
        self.name = data.name
        self.cells = data.quotaCells.map(function(cell) {
          return new PanelTargetCell().deserialize(cell)
        })
        self.attributeIds = data.quotaCells[0].quotaNodes.map(function(
          quotaNode
        ) {
          return quotaNode.attributeId
        })
      }

      self.applyDefaults()
      return self
    }

    PanelTarget.prototype.serialize = function(keepPercent) {
      var data
      if (this.type === Types.FILTER) {
        this.cells.forEach(function(cell) {
          var nodeData = cell.nodes[0].serialize()
          if (!data) {
            data = nodeData
            return
          }
          data.options.push(nodeData.options[0])
        })
      }
      if (this.type === Types.ALLOCATION) {
        data = {}
        data.name = this.name
        data.quotaCells = this.cells.map(function(cell) {
          return cell.serialize(keepPercent)
        })
        data.quotaGroupId = this.id
      }
      return data
    }

    PanelTarget.prototype.isFilter = function() {
      return this.type === Types.FILTER
    }

    PanelTarget.prototype.isAllocation = function() {
      return this.type === Types.ALLOCATION
    }

    PanelTarget.prototype.removeCell = function(cell) {
      _.remove(this.cells, cell)
    }

    PanelTarget.prototype.interlock = function(target) {
      var self = this

      if (self.type === Types.FILTER)
        return console.error('filter targets cannot interlock')
      if (target.type === Types.FILTER)
        return console.error('cannot interlock a filter target')
      if (target.attributeIds.length > 1)
        return console.error(
          'cannot interlock a target that is already interlocked'
        )

      var ourReferenceCells = self.cells
      self.cells = []

      ourReferenceCells.forEach(function(ourCell) {
        var count = Math.round(ourCell.count / target.cells.length)
        var leftover = ourCell.count - count * target.cells.length

        target.cells.forEach(function(theirCell, idx) {
          var newCell = ourCell.clone()

          // NOTE: we've disabled source count distribution as the
          // business thinks its confusing. I'm leaving it here for the
          // day someone else comes up with this idea and wants it
          // implemented >.<
          newCell.count = 0
          // // works similar to PanelTarget.splitEvenly()
          // newCell.count = count
          // // count must be a whole number so if they can't be evenly split we
          // // add the leftover to the first cell
          // if (idx === 0) newCell.count += leftover

          theirCell.nodes.forEach(function(theirNode) {
            newCell.nodes.push(theirNode.clone())
          })
          self.cells.push(newCell)
        })
      })

      target.attributeIds.forEach(function(attributeId) {
        self.attributeIds.push(attributeId)
      })
    }

    PanelTarget.prototype.splitEvenly = function(total) {
      var count = Math.floor(total / this.cells.length)
      var leftover = total - count * this.cells.length
      this.cells.forEach(function(cell) {
        cell.count = count
        // count must be a whole number so if they can't be evenly split we
        // spread the leftover
        if (leftover > 0) {
          cell.count += 1
          leftover--
        }
      })
      // ensure any stragglers are added
      if (leftover > 0) {
        this.cells[0].count += leftover
      }
    }

    PanelTarget.prototype.clone = function() {
      return new PanelTarget().deserialize(this.serialize(true))
    }

    PanelTarget.prototype.percentToCount = function(total) {
      if (this.type === Types.FILTER) return
      var self = this
      var remainder = total
      self.cells.forEach(function(cell) {
        var count = Math.floor((cell.percent / 100) * total)
        cell.count = count
        remainder -= count
      })
      var idx = 0
      while (remainder > 0) {
        self.cells[idx].count += 1
        remainder -= 1
        idx++
      }
    }

    PanelTarget.prototype.countToPercent = function() {
      if (this.type === Types.FILTER) return
      var self = this
      var total = 0
      self.cells.forEach(function(cell) {
        total += cell.count
      })
      self.cells.forEach(function(cell) {
        cell.percent = (cell.count / total) * 100
      })
    }

    PanelTarget.prototype.getTotal = function() {
      var self = this
      return _.sumBy(self.cells, function(cell) {
        return cell.count
      })
    }

    return PanelTarget
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils", "configService", "LOI", "PanelTarget"];
  angular.module('glow.components').factory('Panel', Factory)

  /* @ngInject */
  function Factory(glUtils, configService, LOI, PanelTarget) {
    var notificationEmails = ['panel@glowfeed.com', 'deminetix+ssi@gmail.com']

    // suppress Dynata email notifications if not production
    if (!configService.isProduction()) {
      notificationEmails = ['nobody@3a3af585-99a1-4324-b527-265df0612a2e.com']
    }

    var DeliveryTypes = {
      SLOW: 'SLOW',
      BALANCED: 'BALANCED',
      FAST: 'FAST',
    }

    var validateTargets = function(targets, requiredCompletes) {
      var errors = []
      _.each(targets, function(target) {
        if (!target.cells.length) {
          errors.push('Targets must have at least one row')
        }
        if (target.type === target.Types.ALLOCATION) {
          var total = 0
          target.cells.forEach(function(cell) {
            if (!_.isNumber(cell.count)) {
              errors.push('All target rows must have a count')
              return false
            }
            total += cell.count
          })
          if (total < requiredCompletes) {
            errors.push('Target count total is less than required completes.')
          }
          if (total > requiredCompletes) {
            errors.push(
              'Target count total is greater than required completes.'
            )
          }
        }
      })
      return errors
    }

    function Panel() {
      this.applyDefaults()
    }

    Panel.prototype.DeliveryTypes = Panel.DeliveryTypes = DeliveryTypes
    Panel.prototype.validateTargets = Panel.validateTargets = validateTargets

    Panel.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: glUtils.uuid(),
        category: 'BUSINESS', // IMPORTANT: the UI for this field has been removed. Need to update this value if Dynata make changes to the categories.
        state: 'NEW',
        country: 'AU',
        language: 'en',
        surveyUrl: null,
        surveyTestUrl: null,
        incidenceRate: 100,
        daysInField: 3, // HACK: ssi api doesnt return this :'(
        lengthOfInterview: new LOI(),
        deliveryType: DeliveryTypes.BALANCED,
        requiredCompletes: 1000,
        targets: [],
        exclusions: [],
        stateLastUpdatedAt: null,
        updatedAt: null,
        createdAt: null,
      })
    }

    Panel.prototype.deserialize = function(data) {
      var self = this
      var lineItem = data.lineItems[0]

      this.id = data.extProjectId
      this.category = data.category.surveyTopic[0]
      this.state = lineItem.state
      this.country = lineItem.countryISOCode
      this.language = lineItem.languageISOCode
      this.surveyUrl = lineItem.surveyURL
      this.surveyTestUrl = lineItem.surveyTestURL
      this.incidenceRate = lineItem.indicativeIncidence
      this.daysInField = lineItem.daysInField
      this.lengthOfInterview = new LOI().deserialize(
        lineItem.lengthOfInterview * 60 // SSI uses minutes, we use seconds
      )
      this.deliveryType = lineItem.deliveryType
      this.requiredCompletes = lineItem.targets[0].count

      this.targets = []
      _.each(lineItem.quotaPlan.filters, function(filterData) {
        self.targets.push(new PanelTarget().deserialize(filterData))
      })
      _.each(lineItem.quotaPlan.quotaGroups, function(quotaGroupData) {
        self.targets.push(new PanelTarget().deserialize(quotaGroupData))
      })

      if (data.exclusions && _.isArray(data.exclusions.list)) {
        this.exclusions = data.exclusions.list
      }
      this.endLinks = {}
      if (lineItem.endLinks) {
        this.endLinks.complete = lineItem.endLinks.complete
        this.endLinks.overquota = lineItem.endLinks.overquota
        this.endLinks.screenout = lineItem.endLinks.screenout
        this.endLinks.qualityExit = this.getQualityExitLink(
          lineItem.endLinks.screenout
        )
        this.endLinks.securityKey1 = lineItem.endLinks.securityKey1
        this.endLinks.securityLevel = lineItem.endLinks.securityLevel
      }
      this.stateLastUpdatedAt = lineItem.stateLastUpdatedAt
        ? moment(new Date(lineItem.stateLastUpdatedAt))
        : null
      this.updatedAt = data.updatedAt ? moment(new Date(data.updatedAt)) : null
      this.createdAt = data.createdAt ? moment(new Date(data.createdAt)) : null

      // Note: We keep the original data because we only use a subset of the SSI functionality
      // from their api, in order to keep our own model simple.
      // We then combine our model with the original on serialization to make sure their api
      // still receives fields it may care about
      this._ = _.cloneDeep(data)

      this.applyDefaults()
      return this
    }

    Panel.prototype.serialize = function() {
      // Note: To keep our model simple we abstract away a few things we don't need such as
      // multiple line-items and some configuration. The SSI api probably still needs
      // these fields in requests so we apply them here, but in user land we don't need to
      // think about them.
      var data = this._
        ? _.cloneDeep(this._)
        : {
            title: this.id,
            notificationEmails: notificationEmails,
            devices: ['mobile', 'tablet', 'desktop'],
            category: {
              surveyTopic: [],
            },
            lineItems: [
              {
                extLineItemId: this.id,
                title: this.id,
                quotaPlan: {
                  filters: [],
                  quotaGroups: [],
                },
                targets: [
                  {
                    count: 0,
                    type: 'COMPLETE',
                  },
                ],
              },
            ],
          }
      if (_.isArray(data.lineItems[0].quotaPlan)) {
        data.lineItems[0].quotaPlan = {
          filters: [],
          quotaGroups: [],
        }
      }

      data.extProjectId = this.id
      data.category.surveyTopic[0] = this.category

      var lineItem = data.lineItems[0]
      lineItem.state = this.state
      lineItem.countryISOCode = this.country
      lineItem.languageISOCode = this.language
      lineItem.surveyURL = this.surveyUrl
      lineItem.surveyTestURL = this.surveyTestUrl
      lineItem.indicativeIncidence = this.incidenceRate
      lineItem.daysInField = this.daysInField
      lineItem.lengthOfInterview =
        // SSI use whole minutes > 0, we use seconds
        Math.max(1, Math.ceil(this.lengthOfInterview.serialize() / 60))
      lineItem.deliveryType = this.deliveryType
      lineItem.requiredCompletes = undefined // deprecated so we remove it
      lineItem.targets[0].count = this.requiredCompletes

      var filters = _.filter(this.targets, function(target) {
        return target.isFilter()
      })
      lineItem.quotaPlan.filters = _.map(filters, function(target) {
        return target.serialize()
      })

      var allocations = _.filter(this.targets, function(target) {
        return target.isAllocation()
      })
      lineItem.quotaPlan.quotaGroups = _.map(allocations, function(target) {
        return target.serialize()
      })

      data.exclusions = {
        type: 'PROJECT',
        list: this.exclusions,
      }
      data.respondentFilters = undefined

      return data
    }

    Panel.prototype.serializeForLaunched = function() {
      var data = {}

      data.extProjectId = this.id
      data.exclusions = {
        type: 'PROJECT',
        list: this.exclusions,
      }

      return data
    }

    Panel.prototype.isNew = function() {
      return this.state === 'NEW'
    }

    Panel.prototype.forEstimate = function() {
      // This transforms the panel into a generic
      // structure to be used for generating estimates etc
      // Example: panelService.create().forEstimate()
      this.category = 'BUSINESS'
      this.country = 'AU'
      this.language = 'en'
      this.surveyUrl = this.surveyTestUrl =
        'https://app.glowfeed.com/survey/123'
      this.incidenceRate = 100
      this.daysInField = 3
      this.lengthOfInterview.set(2)
      this.requiredCompletes = 1000
      return this
    }

    Panel.prototype.setSurveyUrls = function(surveyUrl) {
      var params =
        '?pid=<#DubKnowledge[1500/Entity id]>&K2=<#Project[Secure Key 2]>&psid=<#IdParameter[Value]>'
      this.surveyUrl = surveyUrl + params
      this.surveyTestUrl = surveyUrl + params + '&readOnly=true'
    }

    Panel.prototype.clone = function() {
      // only exact copies allowed
      return new Panel().deserialize(this.serialize())
    }

    Panel.prototype.replace = function(panel) {
      this.deserialize(panel.serialize())
    }

    Panel.prototype.validate = function() {
      var self = this
      self.errors = []
      var internalErrors = []
      if (!self.category) self.errors.push('Category is required')
      if (!self.country) self.errors.push('Country is required')
      if (!self.language) self.errors.push('Language is required')
      if (!self.surveyUrl) internalErrors.push('SurveyUrl is required')
      if (!self.surveyTestUrl) internalErrors.push('SurveyTestUrl is required')
      if (!self.incidenceRate) self.errors.push('Incidence Rate is required')
      if (!self.daysInField) self.errors.push('Days In Field is required')
      if (!self.lengthOfInterview)
        self.errors.push('Length of Interview is required')
      if (!self.deliveryType) self.errors.push('Delivery Type is required')
      if (!self.requiredCompletes)
        self.errors.push('Required Completes is required')

      self.errors = self.errors.concat(
        self.validateTargets(self.targets, self.requiredCompletes)
      )

      if (internalErrors.length) {
        console.error('Internal Panel Validation Errors', internalErrors)
        return false
      }
      if (self.errors.length) return false
      return true
    }

    Panel.prototype.getQualityExitLink = function(exitLink) {
      return (exitLink += '&qflag=3')
    }

    Panel.prototype.generateEndLinks = function(psid, pid, K2) {
      var med = this.endLinks.securityKey1 * pid - K2
      return {
        complete: _.chain(this.endLinks.complete)
          .replace('{psid}', psid)
          .replace('{calculatedSecurityCode}', med)
          .value(),
        screenout: _.chain(this.endLinks.screenout)
          .replace('{psid}', psid)
          .value(),
        overquota: _.chain(this.endLinks.overquota)
          .replace('{psid}', psid)
          .value(),
        qualityExit: _.chain(this.endLinks.qualityExit)
          .replace('{psid}', psid)
          .value(),
      }
    }

    Panel.prototype.canUseAsExclusion = function() {
      // Dynata API currently only accepts exclusions for channels that
      // have been launched, including any states after this
      // see: https://developers.dynata.com/demand-api/building/lifecycle
      return _.includes(
        ['LAUNCHED', 'PAUSED', 'CLOSED', 'INVOICED'],
        this.state
      )
    }

    Panel.prototype.isUpdateRestricted = function() {
      return _.includes(['QA_APPROVED', 'LAUNCHED'], this.state)
    }

    Panel.prototype.dynataDateToMoment = function(str) {
      var isoStr = ''
      isoStr += str.substr(0, 10).replace(/\//g, '-')
      isoStr += 'T'
      isoStr += str.substr(11, 8)
      isoStr += '.000Z'
      return moment(isoStr)
    }

    Panel.prototype.getFakeRespondentLink = function() {
      // generates a valid link that can be used to submit a response to this survey.
      // the respondentId etc is fake so the panel will obviously reject the redirect.
      var url = this.surveyUrl
      url = url.replace('<#DubKnowledge[1500/Entity id]>', glUtils.uuid())
      url = url.replace('<#Project[Secure Key 2]>', _.random(1000, 9999))
      url = url.replace('<#IdParameter[Value]>', _.random(1000, 9999))
      // example:
      // https://portal.glowfeed.com/audience-channels/a926e01d-1dba-45a7-80b4-cd2e10131261?pid=af0cff6c-0143-4101-b4b1-74574bc84447&K2=2720&psid=7467
      return url
    }

    return Panel
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "$http", "$timeout", "ssiResource", "api", "userService", "configService", "Panel", "PanelPreset"];
  angular.module('glow.components').service('panelService', Service)

  /* @ngInject */
  function Service(
    $q,
    $http,
    $timeout,
    ssiResource,
    api,
    userService,
    configService,
    Panel,
    PanelPreset
  ) {
    var self = this
    var presetsCache = {} // use a non-cloned cache
    var cache = {}
    var publicAttributeIds = [
      '11', // Gender
      '13', // Age range
      '9521206', // Geo ABS Region (AU)
      '2243', // Geo Region (UK)
      '88097', // Geo Subcountry (UK)
      '62160', // Geo State (US)
      '86583', // Geo Province (CA)
      '488023', // Geo Region (CA)
      '323630', // Geo Regional Division (NZ)
      '6630696', // Geo District (NZ)
      '10006904', // Geo Region (NZ)
    ]
    var natRepTemplateIds_STAGING = {
      'US/en': 133,
      'GB/en': 132,
      'NZ/en': 131,
      'CA/en': 130,
      'AU/en': 129,
    }
    var natRepTemplateIds_PROD = {
      'US/en': 361,
      'GB/en': 360,
      'NZ/en': 359,
      'CA/en': 358,
      'AU/en': 357,
    }

    self.create = create
    self.save = save
    self.get = get
    self.getRaw = getRaw
    self.awaitFeasibility = awaitFeasibility
    self.buy = buy
    self.acceptReprice = acceptReprice
    self.close = close
    self.getCategories = getCategories
    self.getCountries = getCountries
    self.getAttributes = getAttributes
    self.getPresets = getPresets
    self.savePreset = savePreset
    self.deletePreset = deletePreset
    self.applyPreset = applyPreset
    self.getTemplateIdMappings = getTemplateIdMappings

    window.uploadRepsamples = uploadRepsamples

    function create() {
      return new Panel()
    }

    function save(panel) {
      return $q(function(resolve, reject) {
        var action = panel.isNew() ? 'createProject' : 'updateProject'
        var data
        // LAUNCHED only updates supported fields
        if (panel.state === 'LAUNCHED') {
          data = panel.serializeForLaunched()
        } else {
          data = panel.serialize()
        }
        ssiResource[action](data)
          .success(function(_, resp) {
            panel.state = resp.data.lineItems[0].state
            panel.stateLastUpdatedAt = moment(
              new Date(resp.data.lineItems[0].stateLastUpdatedAt)
            )
            panel.createdAt = moment(new Date(resp.data.createdAt))
            panel.updatedAt = moment(new Date(resp.data.updatedAt))
            resolve(panel)
          })
          .error(function(err) {
            console.log(err)
            reject({
              name: 'PanelError',
              message: panel.isNew()
                ? 'Could not create panel'
                : 'Could not update panel',
              errors: _.map(err.status.errors, 'message'),
            })
          })
      })
    }

    function get(id) {
      return getRaw(id).then(function(data) {
        return new Panel().deserialize(data)
      })
    }

    function getRaw(id) {
      return $q(function(resolve, reject) {
        ssiResource
          .getProject({ extProjectId: id })
          .success(function(_, resp) {
            resolve(resp.data)
          })
          .error(function(error) {
            reject(error)
          })
      })
    }

    function awaitFeasibility(panel) {
      return $q(function(resolve, reject) {
        function checkIfReady() {
          getFeasibility(panel)
            .then(function(feasibility) {
              if (feasibility.status === 'READY') {
                // MOCK: is feasible!
                // feasibility.feasible = true

                resolve(feasibility)
              } else {
                $timeout(checkIfReady, 1000)
              }
            })
            .catch(reject)
        }
        checkIfReady()
      })
    }

    function getFeasibility(panel) {
      return $q(function(resolve, reject) {
        ssiResource
          .getFeasibility({ extProjectId: panel.id })
          .success(function(_, resp) {
            console.log('panel.getFeasibility', resp.data[0].feasibility)
            resolve(resp.data[0].feasibility)
          })
          .error(function() {
            reject({
              message: 'Error checking feasibility',
            })
          })
      })
    }

    function buy(panel) {
      return $q(function(resolve, reject) {
        // This is the first time we've had to send
        // an array of data through a resource where
        // the resource also derives a url segment from
        // a value.
        var data = []
        data.extProjectId = panel.id // static Array field!
        data.push({
          extLineItemId: panel.id,
          surveyURL: panel.surveyUrl,
          surveyTestURL: panel.surveyTestUrl,
        })
        ssiResource
          .buyProject(data)
          .success(function(_, resp) {
            panel.state = resp.data[0].state
            resolve()
          })
          .error(function() {
            reject({
              name: 'BuyPanelError',
              message: 'There was an issue buying panel',
            })
          })
      })
    }

    function acceptReprice(panel) {
      return $q(function(resolve, reject) {
        ssiResource
          .getEvents()
          .success(function(x, resp) {
            var event = _.find(resp.data, {
              eventType: 'LineItem:RepriceTriggered',
              extLineItemId: panel.id,
            })
            if (!event) {
              return reject({
                name: 'AcceptRepricePanelError',
                message: 'There was an issue resuming panel',
              })
            }
            ssiResource
              .performEventAction({
                action: event.actions.acceptURL.split('/events/')[1],
              })
              .success(function(x, resp) {
                panel.state = resp.data.resource.status.newValue
                resolve()
              })
              .error(function() {
                reject({
                  name: 'AcceptRepricePanelError',
                  message: 'There was an issue resuming panel',
                })
              })
          })
          .error(function() {
            reject({
              name: 'AcceptRepricePanelError',
              message: 'There was an issue resuming panel',
            })
          })
      })
    }

    function close(panel) {
      return $q(function(resolve, reject) {
        // ss
        // // This is the first time we've had to send
        // // an array of data through a resource where
        // // the resource also derives a url segment from
        // // a value.
        // var data = []
        // data.extProjectId = panel.id // static Array field!
        // data.push({
        //     extLineItemId: panel.id,
        //     surveyURL: panel.surveyUrl,
        //     surveyTestURL: panel.surveyTestUrl,
        // })
        ssiResource
          .closeProject({ extProjectId: panel.id })
          .success(function(_, resp) {
            panel.state = resp.data.lineItems[0].state
            panel.stateLastUpdatedAt = resp.data.lineItems[0].stateLastUpdatedAt
            panel.updatedAt = moment(new Date(resp.data.updatedAt))
            console.log('panel closed', panel)
            resolve()
          })
          .error(function() {
            reject({
              name: 'ClosePanelError',
              message: 'There was an issue closing the panel',
            })
          })
      })
    }

    function getCategories() {
      return $q(function(resolve, reject) {
        var cached = getCached('categories')
        if (cached) return resolve(cached)
        ssiResource
          .getCategories({ limit: 100 })
          .success(function(_, resp) {
            resolve(resp.data)
            setCached('categories', resp.data)
          })
          .error(function(err) {
            reject(err)
          })
      })
    }

    function getCountries() {
      return $q(function(resolve, reject) {
        var cached = getCached('countries')
        if (cached) return resolve(cached)
        ssiResource
          .getCountries({ limit: 1000 })
          .success(function(_, resp) {
            resolve(resp.data)
            setCached('countries', resp.data)
          })
          .error(function(err) {
            reject(err)
          })
      })
    }

    function getAttributes(countryCode, languageCode) {
      var cached = getCached(countryCode + '-' + languageCode)
      if (cached) return $q.resolve(cached)

      // We need all atributes so we need to loop over their
      // paginator to get them all and then combine them.
      // Limit param only works up to 100, it used to be 1000
      // but their API ignored it and used 100 anyway.
      var data = []
      var offset = 0
      function loadRecursive() {
        return api.ssi
          .getAttributes({
            countryCode: countryCode,
            languageCode: languageCode,
            limit: 100,
            offset: offset,
          })
          .then(function(response) {
            response.data.forEach(function(attr) {
              data.push(attr)
            })
            if (response.meta.total > data.length) {
              offset = data.length
              return loadRecursive()
            }
            return data
          })
      }

      return loadRecursive().then(function() {
        var rejected = []
        var attributes = data.filter(function(attribute) {
          // we reject some attributes that have issues or
          // if we do not support them.
          // ---
          // IMPORTANT: we keep state:INACTIVE|DEPRECATED attributes
          // so that older projects can still reference them, but
          // in the UI we don't allow adding them to new channels
          if (attribute.type === 'LIST' && !attribute.options) {
            attribute.rejectedReason = 'type (LIST) has no options'
            rejected.push(attribute)
            return false
          }
          // These are okay as we don't use localizedText anymore
          // if (attribute.localizedText === '&nbsp;&nbsp;') {
          //     attribute.rejectedReason = 'localizedText contains only spaces'
          //     rejected.push(attribute)
          //     return false
          // }
          // if (attribute.localizedText === 'NULL') {
          //     attribute.rejectedReason = 'localizedText field is string value "NULL"'
          //     rejected.push(attribute)
          //     return false
          // }
          if (attribute.text === 'NULL') {
            attribute.rejectedReason = 'text field is string value "NULL"'
            rejected.push(attribute)
            return false
          }
          if (_.includes(publicAttributeIds, attribute.id)) {
            attribute.public = true
          }
          return true
        })
        console.log('attributes (rejected):', rejected)
        setCached(countryCode + '-' + languageCode, attributes)
        return attributes
      })
    }

    function getCached(key) {
      return _.cloneDeep(cache[key])
    }

    function setCached(key, data) {
      cache[key] = _.cloneDeep(data)
    }

    function getPresets(countryCode, languageCode) {
      var cacheKey = 'presets-' + countryCode + '-' + languageCode
      var cached = presetsCache[cacheKey]
      if (cached) return $q.resolve(cached)

      var tags = [PanelPreset.DefaultTags.GLOW, PanelPreset.DefaultTags.DYNATA]
      var subscriberId = userService.getSubscriberId()
      if (subscriberId) {
        tags.push(PanelPreset.getCustomTag(subscriberId))
      }
      return api.ssi
        .getTemplates({
          countryCode: countryCode,
          languageCode: languageCode,
          tags: tags.join(','),
          limit: 100,
          offset: 0,
        })
        .then(function(response) {
          var options = { subscriberId: subscriberId }
          var presets = _.filter(response.data, function(data) {
            // filter out deprecated presets
            return data.state === PanelPreset.States.ACTIVE
          }).map(function(data) {
            return new PanelPreset(options).deserialize(data)
          })
          presetsCache[cacheKey] = presets
          return presets
        })
    }

    function savePreset(preset) {
      var action = preset.id ? updatePreset : createPreset
      return action(preset)
    }

    function createPreset(preset) {
      return api.ssi.createTemplate(preset.serialize()).then(function(data) {
        preset.deserialize(data.data)
        var cacheKey = 'presets-' + preset.country + '-' + preset.language
        var cached = presetsCache[cacheKey]
        if (cached) cached.push(preset)
      })
    }

    function updatePreset(preset) {
      return api.ssi.updateTemplate(preset.serialize()).then(function(data) {
        preset.deserialize(data.data)
      })
    }

    function deletePreset(preset) {
      return api.ssi.deleteTemplate({ id: preset.id }).then(function() {
        var cacheKey = 'presets-' + preset.country + '-' + preset.language
        var cached = presetsCache[cacheKey]
        if (cached) {
          _.remove(cached, function(p) {
            return p.id === preset.id
          })
        }
      })
    }

    function applyPreset(targets, preset, responses) {
      _.remove(targets)
      _.each(preset.targets, function(target) {
        target = target.clone()
        target.percentToCount(responses)
        targets.push(target)
      })
    }

    function getTemplateIdMappings() {
      if (configService.isProduction()) {
        return natRepTemplateIds_PROD
      }
      return natRepTemplateIds_STAGING
    }

    function loadRepresentatives() {
      return $http.get('/repsamples.json').then(function(resp) {
        return resp.data
      })
    }

    function uploadRepsamples() {
      loadRepresentatives().then(function(representatives) {
        var templateIdMappings = getTemplateIdMappings()
        var getTemplatePromises = []
        _.each(representatives, function(value, key) {
          var country = key
          var language = 'en'
          var mappingKey = country + '/' + language
          var templateId = templateIdMappings[mappingKey]
          if (!templateId) return true // continue

          var promise = api.ssi.getTemplates({
            countryCode: country,
            languageCode: language,
            id: templateId,
          })
          getTemplatePromises.push(promise)
        })

        $q.all(getTemplatePromises)
          .then(function(response) {
            var updateTemplatePromises = []
            _.each(response, function(data) {
              var template = data.data[0]
              template.quotaPlan.quotaGroups =
                representatives[template.countryISOCode]
              var preset = new PanelPreset().deserialize(template)
              var promise = updatePreset(preset)
              updateTemplatePromises.push(promise)
            })

            $q.all(updateTemplatePromises)
              .then(function() {
                console.log('SUCCESS')
              })
              .catch(function(err) {
                console.error(err)
              })
          })
          .catch(function(err) {
            console.error(err)
          })
      })
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('PaymentMethod', Factory)

  function Factory() {
    var Brands = {
      visa: 'Visa',
      mastercard: 'MasterCard',
      americanExpress: 'American Express',
      unknown: 'Unknown',
    }

    function PaymentMethod() {
      // ...
    }

    PaymentMethod.prototype.Brands = PaymentMethod.Brands = Brands

    PaymentMethod.prototype.deserialize = function(data) {
      this.id = data.id
      this.brand = data.brand
      this.country = data.country
      this.expMonth = data.expMonth
      this.expYear = data.expYear
      this.lastFour = data.lastFour
      this.name = data.name

      // Moment treats Jan as 0 and Dec as 11 so subtract 1 from stripe's expMonth
      var now = moment()
      this.expDate = moment({
        year: this.expYear,
        month: this.expMonth - 1,
      }).endOf('month')
      this.isExpired = this.expDate.endOf('day').isBefore(now)
      this.expiresSoon = this.expDate.isSame(now, 'month')

      this.maskedCardNumber = makeMaskedCardNumber(this.lastFour, this.brand)

      return this
    }

    function makeMaskedCardNumber(lastFour, brand) {
      lastFour = lastFour || '****'
      switch (brand) {
        case Brands.americanExpress:
          return '**** ***** *' + lastFour
        case Brands.visa:
        case Brands.mastercard:
        default:
          return '**** **** **** ' + lastFour
      }
    }

    return PaymentMethod
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "paymentMethodsResource", "PaymentMethod"];
  angular.module('glow.components').factory('paymentMethodsService', Service)

  /* @ngInject */
  function Service($q, paymentMethodsResource, PaymentMethod) {
    return {
      getBySubscriber: getBySubscriber,
      checkPaymentMethod: checkPaymentMethod,
      create: create,
      replace: replace,
      remove: remove,
    }

    function getBySubscriber(subscriberId) {
      return $q(function(resolve, reject) {
        var options = { subscriberId: subscriberId }
        paymentMethodsResource
          .get(options)
          .success(onSuccess)
          .error(reject)

        function onSuccess(paymentMethods) {
          resolve(
            _.map(paymentMethods, function(paymentMethod) {
              return new PaymentMethod().deserialize(paymentMethod)
            })
          )
        }
      })
    }

    function checkPaymentMethod(subscriberId) {
      return getBySubscriber(subscriberId).then(function(paymentMethods) {
        return paymentMethods.length ? $q.resolve() : $q.reject()
      })
    }

    function create(subscriberId, token) {
      return $q(function(resolve, reject) {
        var options = { subscriberId: subscriberId, tokenId: token }
        paymentMethodsResource
          .create(options)
          .success(resolve)
          .error(reject)
      })
    }

    function replace(subscriberId, token) {
      return $q(function(resolve, reject) {
        var options = { subscriberId: subscriberId, tokenId: token }
        paymentMethodsResource
          .replace(options)
          .success(resolve)
          .error(reject)
      })
    }

    function remove(subscriberId) {
      return $q(function(resolve, reject) {
        var options = { subscriberId: subscriberId }
        paymentMethodsResource
          .remove(options)
          .success(resolve)
          .error(reject)
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["Money", "Currency", "taxService"];
  angular.module('glow.components').factory('Payment', Factory)

  function Factory(Money, Currency, taxService) {
    var DefaultTaxCode = taxService.getByCountry('AU').code

    function Payment() {
      this.applyDefaults()
    }

    Payment.prototype.applyDefaults = function() {
      _.defaults(this, {
        net: new Money(),
        taxAmount: new Money(),
        gross: new Money(),
        currency: Currency.Codes.USD,
        taxCode: DefaultTaxCode,
      })
    }

    Payment.prototype.deserialize = function(data) {
      this.currency = data.chargeCurrency
      this.net = new Money({
        amount: data.chargeAmountNet,
        currency: this.currency,
      })
      this.taxAmount = new Money({
        amount: data.salesTaxAmount,
        currency: this.currency,
      })
      this.gross = new Money({
        amount: data.chargeAmountGross,
        currency: this.currency,
      })
      this.taxCode = data.salesTaxName
      this.applyDefaults()
      return this
    }

    return Payment
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('gPhoneNumber', Service)

  function Service() {
    // Assume valid phone numbers are minimum 4 characters and only include numbers, spaces, +, -, (, )
    // e.g. 0400-000-000, 0400000000, +61 400 000 000, +61 (4) 000 000
    var REGEX = /^[0-9\-\+\s\(\)]{4,}$/

    return {
      isValid: isValid,
    }

    function isValid(phoneNumber) {
      return phoneNumber && REGEX.test(phoneNumber)
    }
  }
})()

;(function() {
  'use strict'

  Directive.$inject = ["gPhoneNumber"];
  angular.module('glow.components').directive('gPhoneNumber', Directive)

  /* @ngInject */
  function Directive(gPhoneNumber) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: link,
    }

    function link(scope, elem, attrs, ctrl) {
      ctrl.$validators.gPhoneNumber = function(phoneNumber) {
        return gPhoneNumber.isValid(phoneNumber)
      }
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('Pipes', Factory)

  // [
  //     {
  //         string: '{{ Q1 }}',
  //         label: 'Question 1',
  //         directives: [
  //             {
  //                 type: 'QUESTION',
  //                 info: 'Injects the answer from Question 1',
  //                 number: 1,
  //                 choice: null,
  //             },
  //             {
  //                 type: 'IGNORE',
  //                 info: 'Shows nothing if the answer is "Foo"',
  //                 match: 'Foo'
  //             },
  //             {
  //                 type: 'REPLACE',
  //                 info: 'Replaces answers to "Carrot" with "Vegetable"',
  //                 match: 'Carrot',
  //                 replace: 'Vegetable'
  //             }
  //         ]
  //     }
  //     {
  //         string: '{{ P_vehicle }}',
  //         label: 'vehicle',
  //         directives: [
  //             {
  //                 type: 'URL_PARAM',
  //                 match: 'vehicle',
  //                 info: 'Inject the URL parameter "vehicle"',
  //             }
  //         ]
  //     }
  //     {
  //         string: '{{ CD_vehicle }}',
  //         label: 'vehicle',
  //         directives: [
  //             {
  //                 type: 'DATA_DIMENSION',
  //                 match: 'vehicle',
  //                 info: 'Inject the data dimension "vehicle"',
  //             }
  //         ]
  //     }
  //     {
  //         string: '{{ CRD_vehicle }}',
  //         label: 'vehicle',
  //         directives: [
  //             {
  //                 type: 'REPORT_DIMENSION',
  //                 match: 'vehicle',
  //                 info: 'Inject the reporting dimension "vehicle"',
  //             }
  //         ]
  //     }
  //     {
  //         string: '{{ RD_vehicle }}',
  //         label: 'vehicle',
  //         directives: [
  //             {
  //                 type: 'SYSTEM_DIMENSION',
  //                 match: 'vehicle',
  //                 info: 'Inject the system dimension "vehicle"',
  //             }
  //         ]
  //     }
  //     {
  //       string: '{{ list_Performance.1 }}',
  //       label: 'List: Performance #1',
  //       directives: [
  //         {
  //           type: 'LIST',
  //           info: 'Inject item #1 from list Performance',
  //           match: 'Performance'
  //           number: 1,
  //         }
  //       ]
  //     }
  //     {
  //       string: '{{ hlist_Performance.1 }}',
  //       label: 'List: Performance #1',
  //       directives: [
  //         {
  //           type: 'LIST',
  //           info: 'Inject item #1 from list Performance',
  //           match: 'Performance'
  //           number: 1,
  //           html: true,
  //         }
  //       ]
  //     }
  // ]

  /* @ngInject */
  function Factory() {
    // var PIPE_REGEX = /{{\s*[\w\s-=|]+\s*}}/g;
    // var PIPE_REGEX = /{{\s*[Qq]\d+([.~]\d+)*\s*(\|\s*-\w[\w\s]+|\|\s*[\w\s]+=[\w\s]+\s*)*}}/g
    // NOTE: we keep ^ these around while we test the new one
    // the first one fired false positive for `{{ }}` which should fail
    var PIPE_REGEX = /{{\s*(((p|crd|rd|cd|hlist|list)_[^\s]+)|(loop_variable)|(variable:[^\s]+)|((if_tag_)[^\s:]+:[^:]+)|(q\d+([.~#]\d+)*)|(q\d+sum\d*)|unknown)\s*(\|\s*-\w[\w\s]+|\|\s*[\w\s]+=[\w\s]+\s*)*}}/gi

    var DIRECTIVE_REGEX = /[\w\s-=.~#:,]+/g
    var WHITESPACE_REGEX = /^\s+|\s+$/g
    var SPLIT_REGEX = /\~|\.|\#|sum/i

    var Directives = {
      QUESTION: 'question',
      IGNORE: 'ignore',
      REPLACE: 'replace',
      URL_PARAM: 'url_param',
      DATA_DIMENSION: 'data_dimension',
      REPORT_DIMENSION: 'report_dimension',
      SYSTEM_DIMENSION: 'system_dimension',
      LIST: 'list',
      IF_TAG: 'if_tag',
      VARIABLE: 'variable',
      LOOP_VARIABLE: 'loop_variable',
      UNKNOWN: 'unknown',
    }

    function Pipes(string) {
      this.set(string)
    }

    Pipes.prototype.Directives = Pipes.Directives = Directives

    Pipes.prototype.getPipeStrings = Pipes.getPipeStrings = function(string) {
      return string.match(PIPE_REGEX) || []
    }

    Pipes.prototype.set = function(string) {
      var self = this
      self.pipes = []
      self.string = string || ''
      if (!this.string) {
        return this
      }
      var pipeStrings = this.string.match(PIPE_REGEX)
      _.each(pipeStrings, function(pipeString) {
        var pipe = {
          string: pipeString,
          directives: [],
        }

        var directiveStrings = pipeString.match(DIRECTIVE_REGEX)
        _.each(directiveStrings, function(directiveString) {
          directiveString = directiveString.replace(WHITESPACE_REGEX, '')

          var directive = {
            type: self.getDirectiveType(directiveString),
          }
          switch (directive.type) {
            case Directives.QUESTION:
              var splitStrings = directiveString.substr(1).split(SPLIT_REGEX)
              var withStatement = splitStrings.length > 2
              directive.number = parseInt(splitStrings[0])

              // Q1.2 means we pipe in the label/text of the respondents 2nd selection in Q1
              // Q1~1 means we pipe in the 1st text entry for Q1 (currently only "Other" for choice, or textAnswer)
              directive.onlyTextEntry = directiveString.includes('~')
              // Q1#1 means we pipe in the 1st number entry for Q1 (currently only numeric question, or textAnswer with numeric validator)
              directive.onlyNumberEntry = directiveString.includes('#')
              // Q1SUM means we pipe in the constant sum question total
              // Q2SUM1 means we pipe in the constant sum quesiton 1st statement total
              directive.onlySumEntry = /sum/i.test(directiveString)

              // directive.choice defines the number choice for Targets.SELECTION but
              // also the number text answer for Targets.TEXT
              // TODO: it would be nice to have this as directive.selection or something
              directive.choice = withStatement
                ? parseInt(splitStrings[2])
                : splitStrings[1]
                ? parseInt(splitStrings[1])
                : null

              // Q1.1.2 means we pipe in the label/text of statement 1 and 2nd selection in Q1
              directive.statement = withStatement
                ? parseInt(splitStrings[1])
                : null

              directive.number = parseInt(directiveString.substr(1))

              if (directive.onlySumEntry) {
                // If there's a choice but no statement, turn the choice into the statement
                if (directive.choice && !directive.statement) {
                  directive.statement = directive.choice
                }
                // For SUM entries, choice is not applicable
                directive.choice = null

                // Build directive info
                directive.info =
                  'Injects the SUM from Question ' + directive.number
                if (directive.statement) {
                  directive.info += ' > Statement ' + directive.statement
                }

                // Build pipe label
                pipe.label =
                  'Q' +
                  directive.number +
                  (directive.statement ? ' > ' + directive.statement : '') +
                  ' (SUM)'
              } else if (directive.choice) {
                var statementPipeLabel = directive.statement
                  ? ' > ' + directive.statement
                  : ''
                if (directive.onlyTextEntry) {
                  directive.info =
                    'Injects text answer ' +
                    directive.choice +
                    ' from Question ' +
                    directive.number
                  pipe.label =
                    'Q' +
                    directive.number +
                    statementPipeLabel +
                    ' > ' +
                    directive.choice +
                    ' (Text)'
                } else if (directive.onlyNumberEntry) {
                  directive.info =
                    'Injects numeric answer ' +
                    directive.choice +
                    ' from Question ' +
                    directive.number
                  pipe.label =
                    'Q' +
                    directive.number +
                    statementPipeLabel +
                    ' > ' +
                    directive.choice +
                    ' (Number)'
                } else {
                  directive.info =
                    'Injects selection ' +
                    directive.choice +
                    ' from Question ' +
                    directive.number
                  pipe.label =
                    'Q' +
                    directive.number +
                    statementPipeLabel +
                    ' > ' +
                    directive.choice
                }
                if (directive.statement) {
                  directive.info += ' > Statement ' + directive.statement
                }
              } else {
                directive.info =
                  'Injects the answer from Question ' + directive.number
                pipe.label = 'Question ' + directive.number
              }
              break
            case Directives.IGNORE:
              directive.match = directiveString.substr(1)
              directive.info =
                'Shows nothing if the answer is "' + directive.match + '"'
              break
            case Directives.REPLACE:
              var split = directiveString.split('=')
              directive.match = split[0]
              directive.replace = split[1]
              directive.info =
                'Replaces value "' +
                directive.match +
                '" with "' +
                directive.replace +
                '"'
              break
            case Directives.URL_PARAM:
              directive.match = directiveString.substr(2)
              directive.info =
                'Injects the URL parameter "' + directive.match + '"'
              pipe.label = directive.match
              break
            case Directives.DATA_DIMENSION:
              directive.match = directiveString.substr(3)
              directive.info =
                'Injects the data dimension "' + directive.match + '"'
              pipe.label = directive.match
              break
            case Directives.REPORT_DIMENSION:
              directive.match = directiveString.substr(4)
              directive.info =
                'Injects the reporting dimension "' + directive.match + '"'
              pipe.label = directive.match
              break
            case Directives.SYSTEM_DIMENSION:
              directive.match = directiveString.substr(3)
              directive.info =
                'Injects the system dimension "' + directive.match + '"'
              pipe.label = directive.match
              break
            case Directives.LIST:
              var html = directiveString.startsWith('hlist')
              var splitStrings = directiveString
                .substr(html ? 6 : 5)
                .split(/\./)
              directive.match = splitStrings[0]
              directive.number = splitStrings[1]
                ? parseInt(splitStrings[1])
                : null
              directive.html = html
              if (directive.number) {
                directive.info =
                  'Injects item #' +
                  directive.number +
                  ' from list "' +
                  directive.match +
                  '"'

                pipe.label =
                  'List: ' + directive.match + ' #' + directive.number
              } else {
                directive.info =
                  'Injects all list items from "' + directive.match + '"'
                pipe.label = 'List: ' + directive.match
              }
              break
            case Directives.IF_TAG:
              var split = directiveString.substr('7').split(':')
              directive.tag = split[0]
              directive.text = split[1]
              directive.info =
                'Injects "' +
                directive.text +
                '" if the respondent has the tag "' +
                directive.tag +
                '"'
              pipe.label = directive.tag + '=' + directive.text
              break
            case Directives.VARIABLE:
              var key = directiveString.substr('9')
              directive.variableKey = key
              directive.info = "Injects variable '" + key + "'"
              pipe.label = key
              break
            case Directives.LOOP_VARIABLE:
              var key = directiveString.substr('9')
              directive.info = 'Injects loop variable'
              pipe.label = 'Loop Variable'
              break
            case Directives.UNKNOWN:
              directive.info = 'Unknown'
              pipe.label = 'Unknown'
              break
          }
          pipe.directives.push(directive)
        })

        self.pipes.push(pipe)
      })
      return this
    }

    Pipes.prototype.getDirectiveType = function(directive) {
      var beginsWithQ = directive[0].toLowerCase() === 'q'
      var beginsWithP_ = directive.substring(0, 2).toLowerCase() === 'p_'
      var beginsWithCD_ = directive.substring(0, 3).toLowerCase() === 'cd_'
      var beginsWithCRD_ = directive.substring(0, 4).toLowerCase() === 'crd_'
      var beginsWithRD_ = directive.substring(0, 3).toLowerCase() === 'rd_'
      var beginsWithLIST_ = directive.substring(0, 5).toLowerCase() === 'list_'
      var beginsWithHLIST_ =
        directive.substring(0, 6).toLowerCase() === 'hlist_'
      var beginsWithIF_TAG =
        directive.substring(0, 7).toLowerCase() === 'if_tag_'
      var beginsWithVARIABLE = directive.toLowerCase().startsWith('variable:')
      var beginsWithLOOP_VARIABLE = directive
        .toLowerCase()
        .startsWith('loop_variable')
      var beginsWithUNKNOWN = directive.toLowerCase().startsWith('unknown')
      var trails = directive.substr(1).length > 0
      var trailsNumber = _.isNumber(parseInt(directive.substr(1)))

      if (beginsWithP_) {
        return Directives.URL_PARAM
      } else if (beginsWithCD_) {
        return Directives.DATA_DIMENSION
      } else if (beginsWithCRD_) {
        return Directives.REPORT_DIMENSION
      } else if (beginsWithRD_) {
        return Directives.SYSTEM_DIMENSION
      } else if (beginsWithLIST_ || beginsWithHLIST_) {
        return Directives.LIST
      } else if (beginsWithIF_TAG) {
        return Directives.IF_TAG
      } else if (beginsWithVARIABLE) {
        return Directives.VARIABLE
      } else if (beginsWithLOOP_VARIABLE) {
        return Directives.LOOP_VARIABLE
      } else if (beginsWithUNKNOWN) {
        return Directives.UNKNOWN
      } else if (beginsWithQ && trails && trailsNumber) {
        return Directives.QUESTION
      } else if (directive[0] === '-' && directive.length > 1) {
        return Directives.IGNORE
      } else if (directive.split('=').length === 2) {
        return Directives.REPLACE
      }
    }

    Pipes.prototype.injectValues = function(
      getAnswer,
      getDimension,
      getParam,
      getList,
      getTag,
      getVariable
    ) {
      var result = this.string
      _.each(this.pipes, function(pipe) {
        var text
        _.each(pipe.directives, function(directive) {
          switch (directive.type) {
            case Directives.QUESTION:
              text = getAnswer(
                directive.number,
                directive.choice,
                directive.statement,
                directive.onlyTextEntry,
                directive.onlyNumberEntry,
                directive.onlySumEntry
              )
              break
            case Directives.IGNORE:
              if (_.includes(text, directive.match)) {
                text = ''
                return false
              }
              break
            case Directives.REPLACE:
              text = text.replace(directive.match, directive.replace)
              break
            case Directives.URL_PARAM:
              text = getParam(directive.match)
              break
            case Directives.DATA_DIMENSION:
              // type matches Responder.Dimensions.DATA
              text = getDimension('DATA', directive.match)
              break
            case Directives.REPORT_DIMENSION:
              // type matches Responder.Dimensions.REPORT
              text = getDimension('REPORT', directive.match)
              break
            case Directives.SYSTEM_DIMENSION:
              // type matches Responder.Dimensions.SYSTEM
              text = getDimension('SYSTEM', directive.match)
              break
            case Directives.LIST:
              text = getList(directive.match, directive.number, directive.html)
              break
            case Directives.IF_TAG:
              if (getTag(directive.tag)) {
                text = directive.text
              }
              break
            case Directives.VARIABLE:
              text = getVariable(directive.variableKey)
              break
            case Directives.LOOP_VARIABLE:
              text = '' // nothing, this is done in post
              break
          }
        })

        result = result.replace(pipe.string, text || '')
      })
      return result
    }

    Pipes.prototype.has = function(questionNumber) {
      return _.some(this.pipes, function(pipe) {
        return pipe.directives[0].number === questionNumber
      })
    }

    Pipes.prototype.rewriteQuestionNumbers = function(getCurrentNumber) {
      var Q_REGEX = /q\d+/i
      var string = this.string
      _.each(this.pipes, function(pipe) {
        var directive = _.find(pipe.directives, {
          type: Pipes.Directives.QUESTION,
        })
        if (!directive) return
        var number = getCurrentNumber(directive.number)
        if (!_.isNumber(number)) {
          string = string.replace(pipe.string, '{{ unknown }}')
        } else if (number !== directive.number) {
          var newPipeString = pipe.string.replace(Q_REGEX, 'Q' + number)
          string = string.replace(pipe.string, newPipeString)
        }
      })
      this.set(string)
      return string
    }

    return Pipes
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["Address"];
  angular.module('glow.components').factory('Place', Factory)

  /* @ngInject */
  function Factory(Address) {
    var Events = {
      CREATED: 'place:created',
    }

    var Sources = {
      GOOGLE: 'GOOGLE',
    }

    var MaxDistance = 200

    function Place(options) {
      _.defaults(this, options, {
        id: null,
        ownerId: null,
        name: null,
        addressFormatted: null,
        address: new Address(),
        location: {
          longitude: null,
          latitude: null,
        },
        distance: null,
        source: null,
        sourceId: null,
        createdAt: moment(),
        updatedAt: moment(),
        mode: 'view',
      })
    }

    Place.prototype.Events = Place.Events = Events

    Place.prototype.deserialize = function(data) {
      this.id = data.id
      this.ownerId = data.ownerId
      this.name = data.name
      this.addressFormatted = data.addressFormatted
      this.address = new Address().deserialize(data.address)
      this.location = {
        longitude: data.location.longitude,
        latitude: data.location.latitude,
      }
      this.distance = data.distance
      this.source = data.source
      this.sourceId = data.sourceId
      this.createdAt = data.createdAt && moment(data.createdAt)
      this.updatedAt = data.updatedAt && moment(data.updatedAt)
      this.snapshot()
      return this
    }

    Place.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.ownerId = this.ownerId
      data.name = this.name
      data.addressFormatted = this.addressFormatted
      data.address = this.address.serialize()
      data.location = {
        longitude: this.location.longitude,
        latitude: this.location.latitude,
      }
      data.source = this.source
      data.sourceId = this.sourceId
      data.createdAt = this.createdAt && this.createdAt.toISOString()
      data.updatedAt = this.updatedAt && this.updatedAt.toISOString()
      return data
    }

    Place.prototype.isNew = function() {
      return !this.id
    }

    Place.prototype.setAddress = function(data) {
      // Source is always Google. Later can be passed in.
      this.source = Sources.GOOGLE
      this.sourceId = data.sourceId
      this.addressFormatted = data.addressFormatted
      this.address.address = data.address
      this.address.city = data.city
      this.address.state = data.state
      this.address.postalCode = data.postalCode
      this.address.setCountryByCc(data.countryCode)
      this.location = {
        longitude: data.location.longitude,
        latitude: data.location.latitude,
      }
    }

    Place.prototype.hasLocation = function() {
      return (
        this.location &&
        _.isNumber(this.location.latitude) &&
        _.isNumber(this.location.longitude)
      )
    }

    Place.prototype.getFormattedDistance = function() {
      if (!_.isNumber(this.distance)) {
        return ''
      }

      var clampedDistance = _.chain(this.distance)
        .round()
        .clamp(0, MaxDistance)
        .value()
      return clampedDistance + (clampedDistance < MaxDistance ? 'm' : 'm+')
    }

    Place.prototype.clone = function() {
      // clone means an exact copy, don't modify fields here.
      return new Place().deserialize(this.serialize())
    }

    Place.prototype.become = function(place) {
      this.deserialize(place.serialize())
    }

    Place.prototype.validate = function() {
      var self = this
      var isValid = true
      self.errors = []
      if (!self.name) {
        self.errors.push('Name is required')
        isValid = false
      }
      if (!self.address) {
        self.errors.push('Address is required')
        isValid = false
      }
      if (
        !self.location ||
        !self.location.latitude ||
        !self.location.longitude
      ) {
        self.errors.push('Location is required')
        isValid = false
      }
      if (!self.source) {
        self.errors.push('Source is required')
        isValid = false
      }
      if (!self.sourceId) {
        self.errors.push('Source id is required')
        isValid = false
      }
      return isValid
    }

    Place.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    Place.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    Place.prototype.Errors = Place.Errors = {
      ChannelRelation: {
        type: 'ChannelRelation',
        message: "You can't delete a place that belongs to a channel.",
      },
      Unknown: {
        type: 'Unknown',
        message: 'Something went wrong, please try again.',
      },
    }

    return Place
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "$rootScope", "Place", "placesResource", "glDialog"];
  angular.module('glow.components').service('placeService', Service)

  /* @ngInject */
  function Service($q, $rootScope, Place, placesResource, glDialog) {
    var self = this

    self.cache = {
      ownerId: null,
      places: [],
    }

    self.list = list
    self.get = get
    self.create = create
    self.save = save
    self.remove = remove
    self.getNearLocation = getNearLocation
    self.showPlaceManagerDialog = showPlaceManagerDialog

    function list(ownerId, cb) {
      // cb(places, loading, error)
      if (self.cache.ownerId !== ownerId) {
        self.cache.ownerId = ownerId
        _.remove(self.cache.places)
      }
      cb(self.cache.places, true)
      placesResource
        .getByOwner({
          ownerId: ownerId,
        })
        .success(function(x, places) {
          _.remove(self.cache.places)
          _.each(places, function(place) {
            self.cache.places.push(new Place().deserialize(place))
          })
          cb(self.cache.places, false)
        })
        .error(function(error) {
          cb(self.cache.places, false, error)
        })
    }

    function get(id, cb) {
      // cb(places, loading, error)
      var place = _.find(self.cache.places, { id: id })
      cb(place, true)
      placesResource
        .get({ id: id })
        .success(function(x, place) {
          cb(place, false)
        })
        .error(function(error) {
          cb(place, false, error)
        })
    }

    function getNearLocation(coords, ownerId, maxDistance) {
      var data = {
        latitude: coords.latitude,
        longitude: coords.longitude,
        ownerId: ownerId,
        maxDistance: maxDistance,
      }
      return $q(function(resolve, reject) {
        placesResource
          .getNearLocation(data)
          .success(function(x, placesData) {
            var places = _.map(placesData, function(data) {
              return new Place().deserialize(data)
            })
            resolve(places)
          })
          .error(reject)
      })
    }

    function create(data) {
      return new Place(data)
    }

    function save(place) {
      return $q(function(resolve, reject) {
        var action = place.isNew() ? 'create' : 'update'
        place.isSaving = true
        place.error = null

        placesResource[action](place.serialize())
          .success(function(response) {
            if (response.id) {
              place.id = response.id
            }
            place.snapshot()
            place.isSaving = false
            resolve()
            if (action === 'create') {
              $rootScope.$broadcast(Place.Events.CREATED)
            }
          })
          .error(function() {
            place.isSaving = false
            place.error = place.Errors.Unknown
            reject()
          })
      })
    }

    function remove(place) {
      return $q(function(resolve, reject) {
        if (place.isNew()) {
          _.remove(self.cache.places, place)
          return resolve()
        }
        place.isRemoving = true
        place.error = null
        placesResource
          .delete({ id: place.id })
          .success(function() {
            _.remove(self.cache.places, place)
            resolve()
          })
          .error(function() {
            place.isRemoving = false
            place.error = place.Errors.ChannelRelation
            reject()
          })
      })
    }

    function showPlaceManagerDialog(channel) {
      var template = [
        '<gl-dialog class="place-manager-dialog__dialog">',
        '<place-manager-dialog ',
        'channel="channel" ',
        'on-done="dialog.close()" ',
        'on-cancel="dialog.cancel()" ',
        '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          channel: channel,
        },
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["Currency", "Price", "LOI", "glUtils", "ResponsePricing"];
  angular.module('glow.components').factory('Plan', Factory)

  function Factory(Currency, Price, LOI, glUtils, ResponsePricing) {
    var Types = {
      DRAFT: 'DRAFT',
      SAAS: 'SAAS',
      CUSTOM: 'CUSTOM',
      LEGACY: 'LEGACY',
    }

    var typeLabels = {
      DRAFT: 'Draft',
      SAAS: 'SaaS',
      CUSTOM: 'Custom',
      LEGACY: 'Legacy',
    }

    var Interval = {
      DAY: 'DAY',
      MONTH: 'MONTH',
      YEAR: 'YEAR',
    }

    var intervals = [
      { type: Interval.DAY, noun: 'day', label: 'Daily' },
      { type: Interval.MONTH, noun: 'month', label: 'Monthly' },
      { type: Interval.YEAR, noun: 'year', label: 'Yearly' },
    ]

    var FeaturesList = [
      {
        field: 'maxMembers',
        label: 'Users',
        type: 'text',
        description: 'The number of users you can have in your organisation.',
        toString: function(value) {
          return value ? value + ' Users' : 'Unlimited Users'
        },
      },
      {
        field: 'maxProjects',
        label: 'Projects',
        type: 'text',
        description: 'The number of projects you can create.',
        toString: function(value) {
          return value ? value + ' Projects' : 'Unlimited Projects'
        },
      },
      {
        field: 'maxSurveys',
        label: 'Surveys',
        type: 'text',
        description: 'The number of surveys you can create.',
        toString: function(value) {
          return value ? value + ' Surveys' : 'Unlimited Surveys'
        },
      },
      {
        field: 'canAddPremiumPublications',
        label: 'Premium Reports',
        type: 'text',
        trueValue: 'Unlimited',
        falseValue: 1,
        description:
          'The number of Premium Reports you can acquire from the store.',
        toString: function(value) {
          // apparently null means you can still have 1!?!?!?
          return value ? 'Unlimited Reports' : '1 Report'
        },
      },
      {
        field: 'maxAnalysisHistoryDays',
        label: 'Analysis Visibility',
        type: 'text',
        unit: 'Days',
        description:
          'The number of days of data you are able to view when analysing a survey.',
        toString: function(value) {
          if (value === null) {
            return 'Unlimited Analysis Visibility'
          }
          return value + ' Days Analysis'
        },
      },
      {
        field: 'canUseAdvancedAnalysisSharing',
        label: 'Research Sharing',
        type: 'text',
        trueValue: 'Unlimited',
        falseValue: 'Basic',
        description:
          'When sharing analysis, "Basic" links are temporary and will expire. "Unlimited" allows you to create permanent links that do not expire.',
        toString: function(value) {
          return value ? 'Research Sharing' : ''
        },
      },
      {
        field: 'canExportResponses',
        label: 'Export to CSV',
        type: 'icon',
        description: 'Export data to CSV for use in third-party tools.',
        toString: function(value) {
          return value ? 'Export to CSV' : ''
        },
      },
      {
        field: 'canAddPanel',
        label: 'Panel Integration',
        type: 'icon',
        description:
          'Collect responses with our world class panel integration.',
        toString: function(value) {
          return value ? 'Panel Integration' : ''
        },
      },
      {
        field: 'canCloneSurveys',
        label: 'Clone surveys',
        type: 'icon',
        description: 'Cloning surveys for backup or modification.',
        toString: function(value) {
          return value ? 'Clone Surveys' : ''
        },
      },
      // {
      //   field: 'canUseResearchServices',
      //   label: 'Book Expert Support',
      //   type: 'icon',
      //   description: '...',
      // },
      {
        field: 'canUseCustomTheme',
        label: 'Custom Analysis Branding',
        type: 'icon',
        description: "Shared analysis is branded with your company's logo.",
        toString: function(value) {
          return value ? 'Custom Analysis Branding' : ''
        },
      },
      {
        field: 'canUseTranslation',
        label: 'Automatic survey translation',
        type: 'icon',
        description:
          'Automatically translate your survey into other languages to support global distribution.',
        toString: function(value) {
          return value ? 'Automatic Survey Translation' : ''
        },
      },
      {
        field: 'canUseProjectResources',
        label: 'Project Files & Links',
        type: 'icon',
        description:
          'Add files and links to your projects to share amongst your team.',
        toString: function(value) {
          return value ? 'Project Files & Links' : ''
        },
      },
      {
        field: 'canUseTagQuotas',
        label: 'Tags & Tag Quotas',
        type: 'icon',
        description: 'Advanced control over respondent progression using tags.',
        toString: function(value) {
          return value ? 'Tags & Quotas' : ''
        },
      },
      {
        field: 'canUseQuickPanel',
        label: '24 hour panel',
        type: 'icon',
        description:
          'Blazing fast panel integration to get responses as quick as possible.',
        toString: function(value) {
          return value ? '24 Hour Panel' : ''
        },
      },
      {
        field: 'canUseChannelCustomTargeting',
        label: 'Panel Targeting',
        type: 'icon',
        description:
          'Advanced panel targeting using custom allocations, filtering and interlocking quotas.',
        toString: function(value) {
          return value ? 'Panel Targeting' : ''
        },
      },
      {
        field: 'canUseChannelRedirects',
        label: 'Survey channel redirects',
        type: 'icon',
        description:
          'Support for using third-party panel providers and other custom delivery requirements.',
        toString: function(value) {
          return value ? 'Survey Channel Redirects' : ''
        },
      },
      {
        field: 'canPublishReports',
        label: 'Report Creation',
        type: 'icon',
        description: 'Publish reports',
        toString: function(value) {
          return 'Report Creation'
        },
      },
    ]

    function Plan() {
      this.applyDefaults()
    }

    Plan.prototype.applyDefaults = function() {
      var taxTypes = {
        AUD: 'GST',
        GBP: 'VAT',
        USD: 'Sales Tax',
      }
      var taxPercentages = {}
      _.each(Currency.Codes, function(code) {
        // taxTypes[code] = null
        taxPercentages[code] = 0
      })
      _.defaultsDeep(this, {
        id: null,
        name: null,
        vendorIds: null,
        description: null,
        canUpgrade: null,
        displayText: null,
        type: Types.DRAFT,
        interval: _.find(intervals, { type: Interval.MONTH }),
        price: new Price(),
        cycleCredit: new Price(),
        pricing: new ResponsePricing(),
        taxTypes: taxTypes,
        taxPercentages: taxPercentages,
        trialDays: 0,
        data: {},
        features: {
          canAddPanel: false,
          canAddPremiumPublications: false,
          canAddRewards: false,
          canCloneSurveys: false,
          canExportResponses: false,
          canUseAdvancedAnalysisSharing: false,
          canUseChannelRedirects: false,
          canUseCustomTheme: false,
          canUseProjectResources: false,
          canUseQuickPanel: false,
          canUseResearchServices: false,
          canUseTagQuotas: false,
          canUseTranslation: false,
          canPublishReports: false,
          maxAnalysisHistoryDays: null,
          maxPlaces: null,
          maxProducts: null,
          maxProjects: null,
          maxSurveys: null,
          maxMembers: null,
        },
        isDefault: false,
        createdAt: null,
        updatedAt: null,
      })
    }

    Plan.prototype.Types = Plan.Types = Types
    Plan.prototype.Interval = Plan.Interval = Interval
    Plan.prototype.intervals = Plan.intervals = intervals
    Plan.prototype.FeaturesList = Plan.FeaturesList = FeaturesList

    Plan.prototype.deserialize = function(data) {
      this.id = data.id
      this.name = data.name
      this.vendorIds = data.vendorIds
      this.description = data.description
      this.canUpgrade = data.canUpgrade
      this.displayText = data.displayText
      this.type = data.type
      this.interval = _.find(intervals, { type: data.interval })
      this.price = new Price().deserialize(data.prices)
      this.cycleCredit = new Price().deserialize(data.cycleCreditPrices)
      this.pricing = new ResponsePricing()
      this.pricing.base.deserialize(data.baseResponsePrices)
      this.pricing.exits.deserialize(data.exitPrices)
      this.pricing.responses.forEach(function(response) {
        response.price.deserialize({
          AUD: _.find(data.responsePrices.AUD, { type: response.type })
            .responseCost,
          USD: _.find(data.responsePrices.USD, { type: response.type })
            .responseCost,
          GBP: _.find(data.responsePrices.GBP, { type: response.type })
            .responseCost,
        })
      })
      // this.taxTypes = data.taxTypes
      this.taxPercentages = data.taxPercentages
      this.trialDays = data.trialDays
      this.features = {
        canAddPanel: data.features.canAddPanel,
        canAddPremiumPublications: data.features.canAddPremiumPublications,
        canAddRewards: data.features.canAddRewards,
        canCloneSurveys: data.features.canCloneSurveys,
        canExportResponses: data.features.canExportResponses,
        canUseAdvancedAnalysisSharing:
          data.features.canUseAdvancedAnalysisSharing,
        canUseChannelRedirects: data.features.canUseChannelRedirects,
        canUseChannelCustomTargeting:
          data.features.canUseChannelCustomTargeting,
        canUseCustomTheme: data.features.canUseCustomTheme,
        canUseProjectResources: data.features.canUseProjectResources,
        canUseQuickPanel: data.features.canUseQuickPanel,
        canUseResearchServices: data.features.canUseResearchServices,
        canUseTagQuotas: data.features.canUseTagQuotas,
        canUseTranslation: data.features.canUseTranslation,
        canPublishReports: data.features.canPublishReports,
        maxAnalysisHistoryDays: data.features.maxAnalysisHistoryDays,
        maxPlaces: data.features.maxPlaces,
        maxProducts: data.features.maxProducts,
        maxProjects: data.features.maxProjects,
        maxSurveys: data.features.maxSurveys,
        maxMembers: data.features.maxMembers,
      }
      this.data = _.isPlainObject(data.data) ? data.data : {}
      this.isDefault = data.isDefault
      this.createdAt = data.createdAt ? moment(data.createdAt) : null
      this.updatedAt = data.updatedAt ? moment(data.updatedAt) : null
      this.applyDefaults()
      this.buildFeatureDetails()
      this.buildFeatureValues()
      return this
    }

    Plan.prototype.serialize = function() {
      var self = this
      var data = {}
      data.id = this.id
      data.name = this.name
      data.vendorIds = this.vendorIds
      data.description = this.description
      data.canUpgrade = this.canUpgrade
      data.displayText = this.displayText
      data.type = this.type
      data.interval = this.interval.type
      data.prices = this.price.serialize()
      data.cycleCreditPrices = this.cycleCredit.serialize()
      data.baseResponsePrices = this.pricing.base.serialize()
      data.exitPrices = this.pricing.exits.serialize()
      function responsePriceByCurrency(currency) {
        return _.map(self.pricing.responses, function(response) {
          return {
            type: response.type,
            maxSeconds: response.loi.maxSeconds,
            responseCost: response.price.byCurrency(currency).amount,
          }
        })
      }
      data.responsePrices = {
        AUD: responsePriceByCurrency('AUD'),
        USD: responsePriceByCurrency('USD'),
        GBP: responsePriceByCurrency('GBP'),
      }
      data.taxTypes = this.taxTypes
      data.taxPercentages = this.taxPercentages
      data.trialDays = this.trialDays
      data.features = {
        canAddPanel: this.features.canAddPanel,
        canAddPremiumPublications: this.features.canAddPremiumPublications,
        canAddRewards: this.features.canAddRewards,
        canCloneSurveys: this.features.canCloneSurveys,
        canExportResponses: this.features.canExportResponses,
        canUseAdvancedAnalysisSharing: this.features
          .canUseAdvancedAnalysisSharing,
        canUseChannelRedirects: this.features.canUseChannelRedirects,
        canUseChannelCustomTargeting: this.features
          .canUseChannelCustomTargeting,
        canUseCustomTheme: this.features.canUseCustomTheme,
        canUseProjectResources: this.features.canUseProjectResources,
        canUseQuickPanel: this.features.canUseQuickPanel,
        canUseResearchServices: this.features.canUseResearchServices,
        canUseTagQuotas: this.features.canUseTagQuotas,
        canUseTranslation: this.features.canUseTranslation,
        canPublishReports: this.features.canPublishReports,
        maxAnalysisHistoryDays: this.features.maxAnalysisHistoryDays,
        maxPlaces: this.features.maxPlaces,
        maxProducts: this.features.maxProducts,
        maxProjects: this.features.maxProjects,
        maxSurveys: this.features.maxSurveys,
        maxMembers: this.features.maxMembers,
      }
      data.data = this.data
      data.createdAt = this.createdAt && this.createdAt.toISOString()
      data.updatedAt = this.updatedAt && this.updatedAt.toISOString()
      return data
    }

    Plan.prototype.isNew = function() {
      return !this.id
    }

    Plan.prototype.isFree = function() {
      return this.price.byCurrency('AUD').amount === 0
    }

    Plan.prototype.isCustom = function() {
      return this.type === Types.CUSTOM
    }

    Plan.prototype.isSteadfast = function() {
      return this.data.isSteadfast
    }

    Plan.prototype.getTypeLabel = function() {
      return typeLabels[this.type]
    }

    Plan.prototype.getTrialEndDate = function() {
      if (this.trialDays === 0) return null
      return moment()
        .add(this.trialDays, 'days')
        .format('D MMMM YYYY')
    }

    Plan.prototype.getCreditIntervalLabel = function() {
      // annual plans are unique and give out credit every 30 days
      if (this.interval.type === Interval.YEAR) {
        return 'month'
      }
      return this.interval.noun
    }

    Plan.prototype.setInterval = function(type) {
      this.interval = _.find(intervals, { type: type })
    }

    Plan.prototype.applyMRP = function(mrp) {
      this.pricing = mrp.clone()
    }

    Plan.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    Plan.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    Plan.prototype.validate = function() {
      var errors = []
      if (!this.name) {
        errors.push('Name is required')
      }
      if (!this.description) {
        errors.push('Description is required')
      }
      if (!this.interval) {
        errors.push('Interval is required')
      }
      _.each(this.price.list, function(price) {
        if (!_.isNumber(price.amount)) {
          errors.push('Price is required')
        }
      })
      _.each(this.cycleCredit.list, function(price) {
        if (!_.isNumber(price.amount)) {
          errors.push('Cycle Credit is required')
        }
      })
      _.each(this.pricing.base.list, function(price) {
        if (!_.isNumber(price.amount)) {
          errors.push('Base response cost is required')
        }
      })
      _.each(this.pricing.exits.list, function(price) {
        if (!_.isNumber(price.amount)) {
          errors.push('Response exit cost is required')
        }
      })
      _.each(this.pricing.responses, function(response) {
        _.each(response.price.list, function(price) {
          if (!_.isNumber(price.amount)) {
            errors.push(response.loi.typeLabel + ' response cost is required')
          }
        })
      })
      if (!_.isNumber(this.trialDays)) {
        errors.push('Trial days is required')
      }
      if (errors.length) {
        this.errors = errors
        return false
      }
      this.errors = null
      return true
    }

    Plan.prototype.buildFeatureValues = function() {
      var values = []
      var self = this
      _.forEach(this.FeaturesList, function(feature) {
        var value = self.features[feature.field]
        if (feature.type === 'text') {
          var text = ''
          if (_.isBoolean(value)) {
            text = value ? feature.trueValue : feature.falseValue
          } else {
            text = value ? value : 'Unlimited'
          }
          if (value && feature.unit) {
            text += ' ' + feature.unit
          }
          values.push(text)
        }
        if (feature.type === 'icon') {
          values.push(
            '<g-icon icon="' +
              (value ? 'check-circle' : 'close-circle-outline') +
              '" size="20" color="' +
              (value ? 'GREEN_SEAFOAM' : 'RGBA(BLACK, .2)') +
              '"></g-icon>'
          )
        }
      })
      this.featureValues = values
    }

    Plan.prototype.buildFeatureDetails = function() {
      var info = []
      info.push(
        makeQuotaLabel(this.features.maxProjects, 'Project', 'Projects')
      )
      info.push(makeQuotaLabel(this.features.maxSurveys, 'Survey', 'Surveys'))
      info.push(
        makeQuotaLabel(
          this.features.maxAnalysisHistoryDays,
          'Online Analysis',
          'Online Analysis',
          'Days'
        )
      )
      info.push(
        makeQuotaLabel(
          this.features.canAddPremiumPublications ? null : 1,
          'Premium Report',
          'Premium Reports'
        )
      )
      if (this.features.canAddPanel) {
        info.push('Get Panel Responses')
        if (this.features.canUseQuickPanel) {
          info.push('24hr Consumer Panel')
        }
        if (this.features.canUseChannelCustomTargeting) {
          info.push('Panel Targeting')
        }
      }
      if (this.features.canExportResponses) {
        info.push('Export to CSV')
      }
      if (this.features.canUseCustomTheme) {
        info.push('Branded Analysis View')
      }
      if (this.features.canUseAdvancedAnalysisSharing) {
        info.push('Unlimited Research Sharing')
      }
      if (this.features.canUseProjectResources) {
        info.push('Project Files & Links')
      }
      if (this.features.canUseResearchServices) {
        info.push('Book Expert Support')
      }
      if (this.features.canUseTagQuotas) {
        info.push('Tags & Tag Quotas')
      }
      if (this.features.canUseTranslation) {
        info.push('Survey Translation')
      }
      if (this.features.canCloneSurveys) {
        info.push('Clone Surveys')
      }
      if (this.features.canUseChannelRedirects) {
        info.push('Survey Channel Redirects')
      }
      this.featureInfo = info
    }

    function makeQuotaLabel(count, single, plural, unit) {
      var amount = count ? count : 'Unlimited'
      if (count && unit) amount += ' ' + unit
      var subject =
        count === null ? plural : glUtils.numberSwitch(count, single, plural)
      return '<b>' + amount + '</b> ' + subject
    }

    return Plan
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["api", "$q", "$rootScope", "glAuthService", "Plan", "ResponsePricing", "plansResource"];
  angular.module('glow.components').service('plansService', Service)

  function Service(
    api,
    $q,
    $rootScope,
    glAuthService,
    Plan,
    ResponsePricing,
    plansResource
  ) {
    var cache = []
    var mrp = null

    $rootScope.$on(glAuthService.Events.USER_CHANGE, resetCache)

    return {
      spawn: spawn,
      save: save,
      list: list,
      get: get,
      loadMRP: loadMRP,
      getMRP: getMRP,
    }

    function resetCache() {
      cache = []
    }

    function spawn() {
      return new Plan()
    }

    function save(plan) {
      if (plan.isNew()) {
        return create(plan)
      } else {
        return update(plan)
      }
    }

    function create(plan) {
      return $q(function(resolve, reject) {
        plansResource
          .create(plan.serialize())
          .success(function(resp) {
            plan.id = resp.id
            plan.snapshot()
            _.remove(cache, function(p) {
              return p.id === plan.id
            })
            cache.push(plan)
            resolve()
          })
          .error(reject)
      })
    }

    function update(plan) {
      return $q(function(resolve, reject) {
        plansResource
          .update(plan.serialize())
          .success(function() {
            plan.snapshot()
            resolve()
          })
          .error(reject)
      })
    }

    function list() {
      return $q(function(resolve, reject) {
        if (cache.length) {
          resolve(cache)
        } else {
          plansResource
            .get()
            .success(function(response) {
              cache = _.map(response, function(data) {
                var plan = new Plan().deserialize(data)
                plan.snapshot()
                return plan
              })
              resolve(cache)
            })
            .error(reject)
        }
      })
    }

    function get(id) {
      return $q(function(resolve, reject) {
        var plan = _.find(cache, { id: id })
        if (plan) {
          resolve(plan)
        } else {
          plansResource
            .get({ id: id })
            .success(function(response) {
              var plan = new Plan().deserialize(response)
              plan.snapshot()
              resolve(plan)
            })
            .error(reject)
        }
      })
    }

    function loadMRP() {
      if (mrp) return $q.resolve(mrp)
      return api.plans.getMRP().then(function(data) {
        mrp = new ResponsePricing().fromMRP(data)
        console.log('MRP Loaded', mrp)
        return mrp
      })
    }

    function getMRP() {
      return mrp
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["Money", "Price", "LOI"];
  angular.module('glow.components').factory('ResponsePricing', Factory)

  function Factory(Money, Price, LOI) {
    //...

    function ResponsePricing() {
      this.applyDefaults()
    }

    ResponsePricing.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        base: new Price(),
        exits: new Price(),
        responses: LOI.types.map(function(loi) {
          return {
            type: loi.type,
            price: new Price(),
            loi: loi,
          }
        }),
      })
    }

    ResponsePricing.prototype.fromMRP = function(mrp) {
      this.base = new Price().deserialize(mrp.baseResponsePrices)
      this.exits = new Price().deserialize(mrp.exitPrices)

      // The BE returns this back-to-front. There is only one LOI type
      // with multiple prices, but we need to gather these all up in a strange
      // way...
      this.responses = LOI.types.map(function(loi) {
        return {
          type: loi.type,
          price: new Price().deserialize({
            AUD: _.find(mrp.responsePrices.AUD, { type: loi.type })
              .responseCost,
            USD: _.find(mrp.responsePrices.USD, { type: loi.type })
              .responseCost,
            GBP: _.find(mrp.responsePrices.GBP, { type: loi.type })
              .responseCost,
          }),
          loi: loi,
        }
      })
      return this
    }

    ResponsePricing.prototype.serialize = function() {
      var data = {}
      data.base = this.base.serialize()
      data.exits = this.exits.serialize()
      data.responses = this.responses.map(function(response) {
        return {
          type: response.type,
          price: response.price.serialize(),
        }
      })
      return data
    }

    ResponsePricing.prototype.deserialize = function(data) {
      this.base = new Price().deserialize(data.base)
      this.exits = new Price().deserialize(data.exits)
      this.responses = data.responses.map(function(d) {
        return {
          type: d.type,
          price: new Price().deserialize(d.price),
          loi: _.find(LOI.types, { type: d.type }),
        }
      })
      return this
    }

    ResponsePricing.prototype.clone = function() {
      return new ResponsePricing().deserialize(this.serialize())
    }

    return ResponsePricing
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["Money", "Currency"];
  angular.module('glow.components').factory('Price', Factory)

  /* @ngInject */
  function Factory(Money, Currency) {
    function Price() {
      this.applyDefaults()
    }

    Price.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        list: _.map(Currency.Codes, function(code) {
          return new Money({ amount: 0, currency: code })
        }),
      })
    }

    Price.prototype.deserialize = function(data) {
      var self = this
      self.list = []
      _.each(data, function(amount, code) {
        self.list.push(new Money({ amount: amount, currency: code }))
      })
      return this
    }

    Price.prototype.serialize = function() {
      var data = {}
      _.each(this.list, function(item) {
        data[item.currency] = item.amount
      })
      return data
    }

    Price.prototype.byCurrency = function(code) {
      return _.find(this.list, { currency: code })
    }

    return Price
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["gGtin"];
  angular.module('glow.components').factory('Product', Factory)

  /* @ngInject */
  function Factory(gGtin) {
    var Events = {
      CREATED: 'product:created',
    }

    function Product(options) {
      _.defaults(this, options, {
        id: null,
        ownerId: null,
        brand: null,
        name: null,
        description: null,
        gtin: null,
        category: null,
        createdAt: moment(),
        updatedAt: moment(),
        mode: 'view',
      })
    }

    Product.prototype.Events = Product.Events = Events

    Product.prototype.deserialize = function(data) {
      this.id = data.id
      this.ownerId = data.ownerId
      this.brand = data.brand
      this.name = data.name
      this.description = data.description
      this.gtin = data.gtin
      this.category = data.category
      this.createdAt = data.createdAt && moment(data.createdAt)
      this.updatedAt = data.updatedAt && moment(data.updatedAt)
      this.snapshot()
      return this
    }

    Product.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.ownerId = this.ownerId
      data.brand = this.brand
      data.name = this.name
      data.description = this.description
      data.gtin = this.gtin
      data.category = this.category
      data.createdAt = this.createdAt && this.createdAt.toISOString()
      data.updatedAt = this.updatedAt && this.updatedAt.toISOString()
      return data
    }

    Product.prototype.isNew = function() {
      return !this.id
    }

    Product.prototype.clone = function() {
      // clone means an exact copy, don't modify fields here.
      return new Product().deserialize(this.serialize())
    }

    Product.prototype.become = function(product) {
      this.deserialize(product.serialize())
    }

    Product.prototype.validate = function() {
      var self = this
      var isValid = true
      self.errors = []
      if (!self.name) {
        self.errors.push('Name is required')
        isValid = false
      }
      if (!self.brand) {
        self.errors.push('Brand is required')
        isValid = false
      }
      if (!gGtin.isValid(self.gtin)) {
        self.errors.push('Barcode is required and must be in the GTIN format')
        isValid = false
      }
      if (!self.description) {
        self.errors.push('Description is required')
        isValid = false
      }
      return isValid
    }

    Product.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    Product.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    Product.prototype.Errors = Product.Errors = {
      ChannelRelation: {
        type: 'ChannelRelation',
        message: "You can't delete a product that belongs to a channel",
      },
      DuplicateBarcode: {
        type: 'DuplicateBarcode',
        message: 'A product with that barcode has already been taken.',
      },
      Unknown: {
        type: 'Unknown',
        message: 'Something went wrong, please try again.',
      },
    }

    return Product
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "$rootScope", "Product", "productsResource", "glDialog"];
  angular.module('glow.components').service('productService', Service)

  /* @ngInject */
  function Service($q, $rootScope, Product, productsResource, glDialog) {
    var self = this

    self.cache = {
      ownerId: null,
      products: [],
    }

    self.list = list
    self.get = get
    self.create = create
    self.save = save
    self.remove = remove
    self.showProductManagerDialog = showProductManagerDialog

    function list(ownerId, cb) {
      // cb(products, loading, error)
      if (self.cache.ownerId !== ownerId) {
        self.cache.ownerId = ownerId
        _.remove(self.cache.products)
      }
      cb(self.cache.products, true)
      productsResource
        .get({
          ownerId: ownerId,
        })
        .success(function(x, products) {
          _.remove(self.cache.products)
          _.each(products, function(product) {
            self.cache.products.push(new Product().deserialize(product))
          })
          cb(self.cache.products, false)
        })
        .error(function(error) {
          cb(self.cache.products, false, error)
        })
    }

    function get(id, cb) {
      // cb(products, loading, error)
      var product = _.find(self.cache.products, { id: id })
      cb(product, true)
      productsResource
        .get({ id: id })
        .success(function(x, product) {
          cb(product, false)
        })
        .error(function(error) {
          cb(product, false, error)
        })
    }

    function create(data) {
      return new Product(data)
    }

    function save(product) {
      return $q(function(resolve, reject) {
        var action = product.id ? 'update' : 'create'
        product.isSaving = true
        product.error = null
        productsResource[action](product.serialize())
          .success(function(response) {
            if (response.id) {
              product.id = response.id
            }
            product.snapshot()
            product.isSaving = false
            resolve()
            if (action === 'create') {
              $rootScope.$broadcast(Product.Events.CREATED)
            }
          })
          .error(function(error) {
            product.isSaving = false
            if (error && error.status === 409) {
              product.error = product.Errors.DuplicateBarcode
            } else {
              product.error = product.Errors.Unknown
            }
            reject()
          })
      })
    }

    function remove(product) {
      return $q(function(resolve, reject) {
        if (product.isNew()) {
          _.remove(self.cache.products, product)
          return resolve()
        }
        product.isRemoving = true
        product.error = null
        productsResource
          .delete({ id: product.id })
          .success(function() {
            _.remove(self.cache.products, product)
            resolve()
          })
          .error(function() {
            product.isRemoving = false
            product.error = product.Errors.ChannelRelation
            reject()
          })
      })
    }

    function showProductManagerDialog(channel) {
      var template = [
        '<gl-dialog class="product-manager-dialog__dialog">',
        '<product-manager-dialog ',
        'channel="channel" ',
        'on-done="dialog.close()" ',
        'on-cancel="dialog.cancel()" ',
        '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          channel: channel,
        },
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["ThemeContext", "SurveyTheme"];
  angular.module('glow.components').factory('Profile', Factory)

  function Factory(ThemeContext, SurveyTheme) {
    function Profile() {
      this.applyDefaults()
    }

    Profile.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: null,
        name: null,
        color: null,
        bgImageUrl: null,
        logoImageUrl: null,
        hasCanUseCustomThemeFeature: false,
        surveyThemes: [],
      })
    }

    Profile.prototype.deserialize = function(data) {
      this.id = data.id
      this.name = data.name
      this.color = data.portalTheme.color
      this.bgImageUrl = data.portalTheme.featureImageUrl
      this.logoImageUrl = data.portalTheme.logoImageUrl
      this.hasCanUseCustomThemeFeature = data.hasCanUseCustomThemeFeature
      this.data = _.isPlainObject(data.data) ? data.data : {}
      this.themeContext = new ThemeContext()
        .asSubscriberDefault()
        .deserialize(this.data.themeContext)
      this.surveyThemes = _.map(this.data.surveyThemes, function(surveyTheme) {
        return new SurveyTheme().deserialize(surveyTheme)
      })
      this.applyDefaults()
      return this
    }

    Profile.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.name = this.name
      data.portalTheme = {
        color: this.color,
        featureImageUrl: this.bgImageUrl,
        logoImageUrl: this.logoImageUrl,
      }
      data.hasCanUseCustomThemeFeature = this.hasCanUseCustomThemeFeature
      data.data = this.data
      data.data.themeContext = this.themeContext.serialize()
      data.data.surveyThemes = this.surveyThemes.map(function(surveyTheme) {
        return surveyTheme.serialize()
      })
      return data
    }

    return Profile
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "Profile", "subscribersResource"];
  angular.module('glow.components').service('profileService', Service)

  function Service($q, Profile, subscribersResource) {
    this.get = get

    function get(subscriberId) {
      return $q(function(resolve, reject) {
        subscribersResource
          .getProfile({ id: subscriberId })
          .success(function(x, resp) {
            resolve(new Profile().deserialize(resp))
          })
          .error(reject)
      })
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "subscriberService", "purchasesResource"];
  angular.module('glow.components').service('purchaseService', Service)

  /* @ngInject */
  function Service($q, subscriberService, purchasesResource) {
    var self = this

    var Types = {
      BUNDLE: 'BUNDLE',
    }

    self.Types = Types
    self.purchase = purchase

    function purchase(type, typeId) {
      return $q(function(resolve, reject) {
        purchasesResource
          .makePurchase({
            subscriberId: subscriberService.getSubscriber().id,
            type: type,
            typeId: typeId,
          })
          .success(resolve)
          .error(reject)
      })
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components.questionEditor').constant('OptionPresets', [
    {
      value: '7p-agreement',
      label: 'Strongly disagree to Strongly agree (7 Points)',
      group: 'Agreement',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Strongly disagree' },
        { value: 'Disagree' },
        { value: 'Somewhat disagree' },
        { value: 'Undecided' },
        { value: 'Somewhat agree' },
        { value: 'Agree' },
        { value: 'Strongly agree' },
      ],
    },
    {
      value: '5p-agreement',
      label: 'Strongly disagree to Strongly agree (5 Points)',
      group: 'Agreement',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Strongly disagree' },
        { value: 'Disagree' },
        { value: 'Undecided' },
        { value: 'Agree' },
        { value: 'Strongly agree' },
      ],
    },
    {
      value: '7p-quality',
      label: 'Very poor to Excellent (7 Points)',
      group: 'Quality',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Very poor' },
        { value: 'Poor' },
        { value: 'Below average' },
        { value: 'Average' },
        { value: 'Above average' },
        { value: 'Good' },
        { value: 'Excellent' },
      ],
    },
    {
      value: '5p-quality',
      label: 'Very poor to Excellent (5 Points)',
      group: 'Quality',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Very poor' },
        { value: 'Poor' },
        { value: 'Average' },
        { value: 'Good' },
        { value: 'Excellent' },
      ],
    },
    {
      value: '7p-likelihood',
      label: 'Very unlikely to Very likely (7 Points)',
      group: 'Likelihood',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Very unlikely' },
        { value: 'Unlikely' },
        { value: 'Somewhat unlikely' },
        { value: 'Undecided' },
        { value: 'Somewhat likely' },
        { value: 'Likely' },
        { value: 'Very likely' },
      ],
    },
    {
      value: '5p-likelihood',
      label: 'Very unlikely to Very likely (5 Points)',
      group: 'Likelihood',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Very unlikely' },
        { value: 'Unlikely' },
        { value: 'Undecided' },
        { value: 'Likely' },
        { value: 'Very likely' },
      ],
    },
    {
      value: '7p-positive',
      label: 'Very negative to Very positive (7 Points)',
      group: 'Positive',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Very negative' },
        { value: 'Negative' },
        { value: 'Somewhat negative' },
        { value: 'Undecided' },
        { value: 'Somewhat positive' },
        { value: 'Positive' },
        { value: 'Very positive' },
      ],
    },
    {
      value: '5p-positive',
      label: 'Very negative to Very positive (5 Points)',
      group: 'Positive',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Very negative' },
        { value: 'Negative' },
        { value: 'Undecided' },
        { value: 'Positive' },
        { value: 'Very positive' },
      ],
    },
    {
      value: '5p-satisfaction',
      label: 'Very unsatisfied to Very satisfied (5 Points)',
      group: 'Positive',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Very unsatisfied' },
        { value: 'Somewhat unsatisfied' },
        { value: 'Undecided' },
        { value: 'Somewhat satisfied' },
        { value: 'Very satisfied' },
      ],
    },
    {
      value: '7p-importance',
      label: 'Not important at all to Very important (7 Points)',
      group: 'Importance',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Not important at all' },
        { value: 'Not very important' },
        { value: 'Somewhat unimportant' },
        { value: 'Undecided' },
        { value: 'Somewhat important' },
        { value: 'Important' },
        { value: 'Very important' },
      ],
    },
    {
      value: '5p-importance',
      label: 'Not important at all to Very important (5 Points)',
      group: 'Importance',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Not important at all' },
        { value: 'Not very important' },
        { value: 'Somewhat important' },
        { value: 'Important' },
        { value: 'Very important' },
      ],
    },
    {
      value: '5p-frequency',
      label: 'Never to Always (5 Points)',
      group: 'Frequency',
      tags: ['scale', 'matrix'],
      items: [
        { value: 'Never' },
        { value: 'Rarely' },
        { value: 'Sometimes' },
        { value: 'Often' },
        { value: 'Always' },
      ],
    },
    {
      value: '6p-mood',
      label: 'Very Angry to Very Happy',
      group: 'Mood',
      tags: ['mood'],
      items: [
        { value: '1', label: 'Very Angry' },
        { value: '2', label: 'Angry' },
        { value: '3', label: 'Meh' },
        { value: '4', label: 'Neutral' },
        { value: '5', label: 'Happy' },
        { value: '6', label: 'Very Happy' },
      ],
    },
    {
      value: 'nps',
      label: 'Not at all Likely to Extremely Likely',
      group: 'NPS',
      tags: ['nps'],
      items: [
        { value: '0' },
        { value: '1' },
        { value: '2' },
        { value: '3' },
        { value: '4' },
        { value: '5' },
        { value: '6' },
        { value: '7' },
        { value: '8' },
        { value: '9' },
        { value: '10' },
      ],
    },
    {
      value: '5star',
      label: '5 Stars',
      group: 'Rating',
      tags: ['rating'],
      items: [
        { value: '1' },
        { value: '2' },
        { value: '3' },
        { value: '4' },
        { value: '5' },
      ],
    },
    {
      value: 'follow-up',
      label: 'Follow-Up',
      group: 'Follow-Up',
      tags: ['follow-up'],
      items: [{ value: "Yes, that's fine" }],
    },
  ])
})()

;(function() {
  'use strict'

  Controller.$inject = ["questionService", "reportMediaBtn"];
  angular
    .module('glow.components.questionEditor')
    .component('glQuestionEditor', {
      controller: Controller,
      templateUrl: 'question-editor.html',
      bindings: {
        survey: '<',
        index: '<',
        question: '=',
        isRestricted: '=',
        editProfiling: '=',
        isSsr: '=',
        subscriberId: '=',
        questionEditorForm: '=?',
      },
    })

  /* @ngInject */
  function Controller(questionService, reportMediaBtn) {
    var ctrl = this

    ctrl.$onInit = onInit

    ctrl.defaultImageLabel = reportMediaBtn.DefaultLabels.IMAGE

    ctrl.isTitleField = isTitleField
    ctrl.isTitleSelector = isTitleSelector
    ctrl.isDescriptionField = isDescriptionField
    ctrl.isImageField = isImageField

    ctrl.isTextFields = isTextFields
    ctrl.isNumericFields = isNumericFields
    ctrl.isRatingFields = isRatingFields
    ctrl.isScaleFields = isScaleFields
    ctrl.isChoiceFields = isChoiceFields
    ctrl.isLocationFields = isLocationFields
    ctrl.isPlaceFields = isPlaceFields
    ctrl.isMatrixFields = isMatrixFields
    ctrl.isMultilineTextFields = isMultilineTextFields
    ctrl.isConstantSumFields = isConstantSumFields
    ctrl.isScoreFields = isScoreFields
    ctrl.isTextExclusiveChoiceFields = isTextExclusiveChoiceFields
    ctrl.getTextExclusiveChoiceHint = getTextExclusiveChoiceHint

    ctrl.isCompulsoryField = isCompulsoryField
    ctrl.isComparisonKeyField = isComparisonKeyField
    ctrl.isProfilingFields = isProfilingFields

    ctrl.isLockedOverlay = isLockedOverlay
    ctrl.canUnlock = canUnlock
    ctrl.unlock = unlock
    ctrl.lock = lock
    ctrl.setImage = setImage

    ctrl.getPipeQuestions = getPipeQuestions
    ctrl.onDescriptionChange = onDescriptionChange

    function onInit() {
      // question template doesn't use survey
      ctrl.isInLoop =
        !ctrl.question.isTemplate &&
        _.some(ctrl.survey.loops, function(loop) {
          return _.some(loop.questionIds, function(questionId) {
            return questionId === ctrl.question.id
          })
        })
      ctrl.titleFieldLabel = ctrl.question.isHiddenVariables()
        ? 'Name'
        : 'Question'

      if (ctrl.question.type === ctrl.question.Types.CONSTANT_SUM) {
        ctrl.descriptionPlaceholder =
          'Please enter a numeric value for each option.'
      }
    }

    function isTitleField() {
      return !ctrl.question.usesTitleSelector()
    }

    function isTitleSelector() {
      return ctrl.question.usesTitleSelector()
    }

    function isDescriptionField() {
      return !ctrl.question.isHiddenVariables()
    }

    function isImageField() {
      return !ctrl.question.isHiddenVariables()
    }

    function isScaleFields() {
      return ctrl.question.isType([ctrl.question.Types.SCALE])
    }

    function isLocationFields() {
      return ctrl.question.isType([ctrl.question.Types.LOCATION])
    }

    function isPlaceFields() {
      return ctrl.question.isType([ctrl.question.Types.PLACES_NEAR_ME])
    }

    function isRatingFields() {
      return ctrl.question.isType([ctrl.question.Types.RATING])
    }

    function isTextFields() {
      return ctrl.question.isType([ctrl.question.Types.SINGLE_TEXT])
    }

    function isNumericFields() {
      return ctrl.question.isType([ctrl.question.Types.NUMERIC])
    }

    function isChoiceFields() {
      return ctrl.question.isType([
        ctrl.question.Types.CHOICE,
        ctrl.question.Types.RANK,
        ctrl.question.Types.HIDDEN_VARIABLES,
      ])
    }

    function isMatrixFields() {
      return ctrl.question.isType([ctrl.question.Types.MATRIX])
    }

    function isMultilineTextFields() {
      return ctrl.question.isType([ctrl.question.Types.TEXT])
    }

    function isConstantSumFields() {
      return ctrl.question.isType([ctrl.question.Types.CONSTANT_SUM])
    }

    function isScoreFields() {
      return ctrl.question.isType(ctrl.question.Types.SCORE)
    }

    function isTextExclusiveChoiceFields() {
      return ctrl.question.isType([
        ctrl.question.Types.SINGLE_TEXT,
        ctrl.question.Types.TEXT,
      ])
    }

    function getTextExclusiveChoiceHint() {
      if (ctrl.question.isType(ctrl.question.Types.SINGLE_TEXT)) {
        return 'Only available when Validator is Text. When selected, this fills the minimum required fields with the label instead of requiring typed answers.'
      }
      return 'Lets respondents choose this instead of typing an answer.'
    }

    function isCompulsoryField() {
      return !ctrl.question.isHiddenVariables()
    }

    function isComparisonKeyField() {
      return ctrl.isSsr && !ctrl.question.isHiddenVariables()
    }

    function isProfilingFields() {
      return ctrl.editProfiling === true
    }

    function isLockedOverlay() {
      var isComparable = ctrl.question.templateId && ctrl.question.comparisonKey
      var isProfiling = ctrl.question.templateId && ctrl.question.profileKey
      var isLocked = !!ctrl.question.isLocked

      return isLocked || isComparable || isProfiling
    }

    function canUnlock() {
      var isSSR = ctrl.isSsr
      var isLocked = !!ctrl.question.isLocked

      return isSSR && isLocked
    }

    function unlock() {
      ctrl.question.isLocked = false
      questionService.updateLock(ctrl.question)
    }

    function lock() {
      ctrl.question.isLocked = true
      questionService.updateLock(ctrl.question)
    }

    function setImage(imageData) {
      questionService.setImage(ctrl.question, imageData)
    }

    function getPipeQuestions() {
      var prevQuestions = ctrl.survey.getQuestionsBefore(ctrl.question.id)
      return prevQuestions
    }

    function onDescriptionChange() {
      ctrl.question.descriptionPipes.set(ctrl.question.description)
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["OptionPresets"];
  angular
    .module('glow.components.questionEditor')
    .factory('questionEditor', Service)

  /* @ngInject */
  function Service(OptionPresets) {
    var OptionTags = {
      SCALE: 'scale',
      MATRIX: 'matrix',
      RATING: 'rating',
    }

    return {
      getOptionPresets: getOptionPresets,
      OptionTags: OptionTags,
    }

    function getOptionPresets(tags) {
      tags = _.isArray(tags) ? tags : [tags]
      var templates = _.filter(OptionPresets, function(template) {
        var hasAllTags = true
        _.each(tags, function(tag) {
          if (!_.includes(template.tags, tag)) {
            hasAllTags = false
            return false
          }
        })
        return hasAllTags
      })
      return _.cloneDeep(templates)
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["$q"];
  angular.module('glow.components').factory('Queue', Factory)

  /* @ngInject */
  function Factory($q) {
    function Queue(queues) {
      var self = this
      self.queue = []

      _.each(queues, function(q) {
        _.each(q.queue, function(queue) {
          self.add(queue.promise, queue.text)
        })
      })
    }

    Queue.prototype.add = function(promise, text) {
      var self = this
      var item = { promise: promise, text: text }
      self.queue.push(item)
      promise.finally(function() {
        _.remove(self.queue, item)
      })
    }

    Queue.prototype.all = function() {
      return $q.all(_.map(this.queue, 'promise'))
    }

    Queue.prototype.isProcessing = function() {
      return !!this.queue.length
    }

    Queue.prototype.processingText = function() {
      return _.find(this.queue, function(item) {
        return item.text
      }).text
    }

    return Queue
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils", "QuotaVariable"];
  angular.module('glow.components').factory('QuotaDefinition', Factory)

  /* @ngInject */
  function Factory(glUtils, QuotaVariable) {
    var Modes = {
      INTERLOCKED: 'INTERLOCKED',
      INDEPENDENT: 'INDEPENDENT',
    }

    var TAG_PREFIX = '__quota__'

    // a token is the part of an option id that cell keys and counter names are built from - see toToken
    //
    // CRITICAL: only a v4 id is shortened, because only a v4 id starts with random hex. a v7 id starts with a
    // timestamp, so options the backend creates in one batch share their first 8 characters and would collapse
    // into one cell, one target and one counter. anything else keeps its full id, which can never collide.
    //
    // never change the 8 for v4 ids: saved targets are keyed by cell key and collected counts by counter name,
    // so a different token orphans both in every existing quota
    var TOKEN_LENGTH = 8
    var UUID_VERSION_RANDOM = 4

    // a tag may legally contain this character, which is why keys are built from option ids and never from tag strings
    var KEY_SEPARATOR = '|'

    function QuotaDefinition() {
      this.applyDefaults()
    }

    QuotaDefinition.prototype.Modes = QuotaDefinition.Modes = Modes
    QuotaDefinition.prototype.TAG_PREFIX = QuotaDefinition.TAG_PREFIX = TAG_PREFIX

    // two passes, not one: tagPrefix reads this.id, and in a single call the literal is built before the id exists
    QuotaDefinition.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: glUtils.uuid(),
      })

      _.defaultsDeep(this, {
        name: '',
        mode: Modes.INTERLOCKED,
        // persisted, so the token rule only ever runs for a quota being created and never re-derives a saved prefix
        tagPrefix: TAG_PREFIX + toToken(this.id) + '_',
        variables: [],
      })
    }

    QuotaDefinition.prototype.deserialize = function(data) {
      data = _.isPlainObject(data) ? data : {}

      this.id = data.id
      this.name = data.name
      this.mode = data.mode
      this.tagPrefix = data.tagPrefix

      this.variables = _.isArray(data.variables)
        ? data.variables.map(function(variableData) {
            return new QuotaVariable().deserialize(variableData)
          })
        : undefined

      this.applyDefaults()
      return this
    }

    QuotaDefinition.prototype.serialize = function() {
      var data = {}

      data.id = this.id
      data.name = this.name
      data.mode = this.mode
      data.tagPrefix = this.tagPrefix
      data.variables = this.variables.map(function(variable) {
        return variable.serialize()
      })

      return data
    }

    QuotaDefinition.isReservedTagName = function(tag) {
      return typeof tag === 'string' && tag.indexOf(TAG_PREFIX) === 0
    }

    QuotaDefinition.prototype.isInterlocked = function() {
      return this.mode === Modes.INTERLOCKED
    }

    QuotaDefinition.prototype.isIndependent = function() {
      return this.mode === Modes.INDEPENDENT
    }

    // key order is variable id order, never array order, so reordering variables for display cannot detach a count
    QuotaDefinition.prototype.getVariablesInKeyOrder = function() {
      return _.sortBy(this.variables, 'id')
    }

    // display only - a cell key built from this order would drift every time the survey is edited
    QuotaDefinition.prototype.getVariablesInDisplayOrder = function(questions) {
      var questionIndexById = {}

      _.each(questions, function(question, index) {
        questionIndexById[question.id] = index
      })

      var questionVariables = _.filter(this.variables, function(variable) {
        return variable.isQuestion()
      })

      var tagVariables = _.filter(this.variables, function(variable) {
        return variable.isTag()
      })

      questionVariables = _.sortBy(questionVariables, function(variable) {
        var index = questionIndexById[variable.questionId]
        return _.isNumber(index) ? index : Number.MAX_VALUE
      })

      return questionVariables.concat(tagVariables)
    }

    QuotaDefinition.prototype.getDerivedName = function(questions) {
      var variables = this.getVariablesInDisplayOrder(questions)

      if (!variables.length) {
        return this.isInterlocked()
          ? 'New interlocked quota'
          : 'New separate quota'
      }

      var joiner = this.isInterlocked() ? ' x ' : ' + '

      return variables
        .map(function(variable) {
          return variable.getShortLabel(questions)
        })
        .join(joiner)
    }

    QuotaDefinition.prototype.addVariable = function(variable) {
      this.variables.push(variable)
      return variable
    }

    QuotaDefinition.prototype.removeVariable = function(variable) {
      _.remove(this.variables, { id: variable.id })
      return variable
    }

    // the argument is a map rather than an ordered list, so a caller cannot supply the wrong order
    QuotaDefinition.prototype.getCellKey = function(optionIdByVariableId) {
      var entries = getKeyEntries(this, optionIdByVariableId)
      if (!entries) return null

      return joinTokens(entries)
    }

    QuotaDefinition.prototype.getCounterName = function(optionIdByVariableId) {
      var entries = getKeyEntries(this, optionIdByVariableId)
      if (!entries) return null

      // a separate quota's tag row counts on the raw tag, which is what lets a migrated quota keep the counts it already has
      if (this.isIndependent() && entries[0].variable.isTag()) {
        var option = _.find(entries[0].variable.options, {
          id: entries[0].optionId,
        })

        if (!option) {
          console.error(
            'QuotaDefinition.getCounterName: option ' +
              entries[0].optionId +
              ' is not in tag variable ' +
              entries[0].variable.id +
              ' of quota ' +
              this.id
          )
          return null
        }

        return option.tag
      }

      return this.tagPrefix + joinTokens(entries)
    }

    function getKeyEntries(quota, optionIdByVariableId) {
      var map = _.isPlainObject(optionIdByVariableId)
        ? optionIdByVariableId
        : {}
      var entries = []
      var missing = []

      quota.getVariablesInKeyOrder().forEach(function(variable) {
        var optionId = map[variable.id]

        if (_.isNil(optionId) || optionId === '') {
          missing.push(variable.id)
          return
        }

        entries.push({
          variable: variable,
          optionId: optionId,
          token: toToken(optionId),
        })
      })

      if (quota.isInterlocked()) {
        if (!entries.length || missing.length) {
          console.error(
            'QuotaDefinition.getCellKey: interlocked quota ' +
              quota.id +
              ' needs an option for every variable; missing ' +
              missing.length +
              ' of ' +
              quota.variables.length,
            missing
          )
          return null
        }
        return entries
      }

      if (entries.length !== 1) {
        console.error(
          'QuotaDefinition.getCellKey: separate quota ' +
            quota.id +
            ' needs exactly one option, got ' +
            entries.length
        )
        return null
      }

      return entries
    }

    // read the note on TOKEN_LENGTH before touching this
    function toToken(id) {
      id = String(id)

      return glUtils.uuidVersion(id) === UUID_VERSION_RANDOM
        ? id.slice(0, TOKEN_LENGTH)
        : id
    }

    function joinTokens(entries) {
      return entries
        .map(function(entry) {
          return entry.token
        })
        .join(KEY_SEPARATOR)
    }

    return QuotaDefinition
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["glUtils", "QuotaPlan", "QuotaDefinition", "QuotaVariable", "TagQuotaSettings"];
  angular.module('glow.components').service('quotaMigrationService', Service)

  /* @ngInject */
  function Service(
    glUtils,
    QuotaPlan,
    QuotaDefinition,
    QuotaVariable,
    TagQuotaSettings
  ) {
    var PLAN_NAME = 'Tag quotas'

    var TAG_VARIABLE_NAME = 'Tags'

    return {
      buildPlan: buildPlan,
    }

    function buildPlan(survey, channels) {
      var settings = survey && survey.tagQuotaSettings

      if (!settings) return null

      var cappedTags = getCappedTags(settings.tagQuotas)

      if (!cappedTags.length) return null

      var plan = new QuotaPlan()
      plan.name = PLAN_NAME

      applyChannelScope(plan, settings, channels)
      addTagQuota(plan, settings, cappedTags)

      return plan
    }

    function getCappedTags(tagQuotas) {
      if (!_.isPlainObject(tagQuotas)) return []

      return _.filter(_.keys(tagQuotas), function(tag) {
        // a cap of 0 is a real cap, so this tests for a number rather than for truthiness
        return tag !== '' && _.isNumber(tagQuotas[tag])
      })
    }

    function applyChannelScope(plan, settings, channels) {
      var Types = TagQuotaSettings.Types

      if (settings.type === Types.NONE) {
        plan.setChannelIds([])
        plan.setEnabled(false)
        return
      }

      if (settings.type === Types.ANY) {
        plan.setChannelIds(
          _.isArray(settings.channelIds) ? settings.channelIds : []
        )
        plan.setEnabled(!!settings.enabled)
        return
      }

      // the remaining type is ALL, which scopes the plan to every channel the survey has
      plan.setChannelIds(
        _.map(channels || [], function(channel) {
          return channel.id
        })
      )
      plan.setEnabled(!!settings.enabled)
    }

    function addTagQuota(plan, settings, cappedTags) {
      // separate plus tag is what keeps the counters on the raw tags, so a migrated survey keeps the progress it already has
      var quota = plan.addQuota(QuotaDefinition.Modes.INDEPENDENT)

      var variable = new QuotaVariable()
      variable.type = QuotaVariable.Types.TAG
      variable.displayName = TAG_VARIABLE_NAME

      variable.options = _.map(cappedTags, function(tag) {
        return {
          id: glUtils.uuid(),
          tag: tag,
        }
      })

      quota.addVariable(variable)

      quota.name = quota.getDerivedName()

      applyTargets(plan, quota, variable, settings.tagQuotas)
    }

    function applyTargets(plan, quota, variable, tagQuotas) {
      _.each(variable.options, function(option) {
        var optionIdByVariableId = {}
        optionIdByVariableId[variable.id] = option.id

        var cellKey = quota.getCellKey(optionIdByVariableId)

        if (_.isNil(cellKey)) return

        plan.setTarget(quota.id, cellKey, tagQuotas[option.tag])
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils", "QuotaDefinition"];
  angular.module('glow.components').factory('QuotaPlan', Factory)

  /* @ngInject */
  function Factory(glUtils, QuotaDefinition) {
    // nine digits: three orders above any real quota, far inside safe integers, and the widest label it produces still fits the cell line
    var MAX_TARGET = 999999999

    function QuotaPlan() {
      this.applyDefaults()
    }

    QuotaPlan.prototype.MAX_TARGET = QuotaPlan.MAX_TARGET = MAX_TARGET

    QuotaPlan.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: glUtils.uuid(),
        name: '',
        enabled: false,
        channelIds: [],
        quotas: [],
        targetSets: [],
      })

      if (this.enabled && !this.channelIds.length) this.enabled = false

      // there is only ever one target set and every reader indexes [0], so a second entry would need all of them updated
      if (!this.targetSets.length) {
        this.targetSets.push({ id: glUtils.uuid(), targets: {} })
      }

      if (!this.targetSets[0].id) {
        this.targetSets[0].id = glUtils.uuid()
      }

      if (!_.isPlainObject(this.targetSets[0].targets)) {
        this.targetSets[0].targets = {}
      }
    }

    QuotaPlan.prototype.deserialize = function(data) {
      var self = this

      data = _.isPlainObject(data) ? data : {}

      self.id = data.id
      self.name = data.name
      self.enabled = data.enabled

      self.channelIds = _.isArray(data.channelIds)
        ? data.channelIds.slice()
        : undefined

      self.quotas = _.isArray(data.quotas)
        ? data.quotas.map(function(quotaData) {
            return new QuotaDefinition().deserialize(quotaData)
          })
        : undefined

      self.targetSets = _.isArray(data.targetSets)
        ? data.targetSets.map(function(targetSet) {
            return {
              id: targetSet && targetSet.id,
              targets: _.isPlainObject(targetSet && targetSet.targets)
                ? _.cloneDeep(targetSet.targets)
                : {},
            }
          })
        : undefined

      self.applyDefaults()
      return self
    }

    QuotaPlan.prototype.serialize = function() {
      var data = {}

      data.id = this.id
      data.name = this.name
      data.enabled = this.enabled
      data.channelIds = this.channelIds.slice()

      data.quotas = this.quotas.map(function(quota) {
        return quota.serialize()
      })

      data.targetSets = this.targetSets.map(function(targetSet) {
        return { id: targetSet.id, targets: _.cloneDeep(targetSet.targets) }
      })

      return data
    }

    QuotaPlan.prototype.getQuotas = function(mode) {
      if (_.isNil(mode)) return this.quotas.slice()

      return _.filter(this.quotas, { mode: mode })
    }

    QuotaPlan.prototype.addQuota = function(mode) {
      var quota = new QuotaDefinition()

      quota.mode = mode || QuotaDefinition.Modes.INTERLOCKED
      quota.name = quota.getDerivedName()

      this.quotas.push(quota)

      return quota
    }

    QuotaPlan.prototype.removeQuota = function(quota) {
      _.remove(this.quotas, { id: quota.id })

      delete this.targetSets[0].targets[quota.id]

      return quota
    }

    QuotaPlan.prototype.getTarget = function(quotaId, cellKey) {
      var targets = this.targetSets[0].targets[quotaId]
      if (!targets) return null

      // a target of 0 means closed and no key at all means unlimited, so this can never become a truthiness test
      var value = targets[cellKey]

      return _.isNumber(value) ? value : null
    }

    QuotaPlan.prototype.setTarget = function(quotaId, cellKey, value) {
      var allTargets = this.targetSets[0].targets

      // null deletes the key rather than storing 0 - unlimited and closed are different states and must stay different
      if (_.isNil(value)) {
        if (allTargets[quotaId]) delete allTargets[quotaId][cellKey]
        return
      }

      if (!_.isNumber(value)) {
        console.error(
          'QuotaPlan.setTarget: target for ' +
            quotaId +
            ' / ' +
            cellKey +
            ' must be a number or null, got ' +
            typeof value
        )
        return
      }

      if (value % 1 !== 0 || value < 0 || value > MAX_TARGET) {
        console.error(
          'QuotaPlan.setTarget: target for ' +
            quotaId +
            ' / ' +
            cellKey +
            ' must be a whole number from 0 to ' +
            MAX_TARGET +
            ', got ' +
            value
        )
        return
      }

      if (!allTargets[quotaId]) allTargets[quotaId] = {}
      allTargets[quotaId][cellKey] = value
    }

    QuotaPlan.prototype.clearTargets = function(quotaId) {
      delete this.targetSets[0].targets[quotaId]
    }

    QuotaPlan.prototype.setEnabled = function(enabled) {
      this.enabled = !!enabled && this.channelIds.length > 0
      return this.enabled
    }

    QuotaPlan.prototype.setChannelIds = function(channelIds) {
      this.channelIds = _.isArray(channelIds) ? channelIds.slice() : []

      // losing the last channel disables the plan, but gaining one deliberately does not re-enable it
      if (!this.channelIds.length) this.enabled = false

      return this.channelIds
    }

    QuotaPlan.findByChannelId = function(plans, channelId) {
      if (_.isNil(channelId)) return null

      // a channel belongs to at most one plan, so the first match is the only match
      var plan = _.find(plans, function(plan) {
        return _.includes(plan.channelIds, channelId)
      })

      return plan || null
    }

    return QuotaPlan
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils"];
  angular.module('glow.components').factory('QuotaVariable', Factory)

  /* @ngInject */
  function Factory(glUtils) {
    var Types = {
      QUESTION: 'QUESTION',
      TAG: 'TAG',
    }

    function QuotaVariable() {
      this.applyDefaults()
    }

    QuotaVariable.prototype.Types = QuotaVariable.Types = Types

    QuotaVariable.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: glUtils.uuid(),
        type: Types.QUESTION,
        questionId: null,
        displayName: null,
      })
    }

    QuotaVariable.prototype.deserialize = function(data) {
      data = _.isPlainObject(data) ? data : {}

      this.id = data.id
      this.type = data.type
      this.questionId = data.questionId
      this.displayName = data.displayName

      if (_.isArray(data.options)) {
        this.options = _.cloneDeep(data.options)
      } else {
        // absent means all of the question's choices - an empty array would mean none, so this deletes rather than defaults
        delete this.options
      }

      this.applyDefaults()
      return this
    }

    QuotaVariable.prototype.serialize = function() {
      var data = {}

      data.id = this.id
      data.type = this.type

      if (this.isQuestion()) data.questionId = this.questionId
      if (this.isTag()) data.displayName = this.displayName

      if (_.isArray(this.options)) {
        data.options = _.cloneDeep(this.options)
      }

      return data
    }

    QuotaVariable.prototype.isQuestion = function() {
      return this.type === Types.QUESTION
    }

    QuotaVariable.prototype.isTag = function() {
      return this.type === Types.TAG
    }

    // nothing writes an explicit options array yet, so the branches this guards are unreachable today and must not be dropped as dead code
    QuotaVariable.prototype.hasExplicitOptions = function() {
      return _.isArray(this.options)
    }

    QuotaVariable.prototype.getOptionIdForChoiceId = function(choiceId) {
      if (_.isNil(choiceId)) return null

      if (!this.hasExplicitOptions()) return choiceId

      var option = _.find(this.options, function(option) {
        return _.includes(option.members, choiceId)
      })

      return option ? option.id : null
    }

    QuotaVariable.prototype.getOptionIdForTag = function(tag) {
      if (!this.isTag()) return null
      if (_.isNil(tag)) return null

      var option = _.find(this.options, { tag: tag })

      return option ? option.id : null
    }

    QuotaVariable.prototype.getOptions = function(question) {
      var self = this

      // a tag option carries no label field - the tag string is its name on every screen
      if (self.isTag()) {
        return _.map(self.options, function(option) {
          return {
            id: option.id,
            label: option.tag,
            tag: option.tag,
          }
        })
      }

      if (self.hasExplicitOptions()) {
        return _.map(self.options, function(option) {
          return {
            id: option.id,
            label: option.label,
            members: _.isArray(option.members) ? option.members.slice() : [],
          }
        })
      }

      if (!question || !_.isArray(question.choices)) return []

      return _.map(question.choices, function(choice) {
        return {
          id: choice.id,
          label: choice.label || choice.value,
          members: [choice.id],
        }
      })
    }

    QuotaVariable.prototype.getMissingTags = function(surveyTags) {
      if (!this.isTag()) return []

      var tags = _.map(this.options, 'tag')

      return _.difference(tags, surveyTags || [])
    }

    QuotaVariable.prototype.getShortLabel = function(questions) {
      if (this.isTag()) return this.displayName

      var question = _.find(questions, { id: this.questionId })
      if (!question) return '?'

      return 'Q' + question.getNumber()
    }

    return QuotaVariable
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('Randomizer', Factory)

  /* @ngInject */
  function Factory() {
    function Randomizer() {
      // ...
    }

    Randomizer.prototype.shuffle = function(arr, getIsAnchored) {
      var anchors = []
      _.each(arr, function(item, index) {
        if (getIsAnchored(item)) {
          anchors.push({ item: item, index: index })
        }
      })
      // get a shuffled array
      var shuffled = _.shuffle(arr)
      // replaced the array with the shuffled order
      _.remove(arr)
      shuffled.forEach(function(item) {
        arr.push(item)
      })
      _.each(anchors, function(anchor) {
        var indexOfAnchorItem = _.indexOf(arr, anchor.item)
        var itemInAnchorPosition = arr[anchor.index]
        // if anchor item is not in it's anchor position
        // swap it with the choice that IS in its position
        if (anchor.item !== itemInAnchorPosition) {
          arr[anchor.index] = anchor.item
          arr[indexOfAnchorItem] = itemInAnchorPosition
        }
      })
    }

    Randomizer.prototype.rotate = function(arr, getIsAnchored) {
      var anchors = []
      // remove anchored and store in an array
      _.remove(arr, function(item, index) {
        if (getIsAnchored(item)) {
          anchors.push({ item: item, index: index })
          return true
        }
        return false
      })
      var maxNumOfRotation = arr.length
      var numOfRotation = _.random(1, maxNumOfRotation)
      _.times(numOfRotation, function() {
        // move first element in array to the tail for each iteration
        var firstEl = arr.shift()
        arr.push(firstEl)
      })
      _.each(anchors, function(anchor) {
        // put back the anchors
        arr.splice(anchor.index, 0, anchor.item)
      })
    }

    Randomizer.prototype.flip = function(arr, getIsAnchored) {
      var anchors = []
      // remove anchored and store in an array
      _.remove(arr, function(item, index) {
        if (getIsAnchored(item)) {
          anchors.push({ item: item, index: index })
          return true
        }
        return false
      })
      // flip a coin to decide if we should flip the array
      var shouldFlip = _.random(0, 1) === 1
      if (shouldFlip) _.reverse(arr)
      // put any anchor back to their anchored position
      _.each(anchors, function(anchor) {
        arr.splice(anchor.index, 0, anchor.item)
      })
    }

    return Randomizer
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["colors"];
  angular.module('glow.components').component('radial', {
    controller: Controller,
    templateUrl: 'radial.html',
    bindings: {
      colorValue: '@color',
      radius: '<',
      stroke: '<',
      progress: '<',
    },
  })

  /* @ngInject */
  function Controller(colors) {
    var ctrl = this
    var DEFAULT_COLOR = 'black'

    ctrl.$onChanges = onChanges

    function onChanges() {
      // originated on a css-tricks post: https://css-tricks.com/building-progress-ring-quickly/
      // code comes from here: https://codepen.io/jeremenichelli/pen/gGWPme

      // this code isn't quite right. The size of the component is indeed 2x the radius
      // but the radial itself seems to be inset too far.
      var progress = ctrl.progress || 0
      ctrl.color = colors.parse(ctrl.colorValue) || DEFAULT_COLOR
      ctrl.normalizedRadius = ctrl.radius - ctrl.stroke * 2
      ctrl.circumference = ctrl.normalizedRadius * 2 * Math.PI
      ctrl.strokeDashoffset =
        ctrl.circumference - (progress / 100) * ctrl.circumference
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('SignificanceTest', Factory)

  /* @ngInject */
  function Factory() {
    var DefaultConfidenceLevel = 95 // default to 95% confidence level

    function SignificanceTest() {
      this.applyDefaults()
    }

    SignificanceTest.prototype.DefaultConfidenceLevel = SignificanceTest.DefaultConfidenceLevel = DefaultConfidenceLevel

    SignificanceTest.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        enabled: false,
        confidenceLevel: DefaultConfidenceLevel,
        isHiddenFromShared: false,
      })
    }

    SignificanceTest.prototype.deserialize = function(data) {
      data = _.isPlainObject(data) ? data : {}

      this.enabled = data.enabled
      this.confidenceLevel = data.confidenceLevel
      this.isHiddenFromShared = data.isHiddenFromShared

      this.applyDefaults()
      return this
    }

    SignificanceTest.prototype.serialize = function() {
      var data = {}
      data.enabled = this.enabled
      data.confidenceLevel = this.confidenceLevel
      data.isHiddenFromShared = this.isHiddenFromShared
      return data
    }

    SignificanceTest.prototype.validate = function() {
      var errors = []

      if (this.enabled) {
        if (!this.confidenceLevel) {
          errors.push('Confidence Level is required to show Significance Test')
        }
      }

      this.errors = errors.length ? errors : null
      return !errors.length
    }

    /**
     * Returns "HIGHER" when subset is significantly higher than total
     * Returns "LOWER" when subset is significantly lower than total
     * Returns null when subset is not significant or whenever a calculation
     * result in non finite numbers
     * such as NaN, Infinity or -Infinity
     * Reference: https://docs.glowfeed.com/article/202-significance-testing
     */
    SignificanceTest.prototype.testSubset = function(
      subsetN,
      subsetBase,
      totalN,
      totalBase
    ) {
      // Validate inputs ensure numbers are finite and
      // subset base must be lower than total base
      if (
        !Number.isFinite(subsetN) ||
        !Number.isFinite(subsetBase) ||
        !Number.isFinite(totalN) ||
        !Number.isFinite(totalBase) ||
        subsetBase >= totalBase
      ) {
        return null
      }

      // Step 1: Calculate percent
      var subsetPercent = subsetN / subsetBase || 0 // NaN fallback
      var totalPercent = totalN / totalBase || 0 // NaN fallback

      // Step 2: Combined Variance
      var combinedProportion = (subsetN + totalN) / (subsetBase + totalBase)
      if (!Number.isFinite(combinedProportion)) {
        return null
      }
      var variance =
        (combinedProportion * (1 - combinedProportion)) /
        (1 - 1 / (subsetBase + totalBase))
      if (!Number.isFinite(variance)) {
        return null
      }

      // Step 3: Calculate T-Value
      var tValue =
        Math.abs(subsetPercent - totalPercent) /
        Math.sqrt(variance * (1 / subsetBase - 1 / totalBase))
      if (!Number.isFinite(tValue)) {
        return null
      }

      // Step 4: Calculate P-Value using normal distribution
      var pValue = 2 * (1 - normsDist(Math.abs(tValue)))
      if (!Number.isFinite(pValue)) {
        return null
      }

      // Step 5: Compare P-Value to Confidence Level
      var significanceLevel = 1 - pValue
      var confidenceLevel = this.confidenceLevel / 100 || 0 // NaN fallback
      var isSignificant = significanceLevel > confidenceLevel

      if (isSignificant && subsetPercent > totalPercent) {
        return 'HIGHER'
      }
      if (isSignificant && subsetPercent < totalPercent) {
        return 'LOWER'
      }
      return null
    }

    /**
     * Standard Normal CDF (NORMSDIST in Excel)
     * Returns probability from -∞ to z under the standard normal curve.
     * * Reference:
     * - The relationship between erf() and Φ(z) is standard in statistics:
     *     Φ(z) = 1/2 * [1 + erf(z / √2)]
     * - https://en.wikipedia.org/wiki/Normal_distribution#Cumulative_distribution
     */
    function normsDist(z) {
      return 0.5 * (1 + erf(z / Math.sqrt(2)))
    }

    /**
     * Approximation to the error function erf(x)
     * Reference: Abramowitz and Stegun, Handbook of Mathematical Functions (1964),
     * formula 7.1.26
     */
    function erf(x) {
      // Save the sign of x
      var sign = x < 0 ? -1 : 1
      x = Math.abs(x)

      // Constants used in the approximation
      var a1 = 0.254829592
      var a2 = -0.284496736
      var a3 = 1.421413741
      var a4 = -1.453152027
      var a5 = 1.061405429
      var p = 0.3275911

      // Abramowitz and Stegun formula 7.1.26
      var t = 1 / (1 + p * x)
      var y =
        1 -
        ((((a5 * t + a4) * t + a3) * t + a2) * t + a1) * t * Math.exp(-x * x)

      return sign * y
    }

    return SignificanceTest
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('StateFactory', Factory)

  /* @ngInject */
  function Factory() {
    function State(states) {
      var self = this
      _.each(states, function(state) {
        // Setter
        self[state] = function() {
          self.currentState = state
        }

        // Getter
        self[_.camelCase('is-' + state)] = function() {
          return self.currentState === state
        }
      })
    }

    return State
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["StateFactory"];
  angular.module('glow.components').service('stateService', Service)

  /* @ngInject */
  function Service(StateFactory) {
    var self = this

    self.define = define

    function define(states) {
      return new StateFactory(states)
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('tagsPicker', {
    controller: Controller,
    templateUrl: 'tags-picker.html',
    bindings: {
      survey: '<',
      selectedSrc: '<selected',
      description: '@',
      onApply: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.isSelected = isSelected
    ctrl.select = select
    ctrl.apply = apply

    function onInit() {
      ctrl.selected = []
      _.each(ctrl.selectedSrc, function(tag) {
        ctrl.selected.push(tag)
      })
      ctrl.tags = ctrl.survey.getTags()
    }

    function isSelected(tag) {
      return _.includes(ctrl.selected, tag)
    }

    function select(tag) {
      if (isSelected(tag)) {
        // must use function, _.remove(ctrl.selected, tag) fails
        _.remove(ctrl.selected, function(selected) {
          return selected === tag
        })
      } else {
        ctrl.selected.push(tag)
      }
    }

    function apply() {
      ctrl.onApply({ $selected: ctrl.selected })
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["glDialog"];
  angular.module('glow.components').service('tagsPickerService', Service)

  /* @ngInject */
  function Service(glDialog) {
    var self = this

    self.show = show

    function show(survey, selected, title, description) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="tags-picker__dialog">',
          '<g-dialog-header ',
            'title="' + title + '" ',
            'on-close="dialog.cancel()" ',
          '></g-dialog-header>',
          '<tags-picker ',
            'survey="survey" ',
            'selected="selected" ',
            'description="{{ description }}" ',
            'on-apply="dialog.close($selected)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        locals: {
          survey: survey,
          selected: selected,
          description: description,
        },
        escapeToClose: true,
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils"];
  angular.module('glow.components').factory('Choice', Factory)

  function Factory(glUtils) {
    var Defaults = {
      type: 'choice',
      isNew: true,
      value: '',
    }

    var Types = {
      CHOICE: 'choice',
      STATEMENT: 'statement',
    }

    function Choice(options) {
      _.defaults(this, options, Defaults)
      if (!this.id) {
        this.refresh()
      }
    }

    Choice.prototype.Types = Choice.Types = Types

    Choice.prototype.serialize = function(options) {
      var data = {}
      options = options || {}

      data.id = this.id
      data.order = this.order
      data.score = this.score

      var value = this.value
      if (this.isHeading && !value) {
        // this is a zero width space
        // see: https://unicode-explorer.com/c/200B
        value = '​'
      }
      data[this.type === Types.CHOICE ? 'option' : 'statement'] = value

      data.data = {}
      if (!options.discardImage) {
        data.data.imageUrl = this.imageUrl
      }
      data.data.isHidden = this.isHidden
      data.data.isCapture = this.isCapture
      data.data.isExclusive = this.isExclusive
      data.data.isAnchored = this.isAnchored
      data.data.isIndependent = this.isIndependent
      data.data.isBorrowed = this.isBorrowed
      data.data.isHeading = this.isHeading

      return data
    }

    Choice.prototype.deserialize = function(data) {
      data.data = _.isPlainObject(data.data) ? data.data : {}

      this.id = data.id
      this.isNew = !data.id
      this.value = data[this.type === Types.CHOICE ? 'option' : 'statement']
      this.order = data.order
      this.score = data.score

      // label can be set via options in the constructor. If not, fall back on value.
      this.label = this.label || this.value

      this.imageUrl = data.data.imageUrl
      this.isHidden = data.data.isHidden // IMPORTANT: This field is used in the BE to hide export columns that are hidden
      this.isCapture = data.data.isCapture
      this.isExclusive = data.data.isExclusive
      this.isAnchored = data.data.isAnchored
      this.isIndependent = data.data.isIndependent
      this.isBorrowed = data.data.isBorrowed
      this.isHeading = data.data.isHeading // IMPORTANT: This field is used in the BE to hide export columns that are headings
      return this
    }

    Choice.prototype.convertToHeading = function() {
      this.isHeading = true
      this.isCapture = false
      this.isExclusive = false
      this.isIndependent = false
      this.score = null
    }

    Choice.prototype.clone = function() {
      var choice = new Choice(this)
      choice.refresh()
      return choice
    }

    Choice.prototype.realClone = function() {
      // the clone above is fake because it refreshes the id :/
      return new Choice({ type: this.type }).deserialize(this.serialize())
    }

    Choice.prototype.refresh = function(getId) {
      this.idOld = this.id
      this.id = getId ? getId(this.idOld) : glUtils.uuid()
      this.isNew = true
    }

    return Choice
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('Lender', Factory)

  /* @ngInject */
  function Factory() {
    var Target = {
      STATEMENTS: 'STATEMENTS',
      CHOICES: 'CHOICES',
    }

    var Reducer = {
      SELECTED: 'SELECTED',
      NOT_SELECTED: 'NOT_SELECTED',
      DISPLAYED: 'DISPLAYED',
      NOT_DISPLAYED: 'NOT_DISPLAYED',
    }

    // reducer options
    var MatrixStatementReducerOptions = [
      { label: 'Show all statements', value: null },
      {
        label: 'Only show statements where the respondent selected any of...',
        value: Reducer.SELECTED,
      },
      {
        label: "Only show statements the respondent didn't select any of...",
        value: Reducer.NOT_SELECTED,
      },
      {
        label: 'Only show statements displayed to respondent',
        value: Reducer.DISPLAYED,
      },
      {
        label: 'Only show statements NOT displayed to respondent',
        value: Reducer.NOT_DISPLAYED,
      },
    ]

    var MatrixChoiceReducerOptions = [
      { label: 'Show all choices', value: null },
      {
        label: 'Only show choices the respondent selected in...',
        value: Reducer.SELECTED,
      },
      {
        label: "Only show choices the respondent didn't select in...",
        value: Reducer.NOT_SELECTED,
      },
      {
        label: 'Only show choices displayed to respondent',
        value: Reducer.DISPLAYED,
      },
      {
        label: 'Only show choices NOT displayed to respondent',
        value: Reducer.NOT_DISPLAYED,
      },
    ]

    var ChoiceReducerOptions = [
      { label: 'Show all choices', value: null },
      {
        label: 'Only show choices the respondent selected',
        value: Reducer.SELECTED,
      },
      {
        label: "Only show choices the respondent didn't select",
        value: Reducer.NOT_SELECTED,
      },
      {
        label: 'Only show choices displayed to respondent',
        value: Reducer.DISPLAYED,
      },
      {
        label: 'Only show choices NOT displayed to respondent',
        value: Reducer.NOT_DISPLAYED,
      },
    ]

    var HiddenVariableReducerOptions = [
      { label: 'Show all variables', value: null },
      {
        label: 'Only show variables displayed',
        value: Reducer.DISPLAYED,
      },
      {
        label: 'Only show variables NOT displayed',
        value: Reducer.NOT_DISPLAYED,
      },
    ]

    function Lender() {
      this.errors = []
      this.applyDefaults()
    }

    Lender.prototype.Target = Lender.Target = Target
    Lender.prototype.Reducer = Lender.Reducer = Reducer
    Lender.prototype.MatrixStatementReducerOptions = Lender.MatrixStatementReducerOptions = MatrixStatementReducerOptions
    Lender.prototype.MatrixChoiceReducerOptions = Lender.MatrixChoiceReducerOptions = MatrixChoiceReducerOptions
    Lender.prototype.ChoiceReducerOptions = Lender.ChoiceReducerOptions = ChoiceReducerOptions
    Lender.prototype.HiddenVariableReducerOptions = Lender.HiddenVariableReducerOptions = HiddenVariableReducerOptions

    Lender.prototype.applyDefaults = function() {
      _.defaults(this, {
        id: null,
        target: null,
        reducer: null,
        statementIds: [],
        choiceIds: [],
        exclusionIds: [],
        persistOrder: false,
        loopKey: null,
      })
    }

    Lender.prototype.deserialize = function(data) {
      data = data || {}
      this.id = data.id
      this.target = data.target || Target.CHOICES
      this.reducer = data.reducer
      this.statementIds = data.statementIds ? data.statementIds.slice() : []
      this.choiceIds = data.choiceIds ? data.choiceIds.slice() : []
      this.exclusionIds = data.exclusionIds ? data.exclusionIds.slice() : []
      this.persistOrder = data.persistOrder
      this.loopKey = data.loopKey
      this.applyDefaults()
      return this
    }

    Lender.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.target = this.target
      data.reducer = this.reducer
      data.statementIds = this.statementIds.slice()
      data.choiceIds = this.choiceIds.slice()
      data.exclusionIds = this.exclusionIds.slice()
      data.persistOrder = this.persistOrder
      data.loopKey = this.loopKey
      return data
    }

    Lender.prototype.clear = function() {
      this.id = null
      this.target = null
      this.reducer = null
      this.statementIds = []
      this.choiceIds = []
      this.exclusionIds = []
      this.persistOrder = false
      this.loopKey = null
    }

    Lender.prototype.filterByExclusions = function(choicesOrStatements) {
      var self = this
      if (!self.exclusionIds.length) {
        return choicesOrStatements
      }
      return choicesOrStatements.filter(function(item) {
        return !_.includes(self.exclusionIds, item.id)
      })
    }

    Lender.prototype.targetsChoices = function() {
      return this.target === Target.CHOICES
    }

    Lender.prototype.targetsStatements = function() {
      return this.target === Target.STATEMENTS
    }

    Lender.prototype.isSelectionReducer = function() {
      return _.includes([Reducer.SELECTED, Reducer.NOT_SELECTED], this.reducer)
    }

    Lender.prototype.clone = function() {
      return new Lender().deserialize(this.serialize())
    }

    Lender.prototype.rebind = function(getId) {
      this.id = getId(this.id, true)
      this.choiceIds = this.choiceIds.map(function(oldId) {
        return getId(oldId, true)
      })
      this.statementIds = this.statementIds.map(function(oldId) {
        return getId(oldId, true)
      })
      this.exclusionIds = this.exclusionIds.map(function(oldId) {
        return getId(oldId, true)
      })
      this.loopKey = getId(this.loopKey, true)
    }

    Lender.prototype.usesLoopKey = function(survey, parentId) {
      if (!this.id || !this.reducer) return false

      // ensure the lender question is in loop
      var lenderQuestion = survey.getQuestion(this.id)
      var viewGroup = lenderQuestion.getViewGroup()
      if (!viewGroup || !viewGroup.loop) return false

      // ensure parent is not in the same group with the lender question
      return !viewGroup.viewIds.includes(parentId)
    }

    Lender.prototype.getLoopVariable = function(survey) {
      if (!this.id || !this.loopKey) return null

      var lenderQuestion = survey.getQuestion(this.id)
      var viewGroup = lenderQuestion.getViewGroup()
      var loopVariables = viewGroup.getLoopVariables(survey)
      return _.find(loopVariables, { id: this.loopKey })
    }

    Lender.prototype.cleanUp = function(survey, parentId) {
      if (!this.id) return

      var lenderQuestion = survey.getQuestion(this.id)
      if (!lenderQuestion) {
        // can't clean up without lender question, let validate() return error
        return
      }

      // remove invalid or hidden choice ids
      var choices = lenderQuestion.getProjectedChoices() || []
      _.remove(this.choiceIds, function(choiceId) {
        var choice = _.find(choices, { id: choiceId })
        return !choice || choice.isHidden
      })

      // remove invalid or hidden statement ids
      var statements = lenderQuestion.getProjectedStatements() || []
      _.remove(this.statementIds, function(statementId) {
        var statement = _.find(statements, { id: statementId })
        return !statement || statement.isHidden
      })

      // remove invalid or hidden exclusion ids
      var exclusionOptions = this.targetsStatements()
        ? lenderQuestion.getProjectedStatements(true)
        : lenderQuestion.getProjectedChoices(true)
      _.remove(this.exclusionIds, function(exclusionId) {
        var option = _.find(exclusionOptions, { id: exclusionId })
        return !option || option.isHidden
      })

      // remove loopKey if lender question is not in loop or loop variable doesn't exist
      if (
        this.loopKey &&
        (!this.usesLoopKey(survey, parentId) || !this.getLoopVariable(survey))
      ) {
        this.loopKey = null
      }
    }

    Lender.prototype.validate = function(survey, parentId, questionNumber) {
      _.remove(this.errors) // clear errors

      if (!this.id) {
        return true // immediately validate
      }

      var isValid = true
      var lenderQuestion = survey.getQuestion(this.id)

      // ensure lender is a valid question
      if (!lenderQuestion) {
        this.errors.push(
          'The choices this question borrows no longer exist (the question may have been deleted)'
        )
        return false // immediately invalidate
      }

      // ensure reduced lenders are before this question
      if (questionNumber < lenderQuestion.getNumber()) {
        this.errors.push(
          'Cannot show/hide respondent selections when borrowed choices are from a future question'
        )
        isValid = false
      }

      if (lenderQuestion.isUsedAsMatrix()) {
        // ensure target is selected for matrix type lender
        if (!this.target) {
          this.errors.push(
            'Target is required when borrowing from matrix question'
          )
          return false // immediately invalidate
        }

        // ensure choiceIds or statementIds is selected when reducer is selection type
        if (this.isSelectionReducer()) {
          if (this.targetsStatements() && _.isEmpty(this.choiceIds)) {
            this.errors.push(
              'Choices must be selected when borrowing statements this way'
            )
            isValid = false
          }
          if (this.targetsChoices() && _.isEmpty(this.statementIds)) {
            this.errors.push(
              'Statements must be selected when borrowing choices this way'
            )
            isValid = false
          }
        }
      }

      // ensure loopKey is selected for lender inside loop
      if (this.usesLoopKey(survey, parentId) && !this.loopKey) {
        this.errors.push(
          'Loop variable must be selected when borrowing from question in loop'
        )
        isValid = false
      }

      return isValid
    }

    return Lender
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils"];
  angular.module('glow.components').factory('Mod', Factory)

  /* @ngInject */
  function Factory(glUtils) {
    function Mod() {
      this.errors = []
      this.applyDefaults()
    }

    Mod.prototype.applyDefaults = function() {
      _.defaults(this, {
        id: glUtils.uuid(),
        label: '',
        optionIds: [],
        hidden: false,
      })
    }

    Mod.prototype.deserialize = function(data) {
      this.id = data.id
      this.label = data.label
      this.optionIds = data.optionIds
      this.hidden = data.hidden
      this.applyDefaults()
      return this
    }

    Mod.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.label = this.label
      data.optionIds = this.optionIds
      data.hidden = this.hidden
      return data
    }

    Mod.prototype.clone = function() {
      return new Mod().deserialize(this.serialize())
    }

    Mod.prototype.newId = function() {
      this.id = glUtils.uuid()
    }

    // NOTE: this also needs to refresh questionId and optionIds
    // Mod.prototype.refresh = function(getId) {
    //   this.idOld = this.id
    //   this.id = getId(this.idOld)
    //   this.applyDefaults()
    // }

    return Mod
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('Origin', Factory)

  /* @ngInject */
  function Factory() {
    var Types = {
      EXPORT: 'Export',
      DUPLICATE: 'Duplicate',
    }

    var Envs = {
      PRODUCTION: 'Production',
      STAGING: 'Staging',
    }

    var baseUrls = {
      Production: {
        AP: 'https://admin.glowfeed.com',
        SP: 'https://portal.glowfeed.com',
      },
      Staging: {
        AP: 'https://admin-staging.glowfeed.com',
        SP: 'https://portal-staging.glowfeed.com',
      },
    }

    function Origin() {
      this.applyDefaults()
    }

    Origin.Types = Origin.prototype.Types = Types
    Origin.Envs = Origin.prototype.Envs = Envs

    Origin.prototype.applyDefaults = function() {
      var now = moment()
      _.defaults(this, {
        type: null,
        surveyId: null,
        projectId: null,
        subscriberId: null,
        subscriberName: null,
        userId: null,
        userName: null,
        isSSR: false,
        env: null,
        createdAt: now,
      })
    }

    Origin.prototype.deserialize = function(data) {
      this.type = data.type
      this.surveyId = data.surveyId
      this.projectId = data.projectId
      this.subscriberId = data.subscriberId
      this.subscriberName = data.subscriberName
      this.userId = data.userId
      this.userName = data.userName
      this.isSSR = data.isSSR
      this.env = data.env
      this.createdAt = data.createdAt ? moment(data.createdAt) : null
      this.applyDefaults()
      return this
    }

    Origin.prototype.serialize = function() {
      var data = {}
      data.type = this.type
      data.surveyId = this.surveyId
      data.projectId = this.projectId
      data.subscriberId = this.subscriberId
      data.subscriberName = this.subscriberName
      data.userId = this.userId
      data.userName = this.userName
      data.isSSR = this.isSSR
      data.env = this.env
      data.createdAt = this.createdAt.toISOString()
      return data
    }

    Origin.prototype.getSurveyUrl = function() {
      var baseUrl = baseUrls[this.env].SP
      return baseUrl + '/surveys/' + this.surveyId
    }

    Origin.prototype.getProjectUrl = function() {
      var baseUrl = baseUrls[this.env].SP
      return baseUrl + '/projects/' + this.projectId
    }

    Origin.prototype.getSubscriberUrl = function() {
      var baseUrl = baseUrls[this.env].AP
      return baseUrl + '/subscriber/' + this.subscriberId
    }

    Origin.prototype.getUserUrl = function() {
      var baseUrl = baseUrls[this.env].AP
      return baseUrl + '/user/' + this.userId
    }

    return Origin
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["$q", "$log", "Question"];
  angular.module('glow.components').factory('QuestionTemplate', Factory)

  /* @ngInject */
  function Factory($q, $log, Question) {
    var log = $log.create('QuestionTemplate')

    var Events = {
      CREATED: 'question-template:created',
      UPDATED: 'question-template:updated',
      PUBLISHED: 'question-template:published',
    }

    var Defaults = {
      name: null,
      questions: [],
      serverData: {},
      tags: [],
      kits: [],
    }

    /**
     * @class QuestionTemplate
     * @desc instantiates a new/existing question-template
     * @param {Object} options The initial options
     *
     * @example
     * // instantiate a new question-template
     * var template = new QuestionTemplate();
     * // instantiate from server data
     * var template = new QuestionTemplate().deserialize(data);
     */
    function QuestionTemplate(options) {
      this.errors = []

      // absorb options making sure to set defaults/required values
      _.defaultsDeep(this, options || {}, Defaults)
    }

    QuestionTemplate.prototype.Events = QuestionTemplate.Events = Events

    QuestionTemplate.prototype.deserialize = function(data) {
      // immutable clone
      data = _.cloneDeep(data)

      this.serverData = _.cloneDeep(data)

      this.questions = _.map(data.questions, function(question) {
        return new Question({ isTemplate: true }).deserialize(question)
      })

      this.id = data.id
      this.name = data.name
      this.type = this.questions[0] ? this.questions[0].type : '' // shared question type
      this.typeLabel = this.questions[0] ? this.questions[0].label : '' // shared question type label
      this.ownerId = data.ownerId
      this.tags = data.tags || []
      this.kits = data.kits || []

      this.createdAt = moment(data.createdAt)
      this.updatedAt = moment(data.updatedAt)

      // TODO: check createdAt/updatedAt are guaranteed - if not, use below instead of ^
      // this.createdAt = data.createdAt ? moment(data.createdAt) : null;
      // this.updatedAt = data.updatedAt ? moment(data.updatedAt) : null;

      return this
    }

    QuestionTemplate.prototype.serialize = function() {
      var self = this

      var data = {}

      data.id = self.id
      data.name = self.name
      data.tags = self.tags
      data.ownerId = self.ownerId

      data.questions = _.map(self.questions, function(question) {
        return question.serialize()
      })

      return data
    }

    QuestionTemplate.prototype.fromQuestion = function(question) {
      if (!question || !question.type) {
        return log.error(
          'Cannot add question template without a question or question type'
        )
      }

      var clonedQuestion = new Question({ isTemplate: true }).deserialize(
        question.clone().serialize()
      )
      this.name = clonedQuestion.title
      this.questions.push(clonedQuestion)

      return this
    }

    QuestionTemplate.prototype.useQuestion = function(question) {
      question = question.clone({ comparisonKey: true })
      question.unTemplate(this.id)
      return question
    }

    QuestionTemplate.prototype.isNew = function() {
      return !this.id
    }

    QuestionTemplate.prototype.stateTransText = function(fromState, toState) {
      var trans = {
        DRAFT: {
          DRAFT: null,
          PUBLISHED: 'Publish',
          ARCHIVED: null,
        },
        PUBLISHED: {
          DRAFT: 'Make Draft',
          PUBLISHED: null,
          ARCHIVED: 'Archive',
        },
        ARCHIVED: {
          DRAFT: 'Make Draft',
          PUBLISHED: 'Unarchive',
          ARCHIVED: null,
        },
      }
      return trans[fromState][toState]
    }

    QuestionTemplate.prototype.canPublishQuestion = function(question) {
      var isNew = question.isNew
      var isPublished = question.state === Question.States.PUBLISHED
      return !(isNew || isPublished)
    }

    QuestionTemplate.prototype.canArchiveQuestion = function(question) {
      var isNew = question.isNew
      var isArchived = question.state === Question.States.ARCHIVED
      var isDraft = question.state === Question.States.DRAFT
      return !(isNew || isArchived || isDraft)
    }

    QuestionTemplate.prototype.canRedraftQuestion = function(question) {
      var isNew = question.isNew
      var isDraft = question.state === Question.States.DRAFT
      var isArchived = question.state === Question.States.ARCHIVED
      var haveProfiling = !!question.profileKey
      return !(isNew || isDraft || isArchived || haveProfiling)
    }

    QuestionTemplate.prototype.validate = function() {
      var self = this
      var isValid = true

      self.errors.splice(0, self.errors.length) // clear errors

      // template name
      if (!self.name) {
        self.errors.push('Name is required.')
        isValid = false
      }

      // ensure a question exists
      if (!self.questions.length) {
        self.errors.push('Atleast one variation is required')
        isValid = false
      }

      _.each(self.questions, function(question) {
        if (!question.validate()) {
          isValid = false
          return false // stop iterating
        }
      })

      return isValid
    }

    QuestionTemplate.prototype.getProfileKeys = function() {
      var self = this
      var profileKeys = []
      _.each(self.questions, function(question) {
        if (question.profileKey) {
          profileKeys.push(question.profileKey)
        }
      })
      return profileKeys
    }

    QuestionTemplate.prototype.totalPublished = function() {
      return _.filter(this.questions, { state: Question.States.PUBLISHED })
        .length
    }

    QuestionTemplate.prototype.clone = function() {
      var data = this.serialize()
      delete data.id
      _.each(data.questions, function(question) {
        delete question.id
      })

      return new QuestionTemplate().deserialize(data)
    }

    QuestionTemplate.prototype.addVariation = function() {
      var self = this

      if (!self.type) {
        return log.error('Cannot add variation without a type')
      }

      var question = new Question({ isTemplate: true, type: self.type })
      self.questions.push(question)
    }

    return QuestionTemplate
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$log", "$q", "QuestionTemplate", "Question", "kitsService", "questionTemplatesResource", "userService"];
  angular.module('glow.components').service('questionTemplateService', Service)

  /* @ngInject */
  function Service(
    $log,
    $q,
    QuestionTemplate,
    Question,
    kitsService,
    questionTemplatesResource,
    userService
  ) {
    var log = $log.create('questionTemplateService')

    this.create = create
    this.createFromQuestion = createFromQuestion
    this.get = get
    this.find = find
    this.save = save
    this.remove = remove
    this.publishQuestion = publishQuestion
    this.archiveQuestion = archiveQuestion
    this.redraftQuestion = redraftQuestion

    function create(type) {
      return new QuestionTemplate({
        type: type,
        ownerId: userService.getSubscriberId(),
      })
    }

    function createFromQuestion(question) {
      return create(question.type).fromQuestion(question)
    }

    function get(id) {
      return $q(function(resolve, reject) {
        if (!id || id === 'new') {
          return reject()
        }
        var ownerId = userService.getSubscriberId()
        questionTemplatesResource
          .get({ id: id, ownerId: ownerId })
          .success(function(x, response) {
            var questionTemplate = new QuestionTemplate().deserialize(response)
            resolve(questionTemplate)
          })
          .error(function(data, status) {
            reject({ data: data, status: status })
          })
      })
    }

    function find(options) {
      return $q(function(resolve, reject) {
        _.defaults(options, {})
        options.ownerId = userService.getSubscriberId()
        questionTemplatesResource
          .get(options)
          .success(function(x, response) {
            var questionTemplates = _.map(response, function(data) {
              return new QuestionTemplate().deserialize(data)
            })
            resolve(questionTemplates)
          })
          .error(function(data, status) {
            reject({ data: data, status: status })
          })
      })
    }

    function save(questionTemplate) {
      return persist(questionTemplate)
        .then(saveKits)
        .then(refresh)
    }

    function persist(questionTemplate) {
      return $q(function(resolve, reject) {
        var isValid = questionTemplate.validate()
        if (!isValid) {
          return reject({
            errors: true,
            data: {
              message: 'Failed to validate. Please check error message.',
            },
          })
        }

        var data = questionTemplate.serialize()
        var action = data.id ? 'update' : 'create'
        var options = { ownerId: data.ownerId }

        questionTemplatesResource[action](options, data)
          .success(function(x, response) {
            if (response.id) {
              questionTemplate.id = response.id
            }
            resolve(questionTemplate)
          })
          .error(function(data, status) {
            reject({ data: data, status: status })
          })
      })
    }

    function saveKits(questionTemplate) {
      return kitsService
        .assignKitsToQuestionTemplate(
          questionTemplate.id,
          questionTemplate.serverData.kits,
          questionTemplate.kits
        )
        .then(function() {
          return questionTemplate
        })
    }

    function refresh(questionTemplate) {
      return $q(function(resolve, reject) {
        if (!questionTemplate.id) {
          var errorMsg = 'Tried to refresh but template has no id.'
          log.error(errorMsg)
          reject({ data: { message: errorMsg } })
        }
        questionTemplatesResource
          .get({ id: questionTemplate.id })
          .success(function(x, response) {
            questionTemplate.deserialize(response)
            resolve(questionTemplate)
          })
          .error(function(data, status) {
            reject({ data: data, status: status })
          })
      })
    }

    function remove(questionTemplate) {
      return $q(function(resolve, reject) {
        var options = {
          ownerId: userService.getSubscriberId(),
          id: questionTemplate.id,
        }
        questionTemplatesResource
          .delete(options)
          .success(function() {
            resolve()
          })
          .error(reject)
      })
    }

    function publishQuestion(questionTemplate, question) {
      return $q(function(resolve, reject) {
        if (!questionTemplate.canPublishQuestion(question)) {
          return reject()
        }
        var data = {
          templateId: questionTemplate.id,
          questionId: question.id,
        }
        questionTemplatesResource
          .publishQuestion(data)
          .success(function() {
            question.state = Question.States.PUBLISHED
            resolve()
          })
          .error(reject)
      })
    }

    function archiveQuestion(questionTemplate, question) {
      return $q(function(resolve, reject) {
        if (!questionTemplate.canArchiveQuestion(question)) {
          return reject()
        }
        var data = {
          templateId: questionTemplate.id,
          questionId: question.id,
        }
        questionTemplatesResource
          .archiveQuestion(data)
          .success(function() {
            question.state = Question.States.ARCHIVED
            resolve()
          })
          .error(reject)
      })
    }

    function redraftQuestion(questionTemplate, question) {
      return $q(function(resolve, reject) {
        if (!questionTemplate.canRedraftQuestion(question)) {
          return reject()
        }
        var data = {
          templateId: questionTemplate.id,
          questionId: question.id,
        }
        questionTemplatesResource
          .redraftQuestion(data)
          .success(function() {
            question.state = Question.States.DRAFT
            resolve()
          })
          .error(reject)
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["$log", "$q", "glUtils", "Queue", "titleSelector", "glSurveyUtils", "Pipes", "Logic", "Mod", "LogicCondition", "Choice", "OptionPresets", "Lender", "ThemeContext"];
  angular.module('glow.components').factory('Question', Factory)

  /* @ngInject */
  function Factory(
    $log,
    $q,
    glUtils,
    Queue,
    titleSelector,
    glSurveyUtils,
    Pipes,
    Logic,
    Mod,
    LogicCondition,
    Choice,
    OptionPresets,
    Lender,
    ThemeContext
  ) {
    var log = $log.create('Question')
    var IS_TEXT_VALIDATOR = /[\S]+/

    var Types = {
      CHOICE: 'choice',
      RANK: 'rank',
      SINGLE_TEXT: 'singletext',
      SCALE: 'scale',
      TEXT: 'text',
      SCAN: 'scan',
      NPS: 'nps',
      MOOD: 'mood',
      PLACES_NEAR_ME: 'placesnearme',
      LOCATION: 'location',
      IMAGE: 'image',
      FOLLOW_UP: 'followup',
      RATING: 'rating',
      NUMERIC: 'numeric',
      MATRIX: 'matrix',
      CONSTANT_SUM: 'constantsum',
      SCORE: 'score',
      HIDDEN_VARIABLES: 'hiddenvariables',
    }

    // states used for templates
    var States = {
      DRAFT: 'DRAFT',
      PUBLISHED: 'PUBLISHED',
      ARCHIVED: 'ARCHIVED',
    }

    var globalDefaults = {
      choices: [],
      statements: [],
      isCompulsory: true,
      choiceSamplingEnabled: false,
      choiceSamplingAmount: 1,
      statementSamplingEnabled: false,
      statementSamplingAmount: 1,
      flipTableAxis: false,
      matrixUniqueSelection: false,
      omni: null,
      matrixEnabled: false,
      numberMinValue: 0,
      numberMaxValue: 100,
      numberInterval: null,
      textPrefix: null,
      textSuffix: null,
      textExclusiveChoiceEnabled: false,
      textExclusiveChoiceLabel: null,
      randomizeChoices: null,
      randomizeChoiceHeadings: null,
      randomizeStatements: null,
      randomizeStatementHeadings: null,
      locationBiasCountryCode: 'AU',
      locationRestrictCountryCode: null,
      locationType: null,
      locationSearchTerms: null,
      locationShowSearchField: false,
      locationTypesFilter: [],
      locationExcludePrevious: false,
      reference: null,
      choiceMods: [],
      choiceGridColumnMax: null,
    }

    var MatrixDisplayTypes = {
      DEFAULT: 'DEFAULT',
      DROPDOWN: 'DROPDOWN',
      SCALE: 'SCALE',
      CAROUSEL: 'CAROUSEL',
      DND: 'DND',
    }

    // Options for Matrix display type
    var MatrixDisplayTypeOptions = [
      { value: MatrixDisplayTypes.DEFAULT, label: 'Default' },
      { value: MatrixDisplayTypes.DROPDOWN, label: 'Dropdown' },
      { value: MatrixDisplayTypes.SCALE, label: 'Scale' },
      { value: MatrixDisplayTypes.CAROUSEL, label: 'Carousel' },
      { value: MatrixDisplayTypes.DND, label: 'Drag & Drop' },
    ]

    var ConstantSumTotalQuantifiers = {
      NONE: null,
      EQUAL: 'EQUAL',
      LESS_THAN: 'LESS_THAN',
      LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
      GREATER_THAN: 'GREATER_THAN',
      GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
      BETWEEN: 'BETWEEN',
    }

    // Options for Constant Sum total quantifier
    var ConstantSumTotalQuantifierOptions = [
      {
        label: 'None',
        value: ConstantSumTotalQuantifiers.NONE,
      },
      {
        label: 'Must Equal',
        value: ConstantSumTotalQuantifiers.EQUAL,
      },
      {
        label: 'Must be less than',
        value: ConstantSumTotalQuantifiers.LESS_THAN,
      },
      {
        label: 'Must be less than or equal to',
        value: ConstantSumTotalQuantifiers.LESS_THAN_OR_EQUAL,
      },
      {
        label: 'Must be greater than',
        value: ConstantSumTotalQuantifiers.GREATER_THAN,
      },
      {
        label: 'Must be greater than or equal to',
        value: ConstantSumTotalQuantifiers.GREATER_THAN_OR_EQUAL,
      },
      {
        label: 'Must be between',
        value: ConstantSumTotalQuantifiers.BETWEEN,
      },
    ]

    var LocationTypes = {
      DEFAULT: 'DEFAULT',
      PLACES: 'PLACES',
    }

    var ScoreTypes = {
      NTS: 'nts',
      SRS: 'srs',
      CUSTOM: 'custom',
    }

    function Question(options) {
      options = options || {}

      this.id = glUtils.uuid()
      this.type = options.type
      this.isNew = true
      this.errors = []
      this.logic = []
      this.data = {}
      this.queue = options.queue || new Queue()
      this.titlePipes = new Pipes()
      this.descriptionPipes = new Pipes()
      this.constantSumTotalPipes = new Pipes()
      this.constantSumTotalMinPipes = new Pipes()
      this.constantSumTotalMaxPipes = new Pipes()
      this.choiceLender = new Lender()
      this.statementLender = new Lender()
      this.themeContext = new ThemeContext().asQuestionDefault()

      // give templates a default state
      this.isTemplate = options.isTemplate
      if (this.isTemplate) {
        this.state = States.DRAFT
      }

      this.applyDefaults(options)

      if (this.choices && this.choices.length) {
        this.choices = _.map(this.choices, function(choice) {
          return new Choice(choice)
        })
      }
    }

    Question.prototype.applyDefaults = function(options) {
      var typeDefaults
      var info = this.getInfo(this.type)
      if (info) {
        this.label = info.label
        typeDefaults = info.defaults
      }

      // absorb options (if any) making sure to set defaults/required values
      _.defaultsDeep(this, options, typeDefaults, globalDefaults)
    }

    Question.prototype.States = Question.States = States
    Question.prototype.Types = Question.Types = Types
    Question.prototype.MatrixDisplayTypes = Question.MatrixDisplayTypes = MatrixDisplayTypes
    Question.prototype.MatrixDisplayTypeOptions = Question.MatrixDisplayTypeOptions = MatrixDisplayTypeOptions
    Question.prototype.ConstantSumTotalQuantifiers = Question.ConstantSumTotalQuantifiers = ConstantSumTotalQuantifiers
    Question.prototype.ConstantSumTotalQuantifierOptions = Question.ConstantSumTotalQuantifierOptions = ConstantSumTotalQuantifierOptions
    Question.prototype.LocationTypes = Question.LocationTypes = LocationTypes
    Question.prototype.ScoreTypes = Question.ScoreTypes = ScoreTypes
    Question.prototype.getInfo = Question.getInfo = getInfo

    Question.prototype.deserialize = function(data) {
      var self = this

      // keep a copy of the question so it can be sent back to the server when its in a published state....argh
      // keep the question behaviour and type as it is (do not undo)
      if (data.state === States.PUBLISHED) {
        this.originCopy = _.cloneDeep(data)
      }

      // undo backend behaviour changes (until available for all types)
      glSurveyUtils.undoQuestionBehaviours(data)

      // prevent idx/existential problems below
      data.numericTypeConstraint = _.isPlainObject(data.numericTypeConstraint)
        ? data.numericTypeConstraint
        : {}
      data.data = _.isPlainObject(data.data) ? data.data : {}
      data.profiling = _.isPlainObject(data.profiling) ? data.profiling : {}

      // core
      var info = this.getInfo(data.type)
      this.id = data.id
      this.isNew = !data.id
      this.type = data.type
      this.label = info.label
      this.title = data.title.replace(/ \(Optional\)/g, '') // HACK: backend adds ` (Optional)` to optional question titles
      this.titleSelector = data.data.titleSelector
      this.titlePipes.set(this.title)
      this.imageUrl = data.imageUrl
      this.comparisonKey = data.comparisonKey
      this.data = data.data // TODO: deprecate this and make data keys first-class coming in deserialize()
      this.promptMessage = data.promptMessage // TODO: wtf is this for?
      this.isLocked = data.isLocked
      this.isCompulsory = data.isCompulsory
      this.skipText = data.nonCompulsoryText
      this.isHidden = data.isHidden

      // HACK: Types.LOCATION needs to be stored in the BE as Types.TEXT
      // until the BE supports the type first class
      if (data.type === 'text' && data.data.isLocationType) {
        this.type = 'location'
      }

      if (this.usesTitleSelector()) {
        this.title = titleSelector.format(this.titleSelector)
      }

      // logic
      this.logic = _.map(data.data.logic, function(data) {
        return new Logic(self.survey.logicHelpers).deserialize(data)
      })

      // template/from-template
      this.state = this.isTemplate ? data.state || States.DRAFT : undefined
      this.templateId = data.questionTemplateId

      // image
      this.imageLabel = data.data.imageLabel
      this.imageFromLoop = data.data.imageFromLoop

      // choices
      var choices = _.map(data.choices, function(choice) {
        // Some choices have defaults, e.g. mood, nps
        // NOTE: cannot guarantee that choice.option will be the same as the default value. This is ok for now.
        var choiceDefaults = _.find(info.defaults.choices, {
          value: choice.option,
        })
        var val = new Choice(choiceDefaults).deserialize(choice)
        return val
      })
      // check whether images should be enabled (IMPORTANT: before removing borrowed)
      this.choiceImagesEnabled = _.isBoolean(data.data.choiceImagesEnabled)
        ? data.data.choiceImagesEnabled
        : _.some(choices, function(c) {
            return !c.isBorrowed && c.imageUrl
          })
      // remove borrowed choices (they'll get added back on serialize)
      choices = choices.filter(function(choice) {
        return !choice.isBorrowed
      })

      this.choices = _.orderBy(choices, 'order')
      this.minSelections = data.minSelections
      this.maxSelections = data.maxSelections

      this.randomizeChoices = data.data.randomizeChoices
      this.randomizeChoiceHeadings = data.data.randomizeChoiceHeadings
      this.randomizeStatements = data.data.randomizeStatements
      this.randomizeStatementHeadings = data.data.randomizeStatementHeadings

      // choice sampling
      this.choiceSamplingEnabled = data.choiceSamplingEnabled
      this.choiceSamplingAmount = data.choiceSamplingAmount

      // statement sampling
      this.statementSamplingEnabled = data.statementSamplingEnabled
      this.statementSamplingAmount = data.statementSamplingAmount

      // matrix
      this.matrixEnabled = data.data.matrixEnabled
      this.flipTableAxis = data.data.flipTableAxis // IMPORTANT: used by BE to switch matrix export layout (see: https://engagementinnovation.slack.com/archives/C04AXA92V/p1621491750049200?thread_ts=1621487953.044100&cid=C04AXA92V)
      this.matrixUniqueSelection = data.matrixUniqueSelection

      this.choiceLender = new Lender().deserialize(data.data.choiceLender)
      this.statementLender = new Lender().deserialize(data.data.statementLender)

      // statements
      var statements = _.map(data.statements, function(statement) {
        return new Choice({ type: Choice.Types.STATEMENT }).deserialize(
          statement
        )
      })
      // check whether images should be enabled (IMPORTANT: before removing borrowed)
      this.statementImagesEnabled = _.isBoolean(
        data.data.statementImagesEnabled
      )
        ? data.data.statementImagesEnabled
        : _.some(statements, function(s) {
            return !s.isBorrowed && s.imageUrl
          })
      // remove borrowed statements (they'll get added back on serialize)
      statements = statements.filter(function(statement) {
        return !statement.isBorrowed
      })
      this.statements = _.orderBy(statements, 'order')

      // Hide Labels
      this.choiceLabelsHidden = data.data.choiceLabelsHidden
      this.statementLabelsHidden = data.data.statementLabelsHidden

      // placesnearme
      this.isSearchEnabled = data.showSearchField
      this.defaultSearchQuery = data.placesSearchTerms
      this.subscriberIdFilter = data.subscriberIdFilter

      // profiling
      this.profileKey = data.profiling.key
      this.profileAsDimension = data.profiling.submitAsDimension

      // numeric
      this.numericMin = data.numericTypeConstraint.minValue
      this.numericMax = data.numericTypeConstraint.maxValue
      this.numericSteps = data.numericTypeConstraint.steps
      this.numericUnit = data.numericTypeConstraint.unit
      this.numericLabels = data.data.numericLabels || []
      this.numericDiff = data.data.numericDiff
      this.numericDiffLeft = data.data.numericDiffLeft
      this.numericDiffRight = data.data.numericDiffRight

      // single-text
      this.textFieldNumber = data.textFieldNumber
      this.textFieldLabels = _.isArray(data.textFieldLabels)
        ? data.textFieldLabels
        : []
      this.textValidator = data.data.textValidator || null
      this.textNumericMin = data.data.textNumericMin
      this.textNumericMax = data.data.textNumericMax
      this.minAnswers = data.data.minAnswers

      // common
      this.numberMinValue = data.data.numberMinValue
      this.numberMaxValue = data.data.numberMaxValue
      this.numberInterval = data.data.numberInterval
      this.textPrefix = data.data.textPrefix
      this.textSuffix = data.data.textSuffix
      this.textExclusiveChoiceEnabled = data.data.textExclusiveChoiceEnabled
      this.textExclusiveChoiceLabel = data.data.textExclusiveChoiceLabel

      // minimum characters
      this.minCharacters = data.data.minCharacters

      // constant sum
      this.constantSumTotal = data.data.constantSumTotal
      if (_.isString(data.data.constantSumTotal)) {
        this.constantSumTotalPipes.set(this.constantSumTotal)
        this.constantSumTotal = null
      }
      this.constantSumTotalMin = data.data.constantSumTotalMin
      if (_.isString(data.data.constantSumTotalMin)) {
        this.constantSumTotalMinPipes.set(this.constantSumTotalMin)
        this.constantSumTotalMin = null
      }
      this.constantSumTotalMax = data.data.constantSumTotalMax
      if (_.isString(data.data.constantSumTotalMax)) {
        this.constantSumTotalMaxPipes.set(this.constantSumTotalMax)
        this.constantSumTotalMax = null
      }
      this.constantSumTotalQuantifier = data.data.constantSumTotalQuantifier
      this.constantSumShowTotal = data.data.constantSumShowTotal
      this.constantSumStatementRules = _.map(
        data.data.constantSumStatementRules,
        function(rule) {
          return {
            statementId: rule.statementId,
            total: _.isString(rule.total) ? null : rule.total,
            min: _.isString(rule.min) ? null : rule.min,
            max: _.isString(rule.max) ? null : rule.max,
            totalPipes: new Pipes(_.isString(rule.total) ? rule.total : ''),
            minPipes: new Pipes(_.isString(rule.min) ? rule.min : ''),
            maxPipes: new Pipes(_.isString(rule.max) ? rule.max : ''),
          }
        }
      )

      // score
      this.scoreType = data.data.scoreType
      this.scoreLabel = data.data.scoreLabel
      this.scoreDefinition = data.data.scoreDefinition
      this.scoreLeftExtremityLabel = data.data.scoreLeftExtremityLabel
      this.scoreRightExtremityLabel = data.data.scoreRightExtremityLabel

      // Rename scaleTemplate -> presetId
      // These are now used more generically across different question types
      if (this.data.scaleTemplate) {
        this.data.presetId = this.data.scaleTemplate
        delete this.data.scaleTemplate
      }

      // display type
      this.displayType = data.data.displayType

      // location
      this.locationBiasCountryCode = data.data.locationBiasCountryCode
      this.locationRestrictCountryCode = data.data.locationRestrictCountryCode
      this.locationType = data.data.locationType
      this.locationSearchTerms = data.data.locationSearchTerms
      this.locationShowSearchField = data.data.locationShowSearchField
      this.locationTypesFilter = data.data.locationTypesFilter
      this.locationExcludePrevious = data.data.locationExcludePrevious

      // description
      this.description = data.data.description
      this.descriptionPipes.set(this.description)

      // reference
      this.reference = data.reference

      this.omni = data.data.omni

      this.themeContext.asQuestionDefault().deserialize(data.data.themeContext)

      // mods
      var choiceModsData = _.isArray(data.data.choiceMods) ? data.data.choiceMods : [] // prettier-ignore
      this.choiceMods = choiceModsData.map(function(data) {
        return new Mod().deserialize(data)
      })

      this.choiceGridColumnMax = data.data.choiceGridColumnMax

      this.applyDefaults()

      return this
    }

    Question.prototype.getTitleLabel = function(options) {
      options = _.defaults(options, {
        number: false,
        markdown: false,
      })
      var label = this.title || 'Untitled'
      if (options.number) {
        label = 'Q' + this.getNumber() + ': ' + label
      }
      if (options.markdown) {
        label = window.marked(label)
      }
      return label
    }

    Question.prototype.serialize = function(order) {
      var self = this
      var data = {}

      // return the origin copy if its present
      if (self.originCopy && self.state === States.PUBLISHED) {
        return self.originCopy
      }

      // order is required
      if (!_.isNil(order) && !_.isNumber(order)) {
        log.error('question.serialize requires order param of type Number')
      }

      // core
      data.id = self.id
      data.type = self.type
      data.title = self.title
      data.imageUrl = self.imageUrl
      data.comparisonKey = self.comparisonKey
      data.promptMessage = self.promptMessage
      data.isLocked = self.isLocked
      data.isCompulsory = self.isCompulsory
      data.nonCompulsoryText = self.skipText
      data.isHidden = self.isHidden // IMPORTANT: This field is used in the BE to hide export columns that are hidden
      data.order = order

      // ideally this would be initialised as an empty object `{}` and then fields explicitly set underneath
      // but i suspect this may introduce some issues.
      // right now we deep clone this otherwise duplicated questions will get the same reference
      data.data = _.cloneDeep(self.data)

      // HACK: Types.LOCATION needs to be stored in the BE as Types.TEXT
      // until the BE supports the type first class
      if (self.type === 'location') {
        data.type = 'text'
        data.data.isLocationType = true
      }

      if (self.belongsToTemplate()) {
        data.data.titleSelector = titleSelector.parse(self.title)
      } else {
        data.data.titleSelector = angular.copy(self.titleSelector) // removes $$hashKey's
      }

      data.data.logic = _.map(self.logic, function(logic) {
        return logic.serialize()
      })

      // template/from-template
      data.state = self.isTemplate ? self.state : undefined
      data.questionTemplateId = self.templateId

      // image
      data.data.imageLabel = self.imageUrl ? self.imageLabel : undefined
      data.data.imageFromLoop = self.imageFromLoop

      // choices
      data.choices = []
      _.each(self.getBorrowedChoices(true), function(choice) {
        // clone it so as not to modify any origins that it came from.
        choice = choice.realClone()
        // enforce the type to be CHOICE in case it had a STATEMENT origin
        choice.type = Choice.Types.CHOICE
        // stamp it as borrowed so we know to remove on deserialize
        choice.isBorrowed = true
        data.choices.push(choice)
      })
      _.each(self.getLocalChoices(true), function(choice) {
        data.choices.push(choice)
      })
      if (!self.supportsChoiceHeadings()) {
        // when not supported, we discard heading choices
        _.remove(data.choices, function(choice) {
          return choice.isHeading
        })
      }
      data.choices = data.choices.map(function(choice, index) {
        choice.order = index
        return choice.serialize({
          discardImage: !self.choiceImagesEnabled,
        })
      })

      data.minSelections = self.minSelections
      data.maxSelections = self.maxSelections

      data.data.choiceImagesEnabled = this.choiceImagesEnabled
      data.data.statementImagesEnabled = this.statementImagesEnabled

      data.data.randomizeChoices = this.randomizeChoices
      data.data.randomizeChoiceHeadings = this.randomizeChoiceHeadings
      data.data.randomizeStatements = this.randomizeStatements
      data.data.randomizeStatementHeadings = this.randomizeStatementHeadings

      // Hide Labels
      data.data.choiceLabelsHidden = this.choiceImagesEnabled
        ? this.choiceLabelsHidden
        : false
      data.data.statementLabelsHidden = this.statementImagesEnabled
        ? this.statementLabelsHidden
        : false

      // choice sampling
      data.choiceSamplingEnabled = this.choiceSamplingEnabled
      data.choiceSamplingAmount = this.choiceSamplingAmount

      // statement sampling
      data.statementSamplingEnabled = this.statementSamplingEnabled
      data.statementSamplingAmount = this.statementSamplingAmount

      // matrix
      data.data.matrixEnabled = this.matrixEnabled
      data.data.flipTableAxis = this.flipTableAxis
      data.matrixUniqueSelection = this.matrixUniqueSelection

      data.data.choiceLender = this.choiceLender.serialize()
      data.data.statementLender = this.statementLender.serialize()

      // statements
      data.statements = []
      _.each(self.getBorrowedStatements(true), function(statement) {
        // clone it so as not to modify any origins that it came from.
        statement = statement.realClone()
        // enforce the type to be STATEMENTS in case it had a CHOICE origin
        statement.type = Choice.Types.STATEMENT
        // stamp it as borrowed so we know to remove on deserialize
        statement.isBorrowed = true
        data.statements.push(statement)
      })
      _.each(self.getLocalStatements(true), function(statement) {
        data.statements.push(statement)
      })
      if (!self.supportsStatementHeadings()) {
        // when not supported, we discard heading choices
        _.remove(data.statements, function(statement) {
          return statement.isHeading
        })
      }
      data.statements = data.statements.map(function(statement, index) {
        statement.order = index
        return statement.serialize({
          discardImage: !self.statementImagesEnabled,
        })
      })

      // backend rely on statements to determine if matrix enabled for non-matrix question types
      // so we ensure statements are empty if matrix is disabled
      if (!this.isUsedAsMatrix()) {
        _.remove(data.statements)
      }

      // option presets
      if (this.data.presetId) {
        data.data.presetId = this.data.presetId
      }

      // placesnearme
      data.showSearchField = self.isSearchEnabled
      data.placesSearchTerms = self.defaultSearchQuery
      data.subscriberIdFilter = self.subscriberIdFilter

      // profiling
      if (self.profileKey) {
        data.profiling = {}
        data.profiling.key = self.profileKey
        data.profiling.submitAsDimension = !!self.profileAsDimension
      }

      // numeric
      if (self.type === Types.NUMERIC) {
        data.numericTypeConstraint = {}
        data.numericTypeConstraint.minValue = self.numericMin
        data.numericTypeConstraint.maxValue = self.numericMax
        data.numericTypeConstraint.steps = self.numericSteps
        data.numericTypeConstraint.unit = self.numericUnit
        data.data.numericLabels = self.numericLabels
        data.data.numericDiff = self.numericDiff
        data.data.numericDiffLeft = self.numericDiffLeft
        data.data.numericDiffRight = self.numericDiffRight
      }

      if (self.type === Types.SINGLE_TEXT) {
        data.textFieldNumber = this.textFieldNumber
        data.textFieldLabels = _.isArray(this.textFieldLabels)
          ? this.textFieldLabels
          : []
        data.data.textValidator = this.textValidator
        data.data.textNumericMin = this.textNumericMin
        data.data.textNumericMax = this.textNumericMax
        data.data.minAnswers = this.minAnswers
      }

      // common
      data.data.numberMinValue = this.numberMinValue
      data.data.numberMaxValue = this.numberMaxValue
      data.data.numberInterval = this.numberInterval
      data.data.textPrefix = this.textPrefix
      data.data.textSuffix = this.textSuffix
      data.data.textExclusiveChoiceEnabled = this.textExclusiveChoiceEnabled
      data.data.textExclusiveChoiceLabel = this.textExclusiveChoiceLabel

      // minimum characters
      data.data.minCharacters = this.minCharacters

      // constant sum
      data.data.constantSumTotal = this.constantSumTotalPipes.string
        ? this.constantSumTotalPipes.string
        : this.constantSumTotal
      data.data.constantSumTotalMin = this.constantSumTotalMinPipes.string
        ? this.constantSumTotalMinPipes.string
        : this.constantSumTotalMin
      data.data.constantSumTotalMax = this.constantSumTotalMaxPipes.string
        ? this.constantSumTotalMaxPipes.string
        : this.constantSumTotalMax
      data.data.constantSumTotalQuantifier = this.constantSumTotalQuantifier
      data.data.constantSumShowTotal = this.constantSumShowTotal
      data.data.constantSumStatementRules = _.map(
        this.constantSumStatementRules,
        function(rule) {
          return {
            statementId: rule.statementId,
            total: rule.totalPipes.string || rule.total,
            min: rule.minPipes.string || rule.min,
            max: rule.maxPipes.string || rule.max,
          }
        }
      )

      // score
      data.data.scoreType = this.scoreType
      data.data.scoreLabel = this.scoreLabel
      data.data.scoreDefinition = this.scoreDefinition
      data.data.scoreLeftExtremityLabel = this.scoreLeftExtremityLabel
      data.data.scoreRightExtremityLabel = this.scoreRightExtremityLabel

      // re-add backend behaviour changes (until available for all types)
      glSurveyUtils.redoQuestionBehaviours(data)

      // display type
      data.data.displayType = self.displayType

      // location
      data.data.locationBiasCountryCode = this.locationBiasCountryCode
      data.data.locationRestrictCountryCode = this.locationRestrictCountryCode
      data.data.locationType = this.locationType
      data.data.locationSearchTerms = this.locationSearchTerms
      data.data.locationShowSearchField = this.locationShowSearchField
      data.data.locationTypesFilter = this.locationTypesFilter
      data.data.locationExcludePrevious = this.locationExcludePrevious

      // description
      data.data.description = self.description

      // reference
      data.reference = self.reference

      data.data.omni = _.cloneDeep(self.omni)

      data.data.themeContext = this.themeContext.serialize()

      this.invalidateChoiceMods()
      data.data.choiceMods = this.choiceMods.map(function(mod) {
        return mod.serialize()
      })

      data.data.choiceGridColumnMax = this.choiceGridColumnMax

      return data
    }

    Question.prototype.refresh = function(getId) {
      this.idOld = this.id
      this.id = getId ? getId(this.idOld) : glUtils.uuid()
      this.isNew = true

      _.each(this.choices, function(choice) {
        choice.refresh(getId)
      })

      _.each(this.statements, function(statement) {
        statement.refresh(getId)
      })
    }

    Question.prototype.unTemplate = function(templateId) {
      this.refresh()
      this.templateId = templateId || this.templateId
      this.setTitleSelector()
    }

    Question.prototype.setTitleSelector = function() {
      this.titleSelector = titleSelector.parse(this.title)

      if (this.usesTitleSelector()) {
        this.title = titleSelector.format(this.titleSelector)
      }
    }

    Question.prototype.validate = function(questionNumber) {
      var self = this
      var types = Question.Types
      var isValid = true
      this.errors.splice(0, this.errors.length) // clear errors

      if (!this.title) {
        this.errors.push('Question title is required')
        isValid = false
      }

      if (
        !_.isNil(this.minSelections) &&
        (!_.isNumber(this.minSelections) || this.minSelections < -1)
      ) {
        this.errors.push(
          'The minimum selections amount must be a positive number'
        )
        isValid = false
      }

      if (
        !_.isNil(this.maxSelections) &&
        (!_.isNumber(this.maxSelections) || this.maxSelections < 0)
      ) {
        this.errors.push(
          'The maximum selections amount must be a positive number'
        )
        isValid = false
      }

      if (
        _.isNumber(this.minSelections) &&
        this.minSelections > 0 &&
        (_.isNumber(this.maxSelections) && this.maxSelections > 0) &&
        this.minSelections > this.maxSelections
      ) {
        this.errors.push(
          'The minimum selections amount cannot be greater than maximum selections'
        )
        isValid = false
      }

      if (
        _.isNumber(this.minSelections) &&
        this.minSelections > this.getAllChoices().length
      ) {
        this.errors.push(
          'The minimum selections amount cannot be greater than the amount of choices you have'
        )
        isValid = false
      }

      // validate title pipes
      _.each(this.titlePipes.pipes, function(pipe) {
        var number = pipe.directives[0].number
        if (number >= questionNumber) {
          self.errors.push(
            'Title contains invalid pipe: ' +
              pipe.string +
              ' (must be before current question)'
          )
          isValid = false
        }
      })

      // validate description pipes
      _.each(this.descriptionPipes.pipes, function(pipe) {
        var number = pipe.directives[0].number
        var questionType = pipe.directives[0].type === Pipes.Directives.QUESTION
        if (questionType && number >= questionNumber) {
          self.errors.push(
            'Description contains invalid pipe: ' +
              pipe.string +
              ' (must be before current question)'
          )
          isValid = false
        }
      })

      var isChoiceType = this.isType([
        types.CHOICE,
        types.SCALE,
        types.RANK,
        types.MATRIX,
        types.CONSTANT_SUM,
        types.SCORE,
        types.HIDDEN_VARIABLES,
      ])
      if (isChoiceType) {
        var localChoices = this.getLocalChoices()
        var borrowedChoices = this.getBorrowedChoices()
        var allChoices = this.getAllChoices(true) // include headings

        // empty local labels
        var hasEmptyLabels = _.some(localChoices, function(choice) {
          return !choice.value
        })
        if (hasEmptyLabels) {
          this.errors.push('Choices must have labels')
          return false // immediately invalidate
        }

        // ensure at least 2 visible choices exist.
        // swallow the error if borrowing as the lender should
        // report the error
        if (!borrowedChoices.length) {
          var visibleChoices = this.getVisibleChoices()
          if (visibleChoices.length < 2) {
            this.errors.push('At least two visible choices are required')
            isValid = false
          }
        }

        // ensure choices are unique including choice headings
        var uniqueChoices = _.uniqBy(allChoices, function(choice) {
          return choice.value
        })
        if (allChoices.length !== uniqueChoices.length) {
          this.errors.push('Choices must have unique names')
          isValid = false
        }

        // validate choice sampling
        if (
          this.choiceSamplingEnabled &&
          (!_.isNumber(this.choiceSamplingAmount) ||
            this.choiceSamplingAmount < 1 ||
            this.choiceSamplingAmount > uniqueChoices.length - 1)
        ) {
          this.errors.push(
            'Choices sampled must be more than 1 and less than the number of choices available'
          )
          isValid = false
        }

        // validate choice lender
        if (
          !this.isTemplate &&
          !this.choiceLender.validate(this.survey, this.id, this.getNumber())
        ) {
          this.errors = _.concat(this.errors, this.choiceLender.errors)
          isValid = false
        }
      }

      if (this.isUsedAsMatrix()) {
        var localStatements = this.getLocalStatements()
        var borrowedStatements = this.getBorrowedStatements()
        var allStatements = this.getAllStatements()

        // empty local labels
        var hasEmptyLabels = _.some(localStatements, function(statement) {
          return !statement.value
        })
        if (hasEmptyLabels) {
          this.errors.push('Statements must have labels')
          return false // immediately invalidate
        }

        // ensure at least 2 visible statements exist.
        // swallow the error if borrowing as the lender should
        // report the error
        if (!borrowedStatements.length) {
          // here
          var visibleStatements = this.getVisibleStatements()
          if (visibleStatements.length < 2) {
            this.errors.push('At least two visible statements are required')
            isValid = false
          }
        }

        // ensure statements are unique
        var uniqueStatements = _.uniqBy(allStatements, function(statement) {
          return statement.value
        })
        if (allStatements.length !== uniqueStatements.length) {
          this.errors.push('Statements must have unique names')
          isValid = false
        }

        // validate statement sampling
        if (
          this.statementSamplingEnabled &&
          (!_.isNumber(this.statementSamplingAmount) ||
            this.statementSamplingAmount < 1 ||
            this.statementSamplingAmount > uniqueStatements.length - 1)
        ) {
          this.errors.push(
            'Statements sampled must be more than 1 and less than the number of statements available'
          )
          isValid = false
        }

        // validate unique selection
        if (this.matrixUniqueSelection) {
          if (
            this.getAllChoices().length < allStatements.length &&
            !this.choiceSamplingEnabled &&
            !this.statementSamplingEnabled
          ) {
            this.errors.push(
              'Choices must be greater than or equal to number of statements available when unique selection is enabled'
            )
            isValid = false
          }

          if (
            !this.statementSamplingEnabled &&
            this.choiceSamplingEnabled &&
            _.isNumber(this.choiceSamplingAmount) &&
            this.choiceSamplingAmount < allStatements.length
          ) {
            this.errors.push(
              'Choices sampled must be greater than or equal to number of statements available when unique selection is enabled'
            )
            isValid = false
          }

          if (
            !this.choiceSamplingEnabled &&
            this.statementSamplingEnabled &&
            _.isNumber(this.statementSamplingAmount) &&
            this.statementSamplingAmount > this.getAllChoices().length
          ) {
            this.errors.push(
              'Statements sampled must be less than or equal to number of choices available when unique selection is enabled'
            )
            isValid = false
          }

          if (
            this.choiceSamplingEnabled &&
            _.isNumber(this.choiceSamplingAmount) &&
            this.statementSamplingEnabled &&
            _.isNumber(this.statementSamplingAmount) &&
            this.choiceSamplingAmount < this.statementSamplingAmount
          ) {
            this.errors.push(
              'Choices sampled must be greater than or equal to number of statements sampled when unique selection is enabled'
            )
            isValid = false
          }
        }

        // validate statement lender
        if (
          !this.isTemplate &&
          !this.statementLender.validate(this.survey, this.id, this.getNumber())
        ) {
          this.errors = _.concat(this.errors, this.statementLender.errors)
          isValid = false
        }
      }

      var numericErrors = this.getNumericErrors()
      if (numericErrors.length) {
        while (numericErrors.length) {
          this.errors.push(numericErrors.pop())
        }
        isValid = false
      }

      // logic
      try {
        _.each(self.logic, function(logic) {
          if (!logic.validate()) {
            // console.log('ERR', logic.errors)
            _.each(logic.errors, function(err) {
              self.errors.push(err)
            })
            isValid = false
            return false
          }
        })
      } catch (error) {
        console.error(error)
      }

      // single text
      if (this.type === Types.SINGLE_TEXT) {
        if (
          !_.isNumber(this.textFieldNumber) ||
          this.textFieldNumber < 1 ||
          this.textFieldNumber > 50
        ) {
          this.errors.push('Number of fields must be from 1 to 50')
          isValid = false
        }

        if (!_.isNumber(this.minAnswers) || this.minAnswers < 1) {
          this.errors.push('Minimum required fields must be a positive number')
          isValid = false
        }

        if (
          _.isNumber(this.minAnswers) &&
          this.minAnswers > 0 &&
          (_.isNumber(this.textFieldNumber) && this.textFieldNumber > 0) &&
          this.minAnswers > this.textFieldNumber
        ) {
          this.errors.push(
            'Minimum required fields cannot be greater than the number of fields'
          )
          isValid = false
        }

        var labelsEnabled =
          _.isArray(this.textFieldLabels) && this.textFieldLabels.length > 0
        if (labelsEnabled) {
          var labels = this.textFieldLabels
          var hasBlankLabel = _.some(_.range(this.textFieldNumber), function(
            i
          ) {
            var label = labels[i]
            return !_.isString(label) || label.trim() === ''
          })
          if (hasBlankLabel) {
            this.errors.push('All field labels must be filled in')
            isValid = false
          }
        }
      }

      var isMinCharacters =
        (this.type === Types.SINGLE_TEXT && !this.textValidator) ||
        this.type === Types.TEXT
      if (
        isMinCharacters &&
        !_.isNil(this.minCharacters) &&
        (!_.isNumber(this.minCharacters) || this.minCharacters < 1)
      ) {
        this.errors.push(
          'The minimum characters amount must be a positive number'
        )
        isValid = false
      }

      // validate minimum number value
      if (_.isNil(this.numberMinValue) || !_.isNumber(this.numberMinValue)) {
        this.errors.push('Mininum value must be a number and cannot be empty')
        isValid = false
      }

      // validate maximum number value
      if (_.isNil(this.numberMaxValue) || !_.isNumber(this.numberMaxValue)) {
        this.errors.push('Maximum value must be a number and cannot be empty')
        isValid = false
      }

      // validate mininum must be less than maximum number value
      if (
        _.isNumber(this.numberMinValue) &&
        _.isNumber(this.numberMaxValue) &&
        this.numberMinValue > this.numberMaxValue
      ) {
        this.errors.push(
          'The minimum value cannot be greater than maximum value'
        )
        isValid = false
      }

      // validate interval number value
      if (
        !_.isNil(this.numberInterval) &&
        (!_.isNumber(this.numberInterval) || this.numberInterval < 0)
      ) {
        this.errors.push('Interval must be a positive number')
        isValid = false
      }

      // validate constant sum Total Required
      var totalPipes = []
      if (
        this.constantSumTotalQuantifier &&
        this.constantSumTotalQuantifier !==
          this.ConstantSumTotalQuantifiers.BETWEEN
      ) {
        totalPipes.push(this.constantSumTotalPipes)

        if (
          !this.constantSumTotalPipes.string &&
          (_.isNil(this.constantSumTotal) || !_.isNumber(this.constantSumTotal))
        ) {
          this.errors.push(
            'Total required value must be a valid number and cannot be empty'
          )
          isValid = false
        }
      }
      if (
        this.constantSumTotalQuantifier &&
        this.constantSumTotalQuantifier ===
          this.ConstantSumTotalQuantifiers.BETWEEN
      ) {
        totalPipes.push(this.constantSumTotalMinPipes)
        totalPipes.push(this.constantSumTotalMaxPipes)

        if (
          !this.constantSumTotalMinPipes.string &&
          (_.isNil(this.constantSumTotalMin) ||
            !_.isNumber(this.constantSumTotalMin))
        ) {
          this.errors.push(
            'Total required [minimum] value must be a valid number and cannot be empty'
          )
          isValid = false
        }
        if (
          !this.constantSumTotalMaxPipes.string &&
          (_.isNil(this.constantSumTotalMax) ||
            !_.isNumber(this.constantSumTotalMax))
        ) {
          this.errors.push(
            'Total required [maximum] value must be a valid number and cannot be empty'
          )
          isValid = false
        }
        if (
          !this.constantSumTotalMinPipes.string &&
          !this.constantSumTotalMaxPipes.string &&
          _.isNumber(this.constantSumTotalMin) &&
          _.isNumber(this.constantSumTotalMax) &&
          this.constantSumTotalMin >= this.constantSumTotalMax
        ) {
          this.errors.push(
            'Total required [minimum] value cannot be greater than or equal to total required [maximum] value'
          )
          isValid = false
        }
      }
      if (
        this.matrixEnabled &&
        this.constantSumTotalQuantifier &&
        this.constantSumStatementRules.length
      ) {
        _.each(this.constantSumStatementRules, function(rule) {
          if (
            self.constantSumTotalQuantifier !==
            self.ConstantSumTotalQuantifiers.BETWEEN
          ) {
            totalPipes.push(rule.totalPipes)

            if (
              !rule.totalPipes.string &&
              (_.isNil(rule.total) || !_.isNumber(rule.total))
            ) {
              self.errors.push(
                'Total required value must be a valid number and cannot be empty'
              )
              isValid = false
            }
          } else {
            totalPipes.push(rule.minPipes)
            totalPipes.push(rule.maxPipes)

            if (
              !rule.minPipes.string &&
              (_.isNil(rule.min) || !_.isNumber(rule.min))
            ) {
              self.errors.push(
                'Total required [minimum] value must be a valid number and cannot be empty'
              )
              isValid = false
            }
            if (
              !rule.maxPipes.string &&
              (_.isNil(rule.max) || !_.isNumber(rule.max))
            ) {
              this.errors.push(
                'Total required [maximum] value must be a valid number and cannot be empty'
              )
              isValid = false
            }
            if (
              !rule.minPipes.string &&
              !rule.maxPipes.string &&
              _.isNumber(rule.min) &&
              _.isNumber(rule.max) &&
              rule.min >= rule.max
            ) {
              this.errors.push(
                'Total required [minimum] value cannot be greater than or equal to total required [maximum] value'
              )
              isValid = false
            }
          }
        })
      }
      _.each(totalPipes, function(totalPipe) {
        if (!totalPipe.string) return // continue

        if (!totalPipe.pipes.length) {
          self.errors.push(
            'Total required contains invalid pipe: ' +
              totalPipe.string +
              ' (must use correct pipe format eg "Q1#1" OR "Q1SUM1")'
          )
          isValid = false
        } else if (totalPipe.pipes.length > 1) {
          self.errors.push('Total required can only have single pipe')
          isValid = false
        } else {
          _.each(totalPipe.pipes, function(pipe) {
            // should check the correct use of directive #
            var number = pipe.directives[0].number
            if (number >= questionNumber) {
              self.errors.push(
                'Total required contains invalid pipe: ' +
                  pipe.string +
                  ' (must be before current question)'
              )
              isValid = false
            }
            if (
              !pipe.directives[0].onlyNumberEntry &&
              !pipe.directives[0].onlySumEntry
            ) {
              self.errors.push(
                'Total required contains invalid pipe: ' +
                  pipe.string +
                  ' (must use numeric directive eg "Q' +
                  number +
                  '#1" OR "Q' +
                  number +
                  'SUM1" )'
              )
              isValid = false
            }
          })
        }
      })

      // validate score
      if (this.type === Types.SCORE) {
        _.each(this.getVisibleChoices(), function(choice) {
          if (choice.isIndependent) return // skip
          if (!_.isNumber(choice.score)) {
            self.errors.push(
              'Choice "' + choice.value + '" score cannot be empty'
            )
            isValid = false
          }
        })
      }

      // validate exclusive text choice
      var isTextExclusiveChoiceType = this.isType([
        Types.SINGLE_TEXT,
        Types.TEXT,
      ])
      if (isTextExclusiveChoiceType && this.textExclusiveChoiceEnabled) {
        var textExclusiveChoiceLabel = _.trim(this.textExclusiveChoiceLabel)
        if (!textExclusiveChoiceLabel) {
          self.errors.push('Text Exclusive Choice label cannot be empty')
          isValid = false
        }
        if (
          !_.isNil(this.minCharacters) &&
          textExclusiveChoiceLabel &&
          textExclusiveChoiceLabel.length < this.minCharacters
        ) {
          self.errors.push(
            'Text Exclusive Choice label length must meet the min characters rule'
          )
          isValid = false
        }
        if (!!this.textValidator) {
          self.errors.push(
            'Text Exclusive Choice can\'t be enabled for Validator other than "Text"'
          )
          isValid = false
        }
      }

      return isValid
    }

    Question.prototype.getNumericErrors = function() {
      var errors = []
      if (this.isType(Question.Types.NUMERIC)) {
        var isMinNumber = _.isNumber(this.numericMin)
        var isMaxNumber = _.isNumber(this.numericMax)

        // min/max must be a number
        if (!isMinNumber || !isMaxNumber) {
          errors.push('Start and End must be specified')
        }

        // max must be greater than min
        if (this.numericMin >= this.numericMax) {
          errors.push('End must be greater than Start')
        }

        // must be at least three steps
        if (this.numericSteps < 3) {
          errors.push('There must be at least 3 Steps')
        }

        // differential
        if (
          this.numericDiff &&
          (!this.numericDiffLeft || !this.numericDiffRight)
        ) {
          errors.push('Semantic differential requires both left and right text')
        }

        // custom choices
        if (this.numericLabels && this.numericLabels.length) {
          var choices = _.filter(this.numericLabels, _.isString)
          if (_.uniq(choices).length !== choices.length) {
            errors.push('Custom choices must have unique names')
          }
        }
      }
      return errors
    }

    Question.prototype.supportsChoiceHeadings = function() {
      if (this.isType(Types.MATRIX)) {
        if (this.displayType === this.MatrixDisplayTypes.DEFAULT) {
          return !!this.flipTableAxis
        }
        return false
      }
      return this.isType([Types.CHOICE, Types.RANK])
    }

    Question.prototype.supportsStatementHeadings = function() {
      if (this.isType(Types.MATRIX)) {
        if (this.displayType === this.MatrixDisplayTypes.DEFAULT) {
          return !this.flipTableAxis
        }
        if (this.displayType === this.MatrixDisplayTypes.DND) {
          return false
        }
        return true
      }
      return false
    }

    Question.prototype.getBorrowed = function(
      target,
      includeHeadings,
      checked
    ) {
      // loop protection
      if (!checked) {
        checked = {}
      }
      if (checked[this.id]) {
        console.error(
          'Question.getBorrowed has hit infinite loop (questionId:' +
            this.id +
            ')'
        )
        return []
      }
      checked[this.id] = true
      // get the choices
      var lender =
        target === 'STATEMENTS' ? this.statementLender : this.choiceLender
      if (!lender.id) return []
      var parent = this.survey.getQuestion(lender.id)
      if (!parent) {
        console.error(
          'Question.getBorrowed parent does not exist (questionId:' +
            this.id +
            ')'
        )
        return []
      }
      var choices =
        lender.target === 'STATEMENTS'
          ? parent.getLocalStatements(includeHeadings)
          : parent.getLocalChoices(includeHeadings)
      choices = parent
        .getBorrowed(lender.target, includeHeadings, checked)
        .concat(choices)
      // remove isCapture and isExclusive
      choices = _.filter(choices, function(choice) {
        return !choice.isCapture && !choice.isExclusive
      })
      // remove exclusions
      choices = _.filter(choices, function(choice) {
        return !_.includes(lender.exclusionIds, choice.id)
      })
      return choices
    }

    Question.prototype.getBorrowedChoices = function(includeHeadings) {
      return this.getBorrowed('CHOICES', includeHeadings)
    }

    Question.prototype.getLocalChoices = function(includeHeadings) {
      // returns all local choices
      // never modifies arrays and returns an immutable one
      return this.choices.filter(function(choice) {
        return includeHeadings ? true : !choice.isHeading
      })
    }

    Question.prototype.getAllChoices = function(includeHeadings) {
      // returns borrowed choices + local choices
      // never modifies arrays and returns an immutable one
      var choices = this.getBorrowedChoices(includeHeadings)
      this.getLocalChoices(includeHeadings).forEach(function(choice) {
        choices.push(choice)
      })
      return choices
    }

    Question.prototype.getProjectedChoices = function(includeHeadings) {
      // returns borrowed choices + local choices WITHOUT capture/exclusive/excluded
      // never modifies arrays and returns an immutable one
      var choices = this.getAllChoices(includeHeadings)
      // remove isCapture and isExclusive
      choices = _.filter(choices, function(choice) {
        return !choice.isCapture && !choice.isExclusive
      })
      return choices
    }

    Question.prototype.getVisibleChoices = function(includeHeadings) {
      // returns all visible choices
      // never modifies arrays and returns an immutable one
      return _.reject(this.getAllChoices(includeHeadings), { isHidden: true })
    }

    Question.prototype.getBorrowedStatements = function(includeHeadings) {
      return this.getBorrowed('STATEMENTS', includeHeadings)
    }

    Question.prototype.getLocalStatements = function(includeHeadings) {
      // returns all local statements
      // never modifies arrays and returns an immutable one
      if (!this.statements) return []
      return this.statements.filter(function(statement) {
        return includeHeadings ? true : !statement.isHeading
      })
    }

    Question.prototype.getAllStatements = function(includeHeadings) {
      // returns borrowed statements + local statements
      // never modifies arrays and returns an immutable one
      var statements = this.getBorrowedStatements(includeHeadings)
      this.getLocalStatements(includeHeadings).forEach(function(statement) {
        statements.push(statement)
      })
      return statements
    }

    Question.prototype.getProjectedStatements = function(includeHeadings) {
      // returns borrowed statements + local statements WITHOUT capture/exclusive/excluded
      // never modifies arrays and returns an immutable one
      var statements = this.getAllStatements(includeHeadings)
      // remove isCapture and isExclusive
      statements = _.filter(statements, function(statement) {
        return !statement.isCapture && !statement.isExclusive
      })
      return statements
    }

    Question.prototype.getVisibleStatements = function(includeHeadings) {
      // returns all visible statements
      // never modifies arrays and returns an immutable one
      return _.reject(this.getAllStatements(includeHeadings), {
        isHidden: true,
      })
    }

    Question.prototype.getNumberOfRanks = function() {
      return _.isNumber(this.maxSelections)
        ? this.maxSelections
        : this.getAllChoices().length
    }

    Question.prototype.getNumber = function() {
      return this.view.getNumber()
    }

    Question.prototype.getViewGroup = function() {
      return this.survey && this.survey.getViewGroupByViewId(this.id)
    }

    Question.prototype.getPrevQuestions = function() {
      return this.survey.getQuestionsBefore(this.id)
    }

    Question.prototype.getNextQuestions = function() {
      return this.survey.getQuestionsAfter(this.id)
    }

    Question.prototype.getNextSections = function() {
      return this.survey.getSectionsAfter(this.id)
    }

    Question.prototype.isFirst = function() {
      return this.survey && this.survey.isFirstQuestion(this)
    }

    Question.prototype.isLast = function() {
      return this.survey && this.survey.isLastQuestion(this)
    }

    Question.prototype.borrowChoicesFrom = function(questionId, asStatements) {
      // IMPORTANT: a sister piece of code for this exists in ViewGroup.borrowLoopVariablesFrom
      var lenderQuestion = this.survey.getQuestion(questionId)
      var lender = asStatements ? this.statementLender : this.choiceLender
      lender.clear()
      if (lenderQuestion) {
        lender.id = lenderQuestion.id
        // if its not matrix it will target choices
        if (!lenderQuestion.isUsedAsMatrix()) {
          lender.target = lender.Target.CHOICES
        }
      }
    }

    Question.prototype.copyChoicesFrom = function(
      questionId,
      target,
      asStatements
    ) {
      // IMPORTANT: a sister piece of code for this exists in ViewGroup.copyLoopVariablesFrom
      var question = this.survey.getQuestion(questionId)
      if (!question) return

      var choicesOrStatements =
        target === 'STATEMENTS'
          ? question.getAllStatements(true)
          : question.getAllChoices(true)

      if (asStatements) {
        this.statementLender.clear()
        this.statements = choicesOrStatements.map(function(choice) {
          choice = choice.clone() // not a real clone, gives new ID
          choice.type = Choice.Types.STATEMENT
          return choice
        })
      } else {
        this.choiceLender.clear()
        this.choices = choicesOrStatements.map(function(choice) {
          choice = choice.clone() // not a real clone, gives new ID
          choice.type = Choice.Types.CHOICE
          return choice
        })
      }
    }

    Question.prototype.addChoice = function(newChoice, atIndex, shouldReplace) {
      newChoice = new Choice(newChoice)
      newChoice.type = Choice.Types.CHOICE

      if (!_.isNumber(atIndex)) {
        atIndex = this.choices.length
      }

      if (shouldReplace) {
        this.choices[atIndex] = newChoice
      } else {
        this.choices.splice(atIndex, 0, newChoice)
      }
      return newChoice
    }

    Question.prototype.addStatement = function(
      newStatement,
      atIndex,
      shouldReplace
    ) {
      newStatement = new Choice(newStatement)
      newStatement.type = Choice.Types.STATEMENT

      if (!_.isNumber(atIndex)) {
        atIndex = this.statements.length
      }

      if (shouldReplace) {
        this.statements[atIndex] = newStatement
      } else {
        this.statements.splice(atIndex, 0, newStatement)
      }
      return newStatement
    }

    Question.prototype.addChoiceDisplayLogicWithTags = function(choice, tags) {
      tags = _.isArray(tags) ? tags : [tags]
      var logic = new Logic(this.survey.logicHelpers)
      logic.type = Logic.Types.DISPLAY
      if (choice.type === Choice.Types.CHOICE) {
        logic.target = Logic.Targets.CHOICES
        logic.choiceIds.push(choice.id)
      } else {
        logic.target = Logic.Targets.STATEMENTS
        logic.statementIds.push(choice.id)
      }
      logic.setup()
      var condition = logic.conditions[0]
      condition.type = LogicCondition.Types.IS_TAGGED
      condition.selectionQuantifier = LogicCondition.SelectionQuantifiers.ANY
      condition.tags = tags
      this.logic.push(logic)
    }

    /**
     * @name Clone
     * @desc makes a clone of this question
     * @param {Object} options - The options to preserve some keys
     * @param {Bool} options.id - Preserve the question id
     * @param {Bool} options.choiceIds - Preserve the choice id's
     * @param {Bool} options.comparisonKey - Preserve comparison key
     * @returns {Question} question The clone
     */
    // TODO: are the id and choiceIds options being used?
    Question.prototype.clone = function(options) {
      var self = this
      options = options || {}

      var question = new Question({
        survey: self.survey,
        queue: self.queue,
      }).deserialize(self.serialize())

      if (!options.id) {
        question.id = glUtils.uuid()
      }

      // cloned question has to be set to new so that
      // it's not restricted for editing or remove
      question.isNew = true
      question.isLocked = false

      question.templateId = null
      question.isTemplate = false

      if (!options.comparisonKey) {
        question.comparisonKey = null
      }

      // remove hidden choices
      _.remove(question.choices, { isHidden: true })

      // remove hidden statements
      _.remove(question.statements, { isHidden: true })

      if (!options.choiceIds) {
        question.choices = _.map(question.choices, function(choice) {
          return choice.clone()
        })
      }

      if (!options.statementIds) {
        question.statements = _.map(question.statements, function(statement) {
          return statement.clone()
        })
      }

      /**
       * When cloning logic, any conditions that self-reference this
       * question will be rebound to the newly cloned question.
       * (maintains self-referencing)
       */
      var newIds = {
        // [oldId]: newId
      }
      // IMPORTANT: [ES5] function declarations cannot be nested inside of an if block
      // Refernce : https://stackoverflow.com/a/10069457/5731688
      function getId(oldId, getOnly) {
        // if there is no id don't re-assign
        if (!oldId) return oldId
        // safeguard for rebinding old references
        if (!newIds[oldId] && getOnly) {
          return oldId
        }
        // generate one if it hasn't been generated yet
        if (!newIds[oldId]) {
          newIds[oldId] = glUtils.uuid()
        }
        return newIds[oldId]
      }
      if (options.cloneLogic) {
        newIds[self.id] = question.id
        _.each(question.choices, function(choice) {
          var originalChoice = _.find(self.choices, { value: choice.value })
          var choiceIdOld = originalChoice && originalChoice.id
          if (!choiceIdOld) return
          newIds[choiceIdOld] = choice.id
        })
        _.each(question.statements, function(statement) {
          var originalStatement = _.find(self.statements, {
            value: statement.value,
          })
          var statementIdOld = originalStatement && originalStatement.id
          if (!statementIdOld) return
          newIds[statementIdOld] = statement.id
        })
        question.logic = _.map(question.logic, function(logic) {
          return logic.clone().refresh(getId)
        })
      } else {
        question.logic = []
      }

      return question
    }

    Question.prototype.isType = function(type) {
      if (_.isArray(type)) {
        return _.includes(type, this.type)
      }
      return type === this.type
    }

    Question.prototype.isNumericType = function() {
      return (
        this.type === Types.NUMERIC ||
        this.type === Types.CONSTANT_SUM ||
        (this.type === Types.SINGLE_TEXT &&
          _.includes(['NUMERIC', 'NUMERIC_RANGE'], this.textValidator))
      )
    }

    Question.prototype.isUsedAsMatrix = function() {
      return this.type === Types.MATRIX || this.matrixEnabled
    }

    Question.prototype.isHiddenVariables = function() {
      return this.type === Types.HIDDEN_VARIABLES
    }

    Question.prototype.canHaveChoiceImages = function() {
      return this.isType([
        Types.CHOICE,
        Types.RANK,
        Types.MATRIX,
        Types.CONSTANT_SUM,
        Types.HIDDEN_VARIABLES,
      ])
    }

    Question.prototype.canHaveStatementImages = function() {
      return this.isType([Types.MATRIX, Types.CONSTANT_SUM, Types.SCORE])
    }

    Question.prototype.isChoiceImagesEnabled = function(asStatements) {
      if (asStatements) {
        return this.statementImagesEnabled
      }
      return this.choiceImagesEnabled
    }

    Question.prototype.isChoiceLabelsHidden = function(asStatements) {
      if (asStatements) {
        return this.statementLabelsHidden
      }
      return this.choiceLabelsHidden
    }

    Question.prototype.belongsToTemplate = function() {
      // console.log('belongsToTemplate', this.isTemplate, this.survey && this.survey.isTemplate);
      return this.isTemplate || (this.survey && this.survey.isTemplate)
    }

    Question.prototype.usesTitleSelector = function() {
      // console.log('usesTitleSelector', this.belongsToTemplate(), !!this.titleSelector);
      return !this.belongsToTemplate() && this.titleSelector
    }

    Question.prototype.addTitleSelectorOption = function(segment, option) {
      var placeholder = segment.placeholder

      // custom options are added to other title selectors across the whole survey
      _.each(this.survey.views, function(view) {
        if (!view.isQuestion()) return
        var question = view.value
        if (!question.titleSelector) {
          return
        }
        _.each(question.titleSelector.segments, function(segment) {
          if (segment.placeholder === placeholder) {
            // new reference required
            segment.options = segment.options.concat(option)
          }
        })
      })
    }

    Question.prototype.initChoiceMods = function() {
      if (this.choiceMods.length) return
      for (var choice of this.getAllChoices()) {
        var mod = new Mod()
        mod.id = choice.id
        mod.label = choice.label
        mod.optionIds = [choice.id]
        mod.hidden = false
        this.choiceMods.push(mod)
      }
    }

    Question.prototype.clearChoiceMods = function() {
      this.choiceMods = []
    }

    Question.prototype.resetChoiceMods = function() {
      this.clearChoiceMods()
      this.initChoiceMods()
    }

    Question.prototype.invalidateChoiceMods = function() {
      // when someone edits this question and adds/removes choices
      // then we completely reset all mods.
      var originalIds = this.getAllChoices().map(function(choice) {
        return choice.id
      })
      var modIds = []
      for (var mod of this.choiceMods) {
        for (var choiceId of mod.optionIds) {
          modIds.push(choiceId)
        }
      }
      originalIds.sort()
      modIds.sort()
      var exact = _.isEqual(originalIds, modIds)
      if (!exact) this.clearChoiceMods()
    }

    var Info = [
      {
        type: Question.Types.CHOICE,
        label: 'Choice',
        desc: 'Select one or more from a list of choices',
        defaults: {
          choices: [],
          maxSelections: 1,
        },
      },
      {
        type: Question.Types.RANK,
        label: 'Rank',
        desc: 'Select choices in order of preference',
        defaults: {
          choices: [],
          maxSelections: 3,
        },
      },
      {
        type: Question.Types.SCALE,
        label: 'Scale',
        desc: 'Select one from a range',
        defaults: {
          data: {},
          choices: [],
        },
      },
      {
        type: Question.Types.SINGLE_TEXT,
        label: 'Text',
        desc: 'Enter short text or numerical answer',
        defaults: {
          textValidator: null,
          textNumericMin: 0,
          textNumericMax: 100,
          textFieldNumber: 1,
          textFieldLabels: [],
          minAnswers: 1,
        },
      },
      {
        type: Question.Types.TEXT,
        label: 'Multiline Text',
        desc: 'Enter multi-line text as an answer',
        defaults: {},
      },
      {
        type: Question.Types.SCAN,
        label: 'Scan',
        desc: 'Enter a barcode',
        defaults: {},
      },
      {
        type: Question.Types.NPS,
        label: 'NPS',
        desc: 'Net Promoter Score question',
        defaults: {
          data: {
            presetId: 'nps',
          },
          choices: _.cloneDeep(_.find(OptionPresets, { value: 'nps' }).items),
        },
      },
      {
        type: Question.Types.MOOD,
        label: 'Mood',
        desc: 'Choose from a set of moods',
        defaults: {
          data: {
            presetId: '6p-mood',
          },
          choices: _.cloneDeep(
            _.find(OptionPresets, { value: '6p-mood' }).items
          ),
        },
      },
      {
        type: Question.Types.PLACES_NEAR_ME,
        label: 'Places Near Me',
        desc: 'Select one or many places nearby',
        defaults: {
          isCompulsory: false,
          maxSelections: 1,
        },
      },
      {
        type: Question.Types.LOCATION,
        label: 'Location',
        desc: 'Enter and select a location',
        defaults: {
          locationType: LocationTypes.DEFAULT,
        },
      },
      {
        type: Question.Types.IMAGE,
        label: 'Image',
        desc: 'Upload an image',
        defaults: {
          isCompulsory: false,
        },
      },
      {
        type: Question.Types.FOLLOW_UP,
        label: 'Follow-Up',
        desc: 'Request for follow-up to allow you to respond',
        defaults: {
          skipText: 'Skip',
          choices: _.cloneDeep(
            _.find(OptionPresets, { value: 'follow-up' }).items
          ),
          isCompulsory: false,
          title: 'Would you like us to get back to you via Glow?',
        },
      },
      {
        type: Question.Types.RATING,
        label: 'Rating',
        desc: 'Stars from 1 to 5',
        defaults: {
          choices: _.cloneDeep(_.find(OptionPresets, { value: '5star' }).items),
        },
      },
      {
        type: Question.Types.NUMERIC,
        label: 'Numeric Scale',
        desc: 'Select a numeric scale value',
        defaults: {
          numericMin: 0,
          numericMax: 10,
          numericSteps: 10,
          numericUnit: 'number',
          numericLabels: [],
        },
      },
      {
        type: Question.Types.MATRIX,
        label: 'Matrix',
        desc: 'Select a choice for multiple statements',
        defaults: {
          choices: [],
          statements: [],
          maxSelections: 1,
          displayType: MatrixDisplayTypes.DEFAULT,
        },
      },
      {
        type: Question.Types.CONSTANT_SUM,
        label: 'Constant Sum',
        desc: 'Allocate number of points for multiple choices',
        defaults: {
          constantSumTotal: null,
          constantSumTotalMin: null,
          constantSumTotalMax: null,
          constantSumTotalQuantifier: null,
          constantSumShowTotal: false,
          constantSumStatementRules: [],
        },
      },
      {
        type: Question.Types.SCORE,
        label: 'Score',
        desc:
          'Net Trust, Social Responsibility and Custom score based question',
        defaults: {
          choices: [],
          scoreType: null,
          scoreLabel: '',
          scoreDefinition: '',
          scoreLeftExtremityLabel: '',
          scoreRightExtremityLabel: '',
        },
      },
      {
        type: Question.Types.HIDDEN_VARIABLES,
        label: 'Hidden Variables',
        desc: 'Not shown to respondent',
        defaults: {
          choices: [],
          maxSelections: null,
          isCompulsory: false,
        },
      },
    ]

    function getInfo(typeOrTypes) {
      var type = _.isString(typeOrTypes) ? typeOrTypes : null
      var types = _.isArray(typeOrTypes) ? typeOrTypes : null

      // if type specified - return just that info
      if (type) {
        return _.cloneDeep(_.find(Info, { type: type }))
      }

      // if types array, return just those types
      if (types) {
        // retain the order of `types`
        var info = _.map(types, function(type) {
          return _.find(Info, { type: type })
        })
        return _.cloneDeep(info)
      }

      // otherwise return all info
      return _.cloneDeep(Info)
    }

    return Question
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "Question", "questionsResource", "imageService"];
  angular.module('glow.components').service('questionService', Service)

  /* @ngInject */
  function Service($q, Question, questionsResource, imageService) {
    this.updateLock = updateLock
    this.setImage = setImage
    this.setChoiceImage = setChoiceImage

    function updateLock(question) {
      return $q(function(resolve, reject) {
        if (question.isNew) {
          return resolve()
        }
        var action = question.isLocked ? 'lock' : 'unlock'
        questionsResource[action]({ id: question.id })
          .success(function() {
            console.info('question.isLocked updated', question.isLocked)
            resolve()
          })
          .error(function() {
            question.isLocked = !question.isLocked // revert
            console.error('could not update question.isLocked')
            reject()
          })
      })
    }

    function setImage(question, imageData) {
      if (!imageData) {
        question.imageUrl = null
        return $q.resolve()
      }
      var promise = imageService.create(imageData).then(function(imageUrl) {
        question.imageUrl = imageUrl
      })
      question.queue.add(promise, 'Uploading Image')
      return promise
    }

    function setChoiceImage(question, choice, imageData) {
      if (!imageData) {
        choice.imageData = null
        choice.imageUrl = null
        return $q.resolve()
      }
      var promise = imageService.create(imageData).then(function(imageUrl) {
        choice.imageUrl = imageUrl
      })
      question.queue.add(promise, 'Uploading Image')
      return promise
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').service('responseTypeService', Service)

  /* @ngInject */
  function Service() {
    var Types = {
      COMPLETE: 'COMPLETE',
      EXIT: 'EXIT',
      OVERQUOTA: 'OVERQUOTA',
      QUALITYEXIT: 'QUALITYEXIT',
    }

    var selectOptions = [
      {
        label: 'All Responses',
        value: null,
      },
      {
        label: 'Completes',
        value: Types.COMPLETE,
      },
      {
        label: 'Exits',
        value: Types.EXIT,
      },
      {
        label: 'Overquota',
        value: Types.OVERQUOTA,
      },
      {
        label: 'Quality Exits',
        value: Types.QUALITYEXIT,
      },
    ]

    var selected = Types.COMPLETE // default

    this.Types = Types
    this.selectOptions = selectOptions
    this.getSelected = getSelected
    this.setSelected = setSelected

    function getSelected() {
      return selected
    }

    function setSelected(type) {
      selected = type
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils", "Queue", "Logic", "Video", "Pipes"];
  angular.module('glow.components').factory('Section', Factory)

  /* @ngInject */
  function Factory(glUtils, Queue, Logic, Video, Pipes) {
    // media types
    var MediaTypes = {
      VIDEO: 'VIDEO',
      VIDEO_UPLOAD: 'VIDEO_UPLOAD',
      AUDIO: 'AUDIO',
      IMAGE: 'IMAGE',
      IFRAME: 'IFRAME',
    }

    function Section(options) {
      options = options || {}
      this.queue = options.queue || new Queue()
      this.survey = options.survey
      this.titlePipes = new Pipes()
      this.errors = []
      this.applyDefaults()
    }

    Section.prototype.MediaTypes = Section.MediaTypes = MediaTypes

    Section.prototype.applyDefaults = function() {
      _.defaults(this, {
        id: glUtils.uuid(),
        title: '',
        imageUrl: null,
        imageFromLoop: false,
        youTubeVideoUrl: null,
        video: new Video(),
        audioUrl: null,
        iframeUrl: null,
        logic: [],
        mediaType: null,
        mediaLabel: null,
        delay: 0,
        hide: 0,
        reference: null,
        omni: null,
        isHidden: false,
      })
    }

    Section.prototype.deserialize = function(data) {
      var self = this
      this.id = data.id
      this.title = data.title
      this.titlePipes.set(this.title)
      this.imageUrl = data.imageUrl
      this.imageFromLoop = data.imageFromLoop
      this.youTubeVideoUrl = data.youTubeVideoUrl
      this.video.deserialize(data.video)
      this.audioUrl = data.audioUrl
      this.iframeUrl = data.iframeUrl
      this.logic = _.map(data.logic, function(logic) {
        try {
          return new Logic(self.survey.logicHelpers).deserialize(logic)
        } catch (err) {
          console.error(err)
        }
      })
      this.mediaType = data.mediaType
      this.mediaLabel = data.mediaLabel
      this.delay = data.delay
      this.hide = data.hide
      this.reference = data.reference
      this.omni = data.omni
      this.isHidden = data.isHidden

      this.applyDefaults()
      return this
    }

    Section.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.title = this.title

      switch (this.mediaType) {
        case MediaTypes.VIDEO:
          data.youTubeVideoUrl = this.youTubeVideoUrl
          break
        case MediaTypes.AUDIO:
          data.audioUrl = this.audioUrl
          break
        case MediaTypes.IMAGE:
          data.imageUrl = this.imageUrl
          data.imageFromLoop = this.imageFromLoop
          data.hide = this.hide
          break
        case MediaTypes.IFRAME:
          data.iframeUrl = this.iframeUrl
          break
      }
      if (this.mediaType !== MediaTypes.VIDEO_UPLOAD) {
        this.video.clear()
      }
      data.video = this.video.serialize()

      if (this.usesDelay()) {
        data.delay = this.delay
      }

      data.mediaType = this.mediaType
      data.mediaLabel = this.mediaType ? this.mediaLabel : undefined
      data.reference = this.reference
      data.omni = _.cloneDeep(this.omni)

      data.logic = this.logic.map(function(logic) {
        return logic.serialize()
      })

      data.isHidden = this.isHidden
      return data
    }

    Section.prototype.validate = function(questionNumber) {
      var self = this
      var isValid = true
      _.remove(this.errors) // clear errors
      if (!this.title) {
        this.errors.push('Title is required')
        isValid = false
      }

      // validate title pipes
      _.each(this.titlePipes.pipes, function(pipe) {
        var number = pipe.directives[0].number
        if (number >= questionNumber) {
          self.errors.push(
            'Title contains invalid pipe: ' +
              pipe.string +
              ' (must be before current section)'
          )
          isValid = false
        }
      })

      if (
        this.mediaType === MediaTypes.VIDEO &&
        (!this.youTubeVideoUrl ||
          !this.youTubeVideoUrl.startsWith('https://www.youtube.com/embed/'))
      ) {
        this.errors.push(
          'Invalid YouTube URL. The URL must be https://www.youtube.com/embed/<video_id>'
        )
        isValid = false
      }
      if (
        this.mediaType === MediaTypes.VIDEO_UPLOAD &&
        !this.video.validate()
      ) {
        this.errors.push('Video required')
        isValid = false
      }
      if (
        this.mediaType === MediaTypes.AUDIO &&
        (!this.audioUrl || !this.audioUrl.endsWith('.mp3'))
      ) {
        this.errors.push('Invalid MP3 URL. The URL must end with .mp3')
        isValid = false
      }
      if (
        this.mediaType === MediaTypes.IMAGE &&
        !this.imageUrl &&
        !this.imageFromLoop
      ) {
        this.errors.push('Please select an image')
        isValid = false
      }
      if (
        this.mediaType === MediaTypes.IFRAME &&
        (!this.iframeUrl || !glUtils.validateUrl(this.iframeUrl))
      ) {
        this.errors.push(
          'Invalid Iframe URL. The URL must starts with http:// or https://'
        )
        isValid = false
      }
      if (!_.isNumber(this.delay) || this.delay < 0) {
        this.errors.push(
          'Timer delay must be a number greater than or equal to zero'
        )
        isValid = false
      }
      if (!_.isNumber(this.hide) || this.hide < 0) {
        this.errors.push(
          'Hide Timer must be a number greater than or equal to zero'
        )
        isValid = false
      }

      // logic
      _.each(this.logic, function(logic) {
        if (!logic.validate()) {
          _.each(logic.errors, function(err) {
            self.errors.push(err)
          })
          isValid = false
          return false
        }
      })

      return isValid
    }

    Section.prototype.clone = function(options) {
      var self = this
      options = options || {}
      var section = new Section({
        queue: self.queue,
        survey: self.survey,
      }).deserialize(this.serialize())

      // refresh the id
      section.id = glUtils.uuid()

      /**
       * When cloning logic, any conditions that self-reference this
       * section will be rebound to the newly cloned section.
       * (maintains self-referencing)
       */
      var newIds = {
        // [oldId]: newId
      }
      // IMPORTANT: [ES5] function declarations cannot be nested inside of an if block
      // Refernce : https://stackoverflow.com/a/10069457/5731688
      function getId(oldId, getOnly) {
        // if there is no id don't re-assign
        if (!oldId) return oldId
        // safeguard for rebinding old references
        if (!newIds[oldId] && getOnly) {
          return oldId
        }
        // generate one if it hasn't been generated yet
        if (!newIds[oldId]) {
          newIds[oldId] = glUtils.uuid()
        }
        return newIds[oldId]
      }
      if (options.cloneLogic) {
        newIds[self.id] = section.id
        section.logic = _.map(section.logic, function(logic) {
          return logic.clone().refresh(getId)
        })
      } else {
        section.logic = []
      }

      return section
    }

    Section.prototype.refresh = function(getId) {
      this.idOld = this.id
      this.id = getId(this.idOld)
      this.applyDefaults()
    }

    Section.prototype.usesDelay = function() {
      return [MediaTypes.IMAGE, MediaTypes.IFRAME].includes(this.mediaType)
    }

    Section.prototype.getTitleLabel = function(options) {
      options = _.defaults(options, {
        number: true,
        markdown: false,
      })
      var label = this.title || 'Untitled'
      if (options.number) {
        label = 'S' + this.getNumber() + ': ' + label
      }
      if (options.markdown) {
        label = window.marked(label)
      }
      return label
    }

    Section.prototype.getNumber = function() {
      return this.view.getNumber()
    }

    Section.prototype.getViewGroup = function() {
      return this.survey && this.survey.getViewGroupByViewId(this.id)
    }

    return Section
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "imageService", "api"];
  angular.module('glow.components').service('sectionService', Service)

  /* @ngInject */
  function Service($q, imageService, api) {
    var AudioFileExtension = '.mp3'

    this.setImage = setImage
    this.uploadAudioFile = uploadAudioFile
    this.AudioFileExtension = AudioFileExtension

    function setImage(section, imageData) {
      if (!imageData) {
        section.imageUrl = null
        return $q.resolve()
      }
      var promise = imageService.create(imageData).then(function(imageUrl) {
        section.imageUrl = imageUrl
      })
      section.queue.add(promise, 'Uploading Image')
      return promise
    }

    function uploadAudioFile(file) {
      return api.audio.create({
        fileData: file.data,
        filename: file.name,
      })
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils"];
  angular.module('glow.components').factory('ShuffleGroup', Factory)

  /* @ngInject */
  function Factory(glUtils) {
    function ShuffleGroup() {
      this.applyDefaults()
    }

    ShuffleGroup.prototype.applyDefaults = function() {
      _.defaults(this, {
        id: glUtils.uuid(),
        viewGroupIds: [],
        sample: null,
      })
    }

    ShuffleGroup.prototype.deserialize = function(data) {
      data = data || {}
      this.id = data.id
      this.viewGroupIds = data.viewGroupIds
      this.sample = data.sample
      this.applyDefaults()
      return this
    }

    ShuffleGroup.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.viewGroupIds = this.viewGroupIds.slice()
      data.sample = this.sample
      return data
    }

    ShuffleGroup.prototype.refresh = function(getId) {
      this.idOld = this.id
      this.id = getId ? getId(this.idOld) : glUtils.uuid()

      this.viewGroupIds = _.map(this.viewGroupIds, function(oldId) {
        return getId(oldId, true)
      })
    }

    return ShuffleGroup
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils", "colors"];
  angular.module('glow.components').factory('SurveyTheme', Factory)

  /* @ngInject */
  function Factory(glUtils, colors) {
    var HEX_REGEX = /^#[0-9A-F]{6}$/i

    var GlowTheme = {
      id: null,
      label: 'Glow (default)',
      primaryColor: colors.expandHex(colors.Colors.GREEN_EMERALD),
      isDefault: true,
    }

    SurveyTheme.prototype.GlowTheme = SurveyTheme.GlowTheme = GlowTheme

    function SurveyTheme() {
      this.applyDefaults()
    }

    SurveyTheme.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: glUtils.uuid(),
        label: '',
        primaryColor: '#000000', // default to black
        isDefault: false,
      })
    }

    SurveyTheme.prototype.deserialize = function(data) {
      data = _.isPlainObject(data) ? data : {}
      this.id = data.id
      this.label = data.label
      this.primaryColor = data.primaryColor
      this.isDefault = data.isDefault

      this.applyDefaults()
      this.snapshot()
      return this
    }

    SurveyTheme.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.label = this.label
      data.primaryColor = this.primaryColor
      data.isDefault = this.isDefault
      return data
    }

    SurveyTheme.prototype.clone = function() {
      // clone means an exact copy, don't modify fields here.
      return new SurveyTheme().deserialize(this.serialize())
    }

    SurveyTheme.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    SurveyTheme.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    SurveyTheme.prototype.validate = function() {
      if (!this.label) return false
      if (!this.primaryColor || !HEX_REGEX.test(this.primaryColor)) return false
      return true
    }

    return SurveyTheme
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["SurveyTheme", "profileService"];
  angular.module('glow.components').service('surveyThemeService', Service)

  /* @ngInject */
  function Service(SurveyTheme, profileService) {
    var self = this

    self.getDefault = getDefault
    self.getById = getById
    self.apply = apply

    function getDefault() {
      return new SurveyTheme().deserialize(SurveyTheme.GlowTheme)
    }

    function getById(themeId, ownerId) {
      return profileService.get(ownerId).then(function(profile) {
        return _.find(profile.surveyThemes, { id: themeId })
      })
    }

    function apply(theme) {
      var primaryColor = theme.primaryColor
      var primaryTextColor = '#ffffff' // default to white
      var css = [
        ':root {',
        '  --survey-primary-color: ' + primaryColor + ';',
        '  --survey-primary-text-color: ' + primaryTextColor + ';',
        '}',
      ].join('\n')

      var styleTag = document.getElementById('survey-theme-styles')
      if (!styleTag) {
        styleTag = document.createElement('style')
        styleTag.id = 'survey-theme-styles'
        document.head.appendChild(styleTag)
      }
      styleTag.innerHTML = css
    }
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["$rootScope", "glSurveyUtils", "Queue", "Question", "Section", "Origin", "Crosstab", "userService", "Link", "LOI", "View", "ViewGroup", "ShuffleGroup", "ThemeContext", "glUtils", "colors", "ReportSettings", "TagQuotaSettings", "QuotaPlan", "QuotaDefinition", "configService"];
  angular.module('glow.components').factory('Survey', Factory)

  /* @ngInject */
  function Factory(
    $rootScope,
    glSurveyUtils,
    Queue,
    Question,
    Section,
    Origin,
    Crosstab,
    userService,
    Link,
    LOI,
    View,
    ViewGroup,
    ShuffleGroup,
    ThemeContext,
    glUtils,
    colors,
    ReportSettings,
    TagQuotaSettings,
    QuotaPlan,
    QuotaDefinition,
    configService
  ) {
    var CORE_COLORS = colors.CORE_COLORS

    var Events = {
      CREATED: 'survey:created',
      CREATED_TEMPLATE: 'survey:created-template',
      UPDATED: 'survey:updated',
      UPDATED_TEMPLATE: 'survey:updated-template',
      REFRESH: 'survey:refresh',
      REFRESH_TEMPLATE: 'survey:refresh-template',
      VIEW_ADDED: 'survey:view-added',
    }

    var Defaults = {
      startAt: moment().startOf('day'),
      endAt: moment('2030-01-01'),
      isArchived: false,
      activeChannelCount: 0,
      showIntro: true,
      introTimeVisible: true,
      introCustomDataVisible: false,
      isInline: false,
      backAllowed: false,
      outroText: 'Thank you for taking this survey.',
      viewGroups: [],
      shuffleGroups: [],
      origins: [],
      originsPre: false,
      version: 0,
      serverVersion: 0,
      crosstabs: [],
      reportSettings: new ReportSettings(),
      tagQuotaSettings: new TagQuotaSettings(),
      segments: [],
      share: {},
      aiQualityFilterEnabled: false,
      operationsManagerId: '',
      outlink: {
        enabled: false,
        url: null,
        immediate: false,
        submitLink: null,
        exitLink: null,
        quotaLink: null,
        qualityExitLink: null,
      },
      themeId: null,
      hasDatapack: false,
      ai: {
        hasUnsaved: false, // local
        surveyModifiedByUser: false,
        conversationId: null,
        surveyId: null,
        isDevOrigin: false,
        data: {},
      },
    }

    function Survey(options) {
      var self = this
      options = options || {}

      this.idInc = 0
      this.errors = []
      this.views = []
      this.coreProfile = {}
      this.data = {}
      this.queue = new Queue()
      this.serverData = {}
      this.lengthOfInterview = new LOI()
      this.themeContext = new ThemeContext().asSurveyDefault()
      this.introView = new View(this).asIntro()

      this.logicHelpers = {
        getSectionInfo: function(sectionId) {
          var view = self.getView(sectionId)
          if (!view) return
          var section = view.value
          return {
            id: sectionId,
            position: self.views.indexOf(view),
            number: section.getNumber(),
          }
        },
        getQuestionInfo: function(questionId) {
          var view = self.getView(questionId)
          if (!view) return
          var question = view.value
          return {
            id: questionId,
            position: self.views.indexOf(view),
            number: question.getNumber(),
            type: question.type,
            hasStatements: question.isUsedAsMatrix(),
            hasChoices: _.includes(
              [
                question.Types.CHOICE,
                question.Types.RANK,
                question.Types.NPS,
                question.Types.MOOD,
                question.Types.RATING,
                question.Types.MATRIX,
                question.Types.SCALE,
                question.Types.CONSTANT_SUM,
                question.Types.SCORE,
                question.Types.HIDDEN_VARIABLES,
              ],
              question.type
            ),
            isNumeric: question.isNumericType(),
            isText:
              question.type === question.Types.LOCATION ||
              question.type === question.Types.TEXT ||
              (question.type === question.Types.SINGLE_TEXT &&
                _.includes([null, 'EMAIL'], question.textValidator)),
            isConstantSum: question.type === question.Types.CONSTANT_SUM,
            isRank: question.type === question.Types.RANK,
            isHiddenVariables: question.isHiddenVariables(),
          }
        },
        getChoiceInfo: function(questionId, choiceIds) {
          var question = self.getQuestion(questionId)
          if (!question) return
          return question
            .getAllChoices()
            .filter(function(choice) {
              return _.includes(choiceIds, choice.id)
            })
            .map(function(choice) {
              return {
                id: choice.id,
                label: choice.value || choice.label,
                isHidden: choice.isHidden,
              }
            })
        },
        getStatementInfo: function(questionId, statementIds) {
          var question = self.getQuestion(questionId)
          if (!question) return
          return question
            .getAllStatements()
            .filter(function(statement) {
              return _.includes(statementIds, statement.id)
            })
            .map(function(statement) {
              return {
                id: statement.id,
                label: statement.value || statement.label,
                isHidden: statement.isHidden,
              }
            })
        },
        getTags: function(beforeQuestionId) {
          // ...
        },
        getViewGroupInfo: function(viewGroupIds) {
          return _.filter(self.viewGroups, function(viewGroup) {
            return _.includes(viewGroupIds, viewGroup.id)
          }).map(function(viewGroup) {
            return {
              id: viewGroup.id,
              name: viewGroup.name,
            }
          })
        },
        getViewByLogicId: function(logicId) {
          return _.find(self.views, function(view) {
            return !!_.find(view.value.logic, { id: logicId })
          })
        },
        getLoopVariableInfo: function(viewId, loopKeyOrLoopKeys) {
          var viewGroup = self.getViewGroupByViewId(viewId)
          if (!viewGroup) return
          var loopVariables = viewGroup.getLoopVariables(self)
          var loopKey = _.isString(loopKeyOrLoopKeys) ? loopKeyOrLoopKeys : null
          var loopKeys = _.isArray(loopKeyOrLoopKeys) ? loopKeyOrLoopKeys : null
          if (loopKey) {
            return _.find(loopVariables, { id: loopKey })
          }
          if (loopKeys) {
            return _.filter(loopVariables, function(loopVariable) {
              return _.includes(loopKeys, loopVariable.id)
            })
          }
          return null
        },
        getViewGroupByViewId: self.getViewGroupByViewId.bind(self),
      }

      _.defaultsDeep(this, options, Defaults)
    }

    Survey.prototype.Events = Survey.Events = Events
    Survey.prototype.Defaults = Survey.Defaults = Defaults

    Survey.prototype.deserialize = function(survey) {
      var self = this

      glSurveyUtils.parseSandboxData(survey)

      this.didMigrateLogic = survey.didMigrateLogic

      // views used to get their id via _.uniqueId() but
      // this means every time you save the survey the views get
      // given a new random id.
      // if we use a counter that is reset each deserialize
      // it is idempotent and the views will keep the same
      // id after a save (most of the time)
      this.idInc = 0

      this.serverData = _.cloneDeep(survey)

      // immutable clone
      survey = _.cloneDeep(survey)

      this.id = survey.id
      this.ownerId = survey.ownerId
      this.projectId = survey.projectId
      this.elementId = survey.elementId
      this.title = survey.title
      this.reference = survey.reference
      this.comparisonKey = survey.comparisonKey
      this.description = survey.description
      this.tags = survey.tags
      this.tagCounts = survey.tagCounts
      this.imageUrl = survey.imageUrl
      this.listImageUrl = survey.listImageUrl
      this.loops = survey.loops
      this.hasDatapack = survey.hasDatapack

      this.responseCount = survey.responseCount || 0
      this.deletedResponseCount = survey.deletedResponseCount || 0

      this.createdAt = survey.createdAt && moment(survey.createdAt)
      this.startAt = survey.startAt && moment(survey.startAt)
      this.endAt = survey.endAt && moment(survey.endAt)
      this.couponId = survey.couponId
      this.isPromoted = survey.promote
      this.shouldNotify = survey.notify

      this.isInline = survey.presentationType === 'inline'

      this.responseGoal = survey.responseLimit

      this.submitRoute = survey.submitRoute

      // data is not part of the survey instance
      // we move its values to the root, and reconstruct it on serialization
      // (this prevent duplicate field inconsistencies)
      var data = _.isPlainObject(survey.data) ? survey.data : {}

      this.unlimitedQuestionsAllowed = data.unlimitedQuestionsAllowed
      this.backAllowed = data.backAllowed
      this.showQuestionNumbers = data.showQuestionNumbers
      this.isLocked = data.locked
      this.recommendedDistribution = data.recommendedDistribution
      this.templateId = data.surveyTemplateId
      this.fromSurveyId = data.fromSurveyId
      this.outroText = data.outroText
      this.nextSurveyId = data.nextSurveyId
      this.pageId = data.pageId
      this.viewGroups = _.map(data.viewGroups, function(data) {
        return new ViewGroup().deserialize(data)
      })
      this.shuffleGroups = _.map(data.shuffleGroups, function(data) {
        return new ShuffleGroup().deserialize(data)
      })

      this.showIntro = survey.showLandingPage
      this.introText = data.introText
      this.introTextUrl = data.introTextUrl
      this.introTimeVisible = data.introTimeVisible
      this.introCustomDataVisible = data.introCustomDataVisible
      this.aiQualityFilterEnabled = data.aiQualityFilterEnabled

      if (data.restartButton) {
        this.restartEnabled = true
        this.restartButton = data.restartButton
      } else {
        this.restartEnabled = false
        this.restartButton = 'Restart'
      }

      this.share = {}
      if (
        data.shareTitle ||
        data.shareText ||
        data.shareUrl ||
        data.shareImageUrl
      ) {
        this.share.enabled = true
        this.share.title = data.shareTitle
        this.share.text = data.shareText
        this.share.url = data.shareUrl
        this.share.imageUrl = data.shareImageUrl
      }

      this.isArchived = survey.isArchived

      this.activeChannelCount = survey.activeChannelCount

      var questionDataById = {}
      survey.questions.forEach(function(question) {
        questionDataById[question.id] = question
      })
      function getQuestionData(id) {
        return questionDataById[id]
      }
      this.views = data.views.map(function(data) {
        return new View(self).deserialize(data, getQuestionData)
      })

      self.lengthOfInterview.set(survey.lengthOfInterview)

      // build links
      self.links = []
      _.each(survey.links, function(link) {
        self.links.push(new Link().deserialize(link))
      })

      // pluck any followup questions as they are managed at the top level
      var followupView = _.remove(self.views, function(view) {
        return view.isQuestion() && view.value.type === Question.Types.FOLLOW_UP
      })[0]
      if (followupView) {
        self.followupView = followupView
        self.isFollowup = !self.followupView.value.isHidden
      }

      // core-profile options
      this.coreProfile = {
        added: !!data.coreProfileAdded,
        enabled: !!data.coreProfileEnabled,
        isCompulsory: !!data.coreProfileCompulsory,
        views: [],
      }
      if (this.coreProfile.added) {
        // core-profile questions (pull out from questions)
        var views = _.remove(self.views, function(view) {
          return (
            view.isQuestion() &&
            _.includes(
              ['age_year_of_birth', 'age_range', 'sex', 'location'],
              view.value.profileKey
            )
          )
        })
        self.coreProfile.views = views
      }

      if (survey.kits) {
        this.kits = survey.kits
      }

      this.origins = data.origins.map(function(data) {
        return new Origin().deserialize(data)
      })
      this.originsPre = data.originsPre

      this.version = survey.version
      this.serverVersion = this.version

      this.crosstabs =
        data.crosstabs &&
        data.crosstabs.map(function(data) {
          return new Crosstab().deserialize(data)
        })

      this.themeContext.asSurveyDefault().deserialize(data.themeContext)

      this.reportSettings = new ReportSettings().deserialize(
        data.reportSettings
      )

      this.tagQuotaSettings = new TagQuotaSettings().deserialize(
        data.tagQuotaSettings
      )

      this.quotaPlans = _.isArray(data.quotaPlans)
        ? data.quotaPlans.map(function(data) {
            return new QuotaPlan().deserialize(data)
          })
        : undefined

      this.segments = survey.segments || []

      if (survey.operationsManager) {
        this.operationsManagerId = survey.operationsManager.userId || ''
      }

      if (data.outlink) {
        this.outlink = {
          enabled: data.outlink.enabled,
          url: data.outlink.url,
          immediate: data.outlink.immediate,
          submitLink: data.outlink.submitLink,
          exitLink: data.outlink.exitLink,
          quotaLink: data.outlink.quotaLink,
          qualityExitLink: data.outlink.qualityExitLink,
        }
      }

      this.themeId = data.themeId

      this.ai.surveyModifiedByUser = survey.ai.conversationId
        ? survey.ai.surveyModifiedByUser
        : true
      this.ai.conversationId = survey.ai.conversationId
      this.ai.surveyId = survey.ai.surveyId
      this.ai.isDevOrigin = survey.ai.isDevOrigin

      _.defaultsDeep(this, Survey.Defaults)

      return this
    }

    Survey.prototype.serialize = function() {
      var self = this
      var survey = {}

      survey.id = this.id
      survey.ownerId = this.ownerId || userService.getSubscriberId()
      survey.elementId = this.elementId
      survey.projectId = this.projectId
      survey.title = this.title
      survey.reference = this.reference
      survey.comparisonKey = this.comparisonKey
      survey.description = this.description
      survey.tags = this.tags
      survey.imageUrl = this.imageUrl
      survey.listImageUrl = this.listImageUrl

      survey.startAt = this.startAt && this.startAt.toISOString()
      survey.endAt = this.endAt && this.endAt.toISOString()
      survey.couponId = this.couponId
      survey.promote = this.isPromoted
      survey.notify = this.shouldNotify

      survey.links = this.links

      survey.presentationType = this.isInline ? 'inline' : 'sequential'

      // TODO: break up submitRoute to hard fields

      survey.responseLimit = this.responseGoal

      survey.submitRoute = this.submitRoute

      survey.data = {}
      survey.data.unlimitedQuestionsAllowed = this.unlimitedQuestionsAllowed
      survey.data.backAllowed = this.backAllowed
      survey.data.showQuestionNumbers = this.showQuestionNumbers
      survey.data.locked = this.isLocked
      survey.data.surveyTemplateId = this.templateId
      survey.data.fromSurveyId = this.fromSurveyId
      survey.data.recommendedDistribution = this.recommendedDistribution
      survey.data.restartButton = survey.restartEnabled
        ? survey.restartButton
        : undefined
      survey.data.restartEnabled = undefined // virtual
      survey.data.outroText = this.outroText
      survey.data.nextSurveyId = this.nextSurveyId
      survey.data.pageId = this.pageId
      survey.data.viewGroups = this.viewGroups.map(function(group) {
        return group.serialize()
      })
      survey.data.shuffleGroups = this.shuffleGroups.map(function(group) {
        return group.serialize()
      })

      survey.showLandingPage = this.showIntro
      survey.data.introText = this.introText
      survey.data.introTextUrl = this.introTextUrl
      survey.data.introTimeVisible = this.introTimeVisible
      survey.data.introCustomDataVisible = this.introCustomDataVisible
      survey.data.aiQualityFilterEnabled = this.aiQualityFilterEnabled

      if (this.share && this.share.enabled) {
        survey.data.shareTitle = this.share.title
        survey.data.shareText = this.share.text
        survey.data.shareUrl = this.share.url
        survey.data.shareImageUrl = this.share.imageUrl
      }

      // project mods that merge choices for the backend to see
      survey.merges = []
      for (var view of this.views) {
        if (!view.isQuestion()) continue
        var question = view.value
        question.invalidateChoiceMods()
        for (var mod of question.choiceMods) {
          if (mod.optionIds.length >= 2) {
            survey.merges.push({
              id: mod.id,
              questionId: question.id,
              optionIds: mod.optionIds,
              order: 0, // remove from BE (pointless)
              label: mod.label, // remove from BE (pointless)
            })
          }
        }
      }

      survey.questions = []
      function setQuestionData(data) {
        data.order = survey.questions.length
        survey.questions.push(data)
      }

      // IMPORTANT: data.views is used by BE for section duration (see: https://engagementinnovation.atlassian.net/wiki/spaces/EICDEV/pages/2310701069/Section+Duration)
      survey.data.views = self.views.map(function(view) {
        return view.serialize(setQuestionData)
      })

      // store keyed-loops info at the top level for BE
      survey.loops = []
      this.viewGroups.forEach(function(viewGroup) {
        if (!viewGroup.loop) return
        var loop = {
          id: viewGroup.id,
          questionIds: [],
          sectionIds: [],
          keys: [],
        }
        viewGroup.viewIds.forEach(function(viewId) {
          var view = self.getView(viewId)
          if (view.isQuestion()) {
            loop.questionIds.push(view.value.id)
          }
          if (view.isSection()) {
            loop.sectionIds.push(view.value.id)
          }
        })
        loop.keys = viewGroup.getLoopVariables(self)
        survey.loops.push(loop)
      })
      console.log(survey.loops)

      this.calculateLoi()
      survey.lengthOfInterview = this.lengthOfInterview.serialize()

      survey.links = []
      _.each(this.links, function(link) {
        survey.links.push(link.serialize(true))
      })

      // append followup question if any
      if (this.followupView) {
        survey.data.views.push(this.followupView.serialize(setQuestionData))
      }

      // core-profile
      survey.data.coreProfileAdded = this.coreProfile.added
      survey.data.coreProfileEnabled = this.coreProfile.enabled
      survey.data.coreProfileCompulsory = this.coreProfile.isCompulsory
      _.each(this.coreProfile.views, function(view) {
        view.value.isHidden = !self.coreProfile.enabled
        view.value.isCompulsory = self.coreProfile.isCompulsory
        survey.data.views.push(view.serialize(setQuestionData))
      })

      survey.data.origins = this.origins.map(function(origin) {
        return origin.serialize()
      })
      survey.data.originsPre = this.originsPre

      survey.version = this.version

      survey.data.crosstabs = this.crosstabs.map(function(crosstab) {
        return crosstab.serialize()
      })

      survey.data.themeContext = this.themeContext.serialize()

      survey.data.reportSettings = this.reportSettings.serialize()

      survey.data.tagQuotaSettings = this.tagQuotaSettings.serialize()

      survey.data.quotaPlans = _.isArray(this.quotaPlans)
        ? this.quotaPlans.map(function(plan) {
            return plan.serialize()
          })
        : undefined

      survey.segments = this.segments ? this.segments.slice() : []
      survey.operationsManager = {
        userId: this.operationsManagerId || null,
      }

      survey.data.outlink = _.cloneDeep(this.outlink)

      survey.data.themeId = this.themeId

      survey.ai = {}
      survey.ai.surveyModifiedByUser = this.ai.surveyModifiedByUser
      survey.ai.conversationId = this.ai.conversationId
      survey.ai.surveyId = this.ai.surveyId
      survey.ai.isDevOrigin = this.ai.isDevOrigin
      survey.ai.data = {}

      return survey
    }

    Survey.prototype.clone = function() {
      return new Survey().deserialize(this.serialize())
    }

    // Refresh to the pre-saved state
    Survey.prototype.refresh = function() {
      var self = this

      this.id = null
      this.createdAt = undefined
      this.startAt = Defaults.startAt
      this.endAt = Defaults.endAt
      this.ownerId = undefined
      this.responseCount = undefined
      this.deletedResponseCount = undefined
      this.serverData = {}
      this.couponId = undefined
      this.elementId = undefined
      this.links = undefined
      this.isArchived = false
      this.activeChannelCount = 0
      this.crosstabs = []
      this.reportSettings = Defaults.reportSettings
      this.tagQuotaSettings = Defaults.tagQuotaSettings
      this.quotaPlans = undefined

      this.outlink = null
      this.themeId = null

      // reset ai mode
      this.ai = _.clone(Defaults.ai)

      // When we refresh an id we need to ensure that any references to the old id get
      // mapped to the new one too. References are used in lenders and logic etc.
      var newIds = {
        // [oldId]: newId
      }
      function getId(oldId, getOnly) {
        // if there is no id don't re-assign
        if (!oldId) return oldId
        // safeguard for rebinding old references
        if (!newIds[oldId] && getOnly) {
          return oldId
        }
        // generate one if it hasn't been generated yet
        if (!newIds[oldId]) {
          newIds[oldId] = glUtils.uuid()
        }
        return newIds[oldId]
      }

      _.each(this.views, function(view) {
        view.refresh(getId)
      })

      // Now that id's are refreshed, we can update references to those id's

      _.each(self.views, function(view) {
        if (!view.isQuestion()) return
        view.value.choiceLender.rebind(getId)
        view.value.statementLender.rebind(getId)
        // update constant sum statement rules ID
        view.value.constantSumStatementRules.forEach(function(rule) {
          rule.statementId = getId(rule.statementId, true)
        })
      })

      if (this.isFollowup) {
        if (this.followupView) {
          this.followupView.refresh(getId)
        } else {
          this.addFollowup()
        }
      } else {
        this.removeFollowup()
      }

      // Remove core-profiling entirely when refreshing
      // Trello Card : https://trello.com/c/cgkQvVtX
      this.coreProfile = {}

      // refresh view group ids
      _.each(this.viewGroups, function(group) {
        group.refresh(getId)
      })

      // refresh shuffle group ids
      _.each(this.shuffleGroups, function(group) {
        group.refresh(getId)
      })

      // IMPORTANT: logic references must be refreshed last as they relies on the new ids
      // rebind logic references
      _.each(this.views, function(view) {
        view.value.logic.forEach(function(logic) {
          logic.refresh(getId)
        })
      })

      return this
    }

    // convert from survey or template to a new survey
    Survey.prototype.toNewSurvey = function() {
      this.templateId = this.isTemplate ? this.id : undefined
      this.fromSurveyId = !this.isTemplate ? this.id : undefined

      this.refresh()
      this.description = undefined
      this.tags = undefined
      this.unlimitedQuestionsAllowed = false // this is enabled per-survey by SSR
      this.aiQualityFilterEnabled = false // this is enabled per-survey by SSR

      // If converting from a template make sure questions un-templated too,
      // e.g. set title and title-selector appropriately
      // But need to set isTemplate to false first so that usesTitleSelector() is evaluated correctly.
      // TODO: come up with a more straightfoward solution to templates and title-selectors
      if (this.isTemplate) {
        this.isTemplate = false
        _.each(this.views, function(view) {
          if (view.isQuestion()) {
            view.value.setTitleSelector()
          }
        })
      }
    }

    // convert from survey or template to a new template
    Survey.prototype.toNewTemplate = function() {
      this.templateId = this.isTemplate ? this.id : undefined
      this.fromSurveyId = !this.isTemplate ? this.id : undefined

      this.refresh()
      this.title = this.title + ' (Copy)'
      this.isTemplate = true
      this.element = undefined
      this.links = undefined
    }

    Survey.prototype.canExport = function() {
      return !this.isNew() && !this.isTemplate
    }

    Survey.prototype.canImport = function() {
      return this.isNew() && !this.isTemplate
    }

    Survey.prototype.import = function(data) {
      try {
        data = JSON.parse(data)
      } catch (e) {
        return false
      }

      // retain these fields
      data.projectId = this.projectId
      this.deserialize(data)
      this.refresh()

      return true
    }

    Survey.prototype.canClone = function() {
      return !this.isNew() && !this.isTemplate
    }

    Survey.prototype.isEditRestricted = function() {
      return this.hasResponses() || this.hasActiveChannels()
    }

    Survey.prototype.hasResponses = function() {
      return this.responseCount > 0
    }

    Survey.prototype.hasActiveChannels = function() {
      return this.activeChannelCount > 0
    }

    Survey.prototype.isNew = function() {
      return !this.id
    }

    Survey.prototype.cleanUp = function() {
      // we can put anything here that requires clean up to correctly validate
      // before survey is saved.
      var self = this
      this.views.forEach(function(view) {
        view.value.logic.forEach(function(logic) {
          if (view.isQuestion()) {
            logic.cleanUp(view.value)
          }
          if (view.isSection()) {
            logic.cleanUp()
          }
        })
        // clean up lenders in question
        if (view.isQuestion()) {
          view.value.choiceLender.cleanUp(self, view.value.id)
          view.value.statementLender.cleanUp(self, view.value.id)

          // clean up constant sum statement rules
          var statements = view.value.getAllStatements() || []
          _.remove(view.value.constantSumStatementRules, function(rule) {
            var statement = _.find(statements, { id: rule.statementId })
            return !statement || statement.isHidden
          })
        }
      })
      // clean up lender in viewGroup
      this.viewGroups.forEach(function(viewGroup) {
        viewGroup.loopLender.cleanUp(self, viewGroup.id)
      })
    }

    Survey.prototype.validateIntro = function() {
      var isValid = true
      this.introErrors = []

      if (!this.title) {
        this.introErrors.push('Title is required.')
        isValid = false
      }

      return isValid
    }

    Survey.prototype.validate = function() {
      var self = this
      var isValid = true
      var questions = _(this.views)
        .filter({ type: View.Types.QUESTION })
        .map('value')
        .value()
      var sections = _(this.views)
        .filter({ type: View.Types.SECTION })
        .map('value')
        .value()

      var questionsSansHiddenVariables = _.reject(questions, {
        type: Question.Types.HIDDEN_VARIABLES,
      })

      // clear errors
      this.errors.splice(0, this.errors.length)

      if (!this.validateIntro()) {
        isValid = false
      }

      // atleast one question(excluding HIDDEN VARIABLES) or section
      if (questionsSansHiddenVariables.length === 0 && sections.length === 0) {
        this.errors.push('At least one question/section required.')
        isValid = false
      }

      if (questionsSansHiddenVariables.length > 0) {
        // atleast one compulsory question(excluding HIDDEN VARIABLES)
        var compulsoryQuestions = _.filter(questionsSansHiddenVariables, {
          isCompulsory: true,
        })
        if (compulsoryQuestions.length === 0) {
          this.errors.push('At least one compulsory question required.')
          isValid = false
        }
      }

      // max 60 questions(excluding HIDDEN VARIABLES)
      if (
        questionsSansHiddenVariables.length > 60 &&
        !this.unlimitedQuestionsAllowed
      ) {
        this.errors.push(
          'Surveys are limited to 60 questions. Please contact us if you have unique requirements.'
        )
        isValid = false
      }

      // TODO: start + end date
      // TODO: response limit (cant be less than current responses received)

      // validate sections
      _.each(sections, function(section) {
        var beforeQuestionNumber = 0
        if (questions.length > 0) {
          var questionView = self.getViewAfter(section.id, View.Types.QUESTION)
          // if there is question after section, get the question number.
          // otherwise, set the question number to be the views length to bypass pipe validation
          beforeQuestionNumber = questionView
            ? questionView.getNumber()
            : self.views.length
        }
        if (!section.validate(beforeQuestionNumber)) {
          isValid = false
        }
      })

      // validate questions
      _.each(questions, function(question, idx) {
        if (!question.validate(idx + 1)) {
          isValid = false
        }
      })

      // validate view groups
      _.each(this.viewGroups, function(viewGroup) {
        if (!viewGroup.viewIds.length) {
          self.errors.push('Group "' + viewGroup.name + '" is incomplete')
          isValid = false
        }

        var hasInvalidViewIds = _.some(viewGroup.viewIds, function(viewId) {
          return !self.getView(viewId)
        })
        if (hasInvalidViewIds) {
          self.errors.push(
            'Group "' + viewGroup.name + '" requires valid questions/sections'
          )
          isValid = false
        }

        var hasInvalidShuffleIds = _.some(viewGroup.shuffleIds, function(
          viewId
        ) {
          if (viewId === 'all') return false
          return !self.getView(viewId)
        })
        if (hasInvalidShuffleIds) {
          self.errors.push(
            'Group "' + viewGroup.name + '" requires valid shuffle items'
          )
          isValid = false
        }

        // view groups with loops must be gapless
        if (viewGroup.loop) {
          var viewIndices = viewGroup.viewIds.map(function(viewId) {
            return self.getViewIndex(viewId)
          })
          viewIndices.sort(function(a, b) {
            return a - b
          })
          var hasGaps = !!_.find(viewIndices, function(viewIndex, arrIndex) {
            if (arrIndex === 0) return false
            if (viewIndices[arrIndex - 1] !== viewIndex - 1) return true
          })
          if (hasGaps) {
            self.errors.push(
              'Group "' +
                viewGroup.name +
                '" must be sequential when used as a loop (no gaps)'
            )
            isValid = false
          }
        }

        // validate loop lender
        if (viewGroup.loopLender.id) {
          var firstOrderedQuestion = viewGroup.getFirstOrderedQuestion(self)
          var questionNumber =
            firstOrderedQuestion && firstOrderedQuestion.getNumber()
          if (
            !viewGroup.loopLender.validate(self, viewGroup.id, questionNumber)
          ) {
            _.each(viewGroup.loopLender.errors, function(error) {
              self.errors.push('Group "' + viewGroup.name + '" ' + error)
            })
            isValid = false
          }
        }
      })

      // validate shuffle groups
      _.each(this.shuffleGroups, function(shuffleGroup) {
        if (!shuffleGroup.viewGroupIds.length) {
          self.errors.push('Shuffle group is incomplete')
          isValid = false
        }

        if (shuffleGroup.viewGroupIds.length < 2) {
          self.errors.push('At least 2 groups in shuffle group are required')
          isValid = false
        }

        var hasInvalidViewGroupIds = _.some(shuffleGroup.viewGroupIds, function(
          viewGroupId
        ) {
          var viewGroupIndex = _.findIndex(self.viewGroups, { id: viewGroupId })
          return viewGroupIndex === -1
        })
        if (hasInvalidViewGroupIds) {
          self.errors.push('Shuffle group requires valid groups')
          isValid = false
        }
      })

      // cant all be hidden
      var visible = _.filter(questions, function(question) {
        return !question.isHidden
      })
      if (questions.length && !visible.length) {
        this.errors.push('At least one question must be visible.')
        isValid = false
      }

      if (this.share) {
        // share dialog must have text
        if (this.share.enabled && !this.share.text) {
          this.errors.push('Share dialog text is required.')
          isValid = false
        }

        // share dialog must have url
        if (this.share.enabled && !this.share.url) {
          this.errors.push('Share dialog url is required.')
          isValid = false
        }
      }

      // tags cannot use the quota manager's reserved prefix - the backend strips
      // these from exports, so a user tag starting with it would vanish silently
      var reservedTags = _.filter(this.getTags(), function(tag) {
        return QuotaDefinition.isReservedTagName(tag)
      })
      if (reservedTags.length) {
        this.errors.push(
          'Tags cannot start with ' +
            QuotaDefinition.TAG_PREFIX +
            '. Please rename: ' +
            reservedTags.join(', ') +
            '.'
        )
        isValid = false
      }

      // required fields for templates
      if (this.isTemplate) {
        if (!this.description) {
          this.errors.push('Description is required.')
          isValid = false
        }
        if (!this.tags) {
          this.errors.push('At least one tag is required.')
          isValid = false
        }
      }

      return isValid
    }

    Survey.prototype.hasLogic = function() {
      return _.some(this.views, function(view) {
        return view.value.logic.length
      })
    }

    Survey.prototype.hasExitLogic = function() {
      return _.some(this.views, function(view) {
        var logic = view.value.logic
        return _.some(logic, function(logic) {
          return _.some(logic.actions, function(action) {
            return _.includes(
              [action.Types.EXIT, action.Types.QUALITYEXIT],
              action.type
            )
          })
        })
      })
    }

    Survey.prototype.canMoveUp = function(view) {
      var index = _.indexOf(this.views, view)
      return index > 0
    }

    Survey.prototype.canMoveDown = function(view) {
      var index = _.indexOf(this.views, view)
      var isLast = index === this.views.length - 1
      return !isLast
    }

    Survey.prototype.moveView = function(view, amount) {
      var fromIndex = _.indexOf(this.views, view)
      var toIndex = fromIndex + amount
      this.views.splice(toIndex, 0, this.views.splice(fromIndex, 1)[0])
    }

    Survey.prototype.canRemoveView = function(view) {
      switch (view.type) {
        case View.Types.SECTION:
          return this.canRemoveSection(view.value)
        case View.Types.QUESTION:
          return this.canRemoveQuestion(view.value)
      }
    }

    Survey.prototype.canRemoveSection = function() {
      return true
    }

    Survey.prototype.canRemoveQuestion = function(question) {
      if (question.isLocked) {
        return false
      }
      if (this.isEditRestricted()) {
        // questions can only be removed if they are new/unsaved
        return question.isNew
      }
      return true
    }

    Survey.prototype.removeView = function(view) {
      if (!this.canRemoveView(view)) {
        return
      }
      _.remove(this.views, view)
      this.setViewGroupForView(view, null)
    }

    Survey.prototype.addQuestion = function(questionOrType, index, silent) {
      var self = this
      var question
      if (questionOrType instanceof Question) {
        question = questionOrType
        question.survey = self
        question.queue = self.queue
        question.logic.forEach(function(logic) {
          logic.helpers = self.logicHelpers
        })
      } else {
        question = new Question({
          survey: self,
          type: questionOrType,
          queue: self.queue,
        })
      }
      var view = new View(this).fromQuestion(question)
      return this.addView(view, index, silent)
    }

    Survey.prototype.addSection = function(section, index, silent) {
      var self = this
      if (section instanceof Section) {
        section.survey = self
        section.queue = self.queue
        section.logic.forEach(function(logic) {
          logic.helpers = self.logicHelpers
        })
      } else {
        section = new Section({ survey: self, queue: self.queue })
      }
      var view = new View(this).fromSection(section)
      return this.addView(view, index, silent)
    }

    Survey.prototype.addView = function(view, index, silent) {
      var pos = _.isNumber(index) ? index : this.views.length
      this.views.splice(pos, 0, view)
      if (!silent) {
        $rootScope.$broadcast(Events.VIEW_ADDED, view, pos)
      }
      return view
    }

    Survey.prototype.cloneView = function(view) {
      var currentIndex = _.findIndex(this.views, view)
      var clonedView = view.clone({ cloneLogic: true })
      this.addView(clonedView, currentIndex + 1) // add after current view

      // select the cloned view in group
      var viewGroup = this.getViewGroupByViewId(view.value.id)
      if (viewGroup) {
        viewGroup.select(clonedView.value.id)
      }
      return clonedView
    }

    Survey.prototype.addFollowup = function() {
      if (this.followupView) {
        this.followupView.value.isHidden = false
      } else {
        var question = new Question({
          survey: this,
          type: Question.Types.FOLLOW_UP,
        })
        this.followupView = new View(this).fromQuestion(question)
      }
      // Ensure isFollowup is true
      this.isFollowup = true
    }

    Survey.prototype.removeFollowup = function() {
      if (this.followupView) {
        // TODO
        if (this.canRemoveQuestion(this.followupView.value)) {
          this.followupView = null
        } else {
          this.followupView.value.isHidden = true
        }
      }
      // Ensure isFollowup is false
      this.isFollowup = false
    }

    Survey.prototype.getViewGroupByViewId = function(viewId) {
      return _.find(this.viewGroups, function(group) {
        return _.includes(group.viewIds, viewId)
      })
    }

    Survey.prototype.setViewGroupForView = function(view, viewGroupId) {
      var viewId = view.value.id
      // views can only belong to one ViewGroup
      _.each(this.viewGroups, function(viewGroup) {
        if (viewGroup.id === viewGroupId) {
          viewGroup.select(viewId)
        } else {
          viewGroup.deselect(viewId)
        }
      })
    }

    // See: https://stackoverflow.com/questions/38008307/get-key-from-a-javascript-object-with-minimum-value
    Survey.prototype.assignViewGroupColor = function() {
      var palette = CORE_COLORS.slice()
      // remove one orange shade to make it easier to tell the colors apart visually
      _.pull(palette, '#ffbc00')

      var countsPerColor = _.zipObject(
        palette,
        new Array(palette.length).fill(0)
      )
      _.each(this.viewGroups, function(group) {
        if (!group.color) return // continue
        countsPerColor[group.color]++
      })
      // compose available colors by the least used colors
      var availableColors = _.keys(
        _.pickBy(countsPerColor, function(value) {
          return value === _.min(_.values(countsPerColor))
        })
      )
      return availableColors[0]
    }

    Survey.prototype.addViewGroup = function(name) {
      if (!name) {
        name = 'Group ' + (this.viewGroups.length + 1)
      }
      var viewGroup = new ViewGroup({
        name: name,
        color: this.assignViewGroupColor(),
      })
      this.viewGroups.push(viewGroup)
      return viewGroup
    }

    Survey.prototype.removeViewGroup = function(viewGroup) {
      // deselect group in shuffle group
      var shuffleGroup = this.getShuffleGroupByViewGroupId(viewGroup.id)
      if (shuffleGroup) {
        _.pull(shuffleGroup.viewGroupIds, viewGroup.id)
        // remove shuffle group when nothing is selected
        if (!shuffleGroup.viewGroupIds.length) {
          this.removeShuffleGroup(shuffleGroup)
        }
      }
      _.remove(this.viewGroups, viewGroup)
    }

    Survey.prototype.getShuffleGroupByViewGroupId = function(viewGroupId) {
      return _.find(this.shuffleGroups, function(shuffleGroup) {
        return _.includes(shuffleGroup.viewGroupIds, viewGroupId)
      })
    }

    Survey.prototype.addShuffleGroup = function() {
      var group = new ShuffleGroup()
      this.shuffleGroups.push(group)
      return group
    }

    Survey.prototype.removeShuffleGroup = function(group) {
      _.remove(this.shuffleGroups, group)
    }

    Survey.prototype.getViews = function(type) {
      if (!type) return this.views
      return this.views.filter(function(view) {
        return view.type === type
      })
    }

    Survey.prototype.getViewValues = function(type) {
      var views = this.views
      if (type) {
        views = this.views.filter(function(view) {
          return view.type === type
        })
      }
      return views.map(function(view) {
        return view.value
      })
    }

    Survey.prototype.getView = function(id) {
      return this.views.find(function(view) {
        return view.value.id === id
      })
    }

    Survey.prototype.getViewIndex = function(id) {
      return this.views.indexOf(this.getView(id))
    }

    Survey.prototype.getViewValue = function(id) {
      return this.getView(id).value
    }

    Survey.prototype.getViewsBefore = function(viewId, type) {
      var target = this.getView(viewId)
      var views = []
      var done = false
      this.views.forEach(function(view) {
        if (view === target) done = true
        if (done) return
        if (type) {
          if (view.type === type) {
            views.push(view)
          }
        } else {
          views.push(view)
        }
      })
      return views
    }

    Survey.prototype.getViewsAfter = function(viewId, type) {
      var target = this.getView(viewId)
      var views = []
      var started = false
      this.views.forEach(function(view) {
        if (view === target) started = true
        if (!started) return
        if (type) {
          if (view.type === type) {
            views.push(view)
          }
        } else {
          views.push(view)
        }
      })
      return views
    }

    Survey.prototype.getViewBefore = function(viewId, type) {
      var target = this.getView(viewId)
      var match = null
      for (var i = 0; i < this.views.length; i++) {
        var view = this.views[i]
        if (view === target) return match
        if (type) {
          if (view.type === type) {
            match = view
          }
        } else {
          match = view
        }
      }
    }

    Survey.prototype.getViewAfter = function(viewId, type) {
      var target = this.getView(viewId)
      var started = false
      for (var i = 0; i < this.views.length; i++) {
        var view = this.views[i]
        if (view === target) started = true
        if (!started) continue
        if (type) {
          if (view.type === type) {
            return view
          }
        } else {
          return view
        }
      }
    }

    Survey.prototype.getViewValuesBefore = function(viewId, type) {
      return this.getViewsBefore(viewId, type).map(function(view) {
        return view.value
      })
    }

    Survey.prototype.getViewValuesAfter = function(viewId, type) {
      return this.getViewsAfter(viewId, type).map(function(view) {
        return view.value
      })
    }

    Survey.prototype.getViewValueBefore = function(viewId, type) {
      return this.getViewBefore(viewId, type).value
    }

    Survey.prototype.getViewValueAfter = function(viewId, type) {
      return this.getViewAfter(viewId, type).value
    }

    Survey.prototype.getQuestion = function(id) {
      var view = this.getView(id)
      if (!view) return
      if (view.isQuestion()) return view.value
    }

    Survey.prototype.getQuestionCount = function() {
      return this.getQuestions().length
    }

    Survey.prototype.getQuestions = function() {
      return this.getViewValues(View.Types.QUESTION)
    }

    Survey.prototype.getQuestionsBefore = function(viewId) {
      return this.getViewValuesBefore(viewId, View.Types.QUESTION)
    }

    Survey.prototype.getQuestionsAfter = function(viewId) {
      return this.getViewValuesAfter(viewId, View.Types.QUESTION)
    }

    Survey.prototype.getSection = function(id) {
      var view = this.getView(id)
      if (!view) return
      if (view.isSection()) return view.value
    }

    Survey.prototype.getSectionCount = function() {
      return this.getSections().length
    }

    Survey.prototype.getSections = function() {
      return this.getViewValues(View.Types.SECTION)
    }

    Survey.prototype.getSectionsBefore = function(viewId) {
      return this.getViewValuesBefore(viewId, View.Types.SECTION)
    }

    Survey.prototype.getSectionsAfter = function(viewId) {
      return this.getViewValuesAfter(viewId, View.Types.SECTION)
    }

    Survey.prototype.calculateLoi = function() {
      this.lengthOfInterview.set(this.getLOIEstimate())
    }

    Survey.prototype.getTags = function() {
      var tags = []
      _.each(this.views, function(view) {
        _.each(view.getLogic(), function(logic) {
          tags = _.concat(tags, logic.getTags())
        })
      })
      return _.uniq(tags)
    }

    Survey.prototype.getTagQuotas = function() {
      var tagQuotas = this.tagQuotaSettings.tagQuotas || {}
      var tagCounts = this.tagCounts || {}
      return _.map(this.getTags(), function(tag) {
        return {
          name: tag,
          quota: _.isNumber(tagQuotas[tag]) ? tagQuotas[tag] : null,
          count: tagCounts[tag] || 0,
        }
      })
    }

    Survey.prototype.getLists = function() {
      var self = this
      var lists = {}
      _.each(self.views, function(view) {
        var logic = view.getLogic()
        _.each(logic, function(logic) {
          _.each(logic.actions, function(action) {
            if (!action.list) return
            if (!lists[action.list]) lists[action.list] = []
            if (!action.listItem) return
            if (!_.includes(lists[action.list], action.listItem)) {
              lists[action.list].push(action.listItem)
            }
          })
        })
      })
      return lists
    }

    Survey.prototype.getLOIEstimate = function() {
      var self = this
      var seconds = 0
      _.each(self.views, function(view) {
        if (view.isSection()) {
          seconds += 5
          if (view.value.mediaType === view.value.MediaTypes.VIDEO_UPLOAD) {
            seconds += Math.round(view.value.video.duration || 0)
          }
        }
        if (view.isQuestion()) {
          if (view.value.isHidden) {
            return
          }
          switch (view.value.type) {
            case Question.Types.CHOICE:
            case Question.Types.SCALE:
            case Question.Types.NPS:
            case Question.Types.MOOD:
            case Question.Types.RATING:
            case Question.Types.NUMERIC:
            case Question.Types.LOCATION:
              seconds += 10
              break
            case Question.Types.SINGLE_TEXT:
            case Question.Types.PLACES_NEAR_ME:
            case Question.Types.SCAN:
            case Question.Types.RANK:
            case Question.Types.IMAGE:
            case Question.Types.FOLLOW_UP:
              seconds += 15
              break
            case Question.Types.TEXT:
              seconds += 25
              break
            case Question.Types.MATRIX:
              // https://trello.com/c/FceOfgYS/177-improved-matrix-weighting
              // 6 seconds to read the question/description
              seconds += 6
              // 1 second to glance the choice format, this is usually
              // committed to memory as they answer each statement so only happens
              // once
              seconds += 1
              // 3.5 seconds to read statement, glance choices and select
              seconds += 4 * view.value.statements.length
              break
            case Question.Types.CONSTANT_SUM:
            case Question.Types.SCORE:
              if (view.value.matrixEnabled) {
                // same as MATRIX question
                seconds += 6
                seconds += 1
                seconds += 4 * view.value.statements.length
              } else {
                // same as CHOICE question
                seconds += 10
              }
              break
            case Question.Types.HIDDEN_VARIABLES:
              // not applicable
              break
          }
        }
      })
      return seconds
    }

    Survey.prototype.isFirstQuestion = function(question) {
      return _.first(this.getQuestions()) === question
    }

    Survey.prototype.isLastQuestion = function(question) {
      return _.last(this.getQuestions()) === question
    }

    Survey.prototype.upsertLink = function(updatedLink) {
      var link = _.find(this.links, { fragment: updatedLink.fragment })

      if (link) {
        angular.copy(updatedLink, link)
      } else {
        this.links.push(updatedLink)
      }
    }

    Survey.prototype.removeLink = function(deletedLink) {
      _.remove(this.links, { fragment: deletedLink.fragment })
    }

    Survey.prototype.isOutdated = function() {
      return this.serverVersion !== this.version
    }

    Survey.prototype.rewriteLabels = function(labelsToRewrite) {
      // labelsToRewrite: { [questionId|sectionId|choiceId|statementId]: "newLabel" }
      // shared reports might have rewritten labels for question, section, choice and statement
      // this method is to apply the rewritten labels on this survey
      function doRewrite(obj, field) {
        var newLabel = labelsToRewrite[obj.id]
        if (newLabel) {
          obj[field] = newLabel
        }
      }
      this.views.forEach(function(view) {
        if (view.isQuestion()) {
          var question = view.value
          doRewrite(question, 'title')
          question.choices.forEach(function(choice) {
            doRewrite(choice, 'label')
          })
          question.statements.forEach(function(statement) {
            doRewrite(statement, 'label')
          })
        }
        if (view.isSection()) {
          doRewrite(view.value, 'title')
        }
      })
    }

    Survey.prototype.transform = function(payload) {
      var self = this

      // Mark user-modified as false so warning will show on manual editor
      this.ai.surveyModifiedByUser = false

      // Flag has unsaved so that manual editor will try to save on init
      this.ai.hasUnsaved = true

      // Mark as devorigin so that the remote brief worker ignore the survey
      this.ai.isDevOrigin = configService.isDevelopment()

      this.ai.conversationId = payload.conversationId
      this.ai.surveyId = payload.survey.id
      console.log('transform', _.cloneDeep(payload), _.cloneDeep(this.ai))

      this.title = payload.survey.title

      this.views = _.map(payload.survey.views, function(viewData) {
        if (viewData.type === 'section') {
          var section = new Section({
            survey: self,
            queue: self.queue,
          }).deserialize(viewData)
          return new View(self).fromSection(section)
        }

        viewData.data = {
          description: viewData.description,
          textValidator:
            viewData.validator === 'TEXT' ? null : viewData.validator,
          minCharacters:
            _.isNumber(viewData.minLength) && viewData.minLength > 0
              ? viewData.minLength
              : null,
          matrixEnabled: viewData.behaviour === 'matrix',
          scoreType: viewData.scoreType,
          logic: viewData.logic,
        }

        if (viewData.type === 'numeric') {
          // default numeric semantic differential
          viewData.data.numericDiff = true
          viewData.data.numericDiffLeft = 'Not important'
          viewData.data.numericDiffRight = 'Very important'
        }

        viewData.numericTypeConstraint = viewData.numericConstraint
        delete viewData.numericConstraint

        var question = new Question({
          survey: self,
          type: viewData.type,
          queue: self.queue,
        })

        if (['nps', 'rating', 'mood'].includes(question.type)) {
          delete viewData.choices
          var defaultChoices = question.choices.slice()
          question.deserialize(viewData)
          question.choices = defaultChoices
        } else {
          question.deserialize(viewData)
        }

        return new View(self).fromQuestion(question)
      })
    }

    // Aggregate all errors from children (questions/sections first, then survey-level)
    Survey.prototype.aggregateErrors = function() {
      var allErrors = []
      // Question errors (highest priority)
      _.each(this.questions, function(question, idx) {
        _.each(question.errors, function(message) {
          allErrors.push({
            message: message,
            source: {
              type: 'question',
              id: question.id,
              number: idx + 1,
              questionType: question.type,
              title: question.title,
            },
          })
        })
      })
      // Section errors
      _.each(this.sections, function(section, idx) {
        _.each(section.errors, function(message) {
          allErrors.push({
            message: message,
            source: {
              type: 'section',
              id: section.id,
              number: idx + 1,
              title: section.title,
            },
          })
        })
      })
      // Survey-level errors
      _.each(this.errors, function(message) {
        allErrors.push({
          message: message,
          source: { type: 'survey' },
        })
      })
      // Deduplicate by message + source id
      return _.uniqBy(allErrors, function(err) {
        return err.message + (err.source.id || '')
      })
    }

    return Survey
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "$rootScope", "api", "Survey", "Question", "View", "configService", "imageService", "userService", "kitsService", "surveysResource", "questionTemplatesResource", "surveyTemplatesResource", "projectSurveysResource"];
  angular.module('glow.components').service('surveyServiceNext', Service)

  /* @ngInject */
  function Service(
    $q,
    $rootScope,
    api,
    Survey,
    Question,
    View,
    configService,
    imageService,
    userService,
    kitsService,
    surveysResource,
    questionTemplatesResource,
    surveyTemplatesResource,
    projectSurveysResource
  ) {
    this.get = get
    // this.getByProject = getByProject;
    this.save = save
    this.archive = archive
    this.unArchive = unArchive
    this.changeProject = changeProject
    this.setImage = setImage
    this.setListImage = setListImage
    this.fetchVersion = fetchVersion

    function get(id) {
      if (id === 'new') {
        return $q.resolve(new Survey())
      }
      return api.surveys.get({ id: id }).then(function(data) {
        return new Survey().deserialize(data)
      })
    }

    /**
     * ISSUE
     * ----
     * This service was built to work with survey-factory instances but the
     * endpoint below only returns partial survey data.
     * We need to get the whole survey or we're going to have to create
     * and entirely new "project-survey" factory and service - which is
     * probably the worst thing we can do
     */
    // function getByProject (projectId) {
    //     return $q(function (resolve, reject) {
    //         projectSurveysResource
    //             .get({ projectId: projectId })
    //             .success(function (response) {
    //                 var surveys = _.map(response, function (survey) {
    //                     return new Survey().deserialize(survey);
    //                 });
    //                 removeObsolete(surveys);
    //                 // TODO: pull in the order() method from old survey service
    //                 resolve(surveys);
    //             })
    //             .error(reject);
    //     });
    // }

    function save(survey) {
      return survey.queue.all().then(function() {
        var isValid = survey.validate()
        if (!isValid) {
          return $q.reject({ errors: true })
        }

        var promise = syncCoreProfile(survey)
          .then(persist)
          .then(initOutlink)
          .then(saveKits)
          .then(refresh)

        survey.queue.add(promise, 'Saving')
        return promise
      })
    }

    // TODO: should this be here or in the survey factory? And should it be added immediately like followup?
    // If added immediately then can create logic like "jump to CUP"
    function syncCoreProfile(survey) {
      // skip if template
      if (survey.isTemplate) {
        return $q.resolve(survey)
      }
      // skip if they're already added
      if (survey.coreProfile.added) {
        return $q.resolve(survey)
      }
      // skip if its not enabled
      if (!survey.coreProfile.enabled) {
        return $q.resolve(survey)
      }
      // TODO: move this to questionTemplateService...
      return $q(function(resolve, reject) {
        var options = {
          groupId: userService.getSubscriberId(),
          profilingKeys: ['age_year_of_birth', 'sex', 'location'].join(','),
        }
        questionTemplatesResource
          .getCoreProfileTemplates(options)
          .success(function(x, templates) {
            // extract and flatten questions from the templates
            // TODO this will cause issues if there are multiple published variants for a CUP question...
            var questions = _.flatMap(templates, 'questions')

            // exclude non-published questions
            _.remove(questions, function(question) {
              return question.state !== 'PUBLISHED'
            })

            // exclude irrelevant profile key questions
            var keys = ['age_year_of_birth', 'sex', 'location']
            _.remove(questions, function(question) {
              return !(
                question.profiling && _.includes(keys, question.profiling.key)
              )
            })

            // order by sex, age_year_of_birth, location, other
            var order = {
              sex: 1,
              age_year_of_birth: 2,
              location: 3,
              else: 4,
            }
            questions = _.orderBy(questions, function(question) {
              return order[question.profiling.key] || order.else
            })

            // fail if none
            if (!questions.length) {
              console.error(
                'survey indicated to add core-profiling questions but none were returned from the backend'
              )
              return reject()
            }

            var views = _.map(questions, function(question) {
              delete question.id
              var q = new Question({ survey: survey, queue: survey.queue })
                .deserialize(question)
                .clone()
              return new View(survey).fromQuestion(q)
            })

            survey.coreProfile.views = views
            survey.coreProfile.added = true
            resolve(survey)
          })
          .error(function(data, status) {
            reject({ data: data, status: status })
          })
      })
    }

    function persist(survey) {
      return $q(function(resolve, reject) {
        var data = survey.serialize()
        var action = data.id ? 'update' : 'create'
        var resource
        var eventName

        if (!survey.isTemplate) {
          resource = data.id ? surveysResource : projectSurveysResource
          eventName = data.id ? Survey.Events.UPDATED : Survey.Events.CREATED
        } else {
          resource = surveyTemplatesResource
          eventName = data.id
            ? Survey.Events.UPDATED_TEMPLATE
            : Survey.Events.CREATED_TEMPLATE
        }

        resource[action](data)
          .success(function(x, response) {
            if (response.id) {
              survey.id = response.id
              survey.wasJustCreated = true
            }
            resolve(survey)
            $rootScope.$broadcast(eventName, survey)
          })
          .error(function(data, status) {
            reject({ data: data, status: status })
          })
      })
    }

    function saveKits(survey) {
      if (!survey.isTemplate) {
        return $q.resolve(survey)
      }
      return kitsService
        .assignKitsToSurvey(survey.id, survey.serverData.kits, survey.kits)
        .then(function() {
          return survey
        })
    }

    function refresh(survey) {
      return $q(function(resolve) {
        var isTemplate = !!survey.isTemplate
        var resource = isTemplate ? surveyTemplatesResource : surveysResource
        var eventName = isTemplate
          ? Survey.Events.REFRESH_TEMPLATE
          : Survey.Events.REFRESH
        resource.get({ id: survey.id }).success(function(x, response) {
          survey.deserialize(response)
          survey.isTemplate = isTemplate // backend doesn't return this?
          $rootScope.$broadcast(eventName, response)
          resolve(survey)
        })
      })
    }

    function initOutlink(survey) {
      // after the survey is first saved, we need to update any outlink links
      // to use the survey id that it was given
      if (!survey.wasJustCreated) {
        return $q.resolve(survey)
      }
      var outlink = survey.outlink
      if (!outlink || !outlink.enabled) {
        return $q.resolve(survey)
      }
      var promises = []
      promises.push(
        api.links.modifyByShortUrl({
          shortUrl: outlink.submitLink,
          longUrl: configService.getUserPortalUrl(
            '/survey/' + survey.id + '?outlink=submit'
          ),
        })
      )
      promises.push(
        api.links.modifyByShortUrl({
          shortUrl: outlink.exitLink,
          longUrl: configService.getUserPortalUrl(
            '/survey/' + survey.id + '?outlink=exit'
          ),
        })
      )
      promises.push(
        api.links.modifyByShortUrl({
          shortUrl: outlink.quotaLink,
          longUrl: configService.getUserPortalUrl(
            '/survey/' + survey.id + '?outlink=quota'
          ),
        })
      )
      promises.push(
        api.links.modifyByShortUrl({
          shortUrl: outlink.qualityExitLink,
          longUrl: configService.getUserPortalUrl(
            '/survey/' + survey.id + '?outlink=qualityExit'
          ),
        })
      )
      return $q.all(promises).then(function() {
        return survey
      })
    }

    function archive(survey) {
      return $q(function(resolve, reject) {
        if (survey.isArchived) {
          return resolve()
        }

        // optimistic property updates
        survey.previousUpdatedAt = survey.updatedAt
        survey.updatedAt = moment().toISOString()
        survey.isArchived = true

        surveysResource
          .archive({ id: survey.id })
          .success(function() {
            resolve()
          })
          .error(function() {
            survey.updatedAt = survey.previousUpdatedAt
            survey.isArchived = false
            reject()
          })
      })
    }

    function unArchive(survey) {
      return $q(function(resolve, reject) {
        if (!survey.isArchived) {
          return resolve()
        }

        // optimistic property updates
        survey.previousUpdatedAt = survey.updatedAt
        survey.updatedAt = moment().toISOString()
        survey.isArchived = false

        surveysResource
          .unArchive({ id: survey.id })
          .success(function() {
            resolve()
          })
          .error(function() {
            survey.updatedAt = survey.previousUpdatedAt
            survey.isArchived = true
            reject()
          })
      })
    }

    function changeProject(surveyId, projectId) {
      return api.surveys.changeProject({ id: surveyId, projectId: projectId })
    }

    function setImage(survey, imageData) {
      if (!imageData) {
        survey.imageUrl = null
        return $q.resolve()
      }
      var promise = imageService.create(imageData).then(function(imageUrl) {
        survey.imageUrl = imageUrl
      })
      survey.queue.add(promise, 'Uploading Image')
      return promise
    }

    function setListImage(survey, imageData) {
      if (!imageData) {
        survey.listImageUrl = null
        return $q.resolve()
      }
      var promise = imageService.create(imageData).then(function(imageUrl) {
        survey.listImageUrl = imageUrl
      })
      survey.queue.add(promise, 'Uploading List Image')
      return promise
    }

    function fetchVersion(survey) {
      return api.surveys.getVersion({ id: survey.id }).then(function(data) {
        survey.serverVersion = data.version
        return data.version
      })
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('TagQuotaSettings', Factory)

  /* @ngInject */
  function Factory() {
    var Types = {
      ALL: 'ALL',
      ANY: 'ANY',
      NONE: 'NONE',
    }

    function TagQuotaSettings() {
      this.applyDefaults()
    }

    TagQuotaSettings.prototype.Types = TagQuotaSettings.Types = Types

    TagQuotaSettings.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        tagQuotas: {},
        enabled: false,
        type: Types.ALL,
        channelIds: [],
      })
    }

    TagQuotaSettings.prototype.deserialize = function(data) {
      data = _.isPlainObject(data) ? data : {}

      this.tagQuotas = _.isPlainObject(data.tagQuotas) ? data.tagQuotas : {}
      this.enabled = data.enabled
      this.type = data.type
      this.channelIds = data.channelIds

      this.applyDefaults()
      return this
    }

    TagQuotaSettings.prototype.serialize = function() {
      var data = {}

      data.tagQuotas = this.tagQuotas
      data.enabled = this.enabled
      data.type = this.type
      data.channelIds = this.channelIds

      return data
    }

    return TagQuotaSettings
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils", "Choice", "Lender", "View"];
  angular.module('glow.components').factory('ViewGroup', Factory)

  /* @ngInject */
  function Factory(glUtils, Choice, Lender, View) {
    function ViewGroup(options) {
      this.applyDefaults(options)
    }

    ViewGroup.prototype.applyDefaults = function(options) {
      options = options || {}
      _.defaults(this, options, {
        id: glUtils.uuid(),
        name: null,
        viewIds: [],
        shuffleIds: [],
        color: null,
        sample: null,
        loop: false,
        loopVariables: [],
        loopLender: new Lender(),
        loopRandomize: null,
        loopImagesEnabled: false,
      })
    }

    ViewGroup.prototype.deserialize = function(data) {
      data = data || {}
      this.id = data.id
      this.name = data.name
      this.viewIds = data.viewIds

      this.shuffleIds = data.shuffleIds
      if (this.shuffleIds.length === this.viewIds.length) {
        this.shuffleIds.push('all')
      }

      this.color = data.color
      this.sample = data.sample
      this.loop = data.loop
      this.loopVariables = []
      if (data.loopVariables) {
        this.loopVariables = data.loopVariables.map(function(data) {
          return new Choice().deserialize(data)
        })
      }
      this.loopLender.deserialize(data.loopLender)
      this.loopRandomize = data.loopRandomize
      this.loopImagesEnabled = data.loopImagesEnabled
      this.applyDefaults()
      return this
    }

    ViewGroup.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.name = this.name
      data.viewIds = this.viewIds.slice()

      data.shuffleIds = this.shuffleIds.slice()
      _.pull(data.shuffleIds, 'all')

      data.color = this.color
      data.sample = this.sample
      data.loop = this.loop
      data.loopVariables = this.loopVariables.map(function(choice) {
        return choice.serialize()
      })
      data.loopLender = this.loopLender.serialize()
      data.loopRandomize = this.loopRandomize
      data.loopImagesEnabled = this.loopImagesEnabled
      return data
    }

    ViewGroup.prototype.select = function(viewId) {
      if (_.includes(this.viewIds, viewId)) return
      this.viewIds.push(viewId)
    }

    ViewGroup.prototype.deselect = function(viewId) {
      _.pull(this.viewIds, viewId)
      // also deselect from shuffle items
      _.pull(this.shuffleIds, viewId)
    }

    ViewGroup.prototype.copyLoopVariablesFrom = function(
      questionId,
      target,
      survey
    ) {
      // IMPORTANT: a sister piece of code for this exists in Question.copyChoicesFrom
      var question = survey.getQuestion(questionId)
      if (!question) return

      var choicesOrStatements =
        target === 'STATEMENTS'
          ? question.getAllStatements(true)
          : question.getAllChoices(true)

      this.loopLender.clear()
      this.loopVariables = choicesOrStatements.map(function(choice) {
        choice = choice.clone() // not a real clone, gives new ID
        choice.type = Choice.Types.CHOICE
        return choice
      })
    }

    ViewGroup.prototype.borrowLoopVariablesFrom = function(questionId, survey) {
      // IMPORTANT: a sister piece of code for this exists in Question.borrowChoicesFrom
      var lenderQuestion = survey.getQuestion(questionId)
      this.loopLender.clear()
      if (lenderQuestion) {
        this.loopLender.id = lenderQuestion.id
        // if its not matrix it will target choices
        if (!lenderQuestion.isUsedAsMatrix()) {
          this.loopLender.target = this.loopLender.Target.CHOICES
        }
      }
    }

    ViewGroup.prototype.addLoopVariable = function(
      newChoice,
      atIndex,
      shouldReplace
    ) {
      // IMPORTANT: a sister piece of code for this exists in Question.addChoice
      newChoice = new Choice(newChoice)
      newChoice.type = Choice.Types.CHOICE
      if (!_.isNumber(atIndex)) {
        atIndex = this.loopVariables.length
      }
      if (shouldReplace) {
        this.loopVariables[atIndex] = newChoice
      } else {
        this.loopVariables.splice(atIndex, 0, newChoice)
      }
      return newChoice
    }

    ViewGroup.prototype.getLoopVariables = function(survey) {
      var variables = []
      if (!this.loop) return variables
      if (this.loopLender.id) {
        var question = survey.getQuestion(this.loopLender.id)
        var options = this.loopLender.targetsChoices()
          ? question.getProjectedChoices(false)
          : question.getProjectedStatements(false)
        options.forEach(function(option) {
          variables.push({
            id: option.id,
            label: option.value,
            isBorrowed: true,
          })
        })
      }
      this.loopVariables.forEach(function(variable) {
        variables.push({
          id: variable.id,
          label: variable.value,
        })
      })
      return variables
    }

    ViewGroup.prototype.getLoopVariableOptions = function(survey) {
      return this.getLoopVariables(survey).map(function(variable) {
        return {
          label: variable.label,
          value: variable.id,
        }
      })
    }

    ViewGroup.prototype.getOrderedViews = function(survey) {
      if (!this.viewIds.length) return null
      var views = this.viewIds.map(function(viewId) {
        return survey.getView(viewId)
      })
      return _.orderBy(views, function(view) {
        return survey.views.indexOf(view)
      })
    }

    ViewGroup.prototype.getFirstOrderedView = function(survey) {
      var orderedViews = this.getOrderedViews(survey)
      return orderedViews && orderedViews[0]
    }

    ViewGroup.prototype.getFirstOrderedQuestion = function(survey) {
      var orderedViews = this.getOrderedViews(survey)
      return orderedViews && _.find(orderedViews, { type: View.Types.QUESTION })
    }

    ViewGroup.prototype.getPrevQuestions = function(survey) {
      if (!this.viewIds.length) return []
      var firstOrderedView = this.getFirstOrderedView(survey)
      return survey.getQuestionsBefore(firstOrderedView.value.id)
    }

    ViewGroup.prototype.refresh = function(getId) {
      this.idOld = this.id
      this.id = getId ? getId(this.idOld) : glUtils.uuid()

      this.viewIds = _.map(this.viewIds, function(oldId) {
        return getId(oldId, true)
      })

      this.shuffleIds = _.map(this.shuffleIds, function(oldId) {
        return getId(oldId, true)
      })

      this.loopLender.rebind(getId)
      this.loopVariables.forEach(function(choice) {
        choice.refresh(getId)
      })
    }

    return ViewGroup
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils", "Question", "Section"];
  angular.module('glow.components').factory('View', Factory)

  /* @ngInject */
  function Factory(glUtils, Question, Section) {
    var Types = {
      INTRO: 'INTRO',
      QUESTION: 'QUESTION',
      SECTION: 'SECTION',
    }

    function View(survey) {
      this.survey = survey
      this.type = null
      this.value = null
      this.errors = []
    }

    View.prototype.Types = View.Types = Types

    View.prototype.deserialize = function(data, getQuestionById) {
      var self = this
      this.type = data.type
      if (this.type === Types.QUESTION) {
        this.value = new Question({
          survey: self.survey,
          queue: self.survey.queue,
        }).deserialize(getQuestionById(data.value))
      }
      if (this.type === Types.SECTION) {
        this.value = new Section({
          survey: self.survey,
          queue: self.survey.queue,
        }).deserialize(data.value)
      }
      if (this.value) {
        this.value.view = this
      }
      return this
    }

    View.prototype.serialize = function(setQuestionData) {
      var data = {}
      data.type = this.type // IMPORTANT: this field is used by BE for section duration (see: https://engagementinnovation.atlassian.net/wiki/spaces/EICDEV/pages/2310701069/Section+Duration)
      if (this.type === Types.QUESTION) {
        // questions are stored as a ref!
        data.value = this.value.id
        setQuestionData(this.value.serialize())
      }
      if (this.type === Types.SECTION) {
        // sections are stored serialized
        data.value = this.value.serialize()
      }
      return data
    }

    View.prototype.asIntro = function() {
      this.type = Types.INTRO
      this.value = null
      return this
    }

    View.prototype.fromQuestion = function(question) {
      this.type = Types.QUESTION
      this.value = question
      this.value.view = this
      return this
    }

    View.prototype.fromSection = function(section) {
      this.type = Types.SECTION
      this.value = section
      this.value.view = this
      return this
    }

    View.prototype.isIntro = function() {
      return this.type === Types.INTRO
    }

    View.prototype.isQuestion = function() {
      return this.type === Types.QUESTION
    }

    View.prototype.isSection = function() {
      return this.type === Types.SECTION
    }

    View.prototype.isType = function(types) {
      if (!_.isArray(types)) types = [types]
      return _.includes(types, this.type)
    }

    View.prototype.getTitleLabel = function(options) {
      options = options || {} /* number, markdown */
      var label = this.getTitle()
      if (options.number) {
        var number = this.getNumber()
        if (this.isQuestion()) {
          label = 'Q' + number + ': ' + label
        }
        if (this.isSection()) {
          label = 'S' + number + ': ' + label
        }
      }
      if (options.markdown) {
        label = window.marked(label)
      }
      return label
    }

    View.prototype.getTitle = function() {
      var title
      if (this.isQuestion()) {
        title = this.value.title
      }
      if (this.isSection()) {
        title = this.value.title
      }
      return title || 'Untitled'
    }

    View.prototype.getNumber = function() {
      var viewsOfType = _.filter(this.survey.views, { type: this.type })
      var idx = _.findIndex(viewsOfType, this)
      return idx + 1
    }

    View.prototype.getIndex = function() {
      return this.survey.views.indexOf(this)
    }

    View.prototype.getLogic = function() {
      return this.value.logic || []
    }

    View.prototype.validate = function() {
      var isValid = true
      _.remove(this.errors) // clear errors
      // if (!this.title) {
      //   this.errors.push('Title is required')
      //   isValid = false
      // }
      return isValid
    }

    View.prototype.clone = function(options) {
      var view = new View(this.survey)
      view.type = this.type
      view.value = this.value.clone(options)
      view.value.view = view
      return view
    }

    View.prototype.refresh = function(getId) {
      this.value.refresh(getId)
      return this
    }

    return View
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["Theme"];
  angular.module('glow.components').factory('ThemeContext', Factory)

  /* @ngInject */
  function Factory(Theme) {
    function ThemeContext() {
      /**
       * This field tells us where the ThemeContext is being used.
       * Options: SUBSCRIBER, SURVEY, QUESTION
       */
      this.type = null
      /**
       * This field tells us where we should get our theme from.
       *
       * The value of this field can be:
       * A) A context reference: GLOW, SUBSCRIBER, SURVEY, CUSTOM
       * B) A preset guid
       *
       * Each context type has its own options in a hierarchical manner:
       *
       * SUBSCRIBER: GLOW, <...PRESET_ID>, CUSTOM                     (default: GLOW)
       * SURVEY: GLOW, SUBSCRIBER, <...PRESET_ID>, CUSTOM             (default: SUBSCRIBER)
       * QUESTION: GLOW, SUBSCRIBER, SURVEY, <...PRESET_ID>, CUSTOM   (default: SURVEY)
       */
      this.target = null
      /**
       * This field stores the custom theme colors etc for this context.
       * Only used when target=CUSTOM.
       */
      this.custom = new Theme()
      /**
       * This field stores the preset themes.
       * Only used when type=SUBSCRIBER (only subscribers store presets as they are account global)
       */
      this.presets = []
    }

    ThemeContext.prototype.deserialize = function(data) {
      if (!data) return this
      this.type = data.type
      this.target = data.target
      this.custom.deserialize(data.custom)
      this.presets = data.presets.map(function(data) {
        return new Theme().deserialize(data)
      })
      this.snapshot()
      return this
    }

    ThemeContext.prototype.serialize = function() {
      var data = {}
      data.type = this.type
      data.target = this.target
      data.custom = this.custom.serialize()
      data.presets = this.presets.map(function(preset) {
        return preset.serialize()
      })
      return data
    }

    ThemeContext.prototype.asSubscriberDefault = function() {
      this.type = 'SUBSCRIBER'
      this.target = 'GLOW'
      return this
    }

    ThemeContext.prototype.asSurveyDefault = function() {
      this.type = 'SURVEY'
      this.target = 'SUBSCRIBER'
      return this
    }

    ThemeContext.prototype.asQuestionDefault = function() {
      this.type = 'QUESTION'
      this.target = 'SURVEY'
      return this
    }

    ThemeContext.prototype.validate = function() {
      var errors = []
      if (this.type === 'SUBSCRIBER') {
        if (!['GLOW', 'PRESET', 'CUSTOM'].includes(this.target)) {
          err('invalid target (' + this.target + ') for type: ' + this.type)
        }
      }
      if (this.type === 'SURVEY') {
        if (!['GLOW', 'SUBSCRIBER', 'PRESET', 'CUSTOM'].includes(this.target)) {
          err('invalid target (' + this.target + ') for type: ' + this.type)
        }
      }
      if (this.type === 'QUESTION') {
        if (
          !['GLOW', 'SUBSCRIBER', 'SURVEY', 'PRESET', 'CUSTOM'].includes(
            this.target
          )
        ) {
          err('invalid target (' + this.target + ') for type: ' + this.type)
        }
      }
      if (this.type === 'PRESET' && !this.presetId) {
        err('target is PRESET but no presetId is set')
      }
      if (this.type !== 'SUBSCRIBER' && this.presets.length) {
        err('presets not allowed on type' + this.type)
      }
      this.errors = errors
      return errors.length === 0
    }

    function err(msg) {
      throw new Error('[ThemeContext] ' + msg)
    }

    ThemeContext.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()

      // Take a snapshot of the custom theme and each preset
      this.custom.snapshot()
      _.each(this.presets, function(preset) {
        preset.snapshot()
      })
    }

    ThemeContext.prototype.isUnsaved = function() {
      return (
        JSON.stringify(this.lastSnapshot) !== JSON.stringify(this.serialize())
      )
    }

    return ThemeContext
  }
})()

;(function() {
  'use strict'

  Factory.$inject = ["glUtils"];
  angular.module('glow.components').factory('Theme', Factory)

  /* @ngInject */
  function Factory(glUtils) {
    /**
     * Themes dictate what charts should look like.
     * This may grow to support visual changes on things other than charts
     * such as shared-report logos, chart logos, respondent survey colors, etc.
     */
    function Theme() {
      /**
       * Thie field uniquely identifies the theme.
       * Only used for presets, referenced by ThemeContext.target in some cases
       * Ignored by custom themes.
       */
      this.id = glUtils.uuid()
      /**
       * This field is used to give a preset a name.
       * Only used for presets, ignored in custom themes.
       */
      this.name = null
      /**
       * This field holds an array of hex colors, eg `#FF6600`.
       * Used for standard (non-linear) chart colors.
       */
      this.standard = []
      /**
       * This field holds an array of hex colors, eg `#FF6600`.
       * Used for linear/scale based chart colors.
       */
      this.linear = []
    }

    Theme.prototype.deserialize = function(data) {
      this.id = data.id
      this.name = data.name
      this.standard = data.standard
      this.linear = data.linear
      this.snapshot()
      return this
    }

    Theme.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.name = this.name
      data.standard = this.standard.slice()
      data.linear = this.linear.slice()
      return data
    }

    Theme.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    Theme.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    Theme.prototype.validate = function() {
      var errors = []
      if (!this.standard.length) {
        errors.push('At least one standard color required')
      }
      if (!this.linear.length) {
        errors.push('At least one linear color required')
      }
      this.errors = errors
      return errors.length === 0
    }

    Theme.prototype.clone = function() {
      return new Theme().deserialize(this.serialize())
    }

    Theme.prototype.refresh = function() {
      this.id = glUtils.uuid()
      this.name = null
      return this
    }

    return Theme
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["Theme", "colors"];
  angular.module('glow.components').service('themeService', Service)

  /* @ngInject */
  function Service(Theme, colors) {
    var glowTheme = new Theme().deserialize({
      id: null,
      name: null,
      standard: colors.CORE_COLORS.slice(),
      linear: colors.CORE_GRADIENT.slice(),
    })

    this.resolveTheme = resolveTheme

    function resolveTheme(context, subscriberContext, surveyContext) {
      if (context.target === 'SUBSCRIBER') {
        return resolveTheme(subscriberContext, subscriberContext, surveyContext)
      }
      if (context.target === 'SURVEY') {
        return resolveTheme(surveyContext, subscriberContext, surveyContext)
      }
      if (context.target === 'GLOW') {
        return glowTheme
      }
      if (context.target === 'CUSTOM') {
        return context.custom
      }
      var preset = subscriberContext.presets.find(function(preset) {
        return preset.id === context.target
      })
      return preset || glowTheme
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('Timer', Factory)

  /* @ngInject */
  function Factory() {
    function Timer(options) {
      _.defaults(this, options, {
        totalDuration: null, // milliseconds
        lastDuration: null, // milliseconds
        startedAt: null,
        stoppedAt: null,
        isActive: false,
      })
    }

    Timer.prototype.start = function() {
      if (this.isActive) return

      this.startedAt = moment()
      this.isActive = true
    }

    Timer.prototype.stop = function() {
      if (!this.isActive) return

      this.stoppedAt = moment()
      this.isActive = false

      this.lastDuration = this.stoppedAt.diff(this.startedAt, 'milliseconds')
      this.totalDuration = _.isNumber(this.totalDuration)
        ? this.totalDuration + this.lastDuration
        : this.lastDuration
    }

    Timer.prototype.reset = function() {
      this.stop()
      this.totalDuration = null
      this.lastDuration = null
      this.startedAt = null
      this.stoppedAt = null
      this.isActive = false
    }

    Timer.prototype.getDurationInSeconds = function(precision) {
      var duration = _.isNumber(this.totalDuration)
        ? _.round(this.totalDuration / 1000, precision)
        : null
      return duration
    }

    return Timer
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$window"];
  angular.module('glow.components').component('visibilityTimer', {
    controller: Controller,
    bindings: {
      timer: '<',
    },
  })

  /* @ngInject */
  function Controller($window) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy

    // IMPORTANT
    // using this component where an iframe exist in the page or
    // there are components that could trigger a popup such as
    // video player Picture-in-Picture toggle
    // could trigger blur event and might cause timer not
    // capturing duration as intended
    // related issue : https://trello.com/c/jBNorJle

    function onInit() {
      startTimer()
      $window.addEventListener('focus', startTimer)
      $window.addEventListener('blur', stopTimer)
    }

    function startTimer() {
      if (!document.hasFocus()) return

      stopTimer()
      ctrl.timer.start()
    }

    function stopTimer() {
      ctrl.timer.stop()
    }

    function onDestroy() {
      stopTimer()
      $window.removeEventListener('focus', startTimer)
      $window.removeEventListener('blur', stopTimer)
    }
  }
})()

;(function() {
  'use strict'

  glToastDirective.$inject = ["$interval", "glToast"];
  angular
    .module('glow.components.toast', [])
    .directive('glToast', glToastDirective)

  /* @ngInject */
  function glToastDirective($interval, glToast) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: 'toast.template.html',
      link: link,
    }

    function link(scope, element) {
      var timeout

      function createTimeout(time) {
        return $interval(
          function() {
            glToast.remove(scope.toastId)
          },
          time,
          1
        )
      }

      // pause timeout while mouse over
      element.on('mouseenter', function() {
        if (timeout) {
          $interval.cancel(timeout)
        }
      })

      // restart timeout on mouseout
      element.on('mouseleave', function() {
        if (
          scope.options.timeout === 0 &&
          scope.options.extendedTimeout === 0
        ) {
          return
        }
        timeout = createTimeout(scope.options.extendedTimeout)
      })

      scope.close = function(actioned, $event) {
        if ($event && angular.isFunction($event.stopPropagation)) {
          $event.stopPropagation()
        }
        glToast.remove(scope.toastId, actioned)
      }

      // initalise toast
      scope.init = function() {
        if (scope.options.timeout) {
          timeout = createTimeout(scope.options.timeout)
        }
      }

      // close toast on click/tap
      scope.tapToast = function() {
        scope.close()
      }
    }
  }
})()

;(function() {
  'use strict'

  glToast.$inject = ["$animate", "$compile", "$document", "$log", "$q", "$rootElement", "$rootScope", "glToastConfig"];
  angular.module('glow.components.toast').constant('glToastConfig', {
    autoDismiss: false,
    extendedTimeout: 1000,
    maxOpened: 1,
    newestOnTop: false,
    position: 'bottom-left',
    target: 'body',
    timeout: 3000,
  })

  angular.module('glow.components.toast').service('glToast', glToast)

  /* @ngInject */
  function glToast(
    $animate,
    $compile,
    $document,
    $log,
    $q,
    $rootElement,
    $rootScope,
    glToastConfig
  ) {
    var container
    var index = 0
    var toasts = []
    var containerDefer = $q.defer()

    return {
      action: action,
      show: show,
      remove: remove,
    }

    function show(message, options) {
      return buildToast(message, options)
    }

    function action(message, actionText, actionFn, options) {
      options = options || {}
      options.action = actionFn
      options.actionText = actionText
      return buildToast(message, options)
    }

    function remove(toastId, actioned) {
      var toast = findToast(toastId)

      if (toast && !toast.deleting) {
        toast.deleting = true
        toast.isOpened = false
        $animate.leave(toast.el).then(function() {
          if (actioned && toast.scope.action) {
            toast.scope.action()
          }
          toast.scope.$destroy()

          var index = toasts.indexOf(toast)
          toasts.splice(index, 1)

          var maxOpened = glToastConfig.maxOpened
          if (maxOpened && toasts.length >= maxOpened) {
            toasts[maxOpened - 1].open.resolve()
          }

          // remove container if it is the last toast
          if (!toasts.length) {
            container.remove()
            container = null
            containerDefer = $q.defer()
          }
        })
      }

      function findToast(toastId) {
        for (var i = 0; i < toasts.length; i++) {
          if (toasts[i].toastId === toastId) {
            return toasts[i]
          }
        }
      }
    }

    function buildToast(message, options) {
      options = options || {}
      _.defaults(options, glToastConfig)

      var newToast = createToast()

      toasts.push(newToast)

      // if we hit the max - remove the oldest -> FIFO
      if (maxOpenedAndAutoDismiss()) {
        var oldToasts = toasts.slice(0, toasts.length - options.maxOpened)
        for (var i = 0, len = oldToasts.length; i < len; i++) {
          remove(oldToasts[i].toastId)
        }
      }

      if (maxOpenedNotReached()) {
        newToast.open.resolve()
      }

      newToast.open.promise.then(function() {
        getContainer(options).then(function() {
          newToast.isOpened = true

          if (options.newestOnTop) {
            $animate.enter(newToast.el, container).then(function() {
              newToast.scope.init()
            })
          } else {
            var sibling = container[0].lastChild
              ? angular.element(container[0].lastChild)
              : null
            $animate.enter(newToast.el, container, sibling).then(function() {
              newToast.scope.init()
            })
          }
        })
      })

      return newToast

      function maxOpenedAndAutoDismiss() {
        return (
          options.autoDismiss &&
          options.maxOpened &&
          toasts.length > options.maxOpened
        )
      }

      function maxOpenedNotReached() {
        return (
          (options.maxOpened && toasts.length <= options.maxOpened) ||
          !options.maxOpened
        )
      }

      function createToast() {
        var newToast = {
          toastId: index++,
          isOpened: false,
          scope: $rootScope.$new(),
          open: $q.defer(),
        }

        createScope(newToast, message, options)

        newToast.el = createToastEl(newToast.scope)
        return newToast
      }

      function createScope(toast, message, options) {
        toast.scope.message = message
        toast.scope.toastId = toast.toastId
        toast.scope.action = options.action
        toast.scope.actionText = options.actionText

        // copy actions to scope for directives use
        toast.scope.options = {
          extendedTimeout: options.extendedTimeout,
          newestOnTop: options.newestOnTop,
          position: options.position,
          timeout: options.timeout,
        }
      }

      function createToastEl(scope) {
        var toastEl = angular.element('<gl-toast></gl-toast>')
        return $compile(toastEl)(scope)
      }
    }

    function getContainer(options) {
      var target

      if (container) {
        return containerDefer.promise
      }

      container = angular.element('<div></div>')
      container.addClass('toast-container ' + options.position)
      container.css({ 'pointer-events': 'auto' })
      container.append(
        angular.element('<div class="toast-container-inner"></div>')
      )

      target = angular.element(document.querySelector(options.target))

      if (!target || !target.length) {
        throw 'glToast: target for toasts does not exist'
      }

      target.append(container)
      containerDefer.resolve()

      $animate.enter(container, target).then(function() {
        containerDefer.resolve()
      })

      return containerDefer.promise
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$rootScope", "$timeout", "$http", "configService"];
  angular.module('glow.services').factory('updateService', Service)

  /* @ngInject */
  function Service($rootScope, $timeout, $http, configService) {
    var Events = {
      NEW_VERSION_AVAILABLE: 'updateService:newVersionAvailable',
    }
    var timer = null
    var statsCommit = null

    this.Events = Events
    this.start = start
    this.stop = stop
    this.isNewVersion = isNewVersion

    function start() {
      if (timer) return
      check()
    }

    function check() {
      $http
        .get('stats.json')
        .then(function(response) {
          statsCommit = response.data.commit
          if (isNewVersion()) {
            $rootScope.$broadcast(Events.NEW_VERSION_AVAILABLE)
            console.log('New version available!', statsCommit)
          }
        })
        .finally(function() {
          if (!isNewVersion()) {
            timer = $timeout(check, 10000)
          }
        })
    }

    function isNewVersion() {
      return statsCommit ? statsCommit !== configService.getCommit() : false
    }

    function stop() {
      $timeout.cancel(timer)
    }

    return this
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').constant('TranslationLanguages', [
    {
      label: 'English',
      code: 'en',
    },
    {
      label: 'Spanish',
      code: 'es',
    },
    {
      label: 'German',
      code: 'de',
    },
    {
      label: 'Dutch',
      code: 'nl',
    },
    {
      label: 'French',
      code: 'fr',
    },
    {
      label: 'Bulgarian',
      code: 'bg',
    },
    {
      label: 'Portugese',
      code: 'pt',
    },
    {
      label: 'Italian',
      code: 'it',
    },
    {
      label: 'Chinese',
      code: 'zh',
    },
    {
      label: 'Czech',
      code: 'cs',
    },
    {
      label: 'Danish',
      code: 'da',
    },
    {
      label: 'Finnish',
      code: 'fi',
    },
    {
      label: 'Greek',
      code: 'el',
    },
    {
      label: 'Hungarian',
      code: 'hu',
    },
    {
      label: 'Indonesian',
      code: 'id',
    },
    {
      label: 'Bengali',
      code: 'bn',
    },
    {
      label: 'Hindi',
      code: 'hi',
    },
    {
      label: 'Kannada',
      code: 'kn',
    },
    {
      label: 'Marathi',
      code: 'mr',
    },
    {
      label: 'Tamil',
      code: 'ta',
    },
    {
      label: 'Japanese',
      code: 'ja',
    },
    {
      label: 'Korean',
      code: 'ko',
    },
    {
      label: 'Malay',
      code: 'ms',
    },
    {
      label: 'Norwegian',
      code: 'nb',
    },
    {
      label: 'Polish',
      code: 'pl',
    },
    {
      label: 'Romanian',
      code: 'ro',
    },
    {
      label: 'Swedish',
      code: 'sv',
    },
    {
      label: 'Slovak',
      code: 'sk',
    },
    {
      label: 'Thai',
      code: 'th',
    },
    {
      label: 'Turkish',
      code: 'tr',
    },
    {
      label: 'Vietnamese',
      code: 'vi',
    },
  ])
})()

;(function() {
  'use strict'

  Factory.$inject = ["configService", "glUtils"];
  angular.module('glow.components').factory('Translation', Factory)

  function Factory(configService, glUtils) {
    var Types = {
      AUTO: 'AUTO',
      CUSTOM: 'CUSTOM',
    }

    var typeLabels = {
      AUTO: 'Auto',
      CUSTOM: 'Custom',
    }

    function Translation() {
      this.applyDefaults()
    }

    Translation.prototype.Types = Translation.Types = Types

    Translation.prototype.applyDefaults = function() {
      var id = glUtils.uuid()
      var now = moment()
      _.defaultsDeep(this, {
        id: id,
        isNew: true,
        surveyId: null,
        label: '',
        type: Types.AUTO,
        language: null,
        mappings: {},
        isPublicUpdateAllowed: false,
        data: {},
        createdAt: now,
        updatedAt: now,
      })
    }

    Translation.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.isNew = this.isNew
      data.surveyId = this.surveyId
      data.label = this.label
      data.type = this.type
      data.language = this.language
      data.mappings = []
      if (this.isCustom()) {
        _.each(this.mappings, function(value, key) {
          data.mappings.push({ key: key, value: value })
        })
      }
      data.isPublicUpdateAllowed = this.isPublicUpdateAllowed
      data.data = this.data
      data.updatedAt = this.updatedAt.toISOString()
      data.createdAt = this.createdAt.toISOString()
      return data
    }

    Translation.prototype.deserialize = function(data) {
      var self = this
      this.id = data.id
      this.isNew = false
      this.surveyId = data.surveyId
      this.label = data.label
      this.type = data.type
      this.language = data.language
      this.mappings = {}
      _.each(data.mappings, function(m) {
        self.mappings[m.key] = m.value
      })
      this.isPublicUpdateAllowed = data.isPublicUpdateAllowed
      this.data = _.isPlainObject(data.data) ? data.data : {}
      this.createdAt = moment(data.createdAt)
      this.updatedAt = moment(data.updatedAt)
      this.applyDefaults()
      this.snapshot()
      return this
    }

    Translation.prototype.getTypeLabel = function() {
      return typeLabels[this.type]
    }

    Translation.prototype.getShareableLink = function() {
      return configService.getSubscriberPortalUrl('/translations/' + this.id)
    }

    Translation.prototype.isAuto = function() {
      return this.type === Types.AUTO
    }

    Translation.prototype.isCustom = function() {
      return this.type === Types.CUSTOM
    }

    Translation.prototype.isIncomplete = function(corpus) {
      var self = this
      if (this.type === Types.AUTO) {
        return false
      }
      return !_.every(corpus, function(key) {
        var exists = !!self.mappings[key]
        return exists
      })
    }

    Translation.prototype.snapshot = function() {
      this.lastSnapshot = this.serialize()
    }

    Translation.prototype.revert = function() {
      if (this.lastSnapshot) {
        this.deserialize(this.lastSnapshot)
      }
    }

    Translation.prototype.validate = function() {
      var errors = []
      if (!this.label) {
        errors.push('Label is required')
      }
      if (errors.length) {
        this.errors = errors
        return false
      }
      this.errors = null
      return true
    }

    Translation.prototype.copy = function(translation) {
      this.deserialize(translation.serialize())
    }

    Translation.prototype.clone = function() {
      return new Translation().deserialize(this.serialize())
    }

    Translation.prototype.refresh = function() {
      this.id = glUtils.uuid()
      this.isNew = true
      return this
    }

    return Translation
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "$http", "api", "configService", "Translation", "TranslationLanguages", "StateFactory", "glDialog"];
  angular.module('glow.components').service('translationService', Service)

  /* @ngInject */
  function Service(
    $q,
    $http,
    api,
    configService,
    Translation,
    TranslationLanguages,
    StateFactory,
    glDialog
  ) {
    var self = this

    var cacheById = {} /* [translationId]: Translation */
    var cacheBySurveyId = {} /* [surveyId]: [...Translation] */
    var languageLabelsByCode = {} /* [code]: String */

    TranslationLanguages.forEach(function(lang) {
      languageLabelsByCode[lang.code] = lang.label
    })

    self.instantiate = instantiate
    self.save = save
    self.remove = remove
    self.duplicate = duplicate

    self.listBySurvey = listBySurvey
    self.getById = getById

    self.translate = translate
    self.corpus = corpus

    self.showPicker = showPicker
    self.showManager = showManager
    self.showEditor = showEditor

    self.getSupportedLanguages = getSupportedLanguages
    self.getLanguageLabelByCode = getLanguageLabelByCode
    self.getDefaultLabels = getDefaultLabels

    function instantiate() {
      return new Translation()
    }

    function save(translation) {
      var action = translation.isNew ? create : update
      translation.isSaving = true
      return action(translation).finally(function() {
        translation.snapshot()
        translation.isSaving = false
      })
    }

    function create(translation) {
      var data = translation.serialize()
      return api.translations.create(data).then(function() {
        translation.isNew = false
        addToCache(translation)
      })
    }

    function update(translation) {
      var data = translation.serialize()
      return api.translations.update(data)
    }

    function remove(translation) {
      translation.isRemoving = true
      var listIndex = removeFromCache(translation) // optimistic remove
      return api.translations
        .delete({ id: translation.id })
        .catch(function() {
          if (listIndex !== -1) {
            addToCache(translation, listIndex) // revert on fail
          }
          return $q.reject()
        })
        .finally(function() {
          translation.isRemoving = false
        })
    }

    function duplicate(translation) {
      var original = translation
      translation = translation.clone().refresh()
      translation.label = 'Copy of ' + translation.label
      var list = cacheBySurveyId[translation.surveyId]
      var originalIndex = _.findIndex(list, { id: original.id })
      translation = addToCache(translation, originalIndex + 1)
      return save(translation).catch(function() {
        removeFromCache(translation)
        return $q.reject()
      })
    }

    function listBySurvey(surveyId) {
      var loader = {
        value: cacheBySurveyId[surveyId],
        state: new StateFactory(['loading', 'ready', 'error']),
        error: null,
        promise: null,
      }
      if (!loader.value || loader.state.isError()) {
        loader.state.loading()
      }
      if (!loader.value) {
        loader.value = cacheBySurveyId[surveyId] = []
      }
      loader.promise = api.translations
        .listBySurvey({ surveyId: surveyId })
        .then(function(datas) {
          _.remove(loader.value) // clear cached items
          lazyMigrate(datas)
          datas.forEach(function(data) {
            var translation = new Translation().deserialize(data)
            addToCache(translation)
          })
          loader.state.ready()
          return loader.value
        })
        .catch(function(error) {
          loader.error = error
          loader.state.error()
          return $q.reject(error)
        })
      return loader
    }

    function getById(translationId) {
      var loader = {
        value: cacheById[translationId],
        state: new StateFactory(['loading', 'ready', 'error']),
        error: null,
        promise: null,
      }
      if (!loader.value || loader.state.isError()) {
        loader.state.loading()
      }
      loader.promise = api.translations
        .get({ id: translationId })
        .then(function(data) {
          lazyMigrate(data)
          var translation = new Translation().deserialize(data)
          loader.value = addToCache(translation)
          loader.state.ready()
          return translation
        })
        .catch(function(error) {
          loader.error = error
          loader.state.error()
          return $q.reject(error)
        })
      return loader
    }

    function addToCache(translation, listIndex) {
      var existing = cacheById[translation.id]
      if (existing && translation !== existing) {
        existing.copy(translation)
        translation = existing
      }
      var list = cacheBySurveyId[translation.surveyId]
      if (!list) return translation
      if (_.isNumber(listIndex)) {
        list.splice(listIndex, 0, translation)
      } else {
        listIndex = _.findIndex(list, function(t) {
          return t.id === translation.id
        })
        if (listIndex !== -1) {
          list[listIndex] = translation
        } else {
          list.push(translation)
        }
      }
      return translation
    }

    function removeFromCache(translation) {
      var listIndex = _.findIndex(
        cacheBySurveyId[translation.surveyId],
        translation
      )
      _.remove(cacheBySurveyId[translation.surveyId], translation)
      delete cacheById[translation.id]
      return listIndex
    }

    function translate(corpus, language) {
      var request = $http({
        url: configService.getNodeUrl('/translate'),
        method: 'POST',
        data: {
          lines: corpus,
          to: language,
        },
      })
      return request.then(function(resp) {
        return resp.data
      })
    }

    function corpus(surveyRaw, labels, set) {
      var isGetter = !set
      var corpus = set || []
      var cursor = 0
      var tracked = {}

      labels = labels || getDefaultLabels()

      // intro
      action(surveyRaw, 'title')
      action(surveyRaw.data, 'introText')
      // action(this, 'estimatedDuration') TODO: wtf do we do here?

      var questionsById = {}
      _.each(surveyRaw.questions, function(question) {
        questionsById[question.id] = question
      })

      // views
      _.each(surveyRaw.data.views, function(view) {
        // questions
        if (view.type === 'QUESTION') {
          var question = questionsById[view.value]
          action(question, 'title')
          action(question.data, 'description')
          action(question.data, 'imageLabel')
          action(question.data, 'numericDiffLeft')
          action(question.data, 'numericDiffRight')
          action(question.data, 'textPrefix')
          action(question.data, 'textSuffix')
          action(question.data, 'scoreLabel')
          action(question.data, 'scoreDefinition')
          action(question.data, 'scoreLeftExtremityLabel')
          action(question.data, 'scoreRightExtremityLabel')
          _.each(question.choices, function(choice) {
            action(choice, 'option')
          })
          _.each(question.statements, function(statement) {
            action(statement, 'statement')
          })
          // variable values
          _.each(question.data.logic, function(logic) {
            _.each(logic.actions, function(logicAction) {
              if (logicAction.type === 'SET_VARIABLE') {
                action(logicAction, 'variableValue')
              }
            })
          })
        }

        // sections
        if (view.type === 'SECTION') {
          var section = view.value
          action(section, 'title')
          action(section, 'mediaLabel')
          // variable values
          _.each(section.logic, function(logic) {
            _.each(logic.actions, function(logicAction) {
              if (logicAction.type === 'SET_VARIABLE') {
                action(logicAction, 'variableValue')
              }
            })
          })
        }
      })

      // outro
      action(surveyRaw.data, 'outroText')
      action(surveyRaw.data, 'doneButton')
      action(surveyRaw.data, 'restartButton')

      // labels
      action(labels, 'GET_STARTED')
      action(labels, 'SKIP')
      action(labels, 'NEXT')
      action(labels, 'SUBMIT')
      action(labels, 'BACK')
      action(labels, 'DONE')
      action(labels, 'PUBLIC_DEVICE')
      action(labels, 'SELECT_AN_OPTION')
      action(labels, 'DRAG_ME')
      action(labels, 'NPS_LEFT')
      action(labels, 'NPS_RIGHT')
      action(labels, 'LOCATION_INPUT_PLACEHOLDER')
      action(labels, 'LOCATION_NEAR_ME')
      action(labels, 'LOCATION_NO_RESULTS')
      action(labels, 'LOCATION_SEARCH')
      action(labels, 'LOCATION_SHOW_MORE')
      action(labels, 'LOCATION_NONE_RETRY')
      action(labels, 'LOCATION_NONE_SKIP')
      action(labels, 'OPTIONAL')
      action(labels, 'TEXT_INPUT_PLACEHOLDER')
      action(labels, 'NUMBER_INPUT_PLACEHOLDER')
      action(labels, 'EMAIL_INPUT_PLACEHOLDER')
      action(labels, 'TEXT_CAPTURE_PLACEHOLDER')

      return corpus

      function action(node, key, setterEffect) {
        if (!node || !node[key]) {
          return
        }
        var value = node[key]
        if (isGetter) {
          // we only track one occurrence of a string
          // in the corpus
          if (!tracked[value]) {
            corpus.push(value)
            tracked[value] = true
          }
        } else {
          var newValue
          // since we only track one occurrence of a string
          // in a corpus, if we see the same string twice
          // we need to get it from the tracked mapping
          // and not increment the cursor
          if (tracked[value]) {
            newValue = tracked[value]
          } else {
            newValue = corpus[cursor]
            tracked[value] = newValue
            cursor++
          }
          node[key] = newValue
          if (setterEffect) {
            setterEffect(newValue)
          }
        }
      }
    }

    function showPicker(survey, translationId) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="translation-picker__dialog">',
          '<g-dialog-header ',
            'title="Use translation..." ',
            'on-close="dialog.cancel()" ',
          '></g-dialog-header>',
          '<translation-picker ',
            'survey="survey" ',
            'translation-id="translationId" ',
            'on-select="dialog.close($translationId)" ',
          '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        locals: {
          survey: survey,
          translationId: translationId,
        },
        escapeToClose: true,
      })
    }

    function showManager(survey) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="translation-manager__dialog">',
          '<translation-manager ',
            'survey="survey"',
            'on-close="dialog.close()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          survey: survey,
        },
      }
      return glDialog.show(options)
    }

    function showEditor(translation, surveyId, corpus) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="translation-editor__dialog">',
          '<translation-editor ',
            'survey-id="surveyId" ',
            'corpus="corpus" ',
            'translation="translation" ',
            'on-close="dialog.close()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        locals: {
          surveyId: surveyId,
          corpus: corpus,
          translation: translation,
        },
      }
      return glDialog.show(options)
    }

    function getSupportedLanguages() {
      return TranslationLanguages
    }

    function getLanguageLabelByCode(code) {
      return languageLabelsByCode[code]
    }

    function getDefaultLabels() {
      return {
        GET_STARTED: 'Get Started',
        SKIP: 'Skip',
        NEXT: 'Next',
        SUBMIT: 'Submit',
        BACK: 'Back',
        DONE: 'Done',
        PUBLIC_DEVICE: 'This is a public computer/device',
        SELECT_AN_OPTION: 'Select an option',
        DRAG_ME: 'Drag Me',
        NPS_LEFT: 'Not at all Likely',
        NPS_RIGHT: 'Extremely Likely',
        LOCATION_INPUT_PLACEHOLDER: 'Town or suburb',
        LOCATION_NEAR_ME: 'Near Me',
        LOCATION_NO_RESULTS: 'No Results Found.',
        LOCATION_SEARCH: 'Search places',
        LOCATION_SHOW_MORE: 'Show More',
        LOCATION_NONE_RETRY:
          'Not finding it? Try entering the name of the business and the suburb',
        LOCATION_NONE_SKIP: 'Nothing found, please press skip to continue.',
        OPTIONAL: 'Optional',
        TEXT_INPUT_PLACEHOLDER: 'Enter text here',
        NUMBER_INPUT_PLACEHOLDER: 'Enter number here',
        EMAIL_INPUT_PLACEHOLDER: 'Enter email here',
        TEXT_CAPTURE_PLACEHOLDER: 'Please specify',
      }
    }

    function lazyMigrate(rawTranslations) {
      rawTranslations = _.isArray(rawTranslations)
        ? rawTranslations
        : [rawTranslations]

      _.each(rawTranslations, function(data) {
        // we used to store translations in the BE
        // as an object/map but MongoDB doesn't like certain
        // characters in keys ($|.). We lazy migrate them into
        // an array of { key, value } to bypass this issue
        if (_.isPlainObject(data.mappings)) {
          data.mappings = _.map(data.mappings, function(value, key) {
            return { key: key, value: value }
          })
        }
      })
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('gUrl', Service)

  function Service() {
    var VALID_URL_REGEX = /^((https?):\/\/|\/\/)([w|W]{3}\.)*[a-zA-Z0-9\-\.]{3,}\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/

    return {
      isValid: isValid,
      fullyForm: fullyForm,
    }

    function isValid(url) {
      url = url.split('?')[0]
      return VALID_URL_REGEX.test(url)
    }

    function fullyForm(url) {
      // This utility ensures the link is correctly formed with an http(s) protocol.
      // This makes it easier to use the link in anchor tags, because when a link has
      // no protocol it just appends the string to the current base url.
      if (!url || _.startsWith(url, 'http') || _.startsWith('//')) {
        return url
      }
      return 'https://' + url
    }
  }
})()

;(function() {
  'use strict'

  Directive.$inject = ["gUrl"];
  angular.module('glow.components').directive('gUrl', Directive)

  function Directive(gUrl) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: PostLink,
    }

    function PostLink(scope, elem, attrs, ctrl) {
      // only apply the validator if ngModel is present and angular has added the url validator
      if (ctrl && ctrl.$validators.url) {
        // overwrite default angular email validator
        ctrl.$validators.url = validate
      }

      function validate(modelValue) {
        return ctrl.$isEmpty(modelValue) || gUrl.isValid(modelValue)
      }
    }
  }
})()

;(function() {
  'use strict'

  UsageStatementFactory.$inject = ["Money"];
  angular
    .module('glow.components')
    .factory('UsageStatement', UsageStatementFactory)

  /* @ngInject */
  function UsageStatementFactory(Money) {
    function UsageStatement() {
      this.applyDefaults()
    }

    UsageStatement.prototype.applyDefaults = function() {
      this.id = null
      this.invoiceId = null
      this.subscriberId = null
      this.currency = 'AUD'
      this.lineItems = []
      this.range = []
      this.adjustments = []
      this.accountBalance = new Money({ amount: 0, currency: this.currency })
      this.consumedCredit = new Money({ amount: 0, currency: this.currency })
      this.lineItemsTotal = new Money({
        amount: 0,
        currency: this.currency,
      })
      this.statementTotal = new Money({
        amount: 0,
        currency: this.currency,
      })
      this.isProcessed = false
      this.lineItemTypes = [
        { label: 'Account', value: 'account' },
        { label: 'Data', value: 'data' },
        { label: 'Plan', value: 'plan_cycle' },
        { label: 'Support', value: 'support' },
      ]

      this.createDraftAdjustment()
      this.createDraftConsumedCredit()
    }

    UsageStatement.prototype.deserialize = function(data) {
      this._ = _.cloneDeep(data)
      this.id = data.id
      this.invoiceId = data.invoiceId
      this.subscriberId = data.subscriberId
      this.currency = data.currency
      this.transactions = data.transactions
      this.range = data.range
      this.accountBalance = data.accountBalance

      this.consumedCredit = new Money({ amount: 0, currency: this.currency })
      this.lineItemsTotal = new Money({
        amount: 0,
        currency: this.currency,
      })
      this.statementTotal = new Money({
        amount: 0,
        currency: this.currency,
      })

      this.lineItems = []
      data.lineItems.forEach(function(item) {
        this.addToTotals(item.total)
        this.lineItems.push({
          type: item.type,
          units: item.count || 1,
          total: new Money({ amount: item.total, currency: this.currency }),
        })
      }, this)

      this.adjustments = []

      // Is this a previously processed statement?
      // This will hide some UI.
      this.isProcessed = data.isProcessed || false

      // If this is a previously process statement, it may contain
      // consumedCredit
      if (data.consumedCredit) {
        this.consumedCredit = new Money({
          amount: data.consumedCredit,
          currency: this.currency,
        })
        this.adjustStatementTotal()
      }

      return this
    }

    UsageStatement.prototype.addToTotals = function(amount) {
      this.lineItemsTotal.amount += amount
      this.adjustStatementTotal()
    }

    UsageStatement.prototype.adjustStatementTotal = function() {
      this.statementTotal.amount =
        this.lineItemsTotal.amount - this.consumedCredit.amount
    }

    UsageStatement.prototype.addAdjustment = function() {
      var adjustment = this.draftAdjustment
      if (adjustment.total.amount === 0) {
        return
      }
      var lineItem = this.findLineItemByType(adjustment.type)
      if (lineItem) {
        lineItem.total.amount += adjustment.total.amount
        this.addToTotals(adjustment.total.amount)
      } else {
        this.lineItems.push({
          type: adjustment.type,
          units: 1,
          total: adjustment.total,
        })
        this.addToTotals(adjustment.total.amount)
      }

      this.adjustments.push(adjustment)
      this.createDraftAdjustment()
    }

    UsageStatement.prototype.findLineItemByType = function(type) {
      return _.find(this.lineItems, { type: type })
    }

    UsageStatement.prototype.consumeCredit = function() {
      if (!this.validateCredit()) {
        return
      }
      var consumedCredit = this.draftConsumedCredit
      this.accountBalance.amount -= consumedCredit.amount
      this.consumedCredit.amount += consumedCredit.amount
      this.adjustStatementTotal()
      this.createDraftConsumedCredit()
    }

    UsageStatement.prototype.createDraftAdjustment = function() {
      this.draftAdjustment = {
        type: null,
        total: new Money({ amount: 0, currency: this.currency }),
      }
    }

    UsageStatement.prototype.createDraftConsumedCredit = function() {
      this.draftConsumedCredit = new Money({
        amount: 0,
        currency: this.currency,
      })
    }

    UsageStatement.prototype.validateAdjustment = function() {
      var adjustment = this.draftAdjustment
      var errors = []
      if (!adjustment.type) {
        errors.push('Type is required')
      }

      if (!adjustment.total.amount) {
        errors.push('Total amount is required')
      }

      if (errors.length) {
        this.errors = errors
        return false
      }

      this.errors = null

      return true
    }

    UsageStatement.prototype.validateCredit = function() {
      var consumedCredit = this.draftConsumedCredit
      if (
        consumedCredit.amount <= 0 ||
        this.accountBalance.amount < consumedCredit.amount
      ) {
        return false
      }

      return true
    }

    return UsageStatement
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').factory('Video', Factory)

  function Factory() {
    var State = {
      NEW: 'NEW',
      PREPARING: 'PREPARING', // getting an upload token (gives us a video id)
      UPLOADING: 'UPLOADING', // uploading to CF (has progress %)
      QUEUED: 'QUEUED', // waiting for CF inprogress state
      ENCODING: 'ENCODING', // waiting for CF encode to finish (has progress %)
      READY: 'READY', // we have all data and the video is ready to play
      ERROR: 'ERROR', // something went wrong
    }

    function Video() {
      this.applyDefaults()
    }

    Video.prototype.State = Video.State = State

    Video.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        id: null,
        name: null,
        duration: null,
        width: null,
        height: null,
        thumbnail: null,
        restrictions: {
          scrub: false,
          complete: false,
        },
        state: State.NEW,
        progress: 0,
        error: null,
      })
    }

    Video.prototype.deserialize = function(data) {
      data = data || {}
      var restrictions = data.restrictions || {}
      this.id = data.id
      this.name = data.name
      this.duration = data.duration
      this.width = data.width
      this.height = data.height
      this.thumbnail = data.thumbnail
      this.restrictions.scrub = restrictions.scrub
      this.restrictions.complete = restrictions.complete
      this.state = data.id ? State.READY : State.NEW
      this.progress = undefined
      this.error = undefined
      this.applyDefaults()
      return this
    }

    Video.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.name = this.name
      data.duration = this.duration
      data.width = this.width
      data.height = this.height
      data.thumbnail = this.thumbnail
      data.restrictions = {
        scrub: this.restrictions.scrub,
        complete: this.restrictions.complete,
      }
      return data
    }

    Video.prototype.hasProgress = function() {
      return _.includes([State.UPLOADING, State.ENCODING], this.state)
    }

    Video.prototype.isLoading = function() {
      return !_.includes([State.NEW, State.READY, State.ERROR], this.state)
    }

    Video.prototype.validate = function() {
      return (
        this.id &&
        this.name &&
        this.duration &&
        this.width &&
        this.height &&
        this.thumbnail
      )
    }

    Video.prototype.clear = function() {
      // deserialize sets all to undefined and then
      // defaults are applied
      this.deserialize()
    }

    return Video
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$rootScope", "$q", "$http", "configService", "Video"];
  init.$inject = ["videoService"];
  angular
    .module('glow.components')
    .service('videoService', Service)
    .run(init)

  /* @ngInject */
  function Service($rootScope, $q, $http, configService, Video) {
    var vjsVersion = '7.20.3'
    var initialized = false
    var loaded = false
    var userInfo = {}

    this.load = load
    this.upload = upload
    this.getPreviewUrl = getPreviewUrl

    $rootScope.$on('subscriberService:CHANGE', function(e, subscriber) {
      userInfo.subscriberId = subscriber && subscriber.id
      userInfo.subscriberName = subscriber && subscriber.name
    })
    $rootScope.$on('userService:CHANGE', function(e, user) {
      userInfo.userId = user && user.id
      userInfo.userName = user && user.fullname
    })

    function load() {
      return $q(function(resolve, reject) {
        if (!initialized) {
          var link = document.createElement('link')
          link.setAttribute(
            'href',
            'https://vjs.zencdn.net/' + vjsVersion + '/video-js.css'
          )
          link.setAttribute('rel', 'stylesheet')
          document.body.append(link)

          var script = document.createElement('script')
          script.setAttribute(
            'src',
            'https://vjs.zencdn.net/' + vjsVersion + '/video.js'
          )
          document.body.append(script)

          initialized = true
        }
        function check() {
          if (window.videojs) {
            loaded = true
            return resolve(window.videojs)
          }
          setTimeout(check, 200)
        }
        check()
      })
    }

    function upload(video, file) {
      video.clear()
      video.name = file.name

      // get a token to upload the file to CF
      video.state = Video.State.PREPARING
      return getUploadToken()
        .then(function(token) {
          // upload the file to CloudFlare Stream
          video.state = Video.State.UPLOADING
          video.progress = 0
          return uploadFile(file, token, function(progress) {
            video.progress = progress
          })
            .then(function() {
              // now that its uploaded to CF we can store the id.
              // at this point, theoretically a user could save their
              // survey and pick back up from this point on
              video.id = token.id
              video.state = Video.State.QUEUED
              return waitUntilProcessed(video.id, function(info) {
                var status = info.status
                if (
                  status.state === 'inprogress' &&
                  status.step === 'encoding'
                ) {
                  video.state = Video.State.ENCODING
                  video.progress = parseFloat(status.pctComplete).toFixed(0)
                }
              })
                .then(function(info) {
                  // all done!
                  video.width = info.input.width
                  video.height = info.input.height
                  video.duration = info.duration
                  video.thumbnail = info.thumbnail
                  video.state = Video.State.READY
                })
                .catch(function(error) {
                  video.state = Video.State.ERROR
                  video.error = 'Error processing file'
                  return $q.reject(error)
                })
            })
            .catch(function(error) {
              video.state = Video.State.ERROR
              video.error = 'Error uploading file'
              return $q.reject(error)
            })
        })
        .catch(function(error) {
          video.state = Video.State.ERROR
          video.error = 'Error preparing file'
          return $q.reject(error)
        })
    }

    function getUploadToken() {
      return $http({
        method: 'POST',
        url: configService.getNodeUrl('/video-tokens'),
        data: userInfo,
        data: userInfo,
      }).then(function(response) {
        return response.data
      })
    }

    function uploadFile(file, token, onProgress) {
      var data = new FormData()
      data.append('file', file)
      return $http({
        method: 'POST',
        url: token.url,
        headers: { 'Content-Type': undefined },
        data: data,
        uploadEventHandlers: {
          progress: function(event) {
            var percent = ((event.loaded / event.total) * 100).toFixed(0)
            onProgress(percent)
          },
        },
      })
    }

    function getInfoById(id) {
      return $http({
        method: 'GET',
        url: configService.getNodeUrl('/video-info?id=' + id),
      }).then(function(response) {
        return response.data
      })
    }

    function waitUntilProcessed(id, onUpdate) {
      return $q(function(resolve, reject) {
        function check() {
          getInfoById(id)
            .then(function(info) {
              if (info.status.state === 'ready') {
                resolve(info)
              } else {
                onUpdate(info)
                setTimeout(check, 500)
              }
            })
            .catch(function(error) {
              reject(error)
            })
        }
        check()
      })
    }

    function getPreviewUrl(videoId) {
      return 'https://watch.videodelivery.net/' + videoId
    }
  }

  /* @ngInject */
  function init(videoService) {
    // initializes videoService so it receives events from the start
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["glAnalytics", "stateService", "bundleService", "helpService", "subscriberService"];
  angular.module('glow.components').component('bundleSelector', {
    controller: Controller,
    templateUrl: 'bundle-selector.html',
    bindings: {
      onSelect: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller(
    glAnalytics,
    stateService,
    bundleService,
    helpService,
    subscriberService
  ) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.isVisible = isVisible
    ctrl.orderBy = orderBy
    ctrl.openChat = openChat

    function onInit() {
      glAnalytics.track('bundles', 'viewed-all')
      ctrl.state = stateService.define(['loading', 'zero', 'ready'])
      ctrl.state.loading()
      bundleService.loadAll().then(function(bundles) {
        ctrl.currency =
          subscriberService.getSubscriber().billing.currency || 'AUD'
        ctrl.bundles = bundles
        if (ctrl.bundles.length) {
          ctrl.state.ready()
        } else {
          ctrl.state.zero()
        }
      })
    }

    function isVisible(bundle) {
      return bundle.status === bundle.Status.PUBLIC
    }

    function orderBy(bundle) {
      return bundle.price.byCurrency(ctrl.currency).amount
    }

    function openChat() {
      helpService.chat()
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('bundleCard', {
    controller: Controller,
    templateUrl: 'bundle-card.html',
    bindings: {
      bundle: '<',
      currency: '<',
      onSelect: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('creditPromotionThanksDialog', {
    controller: Controller,
    templateUrl: 'credit-promotion-thanks-dialog.html',
    bindings: {
      onDone: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('externalPanelSelector', {
    templateUrl: 'external-panel-selector.html',
    bindings: {
      providers: '<',
      onSelect: '&',
      onCancel: '&',
    },
  })
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('fieldErrorMessage', {
    controller: Controller,
    templateUrl: 'field-error-message.html',
    transclude: true,
    bindings: {
      when: '@',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('fieldCheckbox', {
    controller: Controller,
    templateUrl: 'field-checkbox.html',
    transclude: true,
    bindings: {
      checked: '<',
      onChange: '&',
      inline: '<',
      disabled: '<',
      hint: '@',
      highlight: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onClick = onClick

    function onInit() {
      ctrl.key = _.uniqueId('chkbx')
    }

    function onClick() {
      if (ctrl.disabled) {
        return
      }
      ctrl.onChange({ $checked: !ctrl.checked })
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$timeout", "$element", "glToast", "assetService", "subscriberService"];
  angular.module('glow.components').component('fieldFile', {
    controller: Controller,
    templateUrl: 'field-file.html',
    bindings: {
      key: '@',
      model: '=',
    },
  })

  /* @ngInject */
  function Controller(
    $scope,
    $timeout,
    $element,
    glToast,
    assetService,
    subscriberService
  ) {
    var ctrl = this

    ctrl.clear = clear
    ctrl.rebuild = rebuild
    ctrl.remove = remove
    ctrl.download = download

    ctrl.$onInit = onInit

    function onInit() {
      ctrl.asset = ctrl.model
      init()
    }

    function init() {
      $timeout(function() {
        ctrl.input = $element.find('input')
        ctrl.input.bind('change', onInputChange)
      })
    }

    function onInputChange(e) {
      var file = e.target.files[0]
      if (!file) {
        return
      }

      $scope.$applyAsync(function() {
        clear()

        ctrl.filename = file.name
        ctrl.filetype = file.type

        var reader = new FileReader()
        reader.onload = onReaderLoad
        reader.readAsDataURL(file)
      })
    }

    function onReaderLoad(event) {
      $scope.$apply(function() {
        ctrl.error = null
        ctrl.model = null
        ctrl.asset = assetService.getBlank()
        ctrl.asset.data = event.target.result
        ctrl.asset.filename = ctrl.filename
        ctrl.asset.filetype = ctrl.filetype
        ctrl.asset.ownerId = subscriberService.getSubscriber().id
        ctrl.loading = true

        if (ctrl.asset.isValid()) {
          assetService
            .save(ctrl.asset)
            .then(function() {
              ctrl.model = ctrl.asset
            })
            .catch(function() {
              ctrl.asset = null
              rebuild()
              ctrl.error = 'Error uploading file. Try again.'
            })
            .finally(function() {
              ctrl.loading = false
            })
        } else {
          // Display the first error
          ctrl.error =
            (ctrl.asset.errors.length
              ? ctrl.asset.errors[0]
              : 'Invalid file.') + ' Choose another.'
          ctrl.asset = null
          ctrl.loading = false
          rebuild()
        }
      })
    }

    function clear() {
      ctrl.asset = null
      ctrl.model = null
    }

    function rebuild() {
      ctrl.input.unbind('change', onInputChange)
      ctrl.isRebuilding = true
      $timeout(function() {
        ctrl.isRebuilding = false
        init()
      })
    }

    function remove() {
      // e.preventDefault();
      clear()
      rebuild()
    }

    function download() {
      assetService.download(ctrl.model.id, 'Download File').catch(function() {
        glToast.show('Error downloading file.')
      })
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$timeout", "$element", "imageService"];
  angular.module('glow.components').component('fieldImage', {
    controller: Controller,
    templateUrl: 'field-image.html',
    bindings: {
      key: '@',
      model: '=',
      ratio: '<',
      maxWidth: '<',
      canRemove: '<',
      placeholder: '@',
      required: '<',
    },
  })

  /* @ngInject */
  function Controller($scope, $timeout, $element, imageService) {
    var ctrl = this

    var VALID_FILETYPES = ['image/gif', 'image/jpg', 'image/jpeg', 'image/png']

    ctrl.$onInit = onInit
    ctrl.isValidFile = isValidFile
    ctrl.imageUrl = imageUrl
    ctrl.imageStyle = imageStyle
    ctrl.clear = clear
    ctrl.rebuild = rebuild
    ctrl.ratioStyle = ratioStyle

    function onInit() {
      $timeout(function() {
        if (!ctrl.ratio) {
          ctrl.ratio = 1
        }
        if (ctrl.canRemove !== false) {
          ctrl.canRemove = true
        }
        $element.find('input').bind('change', onInputChange)
      })
    }

    function onInputChange(e) {
      if (!e.target.files.length) {
        return
      }
      if (!isValidFile(e.target.files[0])) {
        return displayInvalidError()
      }

      var reader = new FileReader()
      reader.onload = onReaderLoad
      reader.readAsDataURL(e.target.files[0])
    }

    function onReaderLoad(event) {
      // Logic to extract size if needed in future
      // var img = new Image();
      // img.onload = function () {
      //     // console.log('image size: ' + img.width + 'x' + img.height + 'px');
      // };
      // img.src = reader.result;
      ctrl.error = null

      // Make changes and fire onChange method
      $scope.$apply(function() {
        var imageData = event.target.result
        ctrl.loading = true
        ctrl.imageData = imageData
        imageService.create(imageData).then(function(imageUrl) {
          ctrl.model = imageUrl
          ctrl.loading = false
        })
      })
    }

    function displayInvalidError() {
      $element.find('input').unbind('change', onInputChange)
      clear()
      rebuild()
      var error = 'Invalid File Type. Must be PNG, JPEG, JPG or GIF.'
      // ctrl.onError({ $error: error });
      ctrl.error = error
      return
    }

    function imageUrl() {
      return ctrl.imageData || ctrl.model
    }

    function imageStyle() {
      var url = imageUrl()
      return url && { backgroundImage: 'url(' + url + ')' }
    }

    function isValidFile(file) {
      return file && _.indexOf(VALID_FILETYPES, file.type) >= 0
    }

    function clear() {
      ctrl.model = null
      ctrl.imageData = null
    }

    function rebuild() {
      ctrl.rebuilding = true
      $timeout(function() {
        ctrl.rebuilding = false
        $timeout(onInit)
      })
    }

    function ratioStyle() {
      return {
        display: 'block',
        paddingTop: ctrl.ratio * 100 + '%',
      }
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('fieldLabel', {
    controller: Controller,
    templateUrl: 'field-label.html',
    transclude: true,
    bindings: {
      key: '@',
      text: '@',
      inline: '<',
      hint: '@',
      disabled: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$scope"];
  angular.module('glow.components').component('fieldPalette', {
    controller: Controller,
    templateUrl: 'field-palette.html',
    bindings: {
      value: '<',
      onChange: '&',
      disabled: '<',
    },
  })

  /* @ngInject */
  function Controller($scope) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.getStyle = getStyle
    ctrl.add = add
    ctrl.remove = remove
    ctrl.clean = clean

    function onInit() {
      // ...
    }

    function getStyle(color) {
      return {
        backgroundColor: color,
      }
    }

    function add() {
      var nextValue = ctrl.value.slice()
      nextValue.push('#FFFFFF')
      ctrl.onChange({ $value: nextValue })
    }

    function remove(idx) {
      var nextValue = ctrl.value.slice()
      nextValue.splice(idx, 1)
      ctrl.onChange({ $value: nextValue })
    }

    function clean(idx) {
      var color = ctrl.value[idx] || '#FFFFFF'
      if (!color.startsWith('#')) {
        color = '#' + color
      }
      color = color.substring(0, 7)
      ctrl.value[idx] = color
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('fieldRadio', {
    controller: Controller,
    templateUrl: 'field-radio.html',
    transclude: true,
    bindings: {
      selected: '<',
      onSelect: '&',
      inline: '<',
      disabled: '<',
      hint: '@',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onClick = onClick

    function onInit() {
      ctrl.key = _.uniqueId('rdio')
    }

    function onClick() {
      if (ctrl.disabled) {
        return
      }
      ctrl.onSelect({ $selected: !ctrl.selected })
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('fieldRadioSet', {
    templateUrl: 'field-radio-set.html',
    transclude: true,
    bindings: {
      vertical: '<',
    },
  })
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('fieldSection', {
    controller: Controller,
    templateUrl: 'field-section.html',
    transclude: true,
    bindings: {
      on: '<',
      onClick: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('fieldSectionSwitch', {
    controller: Controller,
    templateUrl: 'field-section-switch.html',
    transclude: true,
    bindings: {
      on: '<',
      onClick: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('fieldSectionToggle', {
    controller: Controller,
    templateUrl: 'field-section-toggle.html',
    transclude: true,
    bindings: {
      open: '<',
      onClick: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$transclude"];
  angular.module('glow.components').component('fieldSelect', {
    templateUrl: 'field-select.html',
    controller: Controller,
    bindings: {
      placeholder: '@',
      optionsSrc: '<options',
      selectedSrc: '<selected',
      noSelection: '<',
      onChange: '&',
      onBeforeOpen: '&',
      onCloseCallback: '&onClose',
      multi: '<',
      multiFormat: '&?',
      multiLabel: '@',
      prefix: '@',
      isDisabled: '<disabled',
      isCustomField: '<custom',
      onOptionAdded: '&',
      onOptionRemoved: '&',
      inline: '<',
      search: '<',
      disableOptions: '<',
      largeList: '<',
      allToggle: '<',
      closeOnInputFocus: '<',
      alignSrc: '@align',
    },
    transclude: {
      control: '?fieldSelectControl',
    },
  })

  /* @ngInject */
  function Controller($transclude) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges

    ctrl.onOpen = onOpen
    ctrl.onClose = onClose
    ctrl.select = select
    ctrl.selectAll = selectAll
    ctrl.selectNone = selectNone
    ctrl.addCustom = addCustom
    ctrl.removeCustom = removeCustom
    ctrl.isSelected = isSelected
    ctrl.isOptionDisabled = isOptionDisabled
    ctrl.isPromotedAndVisible = isPromotedAndVisible
    ctrl.isNotPromotedAndVisible = isNotPromotedAndVisible
    ctrl.hasVisiblePromotedOptions = hasVisiblePromotedOptions
    ctrl.isVisible = isVisible

    function onInit() {
      ctrl.hasControl = $transclude.isSlotFilled('control')
      ctrl.searchKey = Math.random() + 'dskjfhdkfjh'
      ctrl.align =
        ctrl.alignSrc || (ctrl.hasControl ? 'bottom' : 'bottom-attach')
    }

    function onChanges(bindings) {
      if (
        bindings.selectedSrc &&
        bindings.selectedSrc.currentValue !== bindings.selectedSrc.previousValue
      ) {
        ctrl.selected = []
        if (_.isArray(ctrl.selectedSrc)) {
          _.each(ctrl.selectedSrc, function(value) {
            ctrl.selected.push(value)
          })
        } else {
          ctrl.selected.push(ctrl.selectedSrc)
        }
        updateValue()
      }

      if (
        bindings.optionsSrc &&
        bindings.optionsSrc.currentValue !== bindings.optionsSrc.previousValue
      ) {
        // console.log('optionsSrc changed', bindings.optionsSrc);

        // the options array can contain strings or objects
        // strings treat value and label the same, eg ['Foo','Bar']
        // objects have more customisation using the signature { value, label, condition, hidden }
        // eg: [{ value: 'coke', label: 'Coke', condition: fn, hidden: false }]
        ctrl.options = ctrl.optionsSrc ? _.cloneDeep(ctrl.optionsSrc) : []

        // all g-select logic adheres to the object structure, so if they are strings
        // we convert them into objects for consistency
        if (ctrl.options.length && _.isString(ctrl.options[0])) {
          ctrl.stringOptionSrc = true
          ctrl.options = _.map(ctrl.options, function(option) {
            return { value: option, label: option }
          })
        }

        updateValue()
      }
    }

    function updateValue() {
      var value, tag, tagColor
      var selectedOptions = _.filter(ctrl.options, function(option) {
        return isSelected(option.value)
      })
      if (ctrl.multi) {
        if (ctrl.multiFormat) {
          value = ctrl.multiFormat({ $options: selectedOptions })
        } else {
          value = _.map(selectedOptions, ctrl.multiLabel || 'label').join(', ')
        }
      } else {
        value = selectedOptions[0] && selectedOptions[0].label
        tag = selectedOptions[0] && selectedOptions[0].tag
        tagColor = selectedOptions[0] && selectedOptions[0].tagColor
      }
      if (value && ctrl.prefix) {
        value = ctrl.prefix + value
      }
      ctrl.value = value
      ctrl.tag = tag
      ctrl.tagColor = tagColor
    }

    function onOpen() {
      ctrl.isOpen = true
    }

    function onClose() {
      ctrl.isOpen = false
      ctrl.query = null
      if (ctrl.custom) {
        addCustom()
      }
      ctrl.onCloseCallback()
    }

    function select(value) {
      if (isOptionDisabled(value)) {
        return
      }

      var output
      if (ctrl.noSelection) {
        return ctrl.onChange({
          $value: value,
        })
      }
      var prevSelected = ctrl.selected.slice()
      if (ctrl.multi) {
        if (!ctrl.selected) {
          ctrl.selected = []
        }
        if (isSelected(value)) {
          // must use function, _.remove(ctrl.selected, Number) fails
          _.remove(ctrl.selected, function(selected) {
            return selected === value
          })
        } else {
          ctrl.selected.push(value)
        }
        output = _.map(ctrl.selected) // re-reference
      } else {
        ctrl.selected = [value]
        output = value
      }
      updateValue()
      ctrl.onChange({
        $value: output,
        $cancel: function() {
          ctrl.selected = prevSelected
          updateValue()
        },
      })
    }

    function selectAll() {
      ctrl.selected = ctrl.options.map(function(option) {
        return option.value
      })
      updateValue()
      ctrl.onChange({
        $value: ctrl.selected.slice(),
      })
    }

    function selectNone() {
      ctrl.selected = []
      updateValue()
      ctrl.onChange({
        $value: ctrl.selected.slice(),
      })
    }

    function addCustom() {
      // check for duplication
      var duplicate = _.filter(ctrl.options, function(option) {
        return option.value === ctrl.custom
      })

      if (duplicate.length) {
        ctrl.custom = null
        return
      }

      var option
      if (ctrl.stringOptionSrc) {
        option = ctrl.custom
      } else {
        option = {
          value: ctrl.custom,
          label: ctrl.custom,
          isCustom: true,
        }
      }
      ctrl.onOptionAdded({ $option: option })

      // select the new one
      select(ctrl.custom)

      // reset
      ctrl.custom = null
      ctrl.menu.close()
    }

    function removeCustom(option) {
      ctrl.onOptionRemoved({ $option: option })
    }

    function isSelected(value) {
      return _.includes(ctrl.selected, value)
    }

    function isOptionDisabled(value) {
      var option = _.find(ctrl.options, function(option) {
        return option.value === value
      })
      if (option && option.disabled) return true
      return !!ctrl.multi && !!ctrl.disableOptions && !isSelected(value)
    }

    function isPromotedAndVisible(option) {
      if (ctrl.query) {
        return (
          option.promoted &&
          option.label.toLowerCase().includes(ctrl.query.toLowerCase())
        )
      }
      return option.promoted
    }

    function isNotPromotedAndVisible(option) {
      if (ctrl.query) {
        return (
          !option.promoted &&
          option.label.toLowerCase().includes(ctrl.query.toLowerCase())
        )
      }
      return !option.promoted
    }

    function hasVisiblePromotedOptions() {
      return _.some(ctrl.options, { promoted: true })
    }

    function isVisible(option) {
      if (option.hidden) return false
      if (option.condition) return option.condition()
      return true
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('fieldSwitch', {
    controller: Controller,
    templateUrl: 'field-switch.html',
    transclude: true,
    bindings: {
      on: '<',
      onClick: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('fieldText', {
    controller: Controller,
    templateUrl: 'field-text.html',
    bindings: {
      key: '@',
      type: '@',
      model: '=',
      onChange: '&',
      onKeyDown: '<',
      onPaste: '<',
      onBlur: '&',
      disabled: '<',
      placeholder: '@',
      inline: '<',
      icon: '@',
      prefix: '@',
      suffix: '@',
      lang: '<',
      min: '<',
      max: '<',
      autocomplete: '@',
      money: '@',
      small: '<',
      autofocus: '<',
      onEnter: '&',
      expand: '<',
      noTrim: '<',
      noMinHeight: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.handleKeyDown = handleKeyDown

    function onInit() {
      // ...
    }

    function handleKeyDown(event) {
      if (ctrl.onKeyDown) ctrl.onKeyDown(event)
      if (event.defaultPrevented) return
      switch (event.keyCode) {
        case 13: // ENTER
          ctrl.onEnter()
          break
      }
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$element", "videoService"];
  angular.module('glow.components').component('fieldVideo', {
    controller: Controller,
    templateUrl: 'field-video.html',
    bindings: {
      key: '@',
      video: '<',
      onUpload: '&',
      inline: '<',
    },
  })

  /* @ngInject */
  function Controller($scope, $element, videoService) {
    var ctrl = this

    ctrl.loadingStateLabels = {
      PREPARING: 'Preparing...',
      UPLOADING: 'Uploading...',
      QUEUED: 'Processing...',
      ENCODING: 'Encoding...',
    }

    ctrl.$onInit = onInit
    ctrl.bind = bind

    function onInit() {
      videoService.load()
    }

    function bind() {
      ctrl.input = $element.find('input')[0]
      ctrl.input.addEventListener('change', onChange)
      $element[0].addEventListener('dragover', onDragOver)
      $element[0].addEventListener('dragenter', onDragEnter)
      $element[0].addEventListener('dragleave', onDragLeave)
      $element[0].addEventListener('drop', onDrop)
    }

    function onChange(event) {
      $scope.$applyAsync(function() {
        var file = event.target.files[0]
        if (!file) return
        upload(file)
      })
    }

    function upload(file) {
      var promise = videoService
        .upload(ctrl.video, file)
        .catch(function(error) {
          console.error(error)
        })
      ctrl.onUpload({ $promise: promise })
    }

    function onDragOver(e) {
      e.preventDefault()
    }

    function onDragEnter(e) {
      $scope.$applyAsync(function() {
        ctrl.dropTarget = e.target
        ctrl.dropping = true
      })
    }

    function onDragLeave(e) {
      $scope.$applyAsync(function() {
        if (e.target === ctrl.dropTarget) {
          ctrl.dropping = false
        }
      })
    }

    function onDrop(e) {
      $scope.$applyAsync(function() {
        ctrl.dropping = false
      })
      // this uses a modified version of:-
      // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/File_drag_and_drop
      e.preventDefault()
      var file
      if (e.dataTransfer.items) {
        for (var i = 0; i < e.dataTransfer.items.length; i++) {
          var item = e.dataTransfer.items[i]
          if (item.kind === 'file') {
            file = item.getAsFile()
            break
          }
        }
      } else {
        file = e.dataTransfer.files[0]
      }
      if (!file) return
      if (!file.type.startsWith('video/')) return
      upload(file)
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('gMenuItem', {
    controller: Controller,
    templateUrl: 'g-menu-item.html',
    bindings: {
      text: '@',
      subText: '@',
      icon: '@',
      iconSize: '@',
      iconStrike: '<',
      isImage: '<image',
      imageUrl: '<',
      onClick: '&',
      href: '@',
      isHighlighted: '<highlight',
      isDisabled: '<disabled',
      isDanger: '<danger',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onChanges = onChanges
    ctrl.click = click

    function onChanges(changed) {
      if (changed.imageUrl) {
        ctrl.imageStyle = ctrl.imageUrl && {
          backgroundImage: 'url(' + ctrl.imageUrl + ')',
        }
      }
    }

    function click(event) {
      if (!ctrl.isDisabled) {
        ctrl.onClick({ $event: event })
      }
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$scope", "glUtils", "Logic", "LogicCondition", "LogicAction", "Question"];
  angular.module('glow.components').component('logicEditor', {
    controller: Controller,
    templateUrl: 'logic-editor.html',
    bindings: {
      survey: '<',
      view: '<',
      filterId: '<',
      isForbidden: '<',
      onChange: '&',
      onDone: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller(
    $scope,
    glUtils,
    Logic,
    LogicCondition,
    LogicAction,
    Question
  ) {
    var ctrl = this
    var choiceOptions = {}
    var statementOptions = {}
    var displayedTargetOptions = {}
    var loopVariableOptions = {} /* viewId: Options */

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy
    ctrl.getQuestionOptions = getQuestionOptions
    ctrl.isDisplayLogic = isDisplayLogic
    ctrl.isActionLogic = isActionLogic

    ctrl.addLogic = addLogic
    ctrl.handleAddLogic = handleAddLogic
    ctrl.moveLogic = moveLogic
    ctrl.duplicateLogic = duplicateLogic
    ctrl.removeLogic = removeLogic
    ctrl.addQuickTags = addQuickTags

    ctrl.getTitle = getTitle

    ctrl.getLogic = getLogic
    ctrl.isCursorNav = isCursorNav
    ctrl.getCursorInfo = getCursorInfo
    ctrl.setCursor = setCursor
    ctrl.isCursorPrev = isCursorPrev
    ctrl.isCursorNext = isCursorNext
    ctrl.cursorFirst = cursorFirst
    ctrl.cursorPrev = cursorPrev
    ctrl.cursorNext = cursorNext
    ctrl.cursorLast = cursorLast

    ctrl.getConditionChoicesPlaceholder = getConditionChoicesPlaceholder
    ctrl.getChoiceOptions = getChoiceOptions
    ctrl.getStatementOptions = getStatementOptions
    ctrl.getDisplayedTargetOptions = getDisplayedTargetOptions
    ctrl.getLoopVariableOptions = getLoopVariableOptions
    ctrl.clearQuestion = clearQuestion
    ctrl.update = update
    ctrl.updateLeastFill = updateLeastFill
    ctrl.getConditionRowClass = getConditionRowClass
    ctrl.getActionRowClass = getActionRowClass

    ctrl.onVariableKeyDown = onVariableKeyDown
    ctrl.onVariablePaste = onVariablePaste

    ctrl.jumpsAndTargetUsesDisplayLogic = jumpsAndTargetUsesDisplayLogic
    ctrl.applyFilter = applyFilter

    var unWatchLogic = $scope.$watchCollection(
      function() {
        return ctrl.logic
      },
      function() {
        filterLogic()
      }
    )

    function onInit() {
      ctrl.cursor = 9999
      ctrl.set = 20
      ctrl.filteredLogic = []
      ctrl.hiddenLogicIds = []
      ctrl.filterValue = []
      ctrl.filterOptions = []
      if (ctrl.view.isQuestion()) {
        var question = ctrl.view.value
        ctrl.title = question.getTitleLabel({ number: true })
        ctrl.logic = question.logic
        ctrl.viewType = 'question'
        ctrl.supportsDisplayTarget = question.isType([
          Question.Types.CHOICE,
          Question.Types.SCALE,
          Question.Types.RANK,
          Question.Types.MATRIX,
          Question.Types.CONSTANT_SUM,
          Question.Types.SCORE,
          Question.Types.HIDDEN_VARIABLES,
        ])

        // prepare target options
        if (question.isHiddenVariables()) {
          ctrl.targetOptions = [
            { value: Logic.Targets.CHOICES, label: 'Variables' },
          ]
        } else {
          ctrl.targetOptions = [
            { value: Logic.Targets.QUESTION, label: 'Question' },
            { value: Logic.Targets.CHOICES, label: 'Choices' },
          ]
          if (question.isUsedAsMatrix()) {
            ctrl.targetOptions.push({
              value: Logic.Targets.STATEMENTS,
              label: 'Statements',
            })
          }
        }

        ctrl.targetChoicesOptions = _.map(question.getAllChoices(), function(
          choice
        ) {
          return { value: choice.id, label: choice.value || choice.label }
        })
        ctrl.targetStatementsOptions = _.map(
          question.getAllStatements(),
          function(statement) {
            return {
              value: statement.id,
              label: statement.value || statement.label,
            }
          }
        )
        ctrl.targetChoicesPlaceholder = question.isHiddenVariables()
          ? 'variables'
          : 'choices'

        ctrl.supportsQuickTags = question.isType([
          Question.Types.CHOICE,
          Question.Types.SCALE,
          Question.Types.HIDDEN_VARIABLES,
        ])

        // setup filter
        ctrl.supportsFilter = ctrl.supportsDisplayTarget
        if (ctrl.supportsFilter) {
          ctrl.filterOptions = ctrl.targetChoicesOptions.concat(
            ctrl.targetStatementsOptions.map(function(option) {
              return angular.extend({}, option, { isStatement: true })
            })
          )
          // filterId is either choiceId or statementId
          applyFilter(ctrl.filterId ? [ctrl.filterId] : [])
        }
      }
      if (ctrl.view.isSection()) {
        var section = ctrl.view.value
        ctrl.title = section.getTitleLabel()
        ctrl.logic = section.logic
        ctrl.viewType = 'section'
      }
      ctrl.conditionTypeOptions = [
        { value: LogicCondition.Types.SELECTED, label: 'respondent selected' },
        {
          value: LogicCondition.Types.ANSWER_COUNT,
          label: "respondent's answer count",
        },
        {
          value: LogicCondition.Types.ANSWERED,
          label: 'respondent answered question',
        },
        {
          value: LogicCondition.Types.DIDNT_ANSWER,
          label: "respondent didn't answer question",
        },
        {
          value: LogicCondition.Types.IS_TAGGED,
          label: 'respondent has tags',
        },
        {
          value: LogicCondition.Types.IS_PRIOR_TAGGED,
          label: 'respondent has prior tags',
        },
        {
          value: LogicCondition.Types.LIST,
          label: 'list',
        },
        {
          value: LogicCondition.Types.DISPLAYED,
          label: 'respondent displayed',
        },
      ]
      // IS_INSIDE_LOOP type is only available if logic is owned by view in loop
      var viewGroup = ctrl.view.value.getViewGroup()
      if (viewGroup && viewGroup.loop) {
        ctrl.conditionTypeOptions.push({
          value: LogicCondition.Types.IS_INSIDE_LOOP,
          label: 'respondent is inside loop',
        })
      }
      ctrl.actionTypeOptions = [
        { value: LogicAction.Types.SUBMIT, label: 'submit the survey' },
        {
          value: LogicAction.Types.EXIT,
          label: 'exit the survey',
        },
        {
          value: LogicAction.Types.QUALITYEXIT,
          label: 'quality exit the survey',
        },
        {
          value: LogicAction.Types.JUMP_TO_QUESTION,
          label: 'jump to a question',
        },
        {
          value: LogicAction.Types.JUMP_TO_SECTION,
          label: 'jump to a section',
        },
        // DEPRECATED
        // {
        //   value: LogicAction.Types.JUMP_TO_FOLLOWUP,
        //   label: 'jump to followup question',
        // },
        // DEPRECATED
        // {
        //   value: LogicAction.Types.JUMP_TO_PROFILING,
        //   label: 'jump to profiling questions',
        // },
        {
          value: LogicAction.Types.TAG,
          label: 'add tag',
        },
        {
          value: LogicAction.Types.UNTAG,
          label: 'remove tags',
        },
        {
          value: LogicAction.Types.ADD_LEAST_FILLED_TAGS,
          label: 'add least filled tags',
        },
        {
          value: LogicAction.Types.RETAIN_LEAST_FILLED_TAGS,
          label: 'retain least filled tags',
        },
        {
          value: LogicAction.Types.HIDE_VIEW_GROUPS,
          label: 'hide groups',
        },
        {
          value: LogicAction.Types.ADD_TO_LIST,
          label: 'add to list',
        },
        {
          value: LogicAction.Types.SET_VARIABLE,
          label: 'set variable',
        },
      ]
      ctrl.allQuestionOptions = ctrl.survey
        .getQuestions()
        .map(function(question) {
          return {
            label: question.getTitleLabel({ number: true }),
            value: question.id,
            type: question.type,
          }
        })
      ctrl.allQuestionOptionsSansHiddenVariables = ctrl.allQuestionOptions.filter(
        function(q) {
          return q.type !== Question.Types.HIDDEN_VARIABLES
        }
      )
      ctrl.allSelectionQuestionOptions = ctrl.allQuestionOptions.filter(
        function(q) {
          // exclude IMAGE, SCAN, PLACES_NEAR_ME and HIDDEN_VARIABLES types question
          return !_.includes(
            [
              Question.Types.SCAN,
              Question.Types.PLACES_NEAR_ME,
              Question.Types.IMAGE,
              Question.Types.HIDDEN_VARIABLES,
            ],
            q.type
          )
        }
      )
      ctrl.allAnsweredAmountQuestionOptions = ctrl.allQuestionOptions.filter(
        function(q) {
          return _.includes(
            [
              Question.Types.CHOICE,
              Question.Types.RANK,
              Question.Types.MATRIX,
              Question.Types.SINGLE_TEXT,
              Question.Types.CONSTANT_SUM,
            ],
            q.type
          )
        }
      )
      ctrl.allDisplayedQuestionOptions = ctrl.allQuestionOptions.filter(
        function(q) {
          // supported question types are identical to ctrl.supportsDisplayTarget
          return _.includes(
            [
              Question.Types.CHOICE,
              Question.Types.SCALE,
              Question.Types.RANK,
              Question.Types.MATRIX,
              Question.Types.CONSTANT_SUM,
              Question.Types.SCORE,
              Question.Types.HIDDEN_VARIABLES,
            ],
            q.type
          )
        }
      )
      ctrl.allSectionOptions = ctrl.survey.getSections().map(function(section) {
        return {
          label: section.getTitleLabel(),
          value: section.id,
        }
      })
      ctrl.selectionQuantifierOptions = [
        {
          value: LogicCondition.SelectionQuantifiers.ANY,
          label: 'any of',
        },
        {
          value: LogicCondition.SelectionQuantifiers.ALL,
          label: 'all of',
        },
        {
          value: LogicCondition.SelectionQuantifiers.NONE,
          label: 'none of',
        },
        {
          value: LogicCondition.SelectionQuantifiers.EXACTLY,
          label: 'exactly',
        },
      ]
      ctrl.choiceQuantifierOptions = [
        {
          value: LogicCondition.ChoiceQuantifiers.ANY,
          label: 'any of',
        },
        {
          value: LogicCondition.ChoiceQuantifiers.ALL,
          label: 'all of',
        },
      ]
      ctrl.textQuantifierOptions = [
        {
          value: LogicCondition.TextQuantifiers.ANY,
          label: 'any of',
        },
        {
          value: LogicCondition.TextQuantifiers.ALL,
          label: 'all of',
        },
        {
          value: LogicCondition.TextQuantifiers.NONE,
          label: 'none of',
        },
      ]
      ctrl.numericQuantifierOptions = [
        {
          value: LogicCondition.NumericQuantifiers.LESS_THAN,
          label: 'less than',
        },
        {
          value: LogicCondition.NumericQuantifiers.GREATER_THAN,
          label: 'greater than',
        },
        {
          value: LogicCondition.NumericQuantifiers.EQUALS,
          label: 'equal to',
        },
        {
          value: LogicCondition.NumericQuantifiers.ANY,
          label: 'any of',
        },
        {
          value: LogicCondition.NumericQuantifiers.NONE,
          label: 'none of',
        },
      ]
      ctrl.listQuantifierOptions = [
        {
          value: LogicCondition.ListQuantifiers.ANY,
          label: 'any of',
        },
        {
          value: LogicCondition.ListQuantifiers.ALL,
          label: 'all of',
        },
        {
          value: LogicCondition.ListQuantifiers.NONE,
          label: 'none of',
        },
        {
          value: LogicCondition.ListQuantifiers.LESS_THAN,
          label: 'less than',
        },
        {
          value: LogicCondition.ListQuantifiers.GREATER_THAN,
          label: 'greater than',
        },
        {
          value: LogicCondition.ListQuantifiers.EQUALS,
          label: 'equal to',
        },
      ]
      ctrl.displayedQuantifierOptions = [
        {
          value: LogicCondition.DisplayedQuantifiers.ANY,
          label: 'any of',
        },
        {
          value: LogicCondition.DisplayedQuantifiers.ALL,
          label: 'all of',
        },
        {
          value: LogicCondition.DisplayedQuantifiers.NONE,
          label: 'none of',
        },
      ]
      ctrl.insideLoopQuantifierOptions = [
        {
          value: LogicCondition.InsideLoopQuantifiers.ANY,
          label: 'any of',
        },
        {
          value: LogicCondition.InsideLoopQuantifiers.NONE,
          label: 'none of',
        },
      ]
      ctrl.rankOptions = [
        { label: 'Rank 1', value: 0 },
        { label: 'Rank 2', value: 1 },
        { label: 'Rank 3', value: 2 },
        { label: 'Rank 4', value: 3 },
        { label: 'Rank 5', value: 4 },
        { label: 'Rank 6', value: 5 },
        { label: 'Rank 7', value: 6 },
        { label: 'Rank 8', value: 7 },
        { label: 'Rank 9', value: 8 },
        { label: 'Rank 10', value: 9 },
      ]
      populateTagOptions()
      populateListOptions()
      populateViewGroupOptions()
    }

    function getQuestionOptions(condition) {
      switch (condition.type) {
        case condition.Types.SELECTED:
          return ctrl.allSelectionQuestionOptions
        case condition.Types.ANSWER_COUNT:
          return ctrl.allAnsweredAmountQuestionOptions
        case condition.Types.DISPLAYED:
          return ctrl.allDisplayedQuestionOptions
        default:
          return ctrl.allQuestionOptionsSansHiddenVariables
      }
    }

    function isDisplayLogic() {
      return _.some(ctrl.logic, function(logic) {
        return logic.type === logic.Types.DISPLAY
      })
    }

    function isActionLogic() {
      return _.some(ctrl.logic, function(logic) {
        return logic.type === logic.Types.ACTION
      })
    }

    function addLogic(type) {
      var logic = new Logic(ctrl.survey.logicHelpers)
      logic.type = type
      if (type === Logic.Types.DISPLAY) {
        if (ctrl.viewType === 'question') {
          var question = ctrl.view.value
          logic.target = question.isHiddenVariables()
            ? Logic.Targets.CHOICES // hidden variables display logic can only target choices
            : Logic.Targets.QUESTION
        }
        if (ctrl.viewType === 'section') {
          logic.target = Logic.Targets.SECTION
        }
      }
      logic.setup()
      ctrl.logic.push(logic)
      return logic
    }

    function addFilterBasedLogic(type) {
      var choicesAndStatements = ctrl.filterOptions.filter(function(option) {
        return ctrl.filterValue.includes(option.value)
      })
      if (type === Logic.Types.DISPLAY) {
        choicesAndStatements.forEach(function(eachOption) {
          var displyLogic = addLogic(Logic.Types.DISPLAY)
          if (eachOption.isStatement) {
            displyLogic.target = Logic.Targets.STATEMENTS
            displyLogic.statementIds = [eachOption.value]
          } else {
            displyLogic.target = Logic.Targets.CHOICES
            displyLogic.choiceIds = [eachOption.value]
          }
        })
      } else {
        var question = ctrl.view.value
        var actionLogic = addLogic(Logic.Types.ACTION)

        var condition = actionLogic.conditions[0]
        condition.questionId = question.id

        choicesAndStatements.forEach(function(eachOption) {
          if (eachOption.isStatement) {
            condition.statementIds.push(eachOption.value)
          } else {
            condition.choiceIds.push(eachOption.value)
          }
        })

        if (question.isHiddenVariables()) {
          condition.type = LogicCondition.Types.DISPLAYED
          condition.displayedTarget = LogicCondition.DisplayedTargets.CHOICES
          condition.displayedQuantifier =
            LogicCondition.DisplayedQuantifiers.ANY
        } else {
          condition.type = LogicCondition.Types.SELECTED
          condition.selectionQuantifier =
            LogicCondition.SelectionQuantifiers.ANY
        }

        if (question.type === Question.Types.CONSTANT_SUM) {
          condition.choiceQuantifier = LogicCondition.ChoiceQuantifiers.ANY
        }
      }
    }

    function handleAddLogic(type) {
      if (ctrl.filterValue.length) {
        addFilterBasedLogic(type)
      } else {
        addLogic(type)
      }
    }

    function addQuickTags() {
      var question = ctrl.view.value
      var choices = getChoiceOptions(question.id)
      var relevantChoices = ctrl.filterValue.length
        ? choices.filter(function(choice) {
            return ctrl.filterValue.includes(choice.value)
          })
        : choices

      var isHiddenVariables = question.type === Question.Types.HIDDEN_VARIABLES

      relevantChoices.forEach(function(choice) {
        var logic = addLogic(Logic.Types.ACTION)

        var condition = logic.conditions[0]
        condition.questionId = question.id
        condition.choiceIds = [choice.value]

        var action = logic.actions[0]
        action.type = LogicAction.Types.TAG
        action.tag = choice.label

        if (isHiddenVariables) {
          condition.type = LogicCondition.Types.DISPLAYED
          condition.displayedTarget = LogicCondition.DisplayedTargets.CHOICES
          condition.displayedQuantifier =
            LogicCondition.DisplayedQuantifiers.ANY
        } else {
          condition.type = LogicCondition.Types.SELECTED
          condition.selectionQuantifier =
            LogicCondition.SelectionQuantifiers.ANY
        }
      })
    }

    function moveLogic(sourceId, targetId) {
      var sourceIndex = ctrl.logic.findIndex(function(item) {
        return item.id === sourceId
      })
      var targetIndex = ctrl.logic.findIndex(function(item) {
        return item.id === targetId
      })

      if (sourceIndex === -1 || targetIndex === -1) {
        return
      }

      // Remove the source item
      var movedItem = ctrl.logic.splice(sourceIndex, 1)[0]

      // Re-insert at target position
      ctrl.logic.splice(targetIndex, 0, movedItem)
    }

    function duplicateLogic(id) {
      var logic = _.find(ctrl.logic, { id: id })
      var index = _.findIndex(ctrl.logic, logic)
      var ids = {
        /* [oldId]: newId */
      }
      function getId(oldId, getOnly) {
        // if there is no id don't re-assign
        if (!oldId) return oldId
        // safeguard for rebinding old references
        if (!ids[oldId] && getOnly) {
          return oldId
        }
        // generate one if it hasn't been generated yet
        if (!ids[oldId]) {
          ids[oldId] = glUtils.uuid()
        }
        return ids[oldId]
      }
      ctrl.logic.splice(index, 0, logic.clone().refresh(getId))
    }

    function removeLogic(id) {
      _.remove(ctrl.logic, function(logic) {
        return logic.id === id
      })
    }

    function getConditionChoicesPlaceholder(questionId) {
      var question = ctrl.survey.getQuestion(questionId)
      return question.isHiddenVariables() ? 'variables' : 'choices'
    }

    function getChoiceOptions(questionId) {
      if (!choiceOptions[questionId]) {
        var question = ctrl.survey.getQuestion(questionId)
        if (!question) return []
        choiceOptions[questionId] = _.map(
          question.getVisibleChoices(),
          function(choice) {
            return {
              value: choice.id,
              label: choice.value || choice.label,
            }
          }
        )
      }
      return choiceOptions[questionId]
    }

    function getStatementOptions(questionId) {
      if (!statementOptions[questionId]) {
        var question = ctrl.survey.getQuestion(questionId)
        if (!question) return []
        statementOptions[questionId] = _.map(
          question.getVisibleStatements(),
          function(statement) {
            return {
              value: statement.id,
              label: statement.value || statement.label,
            }
          }
        )
      }
      return statementOptions[questionId]
    }

    function getDisplayedTargetOptions(questionId) {
      if (!displayedTargetOptions[questionId]) {
        var question = ctrl.survey.getQuestion(questionId)
        if (!question) return []
        var targetLabel = question.isHiddenVariables() ? 'Variables' : 'Choices'
        displayedTargetOptions[questionId] = [
          {
            value: LogicCondition.DisplayedTargets.CHOICES,
            label: targetLabel,
          },
        ]
        if (question.isUsedAsMatrix()) {
          displayedTargetOptions[questionId].push({
            value: LogicCondition.DisplayedTargets.STATEMENTS,
            label: 'Statements',
          })
        }
      }
      return displayedTargetOptions[questionId]
    }

    function getLoopVariableOptions(viewId) {
      if (!loopVariableOptions[viewId]) {
        var viewGroup = ctrl.survey.getViewGroupByViewId(viewId)
        loopVariableOptions[viewId] = viewGroup.getLoopVariableOptions(
          ctrl.survey
        )
      }
      return loopVariableOptions[viewId]
    }

    function clearQuestion(condition) {
      // clear selected question if not supported on selected condition type
      if (
        !_.find(getQuestionOptions(condition), { value: condition.questionId })
      ) {
        condition.questionId = null
      }
    }

    function update() {
      ctrl.onChange()
      populateTagOptions()
      populateListOptions()
    }

    function populateTagOptions() {
      ctrl.allTagOptions = ctrl.survey.getTags().map(function(tag) {
        return { label: tag, value: tag }
      })
    }

    function populateListOptions() {
      ctrl.listOptions = []
      ctrl.listItemOptionsByList = {}
      var lists = ctrl.survey.getLists()
      _.each(lists, function(items, list) {
        ctrl.listOptions.push({ label: list, value: list })
        ctrl.listItemOptionsByList[list] = items.map(function(item) {
          return { label: item, value: item }
        })
      })
    }

    function populateViewGroupOptions() {
      ctrl.viewGroupOptions = []
      _.each(ctrl.survey.viewGroups, function(viewGroup) {
        ctrl.viewGroupOptions.push({
          label: viewGroup.name,
          value: viewGroup.id,
        })
      })
    }

    function updateLeastFill(leastFill) {
      leastFill.populateAmountOptions()
      leastFill.cleanUp()
    }

    function getConditionRowClass(condition) {
      if (!condition.type) {
        return '-four'
      }
      if (
        _.includes(
          [LogicCondition.Types.IS_TAGGED, LogicCondition.Types.IS_INSIDE_LOOP],
          condition.type
        )
      ) {
        return '-three'
      }
      if (
        condition.usesStatements() ||
        condition.usesRanks() ||
        condition.usesDisplayedTarget()
      ) {
        return condition.usesLoopKey() ? '-six' : '-five'
      }
      return condition.usesLoopKey() ? '-five' : '-four'
    }

    function getActionRowClass(action) {
      if (
        action.usesList() ||
        action.usesVariables() ||
        action.usesLeastFill() ||
        action.usesLoopKey()
      )
        return '-three'
      return '-two'
    }

    function jumpsAndTargetUsesDisplayLogic(action) {
      if (
        action.type !== action.Types.JUMP_TO_QUESTION &&
        action.type !== action.Types.JUMP_TO_SECTION
      ) {
        return
      }
      if (action.type === action.Types.JUMP_TO_QUESTION && !action.questionId) {
        return
      }
      if (action.type === action.Types.JUMP_TO_SECTION && !action.sectionId) {
        return
      }

      if (action.usesLoopKey()) {
        var loopVariable = action.getLoopVariable()
        if (!loopVariable) return

        // check if selected loop variable is borrowed
        if (loopVariable.isBorrowed) {
          return true
        }
      }

      // check if target uses display logic
      var view = ctrl.survey.getView(action.getViewId())
      if (!view || !view.value.logic) return
      return _.some(view.value.logic, function(logic) {
        return logic.type === logic.Types.DISPLAY
      })
    }

    function getLogic() {
      if (ctrl.filteredLogic.length <= ctrl.set) {
        return ctrl.filteredLogic
      }
      // when on last page cursor is set to 9999 to maintain last
      // page while adding logic. so we need to clamp it to get the proper slice amount
      var cursor = ctrl.cursor
      if (cursor === 9999) {
        cursor = ctrl.filteredLogic.length - ctrl.set
      }
      return ctrl.filteredLogic.slice(cursor, cursor + ctrl.set)
    }

    function isCursorNav() {
      return ctrl.filteredLogic.length > ctrl.set
    }

    function getCursorInfo() {
      var total = ctrl.filteredLogic.length
      var from = ctrl.cursor
      var to = ctrl.cursor + ctrl.set
      if (ctrl.cursor === 9999) {
        from = ctrl.filteredLogic.length - ctrl.set
        to = ctrl.filteredLogic.length
      }
      return ['Showing ', from, '-', to, ' of ', total].join('')
    }

    function setCursor(value) {
      ctrl.cursor = Math.max(value, 0)
    }

    function isCursorPrev() {
      return ctrl.filteredLogic.length > ctrl.set && ctrl.cursor > 0
    }

    function isCursorNext() {
      return ctrl.cursor + ctrl.set < ctrl.filteredLogic.length
    }

    function cursorFirst() {
      if (!isCursorPrev()) return
      ctrl.cursor = 0
    }

    function cursorPrev() {
      if (!isCursorPrev()) return
      if (ctrl.cursor === 9999) {
        ctrl.cursor = ctrl.filteredLogic.length - ctrl.set - ctrl.set
      } else {
        ctrl.cursor -= ctrl.set
      }
      if (ctrl.cursor < 0) ctrl.cursor = 0
    }

    function cursorNext() {
      if (!isCursorNext()) return
      ctrl.cursor += ctrl.set
      // don't show partial pages, clamp to end on last page
      if (!isCursorNext()) {
        ctrl.cursor = 9999
      }
    }

    function cursorLast() {
      if (!isCursorNext()) return
      ctrl.cursor = 9999
    }

    function getTitle(logic) {
      if (logic.isAction()) {
        return 'If...'
      }
      return ctrl.supportsDisplayTarget ? 'Display...' : 'Display if...'
    }

    var VARIABLE_REGEX = /^[a-zA-Z0-9_\- ]+$/

    function onVariableKeyDown(event) {
      switch (event.keyCode) {
        case 8: // Backspace
        case 9: // Tab
        case 13: // Enter
        case 37: // Left
        case 38: // Up
        case 39: // Right
        case 40: // Down
          break
        default:
          if (!VARIABLE_REGEX.test(event.key)) {
            event.preventDefault()
            return false
          }
          break
      }
    }
    function onVariablePaste(event) {
      var text = event.clipboardData.getData('text/plain')
      if (!VARIABLE_REGEX.test(text)) {
        event.preventDefault()
      }
    }

    function filterLogic() {
      ctrl.filteredLogic = ctrl.hiddenLogicIds.length
        ? ctrl.logic.filter(function(eachLogic) {
            return !ctrl.hiddenLogicIds.includes(eachLogic.id)
          })
        : ctrl.logic
    }

    function applyFilter(values) {
      ctrl.filterValue = values
      if (ctrl.filterValue.length) {
        ctrl.hiddenLogicIds = ctrl.logic.reduce(function(ids, logic) {
          if (!logic.hasMatchingChoicesOrStatements(ctrl.filterValue)) {
            ids.push(logic.id)
          }
          return ids
        }, [])
      } else {
        ctrl.hiddenLogicIds = []
      }
      filterLogic()
    }

    function onDestroy() {
      unWatchLogic() // safely unwatch logic
    }
  }
})()

;(function() {
  'use strict'

  Service.$inject = ["$q", "glDialog"];
  angular.module('glow.components').service('logicEditor', Service)

  /* @ngInject */
  function Service($q, glDialog) {
    this.show = show

    function show(options) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="logic-editor__dialog">',
          '<logic-editor ',
            'survey="survey" ',
            'view="view" ',
            'filter-id="filterId" ',
            'is-forbidden="isForbidden" ',
            'on-change="onChange({})" ',
            'on-done="dialog.close($clickedSave)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          survey: options.survey,
          view: options.view,
          filterId: options.filterId,
          isForbidden: options.isForbidden,
          onChange: options.onChange,
        },
      })
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$rootScope", "logicEditor"];
  angular.module('glow.components').component('logicEditorOpener', {
    controller: Controller,
    templateUrl: 'logic-editor-opener.html',
    bindings: {
      mode: '@',
      survey: '<',
      view: '<',
      filterId: '<',
      isForbidden: '<',
      onChange: '&',
      onSave: '&',
    },
  })

  /* @ngInject */
  function Controller($scope, $rootScope, logicEditor) {
    var ctrl = this
    var eventName = 'logic-editor-opener:refresh-icon-highlight-'
    var deregisterEvent = angular.noop

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy
    ctrl.openLogicEditor = openLogicEditor

    function onInit() {
      eventName += ctrl.view.value.id

      if (ctrl.mode === 'icon') {
        deregisterEvent = $scope.$on(eventName, updateIconHighlight)
        updateIconHighlight()
      }
    }

    function updateIconHighlight() {
      ctrl.isIconHighlighted = ctrl.filterId
        ? ctrl.view.value.logic.some(function(logic) {
            return logic.hasMatchingChoicesOrStatements([ctrl.filterId])
          })
        : !!ctrl.view.value.logic.length
    }

    function openLogicEditor() {
      if (ctrl.survey.queue.isProcessing()) return
      logicEditor
        .show({
          survey: ctrl.survey,
          view: ctrl.view,
          filterId: ctrl.filterId,
          isForbidden: ctrl.isForbidden,
          onChange: ctrl.onChange,
        })
        .then(function(clickedSave) {
          if (clickedSave && !ctrl.isForbidden) {
            ctrl.onSave()
          }
        })
        .finally(function() {
          $rootScope.$broadcast(eventName)
        })
    }

    function onDestroy() {
      deregisterEvent()
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components').component('pipeChipText', {
    templateUrl: 'pipe-chip-text.html',
    bindings: {
      text: '<',
      pipes: '<',
    },
  })
})()

;(function() {
  'use strict'

  angular.module('glow.components').filter('pipeChipText', Filter)

  function Filter() {
    var cache = {}

    return function(string, pipes) {
      if (cache[string]) {
        return cache[string]
      }
      if (!pipes) {
        return string
      }
      var result = string
      _.each(pipes.pipes, function(pipe) {
        var info = _.map(pipe.directives, function(directive) {
          return '- ' + directive.info + '<br/>'
        }).join('')
        var chip = [
          '<span class="pipe-chip-text__chip">',
          pipe.label,
          '<gl-hint>',
          '<span class="pipe-chip-text__hint">',
          info,
          '</span>',
          '</gl-hint>',
          '</span>',
        ].join('')
        result = result.replace(pipe.string, chip)
      })
      cache[string] = result
      return result
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["questionService"];
  angular.module('glow.components.questionEditor').component('choiceFields', {
    controller: Controller,
    templateUrl: 'choice-fields.html',
    bindings: {
      question: '=',
      isRestricted: '=',
      isSsr: '=',
    },
  })

  /* @ngInject */
  function Controller(questionService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.isTextCaptureOption = isTextCaptureOption
    ctrl.isExclusiveOption = isExclusiveOption
    ctrl.isAnchorOption = isAnchorOption
    ctrl.isMinField = isMinField
    ctrl.isMaxField = isMaxField
    ctrl.isSamplingField = isSamplingField
    ctrl.isHideLabelsOption = isHideLabelsOption
    ctrl.isGridColumnMaxOption = isGridColumnMaxOption
    ctrl.onImageChange = onImageChange

    function onInit() {
      ctrl.listInputLabel = ctrl.question.isHiddenVariables()
        ? 'Variables'
        : 'Choices'
    }

    function isTextCaptureOption() {
      return ctrl.question.isType([
        ctrl.question.Types.CHOICE,
        ctrl.question.Types.RANK,
      ])
    }

    function isExclusiveOption() {
      return ctrl.question.isType([
        ctrl.question.Types.CHOICE,
        ctrl.question.Types.RANK,
      ])
    }

    function isAnchorOption() {
      return ctrl.question.isType([
        ctrl.question.Types.CHOICE,
        ctrl.question.Types.RANK,
        ctrl.question.Types.HIDDEN_VARIABLES,
      ])
    }

    function isMinField() {
      if (ctrl.question.isType([ctrl.question.Types.CHOICE])) {
        return ctrl.isSsr
      }
      if (ctrl.question.isType([ctrl.question.Types.RANK])) {
        return true
      }
      return false
    }

    function isMaxField() {
      return !ctrl.question.isHiddenVariables()
    }

    function isSamplingField() {
      return !ctrl.question.isHiddenVariables()
    }

    function isHideLabelsOption() {
      return ctrl.question.isType([
        ctrl.question.Types.CHOICE,
        ctrl.question.Types.RANK,
      ])
    }

    function isGridColumnMaxOption() {
      return ctrl.question.isType([ctrl.question.Types.CHOICE])
    }

    function onImageChange(choice, imageData) {
      questionService.setChoiceImage(ctrl.question, choice, imageData)
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["questionService", "Pipes"];
  angular
    .module('glow.components.questionEditor')
    .component('constantSumFields', {
      controller: Controller,
      templateUrl: 'constant-sum-fields.html',
      bindings: {
        question: '=',
        isRestricted: '=',
        pipesAllowed: '<',
        getPipeQuestions: '&',
      },
    })

  /* @ngInject */
  function Controller(questionService, Pipes) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onQuantifierChange = onQuantifierChange
    ctrl.onImageChange = onImageChange
    ctrl.makeStatementOptions = makeStatementOptions
    ctrl.onStatementsChange = onStatementsChange
    ctrl.getStatementLabel = getStatementLabel

    function onInit() {
      onQuantifierChange(ctrl.question.constantSumTotalQuantifier)
      makeStatementOptions()
    }

    function onQuantifierChange(value) {
      ctrl.quantifier = _.cloneDeep(
        _.find(ctrl.question.ConstantSumTotalQuantifierOptions, {
          value: value,
        })
      )
      ctrl.question.constantSumTotalQuantifier = ctrl.quantifier.value
    }

    function onImageChange(choice, imageData) {
      questionService.setChoiceImage(ctrl.question, choice, imageData)
    }

    function makeStatementOptions() {
      ctrl.statementOptions = ctrl.question
        .getAllStatements()
        .map(function(statement) {
          return { label: statement.value, value: statement.id }
        })

      // remove statement rules that are not found in the options
      _.remove(ctrl.question.constantSumStatementRules, function(rule) {
        return !_.find(ctrl.statementOptions, { value: rule.statementId })
      })

      // then repopulate the selected statements
      ctrl.selectedStatements = _.map(
        ctrl.question.constantSumStatementRules,
        'statementId'
      )
    }

    function onStatementsChange(value) {
      var tempStatementRules = ctrl.question.constantSumStatementRules.slice()
      ctrl.question.constantSumStatementRules = _.map(value, function(
        statementId
      ) {
        var rule = _.find(tempStatementRules, { statementId: statementId })
        if (rule) {
          return rule
        }
        return {
          statementId: statementId,
          total: null,
          min: null,
          max: null,
          totalPipes: new Pipes(),
          minPipes: new Pipes(),
          maxPipes: new Pipes(),
        }
      })
    }

    function getStatementLabel(statementId) {
      var option = _.find(ctrl.statementOptions, { value: statementId })
      return option ? option.label : 'not found'
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$element", "$timeout"];
  angular
    .module('glow.components.questionEditor')
    .component('constantSumTotalField', {
      controller: Controller,
      templateUrl: 'constant-sum-total-field.html',
      bindings: {
        question: '=',
        key: '@',
        model: '=',
        pipes: '<',
        pipesAllowed: '<',
        getPipeQuestions: '&',
      },
    })

  /* @ngInject */
  function Controller($element, $timeout) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.initInput = initInput
    ctrl.insertPipe = insertPipe
    ctrl.prepareMenu = prepareMenu
    ctrl.shouldShowTextInput = shouldShowTextInput
    ctrl.setEditing = setEditing
    ctrl.shouldShowInserter = shouldShowInserter
    ctrl.setInsertingPipe = setInsertingPipe
    ctrl.clearPipes = clearPipes
    ctrl.cleanPipeString = cleanPipeString
    ctrl.$onDestroy = onDestroy

    function onInit() {
      if (ctrl.pipes.string) {
        setInsertingPipe(true)
        $timeout(function() {
          setValue(ctrl.pipes.string)
        }, 0)
      }
    }

    function initInput(type) {
      if (ctrl.input) {
        unbindInputEvent()
      }
      var inputClass = '.constant-sum-total-field__input-' + type
      ctrl.input = angular.element($element[0].querySelector(inputClass))
      if (type === 'text') {
        ctrl.input.on('keyup input', onInputChange)
      }
    }

    function unbindInputEvent() {
      ctrl.input.off('keyup input', onInputChange)
    }

    function insertPipe(questionNumber) {
      ctrl.setInsertingPipe(true)
      $timeout(function() {
        var pipe = '{{ Q' + questionNumber + '#1 }}'
        setValue(pipe)
        ctrl.input[0].focus()
      }, 0)
    }

    function setValue(value) {
      value = value || ''
      ctrl.input[0].value = value
      ctrl.pipes.set(value)
    }

    function updateValue() {
      var value = ctrl.input[0].value
      ctrl.pipes.set(value)
    }

    function onInputChange() {
      updateValue()
    }

    function prepareMenu() {
      ctrl.pipeQuestions = _.filter(ctrl.getPipeQuestions(), function(
        question
      ) {
        return (
          question.type === question.Types.CONSTANT_SUM ||
          (question.isNumericType() && !question.isUsedAsMatrix())
        )
      })
      ctrl.input[0].focus()
    }

    function shouldShowInserter() {
      return ctrl.pipesAllowed && ctrl.isEditing
    }

    function setEditing(isEditing) {
      if (ctrl.editTimer) {
        $timeout.cancel(ctrl.editTimer)
      }
      if (isEditing) {
        ctrl.isEditing = true
      } else {
        ctrl.editTimer = $timeout(function() {
          ctrl.isEditing = false
        }, 300)
      }
      if (!ctrl.input[0].value) {
        clearPipes()
      }
    }

    function shouldShowTextInput() {
      return ctrl.isInsertingPipe
    }

    function setInsertingPipe(isInsertingPipe) {
      ctrl.isInsertingPipe = isInsertingPipe
    }

    function clearPipes() {
      ctrl.pipes.set(null)
      setInsertingPipe(false)
      unbindInputEvent()
    }

    function cleanPipeString() {
      if (!ctrl.pipes.pipes.length) return
      var pipeString = _.map(ctrl.pipes.pipes, 'string').join(' ')
      ctrl.pipes.string = pipeString
      ctrl.input[0].value = pipeString
    }

    function onDestroy() {
      unbindInputEvent()
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["countryService", "placeTypeService"];
  angular.module('glow.components.questionEditor').component('locationFields', {
    controller: Controller,
    templateUrl: 'location-fields.html',
    bindings: {
      question: '=',
      isRestricted: '=',
    },
  })

  /* @ngInject */
  function Controller(countryService, placeTypeService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onChange = onChange
    ctrl.isPlacesType = isPlacesType

    function onInit() {
      ctrl.ruleOptions = [
        { label: 'Biased toward', value: 'bias' },
        { label: 'Restricted to', value: 'restrict' },
      ]
      ctrl.countries = countryService.getSelectOptions()
      ctrl.selectedRule = ctrl.question.locationRestrictCountryCode
        ? 'restrict'
        : 'bias'
      ctrl.selectedCountry = countryService.getByCC(
        ctrl.question.locationRestrictCountryCode ||
          ctrl.question.locationBiasCountryCode
      ).id

      ctrl.typeOptions = [
        { value: ctrl.question.LocationTypes.DEFAULT, label: 'Geographic' },
        { value: ctrl.question.LocationTypes.PLACES, label: 'Places' },
      ]
      ctrl.placeTypeOptions = placeTypeService.getSelectOptions()
    }

    function onChange(rule, countryId) {
      ctrl.selectedRule = rule
      ctrl.selectedCountry = countryId
      // location bias is required so we always set the value to selected country
      ctrl.question.locationBiasCountryCode = countryService.getById(
        countryId
      ).cc
      // if selected rule is not Restrict then set location restrict to null
      ctrl.question.locationRestrictCountryCode =
        rule === 'restrict' ? countryService.getById(countryId).cc : null
    }

    function isPlacesType() {
      return ctrl.question.locationType === ctrl.question.LocationTypes.PLACES
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["questionEditor", "questionService"];
  angular.module('glow.components.questionEditor').component('matrixFields', {
    controller: Controller,
    templateUrl: 'matrix-fields.html',
    bindings: {
      question: '=',
      isRestricted: '=',
    },
  })

  /* @ngInject */
  function Controller(questionEditor, questionService) {
    var ctrl = this

    ctrl.maxDndChoices = 6

    ctrl.$onInit = onInit
    ctrl.onImageChange = onImageChange
    ctrl.setDisplayType = setDisplayType
    ctrl.isDefaultDisplayType = isDefaultDisplayType
    ctrl.isScaleDisplayType = isScaleDisplayType
    ctrl.isDndDisplayType = isDndDisplayType
    ctrl.onFlipTableAxisChange = onFlipTableAxisChange

    function onInit() {
      ctrl.presets = questionEditor.getOptionPresets(
        questionEditor.OptionTags.MATRIX
      )
    }

    function onImageChange(choiceOrStatement, imageData) {
      questionService.setChoiceImage(
        ctrl.question,
        choiceOrStatement,
        imageData
      )
    }

    function setDisplayType(value) {
      ctrl.question.displayType = value
      if (isScaleDisplayType() || isDndDisplayType()) {
        // scale display type only allow single select
        ctrl.question.maxSelections = 1

        // reset the choice.isExclusive and choice.isCapture value
        _.each(ctrl.question.choices, function(choice) {
          choice.isExclusive = false
          choice.isCapture = false
        })

        // retain maximum 6 choices for dnd display type
        if (isDndDisplayType()) {
          ctrl.question.choices.splice(ctrl.maxDndChoices)
        }
      } else {
        // reset the choice.isIndependent value
        _.each(ctrl.question.choices, function(choice) {
          choice.isIndependent = false
        })
      }
    }

    function isDefaultDisplayType() {
      return (
        ctrl.question.displayType === ctrl.question.MatrixDisplayTypes.DEFAULT
      )
    }

    function isScaleDisplayType() {
      return (
        ctrl.question.displayType === ctrl.question.MatrixDisplayTypes.SCALE
      )
    }

    function isDndDisplayType() {
      return ctrl.question.displayType === ctrl.question.MatrixDisplayTypes.DND
    }

    function onFlipTableAxisChange() {
      if (ctrl.question.flipTableAxis) {
        // we currently doesn't support choice text capture
        // on matrix with flip table axis. So we reset
        // the choice.isCapture value for all choices
        // when flip table axis is enabled
        _.each(ctrl.question.choices, function(choice) {
          choice.isCapture = false
        })
      }
    }
  }
})()

;(function() {
  'use strict'

  angular
    .module('glow.components.questionEditor')
    .component('minCharactersField', {
      templateUrl: 'min-characters-field.html',
      bindings: {
        question: '<',
      },
    })
})()

;(function() {
  'use strict'

  Controller.$inject = ["numericService"];
  angular.module('glow.components.questionEditor').component('numericFields', {
    controller: Controller,
    templateUrl: 'numeric-fields.html',
    bindings: {
      question: '=',
      isRestricted: '=',
    },
  })

  /* @ngInject */
  function Controller(numericService) {
    var ctrl = this

    ctrl.ValuesLimit = 15

    ctrl.Units = numericService.Units
    ctrl.units = numericService.getUnits()
    ctrl.calc = calc
    ctrl.$onInit = onInit
    ctrl.updateLabel = updateLabel

    function onInit() {
      calc()
    }

    function calc() {
      ctrl.values = numericService.calculateValues(
        ctrl.question.numericMin,
        ctrl.question.numericMax,
        ctrl.question.numericSteps,
        ctrl.question.numericUnit,
        ctrl.question.numericLabels
      )
      ctrl.errors = ctrl.question.getNumericErrors()
    }

    function updateLabel(index, label) {
      ctrl.question.numericLabels[index] = label
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components.questionEditor').component('placeFields', {
    controller: Controller,
    templateUrl: 'place-fields.html',
    bindings: {
      question: '=',
      isRestricted: '=',
      subscriberId: '=',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["questionEditor"];
  angular.module('glow.components.questionEditor').component('ratingFields', {
    controller: Controller,
    templateUrl: 'rating-fields.html',
    bindings: {
      question: '=',
      isRestricted: '=',
    },
  })

  /* @ngInject */
  function Controller(questionEditor) {
    var ctrl = this

    ctrl.select = select
    ctrl.$onInit = onInit

    function onInit() {
      ctrl.templateOptions = questionEditor
        .getOptionPresets(questionEditor.OptionTags.RATING)
        .map(function(template) {
          return {
            label: template.label,
            value: template.value,
            template: template,
          }
        })

      // for new questions, assign the template and choices
      if (!ctrl.question.data.ratingTemplate) {
        console.log('no template, assigning choices')
        select('5star')
      }
    }

    function select(value) {
      var option = _.find(ctrl.templateOptions, { value: value })
      ctrl.question.data.ratingTemplate = value
      ctrl.question.choices = []
      _.forEach(option.template.items, function(choice) {
        ctrl.question.addChoice(choice)
      })
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["questionEditor"];
  angular.module('glow.components.questionEditor').component('scaleFields', {
    controller: Controller,
    templateUrl: 'scale-fields.html',
    bindings: {
      question: '=',
      isRestricted: '=',
    },
  })

  /* @ngInject */
  function Controller(questionEditor) {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      ctrl.presets = questionEditor.getOptionPresets(
        questionEditor.OptionTags.SCALE
      )
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["Question", "Choice", "questionService"];
  angular.module('glow.components.questionEditor').component('scoreFields', {
    controller: Controller,
    templateUrl: 'score-fields.html',
    bindings: {
      question: '=',
      isRestricted: '=',
    },
  })

  /* @ngInject */
  function Controller(Question, Choice, questionService) {
    var ctrl = this

    var ScoreTypes = Question.ScoreTypes

    var ScoreChoices = [
      { value: '0', score: -100 },
      { value: '1', score: -80 },
      { value: '2', score: -60 },
      { value: '3', score: -40 },
      { value: '4', score: -20 },
      { value: '5', score: 0 },
      { value: '6', score: 20 },
      { value: '7', score: 40 },
      { value: '8', score: 60 },
      { value: '9', score: 80 },
      { value: '10', score: 100 },
    ]

    var ScoreDataByType = {
      nts: {
        scoreType: ScoreTypes.NTS,
        scoreLabel: 'Net Trust Score',
        scoreDefinition:
          'Net Trust Score uses a bipolar scale to measure the level of trust and distrust in a single question. Calculated scores are reported as a single number from -100 to +100',
        scoreLeftExtremityLabel: 'Distrust completely',
        scoreRightExtremityLabel: 'Trust completely',
        choices: _.map(ScoreChoices, function(choice) {
          return new Choice(choice)
        }),
      },
      srs: {
        scoreType: ScoreTypes.SRS,
        scoreLabel: 'Social Responsibility Score',
        scoreDefinition:
          'Social Responsibility Score (SRS) uses a bipolar scale to measure social responsibility and irresponsibility in a single question. Calculated scores are reported as a single number from -100 to +100',
        scoreLeftExtremityLabel: 'Extremely Irresponsible',
        scoreRightExtremityLabel: 'Extremely Responsible',
        choices: _.map(ScoreChoices, function(choice) {
          return new Choice(choice)
        }),
      },
      custom: {
        scoreType: ScoreTypes.CUSTOM,
        scoreLabel: '',
        scoreDefinition: '',
        scoreLeftExtremityLabel: '',
        scoreRightExtremityLabel: '',
        choices: [],
      },
    }

    ctrl.$onInit = onInit
    ctrl.setScoreType = setScoreType
    ctrl.toggleIndependentChoice = toggleIndependentChoice
    ctrl.isNTS = isNTS
    ctrl.isSRS = isSRS
    ctrl.isCustom = isCustom
    ctrl.onImageChange = onImageChange

    function onInit() {
      ctrl.ScoreTypes = ScoreTypes
      if (ctrl.question.scorePrepare) {
        // this value comes from a view-picker/new-views-grid which shows "score" question types as 3 individual
        // types with different configurations, and we need to initialize it here with the specific types config/choices
        var type = ctrl.question.scorePrepare
        ctrl.question.scorePrepare = null
        ctrl.showIndependentChoice = true
        setScoreType(type)
      } else if (!ctrl.question.scoreType) {
        // default to NTS score type and show independent choice
        ctrl.showIndependentChoice = true
        setScoreType(ScoreTypes.NTS)
      } else if (!isCustom()) {
        ctrl.showIndependentChoice = !!_.find(ctrl.question.choices, {
          isIndependent: true,
        })
      }
    }

    function setScoreType(value) {
      if (ctrl.question.scoreType === value) return
      if (isCustom()) {
        // persist inputted custom data when switching from custom type
        var customData = ScoreDataByType.custom
        customData.scoreLabel = ctrl.question.scoreLabel
        customData.scoreDefinition = ctrl.question.scoreDefinition
        customData.scoreLeftExtremityLabel =
          ctrl.question.scoreLeftExtremityLabel
        customData.scoreRightExtremityLabel =
          ctrl.question.scoreRightExtremityLabel
        customData.choices = _.cloneDeep(ctrl.question.choices)
      }

      var scoreData = ScoreDataByType[value]
      ctrl.question.scoreType = scoreData.scoreType
      ctrl.question.scoreLabel = scoreData.scoreLabel
      ctrl.question.scoreDefinition = scoreData.scoreDefinition
      ctrl.question.scoreLeftExtremityLabel = scoreData.scoreLeftExtremityLabel
      ctrl.question.scoreRightExtremityLabel =
        scoreData.scoreRightExtremityLabel
      ctrl.question.choices = _.cloneDeep(scoreData.choices)

      if (!isCustom()) {
        toggleIndependentChoice()
      }
    }

    function toggleIndependentChoice() {
      if (ctrl.showIndependentChoice) {
        ctrl.question.addChoice({ value: "Don't know", isIndependent: true })
      } else {
        _.remove(ctrl.question.choices, { isIndependent: true })
      }
    }

    function isNTS() {
      return ctrl.question.scoreType === ScoreTypes.NTS
    }

    function isSRS() {
      return ctrl.question.scoreType === ScoreTypes.SRS
    }

    function isCustom() {
      return ctrl.question.scoreType === ScoreTypes.CUSTOM
    }

    function onImageChange(choice, imageData) {
      questionService.setChoiceImage(ctrl.question, choice, imageData)
    }
  }
})()

;(function() {
  'use strict'

  angular.module('glow.components.questionEditor').component('textFields', {
    controller: Controller,
    templateUrl: 'text-fields.html',
    bindings: {
      question: '<',
      isRestricted: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onChanges = onChanges
    ctrl.onValidatorChange = onValidatorChange
    ctrl.toggleLabels = toggleLabels
    ctrl.onFieldNumberChange = onFieldNumberChange

    function onChanges() {
      if (!ctrl.hasInit) init()
      onValidatorChange(ctrl.question.textValidator)
    }

    function init() {
      ctrl.validators = [
        { label: 'Text', value: null },
        { label: 'Email Address', value: 'EMAIL' },
        { label: 'Numeric', value: 'NUMERIC' },
        { label: 'Numeric Range', value: 'NUMERIC_RANGE' },
      ]

      ctrl.labelsEnabled = ctrl.question.textFieldLabels.length > 0
      ctrl.labelsBuffer = ctrl.question.textFieldLabels.slice()

      ctrl.hasInit = true
    }

    function onValidatorChange(value) {
      ctrl.validator = _.cloneDeep(_.find(ctrl.validators, { value: value }))
      ctrl.question.textValidator = ctrl.validator.value
      if (!!ctrl.question.textValidator) {
        ctrl.question.textExclusiveChoiceEnabled = false
      }
    }

    function toggleLabels() {
      if (ctrl.labelsEnabled) {
        ctrl.question.textFieldLabels = ctrl.labelsBuffer.slice()
        syncLabels()
      } else {
        ctrl.labelsBuffer = ctrl.question.textFieldLabels.slice()
        ctrl.question.textFieldLabels = []
      }
    }

    function onFieldNumberChange() {
      if (ctrl.labelsEnabled) syncLabels()
    }

    function syncLabels() {
      var count = ctrl.question.textFieldNumber || 0
      var labels = ctrl.question.textFieldLabels || []
      while (labels.length < count) labels.push('')
      if (labels.length > count) labels.length = count
      ctrl.question.textFieldLabels = labels
      ctrl.labelsBuffer = labels.slice()
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$element", "$timeout"];
  angular.module('glow.components.questionEditor').component('titleField', {
    controller: Controller,
    templateUrl: 'title-field.html',
    bindings: {
      key: '@',
      type: '@',
      label: '@',
      pipesAllowed: '<',
      value: '<',
      pipes: '<',
      onChange: '&',
      getPipeQuestions: '&',
    },
  })

  /* @ngInject */
  function Controller($scope, $element, $timeout) {
    var ctrl = this

    ctrl.selection = {}

    ctrl.initInput = initInput
    ctrl.$onChanges = onChanges
    ctrl.prepareMenu = prepareMenu
    ctrl.insertPipe = insertPipe
    ctrl.$onDestroy = onDestroy
    ctrl.shouldShowInserter = shouldShowInserter
    ctrl.setEditing = setEditing

    function initInput(tagName) {
      ctrl.input = angular.element($element[0].querySelector(tagName))
      // the `input` event also catches right-click-paste and drag-&-drop
      ctrl.input.on('keyup input', onInputChange)
      setValue(ctrl.value)
    }

    function onChanges() {
      if (ctrl.input && ctrl.value !== ctrl.input[0].value) {
        setValue(ctrl.value)
      }
    }

    function setValue(value) {
      value = value || ''
      ctrl.input[0].value = value
      ctrl.pipes.set(value)
      $scope.$applyAsync(function() {
        ctrl.onChange({ $value: value })
      })
    }

    function updateValue() {
      var value = ctrl.input[0].value
      ctrl.pipes.set(value)
      $scope.$applyAsync(function() {
        ctrl.onChange({ $value: value })
      })
    }

    function onInputChange() {
      updateValue()
    }

    function prepareMenu() {
      ctrl.selection.start = ctrl.input[0].selectionStart
      ctrl.selection.end = ctrl.input[0].selectionEnd
      ctrl.pipeQuestions = ctrl.getPipeQuestions()
      ctrl.input[0].focus()
    }

    function insertPipe(questionNumber) {
      var pipe = '{{ Q' + questionNumber + ' }}'
      var value = ctrl.input[0].value
      var start = _.isNumber(ctrl.selection.start)
        ? ctrl.selection.start
        : value.length
      var end = _.isNumber(ctrl.selection.end)
        ? ctrl.selection.end
        : value.length
      var isSelection = start !== end

      value = value.substring(0, start) + pipe + value.substring(end)
      setValue(value)

      ctrl.input[0].focus()
      if (isSelection) {
        ctrl.input[0].setSelectionRange(start, start + pipe.length)
      } else {
        ctrl.input[0].setSelectionRange(end + pipe.length, end + pipe.length)
      }

      ctrl.showPipes = false
    }

    function shouldShowInserter() {
      return ctrl.pipesAllowed && ctrl.isEditing
    }

    function setEditing(isEditing) {
      if (ctrl.editTimer) {
        $timeout.cancel(ctrl.editTimer)
      }
      if (isEditing) {
        ctrl.isEditing = true
      } else {
        ctrl.editTimer = $timeout(function() {
          ctrl.isEditing = false
        }, 300)
      }
    }

    function onDestroy() {
      ctrl.input.off('keyup input', onInputChange)
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["titleSelector"];
  angular.module('glow.components.questionEditor').component('titleSelector', {
    controller: Controller,
    templateUrl: 'title-selector.html',
    bindings: {
      question: '<',
    },
  })

  /* @ngInject */
  function Controller(titleSelector) {
    var ctrl = this

    ctrl.Segments = titleSelector.Segments

    ctrl.$onInit = onInit
    ctrl.updateSegment = updateSegment
    ctrl.addOption = addOption

    function updateSegment(segment, value) {
      segment.value = value
      ctrl.question.title = titleSelector.format(ctrl.selector)
    }

    function onInit() {
      ctrl.selector = ctrl.question.titleSelector
    }

    function addOption(segment, option) {
      ctrl.question.addTitleSelectorOption(segment, option)
    }
  }
})()

;(function() {
  'use strict'

  angular
    .module('glow.components.questionEditor')
    .factory('titleSelector', Service)

  /* @ngInject */
  function Service() {
    var SYNTAX_REGEX = /({{\s*select[\s\S][^{]+?\s*}})/g
    var SYNTAX_INNER_REGEX = /{{\s*select([\s\S][^{]+?)\s*}}/
    var PLACEHOLDER_REGEX = /\(([^\)]*)\)/

    var Segments = {
      TEXT: 'TEXT',
      DROPDOWN: 'DROPDOWN',
      INPUT: 'INPUT',
    }

    return {
      parse: parse,
      format: format,
      Segments: Segments,
    }

    function parse(string) {
      var data = {
        string: string || '',
        segments: [],
      }

      var syntaxes = data.string.match(SYNTAX_REGEX)
      if (!syntaxes || !syntaxes.length) {
        return
      }

      var segmentSplit = data.string.split(SYNTAX_REGEX) // relies on capture group of regex

      _.each(segmentSplit, function(segmentStr) {
        var segment = {
          string: segmentStr,
        }

        if (!SYNTAX_REGEX.test(segmentStr)) {
          segment.type = Segments.TEXT
        } else {
          // defaults
          segment.options = []
          segment.allowCustom = true
          segment.placeholder = null
          segment.value = null

          // remove the begining and end, ie `{{ select` and ` }}`
          var syntax = segment.string.match(SYNTAX_INNER_REGEX)[1]

          // map the options (if any)
          if (_.includes(syntax, ':')) {
            var snap = syntax.split(':')
            syntax = snap[0]
            _.each(snap[1].split('|'), function(option) {
              segment.options.push(option)
            })
            segment.type = Segments.DROPDOWN
          } else {
            segment.type = Segments.INPUT
          }

          // interpret compulsory
          if (_.includes(syntax, '*')) {
            syntax = syntax.replace('*', '')
            segment.allowCustom = false
          }

          // interpret placeholder
          if (_.includes(syntax, '(') && _.includes(syntax, ')')) {
            segment.placeholder = syntax.match(PLACEHOLDER_REGEX)[1]
          }
        }

        data.segments.push(segment)
      })

      return data
    }

    function isCompleted(selector) {
      return _.every(selector.segments, function(segment) {
        switch (segment.type) {
          case Segments.TEXT:
            return true
          case Segments.DROPDOWN:
            return !!segment.value
          case Segments.INPUT:
            return !!segment.value
        }
      })
    }

    function format(selector) {
      if (!isCompleted(selector)) {
        return _.map(selector.segments, function(segment) {
          switch (segment.type) {
            case Segments.TEXT:
              return segment.string
            case Segments.DROPDOWN:
              return segment.value || '<Placeholder>'
            case Segments.INPUT:
              return segment.value || '<Placeholder>'
          }
        }).join('')
      }

      return _.map(selector.segments, function(segment) {
        switch (segment.type) {
          case Segments.TEXT:
            return segment.string
          case Segments.DROPDOWN:
            return segment.value
          case Segments.INPUT:
            return segment.value
        }
      }).join('')
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["glUtils", "glToast", "surveyServiceNext"];
  angular.module('glow.components').component('introEditor', {
    controller: Controller,
    templateUrl: 'intro-editor.html',
    bindings: {
      survey: '<',
      isSsr: '<',
    },
  })

  /* @ngInject */
  function Controller(glUtils, glToast, surveyServiceNext) {
    var ctrl = this
    var broadcast = glUtils.broadcaster('survey-editor')

    ctrl.setImage = setImage

    function setImage(imageData) {
      surveyServiceNext
        .setImage(ctrl.survey, imageData)
        .then(function() {
          broadcast('survey-image-added') // for tip succession
        })
        .catch(function() {
          glToast.show('Failed to save image')
        })
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["sectionService", "reportMediaBtn", "glToast"];
  angular.module('glow.components').component('sectionEditor', {
    controller: Controller,
    templateUrl: 'section-editor.html',
    bindings: {
      survey: '<',
      index: '<',
      section: '<',
      showErrors: '=',
    },
  })

  /* @ngInject */
  function Controller(sectionService, reportMediaBtn, glToast) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.setImage = setImage
    ctrl.onPaste = onPaste
    ctrl.getPipeQuestions = getPipeQuestions
    ctrl.getDefaultMediaLabel = reportMediaBtn.getDefaultLabelBySectionMediaType
    ctrl.uploadAudioFile = uploadAudioFile
    ctrl.audioFileExtension = sectionService.AudioFileExtension

    function onInit() {
      ctrl.isInLoop = _.some(ctrl.survey.loops, function(loop) {
        return _.some(loop.sectionIds, function(sectionId) {
          return sectionId === ctrl.section.id
        })
      })
      ctrl.mediaTypeOptions = [
        { value: null, label: 'None' },
        {
          value: ctrl.section.MediaTypes.VIDEO,
          label: 'Video (YouTube)',
        },
        {
          value: ctrl.section.MediaTypes.VIDEO_UPLOAD,
          label: 'Video (Upload)',
        },
        { value: ctrl.section.MediaTypes.AUDIO, label: 'Audio (MP3)' },
        { value: ctrl.section.MediaTypes.IMAGE, label: 'Image' },
        { value: ctrl.section.MediaTypes.IFRAME, label: 'Iframe' },
      ]
    }

    function setImage(imageData) {
      sectionService.setImage(ctrl.section, imageData)
    }

    function onPaste(event) {
      // intercept on paste event to get the ID and add it to the correct embed URL
      event.preventDefault()
      var url = event.clipboardData.getData('text/plain')
      var youtubeId = getYouTubeID(url)
      if (youtubeId) {
        ctrl.section.youTubeVideoUrl =
          'https://www.youtube.com/embed/' + youtubeId
      } else {
        // don't intercept when it's not correct format
        ctrl.section.youTubeVideoUrl = url
      }
    }

    function getYouTubeID(url) {
      // source: https://gist.github.com/takien/4077195
      // this will return the ID from most YouTube URL format
      // return false when it's not the correct format
      url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/\/?)/)
      return undefined !== url[2] && url[2].split(/[^0-9a-z_\-]/i)[0]
    }

    function getPipeQuestions() {
      var prevQuestions = ctrl.survey.getQuestionsBefore(ctrl.section.id)
      return prevQuestions
    }

    function uploadAudioFile(files) {
      if (!files.length) return

      ctrl.isUploadingAudioFile = true
      sectionService
        .uploadAudioFile(files[0])
        .then(function(resp) {
          ctrl.section.audioUrl = resp.assetUrl
          glToast.show('Audio file uploaded!')
          ctrl.isUploadingAudioFile = false
        })
        .catch(function(error) {
          glToast.show(
            'Upload error, please try again. Message: ' + error.message
          )
          ctrl.isUploadingAudioFile = false
        })
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["subscriberService", "surveyServiceNext"];
  angular.module('glow.components').component('themeQuestionDialog', {
    controller: Controller,
    templateUrl: 'theme-question-dialog.html',
    bindings: {
      surveyId: '<',
      questionId: '<',
      onComplete: '&',
      onClose: '&',
    },
  })

  /* @ngInject */
  function Controller(subscriberService, surveyServiceNext) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.save = save

    function onInit() {
      ctrl.subscriber = subscriberService.getSubscriber()
      surveyServiceNext.get(ctrl.surveyId).then(function(survey) {
        ctrl.survey = survey
        ctrl.question = survey.getQuestion(ctrl.questionId)
      })
    }

    function save() {
      ctrl.saving = true
      subscriberService.saveSubscriber(ctrl.subscriber).then(function() {
        return surveyServiceNext.save(ctrl.survey).then(function() {
          ctrl.onComplete()
        })
      })
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$scope", "glToast", "glDialog", "themeService", "Theme"];
  angular.module('glow.components').component('themeSettings', {
    controller: Controller,
    templateUrl: 'theme-settings.html',
    bindings: {
      context: '<',
      surveyContext: '<',
      subscriberContext: '<',
      skipRevert: '<',
    },
  })

  /* @ngInject */
  function Controller($scope, glToast, glDialog, themeService, Theme) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy

    ctrl.select = select

    ctrl.canEdit = canEdit
    ctrl.edit = edit

    ctrl.canDuplicate = canDuplicate
    ctrl.duplicate = duplicate

    ctrl.canCreate = canCreate
    ctrl.create = create

    ctrl.copyColors = copyColors
    ctrl.pasteColors = pasteColors

    function onInit() {
      init()
      $scope.$on('theme-settings:rebuild', init)
    }

    function init() {
      // ensure we have everything we need
      if (!ctrl.context) {
        throw new Error('[theme-settings] context required')
      }
      if (ctrl.context.type === 'SURVEY' && !ctrl.subscriberContext) {
        throw new Error(
          '[theme-settings] subscriber context required for surveys'
        )
      }
      if (ctrl.context.type === 'QUESTION' && !ctrl.surveyContext) {
        throw new Error(
          '[theme-settings] survey context required for questions'
        )
      }
      if (ctrl.context.type === 'QUESTION' && !ctrl.subscriberContext) {
        throw new Error(
          '[theme-settings] subscriber context required for questions'
        )
      }

      if (ctrl.context.type === 'SUBSCRIBER') {
        ctrl.subscriberContext = ctrl.context
      }

      makeOptions()
      resolve()
    }

    function resolve() {
      ctrl.theme = themeService.resolveTheme(
        ctrl.context,
        ctrl.subscriberContext,
        ctrl.surveyContext
      )
      if (ctrl.context.target === 'CUSTOM') {
        ctrl.mode = 'EDIT_CUSTOM'
      } else {
        ctrl.mode = 'PREVIEW'
      }
    }

    function makeOptions() {
      ctrl.options = []
      ctrl.options.push({
        label: 'Use Glow theme',
        value: 'GLOW',
      })
      if (ctrl.context.type === 'SURVEY' || ctrl.context.type === 'QUESTION') {
        ctrl.options.push({
          label: 'Use account theme',
          value: 'SUBSCRIBER',
        })
      }
      if (ctrl.context.type === 'QUESTION') {
        ctrl.options.push({
          label: 'Use survey theme',
          value: 'SURVEY',
        })
      }
      ctrl.options.push({
        label: 'Custom',
        value: 'CUSTOM',
      })
      if (ctrl.subscriberContext.presets.length) {
        ctrl.options.push({
          label: '---------------------------------------',
          value: '-',
          disabled: true,
        })
      }
      ctrl.subscriberContext.presets.forEach(function(preset) {
        ctrl.options.push({
          label: preset.name,
          value: preset.id,
        })
      })
    }

    function revert() {
      if (ctrl.mode === 'NEW_PRESET') {
        _.remove(ctrl.subscriberContext.presets, ctrl.theme)
      } else {
        ctrl.theme.revert()
      }
    }

    function select(target) {
      revert()
      ctrl.context.target = target
      resolve()
    }

    function canEdit() {
      if (ctrl.mode !== 'PREVIEW') return false
      return !['GLOW', 'SUBSCRIBER', 'SURVEY', 'CUSTOM'].includes(
        ctrl.context.target
      )
    }

    function edit() {
      if (!canEdit()) return
      glDialog
        .confirm(
          'Edit Theme',
          'Any changes made to this theme will also affect other places it is being used.\n\nAre you sure you want to edit this theme?'
        )
        .then(function() {
          ctrl.mode = 'EDIT_PRESET'
        })
    }

    function canDuplicate() {
      if (ctrl.mode !== 'PREVIEW') return false
      return ctrl.context.type !== 'CUSTOM'
    }

    function duplicate() {
      if (!canDuplicate()) return
      ctrl.theme = ctrl.theme.clone().refresh()
      ctrl.subscriberContext.presets.push(ctrl.theme)
      ctrl.context.target = ctrl.theme.id
      ctrl.mode = 'NEW_PRESET'
    }

    function canCreate() {
      if (ctrl.mode === 'NEW_PRESET') return false
      return true
    }

    function create() {
      if (!canCreate()) return
      revert()
      ctrl.theme = new Theme()
      ctrl.subscriberContext.presets.push(ctrl.theme)
      ctrl.context.target = ctrl.theme.id
      ctrl.mode = 'NEW_PRESET'
    }

    function copyColors(colors) {
      ctrl.copied = colors.slice()
      glToast.show('Copied')
    }

    function pasteColors(colors) {
      if (!ctrl.copied) return
      _.remove(colors)
      ctrl.copied.forEach(function(color) {
        colors.push(color)
      })
    }

    function onDestroy() {
      // revert any unsaved changes
      if (!ctrl.skipRevert) {
        revert()
      }
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$scope", "Translation", "translationService", "clipboardService", "glToast"];
  angular.module('glow.components').component('translationEditor', {
    controller: Controller,
    templateUrl: 'translation-editor.html',
    bindings: {
      surveyId: '<',
      corpus: '<',
      translation: '<',
      onClose: '&',
    },
  })

  /* @ngInject */
  function Controller(
    $scope,
    Translation,
    translationService,
    clipboardService,
    glToast
  ) {
    var ctrl = this

    ctrl.Types = Translation.Types

    ctrl.$onInit = onInit
    ctrl.done = done
    ctrl.cancel = cancel
    ctrl.copyLink = copyLink
    ctrl.customize = customize
    ctrl.updateVisibleCorpus = _.debounce(updateVisibleCorpus, 100, {
      trailing: true,
    })
    ctrl.getLangHint = getLangHint

    function onInit() {
      ctrl.filters = {
        query: '',
        incomplete: false,
      }
      if (!ctrl.translation) {
        ctrl.translation = translationService.instantiate()
        ctrl.translation.surveyId = ctrl.surveyId
      }
      ctrl.typeOptions = [
        { label: 'Auto Translate', value: ctrl.Types.AUTO },
        { label: 'Custom', value: ctrl.Types.CUSTOM },
      ]
      ctrl.languageOptions = translationService
        .getSupportedLanguages()
        .map(function(lang) {
          return {
            label: lang.label,
            value: lang.code,
          }
        })
      updateVisibleCorpus()
    }

    function done() {
      translationService
        .save(ctrl.translation)
        .then(function() {
          ctrl.onClose()
        })
        .catch(function() {
          glToast.show('Could not save translation')
        })
    }

    function cancel() {
      ctrl.translation.revert()
      ctrl.onClose()
    }

    function copyLink(event) {
      event.preventDefault()
      event.stopPropagation()
      clipboardService.copy(ctrl.translation.getShareableLink())
    }

    function customize() {
      if (!ctrl.translation.language) {
        return glToast.show('Please select a language')
      }
      ctrl.isCustomizing = true
      translationService
        .translate(ctrl.corpus, ctrl.translation.language)
        .then(function(translatedCorpus) {
          ctrl.corpus.forEach(function(key, index) {
            ctrl.translation.mappings[key] = translatedCorpus[index]
          })
          ctrl.translation.type = ctrl.Types.CUSTOM
        })
        .catch(function() {
          glToast.show('Could not customize')
        })
        .finally(function() {
          ctrl.isCustomizing = false
        })
    }

    function updateVisibleCorpus() {
      $scope.$applyAsync(function() {
        var query = ctrl.filters.query.toLowerCase()
        ctrl.visibleCorpus = _.filter(ctrl.corpus, function(item) {
          var mapping = ctrl.translation.mappings[item] || ''
          var queryMatch = query
            ? item.toLowerCase().includes(query) ||
              mapping.toLowerCase().includes(query)
            : true
          var incompleteMatch = ctrl.filters.incomplete ? !mapping : true
          return queryMatch && incompleteMatch
        })
      }, 100)
    }

    function getLangHint() {
      return ctrl.translation.type === ctrl.Types.AUTO
        ? 'The language to auto-translate this survey into'
        : 'The language of this translation (used for display formatting)'
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["translationService", "clipboardService", "glDialog", "glToast", "glPrefs"];
  angular.module('glow.components').component('translationManager', {
    controller: Controller,
    templateUrl: 'translation-manager.html',
    bindings: {
      survey: '<',
      onClose: '&',
    },
  })

  /* @ngInject */
  function Controller(
    translationService,
    clipboardService,
    glDialog,
    glToast,
    glPrefs
  ) {
    var ctrl = this
    var prefs = glPrefs.create('translations')

    ctrl.$onInit = onInit
    ctrl.hideWarning = hideWarning
    ctrl.add = add
    ctrl.edit = edit
    ctrl.duplicate = duplicate
    ctrl.remove = remove
    ctrl.share = share
    ctrl.getAutoSuffix = getAutoSuffix

    function onInit() {
      ctrl.warningHidden = prefs.get('warningHidden')
      ctrl.translations = translationService.listBySurvey(ctrl.survey.id)
      ctrl.corpus = translationService.corpus(ctrl.survey.serialize())
    }

    function hideWarning() {
      ctrl.warningHidden = true
      prefs.set('warningHidden', true)
    }

    function add() {
      translationService.showEditor(null, ctrl.survey.id, ctrl.corpus)
    }

    function edit(translation) {
      translationService.showEditor(translation, ctrl.survey.id, ctrl.corpus)
    }

    function duplicate(translation) {
      translationService
        .duplicate(translation)
        .then(function() {
          glToast.show('Translation duplicated')
        })
        .catch(function() {
          glToast.show('Could not duplicate translation')
        })
    }

    function remove(translation) {
      translationService
        .remove(translation)
        .then(function() {
          glToast.show('Translation removed')
        })
        .catch(function() {
          glToast.show('Could not remove translation')
        })
    }

    function share(translation) {
      clipboardService.copy(translation.getShareableLink())
    }

    function getAutoSuffix(translation) {
      if (translation.isAuto()) {
        return (
          '(' +
          translationService.getLanguageLabelByCode(translation.language) +
          ')'
        )
      }
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["translationService"];
  angular.module('glow.components').component('translationPicker', {
    controller: Controller,
    templateUrl: 'translation-picker.html',
    bindings: {
      survey: '<',
      translationId: '<',
      onSelect: '&',
    },
  })

  /* @ngInject */
  function Controller(translationService) {
    var ctrl = this
    var cachedIncompleteChecks = {} // Translation.id -> Boolean

    ctrl.$onInit = onInit
    ctrl.select = select
    ctrl.isIncomplete = isIncomplete

    function onInit() {
      ctrl.corpus = translationService.corpus(ctrl.survey.serialize())
      ctrl.translations = translationService.listBySurvey(ctrl.survey.id)
    }

    function select(translation) {
      if (translation.isIncomplete(ctrl.corpus)) return
      ctrl.onSelect({ $translationId: translation.id })
    }

    function isIncomplete(translation) {
      var value = cachedIncompleteChecks[translation.id]
      if (!_.isBoolean(value)) {
        value = cachedIncompleteChecks[
          translation.id
        ] = translation.isIncomplete(ctrl.corpus)
      }
      return value
    }
  }
})()

;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$element", "videoService"];
  angular.module('glow.components').component('videoPlayer', {
    controller: Controller,
    templateUrl: 'video-player.html',
    bindings: {
      video: '<',
    },
  })

  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

  /* @ngInject */
  function Controller($scope, $element, videoService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy

    function onInit() {
      ctrl.playerElem = $element.find('video')[0]
      videoService.load().then(function(videojs) {
        ctrl.player = videojs(ctrl.playerElem, {
          // this is needed to fix audio issue on safari and ipad
          html5: { vhs: { overrideNative: true } },
        })
        ctrl.player.src([
          // dash
          {
            type: 'application/dash+xml',
            src:
              'https://videodelivery.net/' +
              ctrl.video.id +
              '/manifest/video.mpd',
          },
          // hls
          {
            type: 'application/x-mpegURL',
            src:
              'https://videodelivery.net/' +
              ctrl.video.id +
              '/manifest/video.m3u8',
          },
        ])
        ctrl.player.controls(true)
        ctrl.player.aspectRatio(ctrl.video.width + ':' + ctrl.video.height)
        ctrl.player.on('ended', onEnd)
        window.player = ctrl.player // DEBUG

        // iOS fullscreen has its own UI which includes progress controls.
        // We can't allow this, especially if the respondent has restrictions
        // enabled.
        if (iOS) {
          var fullscreenToggle = ctrl.player.controlBar.fullscreenToggle
          ctrl.player.controlBar.removeChild(fullscreenToggle)
        }

        // build the restart button component
        var Button = videojs.getComponent('Button')
        ctrl.restartBtn = new Button(ctrl.player)
        var restartBtnElem = ctrl.restartBtn.el()
        restartBtnElem.innerHTML = '<span class="gi gi-restart"></span>'
        restartBtnElem.style.fontSize = '20px'
        restartBtnElem.style.width = '35px'
        restartBtnElem.addEventListener('mousedown', onRestartClick)
        restartBtnElem.addEventListener('touchstart', onRestartClick)

        // build the backTen button component
        var Button = videojs.getComponent('Button')
        ctrl.backTenBtn = new Button(ctrl.player)
        var backTenBtnElem = ctrl.backTenBtn.el()
        backTenBtnElem.innerHTML = '<span class="gi gi-rewind-10"></span>'
        backTenBtnElem.style.fontSize = '20px'
        backTenBtnElem.style.width = '35px'
        backTenBtnElem.addEventListener('mousedown', onBackTenClick)
        backTenBtnElem.addEventListener('touchstart', onBackTenClick)

        // build the spacer component
        var Component = videojs.getComponent('Component')
        ctrl.spacer = new Component(ctrl.player)
        var spacerElem = ctrl.spacer.el()
        spacerElem.style.flex = 'auto'

        $scope.$watch(function() {
          updateScrubRestriction()
        })
        updateScrubRestriction()
      })
    }

    function updateScrubRestriction() {
      if (ctrl.video.restrictions.scrub && !ctrl.scrubRestricted) {
        // hide the progress control
        ctrl.player.controlBar.progressControl.el().style.display = 'none'
        // add the restart button
        ctrl.player.controlBar.addChild(ctrl.restartBtn, null, 2)
        // add the backTen button
        ctrl.player.controlBar.addChild(ctrl.backTenBtn, null, 3)
        // add the spacer
        ctrl.player.controlBar.addChild(ctrl.spacer, null, 4)
        ctrl.scrubRestricted = true
      }
      if (!ctrl.video.restrictions.scrub && ctrl.scrubRestricted) {
        // show the progress control
        ctrl.player.controlBar.progressControl.el().style.display = ''
        // remove the restart button
        ctrl.player.controlBar.removeChild(ctrl.restartBtn)
        // remove the backTen button
        ctrl.player.controlBar.removeChild(ctrl.backTenBtn)
        // remove the spacer
        ctrl.player.controlBar.removeChild(ctrl.spacer)
        ctrl.scrubRestricted = false
      }
    }

    function onRestartClick() {
      ctrl.player.currentTime(0)
    }

    function onBackTenClick() {
      var newTime = _.clamp(ctrl.player.currentTime() - 10, 0, Infinity)
      ctrl.player.currentTime(newTime)
    }

    function onEnd() {
      $scope.$applyAsync(function() {
        ctrl.video.completed = true
        console.log('onEnd')
      })
    }

    function onDestroy() {
      ctrl.player && ctrl.player.dispose()
    }
  }
})()
